// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
export const nn = {
    login: {
        title: '[[TOK_0]] ComplianceOne',
        subtitle: 'Logg inn på kontoen din',
        email: 'E-post',
        password: 'Passord',
        sign_in: 'Logg inn',
        signing_in: 'Loggar inn...',
        mfa_code: 'MFA-kode',
        mfa_placeholder: 'Skriv inn 6-sifra kode',
        mfa_instruction: 'Skriv inn den 6-sifra koden frå autentiseringsappen din.',
        verify: 'Stadfest',
        verifying: 'Stadfester...',
        forgot_password: 'Gløymt passord?',
        account_locked: 'Kontoen er låst. Ver venleg og prøv igjen seinare.',
        account_deactivated: 'Kontoen er deaktivert. Kontakt administratoren din.',
        invalid_mfa: 'Ugyldig MFA-kode. Ver venleg og prøv igjen.',
        invalid_credentials: 'Ugyldig e-post eller passord.',
        login_failed: 'Innlogging mislukkast',
        session_expired: '��kta di har gått ut. Ver venleg og last sida på nytt og prøv igjen.',
    },
    auth: {
        forgot_password: {
            title: 'Gløymt passord',
            subtitle: 'Skriv inn e-postadressa di, så sender vi deg ei lenkje for å tilbakestille passordet.',
            send: 'Send tilbakestillingslenkje',
            sending: 'Sender...',
            success: 'Dersom den e-postadressa finst, er ei lenkje for tilbakestilling av passord sendt.',
            back_to_login: 'Tilbake til innlogging',
        },
        reset_password: {
            title: 'Tilbakestill passord',
            subtitle: 'Skriv inn det nye passordet ditt nedanfor.',
            new_password: 'Nytt passord',
            confirm_password: 'Stadfest passord',
            reset: 'Tilbakestill passord',
            resetting: 'Tilbakestiller...',
            success: 'Passordet ditt er tilbakestilt.',
            go_to_login: 'Gå til innlogging',
            password_mismatch: 'Passorda samsvarar ikkje.',
            invalid_token: 'Ugyldig eller manglande tilbakestillingstoken. Ver venleg og be om ei ny lenkje for tilbakestilling av passord.',
            requirements_title: 'Passordkrav:',
            password_requirements: 'Passordet må oppfylle følgjande krav:',
            rules: {
                min_length: 'Minst 12 teikn',
                uppercase: 'Minst éin stor bokstav',
                lowercase: 'Minst éin liten bokstav',
                digit: 'Minst eitt siffer',
                special: 'Minst eitt spesialteikn',
            },
        },
        verify_email: {
            title: 'E-poststadfesting',
            verifying: 'Stadfestar e-postadressa di...',
            success: 'E-postadressa di er stadfesta.',
            invalid_token: 'Ugyldig eller manglande stadfestingstoken.',
            failed: 'E-poststadfesting mislukkast. Tokenet kan vere ugyldig eller utgått.',
            go_to_login: 'Gå til innlogging',
        },
        offline: {
            title: 'Du er fråkopla',
            message: 'Det ser ut til at du har mista internettilkoplinga. Ver venleg og sjekk nettverket ditt og prøv på nytt.',
        },
    },
    intake: {
        title: 'Innsynskrav',
        subtitle: 'Send eit innsynskrav til organisasjonen vår',
        fields: {
            full_name: 'Fullt namn',
            email: 'E-postadresse',
            phone: 'Telefonnummer (valfritt)',
            request_type: 'Type førespurnad',
            description: 'Skildra førespurnaden din',
            preferred_language: 'Føretrekt språk',
            consent: 'Eg samtykkjer til behandling av denne førespurnaden',
        },
        submit: 'Send førespurnad',
        validation: {
            name_required: 'Fullt namn er påkravd',
            email_required: 'Ei gyldig e-postadresse er påkravd',
            type_required: 'Vel ein type førespurnad',
            description_required: 'Skildra førespurnaden din',
            consent_required: 'Du må samtykkja til behandling for å halda fram',
        },
        error_title: 'Feil',
        config_load_error: 'Kunne ikkje laste konfigurasjonen. Venlegst sjekk nettadressa.',
        organization_label: 'Organisasjon',
        customer_reference: 'Kundereferansenummer',
        country: 'Land / Jurisdiksjon',
        preferred_channel: 'Føretrekt svarskanal',
        channels: {
            email: 'E-post',
            postal: 'Post',
            phone: 'Telefon',
            portal: 'Portal',
        },
        confirmation: {
            title: 'Førespurnad motteken',
            message: 'Førespurnaden din er registrert. Referansenummeret ditt er:',
            next_steps: 'Vi vil behandla førespurnaden din så snart som mogleg i samsvar med gjeldande lovgiving. Forventa behandlingstid er 30 arbeidsdagar.',
        },
    },
    request_types: {
        access: 'Innsyn (DSAR)',
        deletion: 'Sletting',
        correction: 'Retting / Oppdatering',
        objection: 'Motsegn',
        portability: 'Dataportabilitet',
        restriction: 'Avgrensing av behandling',
        consent_withdrawal: 'Tilbakekalling av samtykke',
    },
    statuses: {
        new: 'Ny',
        in_review: 'Under vurdering',
        waiting_on_requester: 'Ventar på innsendar',
        waiting_on_internal_data: 'Ventar på interne data',
        approved: 'Godkjend',
        closed: 'Lukka',
        rejected: 'Avvist',
    },
    admin: {
        nav: {
            rights_requests: 'Innsynskrav',
            templates: 'Malar',
            response_templates: 'Svarmalar',
            data_mapping: 'Datakartlegging',
            governance: 'Styring',
            consent: 'Samtykke',
            assessments: 'Vurderingar',
            classification: 'Klassifisering',
            monitoring: 'Overvaking',
            incidents: 'Hendingar',
            onboarding: 'Innføring',
            connectors: 'Koplingspunkt',
            vendor_risk: 'Leverandørrisiko',
            deletion_orchestration: 'Slettestyring',
            discovery: 'Dataoppdaging',
            incident_ops: 'Hendingsoperasjonar',
            program_governance: 'Programstyring',
            access_accountability: 'Tilgangsansvar',
            consent_properties: 'Samtykkeeigedommar',
            localization: 'Lokalisering',
            partner_workspace: 'Partnararbeidsområde',
            audit_trail: 'Revisjonsspor',
            forseti: 'Forseti',
            settings: 'Innstillingar',
            help_center: 'Hjelpesenter',
            dashboard: 'Kontrollpanel',
            platform: 'Plattform',
            integrations: 'Integrasjonar',
            cmp_dsar_sync: 'CMP DSAR-synkronisering',
            cmp_integration: 'CMP-integrasjon',
            purpose_mapping: 'Føremålskopling',
            webhook_config: 'Webhook-konfigurasjon',
            bulk_sync: 'Massesynkronisering',
            privacy_scanner: 'Personvernskannar',
            privacy_monitoring: 'Personvernovervaking',
            real_time_scanner: 'Sanntidsskannar',
            compliance_forms: 'Samsvarsskjema',
            forms_dashboard: 'Skjemakontrollpanel',
            form_templates: 'Malar',
            form_catalog: 'Skjemakatalog',
            pack_catalog: 'Pakkekatalog',
            org_groups: 'Organisasjonsgrupper',
            consolidation: 'Konsolidering',
            organizations: 'Organisasjonar',
            org_list: 'Alle Organisasjonar',
            intake_configs: 'Inntak Konfigurasjonar',
            task_management: 'Oppgåvestyring',
            unified_audit: 'Samla Revisjon',
            evidence_packs: 'Bevispakkar',
            audit_periods: 'Revisjonsperiodar',
            regulatory_updates: 'Regelverksoppdateringar',
            departments: 'Avdelingar',
        },
        sidebar_category_data_privacy_rights: 'Personvern & Rettar',
        sidebar_category_vendor_third_party: 'Leverandør & Tredjepartsstyring',
        sidebar_category_risk_assessment: 'Risiko & Vurdering',
        sidebar_category_operations_automation: 'Drift & Automatisering',
        sidebar_category_task_workflow: 'Oppgåve & Arbeidsflyt',
        sidebar_groups: {
            consent_cmp_webhooks: '[[TOK_0]] og webhooks',
            data_mapping_ropa: 'RoPA Register',
            data_mapping_classification: 'Klassifisering',
            data_mapping_governance: 'Styring',
            access_live_monitoring: 'Live overvåking',
            access_reviews_investigations: 'Anmeldelser og undersøkelser',
            access_evidence_policies: 'Bevis og retningslinjer',
            classification_taxonomies: 'Taksonomier og etiketter',
            classification_workflow: 'Arbeidsflyt',
            classification_insights: 'Innsikt',
            connectors_runtime: 'Kjøretid',
            connectors_due_diligence: 'Due Diligence',
            connectors_coverage: 'Dekning',
            cp_definitions: 'Definisjoner',
            cp_lifecycle: 'Livssyklus',
            cp_quality: 'Kvalitet og bevis',
            deletion_execution: 'Utførelse',
            deletion_vendors: 'Leverandører',
            deletion_evidence: 'Bevis og integrasjon',
            discovery_rules: 'Regler og maler',
            discovery_scanning: 'Skanning',
            discovery_review: 'Gjennomgå arbeidsflyt',
            discovery_insights: 'Innsikt',
            governance_oversight: 'Tilsyn',
            governance_reporting: 'Rapportering',
            governance_vendors: 'Leverandører og grenseoverskridende',
            governance_lifecycle: 'Livssyklus',
            incident_ops_dashboards: 'Dashboards',
            incident_ops_sla: '[[TOK_0]] Konfig',
            incident_ops_playbooks: 'Playbooks',
            incident_ops_vendor_regulator: 'Leverandør og regulator',
            incident_ops_evidence: 'Bevis og gjennomgang',
            incidents_workload: 'Arbeidsmengde',
            incidents_regulatory: 'Regulatorisk',
            incidents_reporting: 'Rapportering',
            localization_content: 'Innhold',
            localization_regulatory: 'Regulatorisk',
            localization_observability: 'Observerbarhet',
            monitoring_metrics: 'Beregninger',
            monitoring_programs: 'Programmer',
            monitoring_tasks: 'Oppgaver',
            monitoring_controls: 'Kontroller',
            org_entities: 'Entiteter',
            org_config: 'Konfigurasjon',
            org_frameworks: 'Frameworks & Rollup',
            partner_overview: 'Oversikt',
            partner_partners: 'Partnere',
            partner_delivery: 'Levering',
            partner_support: 'Støtte',
            platform_identity: 'Identitet og roller',
            platform_access_control: 'Tilgangskontroll',
            platform_auth_session: 'Autentisering og økt',
            platform_access_reviews: 'Få tilgang til anmeldelser',
            platform_files: 'Filer',
            platform_notifications: 'Varsler',
            platform_module_config: 'Modulkonfig',
            platform_ops: 'Ops og logger',
            pg_health: 'Program Helse',
            pg_maturity: 'Modenhet',
            pg_audit: 'Revisjon og bevis',
            pg_obligations: 'Forpliktelser',
            pg_documents: 'Dokumenter',
            vr_overview: 'Oversikt',
            vr_onboarding: 'Onboarding',
            vr_assessment: 'Vurdering',
            vr_oversight: 'Tilsyn',
        },
        tickets: {
            title: 'Rettar Førespurnader',
            create: 'Opprett Førespurnad',
            filters: 'Filtrer',
            search_placeholder: 'Søk i saker...',
            export_csv: 'Eksporter [[TOK_0]]',
            exporting: 'Eksporterer...',
            bulk_export_failed: 'Masseksport mislyktes',
            bulk_export: {
                label: 'Eksporter',
                format: {
                    pdf: '[[TOK_0]] Sammendrag',
                    zip: 'ZIP (bevispakker per sak)',
                    csv: '[[TOK_0]]',
                },
                warning_over_50: 'Dette vil generere omtrent [[TOK_1]] case-pakker � kan ta flere minutter. Fortsette?',
                blocked_over_500: 'Begrens filteret til 500 eller færre tilfeller før du eksporterer ZIP (gjeldende: [[TOK_1]]).',
                success: 'Masseksport lagret i filnettleseren ([[TOK_1]] tilfeller)',
                failed: 'Masseksport mislyktes',
                continue: 'Fortsett',
                cancel: 'Avbryt',
            },
            no_results: 'Ingen førespurnader funne',
            ticket_id: 'Sak ID',
            request_type: 'Førespurnad Type',
            requester: 'Søkjar',
            source: 'Kilde',
            all_sources: 'Alle kilder',
            assigned_to: 'Tildelt Til',
            created: 'Oppretta',
            load_error: 'Kunne ikkje laste saker. Ver venleg og prøv igjen.',
            case_creation_failed: 'Oppretting av sak mislukkast',
            business_unit: 'Forretningseining',
            reference: 'Referanse',
            sla: {
                title: 'SLA-status',
                on_track: '{days} dagar att',
                approaching: 'Nærmar seg fristen',
                overdue: '{days} dagar over fristen',
                ack_overdue: '{hours}t over stadfestingsfristen',
                ack_warning: 'Stadfesting snart forfallen',
                closed: 'Lukka',
                completed_in: 'Fullført på {days} dagar',
            },
        },
        templates: {
            title: 'Svar Malar',
            new: 'Ny Mal',
            edit: 'Rediger Mal',
            all_types: 'Alle Typar',
            all_locales: 'Alle Lokalitetar',
            type_access: 'Tilgang/DSAR',
            type_deletion: 'Sletting',
            type_correction: 'Retting',
            type_objection: 'Innvending',
            type_portability: 'Portabilitet',
            type_other: 'Anna',
            type_restriction: 'Avgrensing',
            type_all: 'Alle',
            locale_en: 'Engelsk',
            locale_vi: 'Vietnamesisk',
            locale_all: 'Alle',
            name: 'Namn',
            request_type: 'Førespurnad Type',
            locale: 'Lokalitet',
            subject: 'Emne',
            body: 'Brødtekst',
            name_placeholder: 'Mal namn...',
            subject_placeholder: 'E-post/brev-emne...',
            body_placeholder: 'Malens kropp. Bruk {[[TOK_5]]}, {[[TOK_6]]}, {[[TOK_7]]}, {[[TOK_8]]}, {[[TOK_9]]} som plassholdere.',
            available_placeholders: 'Tilgjengelige plassholdere:',
            create_template: 'Opprett Mal',
            preview: 'Førehandsvising',
            close_preview: 'Lukk førehandsvising',
            default_badge: 'Standard',
            no_templates: 'Ingen malar funne',
            confirm_delete: 'Slett denne mal?',
            load_error: 'Kunne ikkje laste malar. Ver venleg og prøv igjen.',
            create_error: 'Kunne ikkje opprette mal',
            update_error: 'Kunne ikkje oppdatere mal',
            delete_error: 'Kunne ikkje slette mal',
            preview_error: 'Kunne ikkje førehandsvise mal',
            response_templates_badge: 'Svarmalar',
            browse_form_templates: 'Bla gjennom Samsvarsskjemamalar',
            templates_loaded: 'Malar lasta',
            sample_organization: 'Eksempelorganisasjon',
        },
        detail: {
            requester_info: 'Søkjar Informasjon',
            status: 'Status',
            assignment: 'Tildeling',
            notes: 'Notat',
            audit_trail: 'Revisjon Spor',
            add_note: 'Legg til notat',
            case_not_found: 'Sak ikke fundet',
            load_error: 'Kunne ikkje laste sak. Ver venleg og prøv igjen.',
            note_error: 'Kunne ikkje leggje til notat. Ver venleg og prøv igjen.',
            submitted_from: 'Sendt frå',
            via_cmp: 'via [[TOK_1]] [[TOK_0]]',
            cmp_ticket: 'CMP-sak:',
            select_template: 'Vel ein mal',
            direction_inbound: '[[TOK_0]] �  GRC',
            direction_outbound: 'GRC �  [[TOK_0]]',
            tabs: {
                details: 'Detaljar',
                evidence: 'Bevis',
                communications: 'Kommunikasjonar',
                escalations: 'Eskaleringer',
                audit_trail: 'Revisjon Spor',
                fulfillment: 'Oppfylling',
                response: 'Svar',
                extension: 'Forlenging',
            },
            requester: {
                name: 'Namn',
                email: 'E-post',
                phone: 'Telefon',
                language: 'Språk',
                source: 'Kjelde',
                customer_ref: 'Kundereferanse',
                country: 'Land',
                preferred_channel: 'Føretrekt kanal',
            },
            sla: {
                title: 'SLA',
                on_track: 'På Spor',
                due_soon: 'Snart forfalle',
                overdue: 'Forsinka',
                days_remaining: 'd attståande',
                due_date: 'Forfallsdato',
                breached: 'Broten',
                paused: 'Pausa',
                total_paused_days: 'Totalt antall pausedagar',
                days_elapsed: 'Dagar gått',
                progress: 'Framdrift',
            },
            identity: {
                title: 'Identitet Verifisering',
                verified: 'Verifisert',
                not_verified: 'Ikkje verifisert',
                method: 'Metode',
                notes: 'Notat',
                verified_by: 'Verifisert Etter',
                verified_at: 'Verifisert Ved',
                warning: 'Identiteten er enno ikkje verifisert.',
                verify_button: 'Verifiser Identitet',
                select_method: '-- Vel --',
                methods: {
                    email_confirmation: 'E-poststadfesting',
                    id_document: 'ID Dokument',
                    phone_call: 'Telefonsamtale',
                    in_person: 'I Person',
                    other: 'Anna',
                },
            },
            closure: {
                reason: 'Lukking �&rsak',
                summary: 'Lukking Samandrag',
                summary_placeholder: 'Samandrag av korleis førespurnaden blei løyst...',
                reason_required: 'Lukkingssamandrag og årsak er påkravd',
                response_not_sent: 'Eit formelt svar må sendast til den registrerte før denne saka kan lukkast',
                reasons: {
                    fulfilled: 'Oppfylt',
                    partially_fulfilled: 'Delvis oppfylt',
                    unfounded: 'Grunnlaus',
                    excessive: 'Overdriven',
                    withdrawn: 'Trekt tilbake',
                    duplicate: 'Dupliser',
                    identity_unverified: 'Identitet ikkje verifisert',
                },
            },
            export_title: 'Eksport',
            export_pdf: 'Eksport PDF',
            export_zip: 'Eksport ZIP',
            case_file_pdf: 'Eksporter [[TOK_0]] (saksfil)',
            evidence_pack_zip: 'Eksporter ZIP (bevispakke)',
            cross_border_warning: 'Grenseoverskridende overføring oppdaget - grenseoverskridende dokumentasjon kreves',
            breach: {
                flag_btn: 'Flagg som bruddskapende',
                modal: {
                    title: 'Flagg tilfelle som brudd-forårsaker',
                    type_label: 'Bruddtype',
                    type: {
                        misdirected_response: 'Feilrettet svar',
                        unauthorised_disclosure: 'Uautorisert avsløring',
                        identity_mismatch: 'Identitetsfeil',
                        other: 'Annet',
                    },
                    description: 'Beskrivelse (valgfritt)',
                    description_placeholder: 'Hva skjedde? (maks 1000 tegn)',
                    confirm: 'Flagg og start 72 timers arkiveringsklokke',
                    cancel: 'Avbryt',
                    flagging: 'Flagger...',
                },
                banner: {
                    title: 'Brudd flagget: [[TOK_1]]',
                    detected_at: 'Oppdaget ved [[TOK_1]]',
                    filing_deadline: '72 timer [[TOK_2]] innleveringsfrist: om [[TOK_1]] timer',
                    overdue: '72 timer [[TOK_0]] innleveringsfrist: FORSIDEN',
                },
                toasts: {
                    flagged: 'Sak flagget som brudd-forårsaker � 72 timers klokke startet',
                    flag_failed: 'Kunne ikke flagge saken som bruddforårsak',
                },
            },
            export: {
                generating: 'Genererer... vennligst vent',
                success: 'Eksport lagret til Filleser',
                failed: 'Eksporten mislyktes - sjekk revisjonsloggen',
            },
            no_notes: 'Ingen notat enno',
            assign_placeholder: 'Brukar ID to tildel...',
            reassign: 'Omtildel',
            evidence: {
                checklist_title: 'Bevis Sjekkliste',
                complete_pct: '% fullført',
                no_checklist: 'Ingen sjekkliste element',
                attachments: 'Vedlegg',
                upload_attachment: 'Last opp vedlegg',
                upload_button: 'Last opp',
                uploading: 'Lastar opp...',
                attachment_uploaded: 'Vedlegg lasta opp',
                upload_error: 'Opplasting mislykkast',
                category: 'Kategori',
                categories: {
                    identity_proof: 'Identitetsbevis',
                    correspondence: 'Korrespondanse',
                    internal_data: 'Interne data',
                    legal: 'Juridisk',
                    other: 'Anna',
                },
                no_attachments: 'Ingen attachments',
                references_title: 'Bevis Referansar',
                no_references: 'Ingen referansar',
                add_reference: 'Add Referanse',
                ref_type: 'Type',
                ref_value: 'Verdi',
                ref_desc: 'Skildring',
                ref_value_placeholder: 'URL, e-post ID, eller referanse...',
                ref_desc_placeholder: 'Skildring...',
                ref_types: {
                    url: 'URL',
                    email_id: 'E-post ID',
                    crm_record: 'CRM Post',
                    ticket_ref: 'Sak Referanse',
                    other: 'Anna',
                },
            },
            communications: {
                title: 'Kommunikasjonar',
                add: 'Add Melding',
                no_records: 'Ingen communications recorded',
                direction: 'Retning',
                channel: 'Kanal',
                visibility: 'Synlegheit',
                subject: 'Emne',
                body: 'Brødtekst',
                send: 'Send',
                inbound: 'Innkomande',
                outbound: 'Utgåande',
                internal: 'Intern',
                external: 'Ekstern',
                tab_all: 'Alle',
                tab_internal: 'Intern',
                tab_external: 'Ekstern',
                subject_placeholder: 'Emne (valfritt)',
                body_placeholder: 'Meldingstekst...',
                channels: {
                    email: 'E-post',
                    portal: 'Portal',
                    phone: 'Telefon',
                    postal: 'Post',
                    in_person: 'I Person',
                },
                apply_template: 'Bruk Mal',
                select_template: 'Vel ein mal...',
                no_templates: 'Ingen malar tilgjengelege',
                template_applied: 'Mal brukt på svaret.',
                template_apply_error: 'Kunne ikkje bruke mal.',
            },
            escalations: {
                title: 'Eskalering Historikk',
                no_events: 'Ingen eskalering hendingar',
                tier: 'Nivå',
                threshold: 'Terskel',
                action: 'Handling',
                target: 'Mål',
                triggered_at: 'Utløyst At',
            },
            cmp_sync: {
                title: 'AesirX CMP Synkronisering',
                sync_status: 'Synkronisering Status',
                last_synced: 'Sist synkronisert',
                not_synced: 'Ikkje synkronisert',
                resync: 'Synkroniser på nytt no',
                syncing: 'Synkroniserer...',
                sync_history: 'Synkroniseringshistorikk (seneste 10)',
                direction: 'Retning',
                time: 'Tid',
                retries: 'Gjenforsøk',
                error_col: 'Feil',
            },
            audit: {
                filter_event_placeholder: 'Filter etter hending type...',
                filter_actor_placeholder: 'Filtrer efter aktør...',
            },
            fulfillment: {
                title: 'Avdelingsoppfylling',
                assign_departments: 'Tildel avdelingar',
                department: 'Avdeling',
                assignee: 'Tildelt',
                deadline: 'Frist',
                evidence_count: 'Bevis',
                signoff: 'Godkjenning',
                signed_off: 'Godkjend',
                pending_signoff: 'Ventande',
                start_button: 'Start',
                complete_button: 'Merk som fullført',
                signoff_button: 'Meld deg av',
                no_tasks: 'Ingen oppfyllingsoppgåver tildelt enno.',
                tasks_table: 'Oppfyllingsoppgåver',
                progress_label: 'Oppfyllingsframgang',
                overdue: 'forsinka',
                assigned_success: 'Avdelingsoppfyllingsoppgåve tildelt.',
                assign_error: 'Kunne ikkje tildele oppfyllingsoppgåve.',
                signoff_success: 'Avdelingsgodkjenning registrert.',
                signoff_error: 'Kunne ikkje registrere godkjenning.',
                identity_required: 'Identity verification required before fulfillment actions.',
                remove_task: 'Remove Task',
                remove_success: 'Fulfillment task removed successfully.',
                add_evidence_btn: 'Legg til bevis',
                evidence_uploaded: 'Bevis lasta opp og kopla',
                evidence_upload_error: 'Opplasting av bevis mislykkast',
                suggest_data_stores: 'Føreslå datalager',
                suggest_error: 'Kunne ikkje laste datalagringsforslag.',
                suggest_stores_title: 'Foreslåtte datalagre',
                suggest_stores_none: 'Ingen datalagre samsvarer med denne saken. Konfigurer systemer i datakartlegging for å forbedre forslag.',
                suggest_stores_add: 'Legg til sak',
                suggest_stores_added: 'Datalager lagt til sak',
                no_departments_title: 'Ingen avdelinger er konfigurert',
                no_departments_body: 'Avdelinger lar deg rute DSR-oppfyllingsoppgaver til en funksjon (Personvern, Juridisk, HR, IT Ops). Installer eksempelavdelinger eller be administratoren din om å konfigurere avdelinger i organisasjonsinnstillingene.',
                no_departments_cta: 'Installer eksempeldata',
                department_placeholder: 'Avdelingsnamn...',
                assignee_placeholder: 'Brukar-ID å tildele...',
                assign_button: 'Tildel',
                status_pending: 'Ventande',
                status_in_progress: 'Pågår',
                status_completed: 'Fullført',
                status_verified: 'Verifisert',
                confirm_approve: 'Er du sikker på at du vil godkjenne denne forlenga?',
                confirm_deny: 'Er du sikker på at du vil avslå denne forlenga?',
            },
            response: {
                title: 'Svargenerering',
                select_template: 'Svarsmal',
                choose_template: 'Vel ein mal...',
                generate: 'Generer svar',
                preview: 'Svarsførehandsvising',
                send: 'Send svar',
                delivery_method: {
                    label: 'Leveringsmetode',
                    email: 'E-post',
                    portal: 'Portal',
                    postal: 'Postpost',
                    in_person: 'Personlig',
                },
                recipient: {
                    email: 'Mottakers e-post',
                    portal: 'Portal bruker-ID',
                    address: 'Postadresse',
                },
                auto_generate_btn: 'Generer og send svar',
                auto_generate_success: 'Respons generert og levert',
                auto_generate_missing_recipient: 'Vennligst oppgi en mottaker før du sender.',
                auto_fields: 'Automatisk utfylte felt',
                case_id: 'Saks-ID',
                requester_name: 'Namn på innsendar',
                rights_type: 'Rettighetstype',
                history: 'Sende svar',
                generated_at: 'Generert',
                confirmation: 'Stadfesting',
                sent_label: 'Sendt',
                draft_label: 'Utkast',
                generated_success: 'Svar generert.',
                generate_error: 'Kunne ikkje generere svar.',
                sent_success: 'Svar sendt.',
                send_error: 'Kunne ikkje sende svar.',
                load_error: 'Kunne ikkje laste svarsmalar.',
                pdf_title: 'Svarbrev til registrert person',
                download_pdf: 'Last ned PDF',
                download_all: 'Last ned alle',
                download_error: 'Kunne ikkje laste ned svar',
            },
            extension: {
                title: 'Fristforlengingar',
                acknowledgment_deadline: 'Stadfestingsfrist',
                fulfillment_deadline: 'Oppfyllingsfrist',
                request_extension: 'Be om forlenging',
                reason: 'Grunngiving',
                reason_placeholder: 'Grunngiving for å be om ekstra tid...',
                additional_days: 'Ytterlegare dagar',
                submit_request: 'Send forlengingsførespurnad',
                history: 'Forlengingshistorikk',
                requested_at: 'Førespurd',
                approve: 'Godkjenn',
                deny: 'Avslå',
                request_success: 'Forlengingsførespurnad sendt.',
                request_error: 'Kunne ikkje sende forlengingsførespurnad.',
                approved_success: 'Forlenging godkjend.',
                denied_success: 'Forlenging avslegen.',
                decision_error: 'Kunne ikkje behandle forlengingsvedtak.',
                status_pending: 'Ventande',
                status_approved: 'Godkjend',
                status_denied: 'Avslått',
                confirm_approve: 'Er du sikker på at du vil godkjenne denne forlengingsførespurnaden?',
                confirm_deny: 'Er du sikker på at du vil avslå denne forlengingsførespurnaden?',
                decided_by: 'Avgjort av',
            },
        },
        audit: {
            export_csv: 'Eksport CSV',
            exporting: 'Eksporterer...',
            search_placeholder: 'Søk revisjon detaljar...',
            filter_by_actor: 'Filtrer efter aktør...',
            all_event_types: 'Alle Hending Typar',
            seq: '#',
            timestamp: 'Tidsstempel',
            event: 'Hending',
            case_col: 'Sak',
            actor: 'Aktør',
            summary: 'Samandrag',
            no_events: 'Ingen revisjon hendingar funne',
            export_success: 'Revisjonssporet ble eksportert.',
            export_error: 'Kunne ikkje eksportere revisjons-CSV',
            load_error: 'Kunne ikkje laste revisjonsspor. Ver venleg og prøv igjen.',
            announce_loaded: 'Revisjonsspor lasta',
            start_date: 'Startdato',
            end_date: 'Sluttdato',
            per_page: '{count} / side',
            unknown: 'Ukjend',
            source_filter: {
                label: 'Kilde',
                all: 'Alle',
                module: 'Modul',
                forseti: 'Forseti',
                aria_label: 'Filtrer revisjonshendelser etter kilde',
            },
            event_types: {
                case_created: 'Sak Oppretta',
                status_changed: 'Status endra',
                case_assigned: 'Sak Tildelt',
                note_added: 'Merknad lagt til',
                attachment_added: 'Vedlegg lagt til',
                attachment_deleted: 'Vedlegg sletta',
                reference_added: 'Referanse lagt til',
                checklist_updated: 'Sjekkliste Oppdatert',
                identity_verified: 'Identitet Verifisert',
                closure_summary_added: 'Lukking Samandrag',
                approval_granted: 'Godkjenning gjeve',
                template_applied: 'Mal brukt',
                export_generated: 'Eksport Generert',
                sla_warning: 'SLA �&tvaring',
                sla_overdue: 'SLA Forsinka',
            },
            unified_audit: {
                title: 'Samla Revisjonsspor',
                module_filter: 'Modul',
                framework_filter: 'Rammeverk',
                select_framework: 'Vel eit rammeverk...',
                entity_type_filter: 'Entitetstype',
                action_filter: 'Handling',
                actor_filter: 'Aktør',
                select_actor: 'Vel ein aktør...',
                search_filter: 'Søk',
                search_placeholder: 'Søk i revisjonshendingar...',
                filters_heading: 'Filter',
                date_range: 'Datoperiode',
                no_events_found: 'Ingen revisjonshendingar funne.',
                event_count: 'Tal på hendingar',
                action: 'Handling',
                actor: 'Aktør',
                date_range_start: 'Startdato for intervall',
                date_range_end: 'Sluttdato for intervall',
                filtering_events: 'Filtrerer revisjonshendingar',
                framework_codes: 'Rammekoder',
                entity_type_col: 'Einingstype',
                aria_table: 'Samla revisjonshendingar',
                page_of: 'Side {page} av {total}',
                entity_types: {
                    user: 'Bruker',
                    case: 'Sak',
                    incident: 'Hendelse',
                    assessment: 'Vurdering',
                    vendor: 'Leverandør',
                    consent: 'Samtykke',
                    policy: 'Politikk',
                    data_map: 'Datakart',
                },
                actions: {
                    create: 'Opprett',
                    update: 'Oppdater',
                    delete: 'Slett',
                    view: 'Visning',
                    export: 'Eksporter',
                    status_change: 'Statusendring',
                },
            },
            evidence_packs: {
                title: 'Revisjonsbevis­pakkar',
                assemble_pack: 'Set saman Bevispakke',
                framework: 'Rammeverk',
                select_framework: 'Vel eit rammeverk...',
                framework_code_label: 'Rammekode',
                entity_types: 'Entitetstypar',
                select_entity_types: 'Vel entitetstypar...',
                period: 'Periode',
                period_start: 'Periodestart',
                period_end: 'Periodeslutt',
                completeness: 'Fullstende',
                no_packs_found: 'Ingen bevispakkar funne.',
                verify: 'Verifiser',
                export_pack: 'Eksporter',
                exporting: 'Eksporterer...',
                pack_assembled: 'Bevispakke sett saman',
                pack_exported: 'Bevispakke eksportert',
                aria_table: 'Revisjonsbevispakkar',
                aria_export_pack: 'Eksporter pakke',
                export_format: 'Eksportformat',
                export_in_progress: 'Eksport pågår...',
                status_draft: 'Utkast',
                status_assembled: 'Samansett',
                status_verified: 'Verifisert',
                status_submitted: 'Innsend',
                entity_type_labels: {
                    user: 'Bruker',
                    case: 'Sak',
                    incident: 'Hendelse',
                    assessment: 'Vurdering',
                    vendor: 'Leverandør',
                    consent: 'Samtykke',
                    policy: 'Politikk',
                    data_map: 'Datakart',
                },
                template_id: 'Mal-ID',
                csv_headers: {
                    module: 'Modul',
                    action: 'Handling',
                    actor_id: 'Skuespiller',
                    entity_type: 'Enhetstype',
                    entity_id: 'Enhets-ID',
                    summary: 'Sammendrag',
                    timestamp: 'Tidsstempel',
                    framework_code: 'Rammeverk',
                },
                export_header_framework: 'Evidenspakke � Rammeverk: {framework}',
                export_header_period: 'Periode: {start} til {end}',
                export_header_completeness: 'Fullstende: {score}%',
                export_header_status: 'Status: [[TOK_1]]',
            },
            audit_periods: {
                title: 'Revisjonsperiodar',
                create_period: 'Opprett Revisjonsperiode',
                framework_code_label: 'Rammekode',
                select_framework: 'Vel eit rammeverk...',
                period_label: 'Periodeetikett',
                period_start: 'Periodestart',
                period_end: 'Periodeslutt',
                start: 'Start',
                end: 'Slutt',
                framework: 'Rammeverk',
                retention_days: 'Oppbevaringsdagar',
                no_periods_found: 'Ingen revisjonsperiodar funne.',
                period_created: 'Revisjonsperiode oppretta',
                aria_table: 'Revisjonsperiodar',
                suggested_boundaries: 'Føreslegne grenser',
                suggested_boundaries_info: 'Føreslegne periodegrenser er avleia frå kvart rammeverk sin regulatoriske rapporteringssyklus. Juster etter behov for organisasjonen din.',
                reporting_cycle: 'Rapporteringssyklus',
                suggested_start: 'Føreslegn start',
                suggested_end: 'Føreslegn slutt',
                suggested_next: 'Foreslått neste periode',
                cycle_monthly: 'Månedlig',
                cycle_quarterly: 'Kvartalsvis',
                cycle_semi_annual: 'Halvårlig',
                cycle_annual: '�&rlig',
                cycle_custom: 'Egendefinert',
                period_deleted: 'Revisjonsperiode slettet',
            },
        },
        create_case: {
            customer_ref: 'Kundereferanse',
            country: 'Land / Jurisdiktion',
            preferred_channel: 'Føretrekt kanal',
            channels: {
                email: 'E-post',
                postal: 'Post',
                phone: 'Telefon',
                portal: 'Portal',
            },
            source: 'Kilde',
            sources: {
                admin_manual: 'Administrasjonshåndbok',
                public_form: 'Offentlig form',
                cmp_gateway: '[[TOK_0]] Gateway',
                aesirx_cmp: '[[TOK_1]] [[TOK_0]]',
                phone_received: 'Telefon mottatt',
                postal_received: 'Post mottatt',
                email_received: 'E-post mottatt',
                in_person: 'Personlig',
                legacy_import: 'Eldre import',
            },
            required_fields: 'Førespurnad type, namn, og e-post er påkravd',
            create_error: 'Kunne ikkje opprette sak',
        },
        settings: {
            title: 'Innstillingar',
            request_types: 'Førespurnadstypar',
            request_types_desc: 'Konfigurer kva førespurnadstypar som er aktiverte for det offentlege innsynsskjemaet.',
            notifications: 'Varslingar',
            ticket_numbering: 'Saksnummerering',
            ticket_format: 'Gjeldande format',
            ticket_prefix: 'Prefiks',
            ticket_prefix_note: 'ikkje konfigurerbart i Sprint 1.0.0',
            sla_deadlines: 'SLA-fristar',
            sla_desc: 'Set maksimal svartid (i kalenderdagar) for kvar førespurnadstype. Saker som nærmar seg fristen vil visa åtvaringar.',
            days: 'dagar',
            warning_threshold: '�&tvaringsterskel',
            escalation_label: 'Aktiver automatisk eskalering ved SLA-brot',
            save_sla: 'Lagra SLA-konfigurasjon',
            saving: 'Lagrar...',
            saved: 'Lagra',
            announce_loaded: 'Innstillingar lasta',
            email_on_creation: 'E-postvarsling ved oppretting av sak',
            send_confirmation: 'Send stadfesting til innsendar via e-post',
            users: 'Brukere',
            roles: 'Roller',
            api_keys: '[[TOK_0]] Taster',
            mfa: 'MFA',
            sessions: '��kter',
            webhooks: 'Webhooks',
            modules: 'Moduler',
            deadline_labels: {
                access: 'Innsyn (DSAR)',
                deletion: 'Sletting',
                correction: 'Retting',
                portability: 'Portabilitet',
                objection: 'Motsegn',
                restriction: 'Avgrensing',
                consent_withdrawal: 'Tilbakekalling av samtykke',
            },
        },
        section_assignments: {
            title: 'Seksjonstildelingar',
            assign_section: 'Tildel seksjon',
            section_ref: 'Seksjonsreferanse',
            section_label: 'Seksjonsnamn',
            department_id: 'Avdeling',
            assignee_id: 'Ansvarleg',
            mandatory: 'Obligatorisk',
            assign: 'Tildel',
            no_assignments: 'Ingen seksjonstildelingar',
            status: 'Status',
            completion: 'Fullføring',
            mark_complete: 'Fullfør',
        },
        consolidation: {
            title: 'Konsolideringsframgang',
            add_child: 'Legg til underoppgåve',
            child_task_id: 'Underoppgåve-id',
            department_id: 'Avdeling',
            link: 'Lenkje',
            overall_completion: 'Total fullføring',
            departments_complete: 'Avdelingar fullført',
            overdue: 'Forfalle',
            ready: 'Klar',
            not_ready: 'Ikkje klar',
            master_status: 'Overordna status',
            department_breakdown: 'Avdelingsoversyn',
            department: 'Avdeling',
            status: 'Status',
            completion: 'Fullføring',
            due_date: 'Forfallsdato',
            overdue_flag: 'Forfalle',
            child_tasks: 'Underoppgåver',
            task: 'Oppgåve',
        },
        conflict_detection: {
            title: 'Konfliktoppdaging',
            unresolved: 'uløyst',
            no_conflicts: 'Ingen konfliktar oppdaga',
            section: 'Seksjon',
            field: 'Felt',
            dept_a: 'Avdeling A',
            value_a: 'Verdi A',
            dept_b: 'Avdeling B',
            value_b: 'Verdi B',
            severity: 'Alvor',
            status: 'Status',
            resolved: 'Løyst',
            open: '�&pne',
            resolve: 'Løys',
        },
        org_maturity: {
            title: 'Organisatorisk Mognad',
            departments: 'Avdelingar',
            department_hierarchy: 'Avdelingshierarki',
            create_department: 'Opprett Avdeling',
            department_name: 'Avdelingsnamn',
            department_code: 'Kode',
            level: 'Nivå',
            division: 'Divisjon',
            department: 'Avdeling',
            team: 'Lag',
            parent_department: 'Overordna Avdeling',
            head_user: 'Avdelingsleiar',
            no_departments: 'Ingen avdelingar konfigurerte.',
            user_mappings: 'Brukartilknytingar',
            map_user: 'Tilknytt Brukar',
            user_id: 'Brukar-ID',
            role: 'Rolle',
            no_users: 'Ingen brukarar tilknytte denne avdelinga.',
            remove: 'Fjern',
            framework_assignments: 'Rammeverkstildelingar',
            assign_framework: 'Tildel Rammeverk',
            entity_id: 'Eining-ID',
            entity_type: 'Einingstype',
            framework_id: 'Rammeverk-ID',
            framework_code: 'Rammeverkskode',
            no_assignments: 'Ingen rammeverkstildelingar.',
            compliance_rollup: 'Samsvarsoppsummering',
            entity_name: 'Eining',
            total_assessments: 'Totale Vurderingar',
            completed: 'Fullført',
            completion_pct: 'Fullføring %',
            open_gaps: 'Opne Manglar',
            critical_gaps: 'Kritiske',
            compliance_score: 'Poengsum',
            no_rollup: 'Ingen data for samsvarsoppsummering tilgjengeleg.',
            entity_summary: 'Eininga sitt Samsvarssamandrag',
            frameworks_assigned: 'Rammeverk',
            overall_score: 'Samla Poengsum',
            load_departments_error: 'Kunne ikkje laste avdelingar',
            load_users_error: 'Kunne ikkje laste brukarar',
            department_created: 'Avdeling oppretta',
            department_created_announce: 'Avdeling oppretta',
            create_department_error: 'Kunne ikkje opprette avdeling',
            user_mapped: 'Brukar tilknytt',
            user_mapped_announce: 'Brukar tilknytt avdeling',
            map_user_error: 'Kunne ikkje tilknytte brukar',
            user_removed: 'Brukar fjerna',
            load_rollup_error: 'Kunne ikkje laste samandrag',
            load_assignments_error: 'Kunne ikkje laste tildelingar',
            framework_assigned: 'Rammeverk tildelt',
            framework_assigned_announce: 'Rammeverk tildelt til eining',
            assign_framework_error: 'Kunne ikkje tildele rammeverk',
            assignment_removed: 'Tildeling fjerna',
            enter_entity_id_placeholder: 'Skriv inn einings-ID for å sjå tildelingar',
            entity_type_organization: 'Organisasjon',
            entity_type_department: 'Avdeling',
        },
        onboarding_maturity: {
            title: 'Onboarding modenhet',
            quick_starts: 'Rask start',
            progress: 'Onboarding Progress',
            personas: 'Persona Paths',
            persona_onboarding: 'Persona Onboarding',
            quick_start_scenarios: 'Hurtigstartscenarier',
            start: 'Start',
            restart: 'Start på nytt',
            estimated_minutes: 'Anslått minutter',
            steps: 'Trinn',
            scenario: 'Scenario',
            no_scenarios: 'Ingen hurtigstartscenarier tilgjengelig.',
            persona_id: 'Persona-ID',
            persona_label: 'Persona',
            role_description: 'Rollebeskrivelse',
            primary_modules: 'Primære moduler',
            recommended_tours: 'Anbefalte turer',
            sample_data_modules: 'Eksempel på datamoduler',
            quick_start_scenario: 'Hurtigstartscenario',
            no_personas: 'Ingen persona-stier tilgjengelig.',
            framework_setup: 'Regulatoriske rammeverk',
            framework_code: 'Rammekode',
            framework_name: 'Rammenavn',
            related_modules: 'Relaterte moduler',
            persona_relevance: 'Relevante personas',
            no_frameworks: 'Ingen alternativer for oppsett av rammeverk tilgjengelig.',
            tier_config: 'Konfigurasjon av nivåmodul',
            tier: 'Nivå',
            available_modules: 'Tilgjengelige moduler',
            module_count: 'Antall moduler',
            overall_completion: 'Samlet fullføring',
            wizard_completed: 'Veiviseren fullført',
            tours_completed: 'Turer fullført',
            quick_starts_completed: 'Hurtigstarter fullført',
            selected_frameworks: 'Utvalgte rammer',
            no_progress: 'Ingen ombordstigningsdata tilgjengelig.',
            detected_persona: 'Oppdaget persona',
            current_tier: 'Nåværende nivå',
            completion_pct: 'Fullføring',
            progress_page: {
                loaded: 'Framgang lasta',
                no_progress: 'Ingen onboarding-framgangsdata tilgjengeleg.',
                overall: 'Samla framgang',
                detected_persona: 'Oppdaga persona',
                tier: 'Nivå',
                modules: 'modular',
                wizard: 'Vegvisar',
                completed: 'Fullført',
                pending: 'Ventande',
                tours: 'Omvisingar',
                quick_starts: 'Snøggstartar',
                frameworks: 'Valde rammeverk',
                no_frameworks: 'Ingen rammeverk valde.',
                go_to_wizard: 'Fullfør oppsettrettleiaren',
                framework_selection: 'Rammeverkval',
                framework_toggle: 'Slå på eller av rammeverk for etterlevingsprogrammet ditt.',
                framework_updated: 'Rammeverkval oppdatert.',
                view_tours: 'Sjå omvisingar',
                view_quick_starts: 'Sjå snøggstartar',
            },
            persona_page: {
                description: 'Vel ein persona for å sjå tilrådde modular, omvisingar og snøggstartscenario.',
                no_personas: 'Ingen personastigar tilgjengelege.',
                modules: 'Modular',
                tours: 'Omvisingar',
                quick_start: 'Snøggstart',
                details: 'Detaljar',
                primary_modules: 'Primære modular',
                recommended_tours: 'Tilrådde omvisingar',
                framework_options: 'Regulatoriske rammeverk',
                no_frameworks: 'Ingen alternativ for rammeverkoppsett tilgjengelege.',
                framework_code: 'Rammeverkkode',
                framework_label: 'Merkelapp',
                region: 'Region',
                category: 'Kategori',
                enabled: 'Aktivert',
                disabled: 'Deaktivert',
                tier_modules: 'Nivåmodulkonfigurasjon',
                tiers_loaded: 'Nivåkonfigurasjonar lasta',
                no_tier_config: 'Ingen nivåkonfigurasjon tilgjengeleg.',
                view_tours: 'Sjå modulomvisingar',
                view_quick_start: 'Start snøggstart',
                toggle_framework: 'Veksle rammeverk',
                framework_updated: 'Rammeverkval oppdatert.',
                tier_desc_light: 'Grunnleggjande personvernfunksjonar � PDPL-etterlevingsgrunnlag',
                tier_desc_standard: 'Komplett etterlevingspakke � alle modular med arbeidsflyter',
                tier_desc_enterprise: 'Avansert styring og automatisering � multi-eining, grupperapportering',
                persona_highlight: 'Dine modular',
                aria_go_to_module: '[[TOK_1]] � gå til modulen',
                aria_start_tour: 'Start [[TOK_1]]',
                aria_quick_start: 'Rask start: [[TOK_1]]',
                aria_help_article: 'Hjelpeartikkel: [[TOK_1]]',
                aria_view_framework: '[[TOK_2]][[TOK_3]] � se rammedetaljer',
                aria_primary_for_persona: '[[TOK_1]] (primær for denne persona)',
                primary_for_persona_suffix: ' (primær for denne persona)',
                aria_view_in_persona_paths: '[[TOK_1]] � se i Persona Paths',
                progress_of_total: '[[TOK_2]] av [[TOK_3]] fullført',
            },
            quick_starts_page: {
                description: '��v vanlege arbeidsflyter med guidede snøggstartscenario.',
                no_scenarios: 'Ingen snøggstartscenario tilgjengelege.',
                started: 'Snøggstart starta',
                status_completed: 'Fullført',
                status_in_progress: 'Pågår',
                status_not_started: 'Ikkje starta',
                minutes: 'min',
                steps: 'steg',
                step: 'Steg',
                restart: 'Start på nytt',
                start: 'Start',
                go_to_module: 'Gå til modul',
                next_step: 'Neste steg',
                complete: 'Fullfør',
                reset: 'Nullstill',
                step_of: 'av',
                action_navigate: 'Naviger',
                action_form_fill: 'Fyll ut skjema',
                action_review: 'Gå gjennom',
                action_confirm: 'Stadfest',
                step_changed: 'Steg {current} av {total}: {title}',
                completed_message: 'Snøggstart fullført!',
                reset_message: 'Snøggstarten er nullstilt.',
            },
            persona_p_vn_01_label: 'Enterprise [[TOK_0]]',
            persona_p_vn_01_description: 'Databeskyttelsesansvarlig som administrerer bedriftsomfattende overholdelsesprogrammer',
            persona_p_vn_02_label: 'Avdelingseier',
            persona_p_vn_02_description: 'Avdelingsleder ansvarlig for seksjonssamsvarsrapportering',
            persona_p_vn_03_label: 'Overholdelse av e-handel',
            persona_p_vn_03_description: 'Overholdelsesansvarlig fokuserte på databeskyttelse og samtykke for e-handel',
            persona_p_vn_04_label: 'Telecom [[TOK_0]]',
            persona_p_vn_04_description: 'Telekomsektoren DPO administrerer abonnentdata og hendelsesrapportering',
            persona_p_vn_05_label: 'Leder for datastyring',
            persona_p_vn_05_description: 'Ledende ansvarlig for datakartlegging, klassifisering og styring',
            persona_p_vn_06_label: 'Cybersikkerhet og juridiske operasjoner',
            persona_p_vn_06_description: 'Cybersecurity officer administrerer hendelsesrespons og leverandørrisiko',
            persona_p_vn_07_label: 'AI Leder for styring',
            persona_p_vn_07_description: 'Lede som overvåker AI systemstyring, risikovurderinger og klassifisering',
            persona_p_vn_08_label: 'Cross-Border & Vendor Gov',
            persona_p_vn_08_description: 'Offiser som administrerer grenseoverskridende overføringer og leverandørstyring',
            persona_p_vn_09_label: 'Breach Response Lead',
            persona_p_vn_09_description: 'Lede koordinere bruddvarsling og hendelsesrespons',
            persona_p_vn_10_label: 'Leder for internrevisjon',
            persona_p_vn_10_description: 'Ledende ansvarlig for etterlevelsesrevisjon og gjennomgang av programstyring',
            persona_p_vn_11_label: 'HR- og tilsettdata-ansvarleg',
            persona_p_vn_11_description: 'HR-leiar som handterer samtykkeregistreringar for tilsette og interne DSARar',
            persona_p_vn_12_label: 'Samsvarleiar for multinasjonalt dotterselskap',
            persona_p_vn_12_description: 'Personvernombod i vietnamesisk dotterselskap av utanlandsk selskap som treng lokalt samsvarslagg',
            persona_p_vn_13_label: 'Samsvarleiar for utdanning',
            persona_p_vn_13_description: 'Samsvarleiar ved utanlandsk skule som handterer datavern for elevar og foreldre',
            qs_hr_consent_title: 'Registrer samtykke for tilsette',
            qs_hr_consent_description: 'Gjennomgang av registrering av tilsettesamtykke og generering av dekkingsrapport.',
            qs_subsidiary_dpia_title: 'Opprett DPIA-vurdering for dotterselskap',
            qs_subsidiary_dpia_description: 'Gjennomgang av oppretting av DPIA for ein databehandlingsaktivitet i dotterselskap.',
            qs_student_consent_title: 'Sett opp innsamling av elevsamtykke',
            qs_student_consent_description: 'Gjennomgang av oppretting av foreldresamtykkepolicyer for elevdata.',
            persona_p_vn_14_label: 'Ekstern juridisk rådgiver',
            persona_p_vn_14_description: 'Senior advokatfirmapartner som gir råd til flere klientorganisasjoner om PDPL overholdelse',
            persona_p_vn_15_label: 'Driftsleder i advokatfirmaet',
            persona_p_vn_15_description: 'Kundeengasjementskoordinator som administrerer leveringssporing og koordinering av tidsfrister',
            persona_p_vn_16_label: 'Bedriftseier / CEO',
            persona_p_vn_16_description: 'CEO eller GM som er juridisk behandlingsansvarlig under PDPL, ansvarlig for investering i samsvar',
            qs_dpia_filing_title: 'Fullfør din første DPIA innlevering',
            qs_dept_compliance_title: 'Send inn din første avdelingsseksjon for samsvar',
            qs_ecommerce_consent_title: 'Konfigurer innsamling av samtykke for e-handel',
            qs_telecom_data_title: 'Sett opp datahåndtering for teleabonnenter',
            qs_data_flow_title: 'Kartlegg din første dataflyt',
            qs_incident_response_title: 'Konfigurer arbeidsflyt for respons på hendelser',
            qs_ai_risk_title: 'Kjør en AI systemrisikovurdering',
            qs_cross_border_title: 'Vurder en grenseoverskridende dataoverføring',
            qs_breach_notification_title: 'Simuler en arbeidsflyt for bruddvarsling',
            qs_audit_trail_title: 'Gjennomgå et samsvarsrevisjonsspor',
            qs_legal_advisor_portfolio_title: 'Gjennomgå porteføljen for overholdelse av flere klienter',
            qs_legal_advisor_portfolio_description: 'Gjennomgå overholdelsesstatus på tvers av flere kundeorganisasjoner.',
            qs_law_firm_ops_title: 'Spor klientleveransestatus',
            qs_law_firm_ops_description: 'Overvåk fremdrift og kundeengasjement i rådgivningsleveranser.',
            qs_ceo_dashboard_title: 'Se kontrollpanelet for overholdelse av ledere',
            qs_ceo_dashboard_description: 'Gjennomgå overholdelsesstatus på høyt nivå og investeringsberegninger.',
        },
        rights_requests: {
            response_templates: {
                title: 'Svarmaler',
                subtitle: 'Administrer DSR-svarbrevmalene som ResponseGenerator bruker til å utarbeide svar til registrerte.',
                create_btn: 'Ny mal',
                edit_btn: 'Rediger mal',
                filter_right_type: 'Filtrer etter riktig type',
                filter_locale: 'Filtrer etter lokalitet',
                filter_status: 'Filtrer etter status',
                all_right_types: 'Alle riktige typer',
                any_right_type: 'Alle (gjelder alle typer)',
                all_locales: 'Alle lokaliteter',
                all_statuses: 'Alle',
                status_active: 'Aktiv',
                status_inactive: 'Inaktiv',
                empty_state: 'Ingen maler samsvarer med gjeldende filtre.',
                columns: {
                    template_id: 'Mal-ID',
                    outcome: 'Utfall',
                    locale: 'Språk',
                    right_type: 'Høyre type',
                    is_active: 'Status',
                    last_updated: 'Sist oppdatert',
                    actions: 'Handlinger',
                },
                actions: {
                    edit: 'Rediger',
                    clone: 'Klone',
                    deactivate: 'Deaktiver',
                    reactivate: 'Aktiver på nytt',
                    preview: 'Forhåndsvisning',
                },
                form: {
                    template_id: 'Mal-ID',
                    template_id_help: 'Små bokstaver, f.eks. dsr_access_fulfilled_vi',
                    outcome: 'Utfall',
                    locale: 'Språk',
                    right_type: 'Høyre type',
                    subject: 'Emne',
                    body: 'Kroppsmal',
                    body_help: 'Bruk plassholdere som [[TOK_3]], [[TOK_4]], [[TOK_5]]. Minimum 15 linjer for flerseksjonsbokstaver.',
                    is_active: 'Aktiv',
                    official_form_id: 'Offisiell skjema-ID (valgfritt)',
                },
                outcomes: {
                    fulfilled: 'Oppfylt',
                    partially_fulfilled: 'Delvis oppfylt',
                    denied: 'Nektet',
                },
                clone_modal_title: 'Klonemal',
                clone_target_locale: 'Målsted',
                clone_help: 'En ny mal vil bli opprettet i mållokalet med denne malen som utgangspunkt.',
                preview_modal_title: 'Forhåndsvisning av mal',
                preview_note: 'Forhåndsvisning bruker demo-case DSR-DEMO-0020 plassholdere. Ekte levering erstatter live case-data.',
                preview_unavailable: 'Forhåndsvisning krever en eksisterende sak. Legg ved denne malen til en sak og bruk utkast til svarhandling på saksdetaljsiden.',
                deactivate_confirm: 'Vil du deaktivere denne malen? Den vil fortsatt gjelde for eksisterende saker som refererer til den.',
                toasts: {
                    created: 'Mal opprettet',
                    updated: 'Malen er oppdatert',
                    deactivated: 'Malen er deaktivert',
                    reactivated: 'Mal reaktivert',
                    cloned: 'Mal klonet',
                    load_error: 'Kunne ikke laste inn maler',
                    save_error: 'Kunne ikke lagre malen',
                    clone_error: 'Kunne ikke klone malen',
                },
            },
        },
        organizations: {
            departments: {
                title: 'Avdelinger',
                subtitle: 'Administrer avdelingene som ruter DSR-saker, [[TOK_0]] oppgaver og overholdelsesarbeidsflyter.',
                create_btn: 'Ny avdeling',
                edit_btn: 'Rediger avdeling',
                columns: {
                    name: 'Navn',
                    description: 'Beskrivelse',
                    active_cases: 'Aktive saker',
                    members: 'Medlemmer',
                    status: 'Status',
                    actions: 'Handlinger',
                },
                status_active: 'Aktiv',
                status_inactive: 'Inaktiv',
                form: {
                    name: 'Navn',
                    description: 'Beskrivelse',
                },
                actions: {
                    edit: 'Rediger',
                    deactivate: 'Deaktiver',
                    reactivate: 'Aktiver på nytt',
                    delete: 'Slett',
                    manage_members: 'Administrer medlemmer',
                },
                delete_modal_title: 'Slett avdeling',
                delete_warning: 'Denne avdelingen har fortsatt aktive saker. Velg en avdeling du vil tilordne dem til før sletting.',
                delete_no_cases: 'Denne avdelingen har ingen aktive saker og kan slettes trygt.',
                reassign_prompt: 'Tilordne aktive saker på nytt til:',
                reassign_none_available: 'Ingen andre aktive avdelinger tilgjengelig. Opprett en annen avdeling først.',
                member_section_title: 'Medlemmer',
                add_member: 'Legg til medlem',
                remove_member: 'Fjern',
                member_role: 'Rolle',
                no_members: 'Ingen medlemmer tilordnet denne avdelingen.',
                toasts: {
                    created: 'Avdeling opprettet',
                    updated: 'Avdeling oppdatert',
                    deactivated: 'Avdeling deaktivert',
                    reactivated: 'Avdeling reaktivert',
                    deleted: 'Avdeling slettet',
                    reassigned_count: '[[TOK_1]] sak(er) er tilordnet på nytt',
                    member_added: 'Medlem lagt til',
                    member_removed: 'Medlem fjernet',
                    load_error: 'Kunne ikke laste avdelinger',
                    save_error: 'Kunne ikke lagre avdelingen',
                    delete_error: 'Kunne ikke slette avdelingen',
                },
            },
            retention_policies: {
                title: 'Retningslinjer for oppbevaring',
                subtitle: 'Konfigurer oppbevaringsvinduer per måltype. Identitetsverifiseringsdokumenter bruker dette til å stemple retention_expires_at på fremtidige opplastinger.',
                create_btn: 'Ny politikk',
                edit_btn: 'Rediger policy',
                columns: {
                    target_type: 'Måltype',
                    retention_days: 'Oppbevaring (dager)',
                    owner: 'Poliseier',
                    effective_from: 'Gjelder fra',
                    last_reviewed: 'Sist anmeldt',
                    status: 'Status',
                    actions: 'Handlinger',
                },
                status_active: 'Aktiv',
                status_inactive: 'Inaktiv',
                form: {
                    target_type: 'Måltype',
                    target_type_help: 'Hvilken datakategori oppbevaringsvinduet gjelder for. For øyeblikket støttes bare DSR-identitetsverifiseringsdokumenter.',
                    retention_days: 'Oppbevaringsvindu (dager)',
                    retention_days_help: 'Mellom 1 og 3650 dager (maks. 10 år).',
                    owner: 'Poliseier',
                    owner_help: 'Vanligvis [[TOK_0]]. Ansvarlig for oppbevaringsbeslutningen under DG-2.',
                    effective_from: 'Gjelder fra',
                },
                target_types: {
                    dsr_identity_verification_document: 'DSR identitetsverifiseringsdokumenter',
                },
                deactivate_notice: 'Deaktivering påvirker ikke allerede stemplede vedlegg � bare fremtidige opplastinger vil ikke lenger motta et oppbevaringsvindu.',
                deactivate_confirm: 'Vil du deaktivere denne oppbevaringsretningslinjen?',
                toasts: {
                    created: 'Oppbevaringspolicy opprettet',
                    updated: 'Oppbevaringspolicy oppdatert',
                    deactivated: 'Retningslinjer for oppbevaring er deaktivert',
                    load_error: 'Kunne ikke laste inn retningslinjer for oppbevaring',
                    save_error: 'Kunne ikke lagre retningslinjene for oppbevaring',
                },
            },
        },
    },
    data_mapping: {
        nav: {
            systems: 'System',
            categories: 'Datakategorier',
            registry: 'Dataregister',
            purposes: 'Behandlingsformål',
            retention: 'Lagring',
            flows: 'Dataflyt',
            activities: 'Behandlingsaktivitetar',
            evidence: 'Dokumentasjon',
            exports: 'Eksportar',
            attestation: 'Attestasjonssykluser',
            governance: 'Styring',
            review: 'Gjennomgangsoppgåver',
            inventory: 'Inventar',
            exceptions: 'Unntak',
            history: 'Historikk',
            ropa_completeness: 'ROPA fullstendighet',
        },
        ropa_completeness_autofix: {
            ask_button: 'Spør Forseti',
            drafting: 'Utkaster ⬦',
            accept: 'Godta',
            reject: 'Avvis',
            accepted: 'Godtatt � søk via aktivitetsredigering.',
            rejected: 'Avvist.',
            needs_human_input: 'Forseti trenger mer aktivitetskontekst (f.eks. et dokumentert formål) før utkast til dette feltet.',
        },
        ropa_completeness: {
            title: 'ROPA fullstendighetsrapport',
            subtitle: 'Hygienerevisjon per felt av dine registreringer av behandlingsaktiviteter, omfattet av regelverket.',
            framework_label: 'Rammeverk',
            kpi_total: 'Aktiviteter scoret',
            kpi_critical: 'Kritisk',
            kpi_high: 'Høy',
            kpi_conditional: 'Betinget',
            field_chart_heading: 'Manglende felt etter frekvens',
            drilldown_heading: 'Aktiviteter med hull',
            col_activity: 'Aktivitet',
            col_field: 'Felt',
            col_severity: 'Alvorlighetsgrad',
            col_condition: 'Tilstand',
            col_action: 'Fix',
            action_fix: 'Fix',
            severity_critical: 'Kritisk',
            severity_high: 'Høy',
            severity_conditional: 'Betinget',
            severity_informational: 'Informasjonsmessig',
            include_informational: 'Inkluder informasjon (ISO 27701)',
            export_csv: 'Last ned [[TOK_0]]',
            exporting: 'Eksporterer...',
            loading: 'Lastar⬦',
            empty_state: 'Alle aktive aktiviteter har fullstendige ROPA-poster for dette rammeverket.',
            error_fetch: 'Kunne ikke laste inn fullstendighetsrapporten.',
            error_unsupported_framework: 'Dette rammeverket støttes ikke.',
            error_framework_not_installed: 'Dette rammeverket er ikke installert for organisasjonen din.',
            no_misses_for_field: 'Ingen aktiviteter mangler dette feltet.',
            framework_PDPL: '[[TOK_0]] (lov 91/2025 + dekret 356)',
            framework_GDPR: '[[TOK_0]] Artikkel 30',
            framework_DECREE_165: 'Dekret 165 (Vietnam Data Law)',
            framework_ISO_27701: 'ISO 27701 (informasjon)',
        },
        registry: {
            page: {
                title: 'Dataregister',
                subtitle: 'Personlige dataelementer organisasjonen din har, organisert under Datakategorier.',
                empty_state: 'Ingen registerelementer ennå. Legg til en vare manuelt eller importer fra et regulatorisk register.',
                empty_filter_state: 'Ingen varer samsvarer med filtrene dine.',
            },
            filter: {
                category: 'Kategori',
                sensitivity: 'Følsomhet',
                data_subject: 'Datasubjekt',
                status: 'Status',
                data_tier: 'Datalag',
                cross_border: 'Grenseoverskridende',
                has_owner: 'Har eier',
                has_form_source: 'Importert fra skjema',
                search_placeholder: 'Søk etter navn, beskrivelse eller feltidentifikator ⬦',
                clear: 'Tøm filtre',
                option_all: 'Alle',
            },
            col: {
                name: 'Navn',
                category: 'Kategori',
                sensitivity: 'Følsomhet',
                data_subjects: 'Datasubjekter',
                systems: 'Systemer',
                activities: 'Aktiviteter',
                owner: 'Eier',
                retention: 'Oppbevaring',
                data_tier: 'Datalag',
                status: 'Status',
                last_reviewed: 'Sist anmeldt',
                actions: 'Handlinger',
            },
            action: {
                add_manual: 'Legg til element',
                add_from_form: 'Legg til fra forskriftsregister',
                import_history: 'Importer tidligere innsendinger',
                export: 'Eksporter',
                archive: 'Arkiv',
                restore: 'Gjenopprett',
                edit: 'Rediger',
                assign_owner: 'Tildel eier',
                attach_evidence: 'Legg ved bevis',
                open_lineage: '�&pen slekt',
            },
            modal_editor: {
                section_identity: 'Identitet',
                section_classification: 'Klassifisering',
                section_subjects: 'Emner og volum',
                section_location: 'Plassering og overføring',
                section_systems: 'Systemer og aktiviteter',
                section_retention: 'Oppbevaring og lov',
                section_governance: 'Styring',
                section_notes: 'Notater',
                hint_inherited: '(arvet fra kategori)',
                hint_overridden: '(overstyrt)',
                placeholder_field_identifiers: 'f.eks. kunder.primary_email, hris.employee_id',
                validation_name_required: 'Navn er påkrevd',
                validation_category_required: 'Kategori er påkrevd',
                validation_data_subjects_required: 'Det kreves minst én type registrert',
                label_data_type: 'Datatype',
                label_field_identifiers: 'Feltidentifikatorer (kommaseparert)',
                label_data_subject_types: 'Datasubjekttyper',
                label_volume_band: 'Volumbånd',
                label_storage_locations: 'Lagringsplasseringer (kommaseparert)',
                placeholder_storage_locations: 'ISO-3166 koder eller fritekst (f.eks. VN, Hetzner EU)',
                label_cross_border: 'Overføring over landegrensene',
                label_source_systems: 'Kildesystemer',
                label_processing_activities: 'Behandlingsaktiviteter',
                label_collection_method: 'Innsamlingsmetode',
                label_legal_basis: 'Rettslig grunnlag',
                label_purposes: 'Formål',
                hint_multi_select: 'Hold Cmd/Ctrl for å velge flere.',
                option_inherit_category: '� (arve fra kategori)',
                option_dash: '�',
            },
            modal_import: {
                dry_run_heading: 'Importer forhåndsvisning',
                label_to_create: '�& skape',
                label_to_update: 'For å oppdatere',
                label_skipped_archived: 'Hoppet over (arkivert)',
                label_conflicts: 'Konflikter',
                commit: 'Importer',
                cancel: 'Avbryt',
                conflict_row: '[[TOK_3]] � beholder redigeringen din ([[TOK_4]]); kartlegger ønsket [[TOK_5]].',
            },
            drawer: {
                section_category: 'Kategori',
                section_systems: 'Kildesystemer',
                section_activities: 'Behandlingsaktiviteter',
                section_flows: 'Dataflyter',
                section_retention: 'Effektiv oppbevaring',
                section_governance: 'Styring',
                section_evidence: 'Bevis',
                section_audit: 'Nylig revisjonsspor',
                section_source_form: 'Innsending av kildeskjema',
                badge_inherited: 'Nedarvet',
                badge_overridden: 'Overstyrt',
            },
            toast: {
                created: 'Registerelement opprettet.',
                updated: 'Registerelementet er oppdatert.',
                archived: 'Registerelement arkivert.',
                imported: '[[TOK_1]] elementer importert.',
                conflict_warning: '[[TOK_1]] felt(er) beholdt endringene dine � se konfliktliste.',
            },
        },
        systems: {
            title: 'Systemoversikt',
            new: 'Nytt system',
            edit: 'Rediger system',
            name: 'Namn',
            owner: 'Eigar',
            criticality: 'Kritikalitet',
            dpa_status: 'DPA-status',
            location: 'Plassering',
            system_type: 'Systemtype',
            metadata: 'Metadata ([[TOK_0]])',
            department: 'Avdeling',
            hosting_location: 'Driftsplassering',
            hosting_provider: 'Driftsleverandør',
            data_residency_country: 'Land for datalagring',
            hosting: 'Drift',
            no_systems: 'Ingen system funne',
            confirm_archive: 'Arkiver system «{name}»?',
            count: 'system',
            count_one: 'system',
            type_internal: 'Intern',
            type_external: 'Ekstern',
            type_cloud_service: 'Skyteneste',
            type_on_premise: 'Lokalt',
            type_hybrid: 'Hybrid',
            status_active: 'Aktiv',
            status_decommissioning: 'Under avvikling',
            status_decommissioned: 'Avvikla',
            status_planned: 'Planlagt',
            dpa_not_required: 'Ikkje påkravd',
            dpa_required_missing: 'Påkravd manglar',
            dpa_in_progress: 'Pågår',
            dpa_signed: 'Signert',
            all_criticalities: 'Alle kritikalitetar',
        },
        categories: {
            title: 'Datakategoriar',
            new: 'Ny kategori',
            edit: 'Rediger kategori',
            name: 'Namn',
            sensitivity: 'Sensitivitet',
            tags: 'Merkelappar',
            used_in: 'Brukt i',
            examples: 'Eksempel',
            examples_hint: 'Eksempel (kommaseparert)',
            default: 'Standard',
            all_sensitivities: 'Alle sensitivitetar',
            all_statuses: 'Alle statusar',
            no_categories: 'Ingen kategoriar funne',
            confirm_delete: 'Slett kategori «{name}»?',
            count: 'kategoriar',
            count_one: 'kategori',
            status_draft: 'Utkast',
            status_proposed: 'Føreslått',
            status_under_review: 'Under gjennomgang',
            status_approved: 'Godkjend',
            status_deprecated: 'Utdatert',
            status_updated: 'Kategoristatus oppdatert',
            propose: 'Føreslå',
            approve: 'Godkjenn',
            deprecate: 'Utdater',
        },
        purposes: {
            title: 'Behandlingsføremål',
            new: 'Nytt føremål',
            edit: 'Rediger føremål',
            name: 'Namn',
            legal_basis: 'Rettsleg grunnlag',
            retention_period: 'Lagringsperiode (dagar)',
            justification: 'Grunngiving for legitim interesse',
            legal_basis_detail: 'Detaljar om rettsleg grunnlag',
            all_legal_bases: 'Alle rettslege grunnlag',
            no_purposes: 'Ingen føremål funne',
            confirm_delete: 'Slett «{name}»?',
            default: 'Standard',
            count: '{count} føremål',
            count_one: '{count} føremål',
            basis_consent: 'Samtykke',
            basis_contract: 'Kontrakt',
            basis_legal_obligation: 'Rettsleg plikt',
            basis_vital_interest: 'Vital interesse',
            basis_public_interest: 'Allmenn interesse',
            basis_legitimate_interest: 'Berettiga interesse',
        },
        retention: {
            title: 'Lagringspolitikk',
            new: 'Ny politikk',
            edit: 'Rediger politikk',
            name: 'Namn',
            retention_days: 'Lagringsdagar',
            disposal_method: 'Avhendingsmetode',
            data_categories: 'Datakategoriar',
            activities: 'Aktivitetar',
            review_frequency: 'Gjennomgangsfrekvens',
            review_frequency_days: 'Gjennomgangsfrekvens (dagar)',
            no_policies: 'Ingen lagringspolitikk funnen',
            confirm_delete: 'Slett «{name}»?',
            count: '{count} politikkar',
            count_one: '{count} politikk',
            days: 'dagar',
            disposal_deletion: 'Sletting',
            disposal_anonymization: 'Anonymisering',
            disposal_archival: 'Arkivering',
            review_overdue: 'Gjennomgang forfallen',
            review_status: 'Gjennomgangsstatus',
            review_ok: 'På sporet',
            department: 'Avdeling',
            all_departments: 'Alle avdelingar',
        },
        flows: {
            view_tabs_aria: 'Strømningsvisning',
            view_list: 'Liste',
            view_map: 'Kart',
            title: 'Dataflyt',
            new: 'Ny flyt',
            edit: 'Rediger flyt',
            name: 'Namn',
            from_system: 'Frå system',
            to_system: 'Til system',
            flow_type: 'Flyttype',
            cross_border: 'Grensekryssande',
            risk_level: 'Risikonivå',
            mechanism: 'Mekanisme',
            transfer_mechanism: 'Overføringsmekanisme',
            frequency: 'Frekvens',
            source_country: 'Kjeldeland',
            destination_country: 'Destinasjonsland',
            transfer_safeguard: 'Overføringstryggingstiltak',
            all_risk_levels: 'Alle risikonivå',
            no_flows: 'Ingen dataflyt funne',
            confirm_archive: 'Arkiver «{name}»?',
            count: '{count} flytar',
            count_one: '{count} flyt',
            status_active: 'Aktiv',
            status_inactive: 'Inaktiv',
            status_under_review: 'Under gjennomgang',
            mechanism_api: 'API',
            mechanism_file_transfer: 'Filoverføring',
            mechanism_database_replication: 'Databasereplikering',
            mechanism_manual: 'Manuell',
            mechanism_email: 'E-post',
            mechanism_other: 'Anna',
            frequency_real_time: 'Sanntid',
            frequency_hourly: 'Kvar time',
            frequency_daily: 'Dagleg',
            frequency_weekly: 'Vekeleg',
            frequency_monthly: 'Månadleg',
            frequency_on_demand: 'Ved behov',
            frequency_one_time: 'Eingangs',
            safeguard_adequacy_decision: 'Tilstrekkelegheitsbeslutning',
            safeguard_standard_contractual_clauses: 'Standardkontraktsvilkår',
            safeguard_binding_corporate_rules: 'Bindande verksemdsreglar',
            safeguard_explicit_consent: 'Uttrykkeleg samtykke',
            safeguard_legal_obligation: 'Rettsleg plikt',
            safeguard_none: 'Ingen',
            safeguard_other: 'Anna',
        },
        activities: {
            title: 'Behandlingsaktivitetar',
            new: 'Ny aktivitet',
            edit: 'Rediger aktivitet',
            activity_title: 'Tittel',
            category: 'Kategori',
            legal_basis: 'Rettsleg grunnlag',
            dpa_required: 'DPA påkravd',
            ropa_generated: 'RoPA generert',
            version: 'Versjon',
            generate_ropa: 'Generer RoPA',
            controller: 'Behandlingsansvarleg',
            controller_name: 'Namn på behandlingsansvarleg',
            controller_contact: 'Kontakt for behandlingsansvarleg',
            legal_basis_detail: 'Detaljar om rettsleg grunnlag',
            organization_info: 'Organisasjonsinformasjon (Vedlegg I)',
            org_address: 'Organisasjonsadresse',
            tax_code: 'Skattekode',
            contact_person: 'Kontaktperson',
            contact_email: 'Kontakt-e-post',
            contact_phone: 'Kontakttelefon',
            select_entity: 'Velg...',
            no_entities: 'Ingen varer funnet',
            dpo_name: 'DPO-namn',
            dpo_contact: 'DPO-kontakt',
            processor_name: 'Databehandlarnamn',
            processor_contact: 'Databehandlarkontakt',
            data_subjects: 'Registrerte',
            data_subjects_hint: 'Registrerte (kommaseparert)',
            recipients: 'Mottakarar',
            recipients_hint: 'Mottakarar (kommaseparert)',
            security_measures: 'Tryggingstiltak',
            dpia_reference: 'DPIA-referanse',
            no_activities: 'Ingen behandlingsaktivitetar funne',
            confirm_archive: 'Arkiver «{name}»?',
            count: '{count} aktivitetar',
            count_one: '{count} aktivitet',
            ropa_success: 'RoPA-post generert. Gå til Eksporter for å laste den ned.',
            ropa_error: 'Kunne ikkje generere RoPA',
            required_label: 'Påkravd',
            status_draft: 'Utkast',
            status_active: 'Aktiv',
            status_under_review: 'Under gjennomgang',
            status_archived: 'Arkivert',
            decree_165_heading: 'Dekret 165 datalag (Vietnam Data Law)',
            decree_165_helper: 'Klassifiser dataene denne aktiviteten behandler i henhold til Vietnam-dekret 165. Vanlige data får grunnlinjen for grenseoverskridende regime; viktige og kjernedata utløser ytterligere forpliktelser.',
            data_tier_label: 'Datalag',
            data_tier_help: 'Dekret 165 klassifiserer data som vanlige, viktige eller kjerne � se hjelpeartikkelen for veiledning.',
            data_tier_column_header: 'Datalag',
            data_tier_regular: 'Vanlig',
            data_tier_important: 'Viktig',
            data_tier_core: 'Kjerne',
            transfer_mechanism_label: 'Overføringsmekanisme over landegrensene',
            transfer_mechanism_placeholder: 'f.eks. Standard kontraktsklausuler, beslutning om adekvathet',
            security_assessment_reference_label: 'Sikkerhetsvurderingsreferanse',
            security_assessment_reference_placeholder: 'f.eks. [[TOK_0]]-SA-2026-001',
        },
        evidence: {
            title: 'Dokumentasjonsarkiv',
            new: 'Ny dokumentasjon',
            edit: 'Rediger dokumentasjon',
            name: 'Namn',
            evidence_type: 'Dokumentasjonstype',
            linked_entities: 'Knytte einingar',
            uploaded: 'Opplasta',
            expiry: 'Utløp',
            file_url: 'Fil-URL',
            source_mode_label: 'Beviskjelde',
            source_mode_file: 'Last opp fil',
            source_mode_url: 'Lenk ekstern URL',
            attachment_label: 'Vedlegg',
            link_to: 'Knyt dokumentasjon til',
            entity_type: 'Einingstype',
            entity_id: 'Einings-ID',
            no_evidence: 'Ingen dokumentasjon funnen',
            manage_links: 'Administrer lenker',
            unlink: 'Fjern tilknytningen',
            confirm_delete: 'Slett dokumentasjon «{name}»?',
            count: '{count} element',
            count_one: '{count} element',
            type_document: 'Dokument',
            type_screenshot: 'Skjermbilete',
            type_policy: 'Retningslinje',
            type_contract: 'Kontrakt',
            type_assessment: 'Vurdering',
            type_correspondence: 'Korrespondanse',
            type_other: 'Anna',
            linked_type_system: 'System',
            linked_type_data_flow: 'Dataflyt',
            linked_type_processing_activity: 'Behandlingsaktivitet',
            linked_type_data_category: 'Datakategori',
            linked_type_purpose: 'Formål',
            linked_type_retention_policy: 'Oppbevaringspolicy',
            link_entity: 'Link til enhet',
            link_success: 'Enheten er tilkoblet',
            confirm_unlink: 'Er du sikker på at du vil fjerne tilknytningen til denne enheten?',
            unlink_success: 'Enheten ble fjernet',
            no_linked_entities: 'Ingen tilknyttede enheter',
            select_entity: 'Velg...',
            no_entities: 'Ingen varer',
        },
        exports: {
            title: 'Dataeksportar',
            recent: 'Nylegaste eksportar',
            export_type: 'Eksporttype',
            format: 'Format',
            requested_by: 'Førespurt av',
            requested_at: 'Førespurt',
            download: 'Last ned',
            csv_export: 'CSV-eksport',
            csv_description: 'Last ned data i CSV-format for reknearkanalyse.',
            pdf_reports: 'PDF-rapportar',
            pdf_description: 'Generer formaterte rapportar for samsvarsdokumentasjon.',
            csv_systems: 'Systemoversikt',
            csv_categories: 'Datakategoriar',
            csv_flows: 'Dataflyt',
            csv_activities: 'Behandlingsaktivitetar',
            csv_cross_border: 'Grensekryssande flytar',
            csv_retention_policies: 'Retningslinjer for oppbevaring',
            csv_evidence: 'Beviselementer',
            csv_governance_assignments: 'Styringsoppdrag',
            pdf_ropa: 'RoPA-register',
            pdf_systems: 'Systemrapport',
            pdf_cross_border: 'Grensekryssande rapport',
            pdf_flow_map: 'Flytkartdata',
            export_failed: 'Eksport feila',
            pdf_generated: 'PDF generert.',
            ropa: 'RoPA Register',
            retention_policies: 'Retningslinjer for oppbevaring',
            governance_assignments: 'Styringsoppdrag',
            col_entity: 'Eksporter enhet',
            col_description: 'Beskrivelse',
            desc_ropa: 'Fullstendig ROPA-register over alle behandlingsaktiviteter med juridisk grunnlag, [TOK_0]] status og kontroller.',
            desc_systems: 'Systeminventar med eier, datakategori-tagger og overholdelsesstatus.',
            desc_activities: 'Individuelle behandlingsaktiviteter med behandlingsansvarlig, juridisk grunnlag og [[TOK_0]] klassifisering.',
            desc_categories: 'Datakategorier og sensitivitetsnivåer brukt på tvers av klassifisering og revisjoner.',
            desc_purposes: 'Behandlingsformål med henvisninger til rettslig grunnlag i henhold til dekret 13/2023 og telekommunikasjonslov 2023.',
            desc_flows: 'Dataflyter mellom systemer, inkludert interne og grenseoverskridende ruter.',
            desc_cross_border: 'Bare grenseoverskridende strømmer, med overføringsmekanisme og risikovurdering.',
            desc_retention_policies: 'Retningslinjer for oppbevaring, avhendingsmetoder og gjennomgangstråkk.',
            desc_evidence: 'Bevis knyttet til behandlingsaktiviteter: sertifikater, DPA-kontrakter, [[TOK_0]] rapporter.',
            desc_governance_assignments: 'Styringsoppdrag: eiere, godkjennere og ISO 27001-referanser.',
            unified_heading: 'Eksporter enheter',
            unified_description: 'Eksporter enhver datakartleggingsenhet i [[TOK_0]], [[TOK_3]], [[TOK_2]], eller [[TOK_1]]-format. All eksport lagres i filleseren.',
            export_button_label: 'Eksporter',
            csv_download_success: 'CSV lasta ned.',
        },
        attestation: {
            title: 'Attestasjonssyklusar',
            create: 'Ny syklus',
            name: 'Syklusnamn',
            year: '�&r',
            deadline: 'Frist',
            scope: 'Omfang',
            status: 'Status',
            tasks: 'Avdelingsoppgåver',
            assign_tasks: 'Tildel oppgåver',
            department: 'Avdeling',
            assignee: 'Tildelt til',
            progress: 'Framdrift',
            stale_entries: 'Utdaterte oppføringar',
            detect_stale: 'Finn utdaterte',
            export_bundle: 'Eksporter pakke',
            no_cycles: 'Ingen attestasjonssyklusar enno.',
            create_success: 'Attestasjonssyklus oppretta.',
            assign_success: 'Oppgåver tildelte.',
            complete_success: 'Oppgåve fullført.',
            stale_detected: 'Utdaterte oppføringar funne.',
            stale_systems: 'Utdaterte system',
            stale_flows: 'Utdaterte flytar',
            no_stale: 'Ingen utdaterte oppføringar funne.',
            stale_name: 'Namn',
            stale_announcement: 'Fann {0} utdaterte system og {1} utdaterte flytar',
            last_updated: 'Sist oppdatert',
            status_draft: 'Utkast',
            status_active: 'Aktiv',
            status_completed: 'Fullført',
            task_status_pending: 'Ventar',
            task_status_in_progress: 'Pågår',
            task_status_completed: 'Fullført',
            scope_systems: 'System',
            scope_flows: 'Datastraumar',
            scope_activities: 'Aktivitetar',
            scope_categories: 'Kategoriar',
            scope_purposes: 'Føremål',
            scope_retention: 'Lagring',
        },
        governance: {
            title: 'Styringstildelingar',
            assign: 'Tildel eigarskap',
            entity_type: 'Entitetstype',
            entity: 'Entitet',
            role: 'Rolle',
            assigned_by: 'Tildelt av',
            assigned_at: 'Tildelt den',
            remove: 'Fjern',
            no_assignments: 'Ingen styringstildelingar.',
            assign_success: 'Eigarskap tildelt.',
            remove_success: 'Tildeling fjerna.',
            assignee: 'Tilordna',
            department: 'Avdeling',
            all_departments: 'Alle avdelingar',
            roles: {
                data_owner: 'Dataeigar',
                data_steward: 'Dataforvaltar',
                data_custodian: 'Dataansvarleg',
                informed: 'Informert',
            },
            entity_types: {
                system: 'System',
                flow: 'Datastraum',
                activity: 'Aktivitet',
                category: 'Kategori',
                purpose: 'Føremål',
                retention_policy: 'Lagringspolicy',
            },
        },
        risk_assessment: {
            title: 'Risikovurdering',
            create: 'Ny vurdering',
            safeguard_type: 'Vernetype',
            adequacy_status: 'Tilstrekkelegheitsstatus',
            risk_factors: 'Risikofaktorar',
            mitigations: 'Tiltak',
            reviewer: 'Meldar',
            decision: 'Avgjerd',
            approve: 'Godkjenn',
            reject: 'Avvis',
            no_assessments: 'Ingen risikovurderingar.',
            create_success: 'Risikovurdering oppretta.',
            approve_success: 'Vurdering godkjend.',
            reject_success: 'Vurdering avvist.',
            one_per_line: '�0in per linje',
            safeguard_adequacy_decision: 'Adekvansfråsegn',
            safeguard_standard_contractual_clauses: 'Standardkontraktsklausular',
            safeguard_binding_corporate_rules: 'Bindande konsernreglar',
            safeguard_explicit_consent: 'Uttrykkeleg samtykke',
            safeguard_legal_obligation: 'Rettsleg plikt',
            safeguard_none: 'Ingen',
            safeguard_other: 'Anna',
            adequacy_adequate: 'Adekvat',
            adequacy_inadequate: 'Utilstrekkeleg',
            adequacy_under_review: 'Under vurdering',
            adequacy_not_assessed: 'Ikkje vurdert',
            decision_approved: 'Godkjend',
            decision_rejected: 'Avvist',
        },
        review: {
            title: 'Gjennomgangsoppgåver',
            description: 'Gjennomgangsoppgåver vert oppretta automatisk når ein datakategori vert føreslått. For å lage ei ny oppgåve, gå til Datakategoriar og klikk Foreslå på ein kladde-kategori.',
            count: 'gjennomgangsoppgåver',
            summary: 'Gjennomgangsoversikt',
            pending: 'Ventande',
            resolved_today: 'Løyst i dag',
            escalated: 'Eskalert',
            overdue: 'Forfalle (>5 dagar)',
            all_statuses: 'Alle statusar',
            status_pending: 'Ventande',
            status_resolved: 'Løyst',
            status_escalated: 'Eskalert',
            category_name: 'Kategori',
            system_name: 'System',
            owner: 'Eigar',
            resolve: 'Løys',
            resolve_task: 'Løys gjennomgangsoppgåve',
            resolution: 'Løysing',
            resolution_approve: 'Godkjenn',
            resolution_modify: 'Endre og godkjenn',
            resolution_reject: 'Avvis',
            resolution_escalate: 'Eskaler',
            notes: 'Løysingsnotat',
            notes_required: 'Notat påkravd (minimum 10 teikn) for Endre, Avvis eller Eskaler',
            resolved_success: 'Gjennomgangsoppgåve løyst',
            bulk_approve: 'Massegodkjenning',
            bulk_reject: 'Masseavvising',
            bulk_success: '{count} oppgåver handsama',
            no_tasks: 'Ingen gjennomgangsoppgåver funne',
        },
        inventory: {
            title: 'Klassifiseringsinventar',
            count: 'system',
            summary: 'Inventaroversikt',
            total_systems: 'Totalt system',
            total_labels: 'Totalt etikettar',
            system_name: 'System',
            label_count: 'Etikettar',
            approved_count: 'Godkjend',
            pending_count: 'Ventande',
            no_items: 'Ingen inventarelement funne',
        },
        exceptions: {
            title: 'Klassifiseringsunntak',
            count: 'unntak',
            all_severities: 'Alle alvorlegheitsgradar',
            all_statuses: 'Alle statusar',
            system_name: 'System',
            severity_label: 'Alvorlegheitsgrad',
            status_open: '�&pne',
            status_resolved: 'Løyst',
            status_accepted_risk: 'Akseptert risiko',
            resolve: 'Løys',
            resolve_exception: 'Løys unntak',
            resolution_type: 'Løysingstype',
            notes: 'Notat',
            justification_required: 'Grunngiving påkravd (minimum 10 teikn) for akseptert risiko',
            resolved_success: 'Unntak løyst',
            no_exceptions: 'Ingen unntak funne',
        },
        history: {
            title: 'Klassifiseringshistorikk',
            count: 'hendingar',
            actor: 'Aktør',
            action: 'Handling',
            entity_type: 'Entitetstype',
            changes: 'Endringar',
            view_lineage: 'Vis opphav',
            lineage_title: 'Klassifiseringsopphav',
            no_events: 'Ingen historikkhendingar funne',
            no_lineage: 'Ingen opphavsdata tilgjengeleg',
            modified: 'Endra',
            created: 'Oppretta',
            removed: 'Fjerna',
            action_created: 'Opprettet',
            action_updated: 'Oppdatert',
            action_archived: 'Arkivert',
            action_approved: 'Godkjent',
            action_deprecated: 'Utdatert',
            entity_label: 'Etikett',
            entity_taxonomy: 'Taksonomi',
            entity_review_task: 'Gjennomgangsoppgåve',
            entity_exception: 'Unntak',
            before: 'Før',
            after: 'Etter',
        },
    },
    governance: {
        audit_trail_title: 'Revisjonsspor for styring',
        audit_trail_subtitle: 'Kryss-entitets revisjonsstraum for styringshandlingar � godkjenningar, playbook-utføringar, provlenkjer og meir.',
        audit_trail_item_count: 'revisjonshendingar',
        audit_trail_fetch_error: 'Kunne ikkje henta revisjonshendingar.',
        audit_trail_no_events: 'Ingen revisjonshendingar funne for gjeldande filter.',
        audit_trail_entity_type: 'Entitetstype',
        audit_trail_entity_id: 'Entitets-ID',
        audit_trail_action: 'Handling',
        audit_trail_actor: 'Aktør',
        audit_trail_timestamp: 'Tidsstempel',
        audit_trail_date_from: 'Frå',
        audit_trail_date_to: 'Til',
        audit_trail_no_rows_to_export: 'Ingen rader å eksportera.',
        nav: {
            vendors: 'Leverandørar',
            subprocessors: 'Underdatabehandlarar',
            cross_border: 'Grensekryssande',
            drift: 'Avviksovervaking',
            scores: 'Samsvarspoeng',
            playbooks: 'Handlingsplanar',
            approvals: 'Godkjenningar',
            audit_trail: 'Revisjonsspor',
            board_report: 'Styrerapport',
            evidence: 'Dokumentasjon',
            onboarding: 'Onboarding-prosess',
            dpa_reviews: 'DPA-gjennomgangar',
            periodic_reviews: 'Periodiske gjennomgangar',
            offboarding: 'Avregistrering',
        },
        vendors: {
            title: 'Leverandørregister',
            new: 'Ny leverandør',
            edit: 'Rediger leverandør',
            name: 'Namn',
            jurisdiction: 'Jurisdiksjon',
            dpa_status: 'DPA-status',
            risk_level: 'Risikonivå',
            onboarding_status: 'Innføringsstatus',
            contact_email: 'Kontakt-e-post',
            contact_name: 'Kontaktperson',
            contact_phone: 'Kontakttelefon',
            website: 'Nettstad',
            services_csv: 'Tenester (kommaseparert)',
            country: 'Land',
            country_placeholder: 'f.eks. NO',
            last_reviewed: 'Sist gjennomgått',
            offboard: 'Avslutt',
            offboard_vendor: 'Avslutt leverandør',
            offboard_reason: 'Grunn for avslutting',
            no_vendors: 'Ingen leverandørar funne',
            vendor_count: '{count} leverandør(ar)',
            all_dpa_status: 'Alle DPA-statusar',
            all_risk_levels: 'Alle risikonivå',
            all_onboarding: 'Alle innføringsstatusar',
            fetch_error: 'Feila. Prøv igjen.',
            save_error: 'Kunne ikkje lagra leverandør',
            offboard_error: 'Kunne ikkje avslutte',
        },
        vendor_types: {
            processor: 'Databehandlar',
            sub_processor: 'Underdatabehandlar',
            controller: 'Behandlingsansvarleg',
            joint_controller: 'Felles Behandlingsansvarleg',
        },
        onboarding_statuses: {
            pending_review: 'Ventar på Gjennomgang',
            approved: 'Godkjend',
            active: 'Aktiv',
            suspended: 'Suspendert',
            offboarded: 'Avslutta',
        },
        dpa_statuses: {
            not_required: 'Ikkje Påkravd',
            required_missing: 'Påkravd Manglar',
            draft: 'Utkast',
            under_review: 'Under Gjennomgang',
            signed: 'Signert',
            expired: 'Utløpt',
        },
        risk_levels: {
            critical: 'Kritisk',
            high: 'Høg',
            medium: 'Middels',
            low: 'Låg',
        },
        approval_statuses: {
            pending: 'Ventar',
            approved: 'Godkjend',
            rejected: 'Avvist',
            expired: 'Utløpt',
        },
        approval_action_types: {
            vendor_onboarding: 'Leverandørtilknyting',
            vendor_offboarding: 'Leverandøravslutting',
            cross_border_acceptance: 'Grenseoverskridande Godkjenning',
            playbook_activation: 'Playbook-aktivering',
            drift_accept_risk: 'Avvik Aksepter Risiko',
            activity_activation: 'Aktivitetsaktivering',
        },
        drift_check_types: {
            dpa_expiry: 'DPA-utløp',
            dpa_missing: 'DPA Manglar',
            review_overdue: 'Gjennomgang Forfallen',
            cross_border_gap: 'Grenseoverskridande Mangel',
            sub_processor_chain: 'Underdatabehandlarkjede',
            risk_assessment_overdue: 'Risikovurdering Forfallen',
            retention_policy_missing: 'Oppbevaringspolicy Manglar',
            evidence_expiring: 'Dokumentasjon Utløper',
        },
        drift_statuses: {
            open: 'Opne',
            acknowledged: 'Stadfesta',
            in_progress: 'Pågår',
            resolved: 'Løyst',
            accepted_risk: 'Akseptert Risiko',
        },
        drift_entity_types: {
            vendor: 'Leverandør',
            system: 'System',
            data_flow: 'Dataflyt',
            processing_activity: 'Behandlingsaktivitet',
            evidence_item: 'Dokumentasjon',
        },
        playbook_statuses: {
            draft: 'Utkast',
            active: 'Aktiv',
            archived: 'Arkivert',
        },
        playbook_action_types: {
            delete_data: 'Slett Data',
            verify_deletion: 'Stadfest Sletting',
            notify_vendor: 'Varsle Leverandør',
            confirm_receipt: 'Stadfest Mottak',
            document_evidence: 'Dokumenter',
            other: 'Anna',
        },
        playbook_target_types: {
            system: 'System',
            vendor: 'Leverandør',
        },
        dpa_chain_statuses: {
            complete: 'Komplett',
            incomplete: 'Ufullstendig',
            unknown: 'Ukjend',
        },
        sub_processor_statuses: {
            active: 'Aktiv',
            terminated: 'Avslutta',
        },
        evidence_types: {
            dpa_agreement: 'DPA-avtale',
            risk_assessment: 'Risikovurdering',
            audit_report: 'Revisjonsrapport',
            certification: 'Sertifisering',
            deletion_confirmation: 'Slettingsstadfesting',
            training_record: 'Opplæringsjournal',
            incident_report: 'Hendingsrapport',
            document: 'Dokument',
            screenshot: 'Skjermbilete',
            policy: 'Retningslinje',
            contract: 'Kontrakt',
            assessment: 'Vurdering',
            correspondence: 'Korrespondanse',
            other: 'Anna',
        },
        linkable_entity_types: {
            vendor: 'Leverandør',
            transfer_mechanism: 'Overføringsmekanisme',
            playbook: 'Spelbok',
            execution: 'Utføring',
            system: 'System',
            activity: 'Aktivitet',
        },
        subprocessors: {
            title: 'Underdatabehandlarrelasjonar',
            new: 'Ny kopling',
            vendor: 'Leverandør',
            subprocessor: 'Underdatabehandlar',
            relationship_type: 'Relasjonstype',
            countries: 'Land',
            countries_csv: 'Land (kommaseparert)',
            dpa_chain: 'DPA-kjede',
            dpa_chain_status: 'DPA-kjedestatus',
            no_processors: 'Ingen databehandlarar funne.',
            no_subprocessors: 'Ingen underdatabehandlarar funne.',
            processor_vendor: 'Databehandlarleverandør',
            select_processor: 'Vel databehandlar',
            select_vendor: 'Vel leverandør',
            services: 'Tenester',
            sub_processor_vendor_id: 'Underdatabehandlar leverandør-ID',
            terminate: 'Avslutt',
            confirm_terminate: 'Er du sikker på at du vil avslutte denne relasjonen?',
            create_error: 'Kunne ikkje opprette kopling.',
            fetch_error: 'Kunne ikkje hente underdatabehandlarar.',
            processor: 'Databehandlar',
            services_csv: 'Tenester (kommaseparert)',
            terminate_error: 'Kunne ikkje avslutte.',
            version_history_heading: 'Sub-prosessor endre versjonering',
            change_tracking_note: 'Alle endringer i forholdet til underbehandleren er versjonert. Hver modifikasjon registrerer før/etter-tilstanden for revisjonsspor.',
            history_retention_note: 'Endringshistorikk beholdes i hele dataoppbevaringsperioden. Gjennomgå endringslogger via leverandørens detaljvisning.',
            vendor_risk_cross_view_heading: 'Underleverandørregister (Vendor Risk)',
            vendor_risk_cross_view_source: 'Kjelde: Vendor Risk-register',
            vendor_risk_cross_view_empty: 'Ingen oppføringar i Vendor Risk-registeret.',
        },
        cross_border: {
            title: 'Grensekryssande styringsrapport',
            flows: 'Grensekryssande flytar',
            transfers: 'Grensekryssande overføringar',
            detected_gaps: 'Oppdaga manglar',
            safeguards: 'Tryggingstiltak',
            cross_border_vendors: 'Grensekryssande leverandørar',
            destination: 'Destinasjon',
            no_cross_border_vendors: 'Ingen grensekryssande leverandørar funne.',
            no_safeguard: 'Ingen tryggingstiltak',
            processing_locations: 'Behandlingslokasjonar',
            export_error: 'Kunne ikkje eksportere rapport.',
            export_pdf: 'Eksporter PDF',
            export_success: 'Rapport eksportert.',
            exporting: 'Eksporterer...',
            fetch_error: 'Kunne ikkje hente grensekryssande data.',
            source: 'Kjelde',
            pdpl_p2_heading: '[[TOK_0]]-P2 Overholdelse av grenseoverskridende overføringer',
            dossier_prep_note: 'Utarbeidelse av dossier: Sett sammen konsekvensanalyse, juridisk grunnlag og ivareta dokumentasjon før innlevering.',
            filing_tracking_note: 'Filsporing: overvåk innsendingsstatus hos myndigheten (PDPC) fra første søknad til godkjenning.',
            supplement_loop_note: 'Tilleggssløyfe: svar på forespørsler om myndighetsinformasjon og send inn endrede dossierer på nytt etter behov.',
            official_forms_note: 'Offisielle skjemaer: bruk Mau so 01a (Søknad), Mau so 01b (tilleggsinformasjon) og Mau so 09 (Transfer Impact Assessment) i henhold til [[TOK_0]]-P2 forskrifter.',
            vendor_search_label: 'Leverandørsøk',
            vendor_search_placeholder: 'Søk etter leverandørnamn⬦',
            jurisdiction_filter_label: 'Jurisdiksjon',
            filings_section_heading: 'Innleveringer på tvers av landegrensene',
            filings_empty: 'Ingen innleveringer ennå. Opprett en for å starte et dossier.',
            filings_create_button: 'Ny arkivering',
            filings_table_id: 'Innleverings-ID',
            filings_table_jurisdiction: 'Jurisdiksjon',
            filings_table_type: 'Skjematype',
            filings_table_status: 'Status',
            filings_table_updated: 'Oppdatert',
            filings_table_open: '�&pne',
            filings_detail_title: 'Grenseoverskridende arkivering',
            filings_back_to_list: 'Tilbake til Cross-Border',
            filings_status_heading: 'Livssyklus',
            filings_evidence_heading: 'Bevis',
            filings_history_heading: 'Revisjonsspor',
            filings_field_filing_id: 'Innleverings-ID',
            filings_field_jurisdiction: 'Jurisdiksjon',
            filings_field_type: 'Skjematype',
            filings_field_status: 'Status',
            filings_field_reference: 'Myndighetsreferanse',
            filings_field_mps_receipt: '[[TOK_0]] kvittering',
            filings_field_submitted_at: 'Innlevert kl',
            filings_field_acknowledged_at: 'Bekreftet kl',
            filings_field_archived_at: 'Arkivert på',
            filings_field_version: 'Versjon',
            filings_field_notes: 'Notater',
            filings_action_advance: 'Forhåndsstatus',
            filings_action_reject: 'Avvis',
            filings_action_archive: 'Arkiv',
            filings_action_submit: 'Merket er sendt inn',
            filings_action_acknowledge: 'Mark kvitterte',
            filings_action_resume_draft: 'Fortsett som utkast',
            filings_status_draft: 'Utkast',
            filings_status_assessed: 'Vurdert',
            filings_status_pending_review: 'Venter på vurdering',
            filings_status_ready_to_file: 'Klar til å arkivere',
            filings_status_submitted: 'Sendt inn',
            filings_status_acknowledged: 'Erkjent',
            filings_status_rejected: 'Avvist',
            filings_status_archived: 'Arkivert',
            filings_type_mau_01a: 'Mẫu 01a � Overføringssøknad',
            filings_type_mau_03a: 'Mẫu 03a � Tilleggsmappe',
            filings_type_mau_09: 'Mẫu 09 � Overføringskonsekvensvurdering',
            filings_new_dialog_title: 'Ny grenseoverskridende arkivering',
            filings_new_form_jurisdiction: 'Jurisdiksjon (f.eks. VN-[[TOK_0]])',
            filings_new_form_type: 'Skjematype',
            filings_new_form_notes: 'Merknader (valgfritt)',
            filings_new_submit: 'Opprett',
            filings_new_cancel: 'Avbryt',
            filings_reason_label: 'Grunn',
            filings_reference_label: 'Myndighetsreferansenummer',
            filings_mps_receipt_label: '[[TOK_0]] kvitteringsreferanse',
            filings_create_error: 'Kunne ikke opprette arkivering.',
            filings_create_success: 'Arkiv opprettet.',
            filings_update_error: 'Kunne ikke oppdatere arkiveringen.',
            filings_update_success: 'Arkiv oppdatert.',
            filings_fetch_error: 'Kunne ikke hente arkiver.',
            filings_archive_confirm: 'Vil du arkivere denne arkiveringen? Dette kan ikke angres.',
            filings_status_rejected_detour: 'Innlevering ble avvist etter gjennomgang. Fortsett som utkast for å starte flyten på nytt.',
            recent_exports_heading: 'Nylig eksport',
            recent_exports_empty: 'Ingen eksport ennå. Klikk "Eksporter [[TOK_0]]" for å generere en.',
        },
        drift: {
            title: 'Konfigurasjonsavviksovervaking',
            drift_type: 'Avvikstype',
            severity: 'Alvorsgrad',
            detected_at: 'Oppdaga',
            resolve: 'Løys',
            all_check_types: 'Alle sjekktypar',
            all_entity_types: 'Alle einingstypar',
            event_count: 'Tal på hendingar',
            accept_risk: 'Aksepter risiko',
            acknowledge: 'Stadfest',
            assign_error: 'Kunne ikkje tildele.',
            assign_event: 'Tildel',
            assigned: 'Tildelt',
            enter_resolution_notes: 'Skriv inn løysingsnotat...',
            enter_user_id: 'Skriv inn brukar-ID...',
            entity: 'Eining',
            fetch_error: 'Kunne ikkje hente avvikshendingar.',
            no_events: 'Ingen avvikshendingar funne.',
            resolution_notes: 'Løysingsnotat',
            update_status_error: 'Kunne ikkje oppdatere status.',
        },
        scores: {
            title: 'Samsvarspoeng-kontrollpanel',
            overall: 'Samla samsvarspoeng',
            breakdown: 'Poengfordeling per modul',
            trend: 'Historisk trend',
            module: 'Modul',
            score: 'Poeng',
            grade: 'Karakter',
            calculated_at: 'Utrekna',
            generate_board_report: 'Generer styrerapport',
            lang_english: 'Engelsk',
            lang_vietnamese: 'Vietnamesisk',
            fetch_error: 'Kunne ikkje hente samsvarspoeng.',
            generate_report: 'Generer rapport',
            generating: 'Genererer...',
            recommendations: 'Tilrådingar',
            report_error: 'Kunne ikkje generere rapport.',
            factor_owner_assigned: 'Eigar tildelt',
            factor_data_categories_linked: 'Datakategoriar knytte',
            factor_purposes_linked: 'Føremål knytte',
            factor_data_flows_documented: 'Dataflytar dokumenterte',
            factor_processing_activity_linked: 'Behandlingsaktivitet knytt',
            factor_dpa_status: 'DPA-status',
            factor_retention_policy_linked: 'Oppbevaringspolicy knytt',
            factor_last_reviewed: 'Sist gjennomgått innanfor terskel',
            factor_risk_assessment_current: 'Risikovurdering oppdatert',
            factor_sub_processors_documented: 'Underdatabehandlarar dokumenterte',
            factor_cross_border_safeguards: 'Grenseoverskridande tryggingstiltak',
            factor_contact_info_complete: 'Kontaktinformasjon fullstendig',
            factor_onboarding_approved: 'Onboarding godkjend',
            factor_avg_system_score: 'Gjennomsnittleg systempoeng',
            factor_avg_vendor_score: 'Gjennomsnittleg leverandørpoeng',
            factor_processing_activity_coverage: 'Dekning av behandlingsaktivitetar',
            factor_ropa_completeness: 'RoPA-fullstende',
            factor_open_drift_events: 'Opne avvikshendingar',
        },
        playbooks: {
            title: 'Slettehandlingsplanar',
            new: 'Ny handlingsplan',
            edit: 'Rediger handlingsplan',
            steps: 'Steg',
            add_step: 'Legg til steg',
            remove_step: 'Fjern steg',
            data_categories_csv: 'Datakategoriar (kommaseparert)',
            estimated_duration: 'Estimert varigheit',
            estimated_duration_label: 'Estimert varigheit',
            evidence_description: 'Dokumentasjonsskildring',
            no_playbooks: 'Ingen handlingsplanar funne.',
            playbook_count: 'Tal på handlingsplanar',
            requires_evidence: 'Krev dokumentasjon',
            step_label: 'Stegetikett',
            target_name: 'Målnavn',
            target_type: 'Måltype',
            action_type: 'Handlingstype',
            archive_error: 'Kunne ikkje arkivere.',
            confirm_archive: 'Er du sikker på at du vil arkivere denne handlingsplanen?',
            data_categories: 'Datakategoriar',
            days: 'dagar',
            fetch_error: 'Kunne ikkje hente handlingsplanar.',
            sla_days: 'SLA (dagar)',
            target_id: 'Mål-ID',
            template_class_heading: 'Malklassifisering',
            official: 'Offisiell',
            internal: 'Intern',
            classification: 'Klassifisering',
            official_note: 'Offisielle: forskriftspålagte maler tilpasset [[TOK_1]], [[TOK_0]], eller sektorspesifikke krav.',
            internal_note: 'Internt: organisasjonsspesifikke prosedyrer som ikke er avledet fra regulatoriske maler.',
            active_executions_heading: 'Aktive køyringar',
            no_active_executions: 'Ingen aktive køyringar.',
            playbook_label: 'Playbook',
            ticket_id_label: 'Sak',
            progress_label: 'Framdrift',
            actions_label: 'Handlingar',
            view_steps_label: 'Vis steg',
            execution_detail_title: 'Detaljar for køyring',
            playbook_missing: 'Playbook ikkje funnen.',
            evidence_required_label: 'Bevis påkravd',
            upload_evidence_label: 'Last opp bevis',
            mark_complete_label: 'Marker som fullført',
            evidence_required_toast: 'Bevis må leggjast ved før steget kan fullførast.',
            evidence_blocking_message: 'Legg ved ei bevisfil for å halde fram.',
            step_completed_toast: 'Steg fullført.',
            executions_fetch_error: 'Kunne ikkje hente køyringar.',
            step_evidence_default_name: 'Bevis for køyringssteg',
            attached_evidence_label: 'Vedlagde bevis',
        },
        approvals: {
            title: 'Godkjenningsarbeidsflyt',
            new: 'Ny godkjenning',
            edit: 'Rediger godkjenning',
            request_type: 'Førespurnadstype',
            requester: 'Innsendar',
            approve: 'Godkjenn',
            reject: 'Avvis',
            justification: 'Grunngiving',
            all_action_types: 'Alle handlingstypar',
            decided_by: 'Avgjort av',
            no_approvals: 'Ingen godkjenningar funne.',
            approval_count: 'Tal på godkjenningar',
            approval_notes_optional: 'Notat (valfritt)',
            approve_error: 'Kunne ikkje godkjenne.',
            approve_request: 'Godkjenn førespurnad',
            decision: 'Avgjerd',
            entity: 'Eining',
            fetch_error: 'Kunne ikkje hente godkjenningar.',
            reject_error: 'Kunne ikkje avvise.',
            reject_request: 'Avvis førespurnad',
            rejection_notes_required: 'Avvisingsnotat påkravd',
            rejection_notes_required_msg: 'Ver venleg og oppgje ein grunn for avvisinga.',
            requested_at: 'Førespurt',
            multi_step_heading: 'Arbeidsflyt for flertrinns godkjenning',
            legal_review_note: 'Trinn 1 � Juridisk gjennomgang: Juridisk rådgiver vurderer forespørselen om overholdelse av regelverket.',
            dpo_review_note: 'Trinn 2 � [[TOK_0]] Gjennomgang: Databeskyttelsesansvarlig validerer implikasjoner for databeskyttelse.',
            management_review_note: 'Trinn 3 � Lederavmelding: Seniorledelsen gir endelig godkjenning.',
            supporting_evidence_label: 'Støttebevis (valfritt)',
            decision_evidence_name: 'Avgjerdsbevis',
        },
        evidence: {
            title: 'Styringsdokumentasjon',
            new: 'Ny dokumentasjon',
            link_to: 'Knyt til',
            entity_id_placeholder: 'Einings-ID',
            file_path_placeholder: '/sti/til/fil',
            evidence_label: 'Dokumentasjonsetikett',
            file_path: 'Filsti',
            source_mode_label: 'Beviskjelde',
            source_mode_file: 'Last opp fil',
            source_mode_url: 'Lenk ekstern URL',
            attachment_label: 'Vedlegg',
            item_count: 'Tal på element',
            link_button: 'Knyt dokumentasjon',
            confirm_delete: 'Er du sikker på at du vil slette denne dokumentasjonen?',
            enter_entity_id: 'Skriv inn einings-ID...',
            entity_id: 'Einings-ID',
            entity_type: 'Einingstype',
            expires: 'Utløper',
            expires_at: 'Utløper',
            fetch_error: 'Kunne ikkje hente dokumentasjon.',
            link_error: 'Kunne ikkje knyte dokumentasjon.',
            no_evidence: 'Ingen dokumentasjon funnen.',
            tags_csv: 'Merkelappar (kommaseparert)',
            uploaded: 'Opplasta',
            url: 'URL',
            framework_tag_heading: 'Rammemerket bevis',
            framework_tag_note: 'Hver bevispost fanger opp rammekode, skuespiller og tidsstempel. Filtrer etter rammeverk for å isolere revisjonsrelevante poster.',
            framework_code: 'Rammekode',
            filter_by_framework: 'Filtrer etter rammekode...',
            actor: 'Skuespiller',
        },
        certification: {
            not_applicable: 'Ikkje aktuelt',
            not_certified: 'Ikkje sertifisert',
            pending: 'Ventar',
            certified: 'Sertifisert',
            revoked: 'Tilbakekalla',
        },
        onboarding_pipeline: {
            title: 'Onboarding-prosess',
            new_workflow: 'Ny onboarding-arbeidsflyt',
            vendor_id: 'Leverandør-ID',
            stages: 'Fasar',
            current_stage: 'Noverande fase',
            advance: 'Framryk fase',
            advance_success: 'Fase framrykka',
            workflow_status: 'Arbeidsflytstatus',
            initiated: 'Starta',
            in_progress: 'Pågår',
            completed: 'Fullført',
            cancelled: 'Avbroten',
            no_workflows: 'Ingen onboarding-arbeidsflytar funne',
            stages_placeholder: 'Steg 1, Steg 2, Steg 3',
            assigned_to: 'Tildelt til',
            notes: 'Notat',
            pdpl_lifecycle_heading: '[[TOK_0]] Leverandørlivssyklus � Onboarding',
            due_diligence_note: 'Due diligence-stadiet er obligatorisk før innføring av en prosessor under [[TOK_0]]. Verifiser databehandlingsomfang, juridisk grunnlag og sikkerhetstiltak.',
            contract_review_note: 'Kontraktsgjennomgang må bekrefte DPA-klausuler, datalagringsgrenser og underbehandlerbegrensninger.',
            create_dpa_review_cta: 'Opprett DPA-gjennomgang',
            dpa_review_linked: 'DPA-gjennomgang lenka',
        },
        dpa_review: {
            title: 'DPA-gjennomgangar',
            new_review: 'Ny DPA-gjennomgang',
            review_type: 'Gjennomgangstype',
            findings: 'Funn',
            outcome: 'Utfall',
            complete_review: 'Fullfør gjennomgang',
            complete_success: 'Gjennomgang fullført',
            link_assessment: 'Kopla tryggingsvurdering',
            link_success: 'Vurdering kopla',
            assessment_id: 'Vurderings-ID',
            combined_title: 'Kombinert vurdering',
            no_reviews: 'Ingen DPA-gjennomgangar funne',
            telecom_disclosure_heading: 'Telecom Disclosure Governance',
            disclosure_trigger_note: 'Avsløringsutløste anmeldelser fanger opp datadelingshendelser for teleabonnenter i henhold til VN Telecom Law.',
            telecom_t2_note: 'TELECOM-T2 nivågodkjenning kreves før abonnentdata avsløres til myndighetene.',
            quarterly_log_note: 'Bruk den kvartalsvise loggen til å dokumentere alle avsløringshendelser og opprettholde et kontinuerlig revisjonsspor.',
        },
        periodic_review: {
            title: 'Periodiske gjennomgangar',
            new_review: 'Ny periodisk gjennomgang',
            review_type: 'Gjennomgangstype',
            due_date: 'Forfallsdato',
            next_review: 'Neste gjennomgangsdato',
            trigger_reassessment: 'Utløys revurdering',
            reassessment_reason: 'Grunn til revurdering',
            reassessment_success: 'Revurdering utløyst',
            complete_success: 'Gjennomgang fullført',
            scheduled: 'Planlagd',
            in_progress: 'Pågår',
            completed: 'Fullført',
            overdue: 'Forfalle',
            material_change: 'Vesentleg endring',
            no_reviews: 'Ingen periodiske gjennomgangar funne',
            mark_complete: 'Merk som fullført',
            pdpl_periodic_heading: '[[TOK_0]] Leverandørlivssyklus � Periodiske vurderinger',
            scheduled_review_note: 'Periodiske gjennomganger må planlegges minst årlig for alle aktive prosessorer. Forsinkede anmeldelser utløser overholdelsesvarsler.',
            material_change_note: 'Vesentlige endringer i databehandling krever umiddelbar revurdering uavhengig av tidsplan.',
            overdue_badge: 'Forfalt',
            overdue_aria: 'Forfall gjennomgang',
            only_overdue_filter: 'Berre forfalte',
        },
        offboarding: {
            title: 'Leverandør-avregistrering',
            initiate: 'Start avregistrering',
            initiate_success: 'Avregistrering starta',
            reason: 'Grunn til avregistrering',
            data_return_required: 'Datareturnering påkravd',
            verify_data: 'Stadfest datareturnering',
            verify_success: 'Datareturnering stadfesta',
            sign_off: 'Godkjenn',
            sign_off_success: 'Avregistrering godkjend',
            status_initiated: 'Starta',
            status_data_pending: 'Ventar på datareturnering',
            status_data_verified: 'Datareturnering stadfesta',
            status_completed: 'Fullført',
            status_cancelled: 'Avbroten',
            task_id: 'Oppgåve-ID',
            no_tasks: 'Ingen avregistreringsoppgåver funne',
            evidence_id: 'Dokumentasjons-ID',
            pdpl_offboarding_heading: '[[TOK_0]] Leverandørlivssyklus � avstigning og sletting',
            deletion_capture_note: 'Offboarding må fange opp bekreftelse på sletting av data fra leverandøren. Bekreft dataretur før avlogging.',
            evidence_attachment_note: 'Legg ved slettebevis (sertifikater, skjermbilder, leverandørbekreftelser) for å fullføre offboarding-posten.',
            verify_mode_label: 'Verifiseringsmetode',
            verify_mode_upload: 'Last opp ny fil',
            verify_mode_link: 'Lenk eksisterande bevis',
            verify_mode_none: 'Ingen data å returnere',
            upload_data_return_evidence: 'Last opp databevis for retur',
            no_data_justification_label: 'Grunngjeving',
            no_data_justification_placeholder: 'Forklar kvifor ingen data skal returnerast',
            no_data_justification_hint: 'Minst 20 teikn',
            upload_required_toast: 'Legg ved ei fil for å halde fram',
            evidence_link_required_toast: 'Vel eit bevis for å halde fram',
            no_data_justification_required_toast: 'Gi ei grunngjeving på minst 20 teikn',
            data_return_evidence_name: 'Databevis for retur',
        },
        dpa_review_types: {
            initial: 'Innleiande',
            annual: '�&rleg',
            renewal: 'Fornying',
            incident_triggered: 'Hendingsutløyst',
        },
        periodic_review_types: {
            initial: 'Innleiande',
            annual: '�&rleg',
            renewal: 'Fornying',
            incident_triggered: 'Hendingsutløyst',
            material_change: 'Vesentleg endring',
            disclosure_triggered: 'Opplysningsutløyst',
            quarterly_log: 'Kvartalslogg',
        },
        dpa_review_statuses: {
            pending: 'Ventar',
            in_progress: 'Pågår',
            completed: 'Fullført',
            cancelled: 'Avbrote',
        },
        onboarding_stage_names: {
            due_diligence: 'Due diligence',
            contract_review: 'Kontraktsgjennomgang',
            security_assessment: 'Tryggleiksvurdering',
            data_mapping: 'Datakartlegging',
            approval: 'Godkjenning',
            integration: 'Integrasjon',
        },
        access_denied_title: 'Tilgang nekta',
        access_denied: 'Du har ikkje løyve til å sjå denne sida. Kontakt administratoren din.',
    },
    consent: {
        nav: {
            policies: 'Retningslinjer',
            purposes: 'Føremålskatalog',
            workflows: 'Arbeidsflyt',
            snapshots: 'CMP-augneblinksbilete',
            change_awareness: 'Endringsvarsling',
            audit: 'Samtykkerevisjon',
        },
        gap_analysis: {
            nav_label: 'Gap analyse',
            page_title: 'Analyse av samtykkegap',
            page_subtitle: 'Forseti sjekker ditt aktive samtykke mot krav til installert rammeverk ([[TOK_0]] Art.7 + Art.6 + Art.9, [[TOK_1]] Art.13 + Art.20, PIPL Art.13 + Art.29) og overflater hull med henvisning + foreslått utbedring.',
            framework_picker_label: 'Rammer',
            org_flags_label: 'Organisasjonskontekst',
            flag_withdrawal: 'Har dokumentert global uttaksmekanisme',
            flag_parental: 'Har foreldresamtykke for personer under 16 år',
            flag_cross_border: 'Har grenseoverskridende arkivering registrert',
            run_label: 'Kjør gapanalyse',
            running_label: 'Kjører ⬦',
            requires_advisor_label: 'Krever ai_advisor:chattetillatelse.',
            results_heading: 'Det dukket opp hull ([[TOK_1]])',
            tokens_label: '�0� [[TOK_1]] tokens',
            empty_label: 'Ingen hull oppdaget for de valgte rammene.',
            remediation_label: 'Foreslått utbedring:',
            dismiss_label: 'Avvis som ikke aktuelt',
            resolve_label: 'Løs',
            dismissed_label: 'Avvist som ikke aktuelt',
            resolved_label: 'Løst',
        },
        import: {
            title: 'Importer samtykkearbeidsflyter',
            nav_title: 'Masseimport',
            description: 'Last opp ei CSV-fil for å masseimportere samtykkearbeidsflyter.',
            select_file: 'Vel CSV-fil',
            file_help: 'CSV med overskrifter som samsvarar med arbeidsflytfelt.',
            required_columns_help: 'Obligatoriske kolonnar: Arbeidsflyttype, Registrerte, Kanal.',
            file_too_large: 'Fila er for stor. Maksimal storleik er 2MB.',
            preview: 'Førehandsvising',
            columns_detected: 'Kolonnar oppdaga: {count}',
            column_mapping: 'Kolonnetilordning',
            import_button: 'Importer',
            import_complete: 'Import fullført',
            import_error: 'Import mislukkast',
            result: 'Importresultat',
            total: 'Totalt',
            imported: 'Importert',
            skipped: 'Hoppa over',
            failed: 'Feila',
            errors: 'Feil',
            error_row: 'Rad',
            error_field: 'Felt',
            error_message: 'Melding',
            history: 'Importhistorikk',
            no_history: 'Ingen importhistorikk.',
            history_file: 'Filnamn',
            history_date: 'Dato',
            create_profiles_label: 'Opprett Registrerte-profilar for nye subjekt',
            create_profiles_help: 'Import utan ein tilhøyrande profil opprettar ein automatisk. Fjern merket for berre å importere arbeidsflyter.',
            profiles_created: 'Profilar oppretta',
            profiles_matched: 'Profilar matcha',
            subject_kind_help: 'Valfrie kolonnar: subject_kind, subject_email, subject_display_name, subject_phone, external_ref_key.',
            error_subject_invalid_email: 'Ugyldig e-post i subject_email-kolonnen.',
            error_subject_unknown_kind: 'Ukjend subject_kind-verdi. Venta: email, visitor_uuid, employee_id, student_id, external_ref.',
            error_missing_external_ref_key: 'external_ref_key er påkravd når subject_kind=external_ref',
        },
        policies: {
            title: 'Samtykkeretningslinjer',
            new: 'Ny retningslinje',
            edit: 'Rediger retningslinje',
            name: 'Namn',
            version: 'Versjon',
            policy_text: 'Retningslinjetekst',
            publish: 'Publiser',
            versions: 'Versjonar',
            hide_versions: 'Gøym versjonar',
            submit_for_review: 'Send inn for Gennemgang',
            suspend: 'Suspender',
            retire: 'Avvikle',
            jurisdictions: 'Jurisdiksjonar',
            jurisdictions_csv: 'Jurisdiksjonar (kommaseparert)',
            approval_mode: 'Godkjenning Modus',
            reviewer_ids: 'Gennemgåer-ID-er (kommaseparert)',
            tags_csv: 'Emneord (kommaseparert)',
            effective_date: 'Gjeldande Dato',
            review_date: 'Gjennomgang Dato',
            consent_model_statement: 'Samtykkemodell-erklæring',
            consent_model_placeholder: 'Valfri samtykkemodell-erklæring...',
            default_settings: 'Standard Innstillingar (JSON)',
            changes: 'Endringar',
            fetch_error: 'Kunne ikkje hente consent policies. Ver venleg og prøv igjen.',
            save_error: 'Kunne ikkje lagre consent policy. Ver venleg og prøv igjen.',
            submit_review_error: 'Kunne ikkje sende inn policy for review. Ver venleg og prøv igjen.',
            activate_error: 'Kunne ikkje aktivere policy. Ver venleg og prøv igjen.',
            suspend_error: 'Klarte ikkje å suspendere retningslinje. Prøv igjen.',
            retire_error: 'Klarte ikkje å avvikle retningslinje. Prøv igjen.',
            submit_review_success: 'Retningslinjer sendt inn for vurdering.',
            activate_success: 'Policy aktivert.',
            suspend_success: 'Politikken er suspendert.',
            retire_success: 'Politikken pensjonert.',
            versions_error: 'Kunne ikkje hente policy versions. Ver venleg og prøv igjen.',
            invalid_json: 'Ugyldig JSON i standardinnstillingar. Prøv igjen.',
            page_title: 'Retningslinjer for samtykke',
            version_updated: 'Oppdatert',
            version_initial: 'Opprinnelig versjon',
            json_format: '[[TOK_0]] format',
            sensitive: 'Sensitive',
            flag_sensitive: 'Flagsensitiv',
            flag_sensitive_title: 'Flagg politikk som sensitiv',
            require_enhanced_review: 'Krev forbedret gjennomgang',
            enhanced_review_success: 'Krav til forbedret gjennomgang er aktivert.',
            select_categories: 'Velg gjeldende [[TOK_0]] sensitive datakategorier i artikkel 2:',
            no_policies: 'Ingen samtykkepolitikkar funne. Opprett din første politikk for å kome i gang.',
            approval_success: 'Politikk godkjend.',
            reviewers_label: 'Granskarar',
            enhanced_review_title: 'Utvida gjennomgang påkravd',
            enhanced_review_badge: 'Utvida gjennomgang påkravd',
            enhanced_review_status_pending: 'Gjennomgang ventar',
            enhanced_review_status_approved: 'Gjennomgang godkjend',
            enhanced_review_status_rejected: 'Gjennomgang avvist',
            enhanced_review_reviewed_by: 'Gjennomgått av',
            enhanced_review_notes: 'Gjennomgangsnotat',
            enhanced_review_approve: 'Godkjenn gjennomgang',
            enhanced_review_reject: 'Avvis gjennomgang',
            enhanced_review_notes_required: 'Gjennomgangsnotat er påkravd',
            enhanced_review_approved: 'Utvida gjennomgang godkjend',
            enhanced_review_rejected: 'Utvida gjennomgang avvist � politikk tilbakestilt til utkast',
            enhanced_review_reset_to_draft: 'Utvida gjennomgang avvist � politikk tilbakestilt til utkast',
            enhanced_review_reject_warning: 'Avvising vil tilbakestille denne politikken til Utkast-status. DPO må sende inn på nytt for gjennomgang etter å ha løyst problema.',
            submitted_modal_title: 'Sendt inn for utvida gjennomgang',
            submitted_modal_body: 'Denne politikken er sendt inn. Ein Juridisk/Personvernrevisor må godkjenne han før han kan aktiverast.',
        },
        sensitive_categories: {
            health: 'Helsedata',
            biometric: 'Biometriske data',
            political: 'Politiske meiningar',
            ethnic: 'Etnisk opphav',
            genetic: 'Genetiske data',
            criminal: 'Strafferegister',
        },
        purposes: {
            title: 'Føremålskatalog',
            new: 'Nytt føremål',
            edit: 'Rediger føremål',
            name: 'Namn',
            legal_basis: 'Rettsleg grunnlag',
            retention_days: 'Lagringsperiode (dagar)',
            is_active: 'Aktiv',
            filter_by_category: 'Filter etter kategori',
            policy_ids: 'Retningslinje-IDar (kommaseparert)',
            ropa_activity_ids: 'ROPA-aktivitets-IDar (kommaseparert)',
            policies: 'Retningslinjer',
            deprecate: 'Utfas',
            fetch_error: 'Kunne ikkje hente consent purposes. Ver venleg og prøv igjen.',
            save_error: 'Kunne ikkje lagre consent purpose. Ver venleg og prøv igjen.',
            deprecate_error: 'Kunne ikkje utfase consent purpose. Ver venleg og prøv igjen.',
            page_title: 'Formålskatalog',
            no_purposes: 'Ingen samtykkeformål funne. Opprett ditt første formål for å kome i gang.',
            category_personal_data: 'Personopplysninger',
            category_sensitive_data: 'Sensitive data',
            category_health_data: 'Helsedata',
            category_financial_data: 'Finansielle data',
            category_biometric_data: 'Biometriske data',
            category_children_data: 'Barnas data',
            category_location_data: 'Stedsdata',
            category_communications_data: 'Kommunikasjonsdata',
            category_other: 'Annet',
        },
        workflows: {
            title: 'Samtykkearbeidsflyt',
            new: 'Ny arbeidsflyt',
            edit: 'Rediger arbeidsflyt',
            workflow_type: 'Arbeidsflyttype',
            user_id: 'Brukar-ID',
            purpose_id: 'Føremåls-ID',
            purpose_ids_csv: 'Formåls-ID (kommaseparert)',
            reason: 'Grunn',
            process: 'Behandle',
            data_subject_ref: 'Data Emne Referanse',
            data_subject: 'Data Emne',
            channel: 'Kanal',
            policy_id: 'Retningslinje ID',
            scope: 'Omfang',
            legal_grounds: 'Rettsleg heimel',
            assessment: 'Vurdering',
            select_outcome: 'Vel utfall',
            partially_approved: 'Delvis godkjent',
            denied: 'Avvist',
            outcome_upheld: 'Oppretthalde',
            outcome_pending: 'Ventar',
            outcome_denied: 'Avvist',
            status_count: 'Statustal',
            channel_filter: 'Filtrer etter kanal',
            add_action: '+ Handling',
            by_type: 'Etter Type',
            by_status: 'Etter Status',
            downstream_actions: 'Nedstraumshandlingar',
            downstream_actions_for: 'Nedstraumshandlingar for {subject} ({type})',
            add_downstream_action: 'Legg til nedstrømshandling',
            assigned_to: 'Tildelt Til',
            fetch_error: 'Kunne ikkje hente consent workflows. Ver venleg og prøv igjen.',
            dashboard_error: 'Kunne ikkje hente workflow dashboard. Ver venleg og prøv igjen.',
            save_error: 'Kunne ikkje lagre consent workflow. Ver venleg og prøv igjen.',
            status_update_error: 'Kunne ikkje oppdatere workflow status. Ver venleg og prøv igjen.',
            assessment_error: 'Kunne ikkje oppdatere workflow assessment. Ver venleg og prøv igjen.',
            add_action_error: 'Kunne ikkje leggje til workflow action. Ver venleg og prøv igjen.',
            update_action_error: 'Kunne ikkje oppdatere workflow action. Ver venleg og prøv igjen.',
            type_refusal: 'Avvising',
            type_withdrawal: 'Tilbaketrekking',
            type_restriction: 'Avgrensing',
            type_objection: 'Innvending',
            status_received: 'Motteke',
            status_processing: 'Behandlar',
            status_under_assessment: 'Under vurdering',
            status_implemented: 'Implementert',
            evidence_button: 'Bevis',
            evidence_modal_title: 'Arbeidsflytbevis',
            no_evidence: 'Ingen bevis knyttet til denne arbeidsflyten.',
            upload_evidence_label: 'Last opp arbeidsflytbevis',
            completed_at: 'Fullført kl',
            effective_date: 'Ikrafttredelsesdato',
            page_title: 'Samtykke arbeidsflyter',
            no_workflows: 'Ingen samtykkearbeidsflytar funne. Arbeidsflytar vert oppretta når registrerte utøver rettane sine.',
            type_grant: 'Tildeling',
            propagation_none: 'Ingen',
            propagation_pending: 'Ventar',
            propagation_pending_warning: 'Kan ikkje fullføre � tilbaketrekkingspropagering er framleis ventande',
            propagation_completed: 'Fullført',
            propagation_partial: 'Delvis',
            propagation_incomplete_error: 'Kan ikkje fullføre arbeidsflyt medan tilbaketrekkingspropagering framleis ventar',
            propagation_status: 'Propageringsstatus',
        },
        snapshots: {
            title: 'CMP-augneblinksbilete',
            new: 'Nytt augneblinksbilete',
            label: 'Etikett',
            snapshot_date: 'Dato for augneblinksbilete',
            purposes_count: 'Antal føremål',
            compare: 'Samanlikna',
            snapshot_data: 'Augneblinksdata (JSON)',
            select_left: 'Vel venstre snapshot',
            select_right: 'Vel høgre snapshot',
            comparison_results: 'Samanlikning Resultat',
            field: 'Felt',
            left: 'Venstre',
            right: 'Høgre',
            close_comparison: 'Lukk sammenligning',
            trigger: 'Utløysar',
            trigger_manual: 'Manuell',
            trigger_policy_approval: 'Retningslinje Godkjenning',
            cmp_version: 'CMP Versjon',
            policy_version_id: 'Retningslinje Versjon ID',
            banner_config: 'Banner Konfiguration (JSON)',
            active_purposes: 'Aktive formål (JSON)',
            active_legal_bases: 'Aktive retsgrundlag (JSON)',
            domain_scope: 'Domeneomfang',
            domain_scope_csv: 'Domeneomfang (kommaseparert)',
            raw_config: 'Raw Konfigurasjon (JSON)',
            checksum: 'Sjekksum',
            created: 'Oppretta',
            fetch_error: 'Kunne ikkje hente CMP snapshots. Ver venleg og prøv igjen.',
            save_error: 'Kunne ikkje lagre CMP snapshot. Ver venleg og prøv igjen.',
            compare_error: 'Klarte ikkje å samanlikne snapshots. Prøv igjen.',
            page_title: '��yeblikksbilder av samtykke',
            json_format: '[[TOK_0]] format',
            json_array_format: '[[TOK_0]] matriseformat',
            manual_snapshot_note: 'Berre for administratorar/utviklarar. I normal drift vert augneblinksbilete oppretta automatisk via CMP-webhook eller ved policygodkjenning. Lim inn JSON eksportert frå din CMP-leverandør (t.d. OneTrust, Cookiebot).',
            banner_config_hint: 'Lim inn bannerkonfigurasjonsobjektet frå din CMP-eksport.',
            active_purposes_hint: 'JSON-array av aktive formålsobjekt kopiert frå din CMP-eksport.',
            active_legal_bases_hint: 'JSON-array av aktive rettsgrunnlag-objekt kopiert frå din CMP-eksport.',
            raw_config_hint: 'Fullstendig rå konfigurasjon-JSON frå din CMP. Andre JSON-felt vert henta herfrå. Ein SHA-256-kontrollsum vert rekna ut automatisk.',
            changed_field: 'Endret felt:',
            no_snapshots: 'Ingen CMP-augeblinksbilete funne. Augeblinksbilete vert oppretta når politikkar vert godkjende eller utløyste manuelt.',
            detail_title: 'Augeblinksbilete-detalj',
            view_snapshot_detail: 'Vis augenblinksbilete-detalj',
            policy_version: 'Politikkversjon',
            removed: 'Før',
            added: 'Etter',
        },
        change_awareness: {
            title: 'Samtykkeendringsvarsling',
            change_type: 'Endringstype',
            entity_type: 'Einingstype',
            entity_id: 'Einings-ID',
            detected_at: 'Oppdaga',
            acknowledge: 'Stadfest',
            new_alert: 'Ny Varsel',
            new_alert_form: 'Nytt endringsvarsel',
            total_open: 'Totalt Opne',
            by_severity: 'Etter Alvorlegheit',
            snapshot_id: 'Augeblikksbilete ID',
            update_status: 'Oppdatering Status',
            resolution_notes: 'Løysing Notat',
            resolution_required: 'Løysingsnotat (påkravd)',
            resolution_required_msg: 'Løysingsnotat er påkravd ved løysing av eit element.',
            status_open: 'Opne',
            status_under_review: 'Under Gennemgang',
            status_resolved: 'Løyst',
            status_accepted: 'Godtatt',
            severity_informational: 'Informativ',
            severity_requires_review: 'Krev gjennomgang',
            severity_policy_violation: 'Retningslinebrot',
            create_reconciliation: 'Opprett avstemmingsoppgave',
            reconciliation_created: 'Avstemmingsoppgave opprettet.',
            reconciliation_error: 'Kunne ikke opprette avstemmingsoppgave. Vennligst prøv igjen.',
            fetch_error: 'Kunne ikkje hente change awareness items. Ver venleg og prøv igjen.',
            dashboard_error: 'Kunne ikkje hente change awareness dashboard. Ver venleg og prøv igjen.',
            create_error: 'Kunne ikkje opprette change awareness item. Ver venleg og prøv igjen.',
            status_update_error: 'Kunne ikkje oppdatere change awareness status. Ver venleg og prøv igjen.',
            page_title: 'Endre bevissthet',
            no_items: 'Ingen endringsmedvitsemne funne. Emne vert oppretta når endringar i samtykkekonfigurasjonen vert oppdaga.',
        },
        audit: {
            title: 'Samtykkerevisjonsspor',
            event_type: 'Hendingstype',
            user_id: 'Brukar-ID',
            timestamp: 'Tidsstempel',
            details: 'Detaljar',
            actor: 'Aktør',
            filter_by_entity_type: 'Filter etter eining type',
            filter_by_action: 'Filter etter handling',
            fetch_error: 'Kunne ikkje hente consent audit trail. Ver venleg og prøv igjen.',
            page_title: 'Samtykke revisjon',
            export_csv: 'Eksporter [[TOK_0]]',
            exporting: 'Eksporterer ⬦',
            export_success: 'Revisjonssporet ble eksportert.',
            export_error: 'Kunne ikke eksportere revisjonssporet for samtykke. Vennligst prøv igjen.',
            no_entries: 'Ingen revisjonsoppføringar funne. Revisjonshendingar vert registrerte automatisk når samtykkedata vert endra.',
            entity_policy: 'Politikk',
            entity_purpose: 'Formål',
            entity_workflow: 'Arbeidsflyt',
            entity_consent_record: 'Samtykkeoppføring',
            entity_change_awareness: 'Endringskunnskap',
            entity_cmp_snapshot: 'CMP-augeblinksbilete',
            action_created: 'Oppretta',
            action_updated: 'Oppdatert',
            action_status_changed: 'Status endra',
            action_drift_detected: 'Avvik oppdaga',
            action_snapshot_created: 'Augeblinksbilete oppretta',
            action_approval_submitted: 'Godkjenning sendt inn',
            action_archived: 'Arkivert',
            action_purpose_auto_mapped: 'Føremål automatisk tilknytt',
            action_purpose_mapping_updated: 'Føremålstilknyting oppdatert',
            action_webhook_configured: 'Webhook konfigurert',
            entity_propagation: 'Formering',
            entity_reconciliation: 'Forsoning',
            action_propagation_confirmed: 'Formering bekreftet',
            action_propagation_failed: 'Forplantning mislyktes',
            action_consent_captured: 'Samtykke fanget',
            action_reconciliation_created: 'Avstemming opprettet',
            action_reconciliation_resolved: 'Avstemming løst',
            action_submitted_for_review: 'Send til gjennomgang',
            action_activated: 'Aktivert',
            action_suspended: 'Suspendert',
            action_retired: 'Avvikla',
            action_enhanced_review_required: 'Forbetra gjennomgang påkravd',
            action_enhanced_review_approved: 'Utvida gjennomgang godkjend',
            action_enhanced_review_rejected: 'Utvida gjennomgang avvist � politikk tilbakestilt til utkast',
            action_consented: 'Samtykke',
            action_consented_customize: 'Samtykke tilpasset',
            action_revoked: 'Opphevet',
            action_rejected: 'Avvist',
        },
        web_records: {
            title: 'Nettsamtykkeposter',
            page_title: 'Nettsamtykkeposter',
            domain: 'Domene',
            visitor_id: 'Besøks-ID',
            consent_action: 'Samtykkehandling',
            received_at: 'Mottatt kl',
            admin_status: 'Admin status',
            revoke: 'Oppheve',
            reject: 'Avvis',
            reason: 'Grunn',
            reason_placeholder: '�&rsak til denne handlingen (valgfritt)',
            revoke_confirm: 'Vil du trekke tilbake denne samtykkeposten?',
            reject_confirm: 'Vil du avvise denne samtykkeposten?',
            override_success: 'Poststatus ble oppdatert.',
            override_error: 'Kunne ikke oppdatere poststatus.',
            no_records: 'Ingen nettsamtykkeposter funnet.',
            fetch_error: 'Kunne ikke laste inn nettsamtykkeposter.',
            filter_by_domain: 'Filtrer etter domene',
            filter_by_action: 'Filtrer etter handling',
            active: 'Aktiv',
        },
        legal_bases: {
            all: 'Alle retsgrundlag',
            consent: 'Samtykke',
            legitimate_interest: 'Berettiga interesse',
            contract: 'Kontrakt',
            legal_obligation: 'Rettsleg plikt',
            vital_interest: 'Livsviktig Interesse',
            public_interest: 'Offentleg Interesse',
        },
        common_statuses: {
            suspended: 'Suspendert',
            retired: 'Utfasa',
            deprecated: 'Utfasa',
        },
        approval_modes: {
            all: 'Alle',
            any: 'Kva som helst',
        },
        cmp_integration: {
            title: 'AesirX CMP Integrasjon',
            back_to_consent: 'Tilbake to Samtykke',
            back_to_integration: 'Tilbage til integration',
            webhook_status: 'Webhook-status',
            events_received: 'Hendingar mottekne',
            web_consent_records: 'Websamtykkepostar',
            unmapped_purposes: 'Ikkje-kartlagde formål',
            integration_management: 'Integrasjonsstyring',
            webhook_configuration: 'Webhook Konfigurasjon',
            webhook_config_desc: 'Konfigurer CMP webhook-endepunktet og administrer HMAC-hemmeligheten.',
            purpose_mapping: 'Føremål Kartlegging',
            purpose_mapping_desc: 'Kartlegg CMP-føremålsidentifikatorar til GRC-samtykkekatalogens føremål.',
            bulk_sync: 'Masse Synkroniser',
            bulk_sync_desc: 'Anvend føremålstilknytingar på nytt på alle ikkje-tilknytte samtykkeopppføringar.',
            consent_analytics: 'Websamtykkeanalyse (siste 30 dagar)',
            consent_grant_rate: 'Samtykkegodkjenningsrate',
            top_domain: 'Top Domene',
            records: 'postar',
            banner_interactions: 'Bannerinteraktioner',
            consent_actions: 'Samtykkjehandlingar',
            opt_in_trend: 'Samtykke/avmelding-trend',
            records_by_domain: 'Oppføringer etter domene',
            date: 'Dato',
            grants: 'Innvilgingar',
            denials: 'Avslag',
            not_configured: 'Ikkje konfigurert',
            load_error: 'Kunne ikkje laste integration data',
            webhook_not_configured: 'Webhook ikkje konfigurert.',
            webhook_not_configured_msg: 'Ver venleg og {link} først.',
            configure_webhook_link: 'konfigurer webhooken',
            setup_wizard: 'Oppsettsrettleiar',
            step_configure_webhook: 'Konfigurer webhook',
            step_map_purposes: 'Map Føremål',
            step_run_sync: 'Køyring Innledende Masse Synkroniser',
            step_verify_data: 'Verifiser data i dashbord',
            configure: 'Konfigurer',
            view_dashboard: 'Vis Dashbord',
            syncing: 'Synkroniserer...',
            sync_now: 'Synkronisering Now',
            sync_completed: 'Synkronisering fullført: {imported} importert, {skipped} hoppa over, {failed} mislukkast.',
            sync_failed: 'Synkronisering mislukkast',
            last_sync_result: 'Siste synkroniseringsresultat',
            imported: 'Importert',
            skipped: 'Hoppa over',
            errors: 'Feil',
            index: 'Indeks',
            error: 'Feil',
            sync_history: 'Synkronisering Historikk',
            no_sync_jobs: 'Ingen sync jobs recorded enno.',
            load_sync_error: 'Kunne ikkje laste sync data',
            purpose_mapping_title: 'CMP Føremål Kartlegging',
            auto_mapping: 'Automatisk kartlegging...',
            auto_map_purposes: 'Automatisk formålskortlægning',
            unmapped_warning: '[[TOK_1]] ikke-tilordnede formål -- disse [[TOK_2]] formålene må tilordnes til GRC-formål.',
            mapping_saved: 'Kartlegging lagra.',
            mapping_deleted: 'Kartlegging sletta.',
            auto_map_complete: 'Automatisk kartlegging fullført: {mapped} kartlagt, {unmatched} ikkje matcha.',
            auto_map_failed: 'Automatisk kortlægning mislykkedes',
            save_mapping_error: 'Kunne ikkje lagre mapping',
            delete_mapping_error: 'Kunne ikkje slette mapping',
            load_data_error: 'Kunne ikkje laste data',
            cmp_purpose: 'CMP Føremål',
            grc_purpose: 'GRC Føremål',
            select_grc_purpose: '-- Vel GRC Føremål --',
            auto_mapped: 'Automatisk kartlagt',
            mapped: 'Kartlagt',
            unmapped: 'Ikkje kartlagt',
            no_mappings: 'Ingen føremålstilknytingar funne. Tilknytingar vert oppretta automatisk når samtykkehendingar vert mottekne.',
            total_mappings: 'Totalt: {count} kartlegging(ar)',
            webhook_config_title: 'Webhook Konfigurasjon',
            current_configuration: 'Noverande Konfigurasjon',
            setup_webhook: 'Sett opp webhook',
            setup_webhook_desc: 'Konfigurer AesirX CMP-webhook for å motta samtykkehendingar.',
            allowed_domains: 'Tilladte domæner (ét per linje)',
            webhook_secret_warning: 'Webhook-hemmelighet (lagre dette no -- det vert ikkje vist igjen):',
            last_event: 'Siste Hending',
            none_received: 'Ingen',
            update_domains: 'Oppdatering Domene',
            pause_webhook: 'Sett på pause Webhook',
            resume_webhook: 'Gjenoppta webhook',
            regenerate_secret: 'Regenerer hemmelighet',
            configuring: 'Konfigurerer...',
            create_webhook_config: 'Opprett webhook-konfigurasjon',
            webhook_endpoint: 'Webhook-endepunkt',
            webhook_endpoint_desc: 'Konfigurer din AesirX CMP til å sende samtykkehendingar til:',
            webhook_signature_note: 'Inkluder HMAC-SHA256-signaturen i {header}-headeren.',
            configured_success: 'Webhook konfigurert.',
            config_updated: 'Konfigurasjon oppdatert.',
            config_error: 'Klarte ikkje å konfigurere webhook',
            update_error: 'Kunne ikkje oppdatere konfigurasjon',
            toggle_error: 'Kunne ikkje veksle webhook',
            deactivated: 'Webhook deaktivert.',
            deactivate_error: 'Kunne ikkje deaktivere webhook',
            page_title: '[[TOK_0]] Integrasjon',
            webhook_config_page_title: '[[TOK_0]] Webhook-konfigurasjon',
            bulk_sync_page_title: 'Kartlegg poster på nytt',
            purpose_mapping_page_title: 'Formålskartlegging',
            data_loaded: '[[TOK_0]] integrasjonsdata er lastet inn',
            sync_all: 'Synkroniser alle',
            sync_selected: 'Synkroniser valde',
            sync_status: 'Synkroniseringsstatus',
            last_sync: 'Siste synkronisering',
            no_records: 'Ingen oppføringar funne.',
            sync_in_progress: 'Synkronisering pågår...',
            sync_complete: 'Synkronisering fullført.',
            sync_error: 'Synkronisering mislukkast. Ver venleg og prøv på nytt.',
            map_purpose: 'Tilknytt formål',
            unmap: 'Fjern tilknyting',
            mapping_status: 'Tilknytingsstatus',
            save_mapping: 'Lagre tilknyting',
            remap_unmapped_records: 'Kartlegg ikke kartlagte poster på nytt',
            remap_records: 'Kartlegg poster på nytt',
            add_mappings_first: 'Legg til formålskartlegginger først (trinn 2)',
            remap_result: 'Omkartleggingsresultat',
            remap_result_desc: 'Behandlet alle samtykkeposter med ikke-kartlagte eller delvis kartlagte formål.',
            total_processed: 'Totalt behandlet',
            newly_mapped: 'Nylig kartlagt',
            still_unmapped_label: 'Fremdeles ikke kartlagt',
            still_unmapped_msg: '[[TOK_2]] post(er) har fortsatt ikke-kartlagte formål. [[TOK_3]] og klikk deretter på Re-map igjen.',
            add_more_mappings: 'Legg til flere kartlegginger',
            remap_complete: 'Ny kartlegging fullført: [[TOK_2]] nylig kartlagt, [[TOK_3]] fortsatt ikke kartlagt.',
            add_mapping: 'Legg til kartlegging',
            cmp_purpose_id_label: '[[TOK_0]] Formåls-ID *',
            cmp_purpose_id_required: '[[TOK_0]] Formåls-ID kreves',
            cmp_purpose_name_label: '[[TOK_0]] Formålsnavn',
            grc_purpose_label: 'GRC Formål',
        },
        propagation: {
            title: 'Tilbaketrekkingsspreiing',
            systems: 'Tilknytte system',
            status: 'Status',
            confirmed: 'Stadfesta',
            pending: 'Ventar',
            failed: 'Mislukkast',
            confirm: 'Stadfest tilbaketrekking',
            fail: 'Merk som mislukkast',
            failure_reason: 'Feilårsak',
            can_close: 'Alle system stadfesta � arbeidsflyten kan lukkast',
            cannot_close: 'Ventar på systemstadfestingar',
            no_tasks: 'Ingen spreiingsoppgåver.',
            confirm_success: 'Systemtilbaketrekking stadfesta.',
            fail_success: 'System merkt som mislukkast.',
            propagate_success: 'Tilbaketrekking spreidd til tilknytte system.',
            propagate: 'Forplante seg til systemer',
            add_system: 'Legg til system',
            remove_system: 'Fjern',
            system_id: 'System-ID',
            system_name: 'Systemnavn',
            owner_id: 'Eier-ID',
            propagate_error: 'Kunne ikke spre tilbaketrekning. Vennligst prøv igjen.',
            no_systems: 'Legg til minst ett system.',
            page_title: 'Uttaksforplantning',
            workflow_id: 'Velg Arbeidsflyt for uttak',
            system_id_hint: 't.d. crm-001, erp-prod',
            owner_id_hint: 'Systemeigar',
            elapsed: 'Forløpt',
        },
        sensitive: {
            title: 'Sensitive datapolicyer',
            flag: 'Merk som sensitiv',
            categories: 'Sensitive kategoriar',
            enhanced_review: 'Krev utvida gjennomgang',
            enhanced_review_success: 'Utvida gjennomgang påkravd.',
            flag_success: 'Policy merkt som sensitiv.',
            no_sensitive: 'Ingen sensitive datapolicyer.',
        },
        reconciliation: {
            title: 'Avviksavstemming',
            create: 'Ny avstemmingsoppgåve',
            system: 'System',
            owner: 'Eigar',
            description: 'Skildring',
            resolution: 'Løysing',
            resolve: 'Løys',
            update_grc: 'Oppdater GRC',
            update_cmp: 'Oppdater CMP',
            accept_difference: 'Godta skilnad',
            escalate: 'Eskaler',
            resolution_notes: 'Løysingsnotat',
            no_tasks: 'Ingen avstemmingsoppgåver.',
            resolve_success: 'Avstemmingsoppgåve løyst.',
            create_success: 'Avstemmingsoppgåve oppretta.',
            open: '�&pne',
            resolved: 'Løyst',
            escalated: 'Eskalert',
            dashboard_open: 'Opne oppgåver',
            dashboard_resolved: 'Løyste oppgåver',
            dashboard_escalated: 'Eskalerte oppgåver',
            page_title: 'Mismatch avstemming',
            my_tasks: 'Mine oppgaver',
            all_tasks: 'Alle oppgaver',
            severity: 'Alvorlighetsgrad',
        },
        sync: {
            title: 'CMP-synkronisering',
            direction: 'Retning',
            cmp_to_grc: '[[TOK_0]] �  GRC',
            grc_to_cmp: 'GRC �  [[TOK_0]]',
            conflict: 'Konflikt',
            resolve_conflict: 'Løys konflikt',
            no_events: 'Ingen synkroniseringshendingar.',
            resolve_success: 'Synkroniseringskonflikt løyst.',
            create_success: 'Synkroniseringshending registrert.',
            page_title: '[[TOK_0]] Synkroniser',
            detect_drift: 'Oppdag konflikter',
            detecting: 'Oppdager...',
            drift_result: '[[TOK_2]] konflikt(er) oppdaget av [[TOK_3]] formål(er) sammenlignet.',
            no_drift: 'Ingen nye konflikter oppdaget.',
            drift_error: 'Kunne ikke kjøre konfliktdeteksjon.',
            resolve_modal_title: 'Løs konflikt',
            resolve_field: 'Felt',
            resolve_grc_value: 'GRC-verdi',
            resolve_cmp_value: '[[TOK_0]] Verdi',
            accept_cmp: 'Godta [[TOK_0]] verdi',
            accept_cmp_desc: 'Oppdater GRC slik at den samsvarer med [[TOK_0]] - verdien [[TOK_1]] blir den nye GRC-verdien.',
            keep_grc: 'Behold GRC-verdien',
            keep_grc_desc: 'Lukk denne konflikten uten å endre GRC � gi eieren [[TOK_0]] beskjed om å justere.',
            resolve_applied: 'Konflikt løst. GRC-formålet er oppdatert for å samsvare med [[TOK_0]].',
        },
    },
    assessments: {
        dossier_preflight: {
            advisory_notice: 'Denne klarskapsrapporten er rådgjevande. Han godkjenner, set saman, materialiserer, leverer eller sender ikkje dokumentpakken.',
            run_label: 'Kjør pre-flight',
            running: 'Kjører pre-flight ⬦',
            assemble_label: 'Automonter pakke',
            assembling: 'Montering ⬦',
            verdict_label: 'Dommen før flyreisen',
            tokens_label: '�0� [[TOK_1]] tokens',
            remediation_label: 'Utbedring',
            no_gaps: 'Ingen hull før flygning oppdaget. Arkivet er klart til å monteres.',
            override_label: 'Overstyr blokkavgjørelse � montering vil bli revisjonsstemplet.',
            accept_label: 'Godta rapporten',
            reject_label: 'Avvis rapport',
            assembled_label: 'Innleveringspakke satt sammen',
            package_id_label: 'Pakke-ID',
            package_filename_label: 'Filnavn',
            package_hash_label: 'Pakkehash',
            evidence_count_label: '[[TOK_1]] beviselementer samlet',
            error_generic: 'Kunne ikke kjøre pre-flight eller sette sammen pakken. Prøv på nytt eller kontroller arkiveringsstatusen.',
        },
        errors: {
            fetch: 'Kunne ikkje laste assessments.',
            save: 'Kunne ikkje lagre assessment.',
            fetch_gap_report_failed: 'Kunne ikkje hente mangelrapport.',
            fetch_transfers_failed: 'Kunne ikkje hente transfers.',
            save_transfer_failed: 'Kunne ikkje lagre overføring.',
            submit_review_failed: 'Kunne ikkje sende inn til gjennomgang.',
            process_decision_failed: 'Kunne ikkje behandle avgjerd.',
            deprecate_failed: 'Kunne ikkje utfase.',
            evaluate_risk_failed: 'Kunne ikkje evaluere risiko.',
            fetch_safeguards_failed: 'Kunne ikkje hente sikringstiltak.',
            save_safeguard_failed: 'Kunne ikkje lagre sikringstiltak.',
            update_safeguard_status_failed: 'Kunne ikkje oppdatere sikringsstatus.',
        },
        nav: {
            dpias: 'DPIA-ar',
            transfers: 'Overføringsvurderingar',
            dashboard: 'Kontrollpanel',
            gap_report: 'Mangelsrapport',
        },
        risk_level_critical: 'Kritisk risiko',
        risk_level_high: 'Høg risiko',
        risk_level_medium: 'Middels risiko',
        risk_level_low: 'Låg risiko',
        severity_critical: 'Kritisk alvorlegheitsgrad',
        severity_high: 'Høg alvorlegheitsgrad',
        severity_medium: 'Middels alvorlegheitsgrad',
        severity_low: 'Låg alvorlegheitsgrad',
        overdue: 'Forfallen',
        framework_filter_label: 'Rammeverk',
        aria_filter_by_framework: 'Filtrer etter rammeverk',
        dashboard: {
            title: 'Vurderingskontrollpanel',
            page_title: 'Vurderingsdashboard',
            announce_loaded: 'Vurderingsdashboard lasta',
            announce_chart_view: 'Viser diagramvising',
            announce_table_view: 'Viser datatabellvising',
            aria_metrics_table: 'Vurderingsdashboard-målingar',
            metric_col: 'Metrikk',
            value_col: 'Verdi',
            dpia_prefix: 'DPIA',
            transfer_prefix: 'Overføring',
            risk_prefix: 'Risiko',
            aria_dpias_by_status: 'DPIAar etter status',
            aria_transfers_by_status: 'Overføringar etter status',
            aria_top_risks: 'Topprisiko',
            aria_top_risks_table: 'Topprisiko på tvers av DPIAar',
            overdue_dpias_attention: '{count} forfalne DPIA-vurderingar krev merksemd',
            no_overdue_dpias: 'Ingen forfalne DPIA-vurderingar',
            overdue_transfers_attention: '{count} forfalne overføringsvurderingar krev merksemd',
            no_overdue_transfers: 'Ingen forfalne overføringsvurderingar',
            dpias_overview: 'DPIA-oversikt',
            transfers_overview: 'Overføringsvurdering-oversikt',
            overdue_items: 'Forfalne punkt',
            overdue_dpias: 'Forfalne DPIA-ar',
            overdue_transfers: 'Forfalne overføringsvurderingar',
            count: 'Tal',
            no_data: 'Ingen data tilgjengelege.',
            no_risks: 'Ingen risks funne.',
            no_dashboard_data: 'Ingen dashbord data tilgjengelege.',
            fetch_error: 'Kunne ikkje hente dashboarddata. Ver venleg og prøv igjen.',
        },
        dpias: {
            page_title: 'DPIAar',
            announce_submitted_for_review: 'DPIA sendt til gjennomgang',
            announce_deprecated: 'DPIA avvikla',
            announce_risks_loaded: '{count} risiko(ar) lasta',
            announce_mitigations_loaded: '{count} tiltak lasta',
            announce_risk_deleted: 'Risiko sletta',
            announce_mitigation_status_updated: 'Tiltaksstatus oppdatert',
            aria_filter: 'Filtrer DPIAar',
            aria_filter_by_status: 'Filtrer etter status',
            aria_filter_by_lead: 'Filtrer etter vurderingsleiar',
            aria_table: 'Personvernkonsekvensvurderingar',
            announce_found: '{count} DPIA(ar) funne',
            announce_decision: '[[TOK_2]] [[TOK_1]]',
            mitigation_start: 'Start',
            mitigation_mark_implemented: 'Merk implementert',
            mitigation_verify: 'Verifiser',
            title: 'Personvernkonsekvensvurderingar (DPIA)',
            new: 'Ny DPIA',
            edit: 'Rediger DPIA',
            dpia_title: 'Tittel',
            activity: 'Aktivitet',
            risk_score: 'Risikoskår',
            risks: 'Risikoar',
            mitigations: 'Risikoavgrensingar',
            add_risk: 'Legg til risiko',
            add_mitigation: 'Legg til risikoavgrensing',
            necessity: 'Nødvende / Proporsjonalitet',
            likelihood: 'Sannsyn',
            impact: 'Konsekvens',
            severity_label: 'Alvorsgrad',
            purpose: 'Føremål',
            consultation_notes: 'Konsultasjonsnotat',
            dpo_opinion: 'DPO-vurdering',
            processing_activity_ids: 'Behandlingsaktivitets-ID-er (kommaseparert)',
            system_ids: 'System-IDar (kommaseparert)',
            vendor_ids: 'Leverandør-IDar (kommaseparert)',
            data_types: 'Datatyper (kommaseparert)',
            data_types_short: 'Data Typar',
            data_subjects: 'Registrerede (kommaseparert)',
            assessment_lead_id: 'Vurdering Leiar ID',
            assessment_lead: 'Vurdering Leiar',
            dpo_id: 'DPO ID',
            reviewer_ids: 'Gennemgåer-ID-er (kommaseparert)',
            approval_mode: 'Godkjenning Modus',
            approval_all: 'Alle',
            approval_any: 'Kva som helst',
            require_dpo_signoff: 'Krev DPO-godkjenning',
            review_date: 'Gjennomgang Dato',
            submit_for_review: 'Send inn for Gennemgang',
            approve_reject: 'Godkjenn/Avvis',
            deprecate: 'Utfas',
            deprecated: 'Utfasa',
            hide_risks: 'Gøym risikoane',
            hide_mitigations: 'Gøym tiltak',
            comments: 'Kommentarar',
            submit_decision: 'Send avgjerd',
            category_label: 'Kategori',
            category_data_breach: 'Data Brot',
            category_unauthorized_access: 'Uautorisert Tilgang',
            category_function_creep: 'Funksjonsutgliding',
            category_re_identification: 'Re-identifisering',
            category_discrimination: 'Diskriminering',
            category_surveillance: 'Overvaking',
            category_other: 'Anna',
            affected_rights: 'Berørte rettigheder (kommaseparert)',
            no_risks: 'Ingen risks funne.',
            no_mitigations: 'Ingen mitigations funne.',
            no_dpias: 'Ingen dpias funne.',
            mitigation_type: 'Type',
            mitigation_technical: 'Teknisk',
            mitigation_organizational: 'Organisatorisk',
            mitigation_contractual: 'Kontraktsmessig',
            risk_ids: 'Risiko-IDar (kommaseparert)',
            responsible_party: 'Ansvarleg Part',
            responsible_party_placeholder: 'Eller skriv inn namn manuelt',
            affected_rights_placeholder: 'Valde rettar vert viste her',
            affected_rights_freetext_placeholder: 'Skriv inn påverka rettar (kommaseparert)',
            responsible: 'Ansvarleg',
            target_date: 'Mål Dato',
            created: 'Oppretta',
            fetch_error: 'Kunne ikkje hente DPIAs. Ver venleg og prøv igjen.',
            save_error: 'Kunne ikkje lagre DPIA. Ver venleg og prøv igjen.',
            submit_review_error: 'Kunne ikkje sende inn DPIA for review. Ver venleg og prøv igjen.',
            decision_error: 'Kunne ikkje behandle avgjerd. Ver venleg og prøv igjen.',
            deprecate_error: 'Kunne ikkje utfase DPIA. Ver venleg og prøv igjen.',
            fetch_risks_error: 'Kunne ikkje hente risks. Ver venleg og prøv igjen.',
            save_risk_error: 'Kunne ikkje lagre risiko. Ver venleg og prøv igjen.',
            delete_risk_error: 'Kunne ikkje slette risiko. Ver venleg og prøv igjen.',
            fetch_mitigations_error: 'Kunne ikkje hente mitigations. Ver venleg og prøv igjen.',
            save_mitigation_error: 'Kunne ikkje lagre mitigation. Ver venleg og prøv igjen.',
            update_mitigation_status_error: 'Kunne ikkje oppdatere tiltaksstatus. Ver venleg og prøv igjen.',
            link_form_template: 'Link forskriftsskjemamal',
            link_form_template_placeholder: 'Velg en [[TOK_0]] skjemamal (valgfritt)',
            link_form_template_none: 'Ingen',
            linked_form: 'Koblet skjema',
            linked_form_creating: 'Oppretter koblet skjema ...',
            linked_form_error: 'Kunne ikke opprette koblet skjemaforekomst. [[TOK_0]] ble opprettet uten et koblet skjema.',
            view_linked_form: 'Se skjema',
            announce_created_with_form: '[[TOK_0]] opprettet med koblet skjemaforekomst',
            creation_mode: '[[TOK_0]] Opprettingsmodus',
            mode_standard: 'Standard [[TOK_0]]',
            mode_template: 'Bruk forskriftsskjemamal',
            select_form_template: 'Velg Skjemamal',
            create_and_fill_form: 'Opprett og fyll ut skjema',
            template_sections_title: 'Malseksjoner',
            field_singular: 'felt',
            field_plural: 'felt',
            no_sections: 'Finner ingen seksjoner i denne malen.',
            template_mode_hint: 'Etter opprettelsen vil du bli omdirigert til å fylle ut det fullstendige forskriftsskjemaet.',
            linked_dossier_filings: 'Tilknytte dossierarkiveringar',
            no_linked_dossier_filings: 'Ingen dossierarkiveringar tilknytte denne DPIA-en.',
            view_dossier_filing: 'Vis arkivering',
            hide_dossier_filings: 'Gøym dossierarkiveringar',
            supporting_evidence: 'Støttende bevis',
            hide_supporting_evidence: 'Skjul bevis',
            no_supporting_evidence: 'Ingen støttende bevis vedlagt.',
            upload_supporting_evidence: 'Last opp støttende bevis',
            view_form_responses: 'Sjå skjemasvar',
            regulatory_framework: 'Regulatorisk rammeverk',
            all_frameworks: 'Alle rammeverk',
            no_templates_for_market: 'Ingen malar tilgjengelege for den valde marknaden. Ver venleg og vel ein annan marknad eller opprett ein mal.',
        },
        transfers: {
            page_title: 'Dataoverføringar',
            announce_found: '{count} overføringsvurdering(ar) funne',
            announce_submitted_for_review: 'Overføring sendt til gjennomgang',
            announce_deprecated: 'Overføring avvikla',
            announce_decision: 'Overføring {decision}',
            announce_risk_eval_completed: 'Risikovurdering fullført',
            announce_safeguard_status_updated: 'Tryggleiksstatus oppdatert',
            announce_safeguards_loaded: '{count} tryggleikstiltak lasta',
            aria_filter: 'Filtrer overføringsvurderingar',
            aria_filter_by_status: 'Filtrer etter status',
            aria_filter_by_mechanism: 'Filtrer etter overføringsmekanisme',
            aria_table: 'Dataoverføringsvurderingar',
            title: 'Grensekryssande overføringsvurderingar',
            new: 'Ny overføring',
            edit: 'Rediger overføring',
            name: 'Namn',
            from_country: 'Frå land',
            to_country: 'Til land',
            safeguards: 'Tryggingstiltak',
            risk_level: 'Risikonivå',
            assessment_notes: 'Vurderingsmerknadar',
            mechanism: 'Mekanisme',
            transfer_mechanism: 'Overføring Mekanisme',
            transfer_mechanism_detail: 'Overføring Mekanisme Detalj',
            all_mechanisms: 'Alle Mekanismar',
            mechanism_adequacy_decision: 'Tilstrekkelighetsavgjerd',
            mechanism_sccs: 'SCC-ar',
            mechanism_bcrs: 'BCR-ar',
            mechanism_consent: 'Samtykke',
            mechanism_derogation: 'Unntak',
            mechanism_other: 'Anna',
            data_types: 'Datatyper (kommaseparert)',
            data_subjects: 'Registrerede (kommaseparert)',
            purpose: 'Føremål',
            recipient_name: 'Mottakarnamn',
            create_success: 'Overføringsvurdering oppretta.',
            update_success: 'Overføringsvurdering oppdatert.',
            recipient_details: 'Mottakardetaljar',
            recipient_details_placeholder: 'Mottakaren si rolle, plassering og system samt detaljar om vidareoverføring',
            vendor_id: 'Leverandør ID',
            processing_activity_ids: 'Behandlingsaktivitets-ID-er (kommaseparert)',
            reviewer_ids: 'Gennemgåer-ID-er (kommaseparert)',
            approval_mode: 'Godkjenning Modus',
            approval_all: 'Alle',
            approval_any: 'Kva som helst',
            require_dpo_signoff: 'Krev DPO-godkjenning',
            review_date: 'Gjennomgang Dato',
            created: 'Oppretta',
            deprecated: 'Utfasa',
            submit_for_review: 'Send inn for Gennemgang',
            approve_reject: 'Godkjenn/Avvis',
            deprecate: 'Utfas',
            risk_eval: 'Risiko Evaluering',
            hide_safeguards: 'Gøym tryggingstiltak',
            mechanism_proof: 'Mekanismebevis',
            hide_mechanism_proof: 'Skjul mekanismebevis',
            mechanism_proof_hint: 'Last opp den signerte overføringsmekanismen (SCC-er, BCR-er, beslutning om tilstrekkelighet osv.) som beviser denne overføringsvurderingen.',
            no_mechanism_proof: 'Ingen mekanisme bevis vedlagt.',
            upload_mechanism_proof: 'Last opp mekanismebevis',
            comments: 'Kommentarar',
            submit_decision: 'Send avgjerd',
            data_sensitivity: 'Datafølsomhed (1-5)',
            country_risk: 'Landerisiko (1-5)',
            safeguard_adequacy: 'Sikringstiltak Tilstrekkelighets (1-5)',
            volume_factor: 'Mængdefaktor (1-5)',
            evaluate: 'Evaluer',
            add_safeguard: 'Add Sikringstiltak',
            responsible_party: 'Ansvarleg Part',
            responsible_party_placeholder: 'Eller skriv inn namn manuelt',
            responsible: 'Ansvarleg',
            implementation_date: 'Implementeringsdato',
            implementation: 'Implementering',
            expiry_date: 'Utløp Dato',
            expiry: 'Utløp',
            expire: 'Utløp',
            no_safeguards: 'Ingen sikringstiltak funne.',
            no_transfers: 'Ingen overføring vurderingar funne.',
            fetch_error: 'Kunne ikkje hente overføringsvurderingar. Ver venleg og prøv igjen.',
            save_error: 'Kunne ikkje lagre overføringsvurdering. Ver venleg og prøv igjen.',
            submit_review_error: 'Kunne ikkje sende inn til gjennomgang. Ver venleg og prøv igjen.',
            decision_error: 'Kunne ikkje behandle avgjerd. Ver venleg og prøv igjen.',
            deprecate_error: 'Kunne ikkje utfase overføring. Ver venleg og prøv igjen.',
            risk_eval_error: 'Kunne ikkje evaluere risiko. Ver venleg og prøv igjen.',
            fetch_safeguards_error: 'Kunne ikkje hente sikringstiltak. Ver venleg og prøv igjen.',
            save_safeguard_error: 'Kunne ikkje lagre sikringstiltak. Ver venleg og prøv igjen.',
            update_safeguard_status_error: 'Kunne ikkje oppdatere sikringsstatus. Ver venleg og prøv igjen.',
            safeguard_type_encryption_in_transit: 'Kryptering under transport',
            safeguard_type_encryption_at_rest: 'Kryptering i hvile',
            safeguard_type_access_controls: 'Tilgang Kontrollar',
            safeguard_type_contractual_clauses: 'Kontraktsklausular',
            safeguard_type_data_minimization: 'Data Minimering',
            safeguard_type_pseudonymization: 'Pseudonymisering',
            safeguard_type_audit_rights: 'Revisjon Rettar',
            safeguard_type_breach_notification: 'Brot Varsling',
            safeguard_type_data_localization: 'Data Lokalisering',
            safeguard_type_other: 'Anna',
            activate: 'Aktiver',
            all_statuses: 'Alle statuser',
            any: 'Kva som helst',
            mechanism_detail: 'Mekanisme Detalj',
            mechanisms: {
                adequacy_decision: 'Tilstrekkelighetsavgjerd',
                sccs: 'SCC-ar',
                bcr: 'BCR',
                bcrs: 'BCR-ar',
                derogation: 'Unntak',
                consent: 'Samtykke',
                other: 'Anna',
            },
            safeguard_types: {
                encryption_in_transit: 'Kryptering under overføring',
                encryption_at_rest: 'Kryptering i kvile',
                access_controls: 'Tilgangskontrollar',
                contractual_clauses: 'Kontraktsklausular',
                data_minimization: 'Dataminimering',
                pseudonymization: 'Pseudonymisering',
                audit_rights: 'Revisjonsrettar',
                breach_notification: 'Brotsvarsel',
                data_localization: 'Datalokalisering',
                other: 'Anna',
            },
        },
        gap_report: {
            page_title: 'Gap-rapport for vurderingar',
            announce_loaded: 'Gap-rapport lasta. {count} gap identifisert',
            aria_activities_without_dpia: 'Aktivitetar utan DPIA-vurdering',
            aria_activities_unclassified: 'Aktivitetar med uklassifisert DPIA-krav',
            activities_unclassified_section_title: 'Aktivitetar med uklassifisert DPIA-krav',
            activities_unclassified_description: 'Desse aktivitetane er ikkje gjennomgått for å avgjere om ein DPIA er juridisk påkravd. Klassifiser kvar einskild for å fjerne signalet.',
            activities_unclassified_empty: 'Alle aktive aktivitetar er klassifiserte.',
            aria_unmitigated_risks: 'Ubehandla høge og kritiske risikoar',
            aria_transfers_without_safeguards: 'Overføringar utan tilstrekkelege tryggleikstiltak',
            aria_expired_assessments: 'Utløpte vurderingar som krev fornying',
            title: 'Vurderingsmangelsrapport',
            no_dpia: 'Aktivitetar utan DPIA',
            no_assessment: 'Overføringar utan vurdering',
            unmitigated: 'DPIA-ar med uavgrensa risikoar',
            activity_id: 'Aktivitet ID',
            dpia_id: 'DPIA ID',
            assessment_id: 'Vurdering ID',
            expired_assessments: 'Utløpte Vurderingar',
            no_gaps_activities: 'Ingen manglar funne. Alle aktivitetar har DPIA-ar.',
            no_unmitigated_risks: 'Ingen uutbetra høge/kritiske risikoar funne.',
            no_gaps_safeguards: 'Ingen manglar funne. Alle overføringar har tilstrekkelege sikringstiltak.',
            no_expired: 'Ingen utløpte vurderingar funne.',
            no_report_data: 'Ingen mangel rapport data tilgjengelege.',
            fetch_error: 'Kunne ikkje hente mangelrapport. Ver venleg og prøv igjen.',
            no_expired_assessments: 'Ingen utløpte vurderingar.',
            no_gaps_dpia: 'Ingen dpia gaps funne.',
            no_data: 'Ingen data tilgjengelege.',
        },
        dossier_filings: {
            page_title_detail: 'Dossierinnleveringsdetalj',
            page_title_list: 'Dossierinnleveringssaker',
            announce_filings_found: '{count} innlevering(ar) funne',
            announce_results: '{count} resultat',
            aria_filter_by_status: 'Filtrer etter status',
            title: 'Dossierarkivsaker',
            nav_label: 'Dossierarkivering',
            create: 'Lag dossierarkivering',
            form_type: 'Skjematype',
            phu_luc_i_label: 'Mẫu s� 02a (Standard [[TOK_0]], dekret 356)',
            phu_luc_ii_label: 'Mẫu s� 02b (Grenseoverskridende / høyrisiko [[TOK_0]], dekret 356)',
            dpia_reference: '[[TOK_0]] Referanse',
            submitted_date: 'Innsendt dato',
            outcome: 'Utfall',
            parent_filing: 'Foreldre',
            no_filings: 'Fant ingen dossier.',
            fetch_error: 'Kunne ikke hente dossierinnleveringer. Vennligst prøv igjen.',
            save_error: 'Kunne ikke opprette dossierarkivering. Vennligst prøv igjen.',
            created: 'Dokumentarkiv opprettet.',
            loaded: 'Dokumentarkiv lastet.',
            not_found: 'Finner ikke dossier.',
            back_to_list: 'Tilbake til listen',
            section_assignments: 'Seksjonsoppgaver',
            assign_sections: 'Tilordne seksjoner',
            section_id: 'Seksjon',
            department: 'Avdeling',
            assignee: 'Oppdragstaker',
            deadline: 'Frist',
            no_assignments: 'Ingen seksjonsoppgaver ennå.',
            sections_assigned_msg: 'Seksjoner tildelt.',
            assign_error: 'Kunne ikke tilordne seksjoner. Vennligst prøv igjen.',
            lifecycle: 'Arkiveringslivssyklus',
            submission: 'Innleveringsdetaljer',
            submission_channel: 'Sendingskanal',
            mps_portal: '[[TOK_0]] Portal',
            in_person: 'Personlig',
            postal: 'Post',
            confirmation_number: 'Bekreftelsesnummer',
            submit_for_review: 'Send til gjennomgang',
            submitted_for_review: 'Sendt til intern vurdering.',
            submit_review_error: 'Kunne ikke sende inn til vurdering. Vennligst prøv igjen.',
            legal_signoff: 'Juridisk avmelding',
            legal_signoff_done: 'Juridisk signering fullført.',
            legal_signoff_error: 'Kunne ikke fullføre juridisk signering. Vennligst prøv igjen.',
            approve: 'Godkjenne',
            approved_msg: 'Innlevering godkjent.',
            approve_error: 'Kunne ikke godkjenne innlevering. Vennligst prøv igjen.',
            materialisation_status_column: 'Innleveringsartefakt',
            materialisation_na: 'Ikke aktuelt',
            materialisation_pending: 'Venter',
            materialisation_success: 'Materialisert',
            materialisation_failed: 'Mislyktes',
            materialisation_banner_title: 'Innsendingsartefakt kunne ikke opprettes',
            materialisation_banner_body: 'Innleveringen ble godkjent, men den underliggende dossierposten kunne ikke opprettes. Eksport av følgebrev og innsending er utilgjengelig før du prøver på nytt.',
            materialisation_retry_button: 'Prøv på nytt',
            materialisation_retry_count: 'Tidligere forsøk på nytt:',
            materialisation_retry_success: 'Innsendingsartefakt materialiserte vellykket.',
            materialisation_retry_announce: 'Forsøk på nytt lyktes',
            filter_materialisation_failed: 'Vis bare materialiseringsfeil',
            column_title: 'Tittel',
            column_form_type: 'Skjema',
            submit_to_mps: 'Send til [[TOK_0]]',
            submitted_to_mps_msg: 'Sendt til [[TOK_0]].',
            submit_mps_error: 'Kunne ikke sende inn til [[TOK_0]]. Vennligst prøv igjen.',
            supplement_request: 'Tilleggsforespørsel',
            supplement_requests: 'Tilleggsforespørsler',
            supplement_response: 'Tilleggsvar',
            record_supplement: 'Registrer tilleggsforespørsel',
            supplement_recorded: 'Tilleggsforespørsel registrert.',
            supplement_error: 'Kunne ikke registrere tilleggsforespørsel. Vennligst prøv igjen.',
            submit_supplement: 'Send inn tilleggssvar',
            supplement_submitted_msg: 'Tilleggssvar innsendt.',
            supplement_submit_error: 'Kunne ikke sende inn tilleggssvar. Vennligst prøv igjen.',
            response_status: 'Svarstatus',
            response_notes: 'Svarnotater',
            resubmit: 'Send inn på nytt',
            resubmitted_msg: 'Saksdokumentet er sendt inn på nytt.',
            resubmit_error: 'Kunne ikke sende inn dokumentet på nytt. Vennligst prøv igjen.',
            record_outcome: 'Ta opp resultat',
            outcome_recorded: 'Utfall registrert.',
            outcome_error: 'Kunne ikke registrere utfallet. Vennligst prøv igjen.',
            accepted: 'Akseptert',
            rejected: 'Avvist',
            close: 'Lukk',
            closed_msg: 'Arkiv stengt.',
            close_error: 'Kunne ikke lukke arkivet. Vennligst prøv igjen.',
            change_filing: 'Opprett endringsarkivering',
            change_filing_created: 'Endre arkivering opprettet.',
            change_filing_error: 'Kunne ikke opprette endringsarkivering. Vennligst prøv igjen.',
            change_reason: 'Grunn til endring',
            filing_lineage: 'Arkivering avstamning',
            timers: 'Aktive timere',
            timer_mps_review: '[[TOK_0]] Anmeldelse',
            timer_supplement: 'Tilleggsfrist',
            timer_resubmission: 'Frist for ny innsending',
            timer_department: 'Avdelingsfrist',
            days_remaining: 'dagar att',
            days_overdue: 'dagar forseinka',
            cover_letter: 'Følgebrev',
            checklist: 'Sjekkliste',
            evidence_index: 'Bevisindeks',
            status_draft: 'Utkast',
            status_sections_assigned: 'Seksjoner tildelt',
            status_internal_review: 'Intern gjennomgang',
            status_legal_signoff: 'Juridisk avmelding',
            status_approved: 'Godkjend',
            status_submitted_to_mps: 'Sendt til [[TOK_0]]',
            status_supplement_requested: 'Tillegg etterspurt',
            status_supplement_submitted: 'Tillegg innsendt',
            status_resubmitted: 'Sendt på nytt',
            status_accepted: 'Godtatt',
            status_rejected: 'Avvist',
            status_closed: 'Stengt',
            linked_dpia: 'Tilknytt DPIA',
            linked_dpia_none: 'Ingen DPIA tilknytt denne arkiveringa.',
            view_linked_dpia: 'Vis DPIA',
            linked_dpia_label: 'Denne dossierarkiveringa er tilknytt følgjande DPIA:',
        },
        materialisation_health: {
            nav_label: 'Innsending artefakt helse',
            page_title: 'Innlevering Artefakt Helse',
            page_description: 'Oppdag og utbedre problemer med materialisering av dossier. Listene er tilpasset organisasjonen din.',
            failed_title: 'Mislykkede materialiseringer',
            failed_empty: 'Ingen mislykkede materialiseringer - bra.',
            pending_title: 'Godkjent, men ikke realisert',
            pending_empty: 'Alle godkjente registreringer har en dokumentasjon.',
            orphan_title: 'Foreldreløse dossierer',
            orphan_description: 'Dossier opprettet av materialisering som ikke lenger refereres til i noen arkivering - vanligvis taperen av et samtidig løp. Oppført for etterforskning; opprydding er manuell.',
            orphan_empty: 'Ingen foreldreløse dossierer oppdaget.',
            materialise_button: 'Materialiseres nå',
            column_failure_reason: '�&rsak til feil',
            column_failed_at: 'Mislyktes kl',
            column_retries: 'Forsøk på nytt',
            column_approved_at: 'Godkjent kl',
            column_dossier_id: 'Dossier ID',
            column_source_filing_id: 'Kildearkivering',
            column_dossier_type: 'Type',
            column_created_at: 'Opprettet kl',
        },
    },
    classification: {
        access_denied_title: 'Tilgang nektet',
        access_denied: 'Du har ikke de nødvendige tillatelsene for å få tilgang til klassifiseringsmodulen. Kontakt administratoren din.',
        nav: {
            taxonomies: 'Taksonomiar',
            labeling: 'Merking',
            lifecycle: 'Livssyklus',
            gaps: 'Mangelsrapport',
            exports: 'Eksportar',
        },
        exports: {
            title: 'Klassifiseringseksportar',
            csv_section: 'CSV-eksportar',
            pdf_section: 'PDF-rapportar',
            inventory: 'Oversikt',
            classification_register: 'Klassifiseringsregister',
            raci: 'RACI-matrise',
            exceptions: 'Unntak',
            evidence_pack: 'Dokumentasjonspakke',
            delta_report: 'Deltarapport',
            executive_summary: 'Leiingssamandrag',
            exporting: 'Eksporterer⬦',
            export_success: 'Eksport fullført.',
            export_error: 'Eksport mislukkast. Prøv igjen.',
            csv_download: 'CSV-nedlasting klar.',
            pdf_download: 'PDF-generering starta.',
            no_data: 'Ingen data tilgjengeleg for eksport.',
        },
        delta: {
            title: 'Endringsdetaljar',
            added: 'Lagt til',
            removed: 'Fjerna',
            changed: 'Endra',
            added_count: 'Lagt til ({count})',
            removed_count: 'Fjerna ({count})',
            changed_count: 'Endra ({count})',
            object_id: 'Objekt-ID',
            object_type: 'Objekttype',
            taxonomy: 'Taksonomi',
            level: 'Nivå',
            previous: 'Førre',
            current: 'Noverande',
            no_records: 'Ingen postar i denne seksjonen.',
            empty_section: 'Denne seksjonen er tom.',
        },
        schedule: {
            title: 'Planlegg oppdagingssyklus',
            enabled: 'Aktivert',
            interval_days: 'Intervall (dagar)',
            interval_label: 'Køyr kvar N. dag',
            manual_only: 'Berre manuell',
            every_n_days: 'Kvar {n}. dag',
            save: 'Lagre tidsplan',
            cancel: 'Avbryt',
            schedule_updated: 'Tidsplan oppdatert.',
        },
        taxonomies: {
            title: 'Klassifiseringstaksonomiar',
            new: 'Ny taksonomi',
            edit: 'Rediger taksonomi',
            name: 'Namn',
            levels: 'Klassifiseringsnivå',
            seed_defaults: 'Initialiser standarder',
            scope: 'Omfang',
            scope_organization: 'Organisasjon',
            scope_module_specific: 'Modul Spesifikk',
            deprecate: 'Utfas',
            hide_levels: 'Gøym nivå',
            versions: 'Versjonar',
            hide_versions: 'Gøym versjonar',
            add_level: 'Add Nivå',
            new_level: 'Ny Nivå',
            edit_level: 'Rediger Nivå',
            code: 'Kode',
            label: 'Etikett',
            color: 'Farge',
            ordinal: 'Ordenstal',
            handling_requirements: 'Handtering Krav',
            version_history: 'Versjon Historikk',
            changes: 'Endringar',
            failed_fetch: 'Kunne ikkje hente taksonomiar. Ver venleg og prøv igjen.',
            failed_save: 'Kunne ikkje lagre taksonomi. Ver venleg og prøv igjen.',
            failed_activate: 'Kunne ikkje aktivere taksonomi. Ver venleg og prøv igjen.',
            failed_deprecate: 'Kunne ikkje utfase taksonomi. Ver venleg og prøv igjen.',
            failed_seed: 'Kunne ikkje initialisere standardtaksonomiar. Ver venleg og prøv igjen.',
            failed_fetch_levels: 'Kunne ikkje hente taksonomiske nivå. Ver venleg og prøv igjen.',
            failed_save_level: 'Kunne ikkje lagre taksonomisk nivå. Ver venleg og prøv igjen.',
            failed_delete_level: 'Kunne ikkje slette taksonomisk nivå. Ver venleg og prøv igjen.',
            failed_fetch_versions: 'Kunne ikkje hente taksonomiversion. Ver venleg og prøv igjen.',
            loaded_count: 'Lasta {count} taksonomiar',
            defaults_seeded: 'Standard-taksonomiar initialiserte.',
            no_levels: 'Ingen klassifiseringsnivå definerte � legg til nivå for å byggje klassifiseringshierarkiet.',
            no_versions: 'Ingen versjonshistorikk enno � versjonar vert oppretta når ein aktiv taksonomi vert oppdatert.',
        },
        labeling: {
            title: 'Datamerking',
            new: 'Ny merkelapp',
            edit: 'Rediger merkelapp',
            entity_type: 'Einingstype',
            entity_id: 'Einings-ID',
            taxonomy: 'Taksonomi',
            classification_level: 'Klassifiseringsnivå',
            applied_by: 'Påført av',
            applied_at: 'Påført',
            bulk_apply: 'Massebruk',
            bulk_remove: 'Massefjerning',
            all_taxonomies: 'Alle Taksonomiar',
            system: 'System',
            dataset: 'Datasett',
            level_code_placeholder: 'Nivå kode...',
            select_taxonomy: 'Vel taksonomi...',
            select_level: 'Vel nivå...',
            rationale: 'Grunngiving',
            review_date: 'Gjennomgang Dato',
            review: 'Gjennomgang',
            selected: 'vald',
            select_all_labels: 'Vel alle etikettar',
            loaded_count: 'Lasta {count} etikettar',
            hide_stale_labels: 'Skjul forældede etiketter',
            show_conflicts: 'Vis konfliktar',
            hide_conflicts: 'Gøym konfliktar',
            label_conflicts: 'Etikett Konfliktar',
            conflict_reason: 'Konflikt �&rsak',
            labels: 'Etikettar',
            failed_fetch: 'Kunne ikkje hente etikettar. Ver venleg og prøv igjen.',
            failed_fetch_taxonomies: 'Kunne ikkje hente taksonomiar. Ver venleg og prøv igjen.',
            failed_fetch_levels: 'Kunne ikkje hente taksonomiske nivå. Ver venleg og prøv igjen.',
            failed_save: 'Kunne ikkje lagre etikett. Ver venleg og prøv igjen.',
            failed_review: 'Kunne ikkje gjennomgå etikett. Ver venleg og prøv igjen.',
            failed_bulk: 'Kunne ikkje massemerke. Ver venleg og prøv igjen.',
            failed_stale: 'Kunne ikkje hente utdaterte etikettar. Ver venleg og prøv igjen.',
            failed_conflicts: 'Kunne ikkje hente etikettkonfliktar. Ver venleg og prøv igjen.',
            review_permission_denied: 'Du har ikkje løyve til å gå gjennom denne etiketten.',
            review_not_found: 'Etikett ikkje funnen � han kan ha vorte sletta.',
            approve_selected: 'Godkjenn valde',
            reject_selected: 'Avvis valde',
            approved: 'Godkjend',
            rejected: 'Avvist',
            labels_count: 'etikettar',
            failed_count: 'mislukkast',
            confirm_approve: 'Stadfest godkjenning',
            confirm_reject: 'Stadfest avvising',
            approve_n_labels: 'Godkjenn {count} etikettar?',
            reject_n_labels: 'Avvis {count} etikettar?',
            submit_for_review: 'Send til gjennomgang',
            approve: 'Godkjenn',
            reject: 'Avvis',
            parent_system: 'Overordna system',
            parent_system_placeholder: 'Vel overordna system...',
            parent_system_help: 'Brukast til konfliktdeteksjon.',
            dataset_level: 'Datasettniva',
            parent_level: 'Overordna niva',
            bulk_created: 'Oppretta {created} etikett(ar)',
            bulk_skipped: '{skipped} hoppa over',
            bulk_all_skipped: 'Alle {skipped} hoppa over',
            ids_hint: 'Skriv inn IDar skilde med komma',
            delete_confirm: 'Slett etikett for "{id}"?',
        },
        lifecycle: {
            title: 'Datalivssyklusovervaking',
            new: 'Ny oppføring',
            current_stage: 'Gjeldande fase',
            last_transition: 'Siste overgang',
            transition: 'Overgang',
            view_history: 'Vis historikk',
            stages: {
                creation: 'Oppretting',
                collection: 'Innsamling',
                processing: 'Behandling',
                storage: 'Lagring',
                retention: 'Oppbevaring',
                disposal: 'Avhending',
                archived: 'Arkivert',
                active: 'Aktiv',
                pending_deletion: 'Ventande Sletting',
                deleted: 'Sletta',
                on_hold: 'På Sperring',
            },
            all_stages: 'Alle Fasar',
            object_id: 'Objekt ID',
            object_type: 'Objekt Type',
            policy_reference: 'Retningslinje Referanse',
            retention_period_days: 'Opbevaringsperiode (dagar)',
            retention_basis: 'Oppbevaring Grunnlag',
            deletion_method: 'Sletting Metode',
            deletion_secure_erase: 'Sikker Sletting',
            deletion_anonymization: 'Anonymisering',
            deletion_physical_destruction: 'Fysisk Destruksjon',
            deletion_other: 'Anna',
            responsible_party: 'Ansvarleg Part',
            responsible_user_id: 'Ansvarleg Brukar ID',
            retention_expiry: 'Oppbevaring Utløp',
            hold_reason: 'Sperring �&rsak',
            hold: 'Hald tilbake',
            release: 'Frigiving',
            hide_events: 'Gøym hendingar',
            events_timeline: 'Hendingar Tidslinje',
            add_event: 'Add Hending',
            event_type: 'Hending Type',
            create_event: 'Opprett hending',
            from_stage: 'Frå Fase',
            to_stage: 'Til Fase',
            actor: 'Aktør',
            reason_placeholder: '�&rsak...',
            go: 'Go',
            show_expired_retentions: 'Vis udløbne opbevaringer',
            hide_expired_retentions: 'Skjul udløbne opbevaringer',
            expired_retentions_alert: 'Alarm for udløbne opbevaringer',
            failed_fetch: 'Kunne ikkje hente livssykluspostar. Ver venleg og prøv igjen.',
            failed_save: 'Kunne ikkje lagre livssykluspost. Ver venleg og prøv igjen.',
            failed_transition: 'Kunne ikkje overføre livssyklusfase. Ver venleg og prøv igjen.',
            failed_hold: 'Kunne ikkje plassere sperring. Ver venleg og prøv igjen.',
            failed_release: 'Kunne ikkje frigje sperring. Ver venleg og prøv igjen.',
            failed_fetch_events: 'Kunne ikkje hente livssyklushendingar. Ver venleg og prøv igjen.',
            failed_create_event: 'Kunne ikkje opprette livssyklushending. Ver venleg og prøv igjen.',
            failed_expired: 'Kunne ikkje hente utløpte oppbevaringar. Ver venleg og prøv igjen.',
            hold_reason_prompt: 'Oppgje tilbageholdelsesårsak:',
            loaded_count: 'Lasta {count} livssykluspostar',
            stage_transition_for: 'Faseovergang for {id}',
            event_created: 'Oppretta',
            event_updated: 'Oppdatert',
            event_approved: 'Godkjend',
            event_deprecated: 'Utgått',
            event_proposed: 'Føreslått',
            event_reviewed: 'Gjennomgått',
            event_archived: 'Arkivert',
            event_restored: 'Attoppretta',
        },
        gap_report: {
            title: 'Klassifiseringsmangelsrapport',
            unlabeled: 'Umerkte data',
            missing_lifecycle: 'Manglande livssyklus',
            stale_labels: 'Forelda merkelappar',
            run_detection: 'Køyring Mangel Deteksjon',
            detecting: 'Detekterer...',
            detection_complete: 'Mangelregistrering fuldført. {count} mangel(er) registreret.',
            detection_failed: 'Mangel deteksjon mislukkast.',
            by_severity: 'Etter Alvorlegheit',
            by_gap_type: 'Etter Mangel Type',
            all_gap_types: 'Alle Mangel Typar',
            conflicting_labels: 'Motstridande Etikettar',
            expired_retention: 'Utløpte Oppbevaring',
            missing_handling: 'Manglande Handtering',
            info: 'Info',
            gap_type: 'Mangel Type',
            object_id: 'Objekt ID',
            object_type: 'Objekt Type',
            detected_at: 'Oppdaga den',
            open: 'Opne',
            acknowledged: 'Stadfesta',
            remediated: 'Utbetra',
            accepted: 'Godtatt',
            acknowledge: 'Stadfest',
            remediate: 'Utbetre',
            accept_risk: 'Godta Risiko',
            accept_risk_prompt: 'Oppgje risiko aksept grunngiving:',
            failed_fetch: 'Kunne ikkje hente manglar. Ver venleg og prøv igjen.',
            failed_acknowledge: 'Kunne ikkje stadfeste mangel. Ver venleg og prøv igjen.',
            failed_remediate: 'Kunne ikkje utbetre mangel. Ver venleg og prøv igjen.',
            failed_accept_risk: 'Kunne ikkje godta mangelrisiko. Ver venleg og prøv igjen.',
            failed_detect: 'Kunne ikkje køyre mangeldeteksjon. Ver venleg og prøv igjen.',
            loaded_count: 'Lasta {count} klassifiseringsmanglar',
            related_object_id: 'Relatert objekt-ID',
            related_object_type: 'Relatert objekttype',
            gap_types: {
                unlabeled_asset: 'Umerka ressurs',
                missing_lifecycle: 'Manglande livssyklus',
                expired_retention: 'Utlopt oppbevaring',
                extended_pending_deletion: 'Utvida ventande sletting',
            },
        },
        label_workflow: {
            title: 'Etikettarbeidsflyt',
            proposed: 'Føreslegen',
            under_review: 'Under vurdering',
            approved: 'Godkjend',
            deprecated: 'Utgått',
            submit_review: 'Send til vurdering',
            approve: 'Godkjenn etikett',
            deprecate: 'Utgå',
            bulk_approve: 'Massegodkjenn',
            bulk_approve_success: 'Etikettar godkjende.',
            submit_success: 'Etikett sendt til vurdering.',
            approve_success: 'Etikett godkjend.',
            deprecate_success: 'Etikett utgått.',
        },
        review_tasks: {
            title: 'Vurderingsoppgåver',
            create: 'Ny vurderingsoppgåve',
            system: 'System',
            owner: 'Eigar',
            description: 'Skildring',
            resolution: 'Løysing',
            resolve: 'Løys',
            approve: 'Godkjenn',
            modify: 'Endre',
            reject: 'Avvis',
            escalate: 'Eskaler',
            escalated: 'Eskalerte oppgåver',
            no_tasks: 'Ingen vurderingsoppgåver.',
            resolve_success: 'Vurderingsoppgåve løyst.',
            status_pending: 'Ventande',
            status_resolved: 'Løyst',
            status_escalated: 'Eskalert',
            notes: 'Notat',
            create_success: 'Gjennomgangsoppgåve oppretta.',
            no_tasks_detail: 'Ingen gjennomgangsoppgåver enno � opprett ei oppgåve for å tildele etikettgjennomgangar til systemeigarar.',
            label_id: 'Etikett-ID',
            system_id: 'System-ID',
            system_name: 'Systemnamn',
            owner_id: 'Eigar-ID',
            resolution_col: 'Loysing',
            notes_col: 'Notat',
        },
        exceptions: {
            title: 'Unntakskø',
            create: 'Nytt unntak',
            severity: 'Alvorleggrad',
            system: 'System',
            owner: 'Eigar',
            resolve: 'Løys',
            no_exceptions: 'Ingen unntak funne.',
            resolve_success: 'Unntak løyst.',
            dashboard_open: 'Opne unntak',
            dashboard_resolved: 'Løyste unntak',
            dashboard_total: 'Totalt',
            dashboard_by_severity: 'Etter alvorleggrad',
            status_open: '�&pne',
            status_resolved: 'Løyst',
            status_accepted_risk: 'Akseptert risiko',
            create_success: 'Unntak oppretta.',
            no_exceptions_detail: 'Ingen unntak enno � unntak vert oppretta frå alvorlege manglar som krev spesiell handtering.',
            gap_id: 'Mangel-ID',
            system_id: 'System-ID',
            system_name: 'Systemnamn',
            owner_id: 'Eigar-ID',
            resolution_notes: 'Løysingsnotat',
            resolution_notes_placeholder: 'Beskriv korleis dette unntaket vart løyst...',
        },
        enterprise_map: {
            title: 'Bedriftsdatakart',
            inventory: 'Dataoversyn',
            total_systems: 'Totalt antal system',
            total_labels: 'Totalt antal etikettar',
            approved_count: 'Godkjende etikettar',
            proposed_count: 'Føreslåtte etikettar',
            no_data: 'Ingen klassifiseringsdata tilgjengeleg.',
            no_approved_labels: 'Ingen godkjende etikettar enno � etikettar må gåast gjennom og godkjennast før dei vert viste på datakartet.',
            loaded_count: 'Lastet bedriftsdatakart',
        },
        discovery: {
            title: 'Oppdagingssyklusar',
            create: 'Ny syklus',
            cycle_name: 'Syklusnamn',
            run_delta: 'Køyr deltadeteksjon',
            delta_success: 'Deltadeteksjon fullført.',
            create_success: 'Oppdagingssyklus oppretta.',
            no_cycles: 'Ingen oppdagingssyklusar.',
            status_created: 'Opprettet',
            status_scanning: 'Skanning',
            status_review: 'Gjennomgå',
            status_approved: 'Godkjent',
            status_published: 'Publisert',
            status_draft: 'Utkast',
            running: 'Køyrer',
            completed: 'Fullført',
            cancelled: 'Avbroten',
            delta_result_summary: 'Fann {added} lagt til, {removed} fjerna, {changed} endra etikettar.',
            delta_results: 'Deltaresultat',
            view_results: 'Sjå resultat',
            scope_type: 'Omfang Type',
            scope_type_all: 'Alle',
            scope_type_systems: 'Systemer',
            scope_type_datasets: 'Datasett',
            scope_ids: 'Omfangs-IDer',
            scope_ids_placeholder: 'Skriv inn IDer atskilt med komma',
            cycle_explanation: 'En oppdagelsessyklus skanner datainfrastrukturen din for å identifisere, klassifisere og spore dataressurser. Konfigurer omfanget for å målrette mot spesifikke systemer eller datasett.',
            empty_state_title: 'Ingen oppdagelsessykluser ennå',
            empty_state_description: 'Lag din første oppdagelsessyklus for å begynne å skanne og klassifisere datamidlene dine.',
            empty_state_cta: 'Lag første syklus',
            validation_name_required: 'Syklusnavn er påkrevd',
            validation_scope_type_required: 'Omfangstype er påkrevd',
            validation_scope_ids_required: 'Minst én omfangs-ID kreves',
        },
        regulatory: {
            sensitivity_importance_info: 'Dataloven (lov [[TOK_0]], krav. 18e4bfd1) krever klassifisering etter både sensitivitet og viktighet som separate dimensjoner. Opprett én taksonomi for hver dimensjon for å tilfredsstille dette kravet.',
            handling_rules_info: 'Hvert klassifiseringsnivå bør definere håndteringsregler per forespørsel. b89981ac ("Definer håndteringsregler etter klassifiseringsnivå").',
            template_internal_ids_info: 'Alle klassifiseringsmaler bruker interne IDer (f.eks. vn_data_law_data_classification_record). Ingen mal presenteres som et offisielt departementsskjema.',
            ai_risk_tiers_info: '[[TOK_0]] Lov (lov [[TOK_3]], krav 3a87ad63) definerer fire [[TOK_1]] systemrisikonivåer: minimal, begrenset, høy og uakseptabel. Lag en [[TOK_2]] risikotaksonomi med disse nivåene.',
            ai_risk_tier_minimal: 'Minimal',
            ai_risk_tier_limited: 'Avgrensa',
            ai_risk_tier_high: 'Hog',
            ai_risk_tier_unacceptable: 'Uakseptabel',
            ai_register_info: '[[TOK_0]] klassifiseringsposter bør kobles til en [[TOK_1]] systemregisteroppføring (req. 0f4475d3) som fanger opp: systemnavn, eier, formål, distribusjonskontekst, risikonivå, leverandørinvolvering.',
            ai_template_internal_info: '[[TOK_0]] klassifiseringsmaler bruker interne IDer (f.eks. [[TOK_1]]-RISK-01). Ingen offisielle [[TOK_2]] plassholder-ID-er ([[TOK_3]]-HC-01 til [[TOK_4]]-HC-08) brukes.',
            ai_audit_trail_info: '[[TOK_0]] klassifiseringsendringer produserer et versjonert revisjonsspor per UC-VN-06: aktør, tidsstempel, tidligere verdi, ny verdi og begrunnelse.',
            lifecycle_data_d1_info: 'Livssyklusoverganger kartlegger til Data Law-prosedyre DATA-D1 trinn: katalogisere, klassifisere, definere håndteringsregler, fange bevis, planlegge gjennomganger.',
            lifecycle_deletion_link_info: 'Et klassifisert dataelement som når slutten av levetiden, bør utløse en sletteplanpost via Deletion Orchestration-modulen.',
            lifecycle_evidence_info: 'Hver livssyklustilstandsendring (utkast, aktiv, undervurdering, arkivert, slettet) fanger opp aktør, tidsstempel og begrunnelse som en revisjonssporoppføring.',
            escalation_timers_info: 'UC-VN-10 eskaleringsfrister: 5 virkedager for eiervurdering, 48 timer for unntakseskalering, 72 timer for høyrisiko/sensitive elementer.',
            escalation_owner_review: '5 verkedagar',
            escalation_exception: '48 timar',
            escalation_high_risk: '72 timar',
            gap_risk_areas_info: 'Datalovkrav. f6c3060a ("Datarisikovurdering") krever gapanalyse på tvers av 4 risikoområder: personvern, cybersikkerhet, tilgangskontroll og operasjonell risiko.',
            gap_risk_area_privacy: 'Personvern',
            gap_risk_area_cybersecurity: 'Cybertrygging',
            gap_risk_area_access: 'Tilgangskontroll',
            gap_risk_area_operational: 'Operasjonell',
            gap_framework_filter_info: 'Filtrer hull etter regelverk (VN_DATA_LAW eller VN_AI_LAW_2026) for å se relevante hull for hvert regelverk.',
            framework_vn_data_law: 'VN Datalov',
            framework_vn_ai_law: 'VN AI-lov 2026',
            enterprise_map_approved_info: 'Dette datakartet viser bare godkjente klassifiseringsposter per UC-VN-10 arbeidsflyttrinn 10 ("Godkjente etiketter blir gjeldende virksomhetssannhet"). Utkast og foreslåtte poster er ekskludert.',
            exports_bundle_info: 'Eksportpakker inkluderer: klassifiseringsregister, håndteringsregler, eierskap/RACI og bevispakke � samsvarende med UC-VN-10 eksportkrav og DATA-EVD-01 dokumentformat.',
        },
    },
    monitoring: {
        no_permission_title: 'Utilstrekkelege tillatingar',
        no_permission_message: 'Du har ikkje tilgang til denne overvakingsmodulen.',
        errors: {
            fetch: 'Kunne ikkje laste.',
            save: 'Kunne ikkje lagre.',
            fetch_programs_failed: 'Kunne ikkje hente program.',
            fetch_kpi_failed: 'Kunne ikkje hente KPI-data.',
            create_snapshot_failed: 'Kunne ikkje opprette augeblikksbilete.',
            fetch_periods_failed: 'Kunne ikkje hente periodar.',
            create_period_failed: 'Kunne ikkje opprette periode.',
            auto_generate_failed: 'Kunne ikkje autogenerere periodar.',
            start_period_failed: 'Kunne ikkje starte periode.',
            close_period_failed: 'Kunne ikkje lukke periode.',
            save_program_failed: 'Kunne ikkje lagre program.',
            activate_program_failed: 'Kunne ikkje aktivere program.',
            pause_program_failed: 'Kunne ikkje pause program.',
            complete_program_failed: 'Kunne ikkje fullføre program.',
            archive_program_failed: 'Kunne ikkje arkivere program.',
            fetch_ric_templates_failed: 'Kunne ikkje hente RIC-malar.',
            fetch_ric_cases_failed: 'Kunne ikkje hente RIC-saker.',
            create_ric_case_failed: 'Kunne ikkje opprette RIC-sak.',
            transition_ric_failed: 'Kunne ikkje overføre RIC-sak.',
            add_follow_up_failed: 'Kunne ikkje leggje til oppfølging.',
            respond_follow_up_failed: 'Kunne ikkje svare på oppfølging.',
            link_evidence_failed: 'Kunne ikkje kople bevis.',
            fetch_task_templates_failed: 'Kunne ikkje hente oppgåvemalar.',
            save_task_template_failed: 'Kunne ikkje lagre oppgåvemal.',
            delete_task_template_failed: 'Kunne ikkje slette oppgåvemal.',
            delete_framework_link_failed: 'Kunne ikkje slette rammeverkskopling.',
            seed_defaults_failed: 'Kunne ikkje initialisere standardverdiar.',
            fetch_tasks_failed: 'Kunne ikkje hente oppgåver.',
            create_task_failed: 'Kunne ikkje opprette oppgåve.',
            instantiate_tasks_failed: 'Kunne ikkje instansiere oppgåver.',
            start_task_failed: 'Kunne ikkje starte oppgåve.',
            complete_task_failed: 'Kunne ikkje fullføre oppgåve.',
            defer_task_failed: 'Kunne ikkje utsetje oppgåve.',
            block_task_failed: 'Kunne ikkje blokkere oppgåve.',
            override_complete_failed: 'Kunne ikkje overstyre fullføring.',
            assign_task_failed: 'Kunne ikkje tildele oppgåve.',
            update_checklist_failed: 'Kunne ikkje oppdatere sjekkliste.',
        },
        nav: {
            programs: 'Program',
            periods: 'Periodar',
            task_templates: 'Oppgåvemalar',
            tasks: 'Oppgåver',
            kpi: 'KPI-kontrollpanel',
            ric: 'Tilsynsførespurnader',
            framework_link: 'Rammeverkovervaking',
            authority_readiness: 'Myndigheitsberedskap',
            change_review: 'Endringsgjennomgang',
            raci: 'RACI-matrise',
        },
        programs: {
            page_title: 'Overvakingsprogram',
            title: 'Overvakingsprogram',
            new: 'Nytt program',
            edit: 'Rediger program',
            name: 'Namn',
            scope: 'Omfang',
            frequency: 'Frekvens',
            owner: 'Eigar',
            activate: 'Aktiver',
            pause: 'Sett på pause',
            resume: 'Hald fram',
            complete: 'Fullfør',
            archive: 'Arkiver',
            custom_frequency_days: 'Brukardefineret frekvens (dagar)',
            select_user: 'Vel brukar⬦',
            assign_training: 'Tildel opplæring',
            linked_forms: 'Tilknytte skjema',
            linked_forms_none: 'Ingen tilknytte skjema enno',
            loaded_count: 'Lasta {0} program',
            scope_labels: {
                full: 'Full',
                partial: 'Delvis',
                targeted: 'Målretta',
                consent: 'Samtykke',
                dpia: 'DPIA',
                vendors: 'Leverandørar',
                classification: 'Klassifisering',
                rights_requests: 'Rettighetsførespurnader',
                data_mapping: 'Datakartlegging',
                transfers: 'Overføringar',
                security_monitoring: 'Sikkerhetsovervåking',
                authority_response: 'Myndighetssvar',
                evidence_preservation: 'Bevaring av bevis',
                localization_review: 'Lokaliseringsgjennomgang',
                ai_system_registration: '[[TOK_0]] Systemregistrering',
                ai_pre_deployment: '[[TOK_0]] vurdering før distribusjon',
                ai_transparency: '[[TOK_0]] �&penhetssjekk',
                ai_incident_review: '[[TOK_0]] Gjennomgang av hendelsen',
            },
            framework_cadence_info: 'Cybersecurity Law programs typically use continuous/monthly/quarterly cadences. AI Law programs typically use annual review cadences.',
        },
        periods: {
            page_title: 'Overvakingsperiodar',
            title: 'Gjennomgangsperiodar',
            new: 'Ny periode',
            label: 'Periodeetikett',
            start_date: 'Startdato',
            end_date: 'Sluttdato',
            reviewers: 'Gjennomgåarar',
            auto_generate: 'Autogenerer periodar',
            start: 'Start',
            close: 'Lukk',
            change_digest: 'Endringssamandrag',
            no_digest: 'Ingen samandrag tilgjengelege.',
            reviewers_count: 'Antal gjennomgåere',
            select_program: 'Vel Program',
            select_program_prompt: 'Vel et program for at se perioder.',
            hide_digest: 'Gøym samandrag',
            loaded_count: 'Lasta {0} periodar',
            periods_auto_generated: 'Periodar autogenererte',
            label_placeholder: 't.d. 2026-K1',
        },
        task_templates: {
            page_title: 'Oppgåvemalar',
            title: 'Oppgåvemalar',
            new: 'Ny mal',
            edit: 'Rediger mal',
            category: 'Kategori',
            priority: 'Prioritet',
            checklist_items: 'Sjekkliste-element',
            effort: 'Estimert arbeidsmengd (timar)',
            pre_seeded: 'Førehandsoppsett',
            seed_defaults: 'Sett standardverdiar',
            add_checklist: 'Legg til sjekkliste-element',
            guidance: 'Rettleiingsmerknadar',
            all_categories: 'Alle Kategoriar',
            loaded_count: 'Lasta {0} oppgåvemalar',
            defaults_seeded: 'Standardoppgåvemalar oppretta',
            checklist_item_label: 'Sjekklistepunkt {0}',
            remove_checklist_item: 'Fjern sjekklistepunkt {0}',
            category_info: 'Categories cover PDPL compliance, Cybersecurity Law tasks, and AI Law tasks.',
        },
        tasks: {
            page_title: 'Gjennomgangsoppgåver',
            title: 'Gjennomgangsoppgåver',
            new: 'Ny oppgåve',
            assigned_to: 'Tildelt til',
            due_date: 'Frist',
            checklist: 'Sjekkliste',
            start: 'Start',
            complete: 'Fullfør',
            defer: 'Utset',
            block: 'Blokker',
            override_complete: 'Overstyr fullføring',
            link_evidence: 'Knyt dokumentasjon',
            direct_upload_label: 'Last opp bevisfil',
            instantiate: 'Opprett frå malar',
            defer_reason: 'Grunn for utsetjing',
            override_justification: 'Grunngiving for overstyring',
            filter_assignee: 'Filtrer efter modtager',
            select_period: 'Vel Periode',
            select_program: 'Vel Program',
            select_program_period_prompt: 'Vel et program og en periode for at se oppgåver.',
            assign_placeholder: 'Tildel to...',
            loaded_count: 'Lasta {0} oppgåver',
            tasks_instantiated: 'Oppgåver oppretta frå malar',
            overdue: 'Forfallen',
            checklist_for: 'sjekkliste for',
            manage_checklist: 'Administrer sjekkliste',
            add_checklist_item: 'Legg til element',
            checklist_item_label: 'Element',
            checklist_item_description: 'Beskriving',
            remove_checklist_item: 'Fjern element',
            save_checklist: 'Lagre sjekkliste',
            no_checklist_items: 'Ingen sjekklisteelement enno.',
            confirm_delete_attachment: 'Er du sikker på at du vil slette denne bevisfilen? Dette kan ikke angres.',
        },
        kpi: {
            page_title: 'KPI-oversikt',
            title: 'KPI-kontrollpanel',
            kpi_name: 'KPI-namn',
            current_value: 'Gjeldande verdi',
            target: 'Mål',
            trends: 'Trendar',
            capture_snapshot: 'Fange Augeblikksbilete',
            select_program: 'Vel Program',
            select_program_prompt: 'Vel et program for at se KPI-er.',
            snapshot: 'Augeblikksbilete',
            kpi_labels: {
                on_track: 'På Spor',
                at_risk: 'Ved Risiko',
                behind: 'Bak',
                rights_request_sla_rate: 'SLA-frekvens for rettighetsførespurnader',
                vendor_review_currency: 'Leverandørgjennomgang aktualitet',
                dpia_completion_rate: 'DPIA-fullføringsgrad',
                classification_coverage: 'Klassifiseringsdekning',
                consent_policy_currency: 'Samtykkepolicy aktualitet',
                security_event_detection_rate: 'Deteksjonsfrekvens for sikkerhetshendelser',
                evidence_preservation_compliance_rate: 'Samsvarsgrad for bevisbevaring',
                authority_response_timeliness: 'Myndighetsrespons aktualitet',
                localization_readiness_score: 'Score for lokaliseringsberedskap',
                ai_register_completeness: '[[TOK_0]] Systemregisterets fullstendighet',
                pre_deployment_gate_pass_rate: 'Gatepasseringsrate før distribusjon',
                transparency_disclosure_coverage: 'Dekning for åpenhet',
                ai_incident_readiness_score: '[[TOK_0]] Hendelsesberedskapspoeng',
            },
            pdpl_kpi_info: 'The predefined KPI codes are PDPL-specific metrics. For Cybersecurity Law or AI Law monitoring, use framework-specific KPI codes.',
            cybersec_kpi_info: 'KPI-er for cybersikkerhetslovgivning: Deteksjonsfrekvens for sikkerhetshendelser, overholdelsesgrad for bevisoppbevaring, aktualitet for myndighetenes svar, poeng for lokaliseringsberedskap.',
            ai_law_kpi_info: '[[TOK_0]] Lov-KPIer: [[TOK_1]] Systemregisterets fullstendighet, gatepasseringsrate før utrulling, dekning for åpenhet, [[TOK_2]] Hendelsesberedskapspoeng.',
            no_data: 'Ingen data tilgjengelege.',
            snapshot_date: 'Augeblikksbilete Dato',
            loaded_count: 'Lasta {0} KPI-augeblikksbilete',
            snapshot_captured: 'KPI-augeblikksbilete teke',
            showing_chart: 'Viser diagramvising',
            showing_table: 'Viser datatabellvising',
            aria_current_values: 'KPI noverande verdiar',
            kpi_label: 'KPI',
            actual: 'Faktisk',
            trend: 'Trend',
            notes: 'Notat',
            trend_up: 'Stigande',
            trend_down: 'Synkande',
            trend_stable: 'Stabil',
        },
        ric: {
            page_title: 'RIC-saker',
            title: 'Tilsynsførespurnadsaker',
            new: 'Ny tilsynssak',
            reference: 'Referanse',
            regulator: 'Tilsynsmynde',
            inquiry_type: 'Førespurnadstype',
            deadline: 'Svarfrist',
            lead: 'Ansvarleg',
            follow_ups: 'Oppfølgingar',
            add_follow_up: 'Legg til oppfølging',
            respond: 'Svar',
            question: 'Spørsmål',
            response: 'Svar',
            asked_at: 'Spurt den',
            no_follow_ups: 'Ingen follow-ups enno.',
            received_date: 'Motteke dato',
            responded_at: 'Besvaret den',
            hide_follow_ups: 'Gøym Oppfølgingar',
            inquiry_types: {
                general: 'Generelt',
                investigation: 'Etterforsking',
                audit: 'Revisjon',
                complaint: 'Klage',
                general_audit: 'Generell revisjon',
                rights_requests_review: 'Gjennomgang av rettighetsførespurnader',
                cross_border_transfer_review: 'Gjennomgang av grenseoverskridande overføringar',
                vendor_governance_review: 'Gjennomgang av leverandørstyring',
                consent_management_review: 'Gjennomgang av samtykkehandtering',
                data_mapping_ropa_review: 'Gjennomgang av datakartlegging / ROPA',
                incident_readiness_review: 'Gjennomgang av hendingsberedskap',
                security_access_control_review: 'Gjennomgang av tryggleik og tilgangskontroll',
                targeted_processing_review: 'Gjennomgang av målretta handsaming',
                bank_readiness_pack: 'Bankberedskapspakke',
            },
            link_evidence: 'Kople Bevis',
            loaded_count: 'Lasta {0} RIC-saker',
            to_follow_up: 'til oppfølgingsspørsmål',
            overdue: 'Forfalt',
            overdue_indicator: 'Svarfristen er overskredet',
            template_info: 'RIC templates are internal platform templates. They are not official government-mandated forms.',
            status_labels: {
                received: 'Motteke',
                in_triage: 'Under triage',
                evidence_gathering: 'Bevisinnsamling',
                response_drafting: 'Svarutkast',
                internal_review: 'Intern gjennomgang',
                submitted: 'Innsend',
                follow_up: 'Oppfølging',
                closed: 'Stengt',
            },
        },
        framework_link: {
            title: 'Rammeverkkopla overvaking',
            link_program: 'Kople program til rammeverk',
            framework_code: 'Rammekode',
            select_framework: 'Vel eit rammeverk...',
            select_program: 'Vel eit program...',
            readiness_score: 'Beredskapspoeng',
            no_links: 'Ingen rammeverkkopla program funne',
            seed_defaults: 'Opprett standardmalar',
            program_id: 'Program-ID',
            program: 'Program',
        },
        authority_readiness: {
            title: 'Myndigheitsførespurnadsberedskap',
            create_entry: 'Ny beredskapsoppføring',
            select_framework: 'Vel eit rammeverk...',
            framework_code: 'Rammeverk',
            readiness_status: 'Beredskapsstatus',
            readiness_package: 'Beredskapspakke',
            run_drill: 'Køyr beredskapsøving',
            drill_success: 'Beredskapsøving registrert',
            last_drill: 'Siste øving',
            never_drilled: 'Aldri',
            no_readiness: 'Ingen myndigheitsberedskapsdata funne',
            entry_created: 'Beredskapsoppføring oppretta',
            ready: 'Klar',
            partial: 'Delvis',
            not_ready: 'Ikkje klar',
            items: 'element',
        },
        change_review: {
            title: 'Regulatorisk endringsgjennomgang',
            new_review: 'Ny endringsgjennomgang',
            change_id: 'Endrings-ID',
            select_change: 'Vel ei endring...',
            select_framework: 'Vel eit rammeverk...',
            impact_assessment: 'Konsekvensvurdering',
            decision: 'Avgjerd',
            no_action: 'Inga handling',
            internal_update: 'Intern oppdatering',
            authority_filing: 'Myndigheitsinnlevering',
            no_reviews: 'Ingen endringsgjennomgangar funne',
            auto_cycle: 'Automatisk gjennomgangssyklus',
            cadence: 'Gjennomgangsfrekvens',
            framework: 'Rammeverk',
        },
        export_csv: 'Eksporter [[TOK_0]]',
        exporting: 'Eksporterer ⬦',
        export_success: '[[TOK_0]] ble eksportert.',
        export_failed: '[[TOK_0]] eksport mislyktes.',
        export_attestation_pack: 'Eksporter attestasjonspakke',
        staleness: {
            badge_label: '[[TOK_1]] foreldede varer',
            days_since: '[[TOK_1]] dager siden siste oppdatering',
            detail_title: 'Foreldede gjenstander',
            accept_justification: 'Godta med begrunnelse',
            justification_label: 'Begrunnelse',
            no_stale: 'Ingen foreldede varer funnet.',
            threshold_label: 'Staleness-terskel (dager)',
            threshold_min: 'Minimum 30 dager',
            threshold_max: 'Maksimalt 730 dager',
            threshold_saved: 'Staleness-terskel oppdatert.',
        },
        csv_columns: {
            name: 'Navn',
            status: 'Status',
            owner: 'Eier',
            created_at: 'Opprettet kl',
            updated_at: 'Oppdatert kl',
            scope: 'Omfang',
            frameworks: 'Rammer',
            period_label: 'Periodemerke',
            start_date: 'Startdato',
            end_date: 'Sluttdato',
            task_count: 'Oppgavetelling',
            completion_rate: 'Gjennomføringsgrad',
            title: 'Tittel',
            assigned_to: 'Tildelt til',
            due_date: 'Forfallsdato',
            priority: 'Prioritet',
            completed_at: 'Fullført kl',
            kpi_code: '[[TOK_0]] Kode',
            kpi_label: '[[TOK_0]] Etikett',
            target: 'Mål',
            actual: 'Faktisk',
            trend: 'Trend',
            reference: 'Referanse',
            regulator: 'Regulator',
            inquiry_type: 'Forespørselstype',
            lead: 'Bly',
            received_date: 'Mottatt dato',
            deadline: 'Frist',
            framework_code: 'Rammekode',
            readiness_status: 'Beredskapsstatus',
            package_count: 'Antall pakker',
            change_id: 'Endre ID',
            impact_assessment: 'Konsekvensutredning',
            decision: 'Beslutning',
            program: 'Program',
            readiness_score: 'Beredskapsscore',
            category: 'Kategori',
            checklist_count: 'Antall sjekklister',
            effort_hours: 'Innsats (timer)',
            version: 'Versjon',
            department: 'Avdeling',
            function_area: 'Funksjonsområde',
            role: 'Rolle',
            assignee: 'Oppdragstaker',
            frequency: 'Frekvens',
        },
        raci: {
            page_title: 'Styring RACI Matrix',
            title: 'Styring RACI Matrix',
            department: 'Avdeling',
            function_area: 'Funksjonsområde',
            responsible: 'Ansvarlig',
            accountable: 'Ansvarlig',
            consulted: 'Konsultert',
            informed: 'Informert',
            assign_role: 'Tildel RACI-rolle',
            select_program: 'Velg Program',
            select_program_prompt: 'Velg et program for å vise RACI-matrise.',
            no_assignments: 'Ingen RACI-oppdrag funnet.',
            role_updated: 'RACI-oppgaven er oppdatert.',
            role_labels: {
                R: 'Ansvarlig',
                A: 'Ansvarlig',
                C: 'Konsultert',
                I: 'Informert',
            },
            loaded_count: 'Lastet inn [[TOK_1]] RACI-oppdrag',
            single_accountability_warning: 'Bare én ansvarlig (A) rolle er tillatt per funksjonsområde. �& tildele en ny ansvarlig rolle vil erstatte den eksisterende.',
            cybersec_function_areas: 'Funksjonsområder for cybersikkerhetslov: Hendelsesrespons, bevisbevaring, myndighetssamarbeid, lokaliseringsgjennomgang.',
            ai_law_function_areas: '[[TOK_0]] Juss funksjonsområder: Systemregistrering, Pre-Deployment Assessment, Transparency, Incident Handling.',
            suggested_function_areas: 'Foreslåtte funksjonsområder',
        },
        prior_cycle: {
            link_label: 'Link til forrige syklus',
            select_prior: 'Velg forrige syklus...',
            linked: '�&r over år',
            no_prior: 'Ingen tidligere sykluser tilgjengelig.',
            linked_success: 'Tidligere syklus koblet.',
        },
        digest_table: {
            module: 'Modul',
            entity_type: 'Enhetstype',
            change_type: 'Endre type',
            description: 'Beskrivelse',
            changed_at: 'Endret kl',
        },
        view_related_ric: 'Se relaterte RIC-saker',
        linked_program: 'Koblet program',
        nav_raci: 'RACI-matrise',
    },
    incidents: {
        authority_response_draft: {
            draft_label: 'Utkast til svar',
            drafting: 'Utkaster ⬦',
            results_heading: 'Utkast til svar ([[TOK_1]])',
            tokens_label: '�0� [[TOK_1]] tokens',
            counsel_label: 'Rådgivergjennomgang kreves:',
            counsel_default: 'Minst ett svar krever advokatgjennomgang før sending.',
            requires_counsel_label: 'Krever advokatgjennomgang.',
            accept_label: 'Godta utkast',
            reject_label: 'Avvis utkast',
            error_generic: 'Kunne ikke skrive utkast til svaret. Prøv igjen eller avgrens forespørselsteksten.',
        },
        breach_timeline: {
            compute_label: 'Tidslinje for varsel om databrudd',
            computing: 'Databehandling ⬦',
            results_heading: 'Brudd varslingsfrister ([[TOK_1]])',
            tokens_label: '�0� [[TOK_1]] tokens',
            handoff_label: 'Forseti foreslår:',
            empty_label: 'Ingen gjeldende rammer for de berørte jurisdiksjonene.',
            mandatory_label: 'Obligatoriske felter:',
            draft_label: 'Varslingsutkast',
            remaining_label: '[[TOK_1]]t igjen',
            overdue_label: 'FORSIDEN innen',
            acknowledge_label: 'Bekreft - oppgaver opprettet eksternt',
            acknowledging: 'Erkjenner ⬦',
            error_generic: 'Kunne ikke beregne tidslinjen for brudd. Prøv igjen.',
        },
        breach_determination: {
            confirmed_breach: 'Stadfesta Brot',
            suspected_breach: 'Mistenkt Brot',
            not_a_breach: 'Ikkje ein Brot',
            pending: 'Ventande',
        },
        errors: {
            fetch: 'Kunne ikkje laste hendingar.',
            save: 'Kunne ikkje lagre hending.',
            fetch_failed: 'Kunne ikkje hente hendingar.',
            save_failed: 'Kunne ikkje lagre hending.',
            transition_failed: 'Kunne ikkje overføre hending.',
            close_failed: 'Kunne ikkje lukke hending.',
            fetch_timeline_failed: 'Kunne ikkje hente tidslinje.',
            fetch_decisions_failed: 'Kunne ikkje hente avgjerder.',
            triage_failed: 'Kunne ikkje oppdatere triage.',
            impact_update_failed: 'Kunne ikkje oppdatere konsekvensvurdering.',
            breach_update_failed: 'Kunne ikkje oppdatere brotvurdering.',
            create_timeline_failed: 'Kunne ikkje opprette tidslinjeoppføring.',
            create_decision_failed: 'Kunne ikkje opprette avgjerd.',
            notification_update_failed: 'Kunne ikkje oppdatere varsling.',
            fetch_tasks_failed: 'Kunne ikkje hente oppgåver.',
            create_task_failed: 'Kunne ikkje opprette oppgåve.',
            update_task_status_failed: 'Kunne ikkje oppdatere oppgåvestatus.',
            update_checklist_failed: 'Kunne ikkje oppdatere sjekkliste.',
            assign_task_failed: 'Kunne ikkje tildele oppgåve.',
            escalate_task_failed: 'Kunne ikkje eskalere oppgåve.',
            fetch_templates_failed: 'Kunne ikkje hente malar.',
            permission_denied: 'Du har ikkje tilgang til denne seksjonen. Kontakt administratoren din for a be om tilgang.',
        },
        harm_likelihood: {
            unlikely: 'Usannsynleg',
            possible: 'Mogleg',
            likely: 'Sannsynleg',
            very_likely: 'Svært sannsynleg',
        },
        reported_via: {
            email: 'E-post',
            phone: 'Telefon',
            internal_system: 'Intern System',
            third_party: 'Tredje Part',
            automated_detection: 'Automatisert Deteksjon',
        },
        task_transition_labels: {
            start: 'Start',
            complete: 'Fullfør',
            block: 'Blokker',
            defer: 'Utset',
        },
        transition_labels: {
            start: 'Start',
            complete: 'Fullfør',
            block: 'Blokker',
            defer: 'Utset',
        },
        nav: {
            all: 'Alle hendingar',
            tasks: 'Responsoppgåver',
            reports: 'Rapportar',
            breach_notifications: 'Brotvarslar',
            supplements: 'Tillegg',
            remediation: 'Utbetring',
            authority_requests: 'Styresmaktførespurnader',
            disclosure_register: 'Offentleggjeringsregister',
        },
        list: {
            page_title: 'Hendelser',
            title: 'Hendingar',
            new: 'Ny hending',
            edit: 'Rediger hending',
            incident_title: 'Tittel',
            severity: 'Alvorsgrad',
            reported_at: 'Rapportert',
            reported_by: 'Rapportert av',
            assigned_to: 'Tildelt til',
            view_detail: 'Vis detaljar',
            reference: 'Referanse',
            lead: 'Leiar',
            reported_via: 'Rapportert Via',
            discovery_date: 'Oppdaging Dato',
            hide_details: 'Gøym detaljar',
            close_incident: 'Lukk Hending',
            close_justification_prompt: 'Oppgje ver venleg en grunngiving for at lukke denne hending.',
            justification: 'Grunngiving',
            lead_id: 'Leiar ID',
            contact: 'Kontakt',
            category: 'Kategori',
            not_assessed: 'Ikkje vurdert',
        },
        detail: {
            page_title: 'Hendelsesdetaljer',
            title: 'Hendingsdetaljar',
            tabs: {
                overview: 'Oversikt',
                triage: 'Triagering',
                impact: 'Konsekvensvurdering',
                breach: 'Brotvurdering',
                timeline: 'Tidslinje',
                decisions: 'Avgjersler',
                evidence: 'Bevis',
                audit_trail: 'Revisjonssti',
            },
            evidence_upload_label: 'Legg ved bevisfil',
            evidence_uploaded: 'Bevis lasta opp',
            evidence_deleted: 'Bevis sletta',
            evidence_delete_error: 'Kunne ikkje slette beviset',
            evidence_uploaded_at: 'Lasta opp',
            evidence_empty: 'Ingen bevisfiler lagt ved denne hendinga.',
            evidence_size: 'Storleik',
            triage_notes: 'Triagemerknadar',
            initial_classification: 'Innleiande klassifisering',
            individuals_affected: 'Antal personar råka',
            data_categories: 'Datakategoriar involverte',
            systems_compromised: 'Kompromitterte system',
            geographic_scope: 'Geografisk omfang',
            breach_determination: 'Brotavgjersle',
            notification_required: 'Varsling påkravd',
            notification_deadline: 'Varslingsfrist',
            pdpc_reportable: 'Rapporteringspliktig til PDPC',
            add_timeline: 'Legg til tidslinjeoppføring',
            add_decision: 'Legg til avgjersle',
            not_found: 'Hending ikke fundet.',
            team_members: 'Team Medlemer',
            checklist: 'Sjekkliste',
            completed: 'Fullført',
            impact_severity_score: 'Utrekna alvorlegheitsscore for konsekvensar',
            records_affected: 'Postar Råka',
            potential_consequences: 'Potensielle Konsekvensar',
            harm_likelihood: 'Skade Sannsyn',
            legal_basis: 'Rettsleg grunnlag',
            jurisdictions: 'Jurisdiksjonar',
            jurisdictions_comma: 'Jurisdiksjonar (kommaseparert)',
            jurisdiction: 'Jurisdiksjon',
            authority_status: 'Myndigheit Status',
            subject_status: 'Emne Status',
            authority_deadline: 'Myndigheit Frist',
            subject_deadline: 'Emne Frist',
            mark_authority_done: 'Marker myndighed færdig',
            mark_subject_done: 'Marker emne færdig',
            not_assessed: 'Ikkje vurdert',
            event_type: 'Hending Type',
            timestamp: 'Tidsstempel',
            actor: 'Aktør',
            no_timeline_events: 'Ingen tidslinje hendingar enno.',
            decision_type: 'Avgjerd Type',
            decision: 'Avgjerd',
            rationale: 'Grunngiving',
            decision_made: 'Avgjerd teken',
            no_decisions: 'Ingen decisions recorded enno.',
            jurisdictions_comma_separated: 'VN, SG, EU',
            no_audit_events: 'Ingen revisjonshendelser registrert ennå.',
            export_pdf: 'Eksporter PDF',
            pdf_title: 'Hendingssamandrag',
            description: 'Skildring',
            linked_records: 'Tilknytte Postar',
        },
        tasks: {
            page_title: 'Hendelsesresponsoppgaver',
            title: 'Hendingsresponsoppgåver',
            new: 'Ny oppgåve',
            edit: 'Rediger oppgåve',
            task_type: 'Oppgåvetype',
            assignee: 'Ansvarleg',
            due_date: 'Frist',
            dependencies: 'Avhengnadar',
            mark_complete: 'Merk som fullført',
            templates: 'Oppgåvemalar',
            select_incident: 'Vel hending',
            all_statuses: 'Alle statusar',
            all_categories: 'Alle kategoriar',
            new_response_task: 'Ny responsoppgåve',
            category: 'Kategori',
            priority: 'Prioritet',
            depends_on: 'Avheng av (kommaseparerte oppgåve-ID-ar)',
            checklist_items: 'Sjekkliste-element',
            remove: 'Fjern',
            add: 'Legg til',
            new_checklist_item: 'Nytt sjekkliste-element',
            no_templates: 'Ingen malar tilgjengelege.',
            assign_task: 'Tildel oppgåve',
            assign_to: 'Tildel til',
            assign: 'Tildel',
            select_incident_prompt: 'Vel ei hending for å sjå responsoppgåvene.',
            checklist: 'Sjekkliste',
            hide_checklist: 'Gøym sjekkliste',
            escalate: 'Eskaler',
            escalations: 'Eskaleringar',
            no_checklist_items: 'Ingen sjekkliste-element.',
        },
        reports: {
            page_title: 'Hendelsesrapporter',
            title: 'Hendingsrapportar',
            summary: 'Samandragsstatistikk',
            by_severity: 'Etter alvorsgrad',
            by_status: 'Etter status',
            recent: 'Nylegaste hendingar',
            total_incidents: 'Totalt antal hendingar',
            open: 'Opne',
            closed: 'Lukka',
            export_csv: 'Eksporter CSV',
            export_pdf: 'Eksporter PDF',
            export_success: 'Rapport eksportert.',
            export_error: 'Kunne ikkje eksportere rapport.',
            reference: 'Referanse',
            view_report: 'Vis rapport',
        },
        statuses: {
            reported: 'Rapportert',
            triage: 'Triagering',
            contained: 'Avgrensa',
            investigation: 'Etterforsking',
            remediation: 'Utbetring',
            closed: 'Lukka',
            false_positive: 'Falsk positiv',
        },
        task_statuses: {
            pending: 'Ventande',
            in_progress: 'Under arbeid',
            completed: 'Fullført',
            blocked: 'Blokkert',
            cancelled: 'Avlyst',
        },
        severity: {
            low: 'Låg',
            medium: 'Middels',
            high: 'Høg',
            critical: 'Kritisk',
        },
        task_types: {
            containment: 'Avgrensing',
            investigation: 'Etterforsking',
            remediation: 'Utbetring',
            communication: 'Kommunikasjon',
            documentation: 'Dokumentasjon',
            notification: 'Varsling',
        },
        categories: {
            data_breach: 'Data Brot',
            unauthorized_access: 'Uautorisert Tilgang',
            data_loss: 'Data Tap',
            system_compromise: 'System Kompromittering',
            malware: 'Skadeprogram',
            phishing: 'Nettsvindel',
            insider_threat: 'Innsidetrussel',
            other: 'Anna',
        },
        reported_via_options: {
            email: 'E-post',
            phone: 'Telefon',
            internal_system: 'Intern System',
            third_party: 'Tredje Part',
            automated_detection: 'Automatisert Deteksjon',
        },
        harm_likelihood_options: {
            unlikely: 'Usannsynleg',
            possible: 'Mogleg',
            likely: 'Sannsynleg',
            very_likely: 'Svært sannsynleg',
        },
        breach_determination_options: {
            confirmed_breach: 'Stadfesta Brot',
            suspected_breach: 'Mistenkt Brot',
            not_a_breach: 'Ikkje ein Brot',
            pending: 'Ventande',
        },
        timeline_event_types: {
            detection: 'Deteksjon',
            escalation: 'Eskalering',
            containment: 'Avgrensing',
            investigation_start: 'Etterforsking Start',
            evidence_collected: 'Bevis Innsamla',
            notification_sent: 'Varsling Sendt',
            remediation_action: 'Utbetring Handling',
            status_change: 'Status Endrings',
            communication: 'Kommunikasjon',
            other: 'Anna',
        },
        decision_types: {
            containment: 'Avgrensing',
            notification: 'Varsling',
            remediation: 'Utbetring',
            escalation: 'Eskalering',
            closure: 'Lukking',
            other: 'Anna',
        },
        task_transitions: {
            start: 'Start',
            complete: 'Fullfør',
            block: 'Blokker',
            cancel: 'Avbryt',
            unblock: 'Opphev blokkering',
        },
        announce: {
            loaded: '[[TOK_1]] hendelser lastet inn',
            reports_loaded: '[[TOK_1]] hendelsesrapporter er lastet inn',
            tasks_loaded: '[[TOK_1]] oppgaver lastet',
            created: 'Hendelsen ble opprettet',
            updated: 'Hendelsen ble oppdatert',
            closed: 'Hendelsen ble avsluttet',
            status_changed: 'Hendelsesstatus endret',
            triage_completed: 'Triage fullført',
            impact_updated: 'Konsekvensutredning oppdatert',
            breach_updated: 'Bruddvurdering oppdatert',
            timeline_added: 'Tidslinjehendelse lagt til',
            decision_recorded: 'Beslutning registrert',
            notification_updated: 'Varslingsstatus oppdatert',
            task_created: 'Oppgave opprettet',
            task_status_changed: 'Oppgavestatus endret',
            checklist_completed: 'Sjekklisteelementet fullført',
            checklist_unchecked: 'Sjekklisteelementet er avmerket',
            task_assigned: 'Oppgaven ble tildelt',
            task_escalated: 'Oppgaven eskalerte',
            export_initiated: 'Eksporten startet',
        },
        breach_notifications: {
            page_title: 'Bruddvarsler',
            title: 'Bruddvarsler',
            new_notification: 'Ny melding',
            no_notifications: 'Ingen bruddvarsler funnet',
            status: 'Status',
            submit_to_mps: 'Send til [[TOK_0]]',
            decision: 'Beslutning',
            decision_maker: 'Beslutningstaker',
            notify: 'Varsle',
            do_not_notify: 'Ikke gi beskjed',
            rationale: 'Begrunnelse',
            filing_deadline: 'Innleveringsfrist',
            overdue: 'Forfallen',
            due_soon: 'Snart forfallen',
            on_track: 'På rett spor',
            legal_review: 'Juridisk gjennomgang',
            incident_id: 'Hendelses-ID',
            notification_statuses: {
                assessment: 'Vurdering',
                decision_to_notify: 'Beslutning om å varsle',
                notification_drafted: 'Melding er utarbeidet',
                legal_review: 'Juridisk gjennomgang',
                submitted_to_mps: 'Sendt til [[TOK_0]]',
                supplement_requested: 'Tillegg forespurt',
                supplement_submitted: 'Tillegg innsendt',
                acknowledged: 'Erkjent',
                closed: 'Stengt',
            },
        },
        supplements: {
            page_title: 'Tilleggsforespørsler',
            title: 'Tilleggsforespørsler',
            new_supplement: 'Nytt tillegg',
            no_supplements: 'Fant ingen tilleggsforespørsler',
            request_details: 'Be om detaljer',
            response_package: 'Svarpakke',
            submit_response: 'Send inn svar',
            deadline: 'Frist',
            notification_id: 'Varslings-ID',
            enter_notification_id: 'Skriv inn en varslings-ID for å se tillegg.',
            supplement_statuses: {
                requested: 'Forespurt',
                drafting: 'Utkast',
                submitted: 'Sendt inn',
                accepted: 'Godtatt',
                rejected: 'Avvist',
            },
        },
        remediation: {
            page_title: 'Utbedringstiltak',
            title: 'Utbedringstiltak',
            new_action: 'Ny handling',
            no_actions: 'Fant ingen utbedringshandlinger',
            description: 'Skildring',
            owner: 'Eier',
            department: 'Avdeling',
            deadline: 'Frist',
            statuses: {
                planned: 'Planlagt',
                in_progress: 'Pågår',
                completed: 'Fullført',
                verified: 'Verifisert',
            },
            verify: 'Bekreft',
            incident_id: 'Hendelses-ID',
            enter_incident_id: 'Angi en hendelses-ID for å se utbedringshandlinger.',
            start: 'Start',
            complete_action: 'Fullfør',
        },
        authority_requests: {
            page_title: 'Myndighetsforespørsler',
            title: 'Myndighetsforespørsler',
            new_request: 'Ny forespørsel',
            no_requests: 'Ingen myndighetsforespørsler funnet',
            authority_name: 'Autoritetsnavn',
            request_details: 'Be om detaljer',
            response_package: 'Svarpakke',
            submission_channel: 'Sendingskanal',
            submit_response: 'Send inn svar',
            deadline: 'Frist',
            confirmation: 'Bekreftelse',
            incident_id_optional: 'Hendelses-ID (valgfritt)',
            response_context_label: 'Svarkontekst (for materialisering av innsendingsdokument)',
            response_context_none: '(hopp over materialisering)',
            response_context_supplement: 'Supplerande svar',
            response_context_information: 'Svar på informasjonsførespurnad',
            response_context_inspection: 'Svar på tilsyn',
            materialisation_status_column: 'Innsendingsdokument',
            materialisation_pending: 'Ventar',
            materialisation_success: 'Materialisert',
            materialisation_failed: 'Feila',
            materialisation_retry_button: 'Prøv på nytt',
            ar_statuses: {
                received: 'Mottatt',
                verified: 'Verifisert',
                assembling: 'Montering',
                submitted: 'Innsendt',
                closed: 'Lukka',
            },
        },
        disclosure_register: {
            page_title: 'Opplysningsregister',
            title: 'Opplysningsregister',
            new_entry: 'Ny oppføring',
            no_entries: 'Ingen oppføringer i opplysningsregisteret ble funnet',
            disclosure_type: 'Avsløringstype',
            disclosure_date: 'Offentliggjøringsdato',
            recipient: 'Mottaker',
            authority_name: 'Autoritetsnavn',
            channel: 'Kanal',
            content_summary: 'Innholdssammendrag',
            incident_id_optional: 'Hendelses-ID (valgfritt)',
        },
    },
    onboarding: {
        nav: {
            wizard: 'Oppsettrettleiar',
            tours: 'Modulomvisingar',
            sample_data: 'Eksempeldata',
        },
        wizard: {
            title: 'Oppsettrettleiar',
            welcome: 'Velkomen til AesirX ComplianceOne',
            welcome_message: 'Lat oss setje opp organisasjonen din. Denne rettleiaren vil guide deg gjennom den fyrste konfigurasjonen.',
            setup_complete: 'Oppsett fullført',
            skipped_message: 'Oppsettrettleiaren vart hoppa over. Du kan køyre han når som helst for å konfigurere organisasjonen din.',
            start_setup: 'Start oppsett',
            skip_wizard: 'Hopp over rettleiaren',
            go_to_admin: 'Gå til Admin',
            skip_for_now: 'Hopp over for no',
            next_step: 'Neste steg',
            previous_step: 'Førre steg',
            finish_setup: 'Fullfør oppsett',
            rerun: 'Køyr oppsettrettleiaren på nytt',
            step_label: 'Steg {number}',
            validation_org_name_required: 'Organisasjonsnamn er påkravd.',
            validation_admin_email_required: 'Admin-e-post er påkravd.',
            validation_admin_email_invalid: 'Ver venleg og oppgi ei gyldig e-postadresse.',
            validation_cmp_endpoint_required: 'CMP-endepunkt er påkravd når CMP er aktivert.',
            steps: {
                license_activation: 'Lisensaktivering',
                org_profile: 'Organisasjonsprofil',
                module_selection: 'Modulval',
                cmp_integration: 'CMP-integrasjon',
                notification_preferences: 'Varsel',
                review: 'Gjennomgang og stadfesting',
            },
            step_descriptions: {
                license_activation: 'Skriv inn lisensnøkkelen din for å aktivere pakken din og finne ut hvilke moduler som er tilgjengelige.',
                org_profile: 'Konfigurer organisasjonsnamn, jurisdiksjon, bransje, storleik og føretrekt språk.',
                module_selection: 'Vel kva samsvarsmodular som skal aktiverast for organisasjonen din.',
                cmp_integration: 'Konfigurer integrasjon med Consent Management Platform (valfritt).',
                notification_preferences: 'Konfigurer korleis du tek imot varsel om samsvarshendingar.',
                review: 'Gå gjennom konfigurasjonen din og fullfør oppsettet.',
            },
            license_step: {
                validate_button: 'Bekreft lisens',
                skip_warning: 'Modultilgang vil være begrenset til standard pakkenivå. Du kan aktivere en lisens senere i Plattform > Lisensinnstillinger.',
            },
            module_descriptions: {
                rights_requests: 'Handter førespurnader om tilgang til og sletting av persondata.',
                data_mapping: 'Kartlegg system, dataflyt og behandlingsaktivitetar.',
                governance: 'Administrer leverandørsamsvar og slettingsprosedyrar.',
                consent: 'Administrer samtykkepolitikkar og føremålskatalogar.',
                consent_properties: 'Administrer samtykke på tvers av digitale eigedommar.',
                assessments: 'Gjennomfør konsekvensvurderingar og grensekryssande dataoverføringar.',
                classification: 'Klassifiser og merk dataaktiva med livssyklussporing.',
                monitoring: 'Planlagde samsvarsgjennomgangar og KPI-sporing.',
                incidents: 'Rapporter og handter tryggings- og personvernhendingar.',
                connectors: 'Kople til eksterne system for automatisert datautveksling.',
                vendor_risk: 'Poengset leverandørar, spor kontraktar og administrer due diligence.',
                deletion_orchestration: 'Koordiner datasletting på tvers av system og leverandørar.',
                discovery: 'Oppdag og klassifiser data på tvers av infrastrukturen din.',
                incident_ops: 'Avanserte hendingsplanar, SLA-sporing og eskaleringar.',
                program_governance: 'Mognadsvurderingar, leiingsrapportering og revisjonsberedskap.',
                access_accountability: 'Overvak brukartilgang, sesjonar og grunngivingsarbeidsflyter.',
                localization: 'Marknadsspesifikke samsvarspakkar og regulatoriske rammeverk.',
                partner_workspace: 'Partner- og forhandlararbeidsområde.',
                privacy_scanner: 'Sanntids personvernovervaking av digitale eigedommar.',
                onboarding: 'Oppsettsrettleiar, guidede turar og administrasjon av eksempeldata.',
                compliance_forms: 'Interaktive samsvarsmalar og dokumentgenerering.',
                audit_trail: 'Omfattande uforanderleg revisjonslogging og oppbevaring.',
                organizations: 'Multiorganisasjons- og gruppeadministrasjon.',
                task_management: 'Samla oppgåveplanlegging, arbeidsflytmotor og kalendervisningar.',
            },
            module_categories: {
                data_privacy_rights: 'Datavern og rettigheter',
                vendor_third_party: 'Leverandør- og tredjepartsledelse',
                risk_assessment: 'Risiko og vurdering',
                operations_automation: 'Drift og automatisering',
                platform_admin: 'Plattform og administrasjon',
            },
            package_tier_label: 'Di Pakke',
            package_module_unavailable: 'Ikkje inkludert i pakka di',
            select_all: 'Vel alle',
            deselect_all: 'Opphev alle',
            load_sample_data: 'Last inn eksempeldata etter oppsett',
            load_sample_data_description: 'Installer realistiske demodata (Lotus Financial Services) for å utforska plattforma. Kan fjernast seinare frå Onboarding > Eksempeldata.',
            language_label: 'Føretrekt Språk',
            language_description: 'Vel standardspråket for organisasjonen din.',
            admin_account_title: 'Administratorkonto',
            admin_account_created: 'Administratorkonto oppretta',
            admin_full_name: 'Fullt namn',
            admin_email: 'E-postadresse',
            admin_password: 'Passord',
            admin_confirm_password: 'Stadfest passord',
            admin_show_password: 'Vis passord',
            admin_hide_password: 'Gøym passord',
            admin_name_placeholder: 'f.eks. Jane Smith',
            admin_email_placeholder: 'admin@example.com',
            admin_password_placeholder: 'Minimum 8 teikn',
            admin_password_confirm_placeholder: 'Skriv inn passord på nytt',
            validation_admin_name_required: 'Administratornamn er påkravd',
            validation_admin_password_required: 'Passord er påkravd',
            validation_admin_password_min_length: 'Passordet må vere minst 8 teikn',
            validation_passwords_mismatch: 'Passorda samsvarar ikkje',
            notification_email_enabled: 'Aktiver E-postvarsel',
            notification_email_description: 'Motta e-postvarsel om oppgåvetildeling, SLA-brot og samsvarshendingar.',
            notification_digest_frequency: 'Samandragsfrekvens',
            notification_digest_daily: 'Dagleg',
            notification_digest_weekly: 'Kvar veke',
            notification_digest_none: 'Ingen samandrag',
            notification_in_app_enabled: 'Aktiver Plattformvarsel',
            notification_in_app_description: 'Vis varselmerke og -skuff for sanntidsalarmar.',
            jurisdictions: {
                vietnam: 'Vietnam',
                asean: 'ASEAN',
                eu_eea: 'EU/E��S',
                global: 'Globalt',
            },
            languages: {
                en: 'engelsk',
                vi: 'Tiếng Vi�!t',
                da: 'Dansk',
                sv: 'Svenska',
                nb: 'Norsk bokmål',
                nn: 'Norsk nynorsk',
                de: 'Deutsch',
                fi: 'Suomi',
                nl: 'Nederlands',
                fr: 'Français',
                lb: 'Lëtzebuergesch',
                ga: 'Gaeilge',
                es: 'Español',
                ca: 'Català',
                eu: 'Euskara',
                pt: 'Português',
            },
            industries: {
                financial_services: 'Finansielle tenester',
                healthcare: 'Helsevesen',
                technology: 'Teknologi',
                telecommunications: 'Telekommunikasjon',
                government: 'Offentleg sektor',
                education: 'Utdanning',
                manufacturing: 'Produksjon',
                retail: 'Detaljhandel',
                other: 'Anna',
            },
            placeholders: {
                org_name: 'f.eks. Lotus Financial Services',
                admin_email: 'admin@company.vn',
                team_emails: 'bruker1@firma.vn, bruker2@firma.vn',
                cmp_endpoint: 'https://cmp.example.com/api',
            },
            fields: {
                org_name: 'Organisasjonsnamn',
                jurisdiction: 'Jurisdiksjon',
                industry: 'Bransje',
                org_size: 'Organisasjonsstorleik',
                language: 'Føretrekt Språk',
                admin_email: 'Admin-e-post',
                team_emails: 'E-postadresser for teammedlemmer (kommaseparert)',
                enable_cmp: 'Aktiver CMP-integrasjon',
                cmp_endpoint: 'CMP API-endepunkt',
                email_notifications: 'E-postvarsel',
                in_app_notifications: 'Plattformvarsel',
                digest_frequency: 'Samandragsfrekvens',
            },
        },
        tours: {
            title: 'Modulomvisingar',
            start: 'Start omvising',
            continue_tour: 'Hald fram med omvising',
            replay: 'Spel omvising på nytt',
            exit: 'Avslutt omvising',
            skip: 'Hopp over omvising',
            next: 'Neste',
            previous: 'Forrige',
            finish: 'Fullfør omvising',
            step_of: 'Steg {current} av {total}',
            info: 'Ta rettleia omvisingar i kvar modul for å lære om nøkkelfunksjonar og arbeidsflyt. Omvisingar kan spelast på nytt når som helst.',
            autoplay: 'Automatisk avspilling',
            interactive: 'Interaktiv',
            play_all: 'Spill alle',
            search_tours: 'Søk etter turer...',
            duration: 'Varighet',
            steps_label: '[[TOK_1]] trinn',
            mode: 'Modus',
            pause: 'Pause',
            resume: 'Fortsett',
            speed: 'Hastighet',
            restart: 'Start på nytt',
            reset: 'Tilbakestill',
            reset_success: 'Turfremdriften er tilbakestilt.',
            category_core_privacy: 'Kjernepersonvern',
            category_governance: 'Styring',
            category_operations: 'Drift',
            category_platform: 'Plattform',
            category_advanced: 'Avansert',
            category_data_privacy_rights: 'Datavern og rettigheter',
            category_vendor_third_party: 'Leverandør- og tredjepartsledelse',
            category_risk_assessment: 'Risiko og vurdering',
            category_operations_automation: 'Drift og automatisering',
            category_platform_admin: 'Plattform og administrasjon',
            steps_count: '[[TOK_1]] trinn',
        },
        sample_data: {
            title: 'Handtering av eksempeldata',
            select_modules: 'Vel modular',
            current_status: 'Gjeldande status',
            operation_history: 'Operasjonshistorikk',
            load: 'Last inn eksempeldata',
            clear: 'Fjern eksempeldata',
            processing: 'Behandlar...',
            loaded: 'Lasta inn',
            not_loaded: 'Ikkje lasta inn',
            records: 'Eksempeloppføringar',
            confirm_clear: 'Er du sikker på at du vil fjerne alle eksempeldata for dei valde modulane?',
            confirm_clear_title: 'Fjern eksempeldata',
            confirm_load_title: 'Last inn eksempeldata',
            confirm_load: 'Er du sikker på at du vil laste inn eksempeldata for dei valde modulane?',
            action_load: 'Last inn',
            action_clear: 'Fjern',
            info: 'Last inn realistisk demodata for opplæring og demonstrasjonar med det fiktive selskapet «Lotus Financial Services». Eksempeldata er merkte og kan trygt fjernast utan å påverka verkelege data.',
        },
        help: {
            title: 'Hjelpesenter',
            search: 'Søk',
            search_placeholder: 'Søk i hjelpeartiklar...',
            clear: 'Tøm',
            all_categories: 'Alle kategoriar',
            all_modules: 'Alle Modular',
            back: 'Tilbake til hjelpesenteret',
            callout_important: 'Viktig',
            callout_tip: 'Tips',
            no_results: 'Ingen artiklar funne for søket ditt.',
            no_articles: 'Ingen hjelpeartiklar er tilgjengelege enno. Artiklar vil dukke opp her etterkvart som innhald vert lagt til.',
            results_for: '{count} resultat for «{query}»',
            quick_links: {
                getting_started: 'Kom i gang',
                getting_started_desc: 'Installasjon, oppsett og hurtigstartsrettleiing.',
                user_guide: 'Brukarrettleiing',
                user_guide_desc: 'Modul-for-modul brukardokumentasjon.',
                admin_guide: 'Administratorrettleiing',
                admin_guide_desc: 'Konfigurasjon, vedlikehald og feilsøking.',
                faq: 'Vanlege spørsmål',
                faq_desc: 'Ofte stilte spørsmål og svar.',
            },
            search_articles_aria: 'Søk i hjelpeartiklar',
            article_metadata_aria: 'Artikkelmetadata',
            articles_list_aria: 'Hjelpeartiklar',
            category_nav_aria: 'Kategorinavigasjon',
            quick_links_aria: 'Hurtiglenkjer til hjelpekategoriar',
            returned_to_list: 'Tilbake til artikellista',
            opening_article: 'Opnar artikkel: {title}',
            read_article_aria: 'Les artikkel: {title}',
            pagination_nav_aria: 'Artikkelpaginering',
            error_unavailable: 'Hjelpesenteret er for tida ikkje tilgjengeleg. Ver venleg og prøv igjen seinare.',
            retry: 'Prøv igjen',
        },
    },
    common: {
        save: 'Lagra',
        cancel: 'Avbryt',
        system_actor: 'System',
        delete: 'Slett',
        edit: 'Rediger',
        create: 'Opprett',
        update: 'Oppdater',
        loading: 'Lastar...',
        error: 'Det oppstod ein feil',
        success: 'Vellukka',
        logout: 'Logg ut',
        actions: 'Handlingar',
        retrying: 'Prøver på nytt ⬦',
        permission_denied: 'Du har ikke tilgang til denne siden.',
        status: 'Status',
        description: 'Skildring',
        name: 'Namn',
        created_at: 'Oppretta',
        updated_at: 'Oppdatert',
        yes: 'Ja',
        no: 'Nei',
        confirm: 'Stadfest',
        back: 'Tilbake',
        next: 'Neste',
        previous: 'Førre',
        search: 'Søk',
        filter: 'Filtrer',
        page_x_of_y: 'Side [[TOK_2]] av [[TOK_3]]',
        pagination_label: 'Paginering',
        view_mode_label: 'Visingsmodus',
        export: 'Eksporter',
        exporting: 'Eksporterer ⬦',
        sidebar_navigation: 'Administrasjonssidebarnavigering',
        items_count: '[[TOK_1]] elementer',
        items_count_one: '[[TOK_1]] element',
        export_success: 'Dokumentet ble generert.',
        generate_pdf: 'Generer PDF',
        import: 'Importer',
        download: 'Last ned',
        upload: 'Last opp',
        view: 'Vis',
        close: 'Lukk',
        submit: 'Send inn',
        saved: 'Lagra',
        saving: 'Lagrar...',
        submitting: 'Sender...',
        created: 'Oppretta',
        all: 'Alle',
        none: 'Ingen',
        select: 'Vel',
        select_user: 'Velg bruker...',
        custom_input: 'Skriv inn manuelt',
        required: 'Påkravd',
        optional: 'Valfritt',
        notes: 'Merknadar',
        tags: 'Merkelappar',
        archive: 'Arkiver',
        clone: 'Klone',
        refresh: 'Oppdater',
        retry: 'Prøv på nytt',
        reset: 'Tilbakestill',
        add: 'Legg til',
        remove: 'Fjern',
        removing: 'Fjernar⬦',
        attachment: 'Vedlegg',
        upload_file: 'Last opp fil',
        upload_file_required: 'Last opp fil (påkravd)',
        select_entity_type_first: 'Vel ein entitetstype først',
        failed_to_remove_file: 'Kunne ikkje fjerne fila.',
        entity_type_label: 'Entitetstype',
        entity_label: 'Entitet',
        entity_reference: 'Entitetsreferanse',
        failed_to_load_entities: 'Kunne ikkje laste inn entitetar',
        enable: 'Aktiver',
        disable: 'Deaktiver',
        no_data: 'Ingen data funne',
        confirm_delete: 'Er du sikker på at du vil slette dette elementet?',
        confirm_action: 'Er du sikker på at du vil halda fram?',
        save_success: 'Lagra',
        save_error: 'Klarte ikkje å lagre',
        delete_success: 'Sletta',
        delete_error: 'Klarte ikkje å slette',
        hour: 'time',
        hours: 'timar',
        load_error: 'Klarte ikkje å laste data',
        operation_error: 'Operasjonen mislukkast',
        something_went_wrong: 'Noko gjekk gale',
        go_home: 'Gå til kontrollpanelet',
        access_denied: 'Tilgang nekta',
        no_permission: 'Du har ikkje løyve til å opne denne sida.',
        no_permission_title: 'Utilstrekkelege løyve',
        no_permission_message: 'Du har ikkje løyve til å opna denne sida.',
        unknown: 'Ukjend',
        back_to_dashboard: 'Tilbake til kontrollpanelet',
        id: 'ID',
        type: 'Type',
        date: 'Dato',
        created_by: 'Oppretta av',
        updated_by: 'Oppdatert av',
        page_of: 'Side {page} av {total}',
        showing_items: 'Viser {count} element',
        items_per_page: 'Element per side',
        no_results: 'Ingen oppføringar samsvarar med filtra dine',
        no_items: 'Ingen element funne',
        sort_by: 'Sorter etter',
        ascending: 'Stigande',
        descending: 'Synkande',
        all_statuses: 'Alle statusar',
        all_types: 'Alle typar',
        all_categories: 'Alle kategoriar',
        all_severities: 'Alle alvorsgradar',
        date_range: 'Datoperiode',
        from_date: 'Frå',
        to_date: 'Til',
        clear_filters: 'Tøm filter',
        apply_filters: 'Bruk filter',
        save_changes: 'Lagra endringar',
        discard_changes: 'Forkast endringar',
        confirm_discard: 'Du har ulagra endringar. Vil du forkaste dei?',
        copy: 'Kopier',
        duplicate: 'Dupliser',
        move: 'Flytt',
        assign: 'Tildel',
        unassign: 'Fjern tildeling',
        approve: 'Godkjenn',
        reject: 'Avvis',
        deleting: 'Slettar...',
        processing: 'Behandlar...',
        loading_page: 'Lastar side...',
        operation_success: 'Operasjonen vart fullført',
        operation_failed: 'Operasjonen mislukkast. Ver venleg og prøv på nytt.',
        empty_dash: '�',
        network_error: 'Nettverksfeil. Sjekk tilkoplinga di.',
        session_expired: '��kta er utgått. Ver venleg og logg inn på nytt.',
        test: 'Test',
        pause: 'Sett på pause',
        resume: 'Hald fram',
        activate: 'Aktiver',
        last_sync: 'Siste synkronisering',
        health: 'Helse',
        email: 'E-post',
        role: 'Rolle',
        title: 'Tittel',
        owner: 'Eigar',
        priority: 'Prioritet',
        category: 'Kategori',
        details: 'Detaljar',
        overview: 'Oversikt',
        configuration: 'Konfigurasjon',
        history: 'Historikk',
        new_item: 'Ny',
        edit_item: 'Rediger',
        select_option: 'Vel...',
        total: 'Totalt',
        active: 'Aktiv',
        inactive: 'Inaktiv',
        enabled: 'Aktivert',
        disabled: 'Deaktivert',
        last_login: 'Siste innlogging',
        never: 'Aldri',
        password_changed: 'Passordet er endra. Du vil verte logga ut.',
        password_change_failed: 'Klarte ikkje å endre passord',
        passwords_mismatch: 'Passorda samsvarar ikkje',
        install: 'Installer',
        uninstall: 'Avinstaller',
        installed: 'Installert',
        available: 'Tilgjengeleg',
        catalog: 'Katalog',
        published: 'Publisert',
        version: 'Versjon',
        market: 'Marknad',
        language: 'Språk',
        framework: 'Rammeverk',
        template: 'Mal',
        connector_type: 'Koplingstype',
        polling_interval: 'Pollingsintervall (minutt)',
        new_instance: 'Ny instans',
        change_password: 'Endre passord',
        current_password: 'Gjeldande passord',
        new_password: 'Nytt passord',
        confirm_password: 'Stadfest passord',
        comments: 'Kommentarar',
        completed: 'Fullført',
        contact: 'Kontakt',
        hide: 'Gøym',
        hide_details: 'Gøym detaljar',
        label: 'Etikett',
        max: 'Max',
        min: 'Min',
        na: 'N/A',
        of: 'of',
        showing: 'Viser',
        page: 'Side',
        preview: 'Førehandsvising',
        print: 'Skriv ut',
        show: 'Vis',
        status_active: 'Aktiv',
        status_completed: 'Fullført',
        status_draft: 'Utkast',
        status_in_progress: 'I gang',
        status_pending: 'Ventande',
        view_details: 'Vis Detaljar',
        all_priorities: 'Alle prioriteringar',
        pipeline: 'Rørledning',
        all_requests: 'Alle Førespurnader',
        schedule: 'Tidsplan',
        deploy: 'Distribuer',
        rollback: 'Tilbakerulling',
        advance_stage: 'Avancer Fase',
        submit_for_approval: 'Send inn til godkendelse',
        approval_log: 'Godkjenning Logg',
        approver: 'Godkjennar',
        decision: 'Avgjerd',
        decided_at: 'Besluttet At',
        rollout_stages: 'Utrulling Fasar',
        approval_comment: 'Godkjenning Kommentar',
        optional_comment: 'Valfritt kommentar...',
        impact_summary: 'Konsekvens Samandrag',
        target_property_ids: 'Målegenskabs-ID-er (kommaseparert)',
        policy_id: 'Retningslinje ID',
        target_version: 'Mål Versjon',
        target_version_placeholder: 'f.eks. 2.0.0',
        scheduled_label: 'Planlagt',
        scheduled_start: 'Planlagt start',
        scheduled_end: 'Planlagt slutning',
        properties_count: '{count} egenskaber',
        results: 'Resultat',
        comparison_results: 'Samanlikning Resultat',
        past_comparison_reports: 'Tidligere sammenligningsrapporter',
        scanning: 'Skannar...',
        run_inconsistency_scan: 'Køyring Inkonsistens Skanning',
        property_ids_label: 'Egenskabs-ID-er (kommaseparert, min. 2)',
        comparison_type: 'Samanlikning Type',
        golden_template_id: 'Gylden mal-ID (valfritt)',
        leave_blank_compare: 'Lad stå tomt for at sammenligne egenskaber indbyrdes',
        add_notes_placeholder: 'Legg til dine analysenoter her...',
        covered_of_active: '{covered} av {active} aktive eigenskapar dekt',
        fetch_error: 'Kunne ikkje hente data. Ver venleg og prøv igjen.',
        run_comparison_error: 'Kunne ikkje køyre samanlikning. Ver venleg og prøv igjen.',
        save_notes_error: 'Kunne ikkje lagre notat. Ver venleg og prøv igjen.',
        scan_complete: 'Inkonsistensscanning fuldført.',
        scan_error: 'Kunne ikkje køyre inkonsistensskann. Ver venleg og prøv igjen.',
        min_two_properties: 'Oppgje ver venleg mindst 2 egenskabs-ID-er til sammenligning.',
        comma_separated: 'kommaseparert',
        language_english: 'Engelsk',
        language_vietnamese: 'Vietnamesisk',
        language_vietnamese_native: 'Tiếng Vi�!t',
        author: 'Forfattar',
        dependencies: 'Avhengigheiter',
        checksum: 'Sjekksum',
        changelog: 'Endringslogg',
        tier: 'Nivå',
        phone: 'Telefon',
        launch: 'Start',
        complete: 'Fullfør',
        back_to_list: 'Tilbake til liste',
        clear_selection: 'Tøm Val',
        deactivate: 'Deaktiver',
        scope: 'Omfang',
        deadline: 'Frist',
        progress: 'Framdrift',
        frequency: 'Frekvens',
        reviewer: 'Gjennomgåar',
        user: 'Brukar',
        campaign: 'Kampanje',
        items: 'Element',
        next_run: 'Neste Køyring',
        last_run: 'Siste Køyring',
        overdue: 'FORSINKA',
        creating: 'Opprettar...',
        launching: 'Startar...',
        loaded: 'loaded',
        page_size: 'Sidestørrelse',
        per_page: '/ side',
        urgent: 'Haster',
        pagination: 'Paginering',
        metric: 'Metrisk',
        value: 'Verdi',
        country: 'Land',
        showing_chart_view: 'Viser diagramvising',
        showing_table_view: 'Viser datatabellvising',
        policies: 'Retningslinjer',
        select_content_type: 'Ver venleg og vel minst éin innhaldstype.',
        compliant: 'Samsvarlig',
        non_compliant_status: 'Ikke-kompatibel',
        all_data: 'Alle data',
        sr_urgent: 'Haster',
        n_per_page: '[[TOK_1]] / side',
        select_user_placeholder: '-- Velg bruker --',
        field_required: 'Dette feltet er påkravd',
        results_found: 'resultat funne',
        select_placeholder: '-- Vel --',
        unknown_user: 'Ukjend brukar',
        export_csv: 'Eksporter CSV',
        not_applicable: 'I/T',
        aria_overdue_since: 'Forfalle sidan {date}',
        placeholders: {
            enter_justification: 'Oppgje grunngiving',
            justification: 'Grunngiving',
            campaign_name_example: 'Q1 2026 Tilgang Gjennomgang',
            optional_description: 'Valfritt skildring',
            enter_user_id: 'Oppgje gjennomgåerens brukar-ID',
            enter_user_id_short: 'Oppgje brukar ID',
            schedule_name_example: 'Kvartalsvis tilgangsattestering',
            enter_property_id: 'Oppgje eigenskap ID',
            enter_policy_id: 'Oppgje politik-ID',
            property_or_group_id: 'Eigenskap eller gruppe ID',
            describe_template_purpose: 'Skildra the mal føremål...',
            step_title: 'Steg tittel...',
            detailed_instructions: 'Detaljert instruksjonar...',
            filter_by_taxonomy_id: 'Filter etter Taksonomi ID...',
            describe_classification_rule: 'Beskriv klassificeringsreglen...',
            describe_dedup_rule: 'Beskriv dedupliceringsreglen...',
            describe_import_template: 'Skildra the importer mal...',
            reason_for_rejection: '�&rsak til afvisning...',
            jurisdiction_codes_example: 'VN, SG, EU',
            filter_by_locale: 'Filter etter lokalitet...',
            filter_by_event_type: 'Filter etter hending type',
            filter_by_actor_id: 'Filtrer efter aktør-ID',
            filter_by_market_code: 'Filter etter marknad kode...',
            filter_by_framework_id: 'Filter etter rammeverk ID...',
            add_comment: 'Add ein kommentar...',
            provide_rejection_reason: 'Oppgje en årsak for afvisning af denne indsendelse...',
            filter_by_jurisdiction: 'Filtrer efter jurisdiktionskode...',
            enter_report_title: 'Oppgje rapport tittel',
            enter_name: 'Skriv inn namn',
            enter_description: 'Skriv inn skildring',
            enter_org_id: 'Oppgje Org ID to legg til',
            describe_evidence_gap: 'Skildra the bevis mangel...',
            expected_evidence: 'Hvilken bevis forventes',
            entity_identifier: 'Eining identifikator',
            remediation_steps: 'Trin til at afhjælpe denne mangel',
            user_id_or_name: 'Brukar ID eller namn',
            reporting_period_id: 'Rapporteringsperiode-ID',
            maturity_model_id: 'Mognad modell ID',
            describe_maturity_model: 'Beskriv denne modenhedsmodel...',
            describe_role_purpose: "Describe this role's purpose...",
            provide_deny_reason: 'Oppgje en årsak for afvisning af denne anmodning',
            describe_emergency: 'Skildra naudsituasjonen som krev forhøgd tilgang (minimum 20 teikn)',
            enter_delegate_id: 'Oppgje brukar ID of the deleger',
            provide_delegation_reason: 'Oppgje en årsak for denne delegering',
            client_identifier: 'Klient identifikator',
            client_secret: 'Klient hemmelighet',
            time_format: 'TT:MM',
            describe_sod_rule: 'Beskriv formålet med denne SoD-regel...',
            enter_role_id: 'Oppgje rolle-ID',
            explain_exception: 'Forklar hvorfor denne undtagelse er nødvendig...',
            describe_compensating_controls: 'Beskriv kompenserende kontroller...',
            full_name: 'Fullstendig namn',
            min_chars: 'Min. 12 tegn',
            enter_override_justification: 'Oppgje grunngiving for at tilsidesætte denne portevaluering',
            enter_evidence_id: 'Skriv inn bevis-ID for å linke:',
            date_format: 'DD/MM/�&�&�&�&',
            describe_pack_contents: 'Beskriv innhaldet og føremålet med pakka',
            select_reviewers: 'Vel vurderarar...',
        },
        aria_previous_page: 'Forrige side',
        aria_next_page: 'Neste side',
        aria_results_per_page: 'Resultater per side',
        per_page_25: '25 / side',
        per_page_50: '50 / side',
        per_page_100: '100 / side',
        select_language: 'Vel språk',
        today: 'I dag',
        tomorrow: 'I morgon',
        dashboard_load_error: 'Kunne ikkje laste dashbordet. Prøv igjen.',
        enum_grade: {
            red: 'Rødt',
            amber: 'Amber',
            yellow: 'Gul',
            green: 'Grønn',
        },
        enum_severity: {
            critical: 'Kritisk',
            high: 'Høg',
            medium: 'Middels',
            low: 'Låg',
        },
        enum_priority: {
            critical: 'Kritisk',
            high: 'Høg',
            medium: 'Middels',
            low: 'Låg',
        },
        enum_status: {
            pending: 'Ventar',
            in_progress: 'Pågår',
            completed: 'Fullført',
            blocked: 'Blokkert',
            escalated: 'Eskalert',
            cancelled: 'Avbroten',
            overdue: 'Forfallen',
            not_started: 'Ikke startet',
            new: 'Nytt',
            open: '�&pne',
            closed: 'Stengt',
            acknowledged: 'Erkjent',
            resolved: 'Løst',
        },
        enum_department: {
            unassigned: 'Ikke tilordnet',
        },
        enum_form_category: {
            assessment: 'Vurdering',
            assessment_report: 'Vurderingsrapport',
            dpia: '[[TOK_0]]',
            authority_submission: 'Innlevering av myndighet',
            cross_border_transfer: 'Overføring over landegrensene',
            vendor: 'Leverandør',
            breach: 'Brudd',
            consent: 'Samtykke',
            governance: 'Styring',
            register: 'Registrer deg',
            monitoring: 'Overvåking',
            dpa: 'DPA',
            dsr: 'DSR',
            privacy: 'Personvern',
            incident: 'Hendelse',
            org: 'Organisasjon',
            sector: 'Sektor',
            classification: 'Klassifisering',
            discovery: 'Oppdagelse',
        },
        enum_module: {
            rights_requests: 'Rettighetsforespørsler',
            assessments: 'Vurderinger',
            incidents: 'Hendelser',
            incident_ops: 'Hendelse Ops',
            monitoring: 'Overvåking',
            vendor_risk: 'Leverandørrisiko',
            governance: 'Styring',
            deletion_orchestration: 'Sletting',
            access_review: 'Tilgang gjennomgang',
            consent: 'Samtykke',
            consent_properties: 'Samtykkeegenskaper',
            forms: 'Skjemaer',
            localization: 'Lokalisering',
            program_governance: 'Programstyring',
            privacy_scanner: 'Personvernskanner',
            classification: 'Klassifisering',
            discovery: 'Oppdagelse',
            manual: 'Manuell',
            data_mapping: 'Datakartlegging',
        },
        enum_risk_level: {
            critical: 'Kritisk',
            high: 'Høg',
            medium: 'Middels',
            low: 'Låg',
        },
        enum_request_type: {
            all: 'Alle',
            access: 'Tilgang ([[TOK_0]])',
            deletion: 'Sletting',
            correction: 'Rettelse',
            objection: 'Innvending',
            portability: 'Bærbarhet',
            restriction: 'Begrensning',
            consent_withdrawal: 'Tilbaketrekking av samtykke',
        },
        enum_locale: {
            en: 'engelsk',
            vi: 'vietnamesisk',
            all: 'Begge deler',
        },
        enum_event_type: {
            case_created: 'Sak opprettet',
            status_changed: 'Status endret',
            case_assigned: 'Sak tildelt',
            note_added: 'Merknad lagt til',
            attachment_added: 'Vedlegg lagt til',
            attachment_deleted: 'Vedlegg slettet',
            reference_added: 'Referanse lagt til',
            checklist_updated: 'Sjekkliste oppdatert',
            identity_verified: 'Identitet bekreftet',
            closure_summary_added: 'Avslutningssammendrag',
            approval_granted: 'Godkjenning gitt',
            template_applied: 'Mal brukt',
            export_generated: 'Eksport generert',
            sla_warning: '[[TOK_0]] Advarsel',
            sla_overdue: '[[TOK_0]] Forfalt',
        },
        more: 'more',
        use: 'Use',
        ok: 'OK',
    },
    common_statuses: {
        removed: 'Fjerna',
        draft: 'Utkast',
        active: 'Aktiv',
        inactive: 'Inaktiv',
        pending: 'Ventande',
        in_progress: 'Under arbeid',
        completed: 'Fullført',
        archived: 'Arkivert',
        published: 'Publisert',
        approved: 'Godkjend',
        rejected: 'Avvist',
        cancelled: 'Avlyst',
        blocked: 'Blokkert',
        deferred: 'Utsett',
        not_started: 'Ikkje starta',
        dismissed: 'Avvist',
        failed: 'Feila',
        in_review: 'I Gjennomgang',
        deprecated: 'Utfasa',
        scheduled: 'Planlagt',
        deploying: 'Distribuerer',
        deployed: 'Distribuert',
        paused: 'Pausa',
        rolled_back: 'Tilbakerulla Tilbake',
        received: 'Motteke',
        processing: 'Behandlar',
        under_assessment: 'Under vurdering',
        implemented: 'Implementert',
        pending_approval: 'Ventande Godkjenning',
        pending_deletion: 'Ventande Sletting',
        on_hold: 'På Sperring',
        deleted: 'Sletta',
        expired: 'Utløpte',
        outdated: 'Utdatert',
        drifted: 'Avvike',
        decommissioned: 'Avvikla',
        match: 'Treff',
        different: 'Forskjellig',
        missing: 'Manglande',
        confirmed: 'Stadfesta',
        revoked: 'Tilbakekalla',
        escalated: 'Eskalert',
        system: 'System',
        custom: 'Tilpassa',
        warning: '�&tvaring',
        blocking: 'Blokkerande',
        analyst: 'Analytikar',
        viewer: 'Lesar',
        daily: 'Dagleg',
        weekly: 'Vekentleg',
        policies: 'Retningslinjer',
        denied: 'Avslått',
        verified: 'Verifisert',
        detected: 'Oppdaget',
        ignored: 'Ignorert',
        open: '�&pne',
        resolved: 'Løst',
        suspended: 'Suspendert',
        retired: 'Pensjonist',
        review: 'Gjennomgå',
        generated: 'Generert',
        exported: 'Eksportert',
    },
    severity: {
        low: 'Låg',
        medium: 'Middels',
        high: 'Høg',
        critical: 'Kritisk',
    },
    sensitivity: {
        standard: 'Standard',
        sensitive: 'Sensitiv',
        special_category: 'Særskild kategori',
        badge_sensitive: 'Sensitiv',
    },
    change_types: {
        policy_update: 'Retningslinje Oppdatering',
        new_binding: 'Ny Binding',
        remove_binding: 'Fjern Bindende',
        configuration_change: 'Konfigurasjon Endrings',
        banner_update: 'Banner Oppdater',
    },
    comparison_types: {
        full: 'Full',
        banner_only: 'Banner Berre',
        purposes_only: 'Føremål Berre',
        legal_bases_only: 'Kun retsgrundlag',
        consent_settings: 'Samtykke Indstillinger',
    },
    lifecycle_stages: {
        active: 'Aktiv',
        archived: 'Arkivert',
        pending_deletion: 'Ventande Sletting',
        deleted: 'Sletta',
        on_hold: 'På Sperring',
    },
    object_types: {
        personal_data: 'Personoplysninger',
        consent_record: 'Samtykke Post',
        user_account: 'Brukar Konto',
        audit_log: 'Revisjon Logg',
        document: 'Dokument',
        backup: 'Tryggingskopi',
    },
    transfer_mechanisms: {
        adequacy_decision: 'Tilstrekkelighetsavgjerd',
        standard_contractual_clauses: 'Standardkontraktklausuler',
        binding_corporate_rules: 'Bindende virksomhedsregler',
        explicit_consent: 'Uttrykkjeleg Samtykke',
        public_interest: 'Offentleg Interesse',
        legal_claims: 'Juridiske krav',
        vital_interests: 'Vitale interesser',
    },
    risk_categories: {
        data_breach: 'Data Brot',
        unauthorized_access: 'Uautorisert Tilgang',
        data_loss: 'Data Tap',
        regulatory_non_compliance: 'Regulatorisk Manglande etterleving',
        third_party_risk: 'Tredjepartens Risiko',
        operational: 'Operasjonell',
        technical: 'Teknisk',
        legal: 'Juridisk',
    },
    mitigation_types: {
        technical: 'Teknisk',
        organizational: 'Organisatorisk',
        contractual: 'Kontraktsmessig',
        procedural: 'Prosedyremessig',
    },
    safeguard_types: {
        encryption_in_transit: 'Kryptering i transitt',
        encryption_at_rest: 'Kryptering i hvile',
        access_controls: 'Tilgangskontroller',
        contractual_clauses: 'Kontraktsklausuler',
        data_minimization: 'Dataminimering',
        pseudonymization: 'Pseudonymisering',
        audit_rights: 'Revisjonsrettigheter',
        breach_notification: 'Bruddvarsel',
        data_localization: 'Datalokalisering',
        other: 'Annet',
    },
    scoring_methods: {
        weighted_average: 'Vægtet gennemsnit',
        simple_average: 'Simpelt gennemsnit',
        maximum: 'Maksimum',
        manual: 'Manuell',
    },
    dpa_status: {
        not_required: 'Ikkje påkravd',
        required: 'Påkravd',
        in_progress: 'Under arbeid',
        completed: 'Fullført',
        signed: 'Signert',
    },
    disposal_methods: {
        anonymize: 'Anonymiser',
        pseudonymize: 'Pseudonymiser',
        aggregate: 'Aggreger',
        delete: 'Slett',
    },
    dashboard: {
        title: 'Kontrollpanel',
        no_data: 'Ingen kontrollpaneldata tilgjengelege.',
        no_data_heading: 'Ingen aktive data enno',
        no_data_detail: 'Kontrollpanelwidgetane nedanfor viser oppsettet. Data vil fyllast inn når backend er kopla til databasen.',
        consent_coverage: 'Samtykkedekning',
        ctia_filings: 'CTIA-meldingar',
        next_dpia_review: 'Neste DPIA-gjennomgang',
        next_review_none: 'Ingen planlagd',
        incident_mps_filings: 'MPS-meldingar for hendingar',
        compliance_score: 'Samsvarspoeng',
        grade: 'Karakter',
        no_score: 'Ingen samsvarspoeng utrekna enno.',
        rights_requests: 'Innsynskrav',
        open: 'Opne',
        sla_breached: 'SLA brote',
        sla_approaching: 'SLA-frist nærmar seg',
        closed_month: 'Lukka (månad)',
        incidents: 'Hendingar og personvernbrot',
        active: 'Aktive',
        breaches: 'Personvernbrot',
        overdue_tasks: 'Forfalne oppgåver',
        breach_72h_notice: 'Ved aktive brudd gjelder 72-timers forskriftsvarslingsfrist',
        recommendations: 'Anbefalinger',
        take_action: 'Ta handling',
        drift_events: 'Avvik og godkjenningar',
        open_events: 'Opne hendingar',
        pending_approvals: 'Ventande godkjenningar',
        monitoring: 'Overvakingsoppgåver',
        programs: 'Program',
        overdue: 'Forfalne',
        pending: 'Ventande',
        ric_cases: 'Tilsynssaker',
        coverage: 'Datadekning',
        systems: 'System',
        activities: 'Aktivitetar',
        vendors: 'Leverandørar',
        dpias: 'DPIA-ar',
        open_gaps: 'opne manglar',
        view_as_table: 'Vis som tabell',
        view_as_chart: 'Vis som diagram',
        table_metric_header: 'Maaletal',
        table_value_header: 'Verdi',
        announce_chart_view: 'Viser diagramvising',
        announce_table_view: 'Viser tabellvising',
        section_core_metrics: 'Kjernemaaletal',
        section_task_management: 'Oppgavehandtering',
        section_compliance_insights: 'Samsvarsinnblikk',
        configure_dashboard: 'Konfigurer oversikt',
        config_col_active: 'Aktiv',
        config_col_widget: 'Widget',
        collapse_section: 'Skjul',
        expand_section: 'Utvid',
        reset_to_defaults: 'Tilbakestill til standard',
        preferences_saved: 'Dashboardinnstillingar lagra',
        preferences_reset: 'Dashboard tilbakestilt til rollestandard',
        preferences_load_error: 'Kunne ikkje laste dashboardinnstillingar',
        factor_avg_system_score: 'Gjennomsnittlig systempoengsum',
        factor_avg_vendor_score: 'Gjennomsnittlig leverandørscore',
        factor_processing_coverage: 'Behandlingsaktivitetsdekning',
        factor_ropa_completeness: 'RoPA fullstendighet',
        factor_drift_penalty: 'Driftsstraff',
        rec_improve_system_gov: 'Forbedre systemstyringsdokumentasjonen',
        rec_improve_vendor_gov: 'Forbedre leverandørstyringsdokumentasjonen',
        rec_document_processing: 'Dokumentbehandlingsaktiviteter for avdekkede systemer',
        rec_generate_ropa: 'Generer RoPA-poster for aktive behandlingsaktiviteter',
        rec_resolve_drift: 'Løs åpne kritiske og alvorlige drifthendelser',
        score_good: 'Bra',
        score_fair: 'Akseptabel',
        score_poor: 'Dårleg',
        score_critical: 'Kritisk',
        drag_to_reorder: 'Dra for å omorganisere',
        widget_moved: 'Widget flytta',
        press_space_to_grab: 'Trykk mellomrom for å gripe, piltastar for å flytte, mellomrom for å sleppe',
        reorder_instructions: 'Bruk dra og slepp eller tastatursnarvegar for å omorganisere widgetar',
        task_widgets: {
            tasks_overview: 'Oppgaveoversikt',
            pending: 'Venter',
            in_progress: 'Pågår',
            overdue: 'Forfalt',
            done_7d: 'Ferdig (7d)',
            by_priority: 'Etter prioritet',
            view_all_tasks: 'Vis alle oppgaver',
            upcoming_tasks: 'Kommende oppgaver (de neste 7 dagene)',
            no_upcoming: 'Ingen oppgaver forfaller de neste 7 dagene.',
            view_calendar: 'Vis kalender',
            overdue_alerts: 'Forfalt',
            no_overdue: 'Ingen forfalte oppgaver. Alt er i rute.',
            assigned_to: 'Tildelt til',
            view_all_overdue: 'Se alle forfalt',
            notifications: 'Nylige varsler',
            unread: 'unread',
            no_notifications: 'Ingen varsler. Dere er alle fanget!',
            view_all_notifications: 'Se alle varsler',
            load_error: 'Kunne ikkje laste data.',
            day_late: 'dag sent',
            days_late_plural: 'dager for sent',
            due_today: 'Har termin i dag',
            just_now: 'akkurat nå',
            minutes_short: 'm',
            hours_short: 'h',
            days_short: 'd',
            cross_org_stats: 'Statistikk på tvers av organisasjoner',
            by_organization: 'Etter organisasjon',
            overdue_across_orgs: 'forfalte oppgaver på tvers av organisasjoner',
            total: 'Totalt',
            tasks: 'tasks',
            organization: 'Organisasjon',
            current_org: 'Nåværende organisasjon',
            all_orgs: 'Alle organisasjoner',
            all_organizations: 'Alle organisasjoner',
            filter_by_org: 'Filtrer etter organisasjon',
            cross_org: 'Cross-org',
            empty_calendar: 'Ingen oppgaver for denne perioden. Lag din første oppgave eller sjekk filtrene dine.',
            empty_my_tasks: 'Du har ingen oppgaver tildelt. Flott arbeid!',
            empty_overdue: 'Ingen forfalte oppgaver. Alt er i rute.',
            empty_notifications: 'Ingen varsler. Dere er alle fanget!',
            empty_workflows: 'Ingen arbeidsflyter er konfigurert. Bla gjennom maler for å komme i gang.',
        },
        my_tasks_widget: {
            title: 'Mine Oppgåver',
            no_tasks: 'Ingen oppgåver tildelte til deg.',
            load_error: 'Klarte ikkje å laste oppgåver.',
            overdue: 'forfalle',
            remaining: 'att',
            view_all: 'Vis Alle Oppgåver',
        },
        my_section_status_widget: {
            title: 'Min Seksjonsstatus',
            overall_completion: 'Totalt',
            sections_count: 'Seksjonar',
            no_sections: 'Ingen seksjonar tildelte til avdelinga di.',
            load_error: 'Klarte ikkje å laste seksjonsstatus.',
        },
        revision_requests_widget: {
            title: 'Revisjonsførespurnader',
            no_revisions: 'Ingen revisjonsførespurnader. Alle seksjonar er på sporet.',
            load_error: 'Klarte ikkje å laste revisjonsførespurnader.',
        },
        consent_summary: {
            title: 'Samtykke',
            active: 'Aktiv',
            withdrawn_30d: 'Tilbaketrukket (30d)',
            expiring_7d: 'Utløper (7d)',
        },
        transfer_assessments: {
            title: 'Overføringsvurderinger',
            open: '�&pne',
            approved: 'Godkjent',
            gaps_flagged: 'Mellomrom flagget',
        },
        breach_notifications: {
            title: 'Bruddvarsler',
            deadline_72h: '72 timers frist',
            submitted: 'Sendt inn',
            pending: 'Venter',
        },
        authority_requests: {
            title: 'Myndighetsforespørsler',
            pending: 'Venter',
            overdue: 'Forfalt',
            responded_30d: 'Svarte (30d)',
        },
        data_subjects_widget: {
            title: 'Datasubjekter',
            total: 'Totalt',
            high_risk: 'Høy risiko',
            active_30d: 'Aktiv (30d)',
        },
        audit_activity_summary: {
            title: 'Revisjonsaktivitet',
            events_today: 'Arrangementer i dag',
            events_7d: 'Hendelser (7d)',
            unique_actors_30d: 'Unike skuespillere (30d)',
        },
        onboarding_progress: {
            title: 'Onboarding Progress',
            completion_pct: 'Komplett',
            status_label: 'Status',
            current_step: 'Nåværende trinn',
            status: {
                in_progress: 'Pågår',
                completed: 'Fullført',
                skipped: 'Hoppet over',
                not_started: 'Ikke startet',
            },
        },
        sector_overlay_reports_due: {
            title: 'Sektoroverlegg med rapportfrist',
        },
        persona_widgets: {
            framework_filter: 'Filtrer etter rammeverk',
            all_frameworks: 'Alle rammeverk',
            filing_lifecycle: 'Innleveringslivsløp',
            filing_pipeline: 'Innleveringspipeline',
            draft: 'Utkast',
            internal_review: 'Intern gjennomgang',
            approved: 'Godkjent',
            submitted: 'Sendt inn',
            supplement_requested: 'Tillegg forespurt',
            resubmitted: 'Sendt inn på nytt',
            accepted: 'Godtatt',
            rejected: 'Avvist',
            closed: 'Stengt',
            deadline: 'Frist',
            days_remaining: 'dager igjen',
            days_overdue: 'dager forsinket',
            no_filings: 'Ingen aktive innleveringar.',
            department_consolidation: 'Avdelingskonsolidering',
            departments_completed: 'Avdelingar fullførte',
            departments_pending: 'Avdelingar ventande',
            departments_overdue: 'Avdelingar forseinka',
            no_consolidation_cases: 'Ingen tverravdelingssaker i gang.',
            vendor_risk: 'Leverandør- og tredjepartsrisiko',
            pending_assessment: 'Ventande vurdering',
            overdue_questionnaires: 'Forseinka spørjeskjema',
            dpa_review_queue: 'DPA-gjennomgangskø',
            risk_distribution: 'Risikofordeling',
            total_vendors: 'Totale leverandørar',
            by_risk_level: 'Etter risikonivå',
            no_vendor_data: 'Ingen leverandørrisikodata tilgjengeleg.',
            discovery_summary: 'Dataoppdagelse',
            discovery_classification: 'Dataoppdaging og klassifisering',
            active_scans: 'Aktive skanningar',
            labels_pending: 'Etiketter venter på gjennomgang',
            exceptions_unresolved: 'Unntak uløst',
            pending_review: 'Ventande gjennomgang',
            exceptions: 'Unntak',
            approved_labels: 'Godkjende etikettar',
            total_classified: 'Totalt klassifisert',
            no_discovery_data: 'Ingen oppdagingsdata tilgjengeleg.',
            ai_governance: 'KI-systemstyring',
            systems_inventory: 'Systemer i inventar',
            systems_in_inventory: 'System i oversikt',
            classification_breakdown: 'Klassifiseringssammenbrudd',
            dossier_completion: 'Dossierferdigstilling',
            by_classification: 'Etter klassifisering',
            labeling_status: 'Merkelappstatus',
            not_started: 'Ikkje starta',
            no_ai_data: 'Ingen KI-styringsdata tilgjengeleg.',
            breach_response: 'Brot- og hendingsrespons',
            active_breaches: 'Aktive brot',
            notification_status: 'Varslingsstatus',
            remediation_progress: 'Utbetringsframgang',
            supplement_loops: 'Tilleggssløyfer',
            no_breach_data: 'Ingen aktive brotssaker.',
            audit_readiness: 'Revisjons- og vurderingsberedskap',
            assessments: 'Vurderingar',
            gap_findings: 'Mangelfunn',
            evidence_completion: 'Bevisferdigstilling',
            export_ready: 'Klar til eksport',
            not_ready: 'Ikkje klar',
            no_audit_data: 'Ingen revisjonsberedskapsdata tilgjengeleg.',
            framework_label_vn_pdpl: 'VN PDPL 2025',
            framework_label_vn_cybersecurity: 'VN Cybersikkerheit 2018',
            framework_label_vn_ecommerce: 'VN E-handel 2023',
            framework_label_vn_telecom: 'VN Telekommunikasjon 2023',
            framework_label_vn_ai: 'VN AI-lov 2025',
            framework_label_gdpr: 'GDPR',
            framework_label_unspecified: 'Uspesifisert',
            my_department: 'Mi avdeling',
            my_tasks: 'Mine oppgåver',
            section_status: 'Seksjonsstatus',
            revision_requests: 'Revisjonsførespurnader',
            completion: 'Ferdigstilling',
            reason: 'Grunn',
            requested_at: 'Etterspurt den',
            no_tasks_assigned: 'Ingen oppgåver tildelt deg.',
            no_sections: 'Ingen seksjonar tildelt di avdeling.',
            no_revisions: 'Ingen revisjonsførespurnader.',
            load_error: 'Kunne ikke laste inn data.',
        },
    },
    connectors: {
        nav: {
            instances: 'Instansar',
            credentials: 'Akkreditivarkiv',
            event_bus: 'Hendingsbuss',
            definitions: 'Definisjoner',
            brds: 'BRD-innsamling',
            security_reviews: 'Tryggleiksgjennomgangar',
            poc_scorecards: 'POC-resultatkort',
            automation_planning: 'Automatiseringsplanlegging',
            system_inventory: 'Systemoversikt',
            traceability_matrix: 'Sporingsmatrise',
            gap_register: 'Gap-register',
        },
        instances: {
            title: 'Koplingsinstansar',
            page_title: 'Koplingar',
            add: 'Legg til instans',
            test: 'Test kopling',
            sync_now: 'Synkroniser no',
            new_instance: 'Ny Kopling Instans',
            no_instances: 'Ingen kopling instansar funne',
            instance_count: '{count} instans(ar)',
            confirm_delete: 'Slett koplinginstans "{name}"?',
            all_connector_types: 'Alle Kopling Typar',
            select_connector: 'Vel en kopling...',
            fetch_error: 'Kunne ikkje hente koplingsinstansar. Ver venleg og prøv igjen.',
            fetch_definitions_error: 'Kunne ikkje hente koplingsdefinisjonar. Ver venleg og prøv igjen.',
            create_error: 'Kunne ikkje opprette koplingsinstans',
            test_error: 'Kunne ikkje teste kopling. Ver venleg og prøv igjen.',
            status_error: 'Kunne ikkje oppdatere koplingsstatus. Ver venleg og prøv igjen.',
            delete_error: 'Kunne ikkje slette koplingsinstans. Ver venleg og prøv igjen.',
        },
        credentials: {
            title: 'Akkreditivarkiv',
            page_title: 'Koplingslegitimasjon',
            add: 'Legg til akkreditiv',
            rotate: 'Roter',
            expired: 'Utgått',
            expiring: 'Utløper snart',
            orphaned: 'Foreldrelaus',
            new_credential: 'Ny Legitimasjon',
            no_credentials: 'Ingen credentials funne',
            no_expiry: 'Ingen utløp',
            linked_connectors: 'Tilknytte Koplingar',
            expires_at: 'Utløper den',
            value_label: 'Værdi * (kun skrivning)',
            confirm_delete_title: 'Bekreft sletting',
            confirm_delete_message: 'Sletta denne legitimasjonen? Tilkopla konnektor mistar tilgang.',
            rotate_title: 'Roter legitimasjon',
            new_credential_value: 'Ny legitimasjonsverdi',
            fetch_error: 'Kunne ikkje laste legitimasjonar. Ver venleg og prøv igjen.',
            health_error: 'Kunne ikkje laste helse. Ver venleg og prøv igjen.',
            create_error: 'Kunne ikkje opprette legitimasjon',
            rotate_error: 'Kunne ikkje rotere legitimasjon',
            delete_error: 'Kunne ikkje slette legitimasjon',
        },
        event_bus: {
            title: 'Hendingsbuss',
            page_title: 'Hendingsbuss',
            events: 'Hendingar',
            subscriptions: 'Abonnement',
            dlq: 'Dødbrøvkø',
            publish: 'Publiser hending',
            retry: 'Prøv på nytt',
            dismiss: 'Avvis',
            search_events: 'Søk hendingar...',
            filter_event_type: 'Filter etter hending type...',
            event_type: 'Hending Type',
            source_module: 'Kjelde Modul',
            timestamp: 'Tidsstempel',
            delivery_status: 'Levering Status',
            correlation_id: 'Korrelasjon ID',
            tracking_id: 'Sporings-ID',
            delivery_status_hint: 'Leveringsstatus vert oppdatert automatisk etter kvart som hendingar vert handsama.',
            no_events: 'Ingen hendingar funne',
            total_with_count: '{count} totalt',
            prev: 'Førre',
            new_subscription: '+ Nytt abonnement',
            subscriber_type: 'Abonnent Type',
            subscriber_id: 'Abonnent ID',
            event_type_pattern: 'Hending Type Mønster',
            event_type_pattern_placeholder: 't.d. incident.*',
            filter_expression: 'Filter Uttrykk',
            filter_expression_placeholder: 'Valfritt filter',
            subscriber_type_hint: 'Vel korleis hendingar vert leverte: webhook sender HTTP-førespurnader, e-post sender varsel, kø ruter til ein meldingskø.',
            subscriber_id_hint: 'Skriv inn destinasjonen for hendingar. For webhooks, bruk ein URL. For e-post, bruk ei adresse. For køar, bruk kønamnet.',
            event_type_pattern_hint: 'Match hendingar etter type med jokerteikn. Bruk * for å matche eit segment (t.d. incident.* matchar incident.created, incident.resolved).',
            filter_expression_hint: 'Valfritt. Filtrer hendingar ytterlegare etter innhald (t.d. severity=high).',
            subscriber_id_placeholder_webhook: 't.d. https://din-app.com/webhook',
            subscriber_id_placeholder_email: 't.d. varsel@ditt-firma.com',
            subscriber_id_placeholder_queue: 't.d. hendings-ko',
            event_pattern: 'Hending Mønster',
            filter: 'Filtrer',
            enabled: 'Aktivert',
            delivery_stats: 'Levering Statistikk',
            no_subscriptions: 'Ingen abonnement funne',
            on: 'ON',
            off: 'OFF',
            delivered_failed: '{delivered} leveret / {failed} mislykkedes',
            confirm_delete_subscription: 'Slett dette abonnement?',
            unresolved: 'Uløyst',
            resolved: 'Løyst',
            event_id: 'Hending ID',
            subscription_id: 'Abonnement ID',
            error_code: 'Feil Kode',
            error_message: 'Feil Melding',
            attempts: 'Forsøk',
            last_failed: 'Siste Mislukkast',
            no_dlq_entries: 'Ingen døde brev oppføringar funne',
            dlq_count: '{count} post(er) i alt',
            fetch_events_error: 'Kunne ikkje hente hendingar. Ver venleg og prøv igjen.',
            fetch_subscriptions_error: 'Kunne ikkje hente abonnement. Ver venleg og prøv igjen.',
            fetch_dlq_error: 'Kunne ikkje hente DLQ-oppføringar. Ver venleg og prøv igjen.',
            create_subscription_error: 'Kunne ikkje opprette abonnement',
            toggle_subscription_error: 'Kunne ikkje veksle abonnement',
            delete_subscription_error: 'Kunne ikkje slette abonnement',
            retry_error: 'Gjenforsøk mislukkast',
            dismiss_error: 'Avvis mislukkast',
            event_published: 'Arrangementet er publisert',
            publish_event_error: 'Kunne ikkje publisere hendinga. Prøv igjen.',
            priority_label: 'Prioritet',
            priority_low: 'Låg',
            priority_normal: 'Normal',
            priority_high: 'Høg',
            payload_helper_text: 'Skriv inn hendingsdata som JSON. Døme: {"incident_id": "INC-001", "severity": "high"}',
            subscription_created: 'Abonnement opprettet',
            subscription_toggled: 'Abonnement slått av',
            subscription_deleted: 'Abonnement slettet',
            dlq_retried: 'DLQ-melding forsøkt på nytt',
            dlq_dismissed: 'DLQ-melding avvist',
        },
        definitions: {
            title: 'Koblingsdefinisjoner',
            page_title: 'Koplingsdefinisjoner',
            add: 'Legg til definisjon',
            new_definition: 'Ny koblingsdefinisjon',
            edit_definition: 'Rediger koblingsdefinisjon',
            no_definitions: 'Fant ingen koblingsdefinisjoner',
            definition_count: '[[TOK_1]] definisjon(er)',
            all_categories: 'Alle kategorier',
            select_category: 'Velg en kategori...',
            capabilities: 'Evner',
            capabilities_hint: 'Muligheter (kommaseparert)',
            capabilities_placeholder: 'f.eks. lese, skrive, synkronisere',
            created: 'Koblingsdefinisjon opprettet',
            updated: 'Koblingsdefinisjonen er oppdatert',
            fetch_error: 'Kunne ikke hente koblingsdefinisjoner. Vennligst prøv igjen.',
            create_error: 'Kunne ikke opprette koblingsdefinisjon',
            update_error: 'Kunne ikkje oppdatere koplingsdefinisjon',
        },
        brds: {
            title: 'BRD-innsamling',
            page_title: 'BRD-registrering',
            create_brd: 'Opprett BRD',
            brd_title: 'BRD-tittel',
            description: 'Skildring',
            requirements: 'Krav',
            status: 'Status',
            stakeholders: 'Interessentar',
            connector_label: 'Kopling',
            select_connector: 'Vel ei kopling...',
            approval: 'Godkjenning',
            no_brds_found: 'Ingen BRD-ar funne',
            decision_records: 'Avgjerdregister',
            create_decision: 'Opprett avgjerd',
            alternatives_considered: 'Vurderte alternativ',
            alternative_name: 'Alternativnamn',
            reason_rejected: 'Grunn til avvising',
            add_alternative: 'Legg til alternativ',
            remove_alternative: 'Fjern alternativ {name}',
            alternatives: 'Alternativ',
            rationale: 'Grunngiving',
            selected_connector: 'Vald kopling',
            comma_separated_names: 'Kommaseparerte namn',
            brd_created: 'BRD oppretta',
            decision_record_created: 'Avgjerdspost oppretta',
            no_decision_records_found: 'Ingen avgjerdsposter funne',
            aria_brds_table: 'BRDar',
            aria_decision_records_table: 'Avgjerdsposter',
            aria_approve: 'Godkjenn {name}',
            aria_archive: 'Arkiver {name}',
            brd_title_help: 'Et kort, lesbart navn for denne BRD - f.eks. "Jira-billettintegrering", "Okta SSO-utrulling".',
            brd_title_placeholder: 'f.eks. Jira billettintegrering',
            description_help: 'Forretningsproblemet løser denne koblingen. Hvilket utfall forventer du når det er live?',
            description_placeholder: 'f.eks. Automatiser oppretting av hendelsesbilletter fra overvåkingsvarsler, slik at vakttelefon blir søkt innen 60-tallet.',
            connector_help: 'Valgfri. Velg en kobling som denne BRD er for - la den stå tom hvis koblingen ikke er valgt ennå.',
            requirements_help: 'Kommaseparert liste over funksjoner du må ha � f.eks. "OAuth2-pålogging, webhook-levering, revisjonseksport".',
            requirements_placeholder: 'OAuth2-pålogging, webhook-levering, revisjonseksport',
            stakeholders_help: 'Kommaseparerte navn eller e-poster til personer som må melde seg av.',
            selected_connector_help: 'Velg koblingen denne avgjørelsen gjelder.',
            rationale_help: 'Hvorfor denne kontakten ble valgt. Dekk de avgjørende faktorene slik at en fremtidig leser forstår oppfordringen.',
            rationale_placeholder: 'f.eks. Valgte Jira fordi den allerede inneholder billetthistorikken vår og teamet er trent på den.',
            alternatives_considered_help: 'Andre koblinger evaluert og hvorfor de ikke ble valgt. Legger til forsvarlighet for revisjon.',
            alternative_name_placeholder: 'f.eks. ServiceNå',
            reason_rejected_placeholder: 'f.eks. Koster 3� høyere, ingen fordel for vår brukssituasjon',
        },
        security_reviews: {
            title: 'Tryggleiksgjennomgangar',
            page_title: 'Tryggingsgjennomgangar',
            create_review: 'Opprett gjennomgang',
            connector_name: 'Koplingsnavn',
            connector_label: 'Kopling',
            select_connector: 'Vel ei kopling...',
            reviewer: 'Meldar',
            select_reviewer: 'Vel ein meldar...',
            findings: 'Funn (eitt per linje)',
            risk_level: 'Risikonivå',
            risk_level_placeholder: 't.d. høg, middels, låg',
            notes: 'Notat',
            review_status: 'Gjennomgangsstatus',
            checklist: 'Sjekkliste',
            privacy_impact: 'Personvernverknad',
            approval_gate: 'Godkjenningsport',
            no_reviews_found: 'Ingen gjennomgangar funne',
            review_created: 'Tryggingsgjennomgang oppretta',
            create_control_mapping: 'Opprett kontrollkopling',
            control_mapping_created: 'Kontrollkopling oppretta',
            connector_id_label: 'Koplings-ID',
            control_id_label: 'Kontroll-ID',
            control_name_label: 'Kontrollnamn',
            aria_approve: 'Godkjenn {name}',
            aria_reject: 'Avvis {name}',
            scan_imported: 'Skanning importert',
            import_scan: 'Importer skanning',
            scan_format: 'Skanningsformat',
            scan_data: 'Skanningsdata',
            import_results: 'Importresultat',
            recommendations: 'Tilrådingar',
            auto_populated_from: 'Automatisk utfylt fra [[TOK_1]]',
            manual_entry: 'Manuell inntasting',
            automation_type: 'Automatiseringstype',
            select_automation_type: 'Velg automatiseringstype...',
            automation_full: 'Full � kobling automatiserer denne kontrollen fullstendig',
            automation_partial: 'Delvis � kobling bidrar med bevis; mennesker handler fortsatt',
            automation_monitoring: 'Kun overvåking � koblingen observerer, håndhever ikke',
            control_id_help: 'Bruk koden fra samsvarsskjemaet ditt (f.eks. ISO-27001-A.12.1, SOC2-CC6.1 eller din interne kontroll-ID).',
            control_name_help: 'Kort menneskelest navn (f.eks. "Nettverkstilgangsbegrensning").',
            description_label: 'Beskrivelse',
            load_sarif_example: 'Last inn SARIF eksempel',
            load_json_example: 'Last inn tilpasset [[TOK_0]] eksempel',
            scan_format_help: 'SARIF er OASIS-standarden som sendes ut av de fleste skannere (Snyk, CodeQL, Semgrep). Bruk tilpasset [[TOK_0]] for verktøy som ikke sender ut SARIF.',
            scan_data_help: 'Lim inn hele skanningen, last opp en .sarif/.json-fil eller klikk på en Last inn eksempel-knapp for å se formen.',
            upload_file_label: 'Last opp .sarif- eller .json-fil',
            invalid_scan_json: 'Kunne ikke analysere skannedata som [[TOK_0]]. Se etter syntaksfeil nær det uthevede tegnet.',
            save_as_review: 'Lagre som sikkerhetsgjennomgang',
            discard_preview: 'Forkast forhåndsvisningen',
            preview_hint: 'Dette er en forhåndsvisning � ingenting er lagret ennå. Klikk på "Lagre som sikkerhetsgjennomgang" for å opprette en ventende gjennomgang forhåndsutfylt med disse verdiene.',
            reviewer_required_for_save: 'Velg en anmelder for å lagre denne skanningen som en sikkerhetsgjennomgang.',
        },
        poc_scorecards: {
            title: 'POC-resultatkort',
            page_title: 'POC-resultatkort',
            create_scorecard: 'Opprett resultatkort',
            connector_label: 'Kopling',
            select_connector: 'Vel ei kopling...',
            vendor_name: 'Leverandørnamn',
            recommendation: 'Tilråding',
            recommendation_placeholder: 't.d. Hald fram, Ikkje hald fram, Treng vidare vurdering',
            criteria: 'Vurderingskriterium',
            criterion_name: 'Kriterienamn',
            score: 'Poeng',
            max_score: 'Maks poeng',
            notes: 'Notat',
            add_criterion: 'Legg til kriterium',
            remove_criterion: 'Fjern kriterium {name}',
            total_score: 'Totalpoeng',
            api_quality: 'API-kvalitet',
            reliability: 'Pålitelegheit',
            support_quality: 'Støttekvalitet',
            cost_score: 'Kostnadspoeng',
            overall_score: 'Totalpoeng',
            evidence: 'Dokumentasjon',
            no_scorecards_found: 'Ingen resultatkort funne',
            scorecard_created: 'POC-resultatkort oppretta',
            connector_help: 'Velg kontakten denne POC-evalueringen er for.',
            vendor_name_help: 'Leverandøren eller produktet som evalueres � f.eks. "Okta", "Datadog", "Snøfnugg".',
            vendor_name_placeholder: 'f.eks. Okta, Datadog, Snowflake',
            recommendation_help: 'Din siste samtale etter evalueringen. Hold det kort og bestemt.',
            criteria_help: 'Poeng leverandøren på hvert evalueringskriterium. Legg til én rad per kriterium ([[TOK_0]] kvalitet, pålitelighet, støtte, kostnad osv.).',
            criterion_name_help: 'Hva du scorer � f.eks. "[[TOK_0]] Kvalitet", "Plitelighet", "Støtte", "Kostnad".',
            criterion_name_placeholder: 'f.eks. [[TOK_0]] Kvalitet',
            score_help: 'Poeng gitt for dette kriteriet. Må ikke overstige Max Score.',
            max_score_help: 'Toppscore tilgjengelig for dette kriteriet. Bruk samme skala på tvers av rader slik at totaler er sammenlignbare.',
            notes_help: 'Valgfritt. Legg til bevis, forbehold eller lenker - alt som forklarer poengsummen.',
        },
        common_labels: {
            aria_filter_instances: 'Filtrer koplingsforekomstar',
            aria_filter_definitions: 'Filtrer koplingsdefinisjoner',
            aria_filter_credentials: 'Filtrer legitimasjon',
            aria_filter_events: 'Filtrer hendingar',
            aria_filter_dlq: 'Filtrer feilmeldingskø',
            aria_instance_summary: 'Koplingsforekomstoversikt',
            aria_active_connectors: 'Aktive koplingar',
            aria_error_connectors: 'Koplingar med feil',
            aria_credential_health: 'Helseoversikt for legitimasjon',
            aria_items_per_page: 'Element per side',
            show_password: 'Vis passord',
            hide_password: 'Gøym passord',
            payload_json_label: 'Nyttelast (JSON)',
            payload_invalid_json: 'Nyttelasten må vere gyldig JSON',
            placeholder_event_type: 'f.eks. incident.created',
            placeholder_source_module: 'f.eks. monitoring',
            placeholder_version: 'f.eks. 1.0',
        },
        statuses: {
            configuring: 'Konfigurerer',
            testing: 'Testing',
            active: 'Aktiv',
            paused: 'Pause',
            error: 'Feil',
            disabled: 'Deaktivert',
            draft: 'Utkast',
            approved: 'Godkjent',
            archived: 'Arkivert',
            pending: 'Venter',
            rejected: 'Avvist',
        },
        system_types: {
            application: 'Applikasjon',
            database: 'Database',
            middleware: 'Mellomvare',
            infrastructure: 'Infrastruktur',
            saas: 'SaaS',
            other: 'Anna',
        },
        hosting_types: {
            on_premise: 'On-Premise',
            cloud: 'Sky',
            hybrid: 'Hybrid',
            managed: 'Administrert',
        },
        system_statuses: {
            active: 'Aktiv',
            decommissioned: 'Avvikla',
            planned: 'Planlagt',
            under_review: 'Under gjennomgang',
        },
        automation_statuses: {
            planning: 'Planlegging',
            in_progress: 'Pågår',
            completed: 'Fullført',
            on_hold: 'På vent',
        },
        gap_types: {
            functional: 'Funksjonell',
            technical: 'Teknisk',
            security: 'Sikkerhet',
            compliance: 'Overholdelse',
            process: 'Prosess',
        },
        severity_labels: {
            critical: 'Kritisk',
            high: 'Høg',
            medium: 'Middels',
            low: 'Låg',
        },
        gap_statuses: {
            open: '�&pne',
            in_progress: 'Pågår',
            mitigated: 'Mitigert',
            closed: 'Lukka',
            accepted: 'Akseptert',
        },
        verification_statuses: {
            not_started: 'Ikkje starta',
            in_progress: 'Pågår',
            verified: 'Verifisert',
            failed: 'Feila',
        },
        subscriber_types: {
            webhook: 'Webhook',
            internal: 'Intern',
            email: 'E-post',
            queue: 'Kø',
        },
        credential_types: {
            password: 'Passord',
            api_key: 'API-nøkkel',
            oauth2_client: 'OAuth2-klient',
            certificate: 'Sertifikat',
            token: 'Token',
            ssh_key: 'SSH-nøkkel',
            imap_credentials: 'IMAP-legitimasjon',
        },
        categories: {
            hr: 'HR',
            crm: 'CRM',
            erp: 'ERP',
            cloud: 'Sky',
            security: 'Sikkerhet',
            itsm: 'ITSM',
            custom: 'Egendefinert',
        },
        delivery_statuses: {
            pending: 'Ventande',
            delivered: 'Levert',
            partial: 'Delvis',
            failed: 'Feila',
        },
        automation_planning: {
            title: 'Automatiseringsplanlegging',
            page_title: 'Automatiseringsplanlegging',
            program_name: 'Programnamn',
            program_status: 'Status',
            description: 'Skildring',
            linked_artifacts: 'Tilknytte artefaktar',
            create_program: 'Opprett program',
            edit_program: 'Rediger program',
            no_programs_found: 'Ingen program funne',
            program_created: 'Program oppretta',
            program_updated: 'Program oppdatert',
            target_date: 'Måldato',
            owner: 'Eigar',
            select_status: 'Vel status...',
            aria_programs_table: 'Automatiseringsprogram',
            aria_edit: 'Rediger {name}',
            export_programs: 'Eksporter program',
            title_label: 'Programtittel',
            title_help: 'Et kort, lesbart navn på automatiseringsprogrammet � f.eks. "Q3-hendelse-til-Jira-utrulling", "[[TOK_0]] automatisering av tilgangsforespørsel".',
            title_placeholder: 'f.eks. Q3-hendelse-til-Jira-utrulling',
            description_help: 'Hva dette programmet dekker og resultatet du forventer når det er live. Valgfritt, men anbefalt.',
            description_placeholder: 'f.eks. Kablet overvåkingsvarsler til Jira, slik at vakttelefon blir søkt innen 60-årene.',
            owner_label: 'Programeier',
            owner_help: 'Personen som er ansvarlig for dette programmet. De vil motta varsler om fremdrift og porter.',
            select_owner: 'Velg en eier...',
            frameworks_in_scope: 'Rammer i omfang',
            frameworks_in_scope_help: 'Samsvarsrammeverk dette programmet støtter. Hjelper revisjonssporet med å vise hvilke regelverk automatiseringen er styrt av.',
            select_frameworks: 'Velg rammer...',
            status_draft: 'Utkast',
            status_active: 'Aktiv',
            status_completed: 'Fullført',
            status_archived: 'Arkivert',
            change_status: 'Endre status',
            status_updated: 'Status oppdatert',
            aria_change_status: 'Endre status for [[TOK_1]]',
        },
        system_inventory: {
            title: 'Systemoversikt',
            page_title: 'Systemoversikt',
            system_name: 'Systemnamn',
            system_type: 'Systemtype',
            hosting: 'Hosting',
            status: 'Status',
            description: 'Skildring',
            create_system: 'Opprett system',
            edit_system: 'Rediger system',
            no_systems_found: 'Ingen system funne',
            system_created: 'System oppretta',
            system_updated: 'System oppdatert',
            select_type: 'Vel type...',
            select_hosting: 'Vel hosting...',
            select_status: 'Vel status...',
            owner: 'Eigar',
            aria_systems_table: 'Systemoversikt',
            aria_edit: 'Rediger {name}',
            export_systems: 'Eksporter system',
            department: 'Avdeling',
            data_categories: 'Datakategoriar',
            data_categories_placeholder: 'Kommadelt, t.d. PII, Finansiell, Helse',
            jurisdiction: 'Jurisdiksjon',
            jurisdiction_placeholder: 't.d. EU, US, Global',
            interfaces: 'Grensesnitt',
            interfaces_placeholder: 'Kommadelt, t.d. REST API, SFTP, JDBC',
            owner_placeholder: 'Vel ein ansvarleg eigar...',
            department_placeholder: 'Vel den ansvarlege organisasjonseininga...',
            system_name_hint: 'Bruk det forretningsanerkjende system- eller applikasjonsnamnet.',
            system_type_hint: 'Klassifiser systemet slik at rapportering kan gruppere liknande eigedelar.',
            hosting_hint: 'Identifiser kvar systemet køyrer for residens, sikkerheit og leverandørgjennomgang.',
            status_hint: 'Set livssyklusstatusen som vert brukt av gjennomgangar, eksportar og revisjonsbevis.',
            owner_hint: 'Vel den aktive brukaren som er ansvarleg for systemstyring og oppfølgingsoppgåver.',
            department_hint: 'Bruk organisasjonseininga som er ansvarleg for å drifte eller styre dette systemet.',
            data_categories_hint: 'List opp dataklassane som vert behandla av dette systemet, separert med komma.',
            jurisdiction_hint: 'Registrer den viktigaste juridiske jurisdiksjonen eller hosting-jurisdiksjonen for samsvarskartlegging.',
            interfaces_hint: 'List opp tilkoplings- eller integrasjonsvegar som vert brukte til å utveksle data.',
            description_hint: 'Oppsummer kva systemet gjer og kvifor det er viktig for datakartet.',
            owner_department_required: 'Eigar og avdeling er påkravd.',
        },
        traceability_matrix: {
            title: 'Sporingsmatrise',
            page_title: 'Sporingsmatrise',
            brd_selector: 'Vel BRD',
            requirement: 'Krav',
            linked_artifact: 'Tilknytt artefakt',
            verification_status: 'Verifiseringsstatus',
            verified_by: 'Verifisert av',
            create_entry: 'Opprett oppføring',
            edit_entry: 'Rediger oppføring',
            no_entries_found: 'Ingen oppføringar funne',
            entry_created: 'Oppføring oppretta',
            entry_updated: 'Oppføring oppdatert',
            select_brd: 'Vel ein BRD...',
            select_status: 'Vel status...',
            aria_matrix_table: 'Sporingsmatrise',
            aria_edit: 'Rediger oppføring for {name}',
            export_matrix: 'Eksporter matrise',
        },
        gap_register: {
            title: 'Gap-register',
            page_title: 'Gap-register',
            gap_title: 'Gap-tittel',
            gap_type: 'Gap-type',
            severity: 'Alvorlegheitsgrad',
            status: 'Status',
            description: 'Skildring',
            remediation_plan: 'Utbetringsplan',
            assigned_to: 'Tildelt til',
            due_date: 'Forfallsdato',
            create_gap: 'Opprett gap',
            edit_gap: 'Rediger gap',
            no_gaps_found: 'Ingen gap funne',
            gap_created: 'Gap oppretta',
            gap_updated: 'Gap oppdatert',
            select_type: 'Vel type...',
            select_severity: 'Vel alvorlegheitsgrad...',
            select_status: 'Vel status...',
            aria_gaps_table: 'Gap-register',
            aria_edit: 'Rediger {name}',
            export_gaps: 'Eksporter gap',
            gap_title_hint: 'Provide a concise name for the identified gap.',
            gap_type_hint: 'Select the nature of the gap (e.g., missing coverage or integration issue).',
            severity_hint: 'The impact of this gap on compliance and operations.',
            status_hint: 'Current stage of the gap resolution lifecycle.',
            owner_hint: 'The person responsible for tracking and remediating this gap.',
            description_hint: 'Detailed context regarding the gap, its root cause, and impact.',
            mitigation_plan_hint: 'Steps planned or taken to address and close the gap.',
            linked_requirement_ids_hint: 'Comma-separated requirement codes this gap affects.',
            linked_system_ids_hint: 'Comma-separated system IDs associated with this gap.',
            gap_types: {
                coverage: 'Coverage',
                capability: 'Capability',
                integration: 'Integration',
                compliance: 'Compliance',
            },
        },
        regulatory: {
            system_inventory_governance_info: 'System inventory aligns with Data Law enterprise governance. System types map to regulatory categories, hosting classification determines jurisdiction-specific controls. Use framework linkage to connect systems to applicable regulatory frameworks.',
            automation_planning_workflow_info: 'Automation programs align with compliance workflow obligations defined by applicable regulatory frameworks. Framework scope determines which requirements the program addresses.',
            traceability_regulatory_source_info: 'Each traceability entry connects a BRD requirement to its regulatory source. Verification status tracks whether implementation satisfies the regulatory obligation.',
            security_reviews_control_mapping_info: 'Security reviews evaluate framework-specific controls applicable to each connector. Risk level captures assessed exposure, findings document deviations from control requirements.',
            gap_register_framework_info: 'Gap Register captures compliance gaps per regulatory framework. Use framework filter to view gaps for a specific framework. Severity levels align with framework risk classification.',
            poc_scorecards_criteria_info: 'POC scorecards evaluate connectors against regulatory criteria. Criteria structure supports weighted scoring with evidence notes. Vendor linkage connects to vendor record.',
            evidence_trail_info: 'All connector module actions generate audit events for cross-module evidence trail integrity. CSV exports preserve referential integrity.',
        },
        system_inventory_extra: {
            framework_linkage: 'Rammeverk-kopling',
            framework_linkage_placeholder: 't.d. GDPR, ISO 27001, NIS2',
        },
        automation_planning_extra: {
            framework_scope: 'Rammeverksomfang',
            framework_scope_placeholder: 't.d. GDPR, PCI-DSS',
            procedure_linkage: 'Prosedyrekopling',
            procedure_linkage_placeholder: 't.d. SOP-001, PROC-DATA-003',
        },
        traceability_matrix_extra: {
            regulatory_source: 'Regulatorisk kjelde',
            regulatory_source_placeholder: 't.d. GDPR Art. 30, ISO 27001 A.8',
        },
        security_reviews_extra: {
            control_mapping_col: 'Kontrollmapping',
            control_mappings_section: 'Kontroller kartlegginger',
            no_control_mappings: 'Ingen kontrolltilordninger ennå. Klikk "Create Control Mapping" for å legge til en.',
            automation_type_col: 'Automatisering',
        },
        gap_register_extra: {
            framework_filter: 'Rammeverk',
            framework_id: 'Rammeverks-ID',
            framework_id_placeholder: 't.d. GDPR, ISO 27001',
            all_frameworks: 'Alle rammeverk',
        },
        poc_scorecards_extra: {
            criteria_count: 'Kriterium',
        },
        export_labels: {
            export_brds: 'Eksporter BRD-ar',
            export_decision_records: 'Eksporter avgjerdsregister',
            export_security_reviews: 'Eksporter tryggleiksgjennomgangar',
            export_poc_scorecards: 'Eksporter POC-poengkort',
            export_instances: 'Eksporter forekomster',
            export_definitions: 'Eksporter definisjoner',
            export_credentials: 'Eksporter legitimasjon',
            export_events: 'Eksporter hendelser',
            exporting: 'Eksporterer...',
            export_success: 'Eksport fullført',
            export_error: 'Eksport mislukkast',
        },
    },
    vendor_risk: {
        risk_acceptance_reasoning: {
            draft_label: 'Utkast til begrunnelse',
            drafting: 'Utarbeide begrunnelse ⬦',
            results_heading: '[[TOK_2]]-utkastet resonnement ([[TOK_1]])',
            tokens_label: '�0� [[TOK_1]] tokens',
            narrative_label: 'Begrunnelsesfortelling',
            controls_heading: 'Kompenserende kontroller',
            no_controls: 'Ingen kompenserende kontroller foreslått.',
            citations_label: 'Sitater',
            accept_label: 'Godta resonnement',
            reject_label: 'Avvis utkast',
            accept_hint: 'Accept registrerer resonnementet om det vedvarende utkastet for IAT-avstamning. Narrative +-kontrollene oppdaterer ikke akseptoppføringen automatisk � operatørlime tilbake er nødvendig.',
            resolve_summary: 'Oppløsning: [[TOK_1]]',
            error_generic: 'Kunne ikke utarbeide begrunnelse. Prøv på nytt eller kontroller statusen for risikoaksept.',
        },
        redline_assistant: {
            run_label: 'Redline med bibliotek',
            running: 'Kjører redline...',
            results_heading: 'Redline-forslag ([[TOK_1]])',
            tokens_label: '�0� [[TOK_1]] tokens',
            no_suggestions: 'Ingen standardklausulhull oppdaget.',
            jurisdiction_label: 'Jurisdiksjon',
            col_kind: 'Snill',
            col_severity: 'Alvorlighetsgrad',
            col_title: 'Forslag',
            col_excerpt: 'Matchende utdrag',
            col_apply: 'Søk',
            kind_missing: 'Mangler standard',
            kind_weaker: 'Svakere enn standard',
            kind_jurisdiction: 'Jurisdiksjonsoverlegg',
            proposed_label: 'Foreslått tekst',
            citations_label: 'Sitater',
            accept_label: 'Godta valgt',
            reject_label: 'Avvis rapport',
            partial_label: 'Bruk utvalg',
            accept_hint: 'Bruk utvalg registrerer de valgte forslagene på utkastet for IAT-avstamning. Ingen automatisk redigering brukes på kontraktsteksten � operatøren kjører rødlinjen.',
            resolve_summary: 'Oppløsning: [[TOK_2]] · [[TOK_3]] forslag er brukt',
            error_generic: 'Kunne ikke produsere en rød linje. Prøv på nytt eller sjekk kontraktstatusen.',
            clause_library_link: 'Administrer klausulbibliotek',
        },
        clause_library: {
            page_title: 'Klausul bibliotek',
            add_label: 'Legg til klausul',
            edit_label: 'Rediger',
            delete_label: 'Slett',
            slug_label: 'Snegl',
            title_label: 'Tittel',
            body_label: 'Kropp',
            jurisdiction_label: 'Jurisdiksjon',
            tags_label: 'Tagger (kommaseparert)',
            must_contain_label: 'Må inneholde markører (kommaseparert)',
            severity_label: 'Alvorlighet når det mangler',
            no_clauses: 'Ingen klausuler ennå. Legg til en for å starte redline-assistenten.',
            save_label: 'Lagre',
            cancel_label: 'Avbryt',
            load_error: 'Kunne ikke laste inn klausulbiblioteket.',
            save_error: 'Kunne ikke lagre klausulen.',
            delete_error: 'Kunne ikke slette klausulen.',
            delete_confirm: 'Vil du slette klausulen "[[TOK_1]]"? Dette kan ikke angres.',
        },
        obligation_extraction: {
            extract_label: 'Trekk ut forpliktelser',
            extracting: 'Trekker ut ⬦',
            results_heading: 'Utdragede forpliktelser ([[TOK_1]])',
            tokens_label: '�0� [[TOK_1]] tokens',
            no_obligations: 'Ingen forpliktelsesmønstre oppdaget i denne kontraktsteksten.',
            col_class: 'Klasse',
            col_summary: 'Sammendrag (redigerbar)',
            col_excerpt: 'Klausulutdrag',
            col_due_date: 'Forfallsdato (redigerbar)',
            col_priority: 'Prioritet',
            due_date_placeholder: 'YYYY-MM-DD',
            class_notice: 'Oppsigelsestid',
            class_audit: 'Revisjonsrett',
            class_insurance: 'Forsikring',
            class_sla: 'Svar [[TOK_0]]',
            class_breach: 'Varsling om brudd',
            class_renewal: 'Fornyelsesvindu',
            citations_label: 'Sitater',
            accept_hint: 'Accept vil opprette én oppgave per forpliktelse (tak 8) med prioritet + forfallsdato vist.',
            accept_label: 'Godta forpliktelser',
            reject_label: 'Avvis rapport',
            resolve_summary: 'Oppløsning: [[TOK_2]] · [[TOK_3]] oppgave(r) opprettet',
            error_generic: 'Kunne ikke trekke ut forpliktelser. Prøv igjen eller sjekk kontraktsteksten.',
        },
        subprocessor_impact: {
            assess_label: 'Vurder innvirkning',
            assessing: 'Vurderer virkningen ⬦',
            results_heading: 'Påvirkning av underprosessor ([[TOK_1]])',
            tokens_label: '�0� [[TOK_1]] tokens',
            risk_delta_label: 'Risiko delta',
            notification_heading: 'Kundevarsling',
            subject_label: 'Emne',
            deadline_label: 'Meldingsfrist',
            body_label: 'Meldingsorgan',
            required_fields_label: 'Obligatoriske Art.28(4)-felt',
            mitigation_heading: 'Reduserende trinn',
            citations_label: 'Sitater',
            accept_label: 'Godta vurdering',
            reject_label: 'Avslå vurdering',
            accept_hint: 'Accept vil opprette en kundevarslingsoppgave med [[TOK_0]] fristen som forfallsdato.',
            resolve_summary: 'Oppløsning: [[TOK_2]][[TOK_3]]',
            error_generic: 'Kunne ikke vurdere denne underbehandlerendringen. Prøv på nytt eller sjekk endringsposten.',
        },
        onboarding_evidence: {
            collect_label: 'Kjør [[TOK_0]] bevisinnsamling',
            collecting: 'Samler bevis...',
            results_heading: 'Bevisinnsamling ([[TOK_1]])',
            tokens_label: '�0� [[TOK_1]] tokens',
            findings_heading: 'Eksisterende bevis',
            missing_heading: 'Manglende gjenstander',
            no_findings: 'Ingen eksisterende bevis oppdaget.',
            no_missing: 'Ingen nødvendige gjenstander mangler for dette risikonivået.',
            next_step_label: 'Neste trinn',
            class_dpa: 'Databehandleravtale',
            class_soc2: 'SOC 2-rapport',
            class_iso27001: 'ISO 27001 sertifikat',
            class_insurance: 'Cyberforsikring',
            class_incident_history: 'Tidligere hendelse',
            accept_hint: 'Accept vil lage oppgaver for hver manglende gjenstand (begrenset til 5). Funnene forblir utkast til du legger dem ved som bevis.',
            accept_label: 'Godta rapporten',
            reject_label: 'Avvis rapport',
            resolve_summary: 'Oppløsning: [[TOK_2]] · [[TOK_3]] oppgave(r) opprettet',
            error_generic: 'Kunne ikke kjøre [[TOK_0]] bevisinnsamling. Prøv på nytt eller sjekk statusen for ombordstigningssaken.',
        },
        no_permission_title: 'Utilstrekkelige tillatelser',
        no_permission_message: 'Du har ikke tillatelse til å få tilgang til leverandørens risikostyring.',
        unknown_vendor: 'Ukjent leverandør',
        nav: {
            dashboard: 'Risikooversikt',
            scoring: 'Risikoscoring',
            questionnaires: 'Spørjeskjema',
            contracts: 'Kontraktar',
            gates: 'Godkjenningsportar',
            reviews: 'Leverandørvurderingar',
            signals: 'Risikosignal',
            reassessments: 'Revurderingar',
            portfolio: 'Risikoportefølje',
            acceptances: 'Risikoaksept',
            review_routing: 'Gjennomgangsruting',
            onboarding_cases: 'Onboarding-saker',
            sub_processor_register: 'Register over underdatabehandlarar',
        },
        dashboard: {
            title: 'Leverandørrisikooversikt',
            page_title: 'Leverandørrisiko Dashboard',
            loading: 'Lastar dashborddata...',
            risk_tier_header: 'Risikonivå',
            count_header: 'Telle',
            percentage_header: 'Prosentandel',
            sections_nav: 'Leverandørrisikoseksjoner',
            urgent_expiry: 'Haster: utløper innen 14 dager',
            no_previous_tier: 'Ingen tidligere nivå',
            view_as_chart: 'Vis som diagram',
            view_as_table: 'Vis som tabell',
            showing_chart: 'Viser diagramvising',
            showing_table: 'Viser datatabellvising',
            load_error: 'Kunne ikkje laste leverandørrisikodashboard',
            risk_distribution: 'Risikofordelingsoversigt',
            recent_tier_changes: 'Nyleg Nivå Endringar',
            no_tier_changes: 'Ingen nyleg nivåendringar.',
            review_kpis: 'Gjennomgang KPI-ar',
            total_vendors_reviewed: 'Totalt leverandørar gjennomgått',
            reviews_by_outcome: 'Gjennomgangar etter Resultat',
            contract_coverage: 'Kontrakt Dekning',
            total_vendors: 'Totalt Leverandørar',
            with_active_dpa: 'Med Aktive DPA',
            without_dpa: 'Utan DPA',
            dpa_coverage: 'DPA Dekning',
            active_contracts_by_type: 'Aktive Kontraktar etter Type',
            expiring_contracts: 'Utløpande kontraktar (neste 90 dagar)',
            no_expiring_contracts: 'Ingen kontraktar utløpar innan dei neste 90 dagane.',
            vendor: 'Leverandør',
            previous_tier: 'Førre Nivå',
            current_tier: 'Noverande Nivå',
            changed_at: 'Endra den',
            expires_at: 'Utløper den',
            days_remaining: 'Dagar att',
            days: 'dagar',
            vendors_label: 'leverandørar',
            no_data: 'Ingen data',
            critical: 'Kritisk',
            high: 'Høg',
            medium: 'Middels',
            low: 'Låg',
            expiring_acceptances_heading: 'Utløpande risikogodkjenningar',
            expiring_30d_label: 'Går ut om 30 dagar',
            expiring_60d_label: 'Går ut om 60 dagar',
            expiring_90d_label: 'Går ut om 90 dagar',
        },
        scoring: {
            title: 'Risikoscoring',
            page_title: 'Leverandørrisikoscore',
            filter_scores: 'Filtrer risikopoeng',
            filter_by_tier: 'Filtrer etter risikonivå',
            scores_pagination: 'Paginering av risikopoeng',
            config_dimensions: 'Konfigurasjon av poengdimensjoner',
            scores_loaded: '[[TOK_1]] risikopoeng lastet',
            weight_must_equal_100: 'Totalvekt må tilsvare 100 (gjeldende: [[TOK_1]])',
            out_of_10: 'av 10, vurdert til [[TOK_1]]',
            dimension_name: 'Dimensjon [[TOK_1]] navn',
            dimension_weight: '[[TOK_1]] vekt (prosent)',
            must_equal_100: 'må tilsvare 100',
            config_title: 'Poengrekning Konfigurasjon',
            scores_title: 'Leverandør Risiko Poeng',
            new_score_title: 'Poeng ein Leverandør',
            new: 'Ny Poeng',
            vendor_id: 'Leverandør ID',
            risk_tier: 'Risiko Nivå',
            score: 'Poeng',
            scored_at: 'Scoret At',
            no_scores: 'Ingen risiko poeng funne.',
            all_tiers: 'Alle Nivå',
            load_config_error: 'Kunne ikkje laste risikoscoringskonfigurasjon',
            update_config: 'Oppdater poengkonfigurasjon',
            update_config_error: 'Kunne ikkje oppdatere risikoscoringskonfigurasjon',
            load_scores_error: 'Kunne ikkje laste leverandørrisikopoeng',
            calculate_error: 'Kunne ikkje rekne ut leverandørrisikoscore',
            weight: 'vekt',
            score_range: 'Poeng (1-5)',
            method: 'Metode',
        },
        questionnaires: {
            title: 'Spørjeskjema',
            page_title: 'Spørreskjemaer fra leverandører',
            filter_questionnaires: 'Spørreskjemafiltre',
            questionnaire_views: 'Spørreskjemavisninger',
            templates_list: 'Liste over spørreskjemamaler',
            instances_list: 'Liste over forekomster av spørreskjema',
            filter_by_status: 'Filtrer etter spørreskjemastatus',
            templates_per_page: 'Maler per side',
            instances_per_page: 'Forekomster per side',
            select_template: 'Velg spørreskjemamal',
            template_category: 'Malkategori',
            templates_tab: 'Malar',
            instances_tab: 'Instansar',
            new: 'Ny Spørjeskjema',
            new_template: 'Ny mal',
            new_instance: 'Ny instans',
            vendor_id: 'Leverandør ID',
            template_id: 'Mal ID',
            assigned_to: 'Tildelt Til',
            due_date: 'Forfallsdato',
            responses: 'Svar',
            risk_score: 'Ferdigstilling',
            no_questionnaires: 'Ingen spørjeskjema funne.',
            load_templates_error: 'Kunne ikkje laste spørjeskjemamalar',
            load_instances_error: 'Kunne ikkje laste spørjeskjema',
            create_template_error: 'Kunne ikkje opprette spørjeskjemamal',
            initiate_error: 'Kunne ikkje starte spørjeskjema',
            submit_error: 'Kunne ikkje sende inn spørjeskjema',
            review_error: 'Kunne ikkje gjennomgå spørjeskjema',
            resubmit: 'Send inn på nytt',
            approve_error: 'Kunne ikkje godkjenne spørjeskjema',
            reject_error: 'Kunne ikkje avvise spørjeskjema',
            resubmit_error: 'Kunne ikkje sende inn spørjeskjema på nytt',
            templates_loaded: '[[TOK_1]] spørreskjemamaler lastet inn',
            instances_loaded: '[[TOK_1]] spørreskjemaforekomster lastet',
            fill_responses_cta: 'Fyll ut svar',
            fill_responses_title: 'Fyll ut svar på spørjeundersøking',
            template_missing: 'Mal ikkje funnen.',
            responses_saved: 'Svar lagra.',
            load_template_error: 'Kunne ikkje lasta inn mal.',
            version_history: 'Versjonshistorikk',
            download_previous_version: 'Last ned tidlegare versjon',
            trigger: 'Utløser',
            template_label: 'Mal',
            reviewer: 'Anmelder',
            reviewer_required: 'En korrekturleser må tildeles for [[TOK_1]] spørreskjemaer (separasjon av oppgaver).',
            select_option: 'Velg et alternativ',
            multi_choice_hint: 'Velg alt som passer',
            category_initial_onboarding: 'Første ombordstigning',
            category_annual_review: '�&rlig gjennomgang',
            category_incident_triggered: 'Hendelse utløst',
            category_contract_renewal: 'Kontraktsfornyelse',
            template_editor: {
                page_title: 'Rediger spørreskjemamal',
                preview_page_title: 'Forhåndsvis spørreskjemamal',
                edit_structure: 'Rediger struktur',
                preview: 'Forhåndsvisning',
                actions: 'Handlinger',
                back_to_list: 'Tilbake til maler',
                load_error: 'Kunne ikke laste inn malen',
                save_error: 'Kunne ikke lagre malstrukturen',
                saved: 'Malstrukturen er lagret.',
                sections_heading: 'Seksjoner',
                questions_heading: 'Spørsmål',
                add_section: 'Legg til seksjon',
                edit_section: 'Rediger seksjon',
                delete_section: 'Slett seksjon',
                move_section_up: 'Flytt delen opp',
                move_section_down: 'Flytt delen ned',
                confirm_delete_section: 'Vil du slette delen «[[TOK_1]]»? Alle spørsmålene vil bli fjernet.',
                section_title: 'Seksjonstittel',
                section_description: 'Seksjonsbeskrivelse',
                section_id: 'Seksjons-ID',
                section_id_hint: 'Automatisk generert med mindre du angir en eksplisitt.',
                no_sections: 'Ingen seksjoner ennå. Legg til en seksjon for å begynne.',
                no_questions: 'Ingen spørsmål i denne delen ennå.',
                add_question: 'Legg til spørsmål',
                edit_question: 'Rediger spørsmål',
                delete_question: 'Slett spørsmålet',
                move_question_up: 'Flytt spørsmålet opp',
                move_question_down: 'Flytt spørsmålet ned',
                confirm_delete_question: 'Vil du slette spørsmålet "[[TOK_1]]"?',
                question_text: 'Spørsmålstekst',
                question_type: 'Spørsmålstype',
                question_id: 'Spørsmåls-ID',
                evidence_required: 'Bevis kreves',
                risk_weight: 'Risikovekt',
                scoring_map: 'Scoringskart',
                scoring_map_json_hint: '[[TOK_0]] objektkartlegger svarverdier til numeriske poeng.',
                scoring_map_invalid_json: 'Poengkartet må være gyldig [[TOK_0]].',
                options_heading: 'Svaralternativer',
                add_option: 'Legg til alternativ',
                remove_option: 'Fjern alternativet',
                option_label: 'Etikett',
                option_value: 'Verdi',
                option_risk_weight: 'Risikovekt',
                min_options_error: 'Valgspørsmål må ha minst 2 alternativer.',
                option_label_required: 'Hvert alternativ trenger en etikett.',
                option_value_required: 'Hvert alternativ trenger en verdi.',
                option_value_unique: 'Alternativverdier må være unike.',
                branching_rules_heading: 'Forgreningsregler',
                branching_rules_hint: 'Vis eller skjul dette spørsmålet basert på svaret på et tidligere spørsmål.',
                add_branching_rule: 'Legg til forgreningsregel',
                remove_branching_rule: 'Fjern forgreningsregelen',
                branching_condition_question: 'Hvis spørsmål',
                branching_condition_value: 'har verdi',
                branching_action: 'deretter',
                branching_action_show: 'vis dette spørsmålet',
                branching_action_hide: 'skjul dette spørsmålet',
                branching_select_condition_question: 'Velg tidligere spørsmål',
                branching_select_condition_value: 'Velg verdi',
                save: 'Lagre struktur',
                saving: 'Lagrer...',
                cancel: 'Avbryt',
                close: 'Lukk',
                question_text_required: 'Spørsmålstekst er påkrevd.',
                section_title_required: 'Seksjonstittel er påkrevd.',
                type_single_choice: 'Enkeltvalg',
                type_multi_choice: 'Flervalg',
                type_free_text: 'Fri tekst',
                type_numeric: 'Numerisk',
                type_date: 'Dato',
                type_file_upload: 'Filopplasting',
                type_yes_no: 'Ja / Nei',
                preview_heading: 'Forhåndsvisning av mal',
                preview_subtitle: 'Skrivebeskyttet forhåndsvisning av hvordan spørreskjemaet ser ut for en leverandør.',
                preview_no_content: 'Denne malen har ingen seksjoner eller spørsmål ennå.',
                preview_branching_notice: 'Forgreningsreglene blir evaluert under utfylling; forhåndsvisning viser hvert spørsmål.',
            },
            review_modal: {
                title: 'Gjennomgå spørreskjemasvarene',
                open_cta: 'Gjennomgå',
                loading: 'Laster inn spørreskjema...',
                template_missing: 'Malen ble ikke funnet.',
                load_error: 'Kunne ikke laste inn spørreskjemaet for gjennomgang.',
                annotation_heading: 'Merknader',
                annotation_placeholder: 'Legg til en anmelderkommentar for dette spørsmålet...',
                annotation_status_label: 'Merknadsstatus',
                annotation_status_acceptable: 'Akseptabelt',
                annotation_status_concern: 'Bekymring',
                annotation_status_requires_action: 'Krever handling',
                review_comments_label: 'Generelle vurderingskommentarer',
                review_comments_placeholder: 'Oppsummer vurderingsfunnene dine...',
                justification_label: 'Begrunnelse for vedtak',
                justification_placeholder: 'Forklar begrunnelsen for avgjørelsen din...',
                reject_requires_comments: '�& avvise et spørreskjema krever gjennomgangskommentarer.',
                decision_heading: 'Beslutning',
                decision: {
                    approved: 'Godkjenne',
                    rejected: 'Avvis',
                    additional_info_requested: 'Be om ytterligere informasjon',
                },
                submit: 'Send inn anmeldelse',
                submitting: 'Sender inn anmeldelse...',
                cancel: 'Avbryt',
                submit_success: 'Anmeldelse sendt inn.',
                submit_error: 'Kunne ikke sende inn anmeldelse.',
                separation_of_duties_error: 'Du kan ikke se gjennom et spørreskjema du har fått i oppdrag å fylle ut. Separasjon av oppgaver krever en annen anmelder.',
                decision_required: 'Velg en vurderingsbeslutning.',
                announce_opened: 'Gjennomgangsmodal åpnet.',
                announce_submitted: 'Anmeldelse sendt inn.',
            },
            instance_detail: {
                submitted_at: 'Sendt inn',
                reviewed_at: 'Anmeldt',
                reviewer: 'Anmelder',
                review_decision: 'Beslutning',
                review_comments: 'Gjennomgå kommentarer',
                decision_approved: 'Godkjent',
                decision_rejected: 'Avvist',
                decision_additional_info_requested: 'Mer info etterspurt',
                decision_pending: 'Venter på vurdering',
                expand_comments: 'Vis fullstendige kommentarer',
                collapse_comments: 'Skjul hele kommentarer',
                no_reviewer: 'Ingen anmelder tildelt',
            },
            export: {
                portfolio_label: 'Eksportportefølje',
                instance_label: 'Eksporter',
                portfolio_success: 'Porteføljeeksport klar.',
                instance_success: 'Spørreskjemaeksport klar.',
                portfolio_error: 'Kunne ikke eksportere spørreskjemaporteføljen.',
                instance_error: 'Kunne ikke eksportere spørreskjemaet.',
            },
            branching: {
                hidden_notice: 'Noen spørsmål er skjult av forgreningsregler.',
                cycle_warning: 'En syklus ble oppdaget i forgreningsregler. Berørte spørsmål er som standard synlige.',
            },
        },
        contracts: {
            title: 'Kontraktar',
            page_title: 'Leverandørkontrakter',
            new: 'Ny Kontrakt',
            vendor_id: 'Leverandør ID',
            filter_contracts: 'Filtrer kontrakter',
            filter_by_document_type: 'Filtrer etter dokumenttype',
            filter_by_status: 'Filtrer etter kontraktstatus',
            per_page: 'Kontrakter per side',
            expired_notice: 'Denne kontrakten er utløpt',
            document_type: 'Dokument Type',
            expiry_date: 'Utløp Dato',
            no_contracts: 'Ingen kontraktar funne.',
            all_document_types: 'Alle Dokument Typar',
            load_error: 'Kunne ikkje laste kontraktar',
            create_error: 'Kunne ikkje opprette kontrakt',
            delete_error: 'Kunne ikkje slette kontrakt',
            update_error: 'Kunne ikkje oppdatere status',
            confirm_delete: 'Slett kontrakt "{title}"?',
            renewal_date: 'Fornying Dato',
            effective_date: 'Gjeldande Dato',
            parties: 'Partar',
            summary: 'Samandrag',
            n_contracts: '{count} kontraktar',
            n_contract: '{count} kontrakt',
            contracts_loaded: '{count} kontraktar lasta',
            doc_type_dpa: 'DPA',
            doc_type_security_addendum: 'Tryggingstillegg',
            doc_type_scc_annex: 'SCC-vedlegg',
            doc_type_sub_processor_list: 'Underdatabehandlarliste',
            doc_type_bcr: 'BCR',
            doc_type_nda: 'NDA',
            doc_type_msa: 'MSA',
            doc_type_sla: 'SLA',
            doc_type_other: 'Anna',
            status_draft: 'Utkast',
            status_under_negotiation: 'Under forhandling',
            status_pending_signature: 'Ventar på signatur',
            status_active: 'Aktiv',
            status_expired: 'Utgått',
            status_terminated: 'Avslutta',
            status_superseded: 'Erstatta',
        },
        gates: {
            title: 'Godkjenningsportar',
            page_title: 'Portevalueringer',
            new: 'Ny Port Evaluering',
            vendor_id: 'Leverandør ID',
            gate_name: 'Port Namn',
            outcome: 'Resultat',
            evaluator: 'Evaluerar',
            no_gates: 'Ingen port evalueringar funne.',
            load_error: 'Kunne ikkje laste portevalueringar',
            evaluate_error: 'Kunne ikkje evaluere leverandørport',
            detail_error: 'Kunne ikkje hente evalueringsdetalj',
            override_error: 'Kunne ikkje overstyre portevaluering',
            criteria_results: 'Kriterium Resultat',
            evaluate_form: 'Vurder leverandørporten',
            per_page: 'Evalueringer per side',
            passed: 'Bestått',
            failed: 'Mislukkast',
            override: 'Overstyr',
            override_justification: 'Overstyring Grunngiving',
            override_placeholder: 'Oppgje grunngiving for at tilsidesætte denne portevaluering',
            approval_id: 'Godkjenning ID',
            overall_passed: 'Bestått',
            overall_failed: 'Ikkje bestått',
            overall_overridden: 'Overstyrt',
            evaluations_loaded: '{count} portvurderingar lasta',
            create_approval_cta: 'Opprett godkjenning',
        },
        reviews: {
            title: 'Leverandørvurderingar',
            page_title: 'Leverandøranmeldelser',
            new: 'Ny Gjennomgang',
            vendor_id: 'Leverandør ID',
            filter_by_outcome: 'Filtrer etter vurderingsresultat',
            per_page: 'Anmeldelser per side',
            kpi_summary: 'Se gjennom [[TOK_0]] sammendraget',
            review_outcome_label: 'Gjennomgå resultatet',
            edit_outcome: 'Rediger vurderingsresultatet',
            reviews_loaded: '[[TOK_1]] leverandøranmeldelser lastet inn',
            reviewer: 'Gjennomgåar',
            review_type: 'Gjennomgang Type',
            outcome: 'Resultat',
            findings: 'Funn',
            no_reviews: 'Ingen leverandør gjennomgangar funne.',
            load_kpis_error: 'Kunne ikkje hente leverandørgjennomgangs-KPI-ar',
            load_error: 'Kunne ikkje hente leverandørgjennomgangar',
            update_error: 'Kunne ikkje oppdatere leverandøromtalen',
            create_error: 'Kunne ikkje opprette leverandørgjennomgang',
            total_reviewed: 'Totalt leverandørar gjennomgått',
            total_reviews: 'Totalt Gjennomgangar',
            satisfactory: 'Tilfredsstillande',
            concerns_identified: 'Bekymringar identifiserte',
            remediation_required: 'Utbetring Påkravd',
            escalated: 'Eskalert',
            program_id: 'Program-ID',
            period_id: 'Periode ID',
            task_id: 'Oppgåve ID',
            recommendations: 'Tilrådingar',
        },
        risk_signals: {
            title: 'Risikosignal',
            page_title: 'Risikosignaler',
            new_signal: 'Nytt risikosignal',
            signal_type: 'Signaltype',
            severity: 'Alvorlegheitsgrad',
            description: 'Skildring',
            source: 'Kjelde',
            vendor_id: 'Leverandør-ID',
            certification_expiry: 'Sertifiseringsutløp',
            breach_notification: 'Brotvarsling',
            financial_instability: 'Finansiell ustabilitet',
            compliance_change: 'Samsvarsendring',
            custom: 'Eigendefinert',
            active: 'Aktiv',
            acknowledged: 'Stadfesta',
            resolved: 'Løyst',
            no_signals: 'Ingen risikosignal funne',
            source_external_feed: 'Ekstern kjelde',
            source_manual: 'Manuell',
            source_integration: 'Integrasjon',
            source_regulatory: 'Regulatorisk',
            source_media: 'Media',
            trigger_reassessment_prompt: 'Dette signalet er høg alvorlegheit. Starte ny vurdering av leverandøren no?',
            reassessment_triggered: 'Ny vurdering starta.',
            reassessment_trigger_error: 'Kunne ikkje starte ny vurdering.',
        },
        reassessments: {
            title: 'Revurderingsoppgåver',
            page_title: 'Revurderingsoppgaver',
            trigger: 'Utløys revurdering',
            trigger_success: 'Revurdering utløyst',
            reason: '�&rsak',
            deadline: 'Tidsfrist',
            assigned_to: 'Tildelt til',
            vendor_id: 'Leverandør-ID',
            outcome: 'Resultat',
            new_risk_level: 'Nytt risikonivå',
            complete: 'Fullfør revurdering',
            complete_success: 'Revurdering fullført',
            pending: 'Ventar',
            in_progress: 'Pågår',
            completed: 'Fullført',
            cancelled: 'Avbroten',
            no_tasks: 'Ingen revurderingsoppgåver funne',
            risk_trend: 'Risikotrend',
            notes: 'Notat',
        },
        portfolio: {
            title: 'Risikoportefølje',
            page_title: 'Risikoportefølje',
            dashboard: 'Porteføljeoversikt',
            vendor_id: 'Leverandør-ID',
            total_vendors: 'Totalt tal leverandørar',
            average_score: 'Gjennomsnittleg risikoscore',
            high_risk_count: 'Høgrisikoleverandørar',
            trend_direction: 'Trendretning',
            improved: 'Forbetra',
            stable: 'Stabil',
            degraded: 'Forverra',
            vendor_trend: 'Leverandørtrend',
            outstanding_questionnaires: 'Uteståande spørjeskjema',
            overdue_assessments: 'Forfalne vurderingar',
            no_outstanding: 'Ingen uteståande spørjeskjema',
            no_overdue: 'Ingen forfalne vurderingar',
            due_date: 'Forfallsdato',
        },
        risk_acceptance: {
            title: 'Risikoakseptregister',
            page_title: 'Risikoakseptregister',
            new_acceptance: 'Ny risikoaksept',
            vendor_id: 'Leverandør-ID',
            risk_level: 'Risikonivå',
            conditions: 'Vilkår',
            justification: 'Grunngjeving',
            expiry_date: 'Utløpsdato',
            create_success: 'Risikoaksept oppretta',
            review_condition: 'Gjennomgå vilkår',
            condition_met: 'Vilkår oppfylt',
            condition_not_met: 'Vilkår ikkje oppfylt',
            review_success: 'Vilkår gjennomgått',
            export_register: 'Eksporter register',
            active: 'Aktiv',
            expired: 'Utløpt',
            revoked: 'Tilbakekalla',
            no_acceptances: 'Ingen risikoakseptar funne',
            met_count: '[[TOK_2]]/[[TOK_3]] møtt',
        },
        review_routing: {
            title: 'Gjennomgangsruting',
            page_title: 'Gjennomgå ruting',
            route_to_reviewers: 'Send til gjennomgangarar',
            route_success: 'Sendt til gjennomgangarar',
            vendor_id: 'Leverandør-ID',
            reviewer_id: 'Gjennomgangar-ID',
            reviewer_role: 'Gjennomgangarrolle',
            questionnaire_id: 'Spørjeskjema-ID',
            review_status: 'Gjennomgangsstatus',
            reviewers_label: 'Anmeldere (user_id, rolle per linje)',
            pending: 'Ventar',
            in_review: 'Under gjennomgang',
            completed: 'Fullført',
            no_routing: 'Ingen gjennomgangsruting funne',
            primary_reviewer: 'Primær gjennomgangar',
            secondary_reviewer: 'Sekundær gjennomgangar',
            approver: 'Godkjennar',
        },
        onboarding: {
            title: 'Leverandør-onboarding-saker',
            page_title: 'Leverandør-onboarding-saker',
            new_case: 'Ny onboarding-sak',
            case_detail: 'Onboarding-sak',
            open_mps_dossier_filing: 'Opne MPS-innsending',
            dossier_filing_description: 'Opprettar ei ny MPS-innsending førehandsutfylt frå denne onboarding-saka. Innsendinga vert kopla tilbake til saka.',
            dossier_filing_dpia_id: 'DPIA-ID',
            dossier_filing_dpia_id_placeholder: 't.d. dpia_01TEST000000000000000001',
            dossier_filing_title: 'Innsendingstittel',
            dossier_filing_form_type: 'Skjematype',
            dossier_filing_submit: 'Opprett innsending',
            dossier_filing_validation_error: 'DPIA-ID og tittel er påkravde.',
            dossier_filing_created: 'MPS-innsending oppretta',
            dossier_filing_error: 'Kunne ikkje opprette MPS-innsending.',
            linked_questionnaire_due_date: 'Forfallsdato',
            linked_questionnaire_assignee: 'Tildelt',
            linked_questionnaire_submitted_at: 'Sendt inn',
            score_last_scored: 'Sist skåra',
            score_dimensions: 'Dimensjonar',
            linked_contract_document_type: 'Dokumenttype',
            linked_contract_effective_date: 'Verkedato',
            linked_contract_expiry_date: 'Utløpsdato',
            linked_sub_processor_countries: 'Handsamingsland',
            linked_sub_processor_last_assessment: 'Siste vurdering',
            linked_sub_processor_next_assessment: 'Neste vurdering',
            case_id: 'Sak-ID',
            vendor: 'Leverandør',
            case_type: 'Sakstype',
            service_description: 'Tenestebeskriving',
            data_categories: 'Datakategoriar',
            systems_accessed: 'Tilgangne system',
            jurisdiction: 'Jurisdiksjon',
            hosting_model: 'Vertsmodell',
            controller_role: 'Behandlingsansvarleg/Databehandlar-rolle',
            status_pipeline: 'Statuspipeline',
            tabs_label: 'Onboarding-saksseksjonar',
            per_page: 'Saker per side',
            filter_cases: 'Filtrer onboarding-saker',
            cases_count: 'saker',
            cases_loaded: 'onboarding-saker lasta',
            no_cases: 'Ingen onboarding-saker funne.',
            vendor_lookup_placeholder: 'Skriv inn leverandør-ID',
            data_categories_placeholder: 't.d., persondata, finans, helse',
            systems_placeholder: 't.d., CRM, ERP, HR-system',
            status_open: '�&pne',
            status_in_progress: 'Pågår',
            status_awaiting_approval: 'Ventar på godkjenning',
            status_approved: 'Godkjend',
            status_remediation_required: 'Utbetring påkravd',
            status_closed: 'Lukka',
            type_new_vendor: 'Ny leverandør',
            type_service_change: 'Tenesteendring',
            type_renewal: 'Fornying',
            type_reassessment: 'Revurdering',
            tab_overview: 'Oversikt',
            tab_due_diligence: 'Aktsemd',
            tab_security_assessment: 'Tryggleiksvurdering',
            tab_contractual_controls: 'Kontraktuelle kontrollar',
            tab_sub_processors: 'Underdatabehandlarar',
            tab_approval_gates: 'Godkjenningsportar',
            tab_evidence: 'Dokumentasjon',
            tab_placeholder: 'Innhaldet i denne seksjonen vert fylt ut under onboarding-prosessen.',
            completion_not_started: 'Ikkje starta',
            completion_in_progress: 'Pågår',
            completion_completed: 'Fullført',
            completion_requiring_attention: 'Krev merksemd',
            gate_name: 'Portnamn',
            approver: 'Godkjennar',
            decision: 'Avgjerd',
            comments: 'Kommentarar',
            decide: 'Ta avgjerd',
            decision_approved: 'Godkjend',
            decision_rejected: 'Avvist',
            decision_deferred: 'Utsett',
            no_approvals: 'Ingen godkjenningsportar konfigurerte for denne saka.',
            approval_success: 'Godkjenningsavgjerd registrert',
            approval_error: 'Kunne ikkje registrere godkjenningsavgjerd',
            transition_status: 'Endre status',
            confirm_transition: 'Endre sak frå "{from}" til "{to}"?',
            transition_success: 'Saksstatus endra',
            transition_error: 'Kunne ikkje endre saksstatus',
            create_success: 'Onboarding-sak oppretta',
            create_error: 'Kunne ikkje opprette onboarding-sak',
            load_error: 'Kunne ikkje laste onboarding-saker',
            detail_error: 'Kunne ikkje laste saksdetaljar',
            export: 'Eksporter',
            export_error: 'Kunne ikkje eksportere onboarding-sak',
            evidence_tab_description: 'Last opp og eksporter bevis for onboarding-saka.',
            upload_evidence_label: 'Last opp bevis',
            attached_evidence_heading: 'Vedlagde bevis',
            no_evidence_attached: 'Ingen bevis vedlagt enno.',
            export_bundle_button: 'Eksporter bevispakke',
            load_attachments_error: 'Kunne ikkje lasta inn bevis.',
            linked_questionnaires_heading: 'Lenka spørjeundersøkingar',
            no_linked_questionnaires: 'Ingen lenka spørjeundersøkingar.',
            linked_scores_heading: 'Lenka risikovurderingar',
            no_linked_scores: 'Ingen lenka vurderingar.',
            latest_score_label: 'Siste vurdering',
            linked_contracts_heading: 'Lenka kontraktar',
            no_linked_contracts: 'Ingen lenka kontraktar.',
            linked_sub_processors_heading: 'Lenka underleverandørar',
            no_linked_sub_processors: 'Ingen lenka underleverandørar.',
        },
        sub_processors: {
            title: 'Register over underdatabehandlarar',
            page_title: 'Register over underdatabehandlarar',
            new_record: 'Ny underdatabehandlar',
            edit_record: 'Rediger underdatabehandlar',
            onboarding_case: 'Onboarding-sak',
            services: 'Leverte tenester',
            data_categories: 'Datakategoriar',
            processing_countries: 'Behandlingsland',
            dpa_chain_status: 'DPA-kjedestatus',
            certifications: 'Sertifiseringar',
            last_assessment: 'Siste vurdering',
            next_assessment: 'Neste vurdering',
            change_history: 'Endringshistorikk',
            history: 'Historikk',
            changed_by: 'Endra av',
            comma_separated: 'Kommaseparerte verdiar',
            filter_records: 'Filtrer oppføringar',
            filter_by_dpa: 'Filtrer etter DPA-kjedestatus',
            all_dpa_statuses: 'Alle DPA-statusar',
            per_page: 'Oppføringar per side',
            records_count: 'underdatabehandlarar',
            records_loaded: 'oppføringar lasta',
            no_records: 'Ingen underdatabehandlarar funne.',
            no_history: 'Ingen endringshistorikk tilgjengeleg.',
            dpa_active: 'Aktiv',
            dpa_pending: 'Ventande',
            dpa_expired: 'Utløpt',
            dpa_not_required: 'Ikkje påkravd',
            create_success: 'Underdatabehandlar oppretta',
            create_error: 'Kunne ikkje opprette underdatabehandlar',
            update_success: 'Underdatabehandlar oppdatert',
            update_error: 'Kunne ikkje oppdatere underdatabehandlar',
            load_error: 'Kunne ikkje laste registeret',
            history_error: 'Kunne ikkje laste endringshistorikk',
            export_csv: 'Eksporter CSV',
            export_json: 'Eksporter JSON',
            export_error: 'Kunne ikkje eksportere data',
        },
    },
    deletion_orchestration: {
        nav: {
            dashboard: 'Orkestreringsoversikt',
            runs: 'Orkestreringskøyringar',
            tasks: 'Utføringsoppgåver',
            templates: 'Sjekkllistemalar',
            vendor_requests: 'Leverandørførespurnader',
            proof_chain: 'Beviskjede',
            dsr_integration: 'DSR-integrasjon',
            vendor_verification: 'Leverandørverifisering',
            completeness: 'Fullstendigheitsoversikt',
        },
        dashboard: {
            title: 'Orkestreringsoversikt',
            loading: 'Lastar dashborddata...',
            active_runs: 'Aktive Køyringar',
            completion_rate: 'Ferdigstilling Rate',
            avg_completion_time: 'Gj.sn. Ferdigstilling Tid',
            overdue_tasks: 'Forsinka Oppgåver',
            vendor_compliance: 'Leverandør Etterleving',
            recent_runs: 'Nyleg Køyringar',
            no_recent_runs: 'Ingen recent orchestration runs.',
            run_id: 'Køyring ID',
            ticket_id: 'Sak ID',
            progress: 'Framdrift',
            systems: 'System',
            vendors: 'Leverandørar',
            load_error: 'Kunne ikke laste inn orkestreringsdashbordet. Vennligst prøv igjen.',
            aria_table: 'Nylige orkestreringsløp',
        },
        runs: {
            title: 'Orkestreringskøyringar',
            new: 'Ny Køyring',
            run_id: 'Køyring ID',
            ticket_id: 'Sak ID',
            progress: 'Framdrift',
            systems: 'System',
            vendors: 'Leverandørar',
            data_subject_ref: 'Data Emne Ref',
            data_categories: 'Data Kategoriar',
            enable_proof_chain: 'Aktiver Bevis Kjede',
            start: 'Start',
            started: 'Løpet startet',
            mark_ready: 'Merk klar',
            marked_ready: 'Kjør merket som klar',
            complete: 'Komplett',
            complete_exceptions: 'Komplett med unntak',
            pause: 'Pause',
            resume: 'Fortsett',
            cancel: 'Avbryt',
            no_runs: 'Ingen orchestration runs funne.',
            load_error: 'Kunne ikke laste inn orkestreringskjøringer. Vennligst prøv igjen.',
            create_error: 'Kunne ikke opprette orkestreringskjøring',
            aria_filter_status: 'Filtrer etter kjørestatus',
            aria_table: 'Orkestrering kjører',
            placeholder_ticket_id: 'f.eks. TKT-000123',
            placeholder_data_subject_ref: 'f.eks. DS-REF-001',
            placeholder_data_categories: 'f.eks. personal_data, økonomisk, helse',
            title_label: 'Title',
            run_type: 'Run Type',
            run_type_labels: {
                data_subject_request: 'Data Subject Request',
                retention_expiry: 'Retention Expiry',
                manual: 'Manual',
                scheduled: 'Scheduled',
            },
            field_guidelines: {
                title: 'A descriptive name for this orchestration run.',
                run_type: 'The origin or trigger for the deletion process.',
                ticket_id: 'The associated ticket ID from your DSR or support system.',
                data_subject_ref: 'A unique identifier for the data subject (e.g., internal ID, email hash).',
                data_categories: 'Specific categories of personal data to be deleted (comma-separated).',
                proof_enabled: 'Maintains an immutable cryptographic chain of evidence for this run.',
            },
            actions: 'Actions',
            progress_guideline: 'Calculated based on completed system tasks and vendor requests.',
            placeholder_title: 'e.g., Q2 2026 Customer Deletion Batch',
        },
        tasks: {
            title: 'Utføringsoppgåver',
            task_id: 'Oppgåve ID',
            run_id: 'Køyring ID',
            system_name: 'System Namn',
            assigned_to: 'Tildelt Til',
            sla_deadline: 'SLA Frist',
            progress: 'Framdrift',
            enter_run_id: 'Oppgje Køyring ID to filtrer...',
            select_run: 'Velg en kjøring for å se oppgaver',
            unassigned: 'Ikkje tildelt',
            overdue: 'Forsinka',
            assign_task: 'Tildel Oppgåve',
            assignee_id: 'Tilordna-ID',
            update_status: 'Oppdatering Status',
            new_status: 'Ny Status',
            no_transitions: 'Denne oppgåva er i ein endeleg tilstand og kan ikkje endre status.',
            select_status_placeholder: 'Vel ein ny status',
            skip_justification: 'Grunngjeving for hopp over',
            failure_reason: 'Årsak til feil',
            no_tasks: 'Ingen utføring oppgåver funne.',
            new_task: 'Ny oppgave',
            system_id: 'System-ID',
            data_classification: 'Dataklassifisering',
            load_error: 'Kunne ikkje laste execution tasks. Prøv igjen.',
            assign_error: 'Kunne ikkje assign task',
            status_error: 'Kunne ikkje oppdatere oppgåvestatus',
            no_tasks_for_run: 'Denne slettekøyringa har ingen utføringsoppgåver enno.',
            aria_filter_run_id: 'Filtrer etter kjøre-ID',
            aria_filter_status: 'Filtrer etter oppgavestatus',
            aria_table: 'Utførelsesoppgaver',
            view_steps: 'Vis steg',
            steps_modal_title: 'Utføringssteg',
            step_title: 'Steg',
            step_status: 'Stegstatus',
            step_notes: 'Notat',
            step_evidence: 'Bevisfiler',
            step_evidence_required: 'Bevis er nødvendig for dette steget',
            step_evidence_missing: 'Ingen bevis lasta opp enno',
            step_save: 'Lagre steg',
            step_saved: 'Steg oppdatert',
            step_save_error: 'Kunne ikkje oppdatere steget',
            create_success: 'Utføringsoppgåve oppretta',
            create_error: 'Kunne ikkje opprette utføringsoppgåve',
            step_upload_label: 'Legg ved bevis',
        },
        templates: {
            title: 'Sjekkllistemalar',
            new: 'Ny Mal',
            template_id: 'Mal ID',
            system_type: 'Systemtype',
            est_duration: 'Ansl.. Varigheit',
            steps: 'Steg',
            action_type: 'Handling Type',
            instructions: 'Instruksjonar',
            mandatory: 'Obligatorisk',
            add_step: 'Add Steg',
            step_n: 'Steg',
            no_templates: 'Ingen sjekkliste malar funne.',
            all_system_types: 'Alle System Typar',
            load_error: 'Kunne ikke laste inn sjekklistemaler. Vennligst prøv igjen.',
            create_error: 'Kunne ikke opprette mal for sjekkliste',
            aria_filter_system_type: 'Filtrer etter systemtype',
            aria_filter_status: 'Filtrer etter malstatus',
            aria_table: 'Sjekklistemaler',
            placeholder_name: 'f.eks. sjekkliste for sletting av database',
            guideline_name: 'Use a clear operating name, for example “Database Deletion Checklist”.',
            guideline_system_type: 'Choose the system category this checklist will usually run against.',
            guideline_status: 'Draft templates can be reviewed before activation; active templates can be reused in runs.',
            guideline_description: 'Summarise scope, retention context, and when teams should select this template.',
            update_success: 'Malen vart oppdatert',
            create_success_msg: 'Malen vart oppretta',
            update_error: 'Kunne ikkje oppdatere malen',
            activate_success: 'Malen vart aktivert',
            activate_error: 'Kunne ikkje aktivere malen',
            archive_success: 'Malen vart arkivert',
            archive_error: 'Kunne ikkje arkivere malen',
            clone_success: 'Malen vart klona',
            clone_error: 'Kunne ikkje klone malen',
        },
        vendor_requests: {
            title: 'Leverandør Sletting Førespurnader',
            new: 'Ny Førespurnad',
            request_id: 'Førespurnad ID',
            vendor_name: 'Leverandør Namn',
            vendor_id: 'Leverandør ID',
            data_subject_ref: 'Data Emne Ref',
            data_categories: 'Data Kategoriar',
            legal_basis: 'Rettsleg grunnlag',
            sla_days: 'SLA Dagar',
            requested_completion: 'Anmodet færdiggørelse',
            communications: 'Kommunikasjonar',
            total_requests: 'Totalt Førespurnader',
            no_requests: 'Ingen leverandør sletting førespurnader funne.',
            filter_vendor_id: 'Filter etter Leverandør ID...',
            change_status: 'Endre Status',
            new_status: 'Ny Status',
            actions: 'Handlingar',
            load_error: 'Kunne ikke laste inn forespørsler om leverandørsletting. Vennligst prøv igjen.',
            create_error: 'Kunne ikke opprette forespørsel om leverandørsletting',
            dashboard_error: 'Kunne ikke laste inn kontrollpanelet for leverandørsletting. Vennligst prøv igjen.',
            aria_filter_status: 'Filtrer etter forespørselsstatus',
            aria_filter_vendor_id: 'Filtrer etter leverandør-ID',
            aria_table: 'Forespørsler om sletting fra leverandører',
            placeholder_vendor_id: 'f.eks. VND-001',
            placeholder_vendor_name: 'f.eks. Acme Analytics',
            placeholder_data_subject_ref: 'f.eks. DS-REF-001',
            placeholder_data_categories: 'f.eks. personal_data, analyser',
            placeholder_legal_basis: 'f.eks. [[TOK_0]] artikkel 19',
        },
        proof_chain: {
            title: 'Bevis Kjede Lesar',
            enter_run_id: 'Oppgje Køyring ID...',
            load_chain: 'Last Kjede',
            verify_chain: 'Verifiser Kjede',
            verifying: 'Verifiserer...',
            chain_valid: 'Kæden er gyldig',
            chain_invalid: 'Kjede er broten',
            chain_length: 'Kjede Lengd',
            broken_at_index: 'Broten ved indeks',
            no_proof_records: 'Ingen proof records found for this run.',
            proof_id: 'Bevis ID',
            entity_type: 'Eining Type',
            entity_id: 'Eining ID',
            event_hash: 'Hending Hash',
            previous_hash: 'Førre Hash',
            attestation: 'Attestering',
            attestation_actor: 'Utført av',
            attestation_signed_at: 'Signert',
            attestation_signature: 'Signatur',
            attestation_evidence_refs: 'Bevisreferansar',
            run_field_label: 'Slettekøyring',
            select_run: 'Vel ei slettekøyring…',
            aria_select_run: 'Slettekøyring for oppslag i beviskjeda',
            chain_broken_here: 'Kæde brudt her',
            load_error: 'Kunne ikke laste den sikre kjeden. Vennligst prøv igjen.',
            verify_error: 'Kunne ikke bekrefte beviskjeden. Vennligst prøv igjen.',
            aria_run_id: 'Kjør ID for bevis kjedeoppslag',
        },
        dsr_integration: {
            change_status: 'Endre status',
            request_type: 'Førespurnadstype',
            data_subject_hint: 'Identifikator for den registrerte som data blir sletta for (t.d. e-post eller kunde-ID). Samsvarar vanlegvis med førespurnaden på den valde DSR-saka.',
            title: 'DSR-slettingsintegrasjon',
            create_run: 'Opprett DSR-slettingskøyring',
            dsr_case_id: 'DSR-saks-ID',
            data_subject_id: 'Registrert sin ID',
            systems: 'Målsystem',
            route_to_department: 'Send til avdeling',
            confirm_deletion: 'Stadfest sletting',
            no_runs: 'Ingen DSR-slettingskøyringar funne',
            status: 'Slettingsstatus',
            deadline: 'Frist',
        },
        vendor_verification: {
            title: 'Leverandørslettingsverifisering',
            create_followup: 'Opprett oppfølging',
            deadline: 'Stadfestingsfrist',
            escalation_contact: 'Eskaleringskontakt',
            record_confirmation: 'Registrer stadfesting',
            overdue: 'Forfalne slettingar',
            escalate: 'Eskaler',
            confirm_escalation: 'Er du sikker på at du vil eskalere denne leverandørslettingsførespurnaden?',
            no_followups: 'Ingen leverandøroppfølgingar funne',
            no_overdue: 'Ingen forfalne leverandørslettingar',
            vendor_request: 'Leverandørforespørsel',
            vendor: 'Leverandør',
            unknown_vendor: 'Ukjend leverandør',
            overdue_badge: 'Forfallen',
            mark_confirmed: 'Merk som stadfesta',
            mark_confirmed_for: 'Merk sletting som stadfesta for {vendor}',
            confirm_confirmation: 'Merke denne leverandørslettinga som stadfesta?',
            confirmation_success: 'Leverandørsletting stadfesta',
            confirmation_failed: 'Kunne ikkje stadfeste leverandørsletting',
            select_request: 'Vel ein leverandørforespørsel…',
            escalation_contact_placeholder: 'f.eks. dpo@vendor.example',
            create_success: 'Leverandøroppfølging oppretta',
            create_failed: 'Kunne ikkje opprette leverandøroppfølging',
            deadline_hint: 'Denne sida viser berre oppfølgingar der fristen allereie er passert.',
            deadline_future_warning: 'Denne fristen er i framtida, så oppfølginga blir ikkje vist i lista over forfalne før datoen har passert.',
            escalation_success: 'Leverandørsletting ble eskalert',
            escalation_failed: 'Kunne ikke eskalere leverandørsletting',
        },
        completeness: {
            title: 'Slettingsfullstende',
            check_conflicts: 'Kontroller oppbevaringskonfliktar',
            no_conflicts: 'Ingen oppbevaringskonfliktar funne',
            conflict_resolution: 'Konfliktløysing',
            extend_retention: 'Forleng oppbevaring',
            proceed_deletion: 'Hald fram med sletting',
            escalate_conflict: 'Eskaler',
            resolve: 'Løys konflikt',
            data_subject_id: 'Datasubjekt-ID',
            placeholder_data_subject_id: 'Angi datasubjekt-ID',
            data_subject_hint: 'Identifikator for personen som du verifiserer sletting for (t.d. e-post, kunde-ID eller DSR-referanse). Vel eit kjent subjekt eller skriv inn eitt.',
            guidance: 'Skriv inn eller vel ein datasubjekt-ID, vel eventuelt system, og køyr kontrollen for å sjå sletteomfang og oppbevaringskonfliktar.',
            completion: 'Slettegrad',
            pending_items: 'Ventande element',
            system: 'System',
            policy: 'Retningslinje',
            retention_end: 'Oppbevaringsslutt',
            completed_items: 'Fullførte Element',
            last_review_label: 'Siste anmeldelse',
            days_ago: 'dager siden',
            review_overdue: 'Gjennomgangssyklusen er overskredet. Ny gjennomgang kreves.',
        },
        run_status_labels: {
            pending: 'Ventar',
            planning: 'Planlegging',
            ready: 'Klar',
            in_progress: 'Pågår',
            paused: 'Pausa',
            completed: 'Fullført',
            completed_with_exceptions: 'Fullført med Unntak',
            cancelled: 'Avbrote',
        },
        task_status_labels: {
            pending: 'Ventande',
            assigned: 'Tildelt',
            in_progress: 'Pågår',
            awaiting_verification: 'Ventar på Verifisering',
            verified: 'Verifisert',
            failed: 'Feila',
            skipped: 'Hoppa Over',
        },
        system_type_labels: {
            database: 'Database',
            saas_application: 'SaaS-applikasjon',
            file_storage: 'Fillagring',
            email_system: 'E-postsystem',
            analytics_platform: 'Analyseplattform',
            backup_system: 'Tryggleiksystem',
            vendor_managed: 'Leverandørstyrt',
            custom: 'Tilpassa',
        },
        template_status_labels: {
            draft: 'Utkast',
            active: 'Aktiv',
        },
        action_type_labels: {
            manual_check: 'Manuell Kontroll',
            api_call: 'API-kall',
            sql_query: 'SQL-spørjing',
            script_execution: 'Skriptkøyring',
            file_deletion: 'Filsletting',
            verification: 'Verifisering',
            notification: 'Varsling',
            approval: 'Godkjenning',
        },
        request_status_labels: {
            draft: 'Utkast',
            sent: 'Sendt',
            acknowledged: 'Stadfesta',
            in_progress: 'Pågår',
            completed: 'Fullført',
            overdue: 'Forfalle',
            escalated: 'Eskalert',
            disputed: 'Omstridd',
        },
        event_type_labels: {
            initiation: 'Oppstart',
            data_deletion: 'Datasletting',
            completion: 'Fullføring',
            verification: 'Verifisering',
            rollback: 'Tilbakerulling',
        },
        count_labels: {
            one_template: '1 mal',
            n_templates: '{n} malar',
            one_run: '1 køyring',
            n_runs: '{n} køyringar',
            one_task: '1 oppgåve',
            n_tasks: '{n} oppgåver',
            one_request: '1 førespurnad',
            n_requests: '{n} førespurnader',
        },
        aria: {
            completion_rate: 'Fullføringsgrad: {pct}%',
            vendor_compliance: 'Leverandøretterleving: {pct}%',
            run_progress: 'Køyringsframgang: {pct}%',
            run_progress_systems: 'Framgang: {completed} av {total} system handsama',
            chain_broken: 'Kjede broten ved denne posten',
            chain_valid: 'Kjede gyldig ved denne posten',
            chain_unknown: 'Kjedestatus ukjend',
            escalate_vendor: 'Eskaler {id}',
            resolve_conflict: 'Løys konflikt for {system}',
        },
        regulatory: {
            annual_review_cycle_info: 'Fullstendigheten av slettingen må vurderes minst hver 365. dag. Oppføringer som overskrider denne terskelen blir flagget for obligatorisk ny gjennomgang for å opprettholde regelmessig samsvar.',
            runs_data_d1_lifecycle_info: 'Orkestrasjonskjøringstilstander kartlegger til DATA-D1 livssyklus: planlegging = katalog, klar = klassifiser, in_progress = bruk regler, fullført = bevis generert, completed_with_exceptions = gjennomgang nødvendig. Hver overgang registreres i prøvekjeden.',
            vendor_record_linkage_info: 'Hver forespørsel om leverandørsletting er knyttet til leverandørposten via vendor_id. Fullføringsbekreftelse krever kryptografisk bevis fra beviskjeden før forespørselen kan merkes som fullført.',
            templates_internal_classification_info: 'Alle sjekklistemaler for sletting er klassifisert som interne organisasjonsdokumenter. De har ikke offisielle ID-er for forskriftsskjemaer og skal ikke sendes inn som forskriftsdokumenter.',
            proof_chain_evidence_info: 'Hver bevispost fanger opp datasubjektet/kategorien, tidsstempelet, aktøren, juridisk grunnlag og en SHA-256-hash. Sammen produserer disse feltene kryptografisk slettebevis som tilfredsstiller regulatoriske revisjonskrav.',
            retention_data_law_info: 'Oppbevaringsplaner på dette dashbordet er avledet fra datalovklassifiseringen som er tildelt hver datakategori. Når en klassifisering endres, oppdateres tilknyttede oppbevaringsregler automatisk for å sikre regulatorisk tilpasning.',
            dsr_erasure_route_info: 'DSR-slettekjøringer er knyttet til den opprinnelige Rights Request-saken. Den regulatoriske fristen (typisk 30 dager i henhold til [[TOK_0]] art. 17) spores automatisk. Forfalte saker flagges for eskalering.',
        },
    },
    discovery: {
        nav: {
            dashboard: 'Oppdagingsoversikt',
            scans: 'Oppdagingsskanningar',
            staging_area: 'Mellomlagringsområde',
            dedup_rules: 'Dedupliseringsreglar',
            classification_rules: 'Klassifiseringsreglar',
            suggestions: 'Forslagskø',
            analytics: 'Forslagsanalyse',
            import_templates: 'Importmalar',
            connectors: 'Tilkoplingsstyring',
            discovery_cycles: 'Oppdagingssyklusar',
            owner_review: 'Eigargjennomgang',
            classification_lineage: 'Klassifiseringshistorikk',
        },
        dashboard: {
            title: 'Oppdagingsoversikt',
            loading: 'Lastar dashborddata...',
            total_scans: 'Totalt Skanningar',
            active_scans: 'Aktive Skanningar',
            completed_30d: 'Fullførte (30d)',
            failed_30d: 'Mislukkast (30d)',
            systems_discovered: 'System oppdaga',
            pending_staged_records: 'Ventende staged poster',
            recent_scans: 'Nyleg Skanningar',
            no_recent_scans: 'Ingen nylege skanningar.',
            scan_id: 'Skanning ID',
            discovered: 'Oppdaga',
            view_all_scans: 'Vis Alle Skanningar',
            staging_area: 'Oppsamlingsområde',
            suggestion_queue: 'Framlegg Kø',
            records_reviewed: 'Gjennomgåtte postar',
            records_approved: 'Godkjende postar',
            exceptions_pending: 'Ventande unntak',
            view_as_chart: 'Vis som diagram',
            view_as_table: 'Vis som tabell',
        },
        scans: {
            title: 'Oppdagingsskanningar',
            new: 'Ny Skanning',
            scan_id: 'Skanning ID',
            scan_type: 'Skanning Type',
            progress: 'Framdrift',
            discovered: 'Oppdaga',
            no_scans: 'Ingen oppdaging skanningar funne.',
            all_scan_types: 'Alle Skanning Typar',
            source_config: 'Kjelde Konfigurasjon (JSON)',
            invalid_json: 'Ugyldig JSON in kjelde konfiguration',
            load_error: 'Kunne ikkje laste oppdagingsskann. Ver venleg og prøv igjen.',
            create_error: 'Kunne ikkje opprette oppdagingsskann',
            change_status: 'Endre status',
            new_status: 'Ny status',
            actions: 'Handlinger',
            type_endpoint: 'Endepunkt',
            type_spreadsheet_import: 'Reknearkimport',
            type_cmdb_sync: 'CMDB-synkronisering',
            type_cloud_sync: 'Skysynkronisering',
            status_pending: 'Ventar',
            status_running: 'Køyrer',
            status_completed: 'Fullført',
            status_failed: 'Mislukkast',
            status_cancelled: 'Avbroten',
            source_config_placeholder: '{"host": "...", "port": 443}',
        },
        staging_area: {
            title: 'Mellomlagringsområde',
            record_id: 'Post ID',
            source_scan: 'Kjelde Skanning',
            entity_type: 'Eining Type',
            suggested_name: 'Føreslått Namn',
            confidence: 'Tillit',
            no_records: 'Ingen staged records funne.',
            promote: 'Forfrem',
            discard: 'Forkast',
            review: 'Gjennomgang',
            merge: 'Slå saman',
            merge_title: 'Slå sammen post',
            merge_target_id: 'Slå sammen Mål ID',
            reject_reason_placeholder: '�&rsak til afvisning...',
            promotion_status: 'Forfremmelse Status',
            dedup_status: 'Deduplisering Status',
            all_source_types: 'Alle Kjelde Typar',
            all_promotion_statuses: 'Alle Forfremmelse Statusar',
            all_dedup_statuses: 'Alle Deduplisering Statusar',
            load_error: 'Kunne ikkje laste mellomlagra postar. Ver venleg og prøv igjen.',
            promote_error: 'Kunne ikkje forfremme post',
            reject_error: 'Kunne ikkje avvise post',
            merge_error: 'Kunne ikkje slå saman post',
            review_error: 'Kunne ikkje markere post til gjennomgang',
            bulk_promote_error: 'Kunne ikkje masseforfremme records',
            bulk_reject_error: 'Kunne ikkje masseavvise records',
            service_type_web_server: 'Vevtenar',
            service_type_database: 'Database',
            service_type_api_gateway: 'API-gateway',
            service_type_storage: 'Lagring',
            service_type_authentication: 'Autentisering',
            service_type_analytics: 'Analyse',
            service_type_unknown: 'Ukjend',
            source_type_endpoint_scan: 'Endepunktskanning',
            source_type_spreadsheet: 'Rekneark',
            source_type_cmdb: 'CMDB',
            source_type_cloud_inventory: 'Skyinventar',
            promotion_status_new: 'Ny',
            promotion_status_under_review: 'Under gjennomgang',
            promotion_status_promoted: 'Forfremma',
            promotion_status_rejected: 'Avvist',
            promotion_status_merged: 'Slått saman',
            dedup_status_unmatched: 'Inga treff',
            dedup_status_potential_match: 'Mogleg treff',
            dedup_status_exact_match: 'Eksakt treff',
            dedup_status_resolved: 'Løyst',
            confirm_bulk_reject: 'Er du sikker på at du vil avvise dei valde postane?',
            scan_batch_id: 'Batch-ID',
            promote_to_registry_title: 'Oppgrader til dataregister',
            promote_modal_instructions: 'Oppretter et dataregisterelement med collection_method: observert og herkomstkobling til denne oppdagelsesposten. Elementet starter i utkaststatus for gjennomgang.',
            promote_label_category: 'Kategori',
            promote_label_name_override: 'Navn (valgfri overstyring)',
            placeholder_name_override: 'Standardinnstillingen til oppdagelsespostens navn/vertsnavn',
            promote_label_sensitivity: 'Foreslått følsomhet',
            inherit_from_category: 'Arv fra kategori',
        },
        dedup_rules: {
            title: 'Dedupliseringsreglar',
            new: 'Ny Regel',
            rule_name: 'Regel Namn',
            match_fields: 'Samsvarsfelt',
            threshold: 'Terskel',
            no_rules: 'Ingen deduplisering reglar funne.',
            seed_defaults: 'Initialiser standarder',
            match_type: 'Samsvarstype',
            similarity_threshold: 'Likskap Terskel',
            field_name: 'Felt Namn',
            load_error: 'Kunne ikkje laste dedupliseringsreglar. Ver venleg og prøv igjen.',
            create_error: 'Kunne ikkje opprette dedupliseringsregel',
            toggle_error: 'Kunne ikkje veksle dedupliseringsregel',
            seed_error: 'Kunne ikkje initialisere standardverdiar',
            priority: 'Prioritet',
            enabled_status: 'Aktivert',
            disabled_status: 'Deaktivert',
            default_badge: 'Standard',
            enable: 'Aktiver',
            disable: 'Deaktiver',
            match_type_exact: 'Eksakt',
            match_type_fuzzy: 'Omtrentleg',
            match_type_regex: 'Regex',
            match_type_ip_range: 'IP-område',
        },
        classification_rules: {
            title: 'Klassifiseringsreglar',
            new: 'Ny Regel',
            rule_name: 'Regel Namn',
            pattern: 'Mønster',
            classification: 'Klassifisering',
            no_rules: 'Ingen classification rules funne.',
            seed_defaults: 'Initialiser standarder',
            run_rules_now: 'Kjør regler nå',
            run_rules_success: 'Genererte [[TOK_1]] nye klassifiseringsforslag(er)',
            run_rules_no_results: 'Ingen nye forslag generert � alle samsvarende regler har allerede ventende forslag',
            run_rules_error: 'Kunne ikke kjøre klassifiseringsregler. Vennligst prøv igjen.',
            taxonomy_id: 'Taksonomi ID',
            level_id: 'Nivå ID',
            condition_logic: 'Vilkår Logikk',
            weight: 'Vekt',
            conditions: 'Vilkår',
            condition_field: 'Felt',
            condition_operator: 'Operatør',
            condition_value: 'Verdi',
            effectiveness: 'Effektivitet',
            match_count: 'Treff',
            approval_count: 'Godkjenningar',
            rejection_count: 'Avvisningar',
            filter_taxonomy: 'Filter etter Taksonomi ID...',
            load_error: 'Kunne ikkje laste klassifiseringsreglar. Ver venleg og prøv igjen.',
            create_error: 'Kunne ikkje opprette klassifiseringsregel',
            seed_error: 'Kunne ikkje initialisere standardverdiar',
            toggle_error: 'Kunne ikkje veksle regel. Ver venleg og prøv igjen.',
            priority: 'Prioritet',
            enabled_status: 'Aktivert',
            disabled_status: 'Deaktivert',
            enable: 'Aktiver',
            disable: 'Deaktiver',
            logic_and: 'OG',
            logic_or: 'ELLER',
            operator_equals: 'Er lik',
            operator_contains: 'Inneheld',
            operator_matches_regex: 'Samsvarar med Regex',
            operator_in_list: 'I lista',
            operator_not_equals: 'Er ikkje lik',
            operator_not_contains: 'Inneheld ikkje',
            enabled_label: 'Aktivert',
            disabled_label: 'Deaktivert',
            taxonomy_label: 'Taksonomi',
            operator_label: 'Operatør',
            value_label: 'Verdi',
        },
        suggestions: {
            title: 'Forslagskø',
            entity_type: 'Eining Type',
            suggested_name: 'Føreslått Namn',
            source: 'Kjelde',
            confidence: 'Tillit',
            accept: 'Godta',
            reject: 'Avvis',
            no_suggestions: 'Ingen framlegg i kø.',
            modify_approve: 'Endre & Godkjenn',
            delegate: 'Deleger',
            delegate_user_id: 'Deleger Brukar ID',
            new_level_id: 'Ny Nivå ID',
            reject_reason_placeholder: '�&rsak til afvisning...',
            current_level: 'Noverande Nivå',
            suggested_level: 'Føreslått Nivå',
            filter_taxonomy: 'Filter etter Taksonomi ID...',
            all_confidence: 'Alle Tillit Band',
            load_error: 'Kunne ikkje laste framlegg. Ver venleg og prøv igjen.',
            approve_error: 'Kunne ikkje godkjenne framlegg',
            reject_error: 'Kunne ikkje avvise framlegg',
            modify_error: 'Kunne ikkje endre og godkjenne framlegg',
            delegate_error: 'Kunne ikkje delegere framlegg',
            bulk_approve_error: 'Kunne ikkje massegodkjenne framlegg',
            bulk_reject_error: 'Kunne ikkje masseavvise framlegg',
            suggestion_type_new_label: 'Ny etikett',
            suggestion_type_validation: 'Validering',
            suggestion_type_reclassification: 'Omklassifisering',
            status_pending: 'Ventar',
            status_approved: 'Godkjend',
            status_rejected: 'Avvist',
            status_superseded: 'Erstatta',
            confidence_high: 'Høg',
            confidence_medium: 'Middels',
            confidence_low: 'Låg',
            confirm_bulk_reject: 'Er du sikker på at du vil avvise dei valde forslaga?',
        },
        analytics: {
            title: 'Forslagsanalyse',
            total_suggestions: 'Totalt Framlegg',
            accepted: 'Godtatt',
            rejected: 'Avvist',
            pending: 'Ventande',
            acceptance_rate: 'Aksept Rate',
            by_entity_type: 'Etter Eining Type',
            by_source: 'Etter Kjelde',
            avg_decision_time: 'Gj.sn. Avgjerd Tid',
            rule_effectiveness: 'Regel Effektivitet',
            by_status: 'Etter Status',
            by_confidence: 'Etter Tillit Band',
            load_error: 'Kunne ikkje laste framleggsanalyse. Ver venleg og prøv igjen.',
            confidence_high: 'Høg',
            confidence_medium: 'Middels',
            confidence_low: 'Låg',
            by_confidence_band: 'Etter tillitsnivå',
            approval_rate: 'Godkjenningsrate',
            by_label_state: 'Etter etikettstatus',
        },
        import_templates: {
            title: 'Importmalar',
            new: 'Ny Mal',
            template_name: 'Mal Namn',
            file_format: 'Fil Format',
            column_mappings: 'Kolonne Kartleggingar',
            no_templates: 'Ingen import malar funne.',
            source_column: 'Kjelde Kolonne',
            target_field: 'Mål Felt',
            transform: 'Transformer',
            source_column_label: 'Kildekolonne',
            target_field_label: 'Målfelt',
            transform_label: 'Forvandle',
            confirm_delete: 'Er du sikker på at du vil slette denne importmalen?',
            load_error: 'Kunne ikkje laste importmalar. Ver venleg og prøv igjen.',
            save_error: 'Kunne ikkje lagre importmal',
            delete_error: 'Kunne ikkje slette importmal',
            file_type_csv: 'CSV',
            file_type_xlsx: 'XLSX',
        },
        connectors: {
            title: 'Tilkoplingsstyring',
            new: 'Ny Kopling',
            connector_name: 'Kopling Namn',
            connector_type: 'Type',
            last_sync: 'Siste Synkronisering',
            no_connectors: 'Ingen koplingar funne.',
            cmdb_syncs: 'CMDB Synkroniseringar',
            cloud_syncs: 'Sky Synkroniseringar',
            new_sync: 'Ny Synkronisering',
            no_syncs: 'Ingen synkroniseringar funne.',
            cmdb_error: 'Kunne ikkje laste CMDB-skann. Ver venleg og prøv igjen.',
            cloud_error: 'Kunne ikkje laste skyskann. Ver venleg og prøv igjen.',
            trigger_error: 'Kunne ikkje utløyse synkronisering',
            trigger_sync_error: 'Kunne ikkje trigger {type}',
            cmdb_section_title: 'CMDB-synkroniseringar',
            cloud_section_title: 'Sky-synkroniseringar',
            column_connector: 'Kopling',
            action_start: 'Start',
            confirm_cancel_sync: 'Avbryt denne synkroniseringa?',
            start_error: 'Kunne ikkje starte synkronisering',
            cancel_error: 'Kunne ikkje avbryte synkronisering',
            type_endpoint: 'Endepunkt-skanning',
            type_spreadsheet_import: 'Rekneark-import',
            type_cmdb_sync: 'CMDB-synkronisering',
            type_cloud_sync: 'Sky-synkronisering',
        },
        discovery_cycles: {
            title: 'Oppdagingssyklusar',
            new_cycle: 'Ny oppdagingssyklus',
            cycle_name: 'Syklusnamn',
            scope_type: 'Omfangstype',
            scope_ids: 'Omfangs-ID',
            cadence_days: 'Frekvens (dagar)',
            status: 'Status',
            no_cycles: 'Ingen oppdagingssyklusar funne',
            compare: 'Samanlikne syklusar',
            delta_report: 'Endringsrapport',
            new_records: 'Nye postar',
            changed_records: 'Endra postar',
            removed_records: 'Fjerna postar',
            schedule: 'Planlegg skanning',
            scope_organization: 'Organisasjon',
            scope_department: 'Avdeling',
            scope_system: 'System',
            scope_systems: 'System',
            bulk_actions: 'Massehandlingar',
            selected: '{count} valde',
            bulk_create: 'Masseoppretting',
            bulk_assign_scope: 'Massetildel omfang',
            bulk_advance: 'Masseavansering',
            confirm_bulk_action: 'Stadfest massehandling',
            bulk_confirm_message: 'Er du sikker på at du vil utføre denne handlinga?',
            cycles_affected: '{count} syklusar vil bli påverka',
            select_all: 'Vel alle',
            select_cycle: 'Vel syklus {name}',
            from_template: 'frå mal',
            bulk_results: 'Masseresultat',
            failed_label: 'mislukka',
            template_id: 'Mal-ID',
            count: 'Tal',
            advance_to: 'Målstatus',
            bulk_success: 'Masseoperasjon fullført',
        },
        owner_review: {
            title: 'Eigargjennomgangsoppgåver',
            assign_owner: 'Tildel til eigar',
            owner_id: 'Eigar',
            decision: 'Avgjerd',
            approve: 'Godkjenn',
            modify: 'Endre',
            reject: 'Avvis',
            escalate: 'Eskalere',
            no_tasks: 'Ingen gjennomgangsoppgåver funne',
            bulk_resolve: 'Masseløysing',
            exceptions: 'Unntak',
            no_exceptions: 'Ingen unntak funne',
            record_id_label: 'Registrer ID',
            selected: 'vald',
            notes: 'Notat',
            select_all: 'Vel alle',
            select: 'Vel',
            confirm_resolve: 'Stadfest',
        },
        classification_lineage: {
            title: 'Klassifiseringshistorikk',
            link_suggestion: 'Koble til føreslegen etikett',
            suggestion_id: 'Forslag',
            proposed_label_id: 'Føreslegen etikett',
            no_lineage: 'Ingen historikkdata funne',
            full_lineage: 'Fullstendig historikk',
            record_id_label: 'Registrer ID',
            staged_record_label: 'Iscenesatt rekord',
            enter_staged_record_id: 'Angi trinnvis post-ID',
            scan_id_label: 'Skann ID',
            select_record: 'Vel ein post',
            select_suggestion: 'Vel eit forslag',
            select_label: 'Vel ein etikett',
        },
        common_labels: {
            n_rules: '[[TOK_1]] regler',
            one_rule: '1 regel',
            n_scans: '[[TOK_1]] skanner',
            one_scan: '1 skanning',
            n_syncs: '[[TOK_1]] synkroniseres',
            one_sync: '1 synkronisering',
            n_records: '[[TOK_1]] poster',
            one_record: '1 rekord',
            n_templates: '[[TOK_1]] maler',
            one_template: '1 mal',
            n_suggestions: '[[TOK_1]] forslag',
            one_suggestion: '1 forslag',
            n_selected: '[[TOK_1]] valgt',
            dashboard_loaded: 'Discovery-dashbordet er lastet inn',
            n_scans_loaded: '[[TOK_1]] skanninger er lastet',
            n_staged_records_loaded: '[[TOK_1]] iscenesatte poster lastet',
            confirm_delete_import_template: 'Er du sikker på at du vil slette denne importmalen?',
            invalid_json_source_config: 'Ugyldig [[TOK_0]] i source_config',
            scope_organization: 'Organisasjon',
            scope_department: 'Avdeling',
            scope_system: 'System',
            aria_filter_scans: 'Filterskanninger',
            aria_filter_staged_records: 'Filtrer iscenesatte poster',
            aria_filter_suggestions: 'Filtre',
            aria_filter_by_taxonomy_id: 'Filtrer etter taksonomi-ID',
            aria_filter_by_enabled_status: 'Filtrer etter aktivert status',
            aria_filter_by_source_type: 'Filtrer etter kildetype',
            aria_filter_by_promotion_status: 'Filtrer etter kampanjestatus',
            aria_filter_by_dedup_status: 'Filtrer etter dedup-status',
            aria_filter_by_scan_type: 'Filtrer etter skannetype',
            aria_filter_by_status: 'Filtrer etter status',
            aria_filter_by_confidence: 'Filtrer etter konfidensbånd',
            aria_select_all_records: 'Velg alle poster',
            aria_select_record: 'Velg post [[TOK_1]]',
            aria_select_all_suggestions: 'Velg alle forslag',
            aria_select_suggestion: 'Velg forslag [[TOK_1]]',
            aria_promote_record: 'Markedsfør rekord [[TOK_1]]',
            aria_discard_record: 'Forkast posten [[TOK_1]]',
            aria_merge_record: 'Slå sammen posten [[TOK_1]]',
            aria_review_record: 'Gjennomgå posten [[TOK_1]]',
            aria_accept_suggestion: 'Godta forslaget [[TOK_1]]',
            aria_reject_record: 'Avvis post',
            aria_merge_record_dialog: 'Slå sammen post',
            aria_create_new_scan: 'Opprett ny skanning',
            aria_sync_progress: 'Synkroniseringsfremgang: [[TOK_2]] av [[TOK_3]] elementer behandlet',
            aria_scan_progress: 'Skannefremgang: [[TOK_2]] av [[TOK_3]] elementer behandlet',
            aria_confidence: 'Tillit: [[TOK_1]] %',
            aria_effectiveness: 'Effektivitet: [[TOK_1]]',
            aria_promote_n_records: 'Markedsfør [[TOK_1]] valgte poster',
            aria_discard_n_records: 'Forkast [[TOK_1]] valgte poster',
            placeholder_pii_detection_rule: 'f.eks. PII-deteksjonsregel',
            placeholder_tax_id: 'f.eks. TAX-001',
            placeholder_lvl_id: 'f.eks. LVL-001',
            placeholder_service_type: 'f.eks. service_type',
            placeholder_database: 'f.eks. database',
            placeholder_hostname_match: 'f.eks. vertsnavn eksakt samsvar',
            placeholder_hostname: 'f.eks. vertsnavn',
            placeholder_hr_systems_csv: 'f.eks. HR Systems [[TOK_0]] import',
            placeholder_server_name: 'f.eks. servernavn',
            placeholder_hostname_field: 'f.eks. vertsnavn',
            placeholder_lowercase: 'f.eks. små bokstaver',
            placeholder_source_config: '{"host": "...", "port": 443}',
            placeholder_stg_id: 'f.eks. STG-000123',
            placeholder_lvl_002: 'f.eks. LVL-002',
            placeholder_usr_id: 'f.eks. USR-000123',
            decision_for: 'Avgjørelse for [[TOK_1]]',
        },
        exports: {
            title: 'Eksporter',
            inventory: 'Dataoversikt',
            classification_register: 'Klassifiseringsregister',
            raci: 'RACI-matrise',
            exceptions: 'Unntaksrapport',
            evidence_pack: 'Bevissamling',
            delta_report: 'Endringsrapport',
            executive_summary: 'Leiingssamandrag',
            export_button: 'Eksporter',
            downloading: 'Lastar ned...',
            download_complete: 'Nedlasting fullført.',
            download_error: 'Klarte ikkje å laste ned eksport. Prøv igjen.',
        },
        flags: {
            title: 'Nedstraums markeringar',
            pending: 'Ventande markeringar',
            cross_border_review_needed: 'Grensekryssande gjennomgang naudsynt',
            sharing_disclosure_needed: 'Delingsmelding naudsynt',
            dpia_review_needed: 'DPIA-gjennomgang naudsynt',
            acknowledge: 'Stadfest',
            resolve: 'Løys',
            no_flags: 'Ingen nedstraums markeringar.',
        },
        delta: {
            title: 'Endringsoversikt',
            new_count: '{n} nye',
            removed_count: '{n} fjerna',
            changed_count: '{n} endra',
            re_review_triggered: 'Ny gjennomgang utløyst',
            create_re_review: 'Opprett ny gjennomgang',
            recent_alerts: 'Siste endringsvarsel',
            no_alerts: 'Ingen siste endringsvarsel.',
            threshold_exceeded: 'Endringsgrense overskriden (>10 %)',
        },
        regulatory: {
            dashboard_governance_info: 'Dette dashbordet viser styringsstatus på syklusnivå: systemer skannet, poster iscenesatt, poster gjennomgått, poster godkjent og unntak som venter. Dette samsvarer med suksesskriteriene for ledelsen: "direkte dashbord for hvem som har oppdatert beholdningen, klassifiseringen og delingsloggene" (P-VN-05).',
            export_artifacts_info: 'Discovery-eksporter inkluderer alle nødvendige artefakttyper per UC-VN-10 og DATA-EVD-01: godkjent databeholdning, klassifiseringsregister, eierskap/RACI-kartlegging, unntakskø, sammendrag, bevispakke og deltarapport.',
            scan_inventory_pipeline_info: 'Hver fullført skanning produserer poster som er kompatible med malen vn_data_law_data_inventory_register (krav 88dd9877). Oppdagede dataressurser fyller automatisk ut datalagerregisteret for å tilfredsstille datalovens forpliktelse til å opprettholde et digitalt datalager.',
            connector_linkage_info: 'Hver koblingskonfigurasjon må inkludere: systemtype (f.eks. [[TOK_0]], skyplattform), datalagerreferanse (database, fillager, SaaS) og forretningsprosesskobling (UC-VN-10 påkrevde støtteposter). Disse feltene sikrer at oppdagede eiendeler kan spores til deres kildesystem og forretningskontekst.',
            owner_routing_info: 'Gjennomgangsoppgaver rutes til riktig avdeling eller applikasjonseier basert på system-/dataeierskap (UC-VN-10 trinn 5). Ruting bruker systemeierskapsregisteret, ikke ad-hoc tildeling.',
            owner_actions_audit_info: 'Eiere kan godkjenne, endre, avvise eller eskalere hver klassifisering (UC-VN-10 trinn 6). Hver handling fanger opp aktør, tidsstempel og årsak, og produserer styringsbevis for revisjonsbevis i henhold til krav f12fc090 (�&rlig styringsattest). Revisjonssporet viser hvem som har vurdert, hva som ble endret og når.',
            escalation_timers_info: 'Eskaleringstidtakere: frist for eiervurdering er 5 virkedager; eskalering av unntak er 48 timer (UC-VN-10 tidtakere). Uløste elementer eskalerer automatisk når fristen utløper. Tidtakere kan konfigureres i henhold til organisasjonens retningslinjer.',
            original_suggestion_preserved_info: 'Det originale maskin-/systemklassifiseringsforslaget er bevart ved siden av hver eieroverstyring (UC-VN-10 beviskrav). Det opprinnelige forslaget blir aldri overskrevet og forblir synlig for revisjonsformål.',
            dedup_lineage_info: 'Dedupliseringsregler forhindrer dupliserte beholdningsoppføringer når det samme dataelementet oppdages på tvers av flere skanninger eller koblinger. De siste skannemetadataene blir bevart som den primære posten, samtidig som de opprettholder avstamningsreferanser til alle tidligere funn for sporbarhet av revisjon.',
            label_states_info: 'Analytics skiller 4 etiketttilstander for styringsgjennomgang: maskinforeslått (venter), eiergodkjent, eiermodifisert og avvist. Disse tilstandene gjør det mulig for revisorer å vurdere automatiseringsnøyaktighet og eierengasjement.',
            import_pipeline_info: 'Importmaler må produsere poster som er kompatible med oppdagelsesrørledningen. Importerte poster går inn i fasering med de samme metadatakravene som skannede poster: kildesystemidentifikasjon, batch-ID og tidsstempel. Kolonnetilordninger bør målrettes mot felt definert i vn_data_law_data_inventory_register.',
            lineage_full_path_info: 'Klassifiseringsavstamning sporer hele banen: skanning/import -> iscenesettelse -> eieranmeldelse -> godkjent etikett -> registeroppføring (UC-VN-10 trinn 1-10). Hvert trinn viser registrerings-ID, skuespiller, tidsstempel og tilstandsovergang for fullstendig sporbarhet.',
            staging_workflow_info: 'Iscenesatte poster skilles visuelt fra godkjente beholdningsposter ved deres kampanjestatusmerke (UC-VN-10 trinn 3). Hver post beholder herkomstmetadata: kildesystem, skannebatch-ID og oppdagelsestidsstempel for full revisjonssporbarhet.',
            suggestion_data_d1_info: 'Forslag stemmer overens med datalovens klassifiseringsprosedyre DATA-D1: (1) katalogisere dataressurser, (2) klassifisere etter sensitivitetsnivå, (3) definere håndteringsregler. Hvert forslag inkluderer følsomhets- og viktighetsdimensjoner per krav 18e4bfd1.',
            downstream_flags_info: 'Elementer som er flagget for deling, grenseoverskridende overføring eller høyrisikobehandling utløser tilknyttede nedstrømsarbeidsflyter: vurdering av grenseoverskridende overføring, vurdering av risikodeling og [[TOK_0]] gjennomgang (UC-VN-10 trinn 8).',
            delta_detection_info: 'Oppdagelsessykluser støtter deltadeteksjon per UC-VN-10 trinn 11: hver syklus viser hvilke poster som er nye, endret eller fjernet siden sist godkjente grunnlinje. Materialendringer (>10 % delta) utløser automatisk arbeidsflyter for ny gjennomgang.',
        },
    },
    incident_ops: {
        errors: {
            fetch: 'Kunne ikkje laste.',
            save: 'Kunne ikkje lagre.',
            fetch_escalation_log_failed: 'Kunne ikkje hente eskaleringslogg.',
            fetch_activations_failed: 'Kunne ikkje hente aktiveringar.',
            deactivate_failed: 'Kunne ikkje deaktivere.',
            complete_activation_failed: 'Kunne ikkje fullføre activation.',
            fetch_playbook_templates_failed: 'Kunne ikkje hente spelbokmalar.',
            create_playbook_template_failed: 'Kunne ikkje opprette spelbokmal.',
            clone_template_failed: 'Kunne ikkje klone mal.',
            update_status_failed: 'Kunne ikkje oppdatere status.',
            deprecate_template_failed: 'Kunne ikkje utfase mal.',
            seed_defaults_failed: 'Kunne ikkje initialisere standardverdiar.',
            fetch_regulator_exports_failed: 'Kunne ikkje hente tilsynseksportar.',
            create_regulator_export_failed: 'Kunne ikkje opprette tilsynseksport.',
            update_submission_status_failed: 'Kunne ikkje oppdatere innsendingsstatus.',
            fetch_response_metrics_failed: 'Kunne ikkje hente svarsmetrikkar.',
            fetch_sla_dashboard_failed: 'Kunne ikkje hente SLA-dashboard.',
            fetch_sla_definitions_failed: 'Kunne ikkje hente SLA-definisjonar.',
            create_sla_definition_failed: 'Kunne ikkje opprette SLA-definisjon.',
            seed_sla_defaults_failed: 'Kunne ikkje initialisere SLA-standardar.',
            fetch_vendor_coordination_failed: 'Kunne ikkje hente leverandørkoordinering.',
            fetch_vendor_detail_failed: 'Kunne ikkje hente leverandørdetalj.',
            create_vendor_coordination_failed: 'Kunne ikkje opprette leverandørkoordinering.',
            add_communication_failed: 'Kunne ikkje leggje til kommunikasjon.',
            add_info_request_failed: 'Kunne ikkje leggje til infoførespurnad.',
            add_action_request_failed: 'Kunne ikkje leggje til handlingsførespurnad.',
        },
        nav: {
            playbooks: 'Dreiebokmalar',
            sla_definitions: 'SLA-definisjonar',
            sla_dashboard: 'SLA-oversikt',
            escalation_log: 'Eskaleringslogg',
            regulator_exports: 'Myndeeksportar',
            deadlines: 'Varsling Fristar',
            vendor_coordination: 'Leverandørkoordinering',
            metrics: 'Svarmålingar',
            playbook_links: 'Dreieboklenker',
            regulatory_sla: 'Regulatorisk SLA',
            coordination_dashboard: 'Koordinering',
            evidence_chain: 'Beviskjede',
            post_review: 'Etterhendingsgjennomgang',
        },
        playbooks: {
            page_title: 'Playbook maler',
            activations_page_title: 'Playbook-aktiveringer',
            title: 'Dreiebokmalar',
            new: 'Ny Mal',
            seed_defaults: 'Initialiser standarder',
            scenario_type: 'Scenariotype',
            severity_applicability: 'Alvorlegheit Anvendelighet',
            all_scenario_types: 'Alle Scenario Typar',
            new_playbook: 'Ny Spelbok Mal',
            clone: 'Klon',
            clone_template: 'Klon Mal',
            template_name: 'Mal namn',
            deprecate: 'Utfas',
            confirm_deprecate: 'Utfas mal "{name}"?',
            create_template: 'Opprett Mal',
            update_status: 'Oppdatering Status',
            no_templates: 'Ingen spelbok malar funne',
            deactivation_reason_placeholder: '�&rsak til deaktivering...',
            description_placeholder: 'Spelbok skildring...',
            name_placeholder: 'Spelbok namn...',
        },
        sla_definitions: {
            page_title: 'SLA-definisjonar',
            title: 'SLA-definisjonar',
            new: 'Ny SLA-definition',
            sla_name: 'SLA Namn',
            target_hours: 'Mål Timar',
            escalation_after: 'Eskalering etter',
            applies_to: 'Gjeld for',
            no_definitions: 'Ingen sla definitions funne.',
            target_value_placeholder: 'Mål verdi',
            name_placeholder: 'SLA namn...',
            threshold_hours_label: 'Terskeltimar',
            severity_label: 'Alvorlegheitsgrad',
            all_types: 'Alle typar',
            all_severities: 'Alle alvorlegheitsgrader',
            default_label: 'Standard',
        },
        sla_dashboard: {
            compliant: 'Samsvarlig',
            page_title: 'SLA-oversikt',
            title: 'SLA-oversikt',
            loading: 'Lastar SLA-data...',
            compliance_rate: 'Etterleving Rate',
            breached: 'Broten',
            at_risk: 'Ved Risiko',
            on_track: 'På Spor',
            by_severity: 'Etter Alvorlegheit',
            total_records: 'Totalt antal postar',
            met: 'Oppfylt',
            sla_records: 'SLA-postar',
            sla_reference: 'SLA-referanse',
            record_id: 'Post-ID',
            metric_type: 'Måletype',
            severity: 'Alvorlegheit',
            elapsed: 'Forløpt',
            clock_start: 'Klokkestart',
        },
        escalation_log: {
            page_title: 'Eskaleringslogg',
            title: 'Eskaleringslogg',
            incident_id: 'Hending ID',
            escalated_by: 'Eskalerte Etter',
            escalated_to: 'Eskalerte Til',
            reason: '�&rsak',
            escalated_at: 'Eskalerte Ved',
            no_escalations: 'Ingen eskaleringer funne.',
            filter_incident_id: 'Filter etter Hending ID',
            escalation_id: 'Eskalerings-ID',
            level: 'Nivå',
            level_range: 'Nivå (L1�L4)',
            create_escalation: 'Opprett eskalering',
            incident_id_placeholder: 't.d. INC-001',
            target_role_placeholder: 't.d. dpo, incident_manager',
            select_placeholder: '� vel �',
        },
        regulator_exports: {
            page_title: 'Tilsynseksportar',
            title: 'Myndeeksportar',
            new: 'Ny Eksport',
            incident_id: 'Hending ID',
            regulator: 'Tilsynsmyndigheit',
            export_format: 'Format',
            exported_at: 'Eksportert den',
            no_exports: 'Ingen regulator exports funne.',
            enter_incident_id: 'Oppgje Hending ID',
            export_id: 'Eksport-ID',
            watermark: 'Vassmerke',
            submission_status: 'Innsendingsstatus',
            all_jurisdictions: 'Alle jurisdiksjonar',
            no_transitions: 'Ingen ytterligere overganger tilgjengelig fra',
            select_new_status: '� vel ny status �',
            sections_included: 'Inkluderte seksjonar',
            form_classification: 'Klassifisering',
            submission_channel: 'Kanal',
        },
        deadlines: {
            title: 'Varsling Fristar',
            incident_id: 'Hending ID',
            deadline: 'Frist',
            regulator: 'Tilsynsmyndigheit',
            remaining: 'Attståande',
            no_deadlines: 'Ingen varsling fristar funne.',
        },
        vendor_coordination: {
            page_title: 'Leverandørkoordinering',
            title: 'Leverandørkoordinering',
            new: 'Ny Koordinering',
            incident_id: 'Hending ID',
            vendor_name: 'Leverandør Namn',
            contact: 'Kontakt',
            coordination_status: 'Koordinering Status',
            no_items: 'Ingen leverandør koordinering element funne.',
            assessment_placeholder: 'Indledende vurdering fra leverandør...',
            coordination_id: 'Koordinasjons-ID',
            communications: 'Kommunikasjon',
            info_requests: 'Infoforespørsler',
            action_requests: 'Handlingsforespørsler',
            direction: 'Retning',
            channel_label: 'Kanal',
            no_transitions: 'Ingen fleire overgangar tilgjengelege.',
            vendor_ref_number: 'Referansenummer',
            report_date: 'Rapportdato',
            contact_email: 'E-post',
            contact_phone: 'Telefon',
            channel_email: 'E-post',
            channel_meeting: 'Møte',
            channel_phone: 'Telefon',
            channel_portal: 'Portal',
            incident_id_placeholder: 'Filter etter Hending ID...',
            priority_critical: 'Kritisk',
            priority_high: 'Høg',
            priority_low: 'Low',
            priority_medium: 'Middels',
            vendor_id_placeholder: 'Filter etter Leverandør ID...',
            description_placeholder: 'Skildring...',
            filter_vendor_id: 'Filter etter Leverandør ID',
            inbound: 'Innkomande',
            outbound: 'Utgåande',
            summary_placeholder: 'Samandrag...',
            priority_label: 'Prioritet',
            due_date_label: 'Forfallsdato',
            info_request_desc: 'Beskrivelse av informasjonsforespørsel',
            action_request_desc: 'Beskrivelse av handlingsforespørsel',
            content_label: 'Innhold',
            select_incident: 'Vel hending',
            select_vendor: 'Vel leverandør',
            discovery_date: 'Oppdaging Dato',
        },
        metrics: {
            page_title: 'Svarmålingar',
            title: 'Svarmålingar',
            loading: 'Lastar metrikdata...',
            avg_response_time: 'Gj.sn. Svar Tid',
            avg_resolution_time: 'Gj.sn. Løysing Tid',
            total_incidents: 'Totalt Hendingar',
            by_severity: 'Etter Alvorlegheit',
            by_status: 'Etter Status',
            trend: 'Trend',
            start_sla_clock: 'Start SLA-klokke',
            sla_records: '[[TOK_0]] Rekorder',
            no_sla_records: 'Ingen SLA-postar enno.',
            record_id: 'Registrer ID',
            severity: 'Alvorlighetsgrad',
            progress: 'Framdrift',
            incident_id_required: 'Hendings-ID er påkravd',
            sla_definition_required: 'SLA-definisjon er påkravd',
            metric_type_required: 'Måletype er påkravd',
            threshold_required: 'Terskeltimar er påkravd',
            sla_clock_started: 'SLA-klokke starta',
            sla_definition: 'SLA-definisjon',
            no_definitions: 'Ingen SLA-definisjonar funne.',
            select_definition: 'Vel SLA-definisjon...',
            select_metric_type: 'Vel måletype...',
            select_severity: 'Vel alvorlegheitsgrad...',
            threshold_hours: 'Terskel (timar)',
            warning_threshold_pct: '�&tvaringsterskel (%)',
            start_clock: 'Start klokke',
            starting: 'Startar...',
            metric_label: 'Måling',
            value_label: 'Verdi',
            incident_id: 'Hendings-ID',
            threshold_placeholder: 't.d. 24',
            metric_types: {
                triage_time: 'Triagetid',
                containment_time: 'Avgrensingstid',
                notification_time: 'Varslingstid',
                resolution_time: 'Løysingstid',
            },
            severities: {
                critical: 'Kritisk',
                high: 'Høg',
                medium: 'Middels',
                low: 'Low',
            },
        },
        playbook_links: {
            page_title: 'Playbooklenker',
            title: 'Dreiebok-varslingslenker',
            new_link: 'Kople dreiebok til varsling',
            activation_id: 'Aktiverings-ID',
            notification_id: 'Varslings-ID',
            select_activation: 'Vel ei aktivering...',
            select_notification: 'Vel ei varsling...',
            no_links: 'Ingen dreieboklenker funne',
            seed_pdpl: 'Initialiser PDPL-dreiebøker',
            created: 'Playbook-koblingen er opprettet',
            seeded: '[[TOK_0]] playbooks seedet',
            create_failed: 'Kunne ikke opprette playbook-link',
            seed_failed: 'Kunne ikke seede [[TOK_0]] spillebøker',
        },
        regulatory_sla: {
            page_title: 'Regulatoriske SLA-tilordningar',
            title: 'Regulatoriske SLA-tilordningar',
            new_mapping: 'Ny SLA-tilordning',
            sla_definition: 'SLA-definisjon',
            select_sla_definition: 'Vel ein SLA-definisjon...',
            framework_code: 'Rammeverkkode',
            deadline_type: 'Fristtype',
            deadline_hours: 'Frist i timar',
            auto_escalate: 'Autoeskalering',
            seed_pdpl: 'Initialiser PDPL-standardar',
            no_mappings: 'Ingen regulatoriske SLA-tilordningar funne',
            dashboard: 'Regulatorisk SLA-oversikt',
            deadline_types: {
                initial_notification: 'Innledende melding',
                supplement_response: 'Supplerende svar',
                authority_response: 'Myndighetssvar',
                remediation_report: 'Utbedringsrapport',
            },
            statutory_reference: 'Lovreferanse',
        },
        coordination_dashboard: {
            page_title: 'Koordineringsoversikt',
            title: 'Koordineringsoversikt',
            incident_id: 'Hending-ID',
            select_incident: 'Vel ei hending...',
            team_role: 'Teamrolle',
            members: 'Medlemmar',
            tasks: 'Oppgåver',
            sla_status: 'SLA-status',
            no_teams: 'Ingen koordineringsteam funne',
            new_team: 'Nytt koordineringsteam',
            enter_incident_id: 'Skriv inn ein hendings-ID for å sjå koordineringsteam.',
            member_ids_placeholder: 'bruker1, bruker2',
            edit_team: 'Rediger team',
            task_count: 'Oppgavetelling',
            tasks_completed: 'Fullført',
            team_roles: {
                security: 'Tryggleik',
                legal: 'Juridisk',
                it: 'IT',
                management: 'Leiing',
                department_owner: 'Avdelingseigar',
                external: 'Ekstern',
            },
        },
        evidence_chain: {
            page_title: 'Beviskjede',
            title: 'Beviskjede',
            new_entry: 'Ny bevisoppføring',
            select_incident: 'Vel ei hending...',
            actor: 'Aktør',
            select_actor: 'Vel ein aktør...',
            evidence_id: 'Bevis-ID',
            action: 'Handling',
            recipient: 'Mottakar',
            no_entries: 'Ingen beviskjedeoppføringar funne',
            enter_incident_id: 'Skriv inn ein hendings-ID for å sjå beviskjede.',
            evidence_id_placeholder: 'f.eks. EVD-2026-0001',
            evidence_id_help: 'Ein unik referanse til bevismaterialet – ei loggfil, eit diskbilete eller eit skjermbilete. Eit forslag er førehandsutfylt; rediger det så det samsvarar med beviskatalogen din.',
            select_incident_first: 'Vel ei hending ovanfor før du legg til ei bevisoppføring.',
            for_incident: 'For hending',
            actions: {
                collected: 'Samlet',
                shared: 'Delt',
                exported: 'Eksportert',
                archived: 'Arkivert',
            },
        },
        post_review: {
            page_title: 'Etterhendingsgjennomgang',
            title: 'Etterhendingsgjennomgang',
            new_review: 'Ny gjennomgang',
            select_incident: 'Vel ei hending...',
            lessons_learned: 'Erfaringar',
            recommendations: 'Tilrådingar',
            improvement_actions: 'Forbetringstiltak',
            submit_for_review: 'Send til gjennomgang',
            aria_submit_review: 'Send gjennomgang {name} til gjennomgang',
            aria_sign_off: 'Godkjenn gjennomgang {name}',
            sign_off: 'Godkjenning',
            no_reviews: 'Ingen etterhendingsgjennomgangar funne',
            enter_incident_id: 'Skriv inn ein hendings-ID for å sjå etterhendingsgjennomgang.',
            one_per_line: 'Ein per linje',
            statuses: {
                draft: 'Utkast',
                in_review: 'Under gjennomgang',
                signed_off: 'Godkjend',
                closed: 'Lukka',
            },
        },
        activations: {
            title: 'Playbook-aktiveringer',
            activation_id: 'Aktiverings-ID',
            phases: 'Faser',
            activated_at: 'Aktivert kl',
            activated_by: 'Aktivert av',
            deactivate: 'Deaktiver',
            complete: 'Fullfør',
            deactivation_reason: '�&rsak til deaktivering',
            evidence_button: 'Bevis',
            evidence_modal_title: 'Aktiveringsbevis',
            no_evidence: 'Ingen bevis knyttet til denne aktiveringen.',
            upload_evidence_label: 'Last opp aktiveringsbevis',
        },
    },
    program_governance: {
        maturity_walkthrough: {
            run_label: 'Gå meg gjennom hull',
            running: 'Gågaper...',
            results_heading: 'Forbedring veikart ([[TOK_2]] gap[[TOK_3]])',
            tokens_label: '�0� [[TOK_1]] tokens',
            no_gaps: 'Ingen hull oppdaget � alle domener ved eller over målet.',
            col_priority: 'Prioritet',
            col_domain: 'Domene',
            col_levels: 'Gjeldende �  Mål',
            col_severity: 'Alvorlighetsgrad',
            col_actions: 'Utbedringstiltak',
            citations_label: 'Sitater',
            accept_label: 'Godta veikart',
            reject_label: 'Avvis utkast',
            export_label: 'Eksporter [[TOK_0]]',
            exported_label: 'Veikart eksportert',
            accept_hint: 'Godta registrerer veikartet på det vedvarende utkastet. Bruk Eksporter [[TOK_0]] for å generere leveransen; operatøren limer tilbake improvement_actions i vurderingen.',
            resolve_summary: 'Oppløsning: [[TOK_1]]',
            error_generic: 'Kunne ikke kjøre gap-gjennomgang. Prøv igjen eller kontroller vurderingsstatusen.',
        },
        policy_gap: {
            run_label: 'Oppdag politiske hull',
            running: 'Oppdager hull ⬦',
            results_heading: 'Politikkhull ([[TOK_1]])',
            tokens_label: '�0� [[TOK_1]] tokens',
            no_gaps: 'Ingen dekningshull oppdaget.',
            col_severity: 'Alvorlighetsgrad',
            col_kind: 'Snill',
            col_clause: 'Klausul / krav',
            kind_missing: 'Manglende klausul',
            kind_weak: 'Svak dekning',
            kind_stale: 'Foreldet (forsinket anmeldelse)',
            remediation_label: 'Foreslått utbedring',
            citations_label: 'Sitater',
            accept_label: 'Godta gap-rapporten',
            reject_label: 'Avvis rapport',
            export_label: 'Eksporter [[TOK_0]]',
            accept_hint: 'Godta registrerer gap-rapporten for det vedvarende utkastet. Bruk Eksporter [[TOK_0]] for å generere en policyrevisjonsrapport; operatøren driver selve policyredigeringen.',
            resolve_summary: 'Oppløsning: [[TOK_1]]',
            error_generic: 'Kunne ikke oppdage politiske hull. Prøv på nytt eller kontroller dokumentstatusen.',
        },
        remediation_plan_generator: {
            run_label: 'Generer plan fra hull',
            running: 'Genererer plan ⬦',
            results_heading: 'Utbedringsplan ([[TOK_2]] fase[[TOK_3]])',
            tokens_label: '�0� [[TOK_1]] tokens',
            phase_label: 'Fase [[TOK_1]]',
            window_label: 'Vindu',
            owner_label: 'Eierrolle',
            evidence_label: 'Bevistyper kreves',
            tasks_label: 'Oppgaver',
            no_phases: 'Ingen faser produsert � input gap-sett kan være tomt.',
            citations_label: 'Sitater',
            accept_label: 'Godta planen',
            reject_label: 'Avvis plan',
            export_label: 'Eksporter [[TOK_0]]',
            accept_hint: 'Accept oppretter faseoppgaver knyttet til planposten. Bruk Eksporter [[TOK_0]] for hele leveransen. Eierrolleplassholdere trenger operatøroppfølging.',
            resolve_summary: 'Oppløsning: [[TOK_2]] · [[TOK_3]] oppgave(r) opprettet',
            error_generic: 'Kunne ikke generere utbedringsplan. Prøv igjen eller sjekk gap-set-inngangen.',
            source_picker_label: 'Kilde',
            source_all: 'Alle',
            source_consent: 'Analyse av samtykkegap',
            source_policy: 'Oppdagelse av politiske gap',
            source_vendor: 'Leverandør onboarding',
            load_upstream_label: 'Last fra oppstrøms',
            loading_upstream: 'Laster inn ⬦',
            upstream_count: '[[TOK_1]] gap(er) lastet',
        },
        nav: {
            maturity_models: 'Mogningsmodellar',
            maturity_assessments: 'Mogningsvurderingar',
            trend_dashboard: 'Trendoversikt',
            reporting_periods: 'Rapporteringsperiodar',
            executive_summaries: 'Leiingssamandrag',
            audit_readiness: 'Revisjonsberedskap',
            evidence_gaps: 'Dokumentasjonsmangler',
            program_health: 'Programhelse',
            obligation_mappings: 'Skyldnadstilordningar',
            governance_documents: 'Styringsdokument',
            remediation_plans: 'Utbetringsplanar',
            governance_model: 'Styringsmodell',
            document_drafting: 'Dokumentutkast',
            document_issuance: 'Dokumentutgiving',
            acknowledgment_tracking: 'Kvitteringssporing',
            change_log: 'Endringslogg',
            review_cadence: 'Gjennomgangskadanse',
        },
        maturity_models: {
            title: 'Mogningsmodellar',
            new: 'Ny Modell',
            seed_defaults: 'Initialiser standarder',
            domains: 'Domene',
            activate: 'Aktiver',
            no_models: 'Ingen mognad modellar funne',
            new_maturity_model: 'Ny Mognad Modell',
            create_model: 'Opprett modell',
            load_error: 'Kunne ikkje laste mognadmodellar. Prøv igjen.',
            create_error: 'Kunne ikkje opprette mognadmodell',
            status_error: 'Kunne ikkje oppdatere modellstatus',
            seed_error: 'Kunne ikkje generere standardverdiar',
            aria_seed_defaults: 'Generer standard mognadmodellar',
            aria_create_new: 'Opprett ny mognadmodell',
            loading_sr: 'Lastar mognadmodellar',
            model_name_placeholder: 't.d., Personvern-mognadmodell',
            status_changed: 'Modellstatus endra til {status}',
        },
        maturity_assessments: {
            title: 'Mogningsvurderingar',
            new: 'Ny Vurdering',
            model: 'Modell',
            assessor: 'Vurderar',
            overall_score: 'Samla Poeng',
            overall_score_help: 'Ei vekta modnadsvurdering frå 0–5 som blir rekna ut automatisk når ei vurdering blir fullført. Auk henne ved å gje kvart domene høgare poeng under evalueringa, og deretter føre vurderinga gjennom Send til gjennomgang → Fullfør.',
            assessed_at: 'Vurdert den',
            no_assessments: 'Ingen mognad vurderingar funne.',
            load_error: 'Kunne ikkje laste mognadsvurderingar. Prøv igjen.',
            create_error: 'Kunne ikkje opprette vurdering',
            start_error: 'Kunne ikkje starte vurdering',
            archive_error: 'Kunne ikkje arkivere vurdering',
            eval_error: 'Kunne ikkje laste vurdering for evaluering',
            eval_min_score: 'Vurder minst eitt domene',
            eval_save_error: 'Kunne ikkje lagre domenevurderingar',
            review_error: 'Kunne ikkje sende til gjennomgang',
            finalize_error: 'Kunne ikkje fullføre vurdering',
            start: 'Start',
            start_confirm_title: 'Start vurdering',
            start_confirm_message: 'Er du sikker på at du vil starte denne vurderinga?',
            archive_confirm_title: 'Arkiver vurdering',
            archive_confirm_message: 'Er du sikker på at du vil arkivere denne vurderinga?',
            evaluate_domains: 'Evaluer',
            evaluate_domains_title: 'Evaluer domene',
            submit_for_review: 'Send til gjennomgang',
            finalize: 'Fullfør',
            archive: 'Arkiver',
            all_reviewers: 'Alle gjennomgåarar må godkjenne',
            any_reviewer: 'Kva gjennomgåar som helst kan godkjenne',
            select_level: 'Vel mognadnivå...',
            findings_placeholder: 'Funn, notat, evidensreferansar...',
            no_domains: 'Ingen domene funne for denne modellen.',
        },
        trend_dashboard: {
            title: 'Trendoversikt',
            loading: 'Lastar tendensdata...',
            score_trend: 'Poeng Trend',
            domain_comparison: 'Domene Samanlikning',
            period: 'Periode',
            load_error: 'Kunne ikkje laste trendsamandrag. Prøv igjen.',
            metrics_load_error: 'Kunne ikkje laste trendmålingar. Prøv igjen.',
            module: 'Modul',
            metric: 'Måling',
            value: 'Verdi',
            trend: 'Trend',
            aria_filters: 'Filter for trendmålingar',
            showing_chart: 'Viser diagramvising',
            showing_table: 'Viser datatabellvising',
        },
        reporting_periods: {
            title: 'Rapporteringsperiodar',
            new: 'Ny Periode',
            period_name: 'Periode Namn',
            start_date: 'Start Dato',
            end_date: 'End Dato',
            no_periods: 'Ingen reporting periods funne.',
            load_error: 'Kunne ikkje laste rapporteringsperiodar. Prøv igjen.',
            create_error: 'Kunne ikkje opprette rapporteringsperiode',
            auto_generate_error: 'Kunne ikkje autogenerere rapporteringsperiodar',
            status_error: 'Kunne ikkje oppdatere periodestatus',
            start_collecting: 'Start innsamling',
            mark_as_draft: 'Merk som utkast',
            submit_for_review: 'Send til gjennomgang',
            publish: 'Publiser',
            auto_generate: 'Autogenerere rapporteringsperiodar',
            period_label_placeholder: 't.d., K1 2026',
            status_updated: 'Periodestatus oppdatert',
        },
        executive_summaries: {
            title: 'Leiingssamandrag',
            new: 'Ny Samandrag',
            period: 'Periode',
            generated_at: 'Generert Ved',
            generated_by: 'Generert Etter',
            no_summaries: 'Ingen leiings samandrag funne.',
            generate: 'Generer',
            load_error: 'Kunne ikkje laste leiingssamandrag. Prøv igjen.',
            generate_error: 'Kunne ikkje generere leiingssamandrag',
            save_error: 'Kunne ikkje lagre leiingssamandrag',
        },
        audit_readiness: {
            title: 'Revisjonsberedskap',
            loading: 'Lastar revisjonsberedskabsdata...',
            overall_readiness: 'Samla Beredskap',
            by_domain: 'Etter Domene',
            evidence_coverage: 'Bevis Dekning',
            gaps: 'Manglar',
            load_error: 'Kunne ikkje laste siste beredskap. Prøv igjen.',
            history_error: 'Kunne ikkje laste beredskapshistorikk. Prøv igjen.',
            calculate_error: 'Kunne ikkje berekne revisjonsberedskap',
            aria_recalculate: 'Berekn revisjonsberedskapspoeng på nytt',
            aria_current_readiness: 'Noverande revisjonsberedskap',
            aria_history: 'Historikk for beredskapspoeng',
            recalculated: 'Revisjonsberedskap berekna på nytt',
            loading_sr: 'Lastar revisjonsberedskapsdata',
        },
        evidence_gaps: {
            title: 'Dokumentasjonsmangler',
            domain: 'Domene',
            control: 'Kontroll',
            gap_type: 'Mangel Type',
            severity: 'Alvorlegheit',
            no_gaps: 'Ingen bevis manglar funne.',
            load_error: 'Kunne ikkje laste bevishol. Prøv igjen.',
            stats_error: 'Kunne ikkje laste holstatistikk. Prøv igjen.',
            create_error: 'Kunne ikkje opprette bevishol',
            update_error: 'Kunne ikkje oppdatere bevishol',
            status_error: 'Kunne ikkje oppdatere status',
            aria_create_new: 'Opprett nytt bevishol',
            aria_statistics: 'Statistikk over bevishol',
            loading_sr: 'Lastar bevishol',
            status_updated: 'Holstatus oppdatert',
            entity_type_placeholder: 't.d., leverandør, system',
            all_modules: 'Alle domene',
            all_severities: 'Alle alvorlegheiter',
        },
        program_health: {
            title: 'Programhelse',
            loading: 'Lastar programsundhedsdata...',
            overall_health: 'Samla Helse',
            by_module: 'Etter Modul',
            risk_areas: 'Risikoområde',
            recommendations: 'Tilrådingar',
            load_error: 'Kunne ikkje laste programhelsedata. Prøv igjen.',
            aria_key_metrics: 'Nøkkelmålingar for programhelse',
            aria_module_scorecard: 'Modulresultatkortopdeling',
            loading_sr: 'Lastar programhelsedata',
            trending_up: 'Stigande trend',
            trending_down: 'Synkande trend',
            trending_stable: 'Stabil',
            data_loaded: 'Programhelsedata lasta',
        },
        obligation_mappings: {
            title: 'Skyldnadstilordningar',
            create_mapping: 'Opprett skyldnadstilordning',
            framework: 'Rammeverk',
            select_framework: 'Vel eit rammeverk...',
            obligation: 'Skyldnad',
            obligation_ref: 'Skyldnadsreferanse',
            obligation_description: 'Skyldnadsskildring',
            role: 'Rolle',
            assigned_role: 'Tildelt rolle',
            assigned_department: 'Tildelt avdeling',
            select_department: 'Vel ei avdeling...',
            control_ids: 'Kontroll-IDar',
            raci_assignments: 'RACI-tildelingar',
            create_raci: 'Opprett RACI-tildeling',
            activity: 'Aktivitet',
            activity_name: 'Aktivitetsnamn',
            activity_description: 'Aktivitetsskildring',
            responsible: 'Ansvarleg',
            select_users: 'Vel brukarar...',
            accountable: 'Rekneskapsansvarleg',
            select_user: 'Vel ein brukar...',
            consulted: 'Konsultert',
            informed: 'Informert',
            review_frequency: 'Gjennomgangsfrekvens',
            frequency_monthly: 'Månadleg',
            frequency_quarterly: 'Kvartalsvis',
            frequency_semi_annual: 'Halvårleg',
            frequency_annual: '�&rleg',
            no_mappings_found: 'Ingen skyldnadstilordningar funne.',
            no_raci_found: 'Ingen RACI-tildelingar funne.',
            mapping_created: 'Forpliktelsestilordning oppretta',
            mapping_updated: 'Skyldnadstilordning oppdatert',
            mapping_deleted: 'Skyldnadstilordning sletta',
            raci_created: 'RACI-tilordning oppretta',
            raci_updated: 'RACI-tildeling oppdatert',
            raci_deleted: 'RACI-tildeling sletta',
            aria_edit_mapping: 'Rediger tilordning {name}',
            aria_delete_mapping: 'Slett tilordning {name}',
            aria_edit_raci: 'Rediger RACI {name}',
            aria_delete_raci: 'Slett RACI {name}',
            confirm_delete_mapping: 'Slette denne skyldnadstilordninga?',
            confirm_delete_raci: 'Slette denne RACI-tildelinga?',
            table_view: 'Tabellvising',
            matrix_view: 'Matrisevising',
            print_export: 'Skriv ut / Eksporter',
            filter_framework: 'Filtrer etter rammeverk',
            no_matrix_data: 'Ingen RACI-tildelingar å vise i matrisevising.',
            aria_print_export: 'Skriv ut eller eksporter RACI-matrise',
        },
        governance_documents: {
            title: 'Styringsdokument',
            create_document: 'Opprett styringsdokument',
            document_title: 'Dokumenttittel',
            document_type: 'Dokumenttype',
            content_url: 'Innhalds-URL',
            content_url_placeholder: 'https://...',
            framework_codes: 'Rammekodar',
            select_frameworks: 'Vel rammeverk...',
            effective_date: 'Verknadsdato',
            review_date: 'Gjennomgangsdato',
            status: 'Status',
            version: 'Versjon',
            acknowledgments: 'Stadfestingar',
            acknowledge: 'Stadfest',
            acknowledged_by: 'Stadfesta av',
            department: 'Avdeling',
            no_documents_found: 'Ingen styringsdokument funne.',
            draft: 'Utkast',
            review: 'Gjennomgang',
            approved: 'Godkjend',
            issued: 'Utgjeve',
            superseded: 'Erstatta',
            document_created: 'Dokument oppretta',
            document_acknowledged: 'Dokument stadfesta',
            policy: 'Retningslinje',
            procedure: 'Prosedyre',
            standard: 'Standard',
            guideline: 'Retningslinje',
        },
        governance_model: {
            title: 'Styringsmodell',
            create_model: 'Styringsmodell',
            edit_model: 'Styringsmodell',
            model_name: 'Model',
            description: 'Beskrivelse',
            governance_type: 'Type',
            type_centralized: 'Sentralisert',
            type_federated: 'Forbundet',
            type_hybrid: 'Hybrid',
            framework_codes: 'Framework',
            select_frameworks: '...',
            review_frequency: 'Frequency',
            freq_monthly: 'Månedlig',
            freq_quarterly: 'Kvartalsvis',
            freq_semi_annual: 'Halvårlig',
            freq_annual: '�&rlig',
            committees: 'komiteer',
            committee_name: 'Name',
            committee_members: 'Members',
            committee_mandate: 'Mandat',
            add_committee: '+',
            no_committees: '�',
            delegation_rules: 'Delegation',
            from_role: 'From',
            to_role: 'To',
            scope: 'Omfang',
            add_delegation_rule: '+',
            control_owner_summary: 'RACI',
            no_raci_data: '�',
            activity: 'Aktivitet',
            responsible: 'R',
            accountable: 'A',
            consulted: 'C',
            informed: 'I',
            no_models_found: '�',
            model_created: 'OK',
            model_updated: 'OK',
            model_deleted: 'OK',
            confirm_delete: '?',
            expand: '+',
            collapse: '-',
            aria_expand: '{name}',
            aria_edit: '{name}',
            aria_delete: '{name}',
            aria_export_csv: '{name} CSV',
            aria_export_json: '{name} JSON',
            framework_read_permission_warning: 'Du trenger regulatory_framework:lesetillatelsen for å velge rammer. Be en administrator om å gi det.',
            select_members: 'Valgkomiteens medlemmer',
            select_from_role: 'Velg delegerende rolle',
            select_to_role: 'Velg mottakerrolle',
            mandate_markdown_hint: 'Markdown støttes: **fet**, lister, lenker.',
            scope_tab_obligation: 'Forpliktelse',
            scope_tab_framework: 'Rammeverk',
            scope_tab_free_text: 'Fri tekst',
            select_obligation: 'Velg en forpliktelse',
            select_framework: 'Velg et rammeverk',
            aria_remove_committee: 'Fjern komité {n}',
            aria_remove_delegation_rule: 'Fjern delegeringsregel {n}',
            no_frameworks_available: 'Ingen rammeverk tilgjengelege. Legg til regelverk først.',
        },
        document_drafting: {
            title: 'Dokumentutkast',
            document_title: 'Document',
            document_type: 'Type',
            status: 'Status',
            drafter: 'Tegner',
            deadline: 'Frist',
            assign_drafter: 'Assign',
            select_drafter: '...',
            assign: 'Tilordne',
            submit_for_review: 'Submit',
            legal_review: 'Review',
            reviewer: 'Anmelder',
            select_reviewer: '...',
            comments: 'Kommentarer',
            review_action: 'Action',
            approve: 'Godkjenne',
            request_changes: 'Be om endringer',
            submit_review: 'Submit',
            executive_approval: 'Approval',
            no_drafts_found: '�',
            drafter_assigned: 'OK',
            status_updated: 'OK',
            review_approved: 'OK',
            changes_requested: 'OK',
            document_approved: 'OK',
            aria_assign: '{name}',
            aria_submit_review: '{name}',
            aria_review: '{name}',
            aria_approve: '{name}',
        },
        document_issuance: {
            title: 'Dokumentutgiving',
            document_title: 'Document',
            document_type: 'Type',
            status: 'Status',
            version: 'Versjon',
            effective_date: 'Date',
            distribution_scope: 'Distribution',
            distribution_placeholder: '...',
            issuance_number: 'Number',
            issuance_number_placeholder: 'ISS-2026-001',
            supersedes: 'Supersedes',
            none: '�',
            issue_document: 'Issue',
            ready_for_issuance: 'Ready',
            issued_documents: 'Issued',
            no_issued_documents: '�',
            view_lineage: 'Lineage',
            supersession_lineage: 'Supersession',
            document_issued: 'OK',
            document_superseded: 'OK',
            aria_issue: '{name}',
            aria_view_lineage: '{name}',
        },
        acknowledgment_tracking: {
            title: 'Kvitteringssporing',
            document_title: 'Dokument',
            acknowledged_count: 'Erkjent',
            pending_count: 'Venter',
            percentage: '%',
            details: 'Detaljer',
            send_reminder: 'Remind',
            acknowledgment_details: 'Details',
            user: 'Bruker',
            department: 'Avdeling',
            acknowledged_at: 'Date',
            status: 'Status',
            acknowledged: 'OK',
            no_issued_documents: '�',
            no_acknowledgments: '�',
            reminder_sent: 'OK',
            aria_expand: '{name}',
            aria_send_reminder: '{name}',
        },
        change_log: {
            title: 'Endringslogg',
            date: 'Dato',
            document: 'Dokument',
            change_type: 'Type',
            actor: 'Skuespiller',
            summary: 'Sammendrag',
            export_csv: 'Eksporter [[TOK_0]]',
            filters: 'Filter',
            filter_document: 'Dokument',
            all_documents: 'Alle dokument',
            filter_change_type: 'Type',
            all_types: 'Alle typar',
            date_from: 'Fr�',
            date_to: 'Til',
            version_history: 'Historikk',
            version_archive: 'Arkiv',
            no_entries: '�',
            no_history: '�',
            exported: 'OK',
            aria_export: 'CSV',
            aria_view_history: '{name}',
        },
        review_cadence: {
            title: 'Gjennomgangskadanse',
            configure_cadence: 'Gjennomgangskadanse',
            edit_cadence: 'Gjennomgangskadanse',
            document: 'Dokument',
            select_document: '...',
            review_frequency: 'Frequency',
            freq_30: '30',
            freq_60: '60',
            freq_90: '90',
            freq_180: '180',
            freq_365: '365',
            last_reviewed: 'Last',
            next_review: 'Next',
            status: 'Status',
            overdue: 'Forfalt',
            on_track: 'OK',
            days: 'days',
            horizon: 'Horizon',
            overdue_warning: 'Overdue',
            overdue_count: '{count}',
            no_cadences: '�',
            cadence_created: 'OK',
            cadence_updated: 'OK',
            aria_edit: '{name}',
        },
        remediation_plans: {
            title: 'Utbetringsplanar',
            create_plan: 'Opprett utbetringsplan',
            gap_id: 'Avviksreferanse',
            select_gap: 'Vel eit avvik...',
            plan_title: 'Tittel',
            description: 'Skildring',
            priority: 'Prioritet',
            priority_critical: 'Kritisk',
            priority_high: 'Høg',
            priority_medium: 'Middels',
            priority_low: 'Låg',
            assigned_to: 'Tildelt til',
            select_user: 'Vel ein brukar...',
            target_date: 'Måldato',
            framework_code: 'Rammeverk',
            select_framework: 'Vel eit rammeverk...',
            gap_finding: 'Avviksfunn',
            action_items: 'Handlingspunkt',
            owner: 'Eigar',
            deadline: 'Frist',
            planned: 'Planlagt',
            in_progress: 'Pågåande',
            completed: 'Fullført',
            verified: 'Verifisert',
            no_plans_found: 'Ingen utbetringsplanar funne.',
            evidence: 'Dokumentasjon',
            plan_created: 'Utbetringsplan oppretta',
            action_items_hint: 'Handlingspunkt (eitt per linje)',
        },
        statuses: {
            identified: 'Identifisert',
            assigned: 'Tildelt',
            in_remediation: 'I utbedring',
            resolved: 'Løst',
            accepted_risk: 'Akseptert risiko',
            planned: 'Planlagt',
            in_progress: 'Pågår',
            under_review: 'Under vurdering',
            finalized: 'Fullført',
            archived: 'Arkivert',
            draft: 'Utkast',
            active: 'Aktiv',
            upcoming: 'Kommende',
            collecting: 'Samler',
            published: 'Publisert',
            review: 'Gjennomgå',
            approved: 'Godkjent',
            issued: 'Utstedt',
            superseded: 'Erstattet',
            completed: 'Fullført',
            verified: 'Verifisert',
        },
        severities: {
            critical: 'Kritisk',
            high: 'Høy',
            medium: 'Middels',
            low: 'Low',
        },
        priorities: {
            critical: 'Kritisk',
            high: 'Høy',
            medium: 'Middels',
            low: 'Low',
        },
        gap_types: {
            missing: 'Mangler',
            expired: 'Utløpt',
            insufficient: 'Utilstrekkelig',
        },
        document_types: {
            policy: 'Politikk',
            procedure: 'Prosedyre',
            standard: 'Standard',
            guideline: 'Retningslinje',
            template: 'Mal (intern)',
        },
        maturity_levels: {
            level_1: 'Nivå 1 � Innledende',
            level_2: 'Nivå 2 � Utvikle',
            level_3: 'Nivå 3 � Definert',
            level_4: 'Nivå 4 � Administrert',
            level_5: 'Nivå 5 � Optimalisering',
        },
        grades: {
            excellent: 'Utmerket',
            good: 'Bra',
            fair: 'Rettferdig',
            poor: 'Dårlig',
            critical: 'Kritisk',
            needs_improvement: 'Trenger forbedring',
            not_assessed: 'Ikke vurdert',
        },
        modules: {
            data_mapping: 'Datakartlegging',
            consent: 'Samtykke',
            governance: 'Styring',
            incidents: 'Hendelser',
            monitoring: 'Overvåking',
            classification: 'Klassifisering',
            vendor_risk: 'Leverandørrisiko',
            discovery: 'Oppdagelse',
            deletion: 'Sletting',
        },
        cadences: {
            monthly: 'Månedlig',
            quarterly: 'Kvartalsvis',
            semi_annual: 'Halvårlig',
            annual: '�&rlig',
        },
        section_labels: {
            opening: '�&pning',
            key_metrics: 'Nøkkelberegninger',
            highlights: 'Høydepunkter',
            concerns: 'Bekymringer',
            recommendations: 'Anbefalinger',
            outlook: 'Outlook',
        },
        out_of_100: '/ 100',
        count_gaps: '[[TOK_1]] gap',
        count_gaps_plural: '[[TOK_1]] hull',
        count_summaries: '[[TOK_1]] sammendrag',
        count_summaries_plural: '[[TOK_1]] sammendrag',
        count_assessments: '[[TOK_1]] vurdering',
        count_assessments_plural: '[[TOK_1]] vurderinger',
        count_models: '[[TOK_1]] modell',
        count_models_plural: '[[TOK_1]] modeller',
        count_periods: '[[TOK_1]] periode',
        count_periods_plural: '[[TOK_1]] perioder',
        count_metrics: '[[TOK_1]] beregning',
        count_metrics_plural: '[[TOK_1]] beregninger',
        unknown_user: 'Ukjent bruker',
        unknown_gap: 'Ukjent gap',
        no_permission_title: 'Utilstrekkelige tillatelser',
        no_permission_message: 'Du har ikke tillatelse til å få tilgang til denne siden.',
        ac_vn_frameworks_title: 'VN Framework Dekning',
        ac_vn_frameworks_body: 'Modenhetsvurderinger dekker alle 6 vietnamesiske regulatoriske rammeverk: [[TOK_0]], datalov, telekomlov, cybersikkerhetslov, [[TOK_1]] lov og e-handelslov � hver med rammespesifikke vurderingskriterier.',
        ac_controller_processor_title: 'Kontroller vs. prosessor',
        ac_controller_processor_body: 'Forpliktelseskartlegginger skiller mellom behandlingsansvarlig og databehandleransvar. Tildel roller ved hjelp av RACI-matrisen for å sikre at hver forpliktelse har en tydelig eier, enten organisasjonen fungerer som kontroller eller prosessor.',
        ac_versioned_evidence_title: 'Versjonert bevissti',
        ac_versioned_evidence_body: 'Hver statusovergang (utkast, gjennomgang, godkjent, utstedt) oppretter en tidsstemplet, versjonert post som fungerer som kontrollerbart bevis. Endringsloggen fanger opp hele dokumentets livssyklushistorikk.',
        ac_remediation_gap_link_title: 'Koblet til Assessment Gaps',
        ac_remediation_gap_link_body: 'Hver utbedringsplan kobler direkte til et identifisert vurderingshull. Tildel en eier og sett en målfrist for å spore oppløsningsfremdriften fra gap til lukking.',
        ac_annual_attestation_title: '�&rlig attestasjonssyklus',
        ac_annual_attestation_body: 'Rapporteringsperioder samsvarer med det årlige attestasjonskravet for vietnamesisk datalov. Bruk "�&rlig" tråkkfrekvens (365-dagers syklus) for å generere attestasjonstilpassede perioder automatisk.',
        ac_evidence_per_obligation_title: 'Bevis per rammeforpliktelse',
        ac_evidence_per_obligation_body: 'Bevishull identifiserer manglende, utløpte eller utilstrekkelige bevis for hver rammeforpliktelse. Filtrer etter domene for å se hvilke regulatoriske krav som mangler støttende bevis.',
        ac_cross_framework_title: 'Fullstendighet på tvers av rammeverk',
        ac_cross_framework_body: 'Revisjonsberedskap gir et fullstendig syn på tvers av rammeverk. Komponentpoeng reflekterer dekning på tvers av alle kartlagte rammeverk, og fremhever områder som trenger oppmerksomhet før en revisjon.',
        ac_cadence_default_title: 'Standard gjennomgangskadens',
        ac_cadence_default_body: 'Standard gjennomgangstråkk er 180 dager. Forsinkede anmeldelser blir automatisk flagget. Juster frekvensen per dokument etter behov � alternativene varierer fra 30 til 365 dager.',
        ac_templates_internal_title: 'Malklassifisering',
        ac_templates_internal_body: 'Maler er klassifisert som interne dokumenter. Bruk dokumenttypen "Mal" for å merke gjenbrukbare styringsartefakter med kun intern distribusjonsomfang.',
    },
    mcp_pending: {
        title: 'MCP � Ventande skrivingar',
        subtitle: 'Eksterne Claude-klientar foreslår skrivingar her. Godkjenn eller avslå kvar oppføring � Forseti utfører berre etter administrator si godkjenning.',
        no_pending: 'Ingen ventande skrivingar.',
        col_tool: 'Verktøy',
        col_preview: 'Førehandsvising',
        col_key: '[[TOK_0]]-tasten',
        col_requested: 'Førespurt',
        col_expires: 'Utgår',
        col_status: 'Status',
        status_pending: 'Ventar',
        status_approved: 'Godkjend',
        status_declined: 'Avslått',
        status_expired: 'Utgått',
        status_executed: 'Utført',
        approve_label: 'Godkjenn',
        decline_label: 'Avslå',
        refresh_label: 'Oppdater',
        error_generic: 'Kunne ikkje lasta ventande skrivingar.',
        confirm_approve: 'Godkjenning vil utføra verktøyet mot organisasjonen din med løyva til API key-innehavaren. Halda fram?',
        confirm_decline: 'Avslå denne ventande skrivinga? Dette kan ikkje angrast.',
        advisory_banner: 'Ventande skrivingar utgår 24 timar etter oppretting. Den timesvise GC-reinsinga avslår utgåtte oppføringar automatisk.',
    },
    audit_walkthrough: {
        title: 'Forseti � Generator for revisjonsgjennomgang',
        subtitle: 'Generer ein strukturert gjennomgang for revisjonsoppstart: opningsspørsmål per kontroll, venta dokumentasjon, oppfølgingsspørsmål, moglege hol.',
        audit_picker_label: 'Revisjon',
        audit_picker_hint: 'Vel ein planlagd revisjon for å generera ein gjennomgang.',
        run_label: 'Generer gjennomgang',
        running: 'Genererer⬦',
        results_heading: 'Gjennomgang � {count} kontroll(ar)',
        tokens_label: '�0� [[TOK_1]] tokens',
        no_controls: 'Ingen kontrollar i omfanget. Legg til kontrollar på revisjonsoppføringa.',
        col_control: 'Kontroll',
        col_question: 'Opningsspørsmål',
        col_evidence: 'Dokumentasjon',
        col_gaps: 'Moglege hol',
        expected_evidence_label: 'Venta dokumentasjon',
        followup_probes_label: 'Oppfølgingsspørsmål',
        accept_label: 'Godta gjennomgang',
        reject_label: 'Avvis',
        export_label: 'Eksporter DOCX',
        resolve_summary: 'Resultat: {status}',
        error_generic: 'Kunne ikkje generera gjennomgangen. Prøv igjen eller sjekk revisjonsstatusen.',
    },
    privilege_creep: {
        title: 'Forseti � Oppdaging av rettsutviding',
        subtitle: 'Periodisk skanning av rolletildelingar. Funn er rådgjevande � Forseti trekkjer aldri tilbake automatisk.',
        run_label: 'Skann no',
        running: 'Skannar⬦',
        findings_heading: '{count} funn',
        no_findings: 'Inga rettsutviding oppdaga.',
        col_user: 'Brukar',
        col_job_function: 'Jobbfunksjon',
        col_severity: 'Alvorsgrad',
        col_unexpected: 'Uventa løyve',
        col_remediation: 'Føreslått tiltak',
        col_status: 'Status',
        severity_critical: 'Kritisk',
        severity_high: 'Høg',
        severity_medium: 'Middels',
        severity_low: 'Låg',
        status_open: '�&pne',
        status_dismissed: 'Avvist',
        status_remediated: 'Utbetra',
        dismiss_label: 'Avvis',
        remediate_label: 'Merk som utbetra',
        note_label: 'Notat (valfritt)',
        error_generic: 'Kunne ikkje skanna rettsutviding. Prøv igjen seinare.',
        advisory_banner: 'Desse funna er rådgjevande. Forseti trekkjer aldri tilbake løyve automatisk � gå gjennom saman med rolleeigaren før du handlar.',
    },
    compliance_rules: {
        rule_mapping: {
            title: 'Automatisk kartlegging av samsvarsregel',
            subtitle: 'Forseti går gjennom en installert forskriftspakke og foreslår nye eller oppdaterte samsvarsregler basert på kildeartiklene.',
            pack_picker_label: 'Forskriftspakke',
            pack_picker_hint: 'Velg en installert pakke å kartlegge.',
            run_label: 'Kart fra pakke',
            running: 'Kartlegging ⬦',
            results_heading: '[[TOK_1]] forslag',
            tokens_label: '�0� [[TOK_1]] tokens fra din månedlige bøtte',
            no_suggestions: 'Ingen forslag � pakkens innhold kan allerede være fullstendig dekket av eksisterende regler.',
            kind_new: 'Ny regel',
            kind_refresh: 'Oppdater eksisterende',
            kind_no_change: 'Ingen endring nødvendig',
            col_kind: 'Snill',
            col_title: 'Foreslått tittel',
            col_existing: 'Eksisterende regel',
            col_source: 'Kilde',
            proposed_body_label: 'Foreslått organ',
            source_quote_label: 'Kilde sitat',
            accept_selected: 'Godta valgt',
            reject_all: 'Avvis alle',
            accept_all: 'Godta alle',
            resolve_summary: 'Oppløsning: [[TOK_2]] · [[TOK_3]] regel(er) opprettet',
            error_generic: 'Kunne ikke kjøre regeltilordning. Prøv igjen eller sjekk pakkekoden.',
        },
    },
    access_accountability: {
        nav: {
            session_dashboard: 'Sesjonsoversikt',
            access_log: 'Tilgangslogg',
            justification_review: 'Grunngjevingsgjennomgang',
            investigations: 'Undersøkingar',
            pattern_analysis: 'Mønsteranalyse',
            anchoring_status: 'Forankringsstatus',
            configuration: 'Konfigurasjon',
            access_policies: 'Tilgangspolitikkar',
            review_campaigns: 'Gjennomgangskampanjar',
            evidence_packages: 'Bevispakkar',
        },
        session_dashboard: {
            title: 'Sesjonsoversikt',
            loading: 'Lastar dashborddata...',
            total_sessions: 'Totalt ��kter',
            active_sessions: 'Aktive ��kter',
            avg_duration: 'Gj.sn. Varigheit',
            concurrent_peak: 'Samtidige Topp',
            auth_method_breakdown: 'Autentisering Metode Fordeling',
            geo_country_breakdown: 'Geografisk landefordeling',
            recent_session_events: 'Nyleg ��kt Hendingar',
            user_id: 'Brukar ID',
            session_id: '��kt ID',
            ip_address: 'IP-adresse',
            auth_method: 'Autentisering Metode',
            started_at: 'Starta den',
            event_type: 'Hending Type',
            all_event_types: 'Alle Hending Typar',
            filter_by_user: 'Filter etter Brukar ID...',
            no_active_sessions: 'Ingen aktive økter',
            no_session_events: 'Ingen økthendingar funne',
            revoke: 'Tilbakekall',
            revoke_session: 'Tilbakekall ��kt',
            revoke_reason: '�&rsak',
            revoke_placeholder: 'Oppgje en årsak for tilbagekaldelse af denne session...',
            session_label: '��kt:',
            load_failed: 'Kunne ikkje laste øktdashboard. Ver venleg og prøv igjen.',
            events_load_failed: 'Kunne ikkje laste økthendingar. Ver venleg og prøv igjen.',
            revoke_failed: 'Kunne ikkje tilbakekalle økt',
            session_events_loaded: '{n} session events lasta',
            event_types: {
                session_created: '��kt opprettet',
                session_refreshed: '��kten er oppdatert',
                session_expired: '��kt utløpt',
                session_revoked: 'Sesjon tilbakekalt',
                session_terminated: '��kt avsluttet',
                login_success: 'Innlogging vellykket',
                login_failure: 'Innloggingsfeil',
                logout: 'Logg ut',
                token_refresh: 'Token Refresh',
                mfa_challenge: 'MFA utfordring',
            },
        },
        access_log: {
            title: 'Tilgangslogg',
            user_id: 'Brukar ID',
            resource: 'Ressurs',
            action: 'Handling',
            ip_address: 'IP-adresse',
            timestamp: 'Tidsstempel',
            no_logs: 'Ingen tilgang logg oppføringar funne.',
            filter_by_user: 'Filter etter Brukar ID...',
            load_failed: 'Kunne ikkje laste tilgangslogg. Ver venleg og prøv igjen.',
            export_success: 'Eksport startet',
            export_failed: 'Kunne ikkje eksportere tilgangslogg',
            record_count: 'post',
            record_count_plural: 'postar',
            unclassified: 'Ikkje klassifisert',
            classification_missing: 'Klassifisering manglar',
            response_code: 'Responskode',
            classification_levels: {
                public: 'Offentlig',
                internal: 'Intern',
                confidential: 'Konfidensielt',
                restricted: 'Begrenset',
                unclassified: 'Uklassifisert',
            },
        },
        justification_review: {
            title: 'Grunngjevingsgjennomgang',
            user_id: 'Brukar ID',
            resource: 'Ressurs',
            justification: 'Grunngiving',
            submitted_at: 'Innsendt At',
            reviewer: 'Gjennomgåar',
            no_reviews: 'Ingen grunngiving gjennomgangar funne.',
            load_failed: 'Kunne ikkje laste grunngivingar. Ver venleg og prøv igjen.',
            review_failed: 'Kunne ikkje gjennomgå grunngiving',
            decline_failed: 'Kunne ikkje avslå tilgang',
            justification_count: 'grunngiving',
            justification_count_plural: 'grunngivingar',
            reviewed: 'Gjennomgått',
            concerning: 'Urovekkjande',
            escalated: 'Eskalert',
            link_investigation_placeholder: 'Koble til en etterforsking (valfritt)',
            review_queue: 'Gjennomgang Kø',
            access_id_label: 'Tilgangs-ID',
            access_id_placeholder: 'ID for tilgangsloggoppføring',
            select_user_placeholder: 'Vel brukar (valfritt)',
            resource_type_label: 'Ressurstype',
            resource_type_placeholder: 'f.eks. document, database',
            resource_id_label: 'Ressurs-ID',
            resource_id_placeholder: 'Ressursidentifikator',
            reason_placeholder: '�&rsak til å få tilgang til denne ressursen...',
            create_failed: 'Kunne ikkje create justification',
            unclassified: 'Ikkje klassifisert',
            review_statuses: {
                pending: 'Venter',
                reviewed: 'Anmeldt',
                concerning: 'Angående',
                escalated: 'Eskalert',
            },
            reason_codes: {
                business_need: 'Forretningsbehov',
                legal_obligation: 'Juridisk forpliktelse',
                data_subject_request: 'Forespørsel om datasubjekt',
                audit_requirement: 'Revisjonskrav',
                incident_response: 'Hendelsesrespons',
                research: 'Forskning',
                administrative: 'Administrativt',
                other: 'Annet',
            },
        },
        investigations: {
            title: 'Etterforsking Arbeidsområde',
            new: 'Ny Etterforsking',
            subject: 'Emne',
            investigator: 'Etterforskar',
            opened_at: 'Opna den',
            findings: 'Funn',
            no_investigations: 'Ingen etterforskingar funne.',
            load_failed: 'Kunne ikkje laste etterforskingar. Ver venleg og prøv igjen.',
            create_failed: 'Kunne ikkje opprette etterforsking',
            timeline_add_failed: 'Kunne ikkje leggje til tidslinjeoppføring',
            link_access_failed: 'Kunne ikkje kople tilgangs-ID-ar',
            link_justification_failed: 'Kunne ikkje kople grunngivings-ID-ar',
            close_failed: 'Kunne ikkje lukke etterforsking',
            export_success: 'Eksport startet',
            export_failed: 'Kunne ikkje eksportere etterforsking',
            refresh_failed: 'Kunne ikkje oppdatere etterforskingsdetalj. Ver venleg og prøv igjen.',
            update_failed: 'Kunne ikkje oppdatere etterforsking',
            investigation_count: 'etterforsking',
            investigation_count_plural: 'etterforskingar',
            title_placeholder: 'Etterforsking tittel',
            description_placeholder: 'Detaljert skildring av etterforsking...',
            assignee_placeholder: 'Brukar-ID på modtager (valfritt)',
            timeline_action_placeholder: 'f.eks. Gennemgåede tilgangslogge',
            timeline_note_placeholder: 'Valfritt notat',
            access_ids_placeholder: 'tilgang-id-1, tilgang-id-2',
            justification_ids_placeholder: 'begrunnelse-id-1, begrunnelse-id-2',
            findings_placeholder: 'Oppsummer etterforskingns fund...',
            by_actor: 'by',
            close_investigation: 'Lukk Etterforsking',
            add_timeline_failed: 'Kunne ikkje leggje til tidslinjeoppføring.',
            fetch_failed: 'Kunne ikkje hente etterforskingar.',
            change_status: 'Endre etterforskningsstatus',
            details: 'Etterforskingsdetaljar',
            link_evidence: 'Koble bevis',
            link_justifications: 'Koble grunngjevingar',
            access_ids_label: 'Tilgangs-IDar',
            justification_ids_label: 'Grunngjevings-IDar',
            access_ids_link_placeholder: 'tilgang-id-1, tilgang-id-2',
            justification_ids_link_placeholder: 'begrunnelse-id-1, begrunnelse-id-2',
            investigations_loaded: '{n} investigations lasta',
            status_changed_to: 'Status endra til {status}',
            add_timeline_entry: 'Legg til tidslinjeoppføring',
            add_access_ids: 'Legg til tilgangs-IDar',
            add_justification_ids: 'Legg til grunngjevings-IDar',
            investigation_types: {
                anomaly_review: 'Anomali gjennomgang',
                complaint_driven: 'Klagedrevet',
                scheduled_review: 'Planlagt gjennomgang',
                whistleblower_report: 'Varslerrapport',
            },
            severity_labels: {
                low: 'Lavt',
                medium: 'Middels',
                high: 'Høy',
                critical: 'Kritisk',
            },
            status_labels: {
                open: '�&pne',
                in_progress: 'Pågår',
                pending_review: 'Venter på gjennomgang',
                closed_substantiated: 'Stengt (begrunnet)',
                closed_unsubstantiated: 'Lukket (ubegrunnet)',
                closed_inconclusive: 'Stengt (ufullstendig)',
            },
            disposition_labels: {
                substantiated: 'Begrunnet',
                unsubstantiated: 'Udokumentert',
                inconclusive: 'Inkonklusive',
            },
        },
        pattern_analysis: {
            title: 'Mønsteranalyse',
            loading: 'Lastar mønsterdata...',
            anomalies_detected: 'Avvik oppdaga',
            patterns: 'Mønster',
            by_user: 'Etter Brukar',
            by_resource: 'Etter Ressurs',
            time_range: 'Tid Område',
            load_failed: 'Kunne ikkje analysere mønster. Ver venleg og prøv igjen.',
            top_resources: 'Topp 10',
            access_by_hour: 'Tilgang etter Time av Dag',
            access_by_day: 'Tilgang etter Dag av Veke',
            fetch_failed: 'Kunne ikkje hente mønsteranalyse.',
            analysis_loaded: 'Mønsteranalyse lasta for {user}, {n} sesjonar funne',
            date_format_placeholder: 'DD/MM/�&�&�&�&',
            access_by_hour_heading: 'Tilgang etter tid på dagen',
            access_by_day_heading: 'Tilgang etter vekedag',
            by_classification: 'Etter klassifiseringsnivå',
            top_accessed_resources: 'Mest besøkte ressursar',
            user_access_summary: 'Brukartilgangsoversikt',
            days: {
                sunday: 'Søndag',
                monday: 'Måndag',
                tuesday: 'Tysdag',
                wednesday: 'Onsdag',
                thursday: 'Torsdag',
                friday: 'Fredag',
                saturday: 'Laurdag',
            },
            linked_access_logs: 'Koblede tilgangslogger',
            linked_access_logs_desc: 'Få tilgang til loggoppføringer knyttet til de oppdagede mønstrene for denne brukeren.',
        },
        anchoring_status: {
            title: 'Forankringsstatus',
            loading: 'Lastar forankringsdata...',
            anchored: 'Forankra',
            pending: 'Ventande',
            failed: 'Mislukkast',
            last_anchor: 'Siste Forankring',
            no_records: 'Ingen anchoring records funne.',
            status_load_failed: 'Kunne ikkje laste forankringsstatus. Ver venleg og prøv igjen.',
            proofs_load_failed: 'Kunne ikkje laste tilgangsbevis. Ver venleg og prøv igjen.',
            verify_failed: 'Kunne ikkje verifisere beviskjede. Ver venleg og prøv igjen.',
            anchor_failed: 'Kunne ikkje forankre tilgangsbevis',
            batch_anchor_failed: 'Kunne ikkje batchforankre tilgangsbevis',
            proof_count: 'bevis',
            proof_count_plural: 'bevis',
            anchor_single: 'Ankre enkelt',
            anchor_batch: 'Forankring Batch',
            access_id_placeholder: 'Oppgje tilgangs-ID til forankring',
            batch_ids_placeholder: 'tilgangs-id-1, tilgangs-id-2, tilgangs-id-3',
            verify_chain: 'Verifiser Kjede',
            chain_breaks: 'Kjede Brot',
            total_checked: 'Totalt sjekka',
            anchor_placeholder: 'Oppgje tilgangs-ID til forankring',
            fetch_failed: 'Kunne ikkje hente forankringsstatus.',
            fetch_proofs_failed: 'Kunne ikkje hente bevis.',
            access_id: 'Tilgangs-ID',
            chain_sequence: 'Kjedesekvens',
            proof_hash_label: 'Bevishash',
            batch_id: 'Batch-ID',
            proofs_loaded: '{n} access proofs lasta',
            anchor_statuses: {
                pending: 'Venter',
                submitted: 'Sendt inn',
                confirmed: 'Bekreftet',
                failed: 'Mislyktes',
            },
            anchor_types: {
                sha256_chain: 'SHA-256 Kjede',
                blockchain_anchor: 'Blockchain-anker',
                zkp_stub: 'ZKP Stubb',
            },
        },
        configuration: {
            title: 'Konfigurasjon',
            session_settings: '��kt Innstillingar',
            log_retention: 'Logopbevaring (dagar)',
            anomaly_threshold: 'Avvik Terskel',
            anchoring_enabled: 'Ankring aktivert',
            save_config: 'Lagre konfigurasjon',
            load_failed: 'Kunne ikkje laste konfigurasjon. Ver venleg og prøv igjen.',
            save_success: 'Konfigurasjon lagra',
            save_failed: 'Kunne ikkje lagre konfigurasjon. Ver venleg og prøv igjen.',
            justification_rules: 'Grunngiving Reglar',
            reason_codes: '�&rsak Kodar',
            anchoring_settings: 'Ankringsinnstillingar',
            anchoring_method: 'Ankringsmetode',
            anchoring_frequency: 'Ankringsfrekvens',
            batch_interval: 'Batchintervall (minutt)',
            eligibility_criteria: 'Kvalifisering Kriterium',
            add_criterion_placeholder: 'Legg til kvalifikasjonskriterie...',
            retention_settings: 'Oppbevaring Innstillingar',
            standard_retention: 'Standard opbevaring (dagar)',
            sensitive_retention: 'Følsom opbevaring (dagar)',
            working_hours: 'Arbeids Timar',
            work_start: 'Start Tid',
            work_end: 'End Tid',
            timezone: 'Tidssone',
            timezone_placeholder: 't.d. Asia/Ho_Chi_Minh',
            working_days: 'Arbeids Dagar',
            concurrent_sessions: 'Samtidige ��kt Grenser',
            concurrent_threshold: 'Samtidige ��kt Terskel',
            classification_level: 'Klassifiseringsnivå',
            prompt_mode: 'Prompttilstand',
            grace_period: 'Frist Periode (s)',
            code_placeholder: 'kode',
            is_custom: 'Tilpassa',
            label_placeholder: 'Etikett',
            description_placeholder: 'Skildring',
            custom: 'Tilpassa',
            fetch_failed: 'Kunne ikkje hente konfigurasjon.',
            classification_levels: {
                public: 'Offentlig',
                internal: 'Intern',
                confidential: 'Konfidensielt',
                restricted: 'Begrenset',
                unclassified: 'Uklassifisert',
            },
            prompt_modes: {
                reason_only: 'Bare grunn',
                reason_text: '�&rsak + tekst',
                reason_text_supervisor: '�&rsak + tekst + veileder',
            },
            anchoring_methods: {
                sha256_chain: 'SHA-256 Kjede',
                blockchain_anchor: 'Blockchain-anker',
                zkp_stub: 'ZKP Stubb',
            },
            anchoring_frequencies: {
                realtime: 'Sanntid',
                batched: 'Batched',
                on_demand: 'På forespørsel',
            },
        },
        access_policies: {
            title: 'Tilgangspolitikkar',
            create_policy: 'Opprett tilgangspolitikk',
            policy_name: 'Policynavn',
            framework_code: 'Rammeverk',
            select_framework: 'Vel eit rammeverk...',
            review_frequency: 'Gjennomgangsfrekvens',
            scope: 'Omfang',
            no_policies_found: 'Ingen tilgangspolitikkar funne.',
            policy_created: 'Tilgangspolicy oppretta',
            frequency_labels: {
                monthly: 'Månadleg',
                quarterly: 'Kvartalsvis',
                semi_annual: 'Halvårleg',
                annual: '�&rleg',
            },
        },
        review_campaigns: {
            title: 'Tilgangsgjennomgangskampanjar',
            create_campaign: 'Opprett gjennomgangskampanje',
            reviewer: 'Gjennomgåar',
            due_date: 'Forfallsdato',
            certify: 'Sertifiser',
            no_campaigns_found: 'Ingen tilgangsgjennomgangskampanjar funne.',
            status_open: '�&pne',
            status_in_review: 'Under gjennomgang',
            status_completed: 'Fullført',
            campaign_created: 'Vurderingskampanje oppretta',
            review_certified: 'Tilgangsgjennomgang sertifisert',
            certify_campaign: 'Sertifiser kampanje {id}',
            policy_id: 'Policy-ID',
            select_policy: 'Vel ein policy...',
            reviewer_ids_label: 'Vurderar',
            select_reviewers: 'Vel vurderarar...',
            status_labels: {
                open: '�&pne',
                in_review: 'Under vurdering',
                completed: 'Fullført',
            },
            evidence_package_id: 'Bevispakke-ID',
        },
        evidence_packages: {
            title: 'Bevispakkar',
            generate_package: 'Generer bevispakke',
            export_type: 'Eksporttype',
            package_type: 'Pakketype',
            framework_scope: 'Rammeverkssomfang',
            period: 'Periode',
            generated_by: 'Generert av',
            generated_at: 'Generert den',
            no_packages_found: 'Ingen bevispakkar funne.',
            package_generated: 'Bevispakke generert',
            export_type_full: 'Full eksport',
            export_type_summary: 'Samandrag',
            export_type_certification_only: 'Berre sertifisering',
            package_type_access_review: 'Tilgangsgjennomgang',
            package_type_investigation: 'Etterforsking',
            package_type_certification: 'Sertifisering',
            package_type_authority_request: 'Myndigheitsførespurnad',
            period_start: 'Periodestart',
            period_end: 'Periodeslutt',
            select_frameworks: 'Vel rammeverk...',
            completeness_col: 'Fullstende',
            status_col: 'Status',
            generated_by_col: 'Generert av',
        },
        evidence_package_detail: {
            title: 'Bevispakkedetaljar',
            not_found: 'Bevispakke ikkje funnen.',
            package_metadata: 'Pakkemetadata',
            status: 'Status',
            item_count: 'Tal på element',
            disposition: 'Disposisjon',
            closed_at: 'Lukka',
            completeness_dashboard: 'Fullstendeoversikt',
            no_completeness_data: 'Ingen fullstendedata tilgjengeleg.',
            controls_covered: 'kontrollar dekte',
            missing: 'Manglar',
            sign_off_tracker: 'Godkjenningssporing',
            stage_framework_owner: 'Rammeverkeigar',
            stage_legal_compliance: 'Jus og etterleving',
            stage_internal_audit: 'Intern revisjon',
            approved: 'Godkjend',
            returned: 'Returnert',
            pending: 'Ventar',
            approve: 'Godkjenn',
            return_btn: 'Returner',
            sign_off_submitted: 'Godkjenning sendt',
            artifacts: 'Artefaktar',
            no_artifacts: 'Ingen artefaktar funne.',
            template_id: 'Mal-ID',
            description: 'Skildring',
            classification: 'Klassifisering',
            evidence_type: 'Bevistype',
            framework_section: 'Rammeverksdel',
            history: 'Godkjenningshistorikk',
            expand: 'Utvid',
            collapse: 'Gøym',
            action: 'Handling',
            actor: 'Aktør',
            timestamp: 'Tidsstempel',
            comment: 'Kommentar',
            close_case: 'Lukk sak',
            confirm_close: 'Stadfest lukking',
            closure_notes: 'Lukkingsnotat',
            disposition_compliant: 'Samsvarande',
            disposition_non_compliant: 'Ikkje-samsvarande',
            disposition_partial: 'Delvis',
            case_closed: 'Bevispakke lukka',
            export_package: 'Eksporter pakke',
            export_complete: 'Bevispakke eksportert',
        },
    },
    consent_properties: {
        nav: {
            dashboard: 'Oversikt',
            properties: 'Eigenskapar',
            groups: 'Grupper',
            bindings: 'Bindingar',
            change_requests: 'Endringsførespurnader',
            comparison: 'Samanlikning',
            inconsistencies: 'Avvik',
            snapshot_schedules: 'Augeblikksbildeplanar',
            golden_templates: 'Gullmalar',
            evidence_packs: 'Dokumentasjonspakkar',
            audit: 'Revisjon',
        },
        select_property: 'Vel eigedom⬦',
        select_policy: 'Vel retningslinje⬦',
        select_properties: 'Vel eigedomar⬦',
        select_target_properties: 'Vel måleigedomar⬦',
        select_owner: 'Vel eigar⬦',
        select_technical_contact: 'Vel teknisk kontakt⬦',
        property_statuses: {
            active: 'Aktiv',
            inactive: 'Inaktiv',
            pending: 'Ventande',
            decommissioned: 'Avvikla',
        },
        dashboard: {
            title: 'Tverrgåande eigenskapsoversikt',
            loading: 'Lastar dashborddata...',
            total_properties: 'Totalt Eigenskapar',
            active_properties: 'Aktive Eigenskapar',
            snapshot_coverage: 'Snapshot-dekning',
            properties_covered: 'eigenskapar dekt',
            total_bindings: 'Totalt bindingar',
            deployed_bindings: 'Utplassert',
            pending_bindings: 'Ventar på utplassering',
            deployment_progress: 'Utplasseringsframgang',
            on_target: 'På mål',
            below_target: 'Under mål',
            target_label: 'Mål',
            total_groups: 'Totalt Grupper',
            pending_changes: 'Ventande Endringar',
            inconsistencies: 'Inkonsistensar',
            recent_activity: 'Nyleg Aktivitet',
            no_recent_activity: 'Ingen nyleg aktivitet.',
            fetch_error: 'Kunne ikkje laste dashboard. Ver venleg og prøv igjen.',
        },
        properties: {
            title: 'Eigenskapsregister',
            new: 'Ny Eigenskap',
            edit: 'Rediger Eigenskap',
            property_name: 'Namn',
            property_type: 'Type',
            identifier: 'Identifikator',
            environment: 'Miljø',
            owner_id: 'Eigar ID',
            technical_contact_id: 'Teknisk Kontakt ID',
            decommission: 'Avvikle',
            confirm_decommission: 'Er du sikker på at du vil avvikle denne eigenskapen?',
            no_properties: 'Ingen eigenskapar funne.',
            all_environments: 'Alle Miljø',
            all_types: 'Alle Typar',
            cmp_instance_id: '[[TOK_0]] Forekomst-ID',
            deployment_date: 'Implementeringsdato',
            identifier_placeholder: 'f.eks. www.example.com eller com.example.app',
            owner_name: 'Eigar',
            technical_contact_name: 'Teknisk kontakt',
            sensitive_data_categories: 'Sensitive datakategorier',
            sensitive_data_categories_placeholder: 'Velg sensitive datakategorier',
            requires_enhanced_review: 'Krever forbedret gjennomgang',
            sensitive_review_status: 'Gjennomgang av sensitive data',
            sensitive_review_pending: 'Venter på gjennomgang',
            sensitive_review_approved: 'Godkjent',
            sensitive_review_rejected: 'Avvist',
            sensitive_review_submit: 'Send inn anmeldelse',
            sensitive_review_approve: 'Godkjenne',
            sensitive_review_reject: 'Avvis',
            sensitive_review_notes: 'Gjennomgå notater',
            sensitive_review_notes_placeholder: 'Skriv inn anmeldelsesnotater...',
            record_withdrawal: 'Rekorduttak',
            withdrawal_subject_id: 'Emne-ID',
            withdrawal_consent_id: 'ID for samtykke',
            withdrawal_reason: 'Grunn',
            withdrawal_downstream_systems: 'Nedstrøms systemer',
            withdrawal_downstream_placeholder: 'system-1, system-2',
            withdrawal_success: 'Uttaket ble forplantet.',
            withdrawal_error: 'Kunne ikke spre tilbaketrekning.',
            withdrawal_data_subject_id: 'Datasubjekt-ID',
            withdrawal_data_subject_id_placeholder: 'f.eks. usr_abc123',
            withdrawal_consent_record_id: 'ID for samtykkepost',
            withdrawal_consent_record_id_placeholder: 'f.eks. consent_xyz789',
            withdrawal_purposes: 'Tilbaketrukket formål',
            withdrawal_purposes_placeholder: 'Velg formål for å trekke tilbake samtykke for...',
            withdrawal_withdrawn_at: 'Uttaksdato',
            withdrawal_tasks_created: 'Oppgaver opprettet',
            withdrawal_affected_bindings: 'Berørte bindinger',
            withdrawal_affected_activities: 'Berørte behandlingsaktiviteter',
            withdrawal_history: 'Uttakshistorikk',
        },
        groups: {
            title: 'Eigenskapsgrupper',
            new: 'Ny Gruppe',
            group_name: 'Gruppe Namn',
            member_count: 'Medlemer',
            no_groups: 'Ingen eigenskap grupper funne.',
            policies: 'Retningslinjer',
            confirm_delete: 'Er du sikker på at du vil slette denne gruppen?',
        },
        bindings: {
            title: 'Bindingsmatrise',
            property: 'Eigenskap',
            purpose: 'Føremål',
            legal_basis: 'Rettsleg grunnlag',
            bound: 'Bunden',
            no_bindings: 'Ingen bindings funne.',
            bind_policy: 'Bind policy',
            bulk_bind: 'Bulkbind',
            bind_policy_to_property: 'Bind policy til eiendom',
            bulk_bind_policy: 'Retningslinjer for massebinding',
            unbound: 'Ubundet',
            policy_id: 'Retningslinje-ID',
            version_placeholder: 'f.eks. 1.0.0',
            property_ids_placeholder: 'prop-id-1, prop-id-2, prop-id-3',
            binding_name: 'Binding',
            property_name: 'Eigenskapsnamn',
            policy_name: 'Policynamn',
            bindings_list: 'Bindingsliste',
            binding_actions: {
                start_deploy: 'Start utrulling',
                mark_deployed: 'Merk som utrulla',
                rollback: 'Rull tilbake',
            },
        },
        change_requests: {
            title: 'Endringsførespurnadsprosess',
            new: 'Ny Endrings Førespurnad',
            requester: 'Søkjar',
            change_type: 'Endrings Type',
            property: 'Eigenskap',
            submitted_at: 'Innsendt At',
            no_requests: 'Ingen endrings førespurnader funne.',
            fetch_pipeline_error: 'Kunne ikkje hente pipeline. Ver venleg og prøv igjen.',
            fetch_list_error: 'Kunne ikkje hente endringsførespurnader. Ver venleg og prøv igjen.',
            create_error: 'Kunne ikkje opprette endringsførespurnad. Ver venleg og prøv igjen.',
            action_error: 'Kunne ikkje utføre handling. Ver venleg og prøv igjen.',
            approver_name: 'Godkjennar',
            placeholder_target_props: 'prop-id-1, prop-id-2',
            view_all: 'Alle',
            view_my_properties: 'Mine Eigenskapar',
            stage_requests: '{stage}-førespurnader',
        },
        comparison: {
            title: 'Samanlikningsarbeidsområde',
            select_properties: 'Vel egenskaber til sammenligning',
            compare: 'Samanlikn',
            no_comparison: 'Vel mindst to egenskaber til sammenligning.',
            fetch_error: 'Kunne ikkje hente samanlikningsrapportar. Ver venleg og prøv igjen.',
            run_error: 'Kunne ikkje køyre samanlikning. Ver venleg og prøv igjen.',
            save_notes_error: 'Kunne ikkje lagre notat. Ver venleg og prøv igjen.',
            scan_complete: 'Inkonsistensscanning fuldført.',
            scan_error: 'Kunne ikkje køyre inkonsistensskann. Ver venleg og prøv igjen.',
            min_two_properties: 'Oppgje ver venleg mindst 2 egenskabs-ID-er til sammenligning.',
            view_inconsistencies: 'Vis inkonsistenser',
            click_to_select: 'Klikk for å velje to eller fleire eigenskapar',
            no_properties_available: 'Ingen eigenskapar tilgjengelege',
            no_matching_properties: 'Ingen samsvarande eigenskapar',
            select_at_least_two_props: 'Vel minst to eigenskapar frå rullegardinmenyen ovanfor.',
            no_differences_found: 'Ingen skilnader funne mellom dei valde eigenskapane.',
            found_inconsistencies: 'Fann {count} inkonsistenser på tvers av {properties} eigenskapar og {bindings} bindingar.',
        },
        inconsistencies: {
            title: 'Avviksliste',
            property: 'Eigenskap',
            field: 'Felt',
            expected: 'Forventa',
            actual: 'Faktisk',
            severity: 'Alvorlegheit',
            no_inconsistencies: 'Ingen inkonsistensar funne.',
            trend: 'Inkonsekvenstrend',
            trend_chart_label: 'Inkonsekvenstrenddiagram som viser tellinger over tid',
            acknowledge: 'Stadfest',
            resolve: 'Løys',
            suppress: 'Undertrykk',
            cr_id_placeholder: 'CR ID',
            view_all: 'Alle',
            view_my_properties: 'Mine Eigenskapar',
            view_dpo_review: '[[TOK_0]] Gjennomgangskø',
            change_request_id_required: 'Endre forespørsels-ID er nødvendig for å løse denne inkonsekvensen.',
        },
        snapshot_schedules: {
            title: 'Augeblikksbildeplanar',
            new: 'Ny Tidsplan',
            schedule_name: 'Tidsplan Namn',
            frequency: 'Frekvens',
            next_run: 'Neste Køyring',
            last_run: 'Siste Køyring',
            no_schedules: 'Ingen augeblikksbilete tidsplanar funne.',
            target_type: 'Måltype',
            target_id: 'Mål-ID',
            custom_frequency_days: 'Egendefinert frekvens (dager)',
            time_of_day: 'Tid på dagen',
            time: 'Tid',
            retention_days: 'Oppbevaring (dager)',
            execute_now: 'Utfør nå',
            placeholder_days: 'f.eks. 10',
            target_name: 'Målnamn',
        },
        golden_templates: {
            title: 'Gullmalar',
            new: 'Ny Mal',
            template_name: 'Mal Namn',
            property_type: 'Eigenskap Type',
            no_templates: 'Ingen gyllen malar funne.',
            applicable_group_ids: 'Gjeldende gruppe-ID-er (kommaseparert)',
            applicable_groups: 'Gjeldende grupper',
            purposes: 'Formål',
            legal_bases: 'Juridiske grunnlag',
            banner_config: 'Bannerkonfig',
            consent_settings: 'Samtykkeinnstillingar',
            group_ids_placeholder: 'gruppe-id-1, gruppe-id-2',
            apply_to_property: 'Bruk på Eigenskap',
            apply_to_group: 'Bruk på Gruppe',
            apply_success: 'Mal brukt vellukka.',
            applications: 'Brukshistorikk',
            no_applications: 'Ingen malbruk enno.',
            no_configuration_details: 'Malen har ingen konfigurasjonsdetaljar. Rediger malen for å leggje til formål, rettslege grunnlag, bannerinnstillingar eller samtykkeinnstillingar.',
        },
        rollouts: {
            title: 'Malutrullingar',
            rollout_status: 'Utrullingsstatus',
            confirmed: 'Stadfesta',
            pending: 'Ventande',
            failed: 'Mislukka',
            confirm: 'Stadfest Eigenskap',
            confirm_success: 'Eigenskap stadfesta i utrulling.',
            can_close: 'Alle eigenskapar stadfesta � utrulling fullført',
            cannot_close: 'Ventar på eigenskapsstadfestingar',
            no_rollouts: 'Ingen utrullingar funne.',
            in_progress: 'Pågår',
            completed: 'Fullført',
            cancelled: 'Avbroten',
            reject: 'Avvis Eigenskap',
            reject_success: 'Eigenskap avvist frå utrulling.',
            confirm_all: 'Stadfest Alle',
            reject_all: 'Avvis Alle',
            confirm_label: 'Stadfest utrulling for',
            reject_label: 'Avvis utrulling for',
            confirm_all_label: 'Stadfest Alle Ventande Utrullingar',
            reject_all_label: 'Avvis Alle Ventande Utrullingar',
            no_properties_in_rollout: 'Denne utrullinga har ingen eigenskapar.',
        },
        analytics: {
            title: 'Eigenskapsanalyse',
            opt_in_rate: 'Opt-in-rate',
            opt_out_rate: 'Opt-out-rate',
            withdrawal_rate: 'Tilbaketrekkingsrate',
            total_consents: 'Totale samtykke',
            total_withdrawals: 'Totale tilbaketrekkingar',
            compliance_score: 'Samsvarspoeng',
            non_compliant: 'Ikkje-samsvarande eigenskapar',
            no_non_compliant: 'Alle eigenskapar er i samsvar.',
            threshold: 'Samsvarsterskel',
            property_id: 'Eiendoms-ID',
            compliant: 'Samsvarlig',
            non_compliant_status: 'Ikke-kompatibel',
            compliance_help_summary: 'Hvordan beregnes samsvarspoeng, og hvordan fikser jeg det?',
            compliance_help_intro: 'En eiendom er flagget som ikke-kompatibel når dens poengsum er under 80 %. Poengsummen beregnes som:',
            compliance_help_with_template_label: 'Hvis en gylden mal brukes:',
            compliance_help_with_template_text: '% av konfigurasjonsnøkler (formål, legal_bases, banner_config, consent_settings) som samsvarer nøyaktig med malen.',
            compliance_help_no_template_label: 'Hvis ingen gylden mal er brukt:',
            compliance_help_no_template_text: '% av bindinger (samtykketyper tilordnet eiendommen) med deployment_status = distribuert. En egenskap uten bindinger er som standard 100 %.',
            compliance_help_fix_intro: 'For å fjerne en egenskap fra denne listen, gjør ett av følgende:',
            compliance_help_fix_deploy_label: 'Utplasser bindingene',
            compliance_help_fix_deploy_text: 'åpne siden Binding Matrix og sett hver bindings distribusjonsstatus til distribuert.',
            compliance_help_fix_template_label: 'Bruk en gylden mal',
            compliance_help_fix_template_text: 'bruk Bruk på gruppe på malen, og bekreft deretter utrullingen for denne egenskapen. Sørg for at egenskapens konfigurasjon samsvarer med malen.',
            compliance_help_fix_decommission_label: 'Ta ut eiendommen',
            compliance_help_fix_decommission_text: 'bruk Decommission-knappen i egenskapsdetaljmodusen hvis den ikke lenger er i bruk.',
            compliance_help_fix_no_bindings_label: 'Fjern alle bindinger',
            compliance_help_fix_no_bindings_text: 'hvis en eiendom ikke har noen mal og ingen bindinger, får den 100 % som standard.',
        },
        evidence_packs: {
            title: 'Dokumentasjonspakkar',
            new: 'Ny Pakke',
            pack_name: 'Pakke Namn',
            properties: 'Eigenskapar',
            generated_at: 'Generert Ved',
            no_packs: 'Ingen bevis pakkar funne.',
            generate: 'Generer',
            content_type_consent_records: 'Samtykkeposter',
            content_type_policy_versions: 'Retningslinje Versjonar',
            content_type_binding_history: 'Binding Historikk',
            content_type_change_requests: 'Endrings Førespurnader',
            content_type_inconsistency_reports: 'Inkonsistens Rapportar',
            content_type_snapshot_data: 'Augeblikksbilete Data',
            content_type_audit_trail: 'Revisjon Spor',
        },
        audit: {
            title: 'Revisjon av samtykkeeigenskapar',
            event_type: 'Hending Type',
            entity_type: 'Eining Type',
            entity_id: 'Eining ID',
            actor: 'Aktør',
            timestamp: 'Tidsstempel',
            no_events: 'Ingen revisjon hendingar funne.',
            entity_type_property: 'Eigenskap',
            entity_type_group: 'Gruppe',
            entity_type_binding: 'Binding',
            entity_type_change_request: 'Endringsførespurnad',
            entity_type_golden_template: 'Gyllen mal',
            entity_type_snapshot_schedule: 'Augeblikksplan',
            entity_type_inconsistency: 'Inkonsistens',
            entity_type_evidence_pack: 'Bevispakke',
            action_created: 'Oppretta',
            action_updated: 'Oppdatert',
            action_deleted: 'Sletta',
            action_decommissioned: 'Deaktivert',
            action_status_changed: 'Status endra',
            action_submitted: 'Innsendt',
            action_approved: 'Godkjend',
            action_rejected: 'Avvist',
            action_deployed: 'Implementert',
            action_rolled_back: 'Rulla tilbake',
            action_paused: 'Sett på pause',
            action_resumed: 'Gjenoppteke',
            action_cancelled: 'Avbroten',
            action_acknowledged: 'Stadfesta',
            action_resolved: 'Løyst',
            action_suppressed: 'Undertrykt',
            action_executed: 'Utført',
        },
        property_types: {
            website: 'Nettstad',
            mobile_app: 'Mobilapp',
            ott: 'OTT',
            iot_device: 'IoT-eining',
            kiosk: 'Kiosk',
            api_service: 'API-teneste',
            sdk: 'SDK',
        },
        environments: {
            production: 'Produksjon',
            staging: 'Iscenesetjing',
            development: 'Utvikling',
            testing: 'Testing',
        },
        group_types: {
            brand: 'Merke',
            region: 'Region',
            product_line: 'Produktlinje',
            business_unit: 'Forretningseining',
            custom: 'Tilpassa',
        },
        target_types: {
            property: 'Eigenskap',
            group: 'Gruppe',
            all: 'Alle',
        },
        frequencies: {
            hourly: 'Kvar time',
            daily: 'Dagleg',
            weekly: 'Kvar veke',
            monthly: 'Kvar månad',
            custom: 'Tilpassa',
        },
        binding_statuses: {
            current: 'Gjeldande',
            outdated: 'Utdatert',
            pending: 'Ventande',
            deploying: 'Implementerer',
            rolled_back: 'Rulla tilbake',
        },
        sensitive_categories: {
            health: 'Helsedata',
            biometric: 'Biometriske data',
            genetic: 'Genetiske data',
            racial_ethnic: 'Rase/etnisk opprinnelse',
            political_opinions: 'Politiske meninger',
            religious_beliefs: 'Religiøs tro',
            trade_union: 'Fagforeningsmedlemskap',
            sexual_orientation: 'Seksuell legning',
            criminal_records: 'Kriminelle journaler',
            financial: 'Finansielle data',
            children: 'Barnas data',
            geolocation: 'Nøyaktig geolokalisering',
        },
        export_csv: 'Eksporter CSV',
        exporting: 'Eksporterer...',
        page_x_of_y: 'Side {page} av {total}',
        regulatory: {
            capture_method_guidance: '[[TOK_0]] krever samtykkebevis for å matche innsamlingskanalen. Eiendomstyper kartlegger metoder for innhenting av samtykke: nettsted/OTT = bannerbasert samtykke, mobilapp/SDK = samtykkeflyt i appen, kiosk = fysisk/samtykkefangst på skjermen, [[TOK_1]] tjeneste = programmatisk samtykke, IoT-enhet = samtykkemekanisme på enhetsnivå.',
            dashboard_metrics_info: 'Dette dashbordet gir [[TOK_0]] én enkelt visning av samtykkestilling på tvers av alle digitale eiendommer. Nøkkelberegninger inkluderer: bindingsprosent (distribuert kontra totale bindinger), overholdelse av maler via inkonsistenswidgeten, ventende endringsforespørsler som krever gjennomgang, og eiendomsstatusoversikt som viser egenskaper med aktive, inaktive eller utrangerte tilstander. Eiendommer med sensitive datakategorier spores via eiendomsregisteret.',
            change_request_impact_info: 'Endringsforespørsler som påvirker samtykkeegenskaper må dokumentere regulatorisk innvirkning: hvilke [TOK_0]]-krav som påvirkes, om endringen påvirker sensitiv databehandling (art. 2.4), og om endringen krever nytt samtykke fra registrerte. Konsekvenssammendraget i hver endringsforespørsel beskriver [[TOK_1]] forskriftsreferanser for revisjonsbevis.',
            outdated_binding_warning: 'Bindinger med «utdatert»-status indikerer at en egenskap kjører en policyversjon som ikke er gjeldende. Disse egenskapene gjenspeiler kanskje ikke de siste [[TOK_0]] kravene eller oppdateringene av organisasjonspolicyer. Gjennomgå og oppdater utdaterte bindinger umiddelbart for å opprettholde [[TOK_1]] samsvar på tvers av alle samtykkeegenskaper.',
            template_pdpl_alignment: 'Per [[TOK_0]] Art. 11, skal gyldne maler knytte formål til rettsgrunnlag. Bannerkonfigurasjoner må håndheve opt-in (ikke opt-out) i henhold til art. 11.3 uttrykkelig samtykke. Maler må spesifisere en uttaksmekanisme i henhold til art. 12. For sensitive data (Art. 2.4), må maler håndheve eksplisitt skriftlig eller tilsvarende samtykke -- klikk-gjennom-godkjenning er utilstrekkelig.',
        },
    },
    localization: {
        nav: {
            dashboard: 'Oversikt',
            market_packs: 'Marknadspakkar',
            language_packs: 'Språkpakkar',
            frameworks: 'Regelverk',
            mappings: 'Modultilknytingar',
            submissions: 'Pakkeinnsendingar',
            translations: 'Omsetjingsførehandsvising',
            audit: 'Revisjonsspor',
        },
        dashboard: {
            title: 'Lokaliseringsoversikt',
            loading: 'Lastar dashborddata...',
            active_market_packs: 'Aktive Marknad Pakkar',
            published_packs_available: 'Udgivne markedspakker tilgjengelige',
            language_packs: 'Språk Pakkar',
            total_language_packs: 'Sprogpakker registreret i alt',
            active_regulatory_frameworks: 'Aktive Regulatoriske Rammeverk',
            frameworks_active: 'Rammeverk med aktive status',
            pending_pack_submissions: 'Ventande Pakke Innsendingar',
            submissions_awaiting_review: 'Send innelser afventer gjennomgang',
            recent_audit_events: 'Nyleg Revisjon Hendingar',
            no_recent_audit: 'Ingen nyleg revisjon hendingar.',
            event_type: 'Hending Type',
            entity_type: 'Eining Type',
            entity_id: 'Eining ID',
            actor: 'Aktør',
            timestamp: 'Tidsstempel',
        },
        market_packs: {
            title: 'Marknadspakkekatalog',
            new: 'Ny Marknad Pakke',
            pack_name: 'Pakke Namn',
            market: 'Marknad',
            locale: 'Lokalitet',
            no_packs: 'Ingen marknad pakkar funne.',
        },
        language_packs: {
            title: 'Språkpakkar',
            new: 'Ny Språk Pakke',
            language: 'Språk',
            locale_code: 'Lokalitet Kode',
            completeness: 'Fullstende',
            completeness_detail: 'Fullstendighetsdetalj',
            overall_completeness: 'Samlet fullstendighet',
            total_keys: 'Totalnøkler',
            translated_keys: 'Oversatte nøkler',
            missing_keys: 'Manglende nøkler',
            namespace_breakdown: 'Navneområdeoppdeling',
            namespace: 'Namnerom',
            translated: 'Oversatt',
            no_packs: 'Ingen språk pakkar funne.',
            install_language_pack: 'Installer språkpakke',
            available_packs: 'Tilgjengelege språkpakkar',
            install: 'Installer',
            all_installed: 'Alle språkpakkar er allereie installerte.',
            install_success: 'Språkpakke installert.',
            market: 'Marknad',
            featured: 'Framheva',
        },
        frameworks: {
            title: 'Regelverk',
            new: 'Ny Rammeverk',
            framework_name: 'Rammeverk Namn',
            jurisdiction: 'Jurisdiksjon',
            effective_date: 'Gjeldande Dato',
            no_frameworks: 'Ingen regulatoriske rammeverk funne.',
            view_requirements: 'Vis krav',
            hide_requirements: 'Skjul krav',
            show_legacy: 'Vis eldre rammeverk',
            effective_until: 'Gyldig til',
            effective_on: 'Gyldig frå',
            replaced_by: 'Erstatta av',
            replaces_label: 'Erstattar',
            status_legacy: 'Eldre',
            status_upcoming: 'Komande',
            watchlist: 'Overvåkningsliste',
            watchlist_empty: 'Ingen utkast eller kommende rammer',
            watchlist_empty_desc: 'Rammer med status "utkast" eller "kommende" vil vises her for overvåking.',
            expected_effective: 'Forventet effektiv',
            effective_date_tbd: 'Ikrafttredelsesdato: TBD',
            activate: 'Aktiver',
            ai_law_title: 'Vietnam [[TOK_0]] lov',
            ai_risk_classification: '[[TOK_0]] Risikoklassifisering',
            ai_system_dossier: '[[TOK_0]] Systemdokumentasjon',
            ai_labeling_checklist: '[[TOK_0]] Merking og avsløring',
            ai_incident_report: '[[TOK_0]] Hendelsesrapport',
            ai_impact_assessment: '[[TOK_0]] Konsekvensanalyse',
            ai_sandbox_application: 'Sandkasseapplikasjon',
            ai_sandbox_monitoring: 'Sandkasseovervåking',
            ai_sandbox_completion: 'Sandkasse ferdigstillelse',
            ai_submission_tracker: 'Innsending Tracker',
            ai_evidence_capture: 'Bevisfangst',
            risk_level_minimal: 'Minimal risiko',
            risk_level_limited: 'Begrenset risiko',
            risk_level_high: 'Høy risiko',
            risk_level_unacceptable: 'Uakseptabel risiko',
            submission_status_draft: 'Utkast',
            submission_status_submitted: 'Sendt inn',
            submission_status_returned: 'Returnert for endring',
            submission_status_accepted: 'Godtatt',
            submission_status_rejected: 'Avvist',
            submission_status_closed: 'Stengt',
            ecommerce_law_title: 'Vietnam e-handelslov',
            ecommerce_platform_classification: 'Plattformklassifisering',
            ecommerce_seller_register: 'Selgerregister',
            ecommerce_complaint_register: 'Klageregister',
            ecommerce_takedown_register: 'Fjerningsregister',
            ecommerce_submission_tracking: 'Innsendingssporing',
            ecommerce_dossier_checklist: 'Dossiersjekkliste',
            ecommerce_cross_border: 'Overholdelse av grenser',
            ecommerce_trustmark: 'Trustmark Program',
            ecommerce_notification: 'Varsling',
            ecommerce_registration: 'Registrering',
            ecommerce_termination: 'Oppsigelse',
            ecommerce_reporting_readiness: 'Rapporteringsberedskap',
            ecommerce_evidence_capture: 'Bevisfangst',
            submission_status_approved: 'Godkjent',
            cybersec_law_2025_title: 'Vietnam Cybersecurity Law (2025)',
            cybersec_system_classification: 'Systemklassifisering',
            cybersec_risk_assessment: 'Risikovurdering',
            cybersec_incident_report: 'Hendelsesrapport',
            cybersec_authority_cooperation: 'Myndighetssamarbeid',
            cybersec_data_localization: 'Datalokalisering',
            cybersec_vendor_security: 'Leverandørsikkerhet',
            cybersec_submission_tracker: 'Innsending Tracker',
            cybersec_evidence_capture: 'Bevisfangst',
            cybersec_dossier_checklist: 'Dossiersjekkliste',
            cybersec_classification_general: 'Generelt',
            cybersec_classification_important: 'Viktig',
            cybersec_classification_critical: 'Kritisk',
            data_law_title: 'Vietnam datalov',
            data_inventory: 'Datainventar',
            data_classification: 'Dataklassifisering',
            data_sharing: 'Datadeling',
            data_governance: 'Datastyring',
            data_submission_tracker: 'Innsending Tracker',
            data_evidence_capture: 'Bevisfangst',
            data_dossier_checklist: 'Dossiersjekkliste',
            telecom_law_title: 'Vietnam telekomlov',
            telecom_authority_request: 'Myndighetsforespørsel',
            telecom_disclosure: 'Avsløring',
            telecom_confidentiality: 'Konfidensialitet',
            telecom_submission_tracker: 'Innsending Tracker',
            telecom_evidence_capture: 'Bevisfangst',
            telecom_dossier_checklist: 'Dossiersjekkliste',
            pdpl_law_title: 'Vietnam lov om beskyttelse av personopplysninger',
            pdpl_breach_notification: 'Bruddvarsel',
            pdpl_dpo_notification: '[[TOK_0]] Melding om avtale',
            pdpl_data_subject_notification: 'Varsling av registrerte',
            pdpl_submission_tracker: 'Innsending Tracker',
            pdpl_evidence_capture: 'Bevisfangst',
            pdpl_dossier_checklist: 'Dossiersjekkliste',
            pdpl_authority_filing: 'Myndighetsarkivering',
            pdpl_mops_filing: 'MoPS-arkivering',
        },
        mappings: {
            title: 'Modultilknytingar',
            new: 'Ny Kartlegging',
            module: 'Modul',
            market_pack: 'Marknad Pakke',
            mapping_status: 'Kartlegging Status',
            no_mappings: 'Ingen modul kartleggingar funne.',
            incomplete_entries_warning: '{count} kartlegging(ar) gøymde på grunn av manglande rammeverk-ID, krav-ID eller modul.',
        },
        submissions: {
            title: 'Pakkeinnsendingar',
            new: 'Ny Innsending',
            submitter: 'Innsendar',
            pack: 'Pakke',
            submitted_at: 'Innsendt At',
            no_submissions: 'Ingen pakke innsendingar funne.',
            installed_sector_overlays_title: 'Sektoroverlegg ({count})',
            installed_sector_overlays_aria: 'Installerte sektoroverlegg',
            installed_col_name: 'Namn',
            installed_col_code: 'Kode',
            installed_col_sector: 'Sektor',
            installed_col_mode: 'Modus',
            installed_col_status: 'Status',
            installed_refresh: 'Oppdater',
        },
        translations: {
            title: 'Omsetjingsførehandsvising',
            select_locale: 'Vel språk',
            select_module: 'Vel Modul',
            key: 'Key',
            value: 'Verdi',
            no_translations: 'Ingen omsetjingar funne.',
        },
        audit: {
            title: 'Lokalisering Revisjon Spor',
            event_type: 'Hending Type',
            entity_type: 'Eining Type',
            entity_id: 'Eining ID',
            entity_name: 'Einingsnamn',
            actor: 'Aktør',
            timestamp: 'Tidsstempel',
            payload: 'Nyttelast',
            collapse_payload: 'Skjul nyttelastdetaljar',
            expand_payload: 'Utvid nyttelastdetaljar',
            collapse: 'Skjul',
            expand: 'Utvid',
            all_entity_types: 'Alle einingstypar',
            no_events: 'Ingen revisjon hendingar funne.',
        },
        market_packs_detail: {
            installed_at: 'Installert den',
            pack_details_label: 'Pakkedetaljar',
            market_code: 'Marknadskode',
            supported_locales: 'Støtta lokalitetar',
            min_platform_version: 'Min. plattformversjon',
            pack_information: 'Pakkeinformasjon',
            pack_contents: 'Pakkeinnhold',
            included_frameworks: 'Inkluderte rammeverk',
            pack_artifacts: 'Pakkeartefaktar',
            no_artifacts: 'Ingen artefaktar funne for denne pakken',
            pack_not_found: 'Pakke ikkje funne',
        },
        mappings_form: {
            framework_id: 'Rammeverk-ID',
            requirement_id: 'Krav-ID',
            module_label: 'Modul',
            mapping_type: 'Koplingstype',
            configuration_json: 'Konfigurasjon (JSON)',
            conflict_resolution: 'Konfliktløysing',
            is_override: 'Er overstyring',
            all_modules: 'Alle modular',
            all_mapping_types: 'Alle koplingstypar',
        },
        submissions_detail: {
            submission_id: 'Innsendings-ID',
            validation: 'Validering',
            reviewers: 'Vurderarar',
            start_review: 'Start vurdering',
            hide_comments: 'Gøym kommentarar',
            review_comments: 'Vurderingskommentarar',
            loading_comments: 'Lastar kommentarar...',
            no_comments: 'Ingen kommentarar enno.',
            add_comment: 'Legg til kommentar',
            reject_submission: 'Avvis innsending',
            reason_for_rejection: '�&rsak til avvising',
            reviewer_ids: 'Vurderar-IDar (kommaseparerte)',
            submit_new_pack: 'Send inn ny pakke',
            pack_type: 'Pakketype',
            market_code: 'Marknadskode',
            target_locales: 'Mållokalitetar',
            pack_file: 'Pakkefil',
            pack_format_info: 'Pakkeformat: Markedspakker bør inkludere lokalitetsspesifikke [[TOK_0]]-filer med navneområde/nøkkeloversettelser. Språkpakker bør gi oversettelser for de angitte målstedene. Se dokumentasjon for detaljert skjema.',
            accepted_formats: 'Godkjente formater: .json eller .zip. [[TOK_0]]-filer skal inneholde et flatt eller navnedelt objekt med oversettelsesnøkkelverdipar. ZIP-filer bør inneholde én eller flere [[TOK_1]] lokalitetsfiler.',
            comma_separated_locales: 'Kommaseparerte lokalkoder for denne språkpakken',
            confirm_approval: 'Stadfest godkjenning',
            approve_message: 'Godkjenn denne pakkeinnsendinga?',
            submission_label: 'Innsending',
            all_pack_types: 'Alle pakketypar',
            passed: 'bestått',
            failed_label: 'mislukka',
            market_code_required: 'Marknadskode er påkravd',
            version_required: 'Versjon er påkravd',
            pack_type_regulatory: 'Regulatorisk',
            framework_code: 'Rammekode',
            jurisdiction_code: 'Jurisdiksjonskode',
            pack_source: 'Kjelde',
            pack_source_manual: 'Manuell',
            pack_version: 'Pakkeversjon',
            install_regulatory_pack: 'Installer regulatorisk pakke',
            regulatory_pack_desc: 'Last opp ei regulatorisk rammepakke (.zip)',
            framework_required: 'Rammeverkkode er påkravd',
            jurisdiction_required: 'Jurisdiksjonskode er påkravd',
        },
        catalog_detail: {
            packs_installed_of: 'av {total} pakker installerte',
            install_all: 'Installer alle',
            installing: 'Installerer...',
            removing: 'Fjernar...',
            requires: 'Krev',
            tab_catalog: 'Katalog',
            tab_installed: 'Installert',
            details: 'Detaljar',
        },
        translations_detail: {
            source_locale: 'Kjeldelokalitet',
            target_locale: 'Mållokalitet',
            locales_must_differ: 'Kjelde- og mållokalitet må vere ulike.',
            all_keys_translated: 'Alle nøklar omsette',
            keys_missing: '[[TOK_1]] nøkkel(er) mangler',
            show_missing_only: 'Vis berre manglande',
            namespace: 'Namnerom',
            source: 'Kjelde',
            target: 'Mål',
        },
        frameworks_detail: {
            tab_frameworks: 'Rammeverk',
            tab_watchlist: 'Overvakingsliste',
            authority: 'Myndigheit',
            requirements_count: 'Krav',
            all_types: 'Alle typar',
            collapse_all: 'Skjul alle',
            expand_all: 'Utvid alle',
            filtered_to: 'Filtrert til',
            clear_filter: 'Fjern filter',
            no_requirements: 'Ingen krav funne for dette rammeverket.',
            requirements_label: 'Krav',
            status_updated: 'Status oppdatert',
            overview_tab: 'Oversikt',
            forms_tab: 'Skjema',
            procedures_tab: 'Prosedyrar',
            fines_risks_tab: 'Bøter og risiko',
            deadlines_tab: 'Fristar',
            guidance_tab: 'Veiledning',
            guidance_empty: 'Ingen veiledningsinnhold for dette rammeverket.',
            guidance_loading: 'Laster veiledning ⬦',
            guidance_section: 'Veiledningsseksjon',
            guidance_view: 'Se veiledning',
            guidance_map_to_workflow: 'Kart til arbeidsflyt',
            guidance_link_evidence: 'Koblingsbevis',
            guidance_filter_type: 'Type',
            guidance_filter_category: 'Kategori',
            guidance_filter_module: 'Modul',
            guidance_filter_status: 'Status',
            guidance_filter_search: 'Søkeveiledning',
            guidance_filter_all: 'Alle',
            guidance_table_reference: 'Referanse',
            guidance_table_name: 'Navn på veiledning',
            guidance_table_type: 'Type',
            guidance_table_category: 'Kategori',
            guidance_table_effective_date: 'Ikrafttredelsesdato',
            guidance_table_modules: 'Relaterte moduler',
            guidance_table_actions: 'Handlinger',
            guidance_reference_only_banner: 'Bare referanse � gjelder for {[[TOK_1]]}-sektoren, men ikke for organisasjonen din.',
            guidance_related_link: 'Relatert veiledning',
            deadlines_empty: 'Ingen regulatoriske fristar funne for dette rammeverket.',
            deadlines_sla_type: 'SLA-type',
            deadlines_value: 'Frist',
            deadlines_unit: 'Eining',
            deadlines_extension: 'Forlenging',
            deadlines_reference: 'Juridisk referanse',
            framework_stack: 'Rammeverkstruktur',
            layer_parent_law: 'Hovudlov',
            layer_implementing_decree: 'Gjennomføringsforskrift',
            layer_enforcement_decree: 'Handhevingsforskrift',
            layer_admin_procedures: 'Administrative prosedyrar',
            status_active: 'Aktiv',
            status_draft: 'Utkast',
            draft_enforcement_badge: 'Utkast � enno ikkje vedteke',
            effective_date: 'Iverksetjingsdato',
            forms_table_id: 'Skjema-ID',
            forms_table_name: 'Skjemanamn',
            forms_table_source: 'Kjelde',
            forms_table_category: 'Kategori',
            forms_table_type: 'Type',
            fill_form: 'Fyll ut skjema',
            view_reference: 'Se referanse',
            forms_official: 'Offisiell',
            forms_internal: 'Intern',
            forms_empty: 'Ingen skjema funne for dette rammeverket.',
            forms_loading: 'Lastar skjema...',
            filter_by_source_layer: 'Filtrer etter kildelag',
            all_layers: 'Alle lag',
            procedures_id: 'Prosedyre-ID',
            procedures_name: 'Prosedyre',
            procedures_trigger: 'Utløysar',
            procedures_steps: 'Steg',
            procedures_outputs: 'Resultat',
            procedures_related_forms: 'Relaterte skjema',
            procedures_submission_channels: 'Innsendingskanaler',
            procedures_empty: 'Ingen prosedyrar funne for dette rammeverket.',
            fines_area: 'Brotsområde',
            fines_articles: 'Utkastartiklar',
            fines_individual: 'Bot (enkeltperson)',
            fines_organization: 'Bot (organisasjon)',
            fines_revenue: 'Inntektseskalering',
            fines_deadlines: 'Fristar',
            fines_remediation: 'Utbetringstiltak',
            fines_related: 'Relaterte prosedyrar',
            fines_empty: 'Ingen handhevingsdata tilgjengeleg for dette rammeverket.',
            fines_enforcement_pending: 'Handhevingsrammeverket er ikkje publisert enno. Sanksjonsdata vert lagt til når gjennomføringsinstrumentet er kunngjort.',
            view_details: 'Vis detaljar',
            back_to_list: 'Attende til lista',
            description: 'Skildring',
            jurisdiction: 'Jurisdiksjon',
            lineage: 'Opphav',
            replaces: 'Erstattar',
            replaced_by: 'Erstatta av',
            requirements: 'Krav',
            tab_navigation: 'Rammeverkdetalj-faner',
            forms_table_actions: 'Handlingar',
            create_form: 'Opprett skjema',
            mark_promulgated: 'Merk som kunngjort',
            status_promulgated: 'Kunngjort',
            promulgated_success: 'Lagstatus oppdatert til kunngjort',
            transition_review: 'Overgangsgjennomgang',
            transition_review_desc: 'Dette rammeverket har ein ventande overgangsgjennomgang for vedtaking av etterfølgjarlov.',
            transition_review_by: 'Gjennomgangsfrist',
            transition_review_status: 'Gjennomgangsstatus',
            transition_review_notes: 'Notat',
            transition_review_pending: 'Ventande',
            transition_review_in_progress: 'Under arbeid',
            transition_review_completed: 'Fullført',
            transition_review_successor: 'Etterfølgjande rammeverk',
            transition_review_lead_time: 'Førebuingstid',
            transition_review_lead_time_days: '{days} dagar før iverksetjingsdato',
            transition_review_forms_heading: 'Skjemaovergangsgjennomgangar',
            transition_review_forms_desc: 'Gå gjennom kvar operativ mal for relevans under etterfølgjande rammeverk.',
            transition_review_outcome: 'Resultat',
            transition_review_outcome_carry_forward: 'Vidareførast',
            transition_review_outcome_carry_forward_revised: 'Vidareførast (revidert)',
            transition_review_outcome_retire: 'Vert avvikla',
            transition_review_outcome_split: 'Delast',
            transition_review_outcome_awaiting_decree: 'Ventar på forskrift',
            transition_review_no_forms: 'Ingen skjemaovergangsgjennomgangar konfigurert.',
            transition_review_update_success: 'Overgangsgjennomgang oppdatert',
            transition_review_operational_note: 'Dette er prosessstøttande operative malar, ikkje lovpålagde skjematal. Juridisk tilordning vert verande under det gamle rammeverket til etterfølgjarlova tek til å gjelde.',
            rights_tab: 'Rettigheter',
            rights_empty: 'Ingen registrerte rettigheter definert for dette rammeverket.',
            rights_code: 'Kode',
            rights_name: 'Høyre',
            rights_legal_basis: 'Juridisk grunnlag',
            rights_elaborating_articles: 'Utdybende artikler',
            rights_description: 'Beskrivelse',
            requirements_reference: 'Referanse',
            requirements_mandatory: 'Obligatorisk',
            requirements_yes: 'Yes',
            requirements_no: 'No',
            requirements_source: 'Kilde',
            category_legal_basis: 'Juridisk grunnlag',
            category_data_subject_rights: 'Datasubjektets rettigheter',
            category_notification: 'Varsling',
            category_assessment: 'Vurdering',
            category_governance: 'Styring',
            category_record_keeping: 'Journalføring',
            category_cross_border: 'Grenseoverskridende',
            category_technical_measures: 'Tekniske tiltak',
            category_incident_reporting: 'Hendelsesrapportering',
            category_risk_management: 'Risikostyring',
            category_supply_chain: 'Forsyningskjede',
            category_certification: 'Sertifisering',
            child_frameworks: '[[TOK_1]] barneramme',
            child_frameworks_plural: '[[TOK_1]] underordnede rammer',
            replaces_prefix: 'Erstatter:',
            replaced_by_prefix: 'Erstattet av:',
            responsible_prefix: 'Ansvarlig:',
            watchlist_empty_hint: 'Rammer med status "utkast" eller "kommende" vil vises her for overvåking.',
            framework_count: '[[TOK_1]] rammeverk',
            framework_count_plural: '[[TOK_1]] rammer',
            hiding_legacy: '(skjuler [[TOK_1]] arv)',
            label_VN_PDPL: '[[TOK_0]] (dekret 13/2023)',
            label_VN_PDPD_DECREE_13: 'PDPD-dekret 13/2023',
            label_VN_PDPL_LAW_2025: '[[TOK_0]] Lov 91/2025',
            label_VN_PDPL_DECREE_356_2025: 'Dekret [[TOK_0]]',
            label_VN_PDPL_ADMIN_PROCEDURES_778_2026: 'QĐ 778/QĐ-BCA-A05',
            label_VN_PDPL_ENFORCEMENT_DRAFT_2026: '[[TOK_0]] Utkast til håndhevelse 2026',
            label_VN_MOPS_ADMIN_SIMPLIFICATION_NQ22_2026: 'NQ22 Temporary Overlay 2026',
            label_VN_DATA_LAW: 'Dataloven',
            label_VN_DATA_LAW_DECREE_165_2025: 'Datalovvedtak 165/2025',
            label_VN_DATA_EXCHANGES_DRAFT_2026: 'Databørsutkast 2026',
            label_VN_TELECOM_LAW_2023: 'Telekommunikasjonsloven 2023',
            label_VN_TELECOM_DECREE_163_2024: 'Teledekret 163/2024',
            label_VN_CYBERSEC_LAW: 'Lov om nettsikkerhet (24/2018)',
            label_VN_CYBERSEC_DECREE_53: 'Cybersec-dekret 53/2022',
            label_VN_CYBERSEC_LAW_2025: 'Lov om nettsikkerhet 116/2025',
            label_VN_ECOMMERCE_LAW_2025: 'E-handelslov 122/2025',
            label_VN_AI_LAW_2026: '[[TOK_0]] Lov 2026',
            label_VN_AI_DECREE_142_2026: '[[TOK_0]] Decree 142/2026/NĐ-CP',
            issuer_company: 'Selskapet',
            issuer_authority_a05_mps: 'MPS/A05',
            issuer_authority_mic: 'MIC',
            issuer_authority_mps_ndc: 'MPS/NDC',
            issuer_other_authority: 'Autoritet',
            sla_type_rights_request_ack: 'Bekreftelse av rettigheter',
            'sla_type_Access control review': 'Gjennomgang av tilgangskontroll',
            'sla_type_Annual governance attestation': '�&rlig styringsattest',
            'sla_type_Audit review cycle': 'Revisjonsgjennomgangssyklus',
            'sla_type_Authority request response': 'Myndighetsforespørselssvar',
            'sla_type_Change notification processing': 'Endre varslingsbehandling',
            'sla_type_Complaint acknowledgment': 'Bekreftelse av klage',
            'sla_type_Complaint resolution': 'Løsning av klage',
            'sla_type_Confidentiality policy review': 'Gjennomgang av konfidensialitetspolicy',
            'sla_type_Cybersecurity incident full report': 'Hele rapporten om cybersikkerhetshendelsen',
            'sla_type_Cybersecurity incident initial report': 'Innledende rapport om cybersikkerhetshendelser',
            'sla_type_Data inventory review': 'Gjennomgang av datalager',
            'sla_type_Disclosure log review cycle': 'Gjennomgangssyklus for avsløringslogg',
            'sla_type_Incident classification decision': 'Beslutning om klassifisering av hendelser',
            'sla_type_Information system classification review': 'Gjennomgang av klassifisering av informasjonssystem',
            'sla_type_Notification processing (sales website/app)': 'Varslingsbehandling (salgsnettsted/app)',
            'sla_type_Pen test cycle': 'Penn testsyklus',
            'sla_type_Registration processing (service platform)': 'Registreringsbehandling (tjenesteplattform)',
            'sla_type_Risk assessment cycle': 'Risikovurderingssyklus',
            'sla_type_Takedown decision (after review)': 'Avgjørelse om fjerning (etter gjennomgang)',
            'sla_type_Termination notice (public)': 'Oppsigelsesvarsel (offentlig)',
            sla_type_ai_impact_assessment_completion: '[[TOK_0]] konsekvensutredning fullført',
            sla_type_ai_sandbox_application_review: '[[TOK_0]] gjennomgang av sandkasseapplikasjoner',
            sla_type_ai_serious_incident_report: '[[TOK_0]] rapport om alvorlig hendelse',
            sla_type_ai_system_registration: '[[TOK_0]] systemregistrering',
            sla_type_authority_request_response: 'Myndighetsforespørselssvar',
            sla_type_certificate_issuance_review: 'Gjennomgang av sertifikatutstedelse',
            sla_type_complaint_handling_approach_notice: 'Tilnærmingsvarsel for klagebehandling',
            sla_type_complaint_incomplete_info_request: 'Ufullstendig forespørsel om klage',
            sla_type_data_governance_attestation: 'Attestering av datastyring',
            sla_type_dsr_acknowledgment: 'DSR-anerkjennelse',
            sla_type_dsr_cl2_withdraw_restrict_object: 'DSR (Cl.2) � Trekk tilbake / begrense / gjøre innsigelse',
            sla_type_dsr_cl2_withdraw_restrict_object_third_party: 'DSR (Cl.2) � Tredjepart',
            sla_type_dsr_cl3_access_correct_provide: 'DSR (Cl.3) � Tilgang / korriger / gi',
            sla_type_dsr_cl3_access_correct_provide_third_party: 'DSR (Cl.3) � Tredjepart',
            sla_type_dsr_cl4_deletion: 'DSR (Cl.4) � Sletting',
            sla_type_dsr_cl4_deletion_third_party: 'DSR (Cl.4) � Sletting, tredjepart',
            sla_type_dsr_cl5_protective_measures: 'DSR (Cl.5) � Beskyttelsestiltak',
            sla_type_telecom_authority_request_response: 'Svar fra telemyndighetene',
            sla_type_rights_request_completion: 'Rettighetsforespørsel om fullføring',
            sla_type_incident_authority_notification: 'Melding fra hendelsesmyndighet',
            sla_type_incident_subject_notification: 'Varsel om hendelsesemne',
            sla_type_dpia_completion: '[[TOK_0]] fullføring',
            sla_type_data_retention_review: 'Gjennomgang av datalagring',
            sla_type_authority_filing_review: 'Myndighetsarkivgjennomgang',
            sla_type_authority_supplement_response: 'Myndighetstilleggsvar',
            sla_type_authority_resubmission: 'Gjeninnsending av myndigheten',
            sla_type_authority_filing_supplement_response: 'Myndighetsarkiveringstilleggssvar',
            sla_type_authority_filing_resubmission: 'Myndighetsarkivering på nytt',
            unit_working_days: 'virkedager',
            unit_calendar_days: 'kalenderdager',
            unit_hours: 'timer',
            form_category_dpa: 'DPA',
            form_category_dsr: 'DSR',
            form_category_consent: 'Samtykke',
            form_category_privacy: 'Personvern',
            form_category_breach: 'Brudd',
            form_category_dpia: '[[TOK_0]]',
            form_category_register: 'Registrer deg',
            form_category_monitoring: 'Overvåking',
            form_category_vendor: 'Leverandør',
            form_category_org: 'Organisatorisk',
            form_category_sector: 'Sektor',
            form_category_data_mapping: 'Datakartlegging',
            form_category_governance: 'Styring',
            form_category_incident: 'Hendelse',
            form_category_authority_submission: 'Innlevering av myndighet',
            form_category_notice: 'Legg merke til',
            form_category_assessment_report: 'Vurderingsrapport',
            form_category_request: 'Forespørsel',
            form_category_dossier: 'Dossier',
            form_category_filing: 'Arkivering',
            module_consent: 'Samtykke',
            module_rights_request: 'Rettighetsforespørsel',
            module_classification: 'Klassifisering',
            module_dpia: '[[TOK_0]]',
            module_governance: 'Styring',
            module_monitoring: 'Overvåking',
            module_register: 'Registrer deg',
            module_risk: 'Risiko',
            module_data_mapping: 'Datakartlegging',
            module_incident: 'Hendelse',
            module_assessment: 'Vurdering',
            module_vendor: 'Leverandør',
            module_policy: 'Politikk',
            module_audit: 'Revisjon',
            module_training: 'Trening',
            module_discovery: 'Oppdagelse',
            enum_guidance_type_calculation_guidance: 'Beregningsveiledning',
            enum_guidance_type_implementation_guidance: 'Implementeringsveiledning',
            enum_guidance_type_interpretive_note: 'Fortolkende notat',
            enum_guidance_type_legal_guidance: 'Juridisk veiledning',
            enum_guidance_type_procedural_guidance: 'Prosedyreveiledning',
            enum_guidance_type_sector_guidance: 'Sektorveiledning',
            enum_guidance_type_technical_methodology: 'Teknisk metodikk',
            enum_guidance_category_annual_reporting: '�&rsrapportering',
            enum_guidance_category_authority_cooperation: 'Myndighetssamarbeid',
            enum_guidance_category_authority_coordination: 'Myndighetskoordinering',
            enum_guidance_category_business_continuity: 'Forretningskontinuitet',
            enum_guidance_category_capital_adequacy: 'Kapitaldekning',
            enum_guidance_category_complaint_handling: 'Klagebehandling',
            enum_guidance_category_consent: 'Samtykke',
            enum_guidance_category_consent_management: 'Samtykkebehandling',
            enum_guidance_category_consumer_protection: 'Forbrukerbeskyttelse',
            enum_guidance_category_control_environment: 'Kontrollmiljø',
            enum_guidance_category_cross_border: 'Grenseoverskridende',
            enum_guidance_category_cross_border_transfers: 'Overføringer over landegrensene',
            enum_guidance_category_data_classification: 'Dataklassifisering',
            enum_guidance_category_data_localization: 'Datalokalisering',
            enum_guidance_category_data_protection_impact_assessment: 'Konsekvensvurdering for databeskyttelse',
            enum_guidance_category_direct_marketing: 'Direkte markedsføring',
            enum_guidance_category_dpia: 'DPIA',
            enum_guidance_category_governance: 'Styring',
            enum_guidance_category_ict_risk_management: 'IKT Risikostyring',
            enum_guidance_category_incident_management: 'Hendelseshåndtering',
            enum_guidance_category_internal_audit: 'Internrevisjon',
            enum_guidance_category_isms_documentation: 'ISMS-dokumentasjon',
            enum_guidance_category_lawful_basis: 'Lovlig grunnlag',
            enum_guidance_category_licensing: 'Lisensering',
            enum_guidance_category_local_presence: 'Lokal tilstedeværelse',
            enum_guidance_category_logging_and_retention: 'Logging og oppbevaring',
            enum_guidance_category_logical_and_physical_access: 'Logisk og fysisk tilgang',
            enum_guidance_category_operational_resilience_testing: 'Operasjonell motstandstesting',
            enum_guidance_category_outsourcing: 'Outsourcing',
            enum_guidance_category_platform_registration: 'Plattformregistrering',
            enum_guidance_category_quality_of_service: 'Kvalitet på tjenesten',
            enum_guidance_category_risk_classification: 'Risikoklassifisering',
            enum_guidance_category_risk_management: 'Risikostyring',
            enum_guidance_category_scope_definition: 'Definisjon av omfang',
            enum_guidance_category_sectoral_localisation: 'Sektorlokalisering',
            enum_guidance_category_subscriber_protection: 'Abonnentbeskyttelse',
            enum_guidance_category_supply_chain: 'Forsyningskjede',
            enum_guidance_category_system_classification: 'Systemklassifisering',
            enum_guidance_category_system_operations: 'Systemoperasjoner',
            enum_guidance_category_telecommunications_data: 'Telekommunikasjonsdata',
            enum_guidance_category_third_party_risk: 'Tredjepartsrisiko',
            enum_guidance_category_transitional_provisions: 'Overgangsbestemmelser',
            enum_guidance_category_vulnerability_management: 'Sårbarhetshåndtering',
            enum_guidance_status_active: 'Aktiv',
            enum_guidance_status_draft: 'Utkast',
            enum_module_access_management: 'Tilgangsadministrasjon',
            enum_module_ai_governance: '[[TOK_0]] Styring',
            enum_module_asset_management: 'Asset Management',
            enum_module_audit_trail: 'Revisjonssti',
            enum_module_breach_notification: 'Bruddvarsel',
            enum_module_capital_adequacy: 'Kapitaldekning',
            enum_module_classification: 'Klassifisering',
            enum_module_consent: 'Samtykke',
            enum_module_consent_management: 'Samtykkebehandling',
            enum_module_cross_border_transfers: 'Overføringer over landegrensene',
            enum_module_data_localization: 'Datalokalisering',
            enum_module_data_mapping: 'Datakartlegging',
            enum_module_data_protection: 'Databeskyttelse',
            enum_module_data_subject_rights: 'Datasubjektets rettigheter',
            enum_module_dpia: 'DPIA',
            enum_module_encryption: 'Kryptering',
            enum_module_governance: 'Styring',
            enum_module_incident: 'Hendelse',
            enum_module_incident_management: 'Hendelseshåndtering',
            enum_module_internal_audit: 'Internrevisjon',
            enum_module_isms_documentation: 'ISMS-dokumentasjon',
            enum_module_isms_governance: 'ISMS-styring',
            enum_module_logging_and_monitoring: 'Logging og overvåking',
            enum_module_monitoring: 'Overvåking',
            enum_module_policy_management: 'Policy Management',
            enum_module_risk: 'Risiko',
            enum_module_risk_management: 'Risikostyring',
            enum_module_training: 'Trening',
            enum_module_vendor: 'Leverandør',
            enum_module_vendor_management: 'Leverandøradministrasjon',
            enum_module_vendor_risk: 'Leverandørrisiko',
            enum_module_vulnerability_management: 'Sårbarhetshåndtering',
            category_access: 'Tilgang',
            category_availability: 'Tilgjengelighet',
            category_change_management: 'Endringsledelse',
            category_classification: 'Klassifisering',
            category_communication_and_information: 'Kommunikasjon og informasjon',
            category_compliance: 'Overholdelse',
            category_confidentiality: 'Konfidensialitet',
            category_control_activities: 'Kontrollaktiviteter',
            category_control_environment: 'Kontrollmiljø',
            category_incident: 'Hendelse',
            category_internal_audit: 'Internrevisjon',
            category_internal_control: 'Internkontroll',
            category_logical_and_physical_access: 'Logisk og fysisk tilgang',
            category_mis_data: 'Ledelsesinformasjonssystemdata',
            category_monitoring: 'Overvåking',
            category_monitoring_activities: 'Overvåkingsaktiviteter',
            category_outsourcing: 'Outsourcing',
            category_privacy: 'Personvern',
            category_processing_integrity: 'Behandlingsintegritet',
            category_reporting: 'Rapportering',
            category_risk_assessment: 'Risikovurdering',
            category_risk_mitigation: 'Risikoreduserende',
            category_sector_applicability: 'Sektoranvendelse',
            category_system_operations: 'Systemoperasjoner',
            category_training: 'Trening',
            category_vendor: 'Leverandør',
            guidance_related_forms_advisory: 'Noen skjemaer har relatert veiledning � se i',
            guidance_related_procedures_advisory: 'Noen prosedyrer har relatert veiledning - se i',
            guidance_related_requirements_advisory: 'Noen krav har relatert veiledning - se i',
        },
        channels: {
            title: 'Innsendingskanalar og fristar',
            channels: 'Innsendingskanalar',
            add_channel: 'Legg til kanal',
            channel_type: 'Type',
            name: 'Namn',
            instructions: 'Instruksjonar',
            active: 'Aktiv',
            no_channels: 'Ingen innsendingskanalar konfigurerte',
            portal: 'Portal',
            in_person: 'Personleg',
            postal: 'Post',
            email: 'E-post',
            add: 'Legg til',
            deadlines: 'Regulatoriske fristar',
            add_deadline: 'Legg til frist',
            label: 'Etikett',
            days: 'Dagar',
            day_type: 'Dagtype',
            calendar_days: 'Kalenderdagar',
            working_days: 'Arbeidsdagar',
            no_deadlines: 'Ingen fristar konfigurerte',
            description: 'Skildring',
            failed_load: 'Kunne ikkje load channel data',
            channel_added: 'Kanal lagt til',
            channel_added_announce: 'Innsendingskanal lagt til',
            failed_add_channel: 'Kunne ikkje add channel',
            deadline_added: 'Frist lagt til',
            deadline_added_announce: 'Regulatorisk frist lagt til',
            failed_add_deadline: 'Kunne ikkje add deadline',
        },
        module_links: {
            title: 'Rammeverkkopling',
            modules: 'Tilknytte modular',
            add_module: 'Legg til modul',
            module_code: 'Modulkode',
            required: 'Påkravd',
            link: 'Koble',
            no_modules: 'Ingen modular kopla',
            notes: 'Notat',
            personas: 'Tilknytte personar',
            add_persona: 'Legg til persona',
            persona_id: 'Persona-ID',
            role_description: 'Rolleskildring',
            no_personas: 'Ingen personar kopla',
            failed_load: 'Kunne ikkje load framework links',
            module_linked: 'Modul kopla',
            module_linked_announce: 'Modul kopla',
            failed_link_module: 'Kunne ikkje link module',
            persona_linked: 'Persona kopla',
            persona_linked_announce: 'Persona kopla',
            failed_link_persona: 'Kunne ikkje link persona',
        },
        regulatory_updates: {
            statuses: {
                pending: 'Ventar',
                assessed: 'Vurdert',
                applied: 'Brukt',
                dismissed: 'Avvist',
            },
            title: 'Regulatoriske oppdateringar og rammeverk-dashboard',
            page_description: 'F� oversikt over dekninga for kvart installert regulatorisk rammeverk, i tillegg til endringsloggen i produktet for regulatoriske oppdateringar: endringar, ikraftsetjingsdatoar og konsekvensvurderingar.',
            coverage_dashboard: 'Dashboard for rammeverkdekning',
            no_frameworks: 'Ingen rammeverk funne',
            framework: 'Rammeverk',
            modules: 'Modular',
            templates: 'Malar',
            forms: 'Skjema',
            channels: 'Kanalar',
            deadlines: 'Fristar',
            pending: 'Ventande oppdateringar',
            updates: 'Regulatoriske oppdateringar',
            create_update: 'Opprett oppdatering',
            framework_id: 'Rammeverk-ID',
            update_title: 'Tittel',
            description: 'Skildring',
            effective_date: 'Ikraftsetjingsdato',
            amendment_ref: 'Endringsreferanse',
            create: 'Opprett',
            no_updates: 'Ingen regulatoriske oppdateringar',
            status: 'Status',
            impact: 'Påverknad',
            change_summary: 'Endringsoversikt',
            assess: 'Vurdér',
            failed_load: 'Kunne ikkje load data',
            update_created: 'Oppdatering oppretta',
            update_created_announce: 'Regulatorisk oppdatering oppretta',
            failed_create: 'Kunne ikkje create update',
            update_assessed: 'Oppdatering vurdert',
            failed_assess: 'Kunne ikkje assess update',
        },
        sector_overlay: {
            sector_labels: {
                banking: 'Bank',
                insurance: 'Forsikring',
                healthcare: 'Helse',
                ict_critical: 'Kritisk IKT',
                telecom: 'Telekommunikasjon',
                energy: 'Energi',
                transport: 'Transport',
                digital_services: 'Digitale tenester',
                digital_technology_industry: 'Digital teknologiindustri',
                public_administration: 'Offentleg forvaltning',
                payments: 'Betalingar',
                other: 'Anna',
            },
            sector_label: 'Sektor',
            direct_scope_label: 'Direkte juridisk omfang',
            chip_direct: 'Direkte gjeldande',
            chip_reference: 'Berre til referanse',
            banner_direct_copy: 'Gjeld direkte for organisasjonen din. Sektorrapportar og fristar er aktive.',
            banner_reference_copy: 'Berre til referanse  organisasjonen din er ikkje klassifisert i denne sektoren. Sektorrapportar og fristar er ikkje aktive.',
            edit_mode_button: 'Rediger modus',
            edit_form_title: 'Endre installasjonsmodus',
            mode_direct_label: 'Direkte  juridisk gjeldande',
            mode_direct_help: 'Planlegg sektorfristar, viser dashbord-widgetar og tel med i samsvarssk�ren din.',
            mode_reference_label: 'Berre til referanse',
            mode_reference_help: 'Kan lesast og redigerast, men utan fristar, widgetar eller bidrag til poengsummen.',
            reason_note_label: 'Grunngiving (valfri)',
            reason_note_placeholder: 't.d. Dotterselskap i banksektoren kj�pt opp',
            cancel: 'Avbryt',
            confirm: 'Stadfest',
            confirming: 'Lagrar&',
            save: 'Lagre',
            saving: 'Lagrar&',
            toast_mode_changed: 'Modusen for sektoroverlegg er oppdatert.',
            toast_installed: 'Sektoroverlegg er installert.',
            toast_sectors_saved: 'Sj�lvidentifisering av sektor er lagra.',
            install_modal_title: 'Installer sektoroverlegg',
            install_modal_intro: 'Sektoroverlegg er frivillige regulatoriske pakkar avgrensa til �in bransje. Vel korleis denne pakken skal gjelde for organisasjonen din.',
            install_modal_footer: 'Du kan endre installasjonsmodus seinare fr� detaljsida for rammeverket.',
            install_button: 'Installer',
            installed_label: 'Installert',
            uninstall_button: 'Avinstaller',
            uninstall_confirm: 'Bekreft avinstallering',
            uninstall_cancel: 'Avbryt',
            suggested_label: 'Tilr�dd',
            catalog_page_title: 'Sektoroverlegg',
            catalog_page_intro: 'Valfrie regulatoriske pakkar avgrensa til �in industrisektor. Vel Direkte dersom organisasjonen din h�yrer til sektoren, eller Referanse for lesevising utan operative fristar.',
            catalog_empty_title: 'Ingen sektoroverlegg tilgjengelege',
            catalog_empty_description: 'Sektoroverleggspakkar som er publiserte i plattforma di, vil visast her.',
            authority_label: 'Mynde',
            org_sectors_title: 'Industrisektorar',
            org_sectors_intro: 'Vel industrisektorane organisasjonen din opererer i. Dette styrer standard installasjonsmodus (Direkte eller Referanse) for regulatoriske sektoroverlegg. Endringar p�verkar ikkje eksisterande installasjonar automatisk.',
            widget_title: 'Sektoroverleggrapportar som forfell',
            widget_aria_label: 'Sektoroverleggrapportar som forfell',
            widget_empty: 'Ingen kommande fristar for sektoroverlegg.',
            audit_event_mode_changed: 'Installasjonsmodus for sektoroverlegg er endra',
            audit_event_installed: 'Sektoroverlegg er installert',
            view_details_button: 'Vis detaljar �',
            banner_aria_label: 'Status for sektoroverlegg',
            toast_load_failed: 'Klarte ikkje � laste sektoroverlegg',
            toast_install_failed: 'Klarte ikkje � installere sektoroverlegg',
            toast_uninstall_confirm_required: 'Skriv "{packCode}" for � stadfeste avinstallering.',
            toast_uninstalled: 'Avinstallert {packCode}.',
            toast_uninstall_failed: 'Klarte ikkje � avinstallere sektoroverlegg',
            uninstall_warning_destructive_label: 'Destruktiv handling.',
            uninstall_warning_body: 'Avinstallering slettar rammeverksposten og alle lagra regulatoriske fristar knytte til {frameworkCode} fr� denne organisasjonen.',
            uninstall_warning_type_to_confirm: 'Skriv {packCode} for � stadfeste.',
            uninstall_in_progress: 'Avinstallerer&',
            widget_view_all: 'Vis alle sektoroverlegg � ',
            widget_due_in_days: 'Forfell om {days} d',
            widget_overdue_days: 'Forfallen med {days} d',
            widget_due_today: 'Forfell i dag',
            widget_due_unknown: '�',
        },
        phased_obligations: {
            panel_title: 'Faseinndelte plikter',
            panel_aria_label: 'Faseinndelte plikter',
            panel_intro: 'Nokre klausular i dette rammeverket blir aktive p� eit seinare tidspunkt enn sj�lve rammeverket. Her kan du f�lgje statusen og registrere tidleg innf�ring.',
            phased_effective_date_label: 'Faseinndelt ikraftsetjing:',
            status_pending: 'Ventande',
            status_active: 'Aktiv',
            status_early: 'Aktiv (innf�rt tidleg)',
            notice_window_label: 'Varslingsvindauge til mynde:',
            days_label: 'dagar',
            recipient_label: 'Mottakar:',
            early_implement_button: 'Merk som innf�rt tidleg',
            early_implement_modal_title: 'Merk faseinndelt plikt som innf�rt tidleg',
            early_implement_modal_intro: 'N�r du registrerer tidleg innf�ring, blir plikta aktiv no, og nedteljinga for varsel til styresmakta startar.',
            effective_at_label: 'Gjeld fr�',
            reason_label: 'Grunngiving (valfri)',
            reason_placeholder: 't.d. Styret godkjende tidleg innf�ring 2026-09-01',
            confirm: 'Stadfest',
            toast_early_implemented: 'Tidleg innf�ring er registrert.',
            audit_event_early_implemented: 'Faseinndelt plikt merka som innf�rt tidleg',
            widget_rolling_window_label: 'Faseinndelte aktiveringar dei neste 90 dagane',
        },
    },
    partner_marketplace: {
        nav: {
            dashboard: 'Oversikt',
            partner_orgs: 'Partnarorganisasjonar',
            service_tiers: 'Tenestenivå',
            deliverable_templates: 'Leveransemalar',
            deliverables: 'Leveransar',
            brand_profiles: 'Merkeprofilar',
            support_tickets: 'Støttesaker',
            workflow_templates: 'Arbeidsflytmalar',
            workflows: 'Arbeidsflytar',
            escalation: 'Eskalering',
            reports: 'Rapportar',
            audit: 'Revisjonsspor',
        },
        dashboard: {
            title: 'Partneroversikt',
            loading: 'Lastar dashborddata...',
            total_managed_tenants: 'Totalt Administrerte Leigetakarar',
            avg_health_score: 'Gj.sn. Helse Poeng',
            open_tickets: 'Opne Saker',
            upcoming_deliverables: 'Komande Leveransar',
            escalated_tickets: 'Eskalerte Saker',
            managed_tenants: 'Administrerte Leigetakarar',
            partner_tier: 'Partner Nivå',
            managed_tenants_count: 'Administrerte Leigetakarar Tal',
            onboarding_date: 'Onboarding Dato',
            view_details: 'Vis Detaljar',
            no_partner_orgs: 'Ingen partnerorganisasjonar funne.',
        },
        partner_orgs: {
            title: 'Partnarorganisasjonar',
            new: 'Ny Partner Org.',
            contact_name: 'Kontakt Namn',
            contact_email: 'Kontakt E-post',
            partner_tier: 'Partner Nivå',
            managed_orgs: 'Administrerte Org.',
            onboarding_date: 'Onboarding Dato',
            no_orgs: 'Ingen partnerorganisasjonar funne.',
            contact_phone: 'Kontakt Telefon',
            metadata_json: 'Metadata ([[TOK_0]])',
            change_status: 'Endrings Status',
            new_status: 'Ny Status',
            invalid_json_metadata: 'Ugyldig JSON i metadatafelt',
            suspended: 'Suspendert',
            offboarded: 'Avregistrert',
            all_tiers: 'Alle Nivå',
            silver: 'Sølv',
            gold: 'Gull',
            platinum: 'Platina',
            status_offboarded: 'Avregistrert',
            status_suspended: 'Suspendert',
            tier_gold: 'Gull',
            tier_platinum: 'Platina',
            tier_silver: 'Sølv',
        },
        service_tiers: {
            title: 'Tenestenivå',
            new: 'Ny Nivå',
            tier_name: 'Nivå Namn',
            monthly_fee: 'Månadleg Fee',
            features: 'Funksjonar',
            no_tiers: 'Ingen service tiers funne.',
            tier_code: 'Nivå Kode',
            user_seats: 'Brukar Plassar',
            user_seat_limit: 'Brukar Plass Grense',
            storage_gb: 'Lagring (GB)',
            storage_limit_gb: 'Lagring Grense (GB)',
            response_time_hrs: 'Svartid (timer)',
            resolution_time_hrs: 'Løsningstid (timer)',
            review_frequency: 'Gjennomgang Frekvens',
            sla_response_time: 'SLA-svartid (timer)',
            sla_resolution_time: 'SLA-løsningstid (timer)',
            module_profile_json: 'Modul Profil (JSON)',
            comparing: 'Samanliknar...',
            compare: 'Samanlikn',
            comparison: 'Tjenestenivåsammenligning',
            attribute: 'Attributt',
            deprecate: 'Utfas',
            deprecated: 'Utfasa',
            invalid_json_module: 'Ugyldig JSON i modulprofilfelt',
            select_compare: 'Vel mindst 2 niveauer til sammenligning',
            comparison_title: 'Tjenestenivåsammenligning',
            status_deprecated: 'Utfasa',
            activate: 'Aktiver',
            invalid_json_module_profile: 'Ugyldig JSON in modul profil',
            resolution_time: 'Løysing Tid',
            response_time: 'Svar Tid',
            select_at_least_two: 'Vel mindst 2 niveauer',
        },
        deliverable_templates: {
            title: 'Leveransemalar',
            new: 'Ny Mal',
            template_name: 'Mal Namn',
            deliverable_type: 'Leveranse Type',
            no_templates: 'Ingen leveranse malar funne.',
            frequency: 'Frekvens',
            est_effort_hrs: 'Ansl. indsats (timer)',
            estimated_effort: 'Estimeret indsats (timer)',
            associated_module: 'Tilknytt Modul',
            linked_tiers_count: 'Tilknytte Nivå Tal',
            evidence_requirements: 'Bevisskrav (kommaseparert)',
            tier_ids: 'Niveau-ID-er (kommaseparert)',
            frequency_one_time: '�0in Tid',
            frequency_monthly: 'Månadleg',
            frequency_quarterly: 'Kvartalsvis',
            frequency_annually: '�&rleg',
            type_report: 'Rapport',
            type_review: 'Gjennomgang',
            type_assessment: 'Vurdering',
            type_meeting: 'Møte',
            type_configuration: 'Konfigurasjon',
            freq_one_time: '�0in Tid',
            freq_monthly: 'Månadleg',
            freq_quarterly: 'Kvartalsvis',
            freq_annually: '�&rleg',
            status_deprecated: 'Utfasa',
        },
        deliverables: {
            title: 'Leveransar',
            new: 'Ny Leveranse',
            partner: 'Partner',
            deliverable_type: 'Leveranse Type',
            due_date: 'Forfallsdato',
            no_deliverables: 'Ingen leveransar funne.',
            assigned_to: 'Tildelt Til',
            completion_date: 'Ferdigstilling Dato',
            update_status: 'Oppdatering Status',
            hide_details: 'Gøym detaljar',
            view_details: 'Vis Detaljar',
            evidence_ids: 'Bevis ID-ar',
            client_approval: 'Klient Godkjenning',
            bulk_update: 'Masse Oppdater',
            bulk_update_status: 'Masse Oppdater Status',
            generate_schedule: 'Generer Planlegg',
            generate_deliverable_schedule: 'Generer Leverance Planlegg',
            organization_id: 'Organisasjon ID',
            service_tier_id: 'Teneste Nivå ID',
            filter_assigned_to: 'Filter etter Tildelt Til',
            select_status: 'Vel status...',
            new_status: 'Ny Status',
            upcoming: 'Komande',
            overdue: 'Forsinka',
            status_deferred: 'Utsett',
            status_overdue: 'Forsinka',
            status_upcoming: 'Komande',
        },
        brand_profiles: {
            title: 'Merkeprofilar',
            new: 'Ny Brand Profil',
            partner: 'Partner',
            brand_name: 'Merkevare Namn',
            primary_color: 'Primær Farge',
            logo_url: 'Logo [[TOK_0]]',
            no_profiles: 'Ingen brand profiles funne.',
            secondary_color: 'Sekundær Farge',
            header_text: 'Topptekst Tekst',
            footer_text: 'Botntekst Tekst',
            contact_email: 'Kontakt E-post',
            contact_phone: 'Kontakt Telefon',
            contact_website: 'Kontakt Nettstad',
            contact_address: 'Kontaktadresse',
            is_default: 'Er Standard',
            set_default: 'Set Standard',
            preview: 'Førehandsvising',
            report_header_preview: 'Rapport Topptekst Førehandsvising',
            report_footer_preview: 'Rapport Botntekst Førehandsvising',
            preview_description: 'Dette er ei førehandsvising av rapporthovudet med dei valde merkevare-fargane.',
            contact_website_short: 'Nettstad',
            logo_preview: 'Logo førehandsvising',
        },
        support_tickets: {
            title: 'Støttesaker',
            new: 'Ny Sak',
            partner: 'Partner',
            subject: 'Emne',
            assigned_to: 'Tildelt Til',
            no_tickets: 'Ingen støtte saker funne.',
            category: 'Kategori',
            priority: 'Prioritet',
            escalation_tier: 'Eskalering Nivå',
            sla_status: 'SLA-status',
            update_status: 'Oppdatering Status',
            escalate: 'Eskaler',
            add_note: 'Legg til notat',
            escalate_ticket: 'Eskaler Sak',
            escalate_to_tier: 'Eskaler To Nivå',
            notes_timeline: 'Notat Tidslinje',
            no_notes: 'Ingen notat enno.',
            attachments: 'Vedlegg',
            no_attachments: 'Ingen attachments.',
            client_org_id: 'Klient Org. ID',
            content: 'Innhald',
            note_type: 'Type',
            view_detail: 'Vis Detalj',
            hide: 'Gøym',
            new_status: 'Ny Status',
            all_categories: 'Alle Kategoriar',
            all_priorities: 'Alle prioriteringar',
            all_tiers: 'Alle Nivå',
            ticket_not_found: 'Sak ikke fundet',
            ticket_id: 'Sak ID',
            client_org: 'Klient Org.',
            deescalate: 'Deeskaler',
            deescalate_ticket: 'Deeskaler Sak',
            deescalate_to_tier: 'Deeskaler To Nivå',
            add_attachment: 'Add Vedlegg',
            file: 'Fil',
            linked_entity: 'Tilknytte Eining',
            sla_target: 'Mål',
            breached: 'Broten',
            remaining_hours: 'attståande',
            na: 'N/A',
            tickets_found: 'saker funne',
            reason: '�&rsak',
            target: 'Mål',
            upload: 'Last opp',
        },
        workflow_templates: {
            title: 'Arbeidsflytmalar',
            new: 'Ny Mal',
            template_name: 'Mal Namn',
            steps: 'Steg',
            no_templates: 'Ingen arbeidsflyt malar funne.',
            category: 'Kategori',
            view_steps: 'Vis Steg',
            hide_steps: 'Gøym trinn',
            step: 'Steg',
            step_title: 'Tittel',
            step_description: 'Skildring',
            assignee_role: 'Tilordna rolle',
            sla_hours: 'SLA Timar',
            evidence_required: 'Bevis Påkravd',
            guidance_notes: 'Rettleiing Notat',
            add_step: 'Add Steg',
            no_steps: 'Ingen steg definert.',
            no_steps_defined: 'Ingen steg definert.',
            templates_found: 'malar funne',
            all_categories: 'Alle Kategoriar',
        },
        workflows: {
            title: 'Arbeidsflyt Instansar',
            new: 'Ny Arbeidsflyt',
            template: 'Mal',
            partner: 'Partner',
            current_step: 'Noverande Steg',
            progress: 'Framdrift',
            no_workflows: 'Ingen arbeidsflyt instansar funne.',
            instances_found: 'instansar funne',
        },
        escalation: {
            title: 'Eskalering Dashbord',
            ticket: 'Sak',
            partner: 'Partner',
            escalated_at: 'Eskalerte Ved',
            reason: '�&rsak',
            no_escalations: 'Ingen eskaleringer funne.',
            time_in_tier: 'Tid i Nivå',
            auto_evaluate: 'Auto Evaluer',
            priority_critical: 'Kritisk',
            priority_high: 'Høg',
            priority_medium: 'Middels',
            priority_low: 'Low',
            deescalated_from_dashboard: 'Deeskaleret fra dashboard',
            sla_breached: 'SLA broten',
            sla_remaining: 'SLA Attståande',
        },
        reports: {
            title: 'Rapportar',
            partner: 'Partner',
            report_type: 'Rapport Type',
            generated_at: 'Generert Ved',
            no_reports: 'Ingen rapportar funne.',
            generate: 'Generer Rapport',
        },
        audit: {
            title: 'Partner Revisjon Spor',
            event_type: 'Hending Type',
            entity_type: 'Eining Type',
            entity_id: 'Eining ID',
            actor: 'Aktør',
            timestamp: 'Tidsstempel',
            no_events: 'Ingen revisjon hendingar funne.',
            events_found: 'hendingar funne',
            event_type_created: 'Opprettet',
            event_type_updated: 'Oppdatert',
            event_type_deleted: 'Slettet',
            event_type_status_change: 'Statusendring',
            event_type_escalation: 'Eskalering',
            event_type_assignment: 'Oppdrag',
            entity_type_partner_org: 'Partner Org',
            entity_type_service_tier: 'Tjenestenivå',
            entity_type_deliverable_template: 'Leverbar mal',
            entity_type_deliverable_instance: 'Leverbar forekomst',
            entity_type_brand_profile: 'Merkevareprofil',
            entity_type_support_ticket: 'Støttebillett',
            entity_type_workflow_template: 'Arbeidsflytmal',
            entity_type_workflow_instance: 'Arbeidsflytforekomst',
            entity_type_generated_report: 'Generert rapport',
            entity_type_escalation_rule: 'Eskaleringsregel',
        },
        no_permission_title: 'Utilstrekkelige tillatelser',
        no_permission_message: 'Du har ikke tillatelse til å få tilgang til partnerarbeidsområdet.',
        status_active: 'Aktiv',
        status_suspended: 'Suspendert',
        status_offboarded: 'Utenbords',
        status_completed: 'Fullført',
        status_cancelled: 'Kansellert',
        status_deprecated: 'Avviklet',
        status_new: 'Nytt',
        status_triaged: 'Triagert',
        status_in_progress: 'Pågår',
        status_waiting_on_client: 'Venter på klient',
        status_waiting_on_vendor: 'Venter på leverandøren',
        status_escalated: 'Eskalert',
        status_resolved: 'Løst',
        status_closed: 'Stengt',
        status_pending: 'Venter',
        status_skipped: 'Hoppet over',
        category_onboarding: 'Onboarding',
        category_incident_escalation: 'Eskalering av hendelsen',
        category_config_change: 'Config Change',
        category_periodic_review: 'Periodisk gjennomgang',
        category_offboarding: 'Offboarding',
        category_custom: 'Egendefinert',
        category_configuration: 'Konfigurasjon',
        category_incident: 'Hendelse',
        category_compliance_question: 'Samsvarsspørsmål',
        category_feature_request: 'Funksjonsforespørsel',
        category_bug_report: 'Feilrapport',
        priority_critical: 'Kritisk',
        priority_high: 'Høy',
        priority_medium: 'Middels',
        priority_low: 'Lavt',
        tier_silver: 'Sølv',
        tier_gold: 'Gull',
        tier_platinum: 'Platina',
        report_type_compliance_summary: 'Samsvarssammendrag',
        report_type_risk_overview: 'Risikooversikt',
        report_type_incident_report: 'Hendelsesrapport',
        report_type_consent_status: 'Samtykkestatus',
        report_type_program_maturity: 'Programforfall',
        report_type_executive_pack: 'Executive-pakke',
        note_type_internal: 'Intern',
        note_type_client_visible: 'Klient synlig',
        status_updated: 'Status oppdatert',
        deliverable_status_updated: 'Leveringsstatus ble oppdatert',
        ticket_status_updated: 'Billettstatusen ble oppdatert',
        ticket_escalated: 'Billetten ble eskalert',
        note_added: 'Merknaden ble lagt til',
        attachment_uploaded: 'Vedlegget ble lastet opp',
        ticket_deescalated: 'Billetten deeskalerte vellykket',
        auto_evaluation_completed: 'Auto-evaluering fullført',
        template_created: 'Arbeidsflytmal ble opprettet',
        template_updated: 'Arbeidsflytmalen ble oppdatert',
        brand_set_default: 'Merkevareprofilen er angitt som standard',
        brand_created: 'Merkevareprofilen ble opprettet',
        brand_updated: 'Merkevareprofilen ble oppdatert',
        tier_created: 'Tjenestenivået ble opprettet',
        tier_updated: 'Tjenestenivået ble oppdatert',
        tier_deprecated: 'Tjenestenivået ble avviklet',
        tier_activated: 'Tjenestenivået ble aktivert',
        period: 'Periode',
        format: 'Format',
        period_start: 'Periodestart',
        period_end: 'Periodeslutt',
        reports_count: '[[TOK_1]] rapporterer',
        reports_count_one: '[[TOK_1]] rapport',
        metric: 'Metrisk',
        value: 'Verdi',
        showing_chart_view: 'Viser kartvisning',
        showing_table_view: 'Viser datatabellvisning',
        evidence_ids_placeholder: 'f.eks. ev-001, ev-002',
        confirm_cancel_workflow: 'Er du sikker på at du vil avbryte denne arbeidsflyten? Denne handlingen kan ikke angres.',
        export_csv: 'Eksporter [[TOK_0]]',
        compliance_qualifications_title: 'Compliance Service-kvalifikasjoner',
        compliance_qualifications_desc: 'Partnerlag (sølv/gull/platina) bestemmer omfanget av samsvarstjenesten. Gull- og platinapartnere er kvalifisert for engasjementer i regulert industri. Bruk Metadata-feltet til å registrere sertifiseringer (ISO 27001, SOC 2), spesialiseringer og jurisdiksjonskvalifikasjoner for hver partner.',
        regulatory_output_title: 'Regulatory Output Alignment',
        regulatory_output_desc: 'Hver maltype tilordnes en regulatorisk utdatakategori: Rapporter produserer samsvarsdokumentasjon, vurderinger validerer kontrolleffektivitet, vurderinger dekker risikoevalueringer ([[TOK_0]], gap-analyse), møter med dokumentstyringsøkter. Beviskrav definerer artefaktene hver leveranse må referere til for revisjonsberedskap.',
        sla_compliance_title: '[[TOK_0]] Sporing for overholdelseslevering',
        sla_compliance_desc: 'SLAer for respons og løsningstid er kontraktsmessig bindende for levering av samsvarstjenester. Gjennomgangsfrekvens avgjør hvor ofte partnersamsvarsleveranser evalueres. [[TOK_0]] brudd på overholdelseskritiske billetter utløser automatisk eskalering og logges i Partner Audit Trail for regulatoriske bevis.',
        regulatory_engagement_title: 'Regulatoriske engasjementmønstre',
        regulatory_engagement_desc: 'Arbeidsflytkategorier kartlegges til regulatoriske engasjementtyper: Onboarding dekker innledende samsvarsoppsett og gapanalyse, periodisk gjennomgang håndterer tilbakevendende samsvarsvurderinger, Incident Escalation administrerer regulatoriske bruddrespons, Offboarding sikrer at forpliktelsene til oppbevaring av data blir oppfylt. Hvert trinn kan kreve bevisinnsamling for fullstendighet i revisjonssporet.',
        compliance_escalation_title: 'Samsvarskritiske eskaleringsprosedyrer',
        compliance_escalation_desc: 'L1 håndterer standard driftsproblemer. L2 dekker samsvarspåvirkende svikt (misste regulatoriske tidsfrister, kontrollhull). L3 er reservert for regulatoriske bruddscenarier som krever umiddelbar oppmerksomhet fra ledelsen. [[TOK_0]] brudd på L2/L3-billetter genererer revisjonssporoppføringer automatisk. Alle eskalerings- og deeskaleringshandlinger logges permanent.',
        audit_regulatory_title: 'Regulatory Evidence Trail',
        audit_regulatory_desc: 'Dette revisjonssporet gir manipulasjonssikre poster for overholdelse av regelverk. Hver partnerhandling (opprett, oppdater, slett, eskalering, statusendring) logges med aktøridentitet, tidsstempel og full nyttelastdiff. Bruk Entity Type-filtre for å isolere bevis etter samsvarsdomene. Eksporter filtrerte resultater for å produsere revisjonsklar dokumentasjon for regulatoriske inspeksjoner.',
        evidence_trail_title: 'Cross-Module Evidence Trail',
        evidence_trail_desc: 'Hvert arbeidsflyttrinn kan samle bevis-ID-er som kobler til leveranser, revisjonshendelser og samsvarsartefakter på tvers av moduler. �& gå videre med bevis-IDer skaper en verifiserbar kjede som kobler partnerarbeidsflyter til regulatorisk dokumentasjon. Fullførte arbeidsflyter med fullstendige beviskjeder tjener som bevis på levering av overholdelse.',
        evidence_ids_label: 'Bevis-IDer',
    },
    org_groups: {
        title: 'Organisasjonsgrupper',
        new: 'Opprett Gruppe',
        group_name: 'Gruppe Namn',
        member_count: 'Medlem Tal',
        root_org: 'Rot Org.',
        no_groups: 'Ingen org. grupper funne.',
        add_organization: 'Legg til Organisasjon',
        select_organization: 'Vel ein organisasjon...',
        no_available_orgs: 'Ingen tilgjengelege organisasjonar å leggje til.',
        no_members: 'Ingen medlemsorganisasjonar i denne gruppa.',
        member_added: 'Organisasjon lagt til gruppa.',
        member_removed: 'Organisasjon fjerna frå gruppa.',
        already_in_group: 'Denne organisasjonen er allereie i ei gruppe.',
        org_not_found: 'Organisasjon ikkje funnen.',
        add_member_error: 'Kunne ikkje leggje til organisasjon i gruppa.',
        remove_member_error: 'Kunne ikkje fjerne organisasjon frå gruppa.',
        confirm_remove_member: 'Er du sikker på at du vil fjerne "{name}" frå denne gruppa?',
        load_error: 'Kunne ikkje laste org. gruppedetaljar.',
        page_title_list: 'Organisasjonsgrupper',
        page_title_detail: 'Organisasjonsgruppedetaljer',
        page_title_create: 'Opprett organisasjonsgruppe',
        page_title_settings: 'Organisasjonsgruppeinnstillinger',
        page_title_users: 'Gruppebrukere',
        page_title_reports: 'Grupperapporter',
        page_title_dashboard: 'Gruppe Dashboard',
        page_title_audit: 'Konsernrevisjon',
        page_title_org_audit: 'Organisasjonsgrupperevisjon',
        page_title_shared_vendors: 'Delte leverandører',
        page_title_shared_frameworks: 'Delte rammer',
        page_title_shared_forms: 'Delte skjemamaler',
        page_title_merged_vendors: 'Sammenslåtte leverandører',
        page_title_settings_inheritance: 'Innstillinger Arv',
        announce_loaded_groups: 'Lastet inn [[TOK_1]] organisasjonsgrupper',
        announce_loaded_group: 'Lastet gruppe [[TOK_1]]',
        announce_loaded_users: 'Lastet [[TOK_1]] gruppebrukere',
        announce_loaded_reports: 'Lastet [[TOK_1]] rapporter',
        announce_loaded_vendors: 'Lastet inn [[TOK_1]] delte leverandører',
        announce_loaded_frameworks: 'Lastet [[TOK_1]] delte rammer',
        announce_loaded_templates: 'Lastet [[TOK_1]] delte skjemamaler',
        announce_loaded_audit: 'Lastet inn [[TOK_1]] revisjonshendelser',
        announce_loaded_merged: 'Lastet inn [[TOK_2]] delte og [[TOK_3]] lokale leverandører',
        announce_dashboard_loaded: 'Dashboard lastet.',
        announce_dashboard_refreshed: 'Dashbordet er oppdatert.',
        announce_dashboard_refresh_failed: 'Kunne ikke oppdatere oversikten.',
        announce_refreshing: 'Oppdaterer dashbordet ...',
        announce_settings_loaded: 'Innstillingsarv lastet.',
        announce_settings_saved: 'Innstillingene er lagret.',
        announce_saving_settings: 'Lagrer innstillinger...',
        announce_error_saving: 'Feil under lagring av innstillinger.',
        announce_group_dissolved: 'Gruppen oppløst.',
        announce_creating_group: 'Oppretter organisasjonsgruppe ...',
        announce_group_created: 'Organisasjonsgruppen ble opprettet.',
        announce_error_creating: 'Feil ved opprettelse av organisasjonsgruppe.',
        announce_vendor_published: 'Leverandør publisert vellykket.',
        announce_vendor_retired: 'Selger gikk av med pensjon.',
        announce_framework_published: 'Rammeverket ble publisert.',
        announce_framework_retired: 'Framework pensjonert.',
        announce_template_published: 'Skjemamal ble publisert.',
        announce_template_retired: 'Skjemamalen er trukket tilbake.',
        announce_role_assigned: 'Rollen ble tildelt.',
        announce_error_assign_role: 'Feil ved tildeling av rolle.',
        announce_role_revoked: 'Rollen er tilbakekalt.',
        announce_report_generating: 'Genererer rapport...',
        announce_report_requested: 'Rapportgenerering forespurt.',
        announce_error_report: 'Feil ved forespørsel om rapport.',
        announce_report_deleted: 'Rapport slettet.',
        announce_search_applied: 'Søk brukt.',
        announce_search_cleared: 'Søket er slettet.',
        announce_tab_selected: '[[TOK_1]]-fanen er valgt',
        announce_error_add_member: 'Feil ved å legge til medlem i gruppen.',
        announce_category_reverted: '[[TOK_1]] tilbakestilt til arvet fra forelder.',
        announce_category_overridden: '[[TOK_1]] satt til lokal overstyring.',
        announce_override_saved: '[[TOK_1]] overstyring lagret.',
        announce_export_started: 'Eksporterer revisjon som [[TOK_1]]...',
        announce_export_completed: 'Eksporten som [[TOK_1]] fullført.',
        announce_export_failed: 'Eksporten mislyktes.',
        announce_filter_org: 'Filtrert etter organisasjon [[TOK_1]]',
        announce_filter_org_cleared: 'Organisasjonsfilteret er tømt',
        announce_filter_event: 'Filtrert etter hendelsestype [[TOK_1]]',
        announce_filter_cleared: 'Filter tømt',
        announce_download: 'Laster ned [[TOK_2]] som [[TOK_3]]',
        error_load_groups: 'Kunne ikke laste inn organisasjonsgrupper. Vennligst prøv igjen.',
        error_load_users: 'Kunne ikke laste inn gruppebrukere.',
        error_load_reports: 'Kunne ikke laste inn grupperapporter.',
        error_load_dashboard: 'Kunne ikke laste inn gruppeoversikten.',
        error_load_settings: 'Kunne ikke laste inn gruppeinnstillinger.',
        error_load_vendors: 'Kunne ikke laste inn sammenslåtte leverandører.',
        error_save_settings: 'Kunne ikke lagre innstillingene.',
        error_dissolve_group: 'Kunne ikke oppløse gruppen.',
        error_assign_role: 'Kunne ikke tildele rollen.',
        error_create_group: 'Kunne ikke opprette organisasjonsgruppe. Vennligst prøv igjen.',
        error_request_report: 'Kunne ikke be om rapport.',
        error_group_name_required: 'Gruppenavn er påkrevd.',
        success_settings_saved: 'Innstillingene er lagret.',
        confirm_retire_vendor: 'Er du sikker på at du vil pensjonere leverandøren "[[TOK_1]]"?',
        confirm_retire_framework: 'Er du sikker på at du vil avvikle rammeverket "[[TOK_1]]"?',
        confirm_retire_template: 'Er du sikker på at du vil trekke tilbake skjemamalen "[[TOK_1]]"?',
        confirm_dissolve_group: 'Er du sikker på at du vil løse opp "[[TOK_1]]"? Denne handlingen kan ikke angres.',
        confirm_revoke_role: 'Er du sikker på at du vil tilbakekalle "[[TOK_2]]"-rollen fra "[[TOK_3]]"?',
        confirm_delete_report: 'Er du sikker på at du vil slette rapporten "[[TOK_1]]"?',
        dissolve_group: 'Løs opp gruppe',
        dissolve_warning: 'Dette vil oppløse organisasjonsgruppen permanent. Alle medlemsorganisasjoner vil bli fjernet.',
        count_groups: '[[TOK_1]] gruppe',
        count_groups_plural: '[[TOK_1]] grupper',
        count_users: '[[TOK_1]] bruker',
        count_users_plural: '[[TOK_1]] brukere med grupperoller',
        count_events: '[[TOK_1]] hendelse',
        count_events_plural: '[[TOK_1]] hendelser',
        count_reports: '[[TOK_1]] rapport',
        count_reports_plural: '[[TOK_1]] rapporterer',
        count_vendors: '[[TOK_1]] leverandør delt på tvers av gruppen',
        count_vendors_plural: '[[TOK_1]] leverandører delt på tvers av gruppen',
        count_frameworks: '[[TOK_1]] rammeverk delt på tvers av gruppen',
        count_frameworks_plural: '[[TOK_1]] rammeverk delt på tvers av gruppen',
        count_templates: '[[TOK_1]] mal delt på tvers av gruppen',
        count_templates_plural: '[[TOK_1]] maler delt på tvers av gruppen',
        count_shared_vendors: '[[TOK_1]] delte leverandører',
        count_local_vendors: '[[TOK_1]] lokale leverandører',
        merged_combined_view: 'Kombinert visning av [[TOK_2]] delte og [[TOK_3]] lokale leverandører',
        dashboard: {
            title: 'Gruppeoversikt',
            loading: 'Lastar dashborddata...',
            total_groups: 'Totalt Grupper',
            total_members: 'Totalt Medlemer',
            active_groups: 'Aktive Grupper',
            overall_compliance_score: 'Samlet samsvarspoeng',
            group_risk_level: 'Grupperisikonivå',
            sla_compliance: '[[TOK_0]] Samsvar',
            compliance_posture: 'Overholdelsesstilling',
            risk_heatmap: 'Risiko varmekart',
            sla_performance: '[[TOK_0]] Ytelse',
            recent_incidents: 'Nylige hendelser',
            recent_activity: 'Nylig aktivitet',
            refresh_label: 'Oppdater dashborddata',
            score_good: 'Bra',
            score_needs_attention: 'Trenger oppmerksomhet',
            score_critical: 'Kritisk',
            trend_up: 'Trender opp',
            trend_down: 'Trender nedover',
            trend_stable: 'Stabil',
            risk_low: 'Low',
            risk_medium: 'Middels',
            risk_high: 'Høy',
            risk_critical: 'Kritisk',
            risk_unknown: 'Ukjent',
            col_organization: 'Organisasjon',
            col_score: 'Score',
            col_trend: 'Trend',
            col_open_issues: '�&pne problemer',
            col_critical_issues: 'Kritiske problemer',
            col_health: 'Helse',
            col_vendor_risk: 'Leverandørrisiko',
            col_data_risk: 'Datarisiko',
            col_compliance_risk: 'Samsvarsrisiko',
            col_total_cases: 'Totalt antall saker',
            col_on_time: 'På tide',
            col_breached: 'Brudd',
            col_sla_percent: '[[TOK_0]] %',
            col_avg_days: 'Gj.sn. dager',
            sr_vendor_risk: 'Leverandørrisikoscore: [[TOK_1]]',
            sr_data_risk: 'Datarisikoscore: [[TOK_1]]',
            sr_compliance_risk: 'Overholdelsesrisikoscore: [[TOK_1]]',
            sr_sla_breaches: 'Advarsel: [[TOK_1]] [[TOK_2]] brudd',
            sr_severity: 'Alvorlighetsgrad: [[TOK_1]]',
        },
        detail: {
            title: 'Gruppedetaljar',
            members: 'Medlemer',
            settings: 'Innstillingar',
            audit: 'Revisjon',
            sr_loading: 'Laster organisasjonsgruppedetaljer',
            sr_loading_hierarchy: 'Laster hierarki',
            member_org: 'medlemsorganisasjon',
            root_org_label: 'rotorganisasjon',
        },
        users: {
            title: 'Gruppebrukarar',
            add_user: 'Add Brukar',
            no_users: 'Ingen brukarar i dette gruppe.',
            role_group_admin: 'Gruppeadministrator',
            role_group_reader: 'Gruppeleser',
            sr_loading: 'Laster gruppebrukere',
        },
        reports: {
            title: 'Grupperapportar',
            no_reports: 'Ingen rapportar funne.',
            generate_report: 'Generer ny rapport',
            report_type_compliance: 'Samsvarssammendrag',
            report_type_risk: 'Risikooversikt',
            report_type_sla: '[[TOK_0]] Ytelse',
            report_type_incident: 'Hendelsesrapport',
            report_type_executive: 'Executive Brief',
            report_type_board: 'Styrets rapport',
            status_queued: 'I kø',
            status_generating: 'Genererer',
            status_completed: 'Fullført',
            status_failed: 'Mislyktes',
            period_start: 'Periodestart',
            period_end: 'Periodeslutt',
            sr_loading: 'Laster grupperapporter',
        },
        shared_vendors: {
            title: 'Delte leverandørar',
            no_vendors: 'Ingen delte leverandørar funne.',
            merged_vendors: 'Samanslåtte Leverandørar',
            publish_form_label: 'Publiser delt leverandør',
            sr_loading: 'Laster inn delte leverandører',
            sr_loading_merged: 'Laster sammenslåtte leverandører',
            local_vendors: 'Lokale leverandører',
            source_shared: 'Delt fra gruppen',
            source_local: 'Lokal leverandør',
            category_technology: 'Teknologi',
            category_consulting: 'Rådgivning',
            category_outsourcing: 'Outsourcing',
            category_cloud: 'Sky',
            category_data_processing: 'Databehandling',
            category_other: 'Annet',
            risk_tier_low: 'Low',
            risk_tier_medium: 'Middels',
            risk_tier_high: 'Høy',
            risk_tier_critical: 'Kritisk',
            compliance_compliant: 'Samsvarlig',
            compliance_non_compliant: 'Ikke-kompatibel',
            compliance_pending: 'Venter',
            compliance_under_review: 'Under vurdering',
            status_active: 'Aktiv',
            status_retired: 'Pensjonist',
        },
        shared_frameworks: {
            title: 'Delte regelverk',
            no_frameworks: 'Ingen delte rammeverk funne.',
            publish_form_label: 'Publiser delt rammeverk',
            sr_loading: 'Laster inn delte rammer',
            status_active: 'Aktiv',
            status_retired: 'Pensjonist',
        },
        shared_forms: {
            title: 'Delte skjemamalar',
            no_forms: 'Ingen delte skjema malar funne.',
            publish_form_label: 'Publiser delt skjemamal',
            sr_loading: 'Laster inn delte skjemamaler',
            status_active: 'Aktiv',
            status_retired: 'Pensjonist',
        },
        audit: {
            title: 'Grupperevisjon',
            consolidated_title: 'Konsolidert Revisjon Spor',
            consolidated_subtitle: 'Tværorganisatoriske revisjonshendingr for denne gruppe',
            audit_log_title: 'Gruppe Revisjon Logg',
            event_type: 'Hending Type',
            actor: 'Aktør',
            timestamp: 'Tidsstempel',
            source_org: 'Kjelde Org.',
            org: 'Org',
            summary: 'Samandrag',
            details: 'Detaljar',
            no_events: 'Ingen revisjon hendingar funne.',
            all_events: 'Alle Hendingar',
            all_orgs: 'Alle Org.',
            organization: 'Organisasjon',
            from: 'Frå',
            to: 'To',
            search_events: 'Søk hendingar...',
            clear: 'Tøm',
            events_24h: 'Hendingar (24h)',
            events_7d: 'Hendingar (7d)',
            active_orgs: 'Aktive Org.',
            exporting: 'Eksporterer...',
            export_csv: 'Eksport CSV',
            export_json: 'Eksport JSON',
            back_to_group: 'Tilbake to Gruppe',
            back_to_detail: 'Tilbake til detaljar',
            sr_loading: 'Laster revisjonshendelser',
            sr_loading_summary: 'Laster revisjonssammendrag',
        },
        settings: {
            title: 'Gruppe Innstillingar',
            inheritance: 'Innstillingar Arv',
            inheritance_subtitle: 'Konfigurer hvilke innstillingskategorier som arver fra gruppen kontra bruk av lokale overstyringer',
            sla_settings: 'SLA Innstillingar',
            calendar_settings: 'Kalender Innstillingar',
            notification_settings: 'Varsling Innstillingar',
            intake_settings: 'Inntak Innstillingar',
            cmp_integration: 'CMP Integrasjon',
            overridden: 'Overstyrt',
            inheriting: 'Arva',
            hide_defaults: 'Gøym standardverdiar',
            show_group_defaults: 'Vis gruppestandarder',
            group_defaults: 'Gruppe Standardverdiar',
            inherit_from_group: 'Nedarv fra gruppe',
            use_local_override: 'Use Lokal Overstyr',
            local_override_json: 'Lokal Overstyr (JSON)',
            save_override: 'Lagre Overstyr',
            saving: 'Lagrar...',
            sr_loading: 'Laster inn innstillinger arv',
            sr_loading_settings: 'Laster inn gruppeinnstillinger',
            sr_enabled: 'Aktivert',
            sr_disabled: 'Deaktivert',
            sr_override_active: 'Lokal overstyring aktiv',
            sr_inherited: 'Arvet fra forelder',
            danger_zone: 'Faresone',
            sharing_options: 'Delingsalternativer',
            advanced_options: 'Avanserte alternativer',
        },
        status_active: 'Aktiv',
        status_dissolved: 'Oppløst',
        status_pending: 'Venter',
        status_suspended: 'Suspendert',
    },
    integrations: {
        nav: {
            webhooks: 'Webhookar',
            domains: 'Domene',
            export_schedules: 'Eksporttidsplanar',
            email_log: 'E-postlogg',
        },
    },
    platform: {
        nav: {
            users: 'Brukarar',
            roles: 'Roller',
            profile: 'Min profil',
        },
        security: {
            mfa: 'MFA-innstillingar',
            sso: 'SSO-konfigurasjon',
            api_keys: 'API-nøklar',
            service_accounts: 'Tenestekontoar',
            ip_allowlist: 'IP-godkjenningsliste',
            delegations: 'Delegeringar',
            break_glass: 'Naudtilgang',
            session_settings: '��ytinnstillingar',
            active_sessions: 'Aktive økter',
            access_reviews: 'Tilgangsvurderingar',
            my_reviews: 'Mine vurderingar',
            role_analytics: 'Rolleanalyse',
            attestation_schedules: 'Tidsplanar for attestering',
            sod_rules: 'SoD-reglar',
            sod_violations: 'SoD-brot',
        },
        module_config: {
            title: 'Modulkonfigurasjon',
            subtitle: 'Aktiver eller deaktiver funksjonsmodular for organisasjonen din. Deaktiverte modular vert gøymde frå navigasjonen.',
            enabled: 'Aktivert',
            disabled: 'Deaktivert',
            save: 'Lagra konfigurasjon',
            saving: 'Lagrar...',
            saved: 'Konfigurasjon lagra',
            nav_label: 'Modulkonfigurasjon',
            settings: 'Innstillingar',
            webhooks: 'Webhookar',
            domains: 'Domene',
            export_schedules: 'Eksporttidsplanar',
            email_log: 'E-postlogg',
        },
        files_nav: {
            section: 'Filer',
            configuration: 'Konfigurasjon',
            browser: 'Filleser',
            dashboard: 'Dashboard for filer',
        },
        immutable_audit_trails: {
            nav_group_label: 'Revisjon og bevis',
            nav_settings: 'Innstillinger',
            nav_status: 'Bevisstatus',
            nav_integrity_center: 'Integritetssenter',
            nav_usage: 'Bruk og kreditter',
            settings_title: 'Uforanderlige revisjonsspor � Innstillinger',
            settings_subtitle: 'Per-org-innstillinger for Immutable Audit Trails-tillegget.',
            settings_banner: 'Tillegget Immutable Audit Trails er ikke aktivert for organisasjonen din. Aktiver den her for å begynne å forankre bevis for Tier-A og Tier-B revisjonshendelser.',
            status_title: 'Uforanderlige revisjonsspor � bevisstatus',
            status_subtitle: 'Per-hendelse bevis relasjoner på tvers av moduler.',
            status_banner: 'Tillegget Immutable Audit Trails er ikke aktivert for organisasjonen din. Gå til Innstillinger for å aktivere den.',
            integrity_center_title: 'Uforanderlige revisjonsspor � Integritetssenter',
            integrity_center_subtitle: 'Bekreft bevis og eksporter integritetspakker.',
            integrity_center_banner: 'Tillegget Immutable Audit Trails er ikke aktivert for organisasjonen din. Gå til Innstillinger for å aktivere det før du kjører verifisering eller eksporterer integritetspakker.',
            usage_title: 'Uforanderlige revisjonsspor � bruk og kreditter',
            usage_subtitle: 'Kredittsaldo, pakkekjøp og brukshistorikk.',
            usage_banner: 'Aktiver uforanderlige revisjonsspor i innstillinger for å begynne å forbruke beviskreditter.',
            module_tips_placeholder: 'Tips og veiledning for denne overflaten er tilgjengelig i brukerstøtten.',
            column_label: 'Bevis',
            no_proof_aria: 'Ingen bevis registrert',
            proof_status_receipt_label: 'kvittering {id}',
            in_progress_hint: 'Pågår � oppdateres automatisk',
            status_pills: {
                pending: 'Venter',
                submitted: 'Sendt inn',
                anchored: 'Forankret',
                confirmed: 'Bekreftet',
                retrying: 'Prøver på nytt',
                paused_cap: 'Satt på pause (cap)',
                failed: 'Mislyktes',
                failed_auth: 'Godkjenning mislyktes',
            },
            status_tooltips: {
                pending: 'Venter � i kø for prøvetrykktjenesten. Vil flytte til Sendt om kort tid; ingen handling nødvendig.',
                submitted: 'Sendt inn � arrangementet ditt ble sendt til bevistjenesten. For batch-modus venter den på å bli forseglet og forankret på kjettingen. Oppdaterer automatisk; ingen handling nødvendig.',
                anchored: 'Forankret � batchen er skrevet på kjeden og venter på endelig bekreftelse. Oppdaterer automatisk; ingen handling nødvendig.',
                confirmed: 'Bekreftet � beviset er forankret på kjeden og kan verifiseres.',
                retrying: 'Prøver på nytt � en forbigående feil oppstod. Avstemmingen prøver automatisk på nytt; ingen handling nødvendig.',
                paused_cap: 'Midlertidig stoppet � den månedlige kredittgrensen er nådd. Løs inn flere kreditter eller vent til neste faktureringsmåned.',
                failed: 'Mislyktes � forankring lyktes ikke. Avstemmingen vil automatisk prøve på nytt; kontakt support hvis det vedvarer.',
                failed_auth: 'Godkjenning mislyktes � bevistjenesten avviste legitimasjonen vår. Sjekk siden Innstillinger for uforanderlige revisjonsspor.',
            },
            mode_pills: {
                direct: 'Direkte',
                batch: 'Batch',
            },
            drawer: {
                title: 'Bevisdetaljer',
                close: 'Lukk',
                section_proof: 'Bevis',
                section_batch: 'Batch-medlemskap',
                status: 'Status',
                proof_reference: 'Bevisreferanse',
                receipt_id: 'Kvitterings-ID',
                taxonomy_class: 'Taksonomi klasse',
                units_consumed: 'Forbrukte enheter',
                created_at: 'Opprettet',
                verification_ref: 'Kjedeverifiseringsreferanse',
                chain: 'Kjede',
                tx_hash: 'Tx-hash',
                block_ref: 'Blokkref',
                batch_reference: 'Batchreferanse',
                leaf_index: 'Bladindeks',
                local_event_hash: 'Lokal event-hash',
                show_inclusion: 'Vis inkluderingsbane',
                hide_inclusion: 'Skjul inkluderingsvei',
                privacy_note: 'Nyttelast er hash; ingen personlige data forlot ComplianceOne for denne hendelsen.',
                verify_now: 'Bekreft nå',
                verify_pending: 'Verifisering pågår ⬦',
                verify_verified: 'Verifisert - lokale + kjedesidesjekker bestått.',
                verify_issue_prefix: 'Bekreftelsesproblem: ',
                verify_failed: 'Bekreftelsesanrop mislyktes.',
                verify_result_prefix: 'Bekreftelsesdom: ',
                verify_pending_note: 'Bekreftelse venter: dette beviset venter fortsatt på forankring på kjedet. Prøv igjen etter at partiet er forseglet.',
                awaiting_anchor_note: 'Dette beviset er en del av en åpen batch. Verifisering blir tilgjengelig når batchen er forseglet og forankret på kjeden � vanligvis innenfor organisasjonens konfigurerte batchvindu. Statusmerket oppdateres automatisk.',
                terminal_error_note: 'Dette beviset klarte ikke å forankre. Bevisstatusavstemmingen vil prøve automatisk på nytt; manuell verifisering har ingenting å sjekke ennå.',
            },
            integrity_center: {
                section_run: 'Kjør verifisering',
                section_progress: 'Kjør fremgang',
                section_issues: 'Problemer',
                period_start: 'Periodestart',
                period_end: 'Periodeslutt',
                module_filter: 'Moduler (kommaseparert, valgfritt)',
                modules_placeholder: 'rights_requests, hendelser',
                run_button: 'Kjør verifisering',
                export_button: 'Eksporter integritetspakke',
                export_success: 'Integrity Pack eksportert.',
                export_failed: 'Eksporten mislyktes.',
                empty_disabled: 'Aktiver uforanderlige revisjonsspor i Innstillinger for å kjøre verifiseringspass.',
                error_period_required: 'Velg en start- og sluttdato.',
                error_start_run: 'Kunne ikke starte kjøringen.',
                processed: 'Behandlet: [[TOK_2]] av [[TOK_3]]',
                col_verdict: 'Dom',
                col_count: 'Telle',
                col_proof_link: 'Bevis link',
                col_module: 'Modul',
                col_event_type: 'Hendelsestype',
                col_expected: 'Forventet hasj',
                col_recomputed: 'Reberegnet hash',
                col_raised_at: 'Oppvokst kl',
                any_verdict: 'Enhver dom',
                no_issues: 'Ingen problemer funnet.',
            },
            settings_page: {
                load_error: 'Kunne ikke laste inn innstillingene.',
                save: 'Lagre',
                save_success: 'Innstillinger lagret.',
                save_error: 'Lagring mislyktes.',
                discard: 'Forkast endringer',
                read_only_banner: 'Du har skrivebeskyttet tilgang. Kontakt en plattformadministrator for å gjøre endringer.',
                section_status: 'Status og aktivering',
                enabled_label: 'Tillegg aktivert',
                enabled_help: 'Når den er aktivert, blir hver revisjonshendelse på nivå-A og nivå-B hashet og forankret.',
                section_scope: 'Omfang',
                scope_self: 'Bare seg selv',
                scope_self_and_children: 'Selv- og barneorganisasjoner',
                scope_children_only: 'Kun barn (foreldre beviser ikke sine egne hendelser)',
                section_mode: 'Standard prøvemodus',
                mode_direct: 'Direkte (ett anker per hendelse)',
                mode_batch: 'Batch (Merkle-root anker per gruppe)',
                mode_hybrid: 'Hybrid (per klasse registerstandard)',
                batch_window_label: 'Batch-vindu (minutter, 1�60)',
                section_taxonomy: 'Beskyttet hendelsestaksonomi',
                taxonomy_help: 'Overstyringer per hendelsesklasse. Nivå A �  direkte modus, Nivå B �  batchmodus, Av �  ikke korrektur.',
                taxonomy_search: 'Søk overstyrer',
                taxonomy_reset: 'Tilbakestill til standardinnstillinger',
                taxonomy_event_class: 'Eventklasse',
                taxonomy_override: 'Overstyr',
                taxonomy_actions: 'Handlinger',
                taxonomy_clear: 'Klart',
                taxonomy_no_overrides: 'Ingen overstyringer � bruker registerstandarder.',
                taxonomy_add_class: 'event_class.kode',
                taxonomy_add: 'Legg til overstyring',
                section_privacy: 'Personvernkontroller',
                privacy_log_actor_ip: 'Logg skuespiller IP',
                privacy_log_user_agent: 'Logg brukeragent',
                privacy_privileged_access_proofing: 'Bevis privilegert tilgang (nivå A)',
                privacy_note: 'Endringer gjelder kun prospektivt.',
                section_caps: 'Caps & limits',
                cap_label: 'Månedlig tak (enheter; blank = ubegrenset)',
                warn_label: 'Advarselsterskel (enheter; må være mindre enn taket)',
                auto_pause_label: 'Sett nye prøvetrykk automatisk på pause når grensen er nådd',
                section_export: 'Eksporter tilgang',
                export_help: 'Rolle-ID-er tillatt å eksportere integritetspakker. Kommaseparert; blank = bruk standardtillatelsen IMMUTABLE_AUDIT_TRAILS_EXPORT.',
                section_group: 'Gruppedeltakelse',
                group_view_intro: 'Du er konfigurert som gruppeforelder. Hver barneorganisasjon kontrollerer sin egen aktivering/deaktivering; deres avgjørelser ruller opp til faktureringen din i henhold til reglene for gruppefakturering.',
                group_view_rule_enabled: 'Et barn med enabled=false vises som "Ikke deltar". Du ser fraværet; barnet styrer bryteren.',
                group_view_rule_billing: 'Barneforbruket ruller opp til ditt månedlige tak. Se brukssiden for å overvåke kombinert brennhastighet.',
                group_view_rule_edit: 'Du kan ikke redigere et barns innstillinger fra denne siden. �&pne den underordnede organisasjonen direkte for å redigere.',
                group_view_open_groups: '�&pne organisasjonsgrupper',
                section_credentials: 'Legitimasjon',
                credential_id: 'Legitimasjons-ID',
                credential_rotated_at: 'Sist rotert',
                rotate_button: 'Roter legitimasjon',
                rotate_success: 'Legitimasjon rotert. Gammel legitimasjon gyldig i [[TOK_1]] minutter til.',
                rotate_failed: 'Påloggingsrotasjon mislyktes.',
                rotate_modal_title: 'Vil du rotere [[TOK_0]] legitimasjon?',
                rotate_modal_body: 'Rotasjon utsteder en ny legitimasjon. Den gamle legitimasjonen forblir akseptert av [[TOK_0]] i et 60-minutters frist slik at arbeidstakere kan fullføre sine nåværende jobber. Etter 60 minutter er den gamle legitimasjonen tilbakekalt.',
                rotate_modal_confirm: 'Roter nå',
                tier_a_off_modal_title: 'Vil du deaktivere korrektur for en hendelsesklasse?',
                tier_a_off_modal_body: 'Hvis du setter en hendelsesklasse til «Av», stopper prøvetrykket fra å forankre disse hendelsene. Arkitektur §6 forklarer den regulatoriske implikasjonen: Tier-A-hendelser er regulatorrelevante; Hvis du slår dem av, kan det bryte forsvarligheten av revisjonssporet.',
                tier_a_off_modal_confirm: 'Jeg forstår - bruk overstyring',
                error_warn_lt_cap: 'Advarselsterskelen må være mindre enn den månedlige grensen.',
                error_window_range: 'Batch-vinduet må være mellom 1 og 60 minutter.',
                error_run_in_progress: 'En verifiseringskjøring pågår; kan ikke deaktivere tillegget akkurat nå.',
            },
            status_page: {
                filter_status: 'Status',
                filter_mode: 'Bevismodus',
                filter_module: 'Modul',
                filter_source_collection: 'Kildesamling',
                filter_from_date: 'Fra',
                filter_to_date: 'Til',
                filter_search: 'Søk',
                any_status: 'Enhver status',
                any_mode: 'Enhver modus',
                col_module: 'Modul',
                col_event_type: 'Hendelsestype',
                col_proof_status: 'Status',
                col_proof_mode: 'Modus',
                col_created_at: 'Opprettet',
                col_units: 'Enheter',
                empty_disabled: 'Tillegget Immutable Audit Trails er ikke aktivert for organisasjonen din. Gå til Innstillinger for å aktivere den.',
                empty_enabled_no_rows: 'Ingen beviskoblinger samsvarer med gjeldende filtre.',
                export_csv: 'Eksporter [[TOK_0]]',
                export_xlsx: 'Eksporter [[TOK_0]]',
                export_success: 'Eksporten er fullført',
                export_failed: 'Eksporten mislyktes',
            },
            usage_page: {
                section_alerts: 'Varsel',
                alert_dismiss: 'Avvis',
                alert_dismiss_aria: 'Avvis varsel [[TOK_1]]',
                alert_dismissed: 'Varsel avvist',
                alert_dismiss_failed: 'Kunne ikke avvise varselet',
                section_balance: 'Kredittsaldo',
                balance_label: 'Tilgjengelige studiepoeng',
                balance_hint: 'Gjenstående enheter (1 enhet = 1 beskyttet hendelsesbevis).',
                section_current_month: 'Gjeldende måned',
                consumed_label: 'Forbrukt',
                granted_label: 'Gitt',
                refunded_label: 'Refundert',
                net_label: 'Netto',
                section_history: 'Brukshistorikk',
                history_kind: 'Snill',
                history_units: 'Enheter',
                history_balance_after: 'Balanse etter',
                history_notes: 'Notater',
                history_at: 'Når',
                cap_warning_banner: 'Du har passert advarselsterskelen for denne faktureringsmåneden. Vurder å løse inn ekstra kreditter.',
                cap_paused_banner: 'Månedlig tak nådd. Bevisinnleveringer settes på pause til neste måned eller til grensen økes.',
                section_redeem: 'Løs inn kredittpakke',
                redeem_purchase_id: 'Fakturanummer',
                redeem_package: 'Pakke',
                redeem_button: 'Løs inn',
                redeem_pending: 'Løser inn ⬦',
                redeem_success: 'Kreditter innløst',
                redeem_failed: 'Innløsning mislyktes',
                redeem_option_template: '[[TOK_4]] � [[TOK_5]] [[TOK_6]] � [[TOK_7]]',
                redeem_option_units: 'enheter',
                alert_dismissing: 'Avviser ⬦',
                alert_kind: {
                    cap_reached: 'Månedlig tak nådd',
                    low_balance: 'Lav balanse',
                    auth_failure: 'Autentiseringsfeil',
                    merkle_mismatch: 'Merkle misforhold',
                    batch_terminal_failure: 'Batch-terminalfeil',
                    direct_terminal_failure: 'Feil på direkte innsendingsterminal',
                },
                usage_kind: {
                    consume: 'Konsumere',
                    refund: 'Refusjon',
                    grant: 'Grant',
                    adjustment: 'Justering',
                    reservation: 'Reservasjon',
                },
                package_starter: 'Starter',
                package_growth: 'Vekst',
                package_enterprise: 'Enterprise',
                // Sprint 48.5.x — self-service "Buy More" billing (Flow A + B).
                buy_more: {
                    buy_button: 'Kjøp fleire kredittar',
                    purchase_title: 'Kjøp fleire kredittar',
                    purchase_subtitle: 'Vel ein pakke. Du blir send til sikker Stripe-utsjekk, og fakturaen din kjem på e-post.',
                    checkout_button: 'Hald fram til utsjekk',
                    checkout_pending: 'Opnar utsjekk…',
                    cancel_button: 'Avbryt',
                    purchase_error: 'Kunne ikkje starte utsjekk. Prøv igjen om litt.',
                    redeem_subtitle: 'Allereie betalt? Vel pakken du kjøpte, og skriv inn faktura-ID-en frå e-posten din for å leggje til kredittane.',
                    error_not_found: 'Fann ingen faktura med det nummeret. Kontroller fakturanummeret og prøv igjen.',
                    error_not_paid: 'Denne fakturaen er enno ikkje merkt som betalt.',
                    error_org_mismatch: 'Denne fakturaen vart ikkje utferda til organisasjonen din.',
                    error_package_mismatch: 'Denne fakturaen samsvarar ikkje med den valde pakken.',
                    error_billing_unavailable: 'Kunne ikkje nå faktureringstenesta. Prøv igjen om litt.',
                },
            },
        },
        files_config: {
            title: 'Filkonfigurasjon',
            subtitle: 'Konfigurer filopplastingsgrenser, oppbevaringspolicyer og per-eier-type overstyringer for plattformvedleggsoverflaten.',
            section_global: 'Globale standardinnstillinger',
            section_global_help: 'Disse grensene gjelder for hver fil som lastes opp av brukere i organisasjonen din, med mindre en per-eier-type overstyring nedenfor endrer dem.',
            section_overrides: 'Per-eier-type overstyringer',
            section_overrides_help: 'Overstyr de globale grensene for en bestemt eiertype. Verdier per eiertype vinner alltid over den globale innstillingen.',
            max_file_size_label: 'Maks filstørrelse',
            max_file_size_hint: 'Per individuell opplasting (MiB)',
            max_total_attachments_label: 'Maks totalt vedlegg',
            max_total_attachments_hint: 'På tvers av hele organisasjonen',
            max_total_size_label: 'Maks total lagringsplass',
            max_total_size_hint: 'På tvers av hele organisasjonen (MiB)',
            allowed_mime_types_label: 'Tillatte filtyper',
            allowed_mime_types_placeholder: 'Velg MIME-typer',
            retention_days_label: 'Oppbevaringsperiode (dager)',
            retention_days_hint: 'Hvor lenge filer må oppbevares før de er kvalifisert for sletting. La stå tomt for ingen oppbevaringspolicy.',
            legal_hold_label: 'Lovlig hold',
            legal_hold_hint: 'Når den er aktivert, krever hard sletting av en fil av denne eiertypen tillatelse for overstyring av juridisk hold og eksplisitt operatørvalg.',
            save: 'Lagre endringer',
            saving: 'Lagrer ⬦',
            reset: 'Tilbakestill',
            save_success: 'Innstillinger lagret',
            save_version_conflict: 'En annen operatør oppdaterte disse innstillingene mens du redigerte. Last inn på nytt for å se de siste verdiene.',
            empty_state_title: 'Bruker plattformstandarder',
            empty_state_body: 'Organisasjonen din kjører for øyeblikket på plattformens standard filpolicy. Rediger en hvilken som helst verdi nedenfor for å opprette en overstyring på organisasjonsnivå.',
            read_only_banner: 'Du har skrivebeskyttet tilgang til filkonfigurasjon. Kontakt en plattformadministrator for å gjøre endringer.',
            owner_type_default_badge: 'Standard',
            owner_type_overridden_badge: 'Overstyrt',
            owner_type_label: 'Eiertype',
            owner_type_collapse: 'Kollaps',
            owner_type_expand: 'Utvid',
            override_save: 'Lagre overstyring',
            override_remove: 'Fjern overstyring',
            mime_labels: {
                'application/pdf': '[[TOK_0]] dokument',
                'image/png': 'PNG-bilde',
                'image/jpeg': 'JPEG-bilde',
                'image/jpg': 'JPG-bilde',
                'application/msword': 'Word-dokument (legacy)',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'Word-dokument',
                'application/vnd.ms-excel': 'Excel-regneark (legacy)',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'Excel-regneark',
                'text/csv': '[[TOK_0]] fil',
                'text/plain': 'Ren tekst',
                'message/rfc822': 'E-postmelding',
            },
        },
        files_browser: {
            title: 'Filleser',
            subtitle: 'Søk, filtrer og administrer hvert vedlegg som lastes opp på tvers av organisasjonen.',
            filter_owner_type: 'Eiertype',
            filter_uploader: 'Lastet opp av',
            filter_from: 'Lastet opp etter',
            filter_to: 'Lastet opp før',
            filter_size_min: 'Min størrelse (MiB)',
            filter_size_max: 'Maks størrelse (MiB)',
            filter_mime: 'Filtype',
            filter_deleted_state: 'Slettetilstand',
            filter_deleted_any: 'Alle filer',
            filter_deleted_only: 'Kun slettet',
            filter_deleted_exclude: 'Ekskluder slettet',
            filter_orphaned: 'Bare foreldreløse',
            filter_search_placeholder: 'Søk filnavn ⬦',
            filter_apply: 'Bruk filtre',
            filter_clear: 'Tøm filtre',
            col_filename: 'Filnavn',
            col_owner_type: 'Eiertype',
            col_owner_entity: 'Eier',
            col_uploader: 'Lastet opp av',
            col_uploaded_at: 'Lastet opp',
            col_size: 'Størrelse',
            col_mime: 'Type',
            col_state: 'stat',
            col_actions: 'Handlinger',
            state_active: 'Aktiv',
            state_deleted: 'Slettet',
            state_orphaned: 'Foreldreløs',
            action_view_detail: 'Se detaljer',
            action_download: 'Last ned',
            action_ai_edits: '[[TOK_0]] Endringer',
            action_soft_delete: 'Myk sletting',
            action_restore: 'Gjenopprett',
            action_hard_delete: 'Vanskelig sletting',
            bulk_soft_delete: 'Myk sletting er valgt',
            bulk_export_csv: 'Eksporter [[TOK_0]]',
            bulk_select_all: 'Velg alle',
            reason_label: 'Grunn',
            reason_min_10_chars: '�&rsak kreves (minst 10 tegn)',
            reason_min_20_chars: '�&rsak kreves (minst 20 tegn)',
            legal_hold_override_label: 'Overstyr juridisk hold',
            legal_hold_override_warning: 'Denne filen er under juridisk oppbevaring. Hard-sletting vil bli registrert i revisjonssporet med ditt grunn- og overstyringsflagg.',
            empty_state_title: 'Ingen filer samsvarer med filtrene dine',
            empty_state_body: 'Juster filtrene for å se resultater, eller tøm dem for å se alle filene.',
            pagination_prev: 'Forrige',
            pagination_next: 'Neste',
            pagination_page: 'Side [[TOK_2]] av [[TOK_3]]',
            pagination_size_label: 'Per side',
            pagination_total: 'Totalt: [[TOK_1]]',
            toast_soft_deleted: 'Filen ble mykt slettet',
            toast_restored: 'Filen gjenopprettet',
            toast_hard_deleted: 'Fil slettet permanent',
            toast_bulk_deleted: '[[TOK_1]] fil(er) slettet',
            toast_error: 'Operasjonen mislyktes',
            confirm_soft_delete_title: 'Myk slette fil',
            confirm_restore_title: 'Gjenopprett fil',
            confirm_hard_delete_title: 'Slett filen permanent',
            confirm_bulk_soft_delete_title: 'Myk sletting av valgte filer',
            confirm_submit: 'Bekreft',
            confirm_cancel: 'Avbryt',
        },
        files_detail: {
            modal_title: 'Fildetaljer',
            close: 'Lukk',
            meta_filename: 'Filnavn',
            meta_size: 'Størrelse',
            meta_mime: 'Type',
            meta_owner_type: 'Eiertype',
            meta_owner_entity: 'Eier enhet',
            meta_uploader: 'Lastet opp av',
            meta_uploaded_at: 'Lastet opp',
            meta_storage_path: 'Lagringsvei',
            meta_deleted_state: 'Slettetilstand',
            audit_section_title: 'Revisjonsspor',
            audit_load_more: 'Last inn flere hendelser',
            audit_empty: 'Ingen revisjonshendelser registrert for denne filen.',
            audit_config_changed: 'Konfigurasjonen endret',
            audit_soft_deleted: 'Myk-slettet',
            audit_restored: 'Gjenopprettet',
            audit_hard_deleted: 'Slettes permanent',
            audit_downloaded: 'Lastet ned',
            audit_quota_breached: 'Kvotebrudd forsøkt',
            action_download: 'Last ned',
            action_soft_delete: 'Myk sletting',
            action_restore: 'Gjenopprett',
            action_hard_delete: 'Vanskelig sletting',
            effective_settings_title: 'Effektiv politikk',
            effective_max_file_size: 'Maks filstørrelse',
            effective_retention_days: 'Oppbevaring',
            effective_legal_hold: 'Lovlig hold',
            effective_legal_hold_yes: 'Aktiv',
            effective_legal_hold_no: 'Ingen',
        },
        files_dashboard: {
            title: 'Dashboard for filer',
            subtitle: 'Lagringsbruk, vekst og foreldreløse filer på tvers av organisasjonen.',
            kpi_total_files: 'Totalt antall filer',
            kpi_total_size: 'Total lagring',
            kpi_near_quota: 'Kvotebruk',
            kpi_orphaned: 'Foreldreløse filer',
            chart_by_owner_type: 'Filer etter eiertype',
            chart_growth_30d: '30-dagers vekst',
            toggle_count: 'Etter telling',
            toggle_size: 'Etter størrelse',
            orphaned_panel_title: 'Foreldreløse filer (topp 20)',
            orphaned_view_all: 'Se alle foreldreløse filer',
            orphaned_empty: 'Ingen foreldreløse filer funnet.',
            growth_empty: 'Ingen opplastingsaktivitet de siste 30 dagene.',
            retention_n_days: '[[TOK_1]] dag(er)',
            retention_none: 'Ingen politikk',
        },
    },
    category_labels: {
        'user-guide': 'Brukerveiledning',
        'admin-guide': 'Administrasjonsveiledning',
        'getting-started': 'Komme i gang',
        faq: 'FAQ',
    },
    tag_labels: {
        faq: 'FAQ',
        dsar: 'DSAR',
        dsr: 'DSR',
        cmp: 'CMP',
        hmac: 'HMAC',
        sso: 'SSO',
        mfa: 'MFA',
        rbac: 'RBAC',
        api: 'API',
        'api-keys': '[[TOK_0]] Taster',
        webhook: 'Webhook',
        webhooks: 'Webhooks',
        admin: 'Admin',
        aesirx: 'AesirX',
        purposes: 'Formål',
        preferences: 'Preferanser',
        onboarding: 'Onboarding',
        'first-steps': 'Første trinn',
        login: 'Logg inn',
        navigation: 'Navigasjon',
        users: 'Brukere',
        user: 'Bruker',
        roles: 'Roller',
        role: 'Rolle',
        'access-control': 'Tilgangskontroll',
        'access-management': 'Tilgangsadministrasjon',
        permissions: 'Tillatelser',
        permission: 'Tillatelse',
        consent: 'Samtykke',
        'consent-management': 'Samtykkebehandling',
        privacy: 'Personvern',
        pdpl: 'PDPL',
        gdpr: 'GDPR',
        iso27001: 'ISO 27001',
        audit: 'Revisjon',
        auditing: 'Revisjon',
        breach: 'Brudd',
        incident: 'Hendelse',
        incidents: 'Hendelser',
        notification: 'Varsling',
        notifications: 'Varsler',
        reporting: 'Rapportering',
        risk: 'Risiko',
        vendor: 'Leverandør',
        vendors: 'Leverandører',
        'vendor-risk': 'Leverandørrisiko',
        assessment: 'Vurdering',
        assessments: 'Vurderinger',
        dpia: 'DPIA',
        'cross-border': 'Grenseoverskridende',
        transfer: 'Overføring',
        transfers: 'Overføringer',
        deletion: 'Sletting',
        retention: 'Oppbevaring',
        'data-mapping': 'Datakartlegging',
        discovery: 'Oppdagelse',
        classification: 'Klassifisering',
        workflow: 'Arbeidsflyt',
        workflows: 'Arbeidsflyter',
        template: 'Mal',
        templates: 'Maler',
        catalog: 'Katalog',
        monitoring: 'Overvåking',
        tasks: 'Oppgaver',
        task: 'Oppgave',
        'task-management': 'Oppgavestyring',
        organizations: 'Organisasjoner',
        org: 'Organisasjon',
        governance: 'Styring',
        compliance: 'Overholdelse',
        forms: 'Skjemaer',
        form: 'Skjema',
        connectors: 'Koblinger',
        connector: 'Kobling',
        integration: 'Integrasjon',
        integrations: 'Integrasjoner',
        security: 'Sikkerhet',
        encryption: 'Kryptering',
        backup: 'Sikkerhetskopiering',
        recovery: 'Gjenoppretting',
        maintenance: 'Vedlikehold',
        settings: 'Innstillinger',
        configuration: 'Konfigurasjon',
        sla: 'SLA',
        escalation: 'Eskalering',
        remediation: 'Utbedring',
        evidence: 'Bevis',
        'case-management': 'Saksbehandling',
        profile: 'Profil',
        delegation: 'Delegering',
        'service-accounts': 'Tjenestekontoer',
        license: 'Lisens',
        'license-management': 'Lisensbehandling',
        plan: 'Planlegg',
        plans: 'Planer',
        dashboard: 'Dashbord',
        'web-consent': 'Websamtykke',
        'partner-marketplace': 'Partner Marketplace',
        partner: 'Partner',
        partners: 'Partnere',
        deliverables: 'Leveranser',
        'service-tiers': 'Tjenestenivåer',
        'support-tickets': 'Støttebilletter',
        'audit-trail': 'Revisjonssti',
        'first-time-setup': 'Førstegangsoppsett',
        setup: 'Oppsett',
        quickstart: 'Rask start',
        tour: 'Omvisning',
        tours: 'Turer',
        'sample-data': 'Eksempeldata',
        'data-subject': 'Datasubjekt',
        'data-subjects': 'Datasubjekter',
        pseudonymous: 'Pseudonym',
        identified: 'Identifisert',
        'help-center': 'Hjelpesenter',
        article: 'Artikkel',
        articles: 'Artikler',
        search: 'Søk',
        'platform-settings': 'Plattforminnstillinger',
        'platform-config': 'Plattformkonfigurasjon',
        'module-config': 'Modulkonfigurasjon',
        'module-configuration': 'Modulkonfigurasjon',
        'rights-requests': 'Rettighetsforespørsler',
        'access-accountability': 'Få tilgang til ansvarlighet',
        'data-discovery': 'Dataoppdagelse',
        'incident-ops': 'Hendelsesoperasjoner',
        'deletion-orchestration': 'Sletting Orkestrering',
        'compliance-forms': 'Overholdelsesskjemaer',
        'program-governance': 'Programstyring',
        localization: 'Lokalisering',
        'privacy-scanner': 'Personvernskanner',
        'consent-properties': 'Samtykkeegenskaper',
        acceptances: 'Aksepter',
        access: 'Tilgang',
        'access-review': 'Tilgang gjennomgang',
        'access-reviews': 'Få tilgang til anmeldelser',
        accountability: 'Ansvarlighet',
        acknowledgment: 'Anerkjennelse',
        'action-plans': 'Handlingsplaner',
        activation: 'Aktivering',
        activations: 'Aktiveringer',
        'active-response': 'Aktiv respons',
        activity: 'Aktivitet',
        adequacy: 'Tilstrekkelighet',
        'admin-guide': 'Administrasjonsveiledning',
        aggregation: 'Aggregasjon',
        agreements: 'Avtaler',
        ai: 'AI',
        alerts: 'Varsler',
        analytics: 'Analytics',
        anchoring: 'Forankring',
        approval: 'Godkjenning',
        approvals: 'Godkjenninger',
        apps: 'Apper',
        assets: 'Eiendeler',
        assignments: 'Oppdrag',
        attestation: 'Attestasjon',
        'audit-log': 'Revisjonslogg',
        'audit-pack': 'Revisjonspakke',
        authentication: 'Autentisering',
        authority: 'Autoritet',
        'auto-play': 'Automatisk avspilling',
        automated: 'Automatisert',
        automation: 'Automatisering',
        baseline: 'Grunnlinje',
        batches: 'Batcher',
        bidirectional: 'Toveis',
        bilingual: 'Tospråklig',
        bindings: 'Bindinger',
        blockchain: 'Blockchain',
        board: 'Styre',
        brand: 'Merke',
        brds: 'BRD-er',
        'break-glass': 'Break-Glass',
        builder: 'Byggmester',
        bulk: 'Bulk',
        'bulk-sync': 'Bulk Sync',
        bundles: 'Bunter',
        calendar: 'Kalender',
        campaigns: 'Kampanjer',
        cases: 'Saker',
        categories: 'Kategorier',
        category: 'Kategori',
        certification: 'Sertifisering',
        chain: 'Kjede',
        change: 'Endre',
        'change-awareness': 'Endre bevissthet',
        'change-log': 'Endre logg',
        'change-management': 'Endringsledelse',
        'change-requests': 'Endringsforespørsler',
        'cmp-validation': '[[TOK_0]] Validering',
        collection: 'Samling',
        comparison: 'Sammenligning',
        completeness: 'Fullstendighet',
        completion: 'Fullføring',
        'compliance-posture': 'Overholdelsesstilling',
        'compliance-proof': 'Samsvarsbevis',
        'compliance-reviews': 'Overholdelsesanmeldelser',
        config: 'Konfig',
        confirmation: 'Bekreftelse',
        conflicts: 'Konflikter',
        consolidation: 'Konsolidering',
        continuous: 'Kontinuerlig',
        contracts: 'Kontrakter',
        controls: 'Kontroller',
        cookies: 'Informasjonskapsler',
        cooperation: 'Samarbeid',
        coordination: 'Koordinering',
        'corporate-governance': 'Corporate Governance',
        'corrective-actions': 'Korrigerende handlinger',
        coverage: 'Dekning',
        'credential-vault': 'Credential Vault',
        credentials: 'Legitimasjon',
        cycles: 'Sykluser',
        dashboards: 'Dashboards',
        'data-assets': 'Dataressurser',
        'data-flows': 'Dataflyter',
        'data-sensitivity': 'Datasensitivitet',
        'data-steward': 'Dataansvarlig',
        deadlines: 'Tidsfrister',
        'decree-356': 'Dekret 356',
        dedup: 'Dedup',
        definitions: 'Definisjoner',
        deliverable: 'Leveres',
        departments: 'Avdelinger',
        'dependency-order': 'Avhengighetsrekkefølge',
        deployment: 'Utplassering',
        detection: 'Deteksjon',
        diff: 'Forskj',
        'digital-properties': 'Digitale egenskaper',
        dimensions: 'Dimensjoner',
        disable: 'Deaktiver',
        'disaster-recovery': 'Katastrofegjenoppretting',
        disclosure: 'Avsløring',
        documentation: 'Dokumentasjon',
        documents: 'Dokumenter',
        domains: 'Domener',
        dossier: 'Dossier',
        dpa: 'DPA',
        drift: 'Drift',
        'drift-detection': 'Driftsdeteksjon',
        'due-diligence': 'Due Diligence',
        email: 'Email',
        emergency: 'Nødsituasjon',
        enable: 'Aktiver',
        'enterprise-map': 'Bedriftskart',
        erasure: 'Sletting',
        evaluation: 'Evaluering',
        'event-bus': 'Eventbuss',
        exceptions: 'Unntak',
        execution: 'Utførelse',
        executive: 'Executive',
        exercises: '��velser',
        export: 'Eksporter',
        exports: 'Eksport',
        filing: 'Arkivering',
        filter: 'Filter',
        filtering: 'Filtrering',
        findings: 'Funn',
        flows: 'Strømmer',
        'follow-up': 'Oppfølging',
        forensic: 'Rettsmedisinsk',
        forensics: 'Forensics',
        'form-filler': 'Skjemautfyller',
        framework: 'Rammeverk',
        frameworks: 'Rammer',
        'gap-analysis': 'Gap analyse',
        'gap-report': 'Gap-rapport',
        gaps: 'Gap',
        gates: 'Porter',
        'getting-started': 'Komme i gang',
        'golden-templates': 'Gylne maler',
        grc: 'GRC',
        'group-management': 'Konsernledelse',
        groups: 'Grupper',
        'guided-tours': 'Guidede turer',
        guides: 'Guider',
        handling: 'Håndtering',
        'hands-on': 'Hands-On',
        health: 'Helse',
        help: 'Hjelp',
        hierarchy: 'Hierarki',
        history: 'Historie',
        i18n: 'i18n',
        iam: 'IAM',
        'identity-provider': 'Identitetsleverandør',
        implementation: 'Implementering',
        import: 'Importer',
        improvement: 'Forbedring',
        'incident-response': 'Hendelsesrespons',
        inconsistencies: 'Inkonsekvenser',
        instances: 'Forekomster',
        intake: 'Inntak',
        'intake-key': 'Inntaksnøkkel',
        interactive: 'Interaktiv',
        international: 'Internasjonal',
        inventory: 'Inventar',
        investigation: 'Etterforskning',
        investigations: 'Undersøkelser',
        'ip-allowlist': 'IP-tillatelsesliste',
        issues: 'Problemer',
        justification: 'Begrunnelse',
        justifications: 'Begrunnelser',
        kanban: 'Kanban',
        keyboard: 'Tastatur',
        keys: 'Nøkler',
        'knowledge-base': 'Kunnskapsbase',
        koncernstyring: 'Corporate Governance',
        kpi: 'KPI',
        labeling: 'Merking',
        language: 'Språk',
        'language-packs': 'Språkpakker',
        languages: 'Språk',
        lawfulness: 'Lovlighet',
        layout: 'Oppsett',
        'legal-basis': 'Juridisk grunnlag',
        'lessons-learned': 'Lærdom',
        levels: 'Nivåer',
        library: 'Bibliotek',
        lifecycle: 'Livssyklus',
        lineage: 'Avstamning',
        links: 'Linker',
        listings: 'Oppføringer',
        live: 'Live',
        locale: 'Språk',
        log: 'Log',
        logging: 'Logging',
        'managed-service': 'Administrert tjeneste',
        mapping: 'Kartlegging',
        mappings: 'Kartlegginger',
        'market-packs': 'Markedspakker',
        marketplace: 'Markedsplass',
        maturity: 'Modenhet',
        metrics: 'Beregninger',
        models: 'Modeller',
        module: 'Modul',
        modules: 'Moduler',
        mps: 'MPS',
        'multi-factor': 'Multifaktor',
        'multi-market': 'Multimarked',
        'multi-org': 'Multi-Org',
        'multi-property': 'Multi-Property',
        'my-tasks': 'Mine oppgaver',
        obligations: 'Forpliktelser',
        offboarding: 'Offboarding',
        oidc: 'OIDC',
        orchestration: 'Orkestrering',
        'org-groups': 'Organisasjonsgrupper',
        organization: 'Organisasjon',
        overdue: 'Forfalt',
        overview: 'Oversikt',
        'owner-review': 'Eieranmeldelse',
        package: 'Pakke',
        packages: 'Pakker',
        packs: 'Pakker',
        pagination: 'Paginering',
        'parent-child': 'Foreldre-barn',
        patterns: 'Mønstre',
        performance: 'Ytelse',
        periodic: 'Periodisk',
        periods: 'Perioder',
        personal: 'Personlig',
        'personal-data': 'Personopplysninger',
        personas: 'Personas',
        planning: 'Planlegging',
        platform: 'Plattform',
        playbooks: 'Playbooks',
        poc: 'PoC',
        'point-in-time': 'Tidspunkt',
        policies: 'Retningslinjer',
        portfolio: 'Portefølje',
        'post-incident': 'Post-hendelse',
        'power-user': 'Power User',
        practice: '��v',
        pricing: 'Prissetting',
        'privacy-impact': 'Innvirkning på personvernet',
        procedures: 'Prosedyrer',
        processes: 'Prosesser',
        processing: 'Behandling',
        'processing-activities': 'Behandlingsaktiviteter',
        procurement: 'Innkjøp',
        productivity: 'Produktivitet',
        profiles: 'Profiler',
        programs: 'Programmer',
        progress: 'Fremgang',
        proof: 'Bevis',
        propagation: 'Formering',
        properties: 'Egenskaper',
        'pub-sub': 'Pub-Sub',
        'public-form': 'Offentlig form',
        quality: 'Kvalitet',
        questionnaires: 'Spørreskjemaer',
        'quick-links': 'Hurtigkoblinger',
        'quick-start': 'Rask start',
        'quick-starts': 'Rask start',
        raci: 'RACI',
        readiness: 'Beredskap',
        'real-time': 'Sanntid',
        reassessments: 'Revurderinger',
        reconciliation: 'Forsoning',
        record: 'Ta opp',
        records: 'Rekorder',
        recurring: 'Tilbakevendende',
        register: 'Registrer deg',
        registry: 'Register',
        regulations: 'Forskrifter',
        regulator: 'Regulator',
        regulatory: 'Regulatorisk',
        'regulatory-frameworks': 'Regulatoriske rammer',
        remap: 'Omkart',
        reminders: 'Påminnelser',
        reports: 'Rapporter',
        requests: 'Forespørsler',
        requirements: 'Krav',
        response: 'Svar',
        'response-plans': 'Responsplaner',
        'response-team': 'Responsteam',
        'response-templates': 'Svarmaler',
        'response-time': 'Responstid',
        responses: 'Svar',
        responsibility: 'Ansvar',
        results: 'Resultater',
        review: 'Gjennomgå',
        reviews: 'Anmeldelser',
        'right-to-delete': 'Rett til å slette',
        rights: 'Rettigheter',
        'risk-tiers': 'Risikonivåer',
        rollouts: 'Utrullinger',
        rollup: 'Rollup',
        ropa: 'ROPA',
        routing: 'Ruting',
        rpo: 'RPO',
        rto: 'RTO',
        rules: 'Regler',
        runs: 'Løper',
        saml: 'SAML',
        scan: 'Skann',
        scanning: 'Skanning',
        scc: 'SCC',
        schedule: 'Tidsplan',
        scheduled: 'Planlagt',
        schedules: 'Tidsplaner',
        scheduling: 'Planlegging',
        scores: 'Scorer',
        scoring: 'Scoring',
        scripts: 'Skript',
        'security-reviews': 'Sikkerhetsvurderinger',
        'sensitive-data': 'Sensitive data',
        sensitivity: 'Følsomhet',
        'separation-of-duties': 'Separasjon av oppgaver',
        service: 'Service',
        sessions: '��kter',
        'setup-wizard': 'Oppsettveiviser',
        severity: 'Alvorlighetsgrad',
        'shared-governance': 'Delt styring',
        'shared-settings': 'Delte innstillinger',
        shortcuts: 'Snarveier',
        sidebar: 'Sidefelt',
        signals: 'Signaler',
        'single-sign-on': 'Enkel pålogging',
        snapshots: '��yeblikksbilder',
        sod: 'SoD',
        sorting: 'Sortering',
        sources: 'Kilder',
        staging: 'Iscenesettelse',
        standards: 'Standarder',
        status: 'Status',
        structure: 'Struktur',
        'sub-processor': 'Underprosessor',
        'sub-processors': 'Underprosessorer',
        submissions: 'Innleveringer',
        subprocessors: 'Underbehandlere',
        subscription: 'Abonnement',
        suggestions: 'Forslag',
        summaries: 'Sammendrag',
        supplements: 'Kosttilskudd',
        support: 'Støtte',
        sync: 'Synkroniser',
        system: 'System',
        systems: 'Systemer',
        tables: 'Tabeller',
        tagging: 'Tagging',
        'tamper-proof': 'Inngrepssikker',
        taxonomies: 'Taksonomier',
        taxonomy: 'Taksonomi',
        tenants: 'Leietakere',
        termination: 'Oppsigelse',
        'third-party': 'Tredjepart',
        'ticket-sync': 'Billettsynkronisering',
        tickets: 'Billetter',
        tiers: 'Nivåer',
        tokens: 'Tokens',
        totp: 'TOTP',
        traceability: 'Sporbarhet',
        tracking: 'Sporing',
        trail: 'Sti',
        training: 'Trening',
        translation: 'Oversettelse',
        translations: 'Oversettelser',
        transparency: '�&penhet',
        trends: 'Trender',
        unified: 'Samlet',
        updates: 'Oppdateringer',
        validation: 'Validering',
        vault: 'Hvelv',
        'vendor-requests': 'Leverandørforespørsler',
        verification: 'Verifikasjon',
        versioning: 'Versjonskontroll',
        versions: 'Versjoner',
        vietnam: 'Vietnam',
        violations: 'Krenkelser',
        visualization: 'Visualisering',
        waivers: 'Fraskrivelser',
        'web-records': 'Nettposter',
        website: 'Nettsted',
        websites: 'Nettsteder',
        weights: 'Vekter',
        'white-label': 'White-Label',
        withdrawal: 'Uttak',
    },
    module_labels: {
        rights_requests: 'Innsynskrav',
        data_mapping: 'Datakartlegging',
        governance: 'Leverandørstyring',
        consent: 'Samtykkestyring',
        consent_properties: 'Samtykkeeigeskapar',
        assessments: 'DPIA og vurderingar',
        classification: 'Dataklassifisering',
        monitoring: 'Overvakingsprogram',
        program: 'Overvakingsprogram',
        incidents: 'Hendingsrespons',
        connectors: 'Konnektorar',
        vendor_risk: 'Leverandørrisiko',
        deletion_orchestration: 'Slettorkestrering',
        discovery: 'Dataoppdaging',
        incident_ops: 'Hendingsdrift',
        program_governance: 'Programstyring',
        access_accountability: 'Tilgangsansvar',
        localization: 'Lokalisering',
        partner_workspace: 'Partnararbeidsområde',
        privacy_scanner: 'Personvernskannar',
        onboarding: 'Onboarding',
        compliance_forms: 'Samsvarssjema',
        audit_trail: 'Revisjonslogg',
        data_subjects: 'Registrerte',
        organizations: 'Organisasjonar',
        task_management: 'Oppgavestyring',
        deletion_orch: 'Slettorkestrering',
        forms: 'Samsvarsskjema',
        partner_marketplace: 'Partnarmarknadsplass',
        dashboard: 'Oversikt',
        platform_settings: 'Plattforminnstillingar',
        help_center: 'Hjelpesenter',
    },
    module_descriptions: {
        rights_requests: 'Administrer førespurnader om registrerte sine rettar, inkludert innsyn, sletting og dataportabilitet. Spor førespurnaden sin livssyklus, tildel sakshandsamarar og overhald regulatoriske fristar.',
        data_mapping: 'Kartlegg datastraumar på tvers av organisasjonen. Spor behandlingsaktivitetar, datakategoriar, føremål, oppbevaringspolitikkar og systemintegrasjonar.',
        governance: 'Administrer leverandøretterleving og styring. Spor leverandørvurderingar, kontraktar, SLA-yting og regulatoriske plikter.',
        consent: 'Administrer innhenting, lagring og tilbaketrekking av samtykke. Spor samtykkeregistreringar, føremål og integrasjon med samtykkeplattformer.',
        consent_properties: 'Konfigurer samtykkeeigeskapar, grupper og gylne malar. Definer attbrukbare samtykkekonfigurasjonar for konsistent utrulling.',
        assessments: 'Gjennomfør personvernkonsekvensvurderingar (DPIA) og risikovurderingar for personvern. Evaluer behandlingsaktivitetar for etterlevingsrisiko.',
        classification: 'Klassifiser dataressursar etter sensitivitetsnivå. Bruk taksonomi-etikettar, spor livssykluspostar og identifiser klassifiseringsgap.',
        monitoring: 'Set opp overvakingsprogram for å spore etterlevingsmetrikkar, nøkkelrisikoindikatorar og kontrolleffektivitet over tid.',
        incidents: 'Rapporter og handter personvernhendingar og datalekkasjar. Spor etterforsking, varsling og utbetringsarbeidsflyt.',
        connectors: 'Konfigurer datakjeldekoplingar og integrasjonar. Kopla til eksterne system for automatisert dataoppdaging og overvaking.',
        vendor_risk: 'Vurder og overvak tredjepartsleverandørrisiko. Scor leverandørar, spor risikoreduksjon og administrer leverandørrisikokonfigurasjonar.',
        deletion_orchestration: 'Orkestrer datasletting på tvers av system. Spor slettingsførespurnader, verifiser provisskjeder og sikre fullstendig fjerning av data.',
        discovery: 'Oppdag personopplysningar på tvers av tilkopla system. Skann datakjelder for å byggje ein omfattande dataoversikt.',
        incident_ops: 'Operasjonell hendingshandtering med spelbok, eskaleringsarbeidsflyt og SLA-sporing for hendingsløysing.',
        program_governance: 'Spor den overordna modna til personvernprogrammet, etterlevingsscorer, provisgap og leiarrapportering på tvers av organisasjonen.',
        access_accountability: 'Undersøk og revider brukartilgangsmønster. Spor tilgangskonfigurasjonar, overvak mistenkeleg aktivitet og handhev ansvar.',
        localization: 'Installer og administrer marknadslokalisringspakkar. Legg til regulatoriske rammeverk, språkpakkar og regionspesifikt etterlevingsinnhald.',
        partner_workspace: 'Samarbeid med eksterne partnarar. Del etterlevingsdata, spor partnarplikter og administrer partnarrelasjonar.',
        privacy_scanner: 'Skann nettstader for personvernetterlevingsproblem. Overvak informasjonskapselbruk, sporingsskript og nærvær av personvernpolicy i sanntid.',
        onboarding: 'Rettlei nye organisasjonar gjennom plattformoppsett. Stegvis innføringsrettleiar for innleiande konfigurasjon og dataimport.',
        compliance_forms: 'Opprett og administrer samsvarssjema frå ein malkatalog. Fyll ut regulatoriske sjema, spor innsendingar og generer rapportar.',
        audit_trail: 'Sjå ein komplett revisjonslogg over alle systemhandlingar. Spor kven som gjorde kva, når og kvar på tvers av alle modular.',
        organizations: 'Administrer organisasjonar og fleirleigarinnstillingar. Konfigurer organisasjonsprofiler, hierarki og relasjonar på tvers av organisasjonar.',
    },
    privacy_scanner: {
        anomaly_explain: {
            explain_label: 'Forklar uregelmessigheter',
            explaining: 'Forklarer ⬦',
            results_heading: 'Anomaliforklaringer ([[TOK_1]])',
            tokens_label: '�0� [[TOK_1]] tokens',
            items_label: '[[TOK_1]] elementer',
            remediation_label: 'Utbedringstrinn',
            items_detail_label: 'Berørte varer',
            accept_label: 'Godta forklaring',
            reject_label: 'Avvis forklaring',
            error_generic: 'Kunne ikke forklare uregelmessighetene. Prøv igjen eller kontroller at skanningen er fullført.',
        },
        cookie_insight: {
            insight_label: 'Informasjonskapsel og sporing [[TOK_0]] innsikt',
            producing: 'Produserer innsikt ⬦',
            results_heading: 'Informasjonskapsler og sporingsinnsikt ([[TOK_1]])',
            tokens_label: '�0� [[TOK_1]] tokens',
            items_label: '[[TOK_1]] elementer',
            classification_label: 'Klassifisering',
            severity_label: 'Alvorlighetsgrad',
            banner_copy_label: 'Foreslått bannerkopi',
            retention_label: 'Oppbevaringsråd',
            citations_label: 'Sitater',
            kind_cookie: 'Cookie',
            kind_tracker: 'Tracker',
            class_necessary: 'Nødvendig',
            class_analytics: 'Analytics',
            class_marketing: 'Markedsføring',
            class_social: 'Sosialt',
            accept_label: 'Godta innsikt',
            reject_label: 'Avvis innsikt',
            no_items: 'Ingen informasjonskapsler eller sporere ble oppdaget i denne skanningen.',
            error_generic: 'Kunne ikke produsere informasjonskapselinnsikten. Prøv igjen eller kontroller at skanningen er fullført.',
        },
        monitoring: {
            title: 'Personvernovervaking',
            new_scan: 'Ny Skanning',
            scan_url: 'URL til Skanning',
            scan_frequency: 'Skanning Frekvens',
            last_scan: 'Siste Skanning',
            score: 'Personvernscore',
            issues: 'Problem funne',
            history: 'Skanning Historikk',
            settings: 'Overvakingsinnstillingar',
        },
        real_time: {
            title: 'Sanntidsskannar',
            scan_now: 'Skanning Now',
            scanning: 'Skannar...',
            results: 'Skanning Resultat',
            no_results: 'Ingen skanning resultat enno.',
            cookies: 'Informasjonskapslar',
            trackers: 'Sporarar',
            consent_banners: 'Samtykkebannarar',
            third_party: 'Tredjepartsskript',
            archive: 'Resultatarkiv',
            settings: 'Skannarinnstillingar',
        },
        dashboard: {
            page_title: 'Dashboard for personvernovervåking',
            privacy_monitoring: 'Personvernovervåking',
            plan_label: '[[TOK_1]] plan',
            expires_label: 'utløper [[TOK_1]]',
            settings: 'Innstillinger',
            refresh: 'Oppdater',
            refreshing_dashboard: 'Forfriskende overvåkingsdashbord',
            refresh_aria: 'Oppdater overvåkingsdashbordet',
            not_configured_title: 'Personvernovervåking ikke konfigurert',
            not_configured_desc: 'Koble til [[TOK_0]]-tjenesten for personvernovervåking for å begynne å spore nettstedets samsvar.',
            configure_monitoring: 'Konfigurer overvåking',
            license_expired_title: 'Lisens utløpt',
            license_expired_desc: 'Din [[TOK_0]] lisens for personvernovervåking har utløpt. Vennligst forny den for å unngå tjenesteavbrudd.',
            compliance_score: 'Samsvarspoeng',
            cookies_detected: 'Informasjonskapsler oppdaget',
            trackers_label: 'Trackers',
            open_issues: '�&pne problemer',
            score_good: 'Bra',
            score_needs_improvement: 'Trenger forbedring',
            score_critical: 'Kritisk',
            action_required: 'Handling kreves',
            cookies_sr: 'informasjonskapsler oppdaget',
            trackers_sr: 'sporere funnet',
            open_issues_sr: 'åpne problemer',
            action_required_sr: 'handling nødvendig',
            metric_label: 'Metrisk',
            value_label: 'Verdi',
            status_label: 'Status',
            aria_metrics: 'Beregninger for personvernovervåking',
            plan_limit_warning: 'Skanner [[TOK_4]]: [[TOK_2]]/[[TOK_3]] � du har nådd plangrensen.',
            manage_domains: 'Administrer domener eller oppgrader planen din.',
            monitored_domains: 'Overvåkede domener',
            domain_added: 'Domene [[TOK_1]] lagt til',
            domain_removed: 'Domenet [[TOK_1]] fjernet',
            failed_add_domain: 'Kunne ikke legge til domene',
            failed_remove_domain: 'Kunne ikke fjerne domenet',
            failed_load: 'Kunne ikke laste inn overvåkingsdashbordet',
            new_domain_aria: 'Nytt domene [[TOK_0]]',
            add_domain: 'Legg til domene',
            adding_domain: 'Legger til ⬦',
            no_domains: 'Ingen overvåkede domener er konfigurert ennå.',
            aria_domains_table: 'Overvåkede domener',
            col_domain: 'Domene',
            col_compliance_score: 'Samsvarspoeng',
            col_status: 'Status',
            col_cookies: 'Informasjonskapsler',
            col_trackers: 'Trackers',
            col_issues: 'Problemer',
            col_last_scan: 'Siste skanning',
            col_action: 'Handling',
            compliance_status_sr: 'overholdelsesstatus',
            showing_chart: 'Viser kartvisning',
            showing_table: 'Viser datatabellvisning',
            loading_sr: 'Laster overvåkingsdashbord',
            col_framework_tags: 'Rammemerker',
            col_last_monitored: 'Sist overvåket',
            framework_tags_sr: 'gjeldende regelverk',
            last_monitored_sr: 'tidsstempel for kontinuerlig overvåking',
            audit_trail_heading: 'Revisjonssti',
            audit_trail_info: 'Hver overvåkingsskanning er tidsstemplet og logget. Endringer i samsvar på domenenivå produserer en uforanderlig revisjonspost som kan eksporteres for regulatorisk gjennomgang.',
            cybersecurity_law_info_heading: 'Deteksjon av lov om nettsikkerhet',
            cybersecurity_law_info: 'Overvåkede domener sjekkes automatisk mot lovkravene for nettsikkerhet (f.eks. Vietnam Cybersecurity Law, [[TOK_0]]-direktivet). Rammebrikker angir hvilket regelverk som gjelder. Problemstillinger er kategorisert etter regelverk for målrettet utbedring.',
        },
        scan: {
            page_title: 'Sanntidsskanning',
            title: 'Personvernskanner i sanntid',
            settings: 'Innstillinger',
            results_archive: 'Resultatarkiv',
            launch_scan: 'Start Scan',
            target_url: 'Mål [[TOK_0]]',
            protocol_aria: 'Protokoll',
            url_required: '[[TOK_0]] kreves',
            url_whitespace: 'Fjern mellomrom fra [[TOK_0]]',
            url_invalid: 'Skriv inn et gyldig domene (f.eks. example.com)',
            add_subpages: 'Legg til undersider',
            add_subpages_aria: 'Legg til undersider, [[TOK_1]] lagt til',
            start_scan: 'Start skanning',
            launching: 'Starter ⬦',
            scan_launched: 'Skanningen ble startet',
            scan_failed: 'Kunne ikke starte skanning',
            scan_progress: 'Skannefremdrift',
            scanning_in_progress: 'Skanning pågår ⬦',
            scan_id: 'Skann ID',
            status_label: 'Status',
            status_unknown: 'unknown',
            progress_label: 'Fremgang',
            pages_label: 'Sider',
            refresh_status: 'Oppdater status',
            new_scan: 'Ny skanning',
            scan_completed: 'Skanning fullført, resultater tilgjengelig',
            failed_check_status: 'Kunne ikke sjekke skannestatus',
            scan_results: 'Skanneresultater',
            main_page: 'Hovedside',
            page_n: 'Side [[TOK_1]]',
            result_pages_nav: 'Resultatsider',
            page_url: 'Side [[TOK_0]]',
            risk_score: 'Risikopoeng',
            risk_score_sr: 'risikoscore',
            cookies_label: 'Informasjonskapsler',
            cookies_sr: 'informasjonskapsler oppdaget',
            scripts_label: 'Skript',
            scripts_sr: 'skript oppdaget',
            issues_label: 'Problemer',
            issues_sr: 'problemer funnet',
            issues_found: 'Problemer funnet',
            aria_issues_table: 'Problemer funnet under skanning',
            col_severity: 'Alvorlighetsgrad',
            col_category: 'Kategori',
            col_title: 'Tittel',
            col_remediation: 'Utbedring',
            severity_sr: 'severity',
            scan_result_metrics: 'Skann resultatberegninger',
            view_full_detail: 'Se full detalj',
            col_consent_category: 'Samtykkekategori',
            consent_category_sr: 'samtykkekategorisering',
            compliance_evidence_heading: 'Samsvarsbevis',
            compliance_evidence_info: 'Skannefunn knyttes automatisk til samsvarssaker. Hver sak kan spores til en samtykkekategori (essensiell, funksjonell, analytisk, markedsføring) og produserer revisjonsklare bevis for regulatorisk gjennomgang.',
            rule_config_heading: 'Regelkonfigurasjon',
            rule_config_info: 'Skanneregler kan konfigureres i henhold til regelverket. Kontroll av informasjonskapsler, skriptdeteksjon og leverandøranalyse kan aktiveres eller deaktiveres via Innstillinger. Egendefinerte regler kan defineres for å matche organisasjonens overholdelseskrav.',
            case_linkage_heading: 'Samsvarssakskobling',
            case_linkage_info: 'Problemer funnet under sanntidsskanninger kan knyttes til samsvarssaker for sporing og utbedring. Naviger til siden med detaljer om skanneresultat for å se sammenhenger.',
            subpages_modal_title: 'Legg til undersider',
            subpages_modal_desc: 'Legg til opptil 5 underside-URLer for å skanne sammen med hoveddomenet.',
            subpage_n: 'Underside [[TOK_1]]',
        },
        result_detail: {
            page_title: 'Skanneresultatdetaljer',
            title: 'Skanneresultat',
            back_to_archive: 'Tilbake til Arkiv',
            failed_load: 'Kunne ikke laste inn skanneresultatet',
            loading_sr: 'Laster inn skanneresultat ⬦',
            scan_id: 'Skann ID',
            target_url: 'Mål [[TOK_0]]',
            status_label: 'Status',
            status_sr: 'status',
            started: 'Startet',
            completed: 'Fullført',
            pages_scanned: 'Sider skannet',
            https_label: 'HTTPS',
            highest_risk_score: 'Høyeste risikopoeng',
            most_cookies: 'De fleste informasjonskapsler',
            most_vendors: 'De fleste tredjepartsleverandører',
            most_issues: 'De fleste problemer',
            across_pages: 'på tvers av sidene',
            highest_values_aria: 'Høyeste verdier på alle sider',
            scanned_pages_nav: 'Skannede sider',
            main_page: 'Hovedside',
            page_n: 'Side [[TOK_1]]',
            page_url: 'Side [[TOK_0]]',
            risk_score: 'Risikopoeng',
            overall_risk_sr: 'samlet risikoscore',
            cookies_label: 'Informasjonskapsler',
            cookies_sr: 'informasjonskapsler oppdaget',
            vendors_label: 'Tredjepartsleverandører',
            vendors_sr: 'tredjepartsleverandører oppdaget',
            issues_label: 'Problemer',
            issues_sr: 'problemer funnet',
            risk_breakdown_aria: 'Fordeling av risikopoeng',
            issues_found: 'Problemer funnet',
            aria_issues_table: 'Problemer funnet under skanning',
            col_severity: 'Alvorlighetsgrad',
            col_category: 'Kategori',
            col_title: 'Tittel',
            col_remediation: 'Utbedring',
            severity_sr: 'severity',
            cookies_heading: 'Informasjonskapsler ([[TOK_1]])',
            aria_cookies_table: 'Informasjonskapsler oppdaget',
            col_name: 'Navn',
            col_domain: 'Domene',
            col_path: 'Sti',
            col_secure: 'Sikker',
            col_httponly: 'Bare Http',
            col_samesite: 'SammeSite',
            vendors_heading: 'Tredjepartsleverandører ([[TOK_1]])',
            aria_vendors_table: 'Tredjepartsleverandører oppdaget',
            col_hostname: 'Vertsnavn',
            scripts_heading: 'Skript / Beacons ([[TOK_1]])',
            aria_scripts_table: 'Skript og beacons oppdaget',
            col_url: 'URL',
            col_type: 'Type',
            links_heading: 'Linker',
            first_party: 'Førstepart',
            third_party: 'Tredjepart',
            col_risk_category: 'Risikokategori',
            col_regulatory_framework: 'Regulatorisk rammeverk',
            col_actionable_detail: 'Handlingsbar detalj',
            risk_category_sr: 'regulatorisk risikokategori',
            risk_category_mapping_heading: 'Risikokategorikartlegging',
            risk_category_mapping_info: 'Hvert skanningsfunn er kartlagt til en regulatorisk risikokategori (datainnsamling, grenseoverskridende overføring, samtykkehåndtering, dataoppbevaring, sikkerhetskontroller). Denne kartleggingen muliggjør målrettet utbedring prioritert etter regulatorisk påvirkning.',
            compliance_case_heading: 'Compliance Case Association',
            compliance_case_info: 'Skanneresultater er knyttet til samsvarssaker for ende-til-ende-sporing. Problemer kan eskaleres direkte fra skanneresultater til arbeidsflyten for samsvarssaker.',
        },
        results_archive: {
            page_title: 'Skanningsresultatarkiv',
            title: 'Skanningsresultatarkiv',
            back_to_scanner: 'Tilbake til skanner',
            failed_load: 'Kunne ikke laste inn skanneresultater',
            results_loaded: 'Skanneresultater lastet, [[TOK_1]] poster',
            total_label: 'Totalt: [[TOK_1]]',
            aria_table: 'Skann resultatarkiv',
            col_scan_date: 'Skanningsdato',
            col_target_url: 'Mål [[TOK_0]]',
            col_duration: 'Varighet',
            col_issues_found: 'Problemer funnet',
            col_risk_score: 'Risikopoeng',
            col_status: 'Status',
            col_actions: 'Handlinger',
            scan_status_sr: 'skannestatus',
            view_result: 'Visning',
            no_results: 'Fant ingen skanneresultater.',
            loading_sr: 'Laster inn skanneresultater',
            pagination_aria: 'Paginering av skanneresultater',
            col_risk_category: 'Risikokategori',
            risk_category_sr: 'regulatorisk risikokategori',
            archive_retention_heading: 'Arkivoppbevaring',
            archive_retention_info: 'Skanneresultater beholdes i varigheten som er spesifisert i organisasjonens retningslinjer for dataoppbevaring. Arkiverte resultater inkluderer full skanningskontekst (rammemerker, risikokategorier, utbedringsveiledning) og kan eksporteres som [[TOK_0]] for regulatorisk bevis.',
            export_context_info: 'Eksporterte [[TOK_0]] filer inkluderer regulatorisk kontekst: risikokategori, gjeldende rammeverk og handlingsbare utbedringsdetaljer for hvert funn.',
        },
        scanner_settings: {
            page_title: 'Skannerinnstillinger',
            title: 'Skannerinnstillinger',
            back_to_scanner: 'Tilbake til skanner',
            failed_load: 'Kunne ikke laste inn skannerkonfigurasjonen',
            endpoint_url: 'Endepunkt [[TOK_0]]',
            save_success: 'Skannerkonfigurasjonen er lagret.',
            save_failed: 'Kunne ikke lagre skannerkonfigurasjonen',
            test_connection: 'Test tilkobling',
            testing: 'Tester...',
            save_configuration: 'Lagre konfigurasjon',
            saving: 'Lagrer...',
            loading_sr: 'Laster skannerinnstillinger',
        },
        monitoring_settings: {
            page_title: 'Innstillinger for personvernovervåking',
            title: 'Overvåkingsinnstillinger',
            back_to_dashboard: 'Tilbake til Dashboard',
            failed_load: 'Kunne ikke laste inn overvåkingskonfigurasjonen',
            credentials_heading: '[[TOK_0]] Legitimasjon',
            connected_as: 'Tilkoblet som [[TOK_1]]',
            credentials_desc: 'Skriv inn din [[TOK_0]] kontolegitimasjon for å koble til personvernovervåking. Finn medlems-ID-en din på profilsiden for [[TOK_1]]-kontoen din.',
            client_id: 'Klient-ID',
            client_secret: 'Klienthemmelighet',
            username: '[[TOK_0]] Brukernavn (e-post)',
            password: '[[TOK_0]] Passord',
            placeholder_keep: '(la stå tomt for å beholde eksisterende)',
            credential_form_aria: '[[TOK_0]] legitimasjonsskjema',
            test_connection: 'Test tilkobling',
            testing: 'Tester ⬦',
            test_aria: 'Test [[TOK_0]]-tilkoblingen',
            testing_aria: 'Tester tilkobling',
            save_configuration: 'Lagre konfigurasjon',
            saving: 'Lagrer ⬦',
            save_aria: 'Lagre legitimasjon',
            saving_aria: 'Lagrer legitimasjon',
            credentials_saved: '[[TOK_0]] påloggingsinformasjon er lagret.',
            credentials_saving: '[[TOK_0]] påloggingsinformasjon lagret. Laster inn konfigurasjonen på nytt ⬦',
            credentials_save_failed: 'Kunne ikke lagre legitimasjonen',
            client_id_required: 'Klient-ID og brukernavn kreves.',
            all_fields_required: 'Alle legitimasjonsfelter er obligatoriske.',
            email_heading: 'E-postvarsler',
            receive_emails: 'Motta e-poster med skannerapporter',
            email_toggle_aria: 'Slå av/på skannerapport-e-poster',
            only_on_change: 'Bare e-post når risikostatus endres',
            only_on_change_aria: 'Slå av/på e-post kun ved endring av risikostatus',
            emails_enabled: 'Skannrapport e-poster aktivert',
            emails_disabled: 'Skannrapport-e-poster er deaktivert',
            only_change_on: 'Sender kun e-post om risikoendringer',
            only_change_off: 'Sender e-post ved hver skanning',
            email_failed: 'Kunne ikke oppdatere e-postinnstillingen',
            email_settings_aria: 'Innstillinger for e-postvarsling',
            loading_sr: 'Laster overvåkingsinnstillinger',
        },
        entity_types: {
            user: 'Bruker',
            case: 'Sak',
            incident: 'Hendelse',
            assessment: 'Vurdering',
            vendor: 'Leverandør',
            consent: 'Samtykke',
            policy: 'Politikk',
            data_map: 'Datakart',
        },
        actions: {
            create: 'Opprett',
            update: 'Oppdater',
            delete: 'Slett',
            view: 'Visning',
            export: 'Eksporter',
            status_change: 'Statusendring',
        },
    },
    forms: {
        dashboard: {
            title: 'Skjemaoversikt',
            total_templates: 'Totalt Malar',
            installed: 'Installerte',
            available: 'Tilgjengelege',
            by_market: 'Etter Marknad',
            back_dashboard: 'Tilbake til dashbord',
            browse_templates: 'Bla gjennom malar',
            catalog_coverage: 'Katalog Dekning',
            quick_start: 'Rask Start',
            recent_instances: 'Nyleg Instansar',
            total_instances: 'Totalt Instansar',
            fetch_failed: 'Kunne ikkje hente dashboarddata.',
            no_instances: 'Ingen instansar funne.',
            form_metrics: 'Oversikt over skjemametrikkar',
            templates_total: 'malar totalt',
            instances_total: 'forekomstar totalt',
            installed_of_available: '[[TOK_2]] av [[TOK_3]] installert',
            templates_in_category: 'malar i {category}',
        },
        templates: {
            title: 'Skjemamalar',
            new: 'Ny Mal',
            edit: 'Rediger Mal',
            name: 'Mal Namn',
            form_type: 'Skjema Type',
            market: 'Marknad',
            language: 'Språk',
            schema: 'Skjemaskjema',
            preview: 'Førehandsvising',
            duplicate: 'Dupliser mal',
            grid_view: 'Rutenett Vis',
            list_view: 'Liste Vis',
            fetch_failed: 'Kunne ikkje hente malar.',
            filter_templates: 'Filtrer malar',
            version_history: 'Versjonshistorikk',
            no_version_history: 'Ingen versjonshistorikk � dette er den opphavlege versjonen.',
            form_id: 'Skjema-ID',
            source_instrument: 'Kjeldeinstrument',
            issuer: 'Utstedar',
            all_frameworks: 'Alle rammeverk',
            view_mode: 'Visningsmodus',
        },
        catalog: {
            title: 'Skjemakatalog',
            install: 'Installer',
            uninstall: 'Avinstaller',
            install_all: 'Installer alle',
            installed_tab: 'Installerte',
            catalog_tab: 'Katalog',
            search_placeholder: 'Søk malar...',
            no_templates: 'Ingen malar funne.',
            template_count: '{count} malar',
            all_markets: 'Alle Marknader',
            sections: 'Seksjonar',
            all_categories: 'Alle Kategoriar',
            category: 'Kategori',
            category_install_failed: 'Kunne ikkje installere kategorimalar.',
            category_install_success: 'Kategori malar installerte.',
            fetch_failed: 'Kunne ikkje hente malar.',
            fetch_installed_failed: 'Kunne ikkje hente installerte malar.',
            fields: 'Felt',
            install_failed: 'Kunne ikkje installere mal.',
            install_success: 'Mal installeret.',
            installing: 'Installerer...',
            removing: 'Fjernar...',
            uninstall_confirm: 'Er du sikker på at du vil avinstallere denne malen?',
            uninstall_failed: 'Kunne ikkje avinstallere mal.',
            uninstall_success: 'Mal afinstalleret.',
            installation_summary: 'Installasjonsoversikt',
            filter_catalog: 'Filtrer katalog',
            all_frameworks: 'Alle rammeverk',
            templates_installed_count: '[[TOK_1]] mal(er) installert',
            all_already_installed: 'Alle malar i denne kategorien er allereie installerte',
            form_id: 'Skjema-ID',
            issuer: 'Utstedar',
            catalog_tabs: 'Skjemakatalogfaner',
        },
        filler: {
            back_templates: 'Tilbake til malar',
            no_sections: 'Ingen seksjonar funne.',
            draft_created: 'Utkast oppretta.',
            draft_saved: 'Utkast lagra.',
            fetch_template_failed: 'Kunne ikkje hente mal.',
            save_draft: 'Lagre Utkast',
            save_draft_failed: 'Kunne ikkje lagre utkast.',
            saving: 'Lagrar...',
            select_option: 'Vel an alternativ',
            submit: 'Send inn',
            submit_failed: 'Kunne ikkje sende inn.',
            submitting: 'Sender inn...',
            title: 'Skjemavegleiar',
            form_id_label: 'Skjema-ID',
            schema_label: 'Skjema',
            framework_label: 'Rammeverk',
            issuer_label: 'Utstedar',
            source_label: 'Kjelde',
            market_label: 'Marknad',
            section_of: 'Seksjon {current} av {total}',
            form_navigation: 'Skjemanavigasjon',
            form_progress: 'Skjemaframdrift: Seksjon {current} av {total}',
            removed_item: 'Element {index} fjerna frå {field}',
            added_item: 'Nytt element lagt til i {field}',
            go_to_previous: 'Gå til førre seksjon, seksjon {current} av {total}',
            go_to_next: 'Gå til neste seksjon, seksjon {current} av {total}',
            risk_matrix_placeholder: '1�5',
        },
        filing: {
            title: 'Innleveringsstatus',
            advance: 'Fremje innleveringsstatus...',
            not_started: 'Ikkje starta',
            drafting: 'Utkast',
            internal_review: 'Intern gjennomgang',
            approved_for_submission: 'Godkjend for innsending',
            submitted_to_authority: 'Sendt til myndigheit',
            supplement_requested: 'Tillegg etterspurt',
            supplement_in_progress: 'Tillegg pågår',
            resubmitted: 'Sendt på nytt',
            accepted: 'Godteke',
            rejected: 'Avvist',
            closed: 'Lukka',
        },
        instances: {
            approved_by: 'Godkjent av',
            form_answers: 'Skjema Svar',
            no_answers: 'Ingen svar funne.',
            view_outputs: 'Vis Utdata',
            approve: 'Godkjenn',
            approve_failed: 'Kunne ikkje godkjenne.',
            approving: 'Godkjenner...',
            detail_title: 'Instans Detalj',
            fetch_failed: 'Kunne ikkje hente instansar.',
            generate_failed: 'Kunne ikkje generere utdata.',
            generate_output: 'Generer Utdata',
            generating: 'Genererer...',
            submitted_at: 'Innsendt At',
            instance_metadata: 'Skjemaforekomstmetadata',
            filing_status_steps: 'Arkiveringsstatussteg',
            current_status: 'noverande status',
            filing_status_update_failed: 'Kunne ikkje oppdatere innleveringsstatus',
        },
        outputs: {
            back_instance: 'Tilbake to Instans',
            no_outputs_msg: 'Ingen utdata har blitt generert enno.',
            no_outputs_title: 'Ingen utdata',
            output_name: 'Utdata Namn',
            download: 'Last ned',
            download_failed: 'Kunne ikkje laste ned.',
            fetch_failed: 'Kunne ikkje hente utdata.',
            format: 'Format',
            generated_at: 'Generert Ved',
            generated_by: 'Generert Etter',
            size: 'Storleik',
            title: 'Skjema Utdata',
            print: 'Skriv ut',
            print_outputs: 'Skriv ut skjemaresultat',
            printing: 'Skriv ut skjemaresultat',
            pdf_preview: 'PDF-førehandsvising',
            downloading: 'Lastar ned {name}',
            preview_in_new_window: 'Førehandsvis {name} ({format}) i nytt vindauge',
        },
        cybersec_domains: {
            scope: 'Omfang og bruksområde',
            risk: 'Risikovurdering og kontrollkartlegging',
            policy: 'Organisatoriske tryggingspolitikkar',
            localization: 'Datalokalisering og lokal tilstadeverelse',
            vendor: 'Tredjepartar og leverandørkjede',
            authority: 'Handtering av styresmaktførespurnader',
            incident: 'Hendingshandtering og bevissiking',
            training: 'Opplæring og beredskap',
        },
        market_finalization_domains: {
            data_law: 'Datalov � Styring og Operasjonelle Kontrollar',
            pdpl_2025: 'PDPL 2025 � Personvernstyring og Rettar til Registrerte',
            decree_356: 'Dekret 356/2025 � Leverandør- og Grenseoverskridande Kontrollar',
            telecom: 'Ekomlov � Konfidensialitet og Styresmaktførespurnader',
        },
        nav: {
            filing_case_links: 'Sakslenkjer',
            section_routing: 'Seksjonsruting',
            submission_packages: 'Innsendingspakkar',
        },
        filing_case_links: {
            title: 'Sakslenkjer',
            link_form: 'Knyt skjema til innleveringssak',
            filing_case_type: 'Innleveringssaktype',
            form_instance: 'Skjemainstans',
            select_form_instance: 'Vel ein skjemainstans...',
            select_filing_case: 'Vel ei innleveringssak...',
            no_links_found: 'Ingen sakslenkjer funne.',
            linked: 'Kopla',
            filing_case_id: 'Arkiveringssak-ID',
            link_created: 'Arkiveringssak-kopling oppretta',
            link_deleted: 'Sakslenkje sletta',
            aria_delete_link: 'Slett lenkje {name}',
            case_type_dpia_dossier: 'DPIA-dossier',
            case_type_cross_border_filing: 'Grensekryssande innlevering',
            case_type_breach_notification: 'Brotsvarsel',
            no_instances_guidance: 'Ingen skjemainstansar enno. Opprett ein frå Skjemamalar.',
            no_filings_guidance: 'Ingen innleveringssaker enno. Opprett ein frå Vurderingar.',
        },
        section_routing: {
            title: 'Seksjonsruting',
            assign_section: 'Tildel seksjon',
            department: 'Avdeling',
            select_department: 'Vel ei avdeling...',
            assignee: 'Tildelt til',
            select_assignee: 'Vel ein tildelt...',
            section: 'Seksjon',
            select_section: 'Vel ein seksjon...',
            select_form_instance: 'Vel ein skjemainstans...',
            no_assignments_found: 'Ingen seksjonstildelingar funne.',
            select_instance_prompt: 'Vel ein skjemainstans for å sjå seksjonstildelingar.',
            complete_section: 'Fullfør seksjon',
            status_pending: 'Ventar',
            status_in_progress: 'Pågår',
            status_completed: 'Fullført',
            status_reviewed: 'Gjennomgått',
            form_instance_id: 'Skjemaforekomst-ID',
            assignment_created: 'Seksjonstildeling oppretta',
            assignment_deleted: 'Seksjonstildeling sletta',
            status_updated: 'Seksjonsstatus oppdatert',
            aria_delete_assignment: 'Slett tildeling {name}',
            deadline: 'Frist',
            deadline_help: 'Valfritt. Tildelingar etter denne datoen vert viste som forfalne.',
            overdue: 'Forfallen',
            days_remaining: 'dagar att',
            approval_requested: 'Sendt til gjennomgang',
            form_approved: 'Skjema godkjent',
            form_rejected: 'Skjema avvist',
            no_departments_guidance: 'Ingen avdelingar konfigurerte. Set opp i Organisasjonsinnstillingar.',
            no_sections_guidance: 'Ingen seksjonar definerte i malen. Sørg for at skjemamalen har seksjonar.',
            select_instance_first: 'Vel ei skjemainstans først for å laste tilgjengelege seksjonar.',
        },
        submission_packages: {
            title: 'Innsendingspakkar',
            assemble_package: 'Set saman innsendingspakke',
            dossier: 'Dossier',
            select_dossier: 'Vel eit dossier...',
            package_label: 'Pakkeetikett',
            cover_letter: 'Følgjebrev',
            checklist: 'Sjekkliste',
            evidence_index: 'Bevisindeks',
            completeness: 'Fullstende',
            incomplete_warning: 'Kan ikkje setje saman: skjemaet har ufullstendige seksjonar.',
            no_packages_found: 'Ingen innsendingspakkar funne.',
            version: 'Versjon',
            package_assembled: 'Innsendingspakke sett saman',
            package_deleted: 'Innsendingspakke sletta',
            aria_delete_package: 'Slett pakke {name}',
            status_draft: 'Utkast',
            status_complete: 'Fullstendig',
            status_submitted: 'Innsend',
            status_accepted: 'Godkjend',
            status_rejected: 'Avvist',
            package_updated: 'Innsendingspakke oppdatert',
            document_generated: 'Dokument generert',
            documents: 'Dokument',
            generate: 'Generer',
            preview: 'Førehandsvisning',
            download: 'Last ned',
            download_all: 'Last ned alle',
            no_dossiers_guidance: 'Ingen dossier enno. Opprett ein frå Vurderingar.',
            package_plan_help: 'Inkluder i pakkeplanen (automatisk dokumentgenerering tilgjengeleg):',
            cover_letter_help: 'Offisielt følgjebrev adressert til mottakande myndigheit',
            checklist_help: 'Samsvarsjekkliste som stadfester at alle innleveringskrav er oppfylte',
            evidence_index_help: 'Indeks over støttedokumentasjon referert i innleveringa',
            completeness_skipped: 'Fullstendigheitskontroll hoppa over � ingen skjemainstans knytt til dette dossieret.',
            completeness_unavailable: 'Fullstendigheitskontroll ikkje tilgjengeleg � held fram med pakkemontasje.',
            duplicate_package_error: 'Det finst allereie ei innleveringspakke for dette dossieret.',
            doc_cover_letter: 'Følgjebrev',
            doc_checklist: 'Sjekkliste',
            doc_evidence_index: 'Bevisindeks',
            export_csv: 'Eksporter CSV',
            export_success: 'Lenkjer til arkiveringssaker eksportert vellukka',
            no_assignments_guidance: 'Ingen seksjonstildelingar enno. Tildel seksjonar til avdelingar og teammedlemmer for å starte ruting.',
        },
        template_picker: {
            title: 'Vel ein mal',
            hint: 'Vel ein regulatorisk skjemamal eller byrj med eit tomt skjema.',
            market_filter: 'Filtrer etter marked',
            framework_filter: 'Filtrer etter rammeverk',
            all_markets: 'Alle marknadar',
            all_frameworks: 'Alle rammeverk',
            search_placeholder: 'Søk etter malar...',
            blank_form: 'Tomt / generisk skjema',
            blank_form_desc: 'Opprett utan mal � fyll ut felt manuelt.',
            no_templates: 'Ingen malar funne for dette filteret.',
            select: 'Vel',
            link_error: 'Malkoplinga lukkast ikkje � du kan kopla ein mal seinare frå Redigeringsvisinga.',
            internal_badge: 'Intern mal',
            legacy_badge: 'Utdatert',
            draft_badge: 'Utkast',
            upcoming_badge: 'Kommande',
            hidden_badge: 'Skjult',
            show_hidden_toggle: 'Vis skjulte / utdaterte malar',
            show_hidden_toggle_hint: 'Administratorvising: inkluderer malar merkte som internal_only, hidden, legacy eller draft.',
        },
        cover_letter_modal: {
            title: 'Følgjebrev: førehandsvising og redigering',
            iframe_title: 'Førehandsvising av følgjebrev',
            stage_label: 'Steg',
            stage_initial: 'Første innsending',
            stage_supplement: 'Supplerande svar',
            stage_resubmission: 'Ny innsending',
            subject_label: 'Emne',
            body_label: 'Hovudavsnitt',
            notes_label: 'Ekstra notat',
            refresh_preview: 'Oppdater førehandsvising',
            confirm: 'Stadfest og lagre',
            regenerate: 'Regenerer',
            snapshot_saved: 'Følgjebrev lagra',
        },
        related_panel: {
            title: 'Relaterte forskriftsskjema',
            open_form: 'Fyll ut skjema',
            no_forms: 'Ingen relaterte skjema funne.',
            hint_vn: 'VN-spesifikke forskriftsskjema tilgjengelege � vel eit skjema for å opne samsvarrettleiaren.',
            internal_badge: 'Intern',
            official_badge: 'Offisiell',
            loading: 'Lastar relaterte skjema...',
            error: 'Klarte ikkje å laste relaterte skjema.',
            form_id: 'Skjema-ID',
            form_name: 'Skjemanavn',
            framework: 'Rammeverk',
        },
        view_form: 'Vis skjema',
        edit_form: 'Rediger skjema',
        save_draft: 'Lagre utkast',
        module_settings: 'Modulinnstillingar',
        validation_errors: 'Ver venleg og rett valideringsfeil',
        custom_name_help: 'Valfritt � standard er malnamnet om tomt',
        select_placeholder: 'Vel...',
        previous_section: 'Førre',
        next_section: 'Neste',
        loading: 'Lastar...',
        array_add: 'Legg til',
        array_remove: 'Fjern',
        array_item_label: '{label} element {index}',
        array_add_item: 'Legg til element i {label}',
        array_remove_item: 'Fjern element {index} frå {label}',
        legacy_banner: 'Denne posten vart oppretta før einsarta skjema. Nokre data kan avvike mellom eininga og skjemainstansen.',
        field_required: '{label} er påkravd',
        section_announcement: 'Del [[TOK_3]] av [[TOK_4]]: [[TOK_5]]',
        sections_nav_label: 'Skjemaseksjoner',
        no_sections: 'Ingen malseksjoner tilgjengelig.',
        section_label_tpl: 'Seksjon [[TOK_2]]: [[TOK_3]]',
        module_settings_auto_applied: 'Modulspesifikke innstillinger brukes automatisk.',
        operation_failed: 'Operasjonen mislyktes',
        failed_to_load_form: 'Kunne ikkje laste inn skjemaet',
        failed_to_save_form: 'Kunne ikkje lagre skjemaet',
        failed_to_submit_form: 'Kunne ikkje sende inn skjemaet',
        failed_to_load_template: 'Kunne ikkje laste inn malen',
        failed_to_save_draft: 'Kunne ikkje lagre utkastet',
        failed_to_create: 'Kunne ikkje opprette',
    },
    pack_catalog: {
        title: 'Pakke Katalog',
        install: 'Installer Pakke',
        uninstall: 'Avinstaller pakke',
        install_batch: 'Installer klynge',
        installed_tab: 'Installerte',
        catalog_tab: 'Katalog',
        pack_details: 'Pakke Detaljar',
        frameworks: 'Rammeverk',
        requirements: 'Krav',
        artifacts: 'Artefaktar',
        language_pack: 'Språk Pakke',
        dependencies: 'Avhengigheiter',
        no_packs: 'Ingen pakkar funne.',
    },
    platform_pages: {
        users: {
            title: 'Brukarar',
            new: 'Ny Brukar',
            invite: 'Inviter brukar',
            edit: 'Rediger Brukar',
            name: 'Namn',
            email: 'E-post',
            role: 'Rolle',
            status: 'Status',
            identity_type: 'Identitet Type',
            last_login: 'Siste innlogging',
            deactivate: 'Deaktiver',
            reactivate: 'Reaktiver',
            unlock: 'Lås opp',
            reset_password: 'Tilbakestill passord',
            remove: 'Fjern',
            remove_confirm: 'Fjern "{name}"? Denne handlinga er permanent, og brukaren mistar all tilgang. Oppføringa vert teken vare på for revisjonsformål.',
        },
        roles: {
            title: 'Roller',
            new: 'Ny Rolle',
            edit: 'Rediger rolle',
            name: 'Rolle Namn',
            description: 'Skildring',
            permissions: 'Løyve',
            users_count: 'Brukarar',
            detail: 'Rolle Detalj',
            all_tiers: 'Alle nivå',
            role_name_placeholder: 'f.eks. regional compliance-leiar',
        },
        profile: {
            title: 'My Profil',
            name: 'Namn',
            display_name: 'Visingsnamn',
            email: 'E-post',
            phone: 'Telefon',
            department: 'Avdeling',
            job_title: 'Stillingstittel',
            language: 'Språk',
            role: 'Rolle',
            persona: 'Oppdaga persona',
            last_login: 'Siste innlogging',
            save: 'Lagre endringar',
            save_success: 'Profilen er oppdatert',
            module_tips_section: 'Modultips',
            tips_toggle: 'Vis regulatoriske tips i modular',
            dismissed_tips: 'Avviste tips',
            reset_dismissed: 'Tilbakestill alle avviste tips',
            notification_prefs: 'Varslingsinnstillingar',
            notification_prefs_link: 'Administrer varslingsinnstillingar � ',
            change_password: 'Endrings Passord',
            current_password: 'Noverande Passord',
            new_password: 'Ny Passord',
            confirm_password: 'Stadfest passord',
            accessibility: 'Tilgjenge',
            high_contrast: 'Hogkontrastmodus',
            high_contrast_desc: 'Auk kontrasten for betre lesbarheit. Oppfyller WCAG 2.1 AAA.',
            passwords_no_match: 'Passorda stemmer ikkje overeins',
            password_changed_logout: 'Passord endra. Du blir logga ut.',
            failed_update: 'Kunne ikkje oppdatere profil',
            failed_change_password: 'Kunne ikkje endre passord',
            none: 'Ingen',
            never: 'Aldri',
            password_requirements: 'Min. 12 teikn, stor bokstav, liten bokstav, siffer, spesialteikn',
        },
        security: {
            mfa_title: 'MFA Innstillingar',
            mfa_enable: 'Aktiver MFA',
            mfa_disable: 'Deaktiver MFA',
            mfa_setup: 'Skann denne QR-koden med autentiseringsappen din',
            sso_title: 'SSO Konfigurasjon',
            sso_provider: 'Leverandør',
            sso_client_id: 'Klient ID',
            sso_redirect: 'Vidaresend-URI',
            api_keys_title: 'API-nøklar',
            api_keys_new: 'Ny API Nøkkel',
            api_keys_name: 'Nøkkel Namn',
            api_keys_last_used: 'Sist brukt',
            api_keys_expires: 'Utløper',
            api_keys_revoke: 'Tilbakekall',
            service_accounts_title: 'Tenestekontuar',
            ip_allowlist_title: 'IP-tilgangsliste',
            ip_add: 'Legg til IP-adresse',
            ip_address: 'IP-adresse',
            ip_description: 'Skildring',
            delegations_title: 'Delegeringar',
            delegations_new: 'Ny delegering',
            delegations_from: 'Frå Brukar',
            delegations_to: 'Til Brukar',
            delegations_expires: 'Utløper',
            break_glass_title: 'Nødtilgang',
            break_glass_request: 'Førespurnad Tilgang',
            break_glass_reason: '�&rsak for Tilgang',
            break_glass_duration: 'Varigheit',
            session_settings_title: '��kt Innstillingar',
            session_timeout: 'Sesjonstidsavbrot (minutt)',
            session_max_concurrent: 'Max Samtidige ��kter',
            active_sessions_title: 'Aktive ��kter',
            active_sessions_device: 'Eining',
            active_sessions_ip: 'IP-adresse',
            active_sessions_started: 'Starta',
            active_sessions_revoke: 'Tilbakekall ��kt',
            active_sessions_confirm_terminate: 'Er du sikker på at du vil avslutte denne økten?',
            active_sessions_confirm_terminate_current: 'Dette er din nåværende økt. Hvis du avslutter det, vil du logge deg ut umiddelbart. Fortsette?',
            active_sessions_confirm_terminate_all: 'Er du sikker på at du vil avslutte alle andre økter? Bare din nåværende økt vil forbli aktiv.',
            active_sessions_terminated: '��kten ble avsluttet.',
            active_sessions_all_terminated: 'Alle andre økter er avsluttet.',
            active_sessions_terminate_all: 'Avslutt alle andre økter',
            active_sessions_last_activity: 'Siste aktivitet',
            active_sessions_current: 'Nåværende økt',
            active_sessions_revoke_selected: 'Tilbakekall valde',
            active_sessions_confirm_terminate_selected: 'Er du sikker på at du vil avslutte dei valde øktene?',
            active_sessions_selected_terminated: 'Valde økter avslutta.',
            ip_allowlist_desc: 'Administrer tillatte IP-adresser for [[TOK_0]] tilgang.',
            ip_no_entries: 'Ingen IP-adresser er konfigurert.',
            session_settings_desc: 'Konfigurer tidsavbrudd for økter og grenser for samtidige økter.',
            session_settings_save_policy: 'Lagre sesjonspolicy',
            session_settings_saved: '��ktinnstillingene er oppdatert.',
            session_settings_idle_timeout: 'Inaktiv tidsavbrudd (minutter)',
            session_settings_absolute_timeout: 'Absolutt tidsavbrudd (minutter)',
            session_settings_help_idle: '��kten vil utløpe etter denne perioden med inaktivitet.',
            session_settings_help_absolute: '��kten vil utløpe etter denne totale varigheten uavhengig av aktivitet.',
            session_settings_help_max: 'Maksimalt antall samtidige økter per bruker.',
            sso_note: 'Endringer i SSO-konfigurasjonen kan kreve at brukere autentiserer seg på nytt.',
            service_accounts_warning: 'Denne [[TOK_0]]-tasten vil bare vises én gang. Kopier det nå og oppbevar det sikkert.',
            service_accounts_new: 'Ny tjenestekonto',
            service_accounts_name: 'Kontonavn',
            service_accounts_role: 'Rolle',
            service_accounts_created: 'Opprettet',
            service_accounts_desc: 'Administrer maskin-til-maskin-tjenestekontoer for [[TOK_0]] integrasjoner.',
            break_glass_warning: 'Break-glass-tilgang revideres og logges. Bruk kun for ekte nødstilfeller.',
            break_glass_min_chars: '[[TOK_2]] / [[TOK_3]] minimumstegn',
            break_glass_permission_count: '[[TOK_1]] tillatelse(r) er valgt',
            break_glass_submitted: 'Forespørsel om knust glass er sendt inn. Venter på godkjenning.',
            break_glass_approved: 'Forespørsel om knust glass godkjent.',
            break_glass_denied: 'Forespørsel om glassknusing avvist.',
            break_glass_confirm_activate: 'Godkjenne denne forespørselen om knust glass? Dette vil gi nødtilgang umiddelbart.',
            break_glass_confirm_title: 'Bekreft aktivering',
            break_glass_pending: 'Ventende forespørsler',
            break_glass_active_sessions: 'Aktive Break-Glass-økter',
            break_glass_time_remaining: 'Gjenstående tid',
            break_glass_expired: 'Utløpt',
            break_glass_approved_denied_by: 'Godkjent/Nekt av',
            delegations_desc: 'Administrer midlertidige tillatelsesdelegeringer mellom brukere.',
            delegations_my: 'Mine delegasjoner',
            delegations_to_me: 'Delegert til meg',
            delegations_scope_all: 'Alle tillatelser',
            delegations_scope_specific: 'Spesifikke tillatelser',
            delegations_created: 'Delegasjonen ble opprettet.',
            delegations_revoked: 'Delegasjonen tilbakekalt.',
            delegations_confirm_revoke: 'Er du sikker på at du vil tilbakekalle denne delegeringen?',
            delegations_confirm_revoke_title: 'Bekreft tilbakekall',
            delegations_permission_count: '[[TOK_1]] tillatelse(r)',
            api_keys_status: 'Status',
            api_keys_prefix: 'Nøkkelprefiks',
            api_keys_permissions_count: 'Tillatelser',
            api_keys_ip_count: 'IP-begrensninger',
            api_keys_created: 'Opprettet',
            api_keys_confirm_revoke_title: 'Bekreft tilbakekall',
            api_keys_confirm_revoke_message: 'Er du sikker på at du vil tilbakekalle [[TOK_2]]-tasten "[[TOK_1]]"? Denne handlingen kan ikke angres.',
            api_keys_confirm_rotate_title: 'Bekreft rotasjon',
            api_keys_confirm_rotate_message: 'Er du sikker på at du vil rotere [[TOK_2]]-tasten "[[TOK_1]]"? Den gjeldende nøkkelen slutter å virke umiddelbart.',
            api_keys_created_success: '[[TOK_0]] nøkkel opprettet.',
            api_keys_revoked_success: '[[TOK_2]]-tasten "[[TOK_1]]" er tilbakekalt.',
            api_keys_rotated_success: '[[TOK_2]]-tasten "[[TOK_1]]" har blitt rotert. Kopier den nye nøkkelen nedenfor.',
            api_keys_load_error: 'Kunne ikke laste inn [[TOK_0]]-nøkler.',
            api_keys_create_error: 'Kunne ikke opprette [[TOK_0]] nøkkel.',
            api_keys_revoke_error: 'Kunne ikke tilbakekalle [[TOK_0]]-nøkkelen.',
            api_keys_rotate_error: 'Kunne ikke rotere [[TOK_0]]-tasten.',
            break_glass_duration_15: '15 minutter',
            break_glass_duration_30: '30 minutter',
            break_glass_duration_60: '60 minutter (1t)',
            break_glass_duration_120: '120 minutter (2t)',
            break_glass_duration_240: '240 minutter (4t)',
            sod_rules_title: 'Regler for pliktdeling',
            sod_violations_report: 'Rapport om brudd',
            sod_create_rule: 'Opprett regel',
            sod_col_name: 'Navn',
            sod_col_description: 'Beskrivelse',
            sod_col_conflict_count: 'Antall konflikter',
            sod_col_severity: 'Alvorlighetsgrad',
            sod_col_status: 'Status',
            sod_col_actions: 'Handlinger',
            sod_no_rules: 'Ingen SoD-regler funnet',
            sod_severity_warning: 'Advarsel',
            sod_severity_blocking: 'Blokkering',
            sod_active: 'Aktiv',
            sod_inactive: 'Inaktiv',
            sod_edit: 'Rediger',
            sod_exceptions: 'Unntak',
            sod_deactivate: 'Deaktiver',
            sod_confirm_deactivate_title: 'Bekreft deaktivering',
            sod_confirm_deactivate_message: 'Vil du deaktivere regelen «[[TOK_1]]»? Det vil ikke lenger flagge brudd.',
            sod_deactivate_error: 'Kunne ikke deaktivere regelen',
            sod_rule_count: '{count} rules',
        },
        access_reviews: {
            title: 'Tilgang Gjennomgangar',
            campaigns: 'Gjennomgangskampanjar',
            new_campaign: 'Ny Kampanje',
            campaign_name: 'Kampanje Namn',
            scope: 'Omfang',
            reviewers: 'Gjennomgåarar',
            due_date: 'Forfallsdato',
            progress: 'Framdrift',
            my_reviews: 'Mine gjennomgangar',
            approve: 'Godkjenn',
            revoke: 'Tilbakekall',
            analytics: 'Rolleanalyse',
            analytics_title: 'Rolleanalyse',
            permission_usage: 'Løyvebruk',
            role_coverage: 'Rolle Dekning',
            campaign_detail: 'Kampanjedetaljer',
            campaign_description: 'Beskrivelse',
            campaign_status: 'Status',
            campaign_deadline: 'Frist',
            campaign_scope_type: 'Omfang Type',
            campaign_completion: 'Fullføring',
            campaign_total_items: 'Totalt antall varer',
            campaign_pending_items: 'Venter',
            campaign_confirmed_items: 'Bekreftet',
            campaign_revoked_items: 'Opphevet',
            campaign_escalated_items: 'Eskalert',
            campaign_launch: 'Start kampanje',
            campaign_cancel: 'Avbryt kampanje',
            campaign_confirm_launch: 'Er du sikker på at du vil lansere denne kampanjen?',
            campaign_confirm_cancel: 'Er du sikker på at du vil kansellere denne kampanjen?',
            campaign_launched: 'Kampanjen ble lansert.',
            campaign_cancelled: 'Kampanjen kansellert.',
            review_items: 'Gjennomgå elementer',
            review_item_user: 'Bruker',
            review_item_role: 'Rolle',
            review_item_reviewer: 'Anmelder',
            review_item_decision: 'Beslutning',
            review_item_justify: 'Begrunnelse',
            review_item_confirm: 'Bekreft',
            review_item_revoke: 'Oppheve',
            review_item_escalate: 'Eskalere',
            all_decisions: 'Alle vedtak',
            bulk_action: 'Bulk handling',
            bulk_confirm: 'Massebekreft',
            bulk_revoke: 'Bulk Revoke',
            selected_count: '[[TOK_1]] valgt',
            justify_required: 'Begrunnelse er nødvendig',
            scope_all_users: 'Alle brukere',
            scope_role_owner: 'Rolleeier',
            scope_department: 'Avdeling',
            back_to_campaigns: 'Tilbake til Kampanjer',
            recommendations: 'Anbefalinger',
            refreshing: 'Oppdaterer...',
            decide: 'Bestem deg',
            decision_by: 'Vedtak av',
            loading_items: 'Laster inn elementer ...',
            loading_review_items: 'Laster inn anmeldelseselementer ...',
            campaign_not_found: 'Fant ikke kampanjen',
            loading_campaign: 'Laster inn kampanjedetaljer ...',
            campaign_completed: 'Kampanjen fullført.',
            confirm_cancel_title: 'Bekreft Avbryt',
            justify_bulk_confirm: 'Begrunnelse for massebekreftelse:',
            justify_bulk_revoke: 'Begrunnelse for masseopphevelse:',
            items_selected: '[[TOK_1]] element(er) er valgt',
            justify_bulk_required: 'Begrunnelse er nødvendig for bulkhandlinger',
            create_campaign_title: 'Opprett tilgangsvurderingskampanje',
            name_required: 'Navn er påkrevd',
            scope_type_required: 'Omfangstype er påkrevd',
            reviewer_strategy_required: 'Anmelderstrategi er nødvendig',
            deadline_required: 'Frist er påkrevd',
            reviewer_id_required: 'Anmelder-ID kreves for spesifikk brukerstrategi',
            invalid_json: 'Ugyldig [[TOK_0]]',
            scope_filter_label: 'Omfangsfilter ([[TOK_0]])',
            reviewer_strategy_label: 'Anmelderstrategi',
            reviewer_id_label: 'Anmelder-ID',
            deadline_label: 'Frist',
            create_campaign_btn: 'Opprett kampanje',
            scope_type_label: 'Omfang Type',
            scope_by_role: 'Etter rolle',
            scope_by_department: 'Etter avdeling',
            scope_custom: 'Egendefinert',
            reviewer_manager: 'Manager',
            reviewer_specific_user: 'Spesifikk bruker',
            enter_json_filter: 'Skriv inn [[TOK_0]] filter',
            hint_label: 'Hint:',
            role_usage: 'Rollebruk',
            over_privileged_users: 'Overprivilegerte brukere',
            role_name_col: 'Rollenavn',
            assigned_users: 'Tilordnede brukere',
            active_users_30d: 'Aktive brukere (30d)',
            total_perms: 'Total Perms',
            used_perms: 'Brukte Perms',
            unused_perms: 'Ubrukte Perms',
            no_data_available: 'Ingen data tilgjengelig',
            roles_col: 'Roller',
            total_col: 'Totalt',
            used_col: 'Brukt',
            unused_pct: 'Ubrukt %',
            current_count: 'Nåværende telling',
            recommended_count: 'Anbefalt antall',
            rationale: 'Begrunnelse',
            loading_analytics: 'Laster inn statistikk ...',
            loading_role_analytics: 'Laster inn rolleanalysedata ⬦',
            computed_at: 'Beregnet ved:',
            form_errors: 'Skjemaet har [[TOK_1]] feil(er). Rett dem opp.',
            scope_filter_invalid_json: 'Omfangsfilteret inneholder ugyldig [[TOK_0]]',
            scope_hint_all_users: 'Ingen filter nødvendig - alle brukere vil bli inkludert.',
            review_type_label: 'Gjennomgangstype',
            review_type_required: 'Gjennomgangstype er påkravd',
            reviewer_ids_label: 'Revisor-ID-ar',
            reviewer_ids_hint: 'Skriv inn brukar-ID-ar skilde med komma',
            reviewer_ids_required: 'Minst éin revisor-ID er påkravd',
            start_date_label: 'Startdato',
            start_date_required: 'Startdato er påkravd',
            end_date_label: 'Sluttdato',
            end_date_required: 'Sluttdato er påkravd',
            review_type_user_access: 'Brukartilgang',
            review_type_role_permissions: 'Rolletillatelar',
            review_type_service_accounts: 'Tenestekontiar',
            review_type_privileged_access: 'Privilegert tilgang',
            review_type_application_access: 'Applikasjonstilgang',
            auto_revoke_label: 'Auto-tilbakekall ved avvising',
            campaigns_title: 'Få tilgang til gjennomgangskampanjer',
            create_campaign_label: '+ Opprett kampanje',
            no_campaigns_found: 'Fant ingen kampanjer',
            loading_campaigns: 'Laster inn kampanjer ...',
            no_reviews_assigned: 'Ingen anmeldelser er tildelt deg',
            loading_reviews: 'Laster anmeldelser ...',
            review_decision_title: 'Gjennomgå vedtak',
            justification_label: 'Begrunnelse',
            announce_loaded_review_items: 'Lastet inn [[TOK_1]] anmeldelsesartikler',
            announce_loaded_campaigns: 'Lastet inn [[TOK_1]] kampanjer',
            announce_decision_submitted: 'Vedtak «[[TOK_1]]» sendt inn for vurdering',
            announce_decision_submitted_for: 'Avgjørelse «[TOK_2]]» sendt inn for [[TOK_3]]',
            announce_bulk_decision: 'Masse [[TOK_2]] brukt på [[TOK_3]] varer',
        },
        attestation: {
            title: 'Attestering Tidsplanar',
            new: 'Ny Tidsplan',
            edit: 'Rediger Planlegg',
            create_title: 'Opprett attesteringstidsplan',
            edit_title: 'Rediger attesteringstidsplan',
            schedule_history: 'Tidsplanhistorikk',
            next_run_date: 'Neste køyringsdato',
            schedule_name: 'Tidsplan Namn',
            frequency: 'Frekvens',
            next_run: 'Neste Køyring',
            last_run: 'Siste Køyring',
            history: 'Attestering Historikk',
            description: 'Beskrivelse',
            scope: 'Omfang',
            status: 'Status',
            created_at: 'Opprettet',
            updated_at: 'Oppdatert',
            trigger_now: 'Utløs nå',
            back_to_schedules: 'Tilbake til tidsplaner',
            confirm_trigger: 'Trigger this schedule now?',
            confirm_delete: 'Delete this schedule?',
            triggered: 'Tidsplanen ble utløst.',
            deleted: 'Tidsplan slettet.',
            saved: 'Tidsplanen er lagret.',
            campaigns_generated: 'Kampanjer generert',
            run_date: 'Kjøringsdato',
            run_status: 'Kjør status',
            create_schedule: 'Opprett tidsplan',
            view_history: 'Vis historikk',
            deactivate: 'Deaktiver',
            overdue: 'OVERDUE',
            overdue_sr: 'Tidsplanen er forsinket',
            confirm_trigger_title: 'Bekreft handling',
            confirm_trigger_message: 'Are you sure you want to trigger this schedule now?',
            confirm_deactivate_title: 'Bekreft deaktivering',
            confirm_deactivate_message: 'Er du sikker på at du vil deaktivere denne tidsplanen?',
            triggered_success: 'Tidsplanen ble utløst.',
            deactivated_success: 'Tidsplan deaktivert.',
            name_label: 'Navn *',
            frequency_label: 'Frekvens *',
            scope_type_label: 'Omfangstype *',
            scope_filter_label: 'Omfangsfilter ([[TOK_0]])',
            reviewer_strategy_label: 'Anmelderstrategi *',
            reviewer_id_label: 'Anmelder-ID *',
            frequency_quarterly: 'Kvartalsvis',
            frequency_semi_annual: 'Halvårlig',
            frequency_annual: '�&rlig',
            scope_all_users: 'Alle brukere',
            scope_by_role: 'Etter rolle',
            scope_by_department: 'Etter avdeling',
            scope_framework: 'Rammeverk',
            scope_custom: 'Egendefinert',
            reviewer_manager: 'Manager',
            reviewer_role_owner: 'Rolleeier',
            reviewer_specific_user: 'Spesifikk bruker',
            computed_next_run_date: 'Beregnet neste kjøringsdato',
            current_scheduled_date: 'Gjeldende planlagt dato',
            recomputed_frequency_changed: '(beregnet på nytt -- frekvens endret)',
            estimated_days_hint: 'Estimert basert på [[TOK_1]] dager fra i dag',
            validation_name_required: 'Navn er påkrevd',
            validation_frequency_required: 'Frekvens er nødvendig',
            validation_scope_type_required: 'Omfangstype er påkrevd',
            validation_reviewer_strategy_required: 'Anmelderstrategi er nødvendig',
            validation_reviewer_id_required: 'Anmelder-ID kreves for spesifikk brukerstrategi',
            validation_invalid_json: 'Ugyldig [[TOK_0]]',
            validation_scope_filter_invalid_json: 'Omfangsfilteret inneholder ugyldig [[TOK_0]]',
            form_errors: 'Skjemaet har [[TOK_1]] feil(er). Rett dem opp.',
            create_schedule_btn: 'Opprett tidsplan',
            schedule_history_title: 'Tidsplan historikk',
            campaign_name_col: 'Kampanjenavn',
            items_col: 'Varer',
            no_campaigns_yet: 'Ingen kampanjer er generert ennå',
            loading_history: 'Laster inn loggen ...',
            loading_schedule: 'Laster tidsplan...',
            total_campaigns: 'Totalt antall kampanjer: [[TOK_1]]',
            results_per_page: 'Resultater per side',
            page_size_option: '[[TOK_1]] / side',
        },
        sod: {
            title: 'Oppgåvedeling-reglar',
            new: 'Ny Regel',
            edit: 'Rediger Regel',
            create_title: 'Opprett SoD-regel',
            edit_title: 'Rediger SoD-regel',
            rule_name: 'Regel Namn',
            conflicting_permissions: 'Motstridande Løyve',
            permission_a: 'Løyve Ein',
            permission_b: 'Løyve B',
            violations: 'SoD-brot',
            violation_user: 'Brukar',
            violation_rule: 'Regel broten',
            violation_date: 'Oppdaga den',
            exceptions: 'SoD-unntak',
            exception_reason: 'Unntaksgrunn',
            exception_approver: 'Godkjent av',
            exception_status: 'Unntaksstatus',
            has_exception: 'Har unntak',
            no_exception: 'Ingen unntak',
            grant_exception: 'Grant Unntak',
            granting: 'Innvilger...',
            grant_new_exception: 'Gi nytt unntak',
            exceptions_for: 'Unntak for: [[TOK_1]]',
            back_to_rules: 'Tilbake til Regler',
            no_violations: 'Ingen brudd funnet',
            no_exceptions_found: 'Ingen unntak funnet for denne regelen',
            all_exception_statuses: 'Alle unntaksstatuser',
            user_id_label: 'Bruker-ID',
            justification_label: 'Begrunnelse',
            compensating_controls_label: 'Kompenserende kontroller',
            expires_at_label: 'Utløper kl',
            granting_exception_for: 'Gir unntak for regel: [[TOK_1]]',
            severity: 'Alvorlighetsgrad',
            severity_warning: 'Advarsel',
            severity_blocking: 'Blokkering',
            violation_count: '[[TOK_1]] brudd(er)',
            exception_count: '[[TOK_1]] unntak(er)',
            rule_description: 'Beskrivelse',
            confirm_delete: 'Er du sikker på at du vil slette denne regelen?',
            deleted: 'Regel slettet.',
            framework_code: 'Regelverk',
            name_label: 'Navn *',
            severity_label: 'Alvorlighetsgrad *',
            conflict_pairs_legend: 'Konflikttillatelsespar',
            conflict_pairs_hint: 'Hvert par definerer to tillatelser som ikke skal innehas av samme bruker.',
            placeholder_permission_a: '-- Tillatelse A --',
            placeholder_permission_b: '-- Tillatelse B --',
            permission_a_for_pair: 'Tillatelse A for par [[TOK_1]]',
            permission_b_for_pair: 'Tillatelse B for paret [[TOK_1]]',
            conflict_pair_label: 'Konfliktpar [[TOK_1]]',
            remove_conflict_pair: 'Fjern konfliktpar [[TOK_1]]',
            add_pair: '+ Legg til par',
            placeholder_name: 'f.eks. Betalingsgodkjenningsseparasjon',
            create_rule: 'Opprett regel',
            loading_rule: 'Laster inn SoD-regel ...',
            failed_load_rule: 'Kunne ikke laste inn regelen.',
            failed_create_rule: 'Kunne ikke opprette SoD-regel.',
            failed_update_rule: 'Kunne ikke oppdatere SoD-regelen.',
            validation_name_required: 'Navn er påkrevd.',
            validation_pair_required: 'Minst ett konflikttillatelsespar kreves.',
            validation_pair_both_required: 'Par [[TOK_1]]: Begge tillatelsene må velges.',
            validation_pair_must_differ: 'Par [[TOK_1]]: Tillatelse A og Tillatelse B må være forskjellige.',
            added_conflict_pair: 'Lagt til konfliktpar [[TOK_1]]',
            removed_conflict_pair: 'Fjernet konfliktpar [[TOK_1]]',
            announce_loaded_violations: 'Lastet [[TOK_1]] brudd',
            announce_loaded_exceptions: 'Lastet inn [[TOK_1]] unntak',
            announce_loaded_rules: 'Lastet [[TOK_1]] SoD-regler',
            announce_loading_exceptions: 'Laster inn unntak ⬦',
            regulatory_info: {
                sod_context: 'SoD-reglar handhevar det regulatoriske rolleskiljet som krevst av PDPL. Brot knytte til ein framework_code kan inkluderast i rammeverksspecifikke evidenspakker (UC-VN-09).',
                violation_export_context: 'SoD-broteksportar inkluderer framework_code, motstridande roller, alvorlegheitsgrad, oppretta av og registreringstidspunkt for evidenspakker (P-VN-10).',
                exception_context: 'SoD-unntak produserer revisjonsdokumentasjon: godkjennar, grunngjeving, kompenserande kontrollar og utloepsdato. Utloepne unntak forblir synlege (UC-VN-09 Steg 5).',
            },
        },
        regulatory_info: {
            attestation_context: 'Attestation schedules support the annual governance attestation cycle required by Data Law (DATA-D4). When scope_type is set to "framework", schedules can be linked to specific regulatory frameworks.',
            api_keys_context: 'API key telemetry constitutes account evidence per VN_CYBERSEC_LAW_2025 Section B.5. Each key record includes last_used_at, ip_allowlist, permissions, status, and expires_at.',
            session_context: 'Session management enforces access controls per Telecom Law confidentiality requirements (Section B.4). Session events produce audit trail entries.',
            break_glass_context: 'Break-glass procedures produce regulatory justification evidence: requestor identity, justification, permissions, duration, approver identity, and approval/denial timestamps.',
            license_context: 'License settings gate modules by tier using PACKAGE_DEFINITIONS. Framework-specific modules require appropriate license tiers. Tier changes produce audit trail entries.',
            module_config_context: 'Module configuration supports framework-driven enablement. Disabling a module required by an active regulatory framework may break evidence completeness.',
            notification_context: 'Compliance-critical notifications (breach deadlines, attestation due dates) are marked with a compliance_critical flag and cannot be fully suppressed.',
            delegation_context: 'Delegation governance produces audit-grade evidence: delegator_id, delegate_id, permission scope, start/end dates, and status. Expired delegations remain visible.',
            access_control_context: 'Access control configuration meets Cybersecurity Law requirements (VN_CYBERSEC_LAW_2025): IP allowlist, MFA, service accounts, and SSO changes are audit-trailed.',
        },
    },
    cmp: {
        integration: {
            title: 'CMP Integrasjon',
            status: 'Tilkoplingsstatus',
            endpoint: 'CMP-endepunkt',
            last_sync: 'Siste Synkronisering',
            configure: 'Konfigurer',
        },
        purpose_mapping: {
            title: 'Føremål Kartlegging',
            cmp_purpose: 'CMP Føremål',
            grc_purpose: 'GRC Føremål',
            mapping_status: 'Kartlegging Status',
            auto_map: 'Automatisk kortlægning',
            new_mapping: 'Ny Kartlegging',
        },
        webhook: {
            title: 'Webhook Konfigurasjon',
            webhook_url: 'Webhook-URL',
            secret: 'Webhook Hemmelighet',
            events: 'Hending Typar',
            test_webhook: 'Test webhook',
        },
        bulk_sync: {
            title: 'Masse Synkroniser',
            sync_now: 'Synkronisering Now',
            last_run: 'Siste Køyring',
            records_synced: 'Postar synkroniserte',
            sync_history: 'Synkronisering Historikk',
            syncing: 'Synkroniserer...',
        },
        sync_settings: {
            sync_failures: 'Synkronisering Feil',
            sync_secret_warning: 'Synkroniseringshemmelighed (gem dette nu � det vises ikke igen):',
            push_description: 'Konfigurer GRC Suite til å sende saksstatusoppdateringar til AesirX CMP.',
            technical_description: 'Denne konfigurasjonen kontrollerer hvordan GRC Suite sender saksstatusoppdateringer til [[TOK_1]] [[TOK_0]].',
            direction_label: 'Retning',
            direction_value: 'GRC Suite �  AesirX CMP (udgående)',
            auth_label: 'Autentisering',
            auth_value: 'HMAC-SHA256-signatur i X-GRC-Signature-header',
            retry_label: 'Gjenforsøk Retningslinje',
            retry_value: '3 gjenforsøk med eksponentiell ventetid (30s, 2min, 10min)',
            inbound_label: 'Innkomande Konfigurasjon',
            inbound_value: 'Indgående webhook (CMP �  GRC) er konfigureret i',
            cmp_webhook_settings: 'CMP Webhook Innstillingar',
            page_title: 'CMP Synkroniseringsinnstillingar',
            outbound_sync_configured: 'Utgåande synkronisering konfigurert.',
            configure_sync_failed: 'Kunne ikkje konfigurere synkronisering',
            configuration_updated: 'Konfigurasjon oppdatert.',
            update_configuration_failed: 'Kunne ikkje oppdatere konfigurasjon',
            connection_test_failed: 'Tilkoplingstest mislukkast',
            test_result_message: 'Test sendt til {endpoint}. Status: {status}',
            endpoint_placeholder: 'https://your-cmp-domain/api/grc-sync',
            events: {
                new_to_under_review: 'Ny �  Under gjennomgang (tildelt)',
                under_review_to_identity_verification: 'Under gjennomgang �  Identitetsverifikation',
                under_review_to_in_progress: 'Under gjennomgang �  I gang',
                in_progress_to_completed: 'I gang �  Fuldført',
                in_progress_to_denied: 'I gang �  Afvist',
                any_to_closed: 'Alle �  Stengd',
            },
        },
    },
    settings_pages: {
        webhooks: {
            title: 'Webhookar',
            new: 'Ny Webhook',
            url: 'URL',
            url_placeholder: 'https://example.com/webhook',
            events: 'Hendingar',
            secret: 'Hemmelighet',
            active: 'Aktiv',
            test: 'Test',
            create_failed: 'Kunne ikkje opprette webhook.',
            create_success: 'Webhook oprettet.',
            deactivate_failed: 'Kunne ikkje deaktivere webhook.',
            deactivate_success: 'Webhook deaktivert.',
            fetch_failed: 'Kunne ikkje hente webhooks.',
            send_test_failed: 'Kunne ikkje sende test.',
            test_failed: 'Webhook test mislukkast.',
            test_success: 'Webhook-test lykkedes.',
            edit_title: 'Rediger webhook',
            announce_loaded: 'Webhookar lasta',
            update_success: 'Webhook oppdatert.',
            update_failed: 'Kunne ikkje oppdatere webhook.',
            activate_success: 'Webhook aktivert.',
            activate_failed: 'Kunne ikkje aktivere webhook.',
        },
        domains: {
            title: 'Domene',
            new: 'Ny Domene',
            domain_name: 'Domene Namn',
            verified: 'Verifisert',
            verify: 'Verifiser',
            add_failed: 'Kunne ikkje leggje til domene.',
            add_success: 'Domæne tilføjet.',
            domain_placeholder: 't.d. grc.example.com',
            fetch_failed: 'Kunne ikkje hente domene.',
            remove_failed: 'Kunne ikkje fjerne domene.',
            remove_success: 'Domæne fjernet.',
            txt_record: 'TXT Post',
            verify_dns_failed: 'DNS verifisering mislukkast.',
            verify_failed: 'Kunne ikkje verifisere domene.',
            verify_success: 'Domæne verificeret.',
        },
        export_schedules: {
            title: 'Eksportplanar',
            new: 'Ny Tidsplan',
            schedule_name: 'Namn',
            frequency: 'Frekvens',
            format: 'Format',
            last_run: 'Siste Køyring',
            next_run: 'Neste Køyring',
            create_failed: 'Kunne ikkje opprette tidsplan.',
            create_success: 'Tidsplan oprettet.',
            day_of_month: 'Dag i måneden',
            day_of_week: 'Dag av Veke',
            deactivate_failed: 'Kunne ikkje deaktivere tidsplan.',
            deactivate_success: 'Tidsplan deaktivert.',
            fetch_failed: 'Kunne ikkje hente tidsplanar.',
            freq_daily: 'Dagleg',
            freq_monthly: 'Månadleg',
            freq_weekly: 'Vekentleg',
            recipients: 'Mottakarar',
            time_utc: 'Tid (UTC)',
            trigger_failed: 'Kunne ikkje utløyse eksport.',
            trigger_success: 'Eksport udløst.',
            type_audit_trail: 'Revisjon Spor',
            type_compliance_report: 'Etterleving Rapport',
            type_custom: 'Tilpassa',
            type_incident_report: 'Hending Rapport',
            type_ropa: 'ROPA',
        },
        email_log: {
            title: 'E-postlogg',
            recipient: 'Mottakar',
            subject: 'Emne',
            sent_at: 'Sendt Ved',
            status: 'Status',
            resend: 'Send på nytt',
            fetch_failed: 'Kunne ikkje hente e-postloggar.',
        },
    },
    organizations: {
        title: 'Organisasjonar',
        create: 'Opprett Organisasjon',
        edit: 'Rediger Organisasjon',
        name: 'Namn',
        slug: 'Snegl',
        timezone: 'Tidssone',
        locale: 'Standard Lokalitet',
        parent: 'Overordna Organisasjon',
        group: 'Gruppe',
        org_group: 'Organisasjonsgruppe',
        no_group: '(Ingen - ikkje i ei gruppe)',
        created: 'Oppretta',
        no_parent: '(Ingen - frittståande)',
        no_orgs: 'Ingen organisasjonar funne',
        load_error: 'Kunne ikkje laste organisasjonar',
        save_error: 'Kunne ikkje lagre organisasjon',
        created_msg: 'Organisasjon oppretta',
        updated: 'Organisasjon oppdatert',
        deactivate: 'Deaktiver',
        deactivated: 'Organisasjon deaktivert',
        confirm_deactivate: 'Er du sikker på at du vil deaktivere denne organisasjonen?',
        loaded_results: 'Organizations lasta, {count} resultat',
        form_loaded: 'Organization-skjema lasta',
        locale_vi_vn: 'Tiếng Vi�!t (vi-VN)',
        locale_en_us: 'Engelsk (en-US)',
    },
    intake_configs: {
        title: 'Offentleg Inntak Konfigurasjonar',
        create: 'Opprett Konfiguration',
        edit: 'Rediger Inntaks Konfiguration',
        label_col: 'Etikett',
        key: 'Inntak Nøkkel',
        key_hint: 'Offentlig URL vil være: /rights-request?key=',
        mapped_org: 'Mål Organisasjon',
        status: 'Status',
        enabled: 'Aktivert',
        disabled: 'Deaktivert',
        request_types: 'Aktivert Førespurnad Typar',
        language: 'Standard Språk',
        public_url: 'Offentleg URL',
        no_configs: 'Ingen inntakskonfigurasjonar funne. Opprett ein for å aktivere offentlege rettighetsførespurnadsskjema.',
        load_error: 'Kunne ikkje laste inntakskonfigurasjonar',
        save_error: 'Kunne ikkje lagre',
        delete_error: 'Kunne ikkje slette',
        created_msg: 'Konfigurasjon oppretta',
        updated: 'Konfigurasjon oppdatert',
        deleted: 'Indtagskonfigurasjon slettet',
        confirm_delete: 'Slett denne indtagskonfigurasjon?',
        select_types: 'Vel mindst én anmodningstype',
        select_org: 'Vel a mål organisasjon',
        routing_mode: 'Rutemodus',
        single_org: 'Einskild Organisasjon',
        org_group_mode: 'Organisasjonsgruppe',
        org_group: 'Organisasjonsgruppe',
        select_group: 'Vel ei organisasjonsgruppe...',
        group_root_hint: 'Vert automatisk sett til rotorganisasjonen i gruppa når gruppa vert vald.',
        loaded_results: 'Intake configurations lasta, {count} resultat',
        form_loaded: 'Intake configuration-skjema lasta',
    },
    frequency: {
        weekly: 'Kvar veke',
        monthly: 'Kvar månad',
        quarterly: 'Kvartalsvis',
        semi_annually: 'Halvårleg',
        annually: '�&rleg',
        custom: 'Eigendefinert',
    },
    task_management: {
        nav: {
            calendar: 'Kalender',
            all_tasks: 'Alle oppgåver',
            my_tasks: 'Mine oppgåver',
            overdue: 'Forseinka',
            board: 'Tavle',
            workflows: 'Arbeidsflytar',
        },
        list: {
            title: 'Alle oppgåver',
            my_title: 'Mine oppgåver',
            overdue_title: 'Forseinka oppgåver',
            new_task: 'Opprett oppgåve',
            no_tasks: 'Ingen oppgåver funne.',
            empty_state: 'Ingen oppgåver funne. Oppgåver vert genererte frå modularbeidsflyter som vurderingar, hendingar og gjennomgangskampanjar.',
            total: 'Totale oppgåver',
            search_placeholder: 'Søk oppgåver...',
            bulk_actions: 'Massehandlingar',
            change_status: 'Endre status',
            change_priority: 'Endre prioritet',
            assign: 'Tildel',
            sr_my_tasks_count: '{count} oppgåver tildelt deg',
            sr_days_overdue: '{count} dagar forseinka',
            sla_label: 'SLA',
        },
        detail: {
            title: 'Oppgåvedetaljar',
            description: 'Skildring',
            workflow_progress: 'Arbeidsflytframgang',
            checklist: 'Sjekkliste',
            dependencies: 'Avhengigheitar',
            comments: 'Kommentarar',
            activity_timeline: 'Aktivitetstidslinje',
            assignees: 'Tildelte',
            add_assignee: 'Legg til tildelt',
            remove_assignee: 'Fjern tildelt',
            due_date: 'Forfallsdato',
            start_date: 'Startdato',
            sla_status: 'SLA-status',
            sla_on_track: 'I rute',
            sla_at_risk: 'I fare',
            sla_breached: 'Brote',
            tags: 'Tagger',
            source_entity: 'Kjeldeentitet',
            view_source: 'Vis kjelde',
            add_dependency: 'Legg til avhengigheit',
            remove_dependency: 'Fjern avhengigheit',
            write_comment: 'Skriv ein kommentar...',
            post_comment: 'Send',
            edit_comment: 'Rediger',
            delete_comment: 'Slett',
            add_checklist_item: 'Legg til element',
            no_dependencies: 'Ingen avhengigheitar',
            no_comments: 'Ingen kommentarar enno',
            blocks: 'Blokkerer',
            blocked_by: 'Blokkert av',
            related: 'Relatert',
            working_days_remain: 'arbeidsdagar att',
            created_by: 'Oppretta av',
            completed_at: 'Fullført den',
            no_assignees: 'Ingen tildelte',
            add_assignee_placeholder: 'Skriv inn brukar-ID...',
            edited: 'redigert',
            timeline: 'Aktivitetstidslinje',
            no_timeline: 'Ingen aktivitet enno',
            no_workflow: 'Ingen arbeidsflyt tildelt',
            add_dependency_placeholder: 'Skriv inn oppgåve-ID...',
            sr_status_updated: 'Status oppdatert til [[TOK_1]]',
            sr_priority_updated: 'Prioritet oppdatert til [[TOK_1]]',
            convert_to_workflow: 'Kjør som arbeidsflyt',
            convert_modal_title: 'Konverter oppgave til arbeidsflytkjøring',
            convert_workflow_label: 'Arbeidsflyt',
            convert_workflow_placeholder: 'Velg en arbeidsflyt...',
            convert_attachments_label: 'Vedlegg',
            convert_attachments_empty: 'Ingen vedlegg til denne oppgaven.',
            convert_persona_label: 'Personaoverstyring (valgfritt)',
            convert_submit: 'Start arbeidsflytkjøring',
            convert_starting: 'Starter arbeidsflytkjøring ⬦',
            convert_started: 'Arbeidsflytkjøring startet � åpningskjøring...',
            convert_disabled_in_flight: 'En arbeidsflyt som kjøres fra denne oppgaven er allerede i gang.',
            linked_workflow_chip: 'Fra [[TOK_1]]',
            linked_chat_chip: 'Fra [[TOK_0]] Chat',
            linked_more: '+[[TOK_1]] til',
        },
        calendar: {
            title: 'Oppgåvekalender',
            page_title: 'Kalender',
            create_task: 'Opprett oppgåve',
            month: 'Månad',
            week: 'Veke',
            day: 'Dag',
            today: 'I dag',
            more_tasks: '+[[TOK_1]] til',
            no_tasks_day: 'Ingen oppgåver denne dagen',
            all_day: 'Heile dagen',
            quick_create_tooltip: 'Opprett oppgåve for denne dagen',
            view_changed: 'Kalendervisning endra til {view}',
            tasks_in_view: '{count} oppgåver i vising',
            task_in_view: '[[TOK_1]] oppgave i sikte',
        },
        filters: {
            assignee: 'Tildelt',
            me: 'Meg',
            role: 'Rolle',
            status: 'Status',
            priority: 'Prioritet',
            task_type: 'Oppgåvetype',
            source_module: 'Kjeldemodul',
            organization: 'Organisasjon',
            sla_breached_only: 'Vis berre SLA-brot',
            clear_filters: 'Fjern filter',
            apply_filters: 'Bruk',
            source_label: 'Kilde',
            source_manual: 'Manuell',
            source_module_kind: 'Modulgenerert',
            source_chat: 'Fra [[TOK_0]] Chat',
            source_workflow_run: 'Fra [[TOK_0]] arbeidsflytkjøring',
        },
        status: {
            pending: 'Ventande',
            in_progress: 'Pågår',
            blocked: 'Blokkert',
            completed: 'Fullført',
            overdue: 'Forseinka',
            escalated: 'Eskalert',
            cancelled: 'Avbroten',
        },
        priority: {
            critical: 'Kritisk',
            high: 'Høg',
            medium: 'Middels',
            low: 'Låg',
        },
        task_types: {
            manual_task: 'Manuell oppgåve',
            dsr_case: 'DSR-sak',
            dsr_review: 'DSR-gjennomgang',
            dsr_escalation: 'DSR-eskalering',
            dpia_review: 'DPIA-gjennomgang',
            dpia_approval: 'DPIA-godkjenning',
            transfer_review: 'Overføringsgjennomgang',
            incident_task: 'Hendingsoppgåve',
            incident_notification: 'Hendingsvarsling',
            playbook_step: 'Spilleboksteg',
            regulator_deadline: 'Myndigheitsfrist',
            monitoring_task: 'Overvakingsoppgåve',
            kpi_alert: 'KPI-varsel',
            vendor_review: 'Leverandørgjennomgang',
            vendor_questionnaire: 'Leverandørspørjeskjema',
            governance_review: 'Styringsgjennomgang',
            drift_alert: 'Avviksvarsel',
            governance_approval: 'Styringsgodkjenning',
            deletion_task: 'Sletteoppgåve',
            deletion_verification: 'Sletteverifisering',
            access_review: 'Tilgangsgjennomgang',
            sod_alert: 'SoD-varsel',
            consent_workflow: 'Samtykkearbeidsflyt',
            consent_alert: 'Samtykkevarsel',
            property_review: 'Eigenskapsgjennomgang',
            inconsistency_alert: 'Inkonsekvensvarsel',
            form_review: 'Skjemagjennomgang',
            dossier_deadline: 'Dossierfrist',
            submission_task: 'Innsendingsoppgåve',
            translation_review: 'Omsetjingsgjennomgang',
            governance_task: 'Styringsoppgåve',
            reporting_deadline: 'Rapporteringsfrist',
            scanner_alert: 'Skannarvarsel',
            classification_review: 'Klassifiseringsgjennomgang',
            lifecycle_task: 'Livsløpsoppgåve',
            discovery_review: 'Oppdagingsgjennomgang',
        },
        task_type_groups: {
            manual: 'Manuell',
            dsr: 'DSR / Rettighetsførespurnader',
            assessments: 'Vurderingar',
            incidents: 'Hendingar',
            incident_ops: 'Hendingsdrift',
            monitoring: 'Overvaking',
            vendor_risk: 'Leverandørrisiko',
            governance: 'Styring',
            deletion: 'Sletting',
            access_review: 'Tilgangsgjennomgang',
            consent: 'Samtykke',
            consent_properties: 'Samtykkeeigeskapar',
            forms: 'Skjema',
            localization: 'Lokalisering',
            program_governance: 'Programstyring',
            privacy_scanner: 'Personvernskannar',
            classification: 'Klassifisering',
            discovery: 'Oppdaging',
        },
        create: {
            title: 'Opprett oppgåve',
            task_title: 'Tittel',
            task_description: 'Skildring',
            task_type: 'Oppgåvetype',
            task_type_label: 'Oppgåvetype',
            task_type_placeholder: 'Vel ein oppgåvetype',
            priority: 'Prioritet',
            assignees: 'Tildelte',
            assignee_search_placeholder: 'Søk brukarar...',
            due_date: 'Forfallsdato',
            start_date: 'Startdato',
            checklist: 'Sjekkliste',
            tags: 'Tagger',
            add_checklist_item: 'Legg til sjekklisteelement',
            validation: {
                title_required: 'Tittel er påkravd',
                title_max_length: 'Tittel må vere 500 teikn eller færre',
                description_max_length: 'Skildring må vere 5000 teikn eller færre',
                due_date_before_start: 'Forfallsdato må vere etter startdato',
                max_reminders: 'Maksimalt 5 påminningar per oppgåve',
            },
            reminders: {
                title: 'Påminningar',
                add: 'Legg til påminning',
                at_due_date: 'Ved forfallsdato',
                minutes_before: '[[TOK_1]] minutter før',
                hours_before: '[[TOK_1]] timer før',
                days_before: '[[TOK_1]] dager før',
                weeks_before: '[[TOK_1]] uker før',
                custom: 'Tilpassa',
                channel_platform: 'Plattform',
                channel_email: 'E-post',
                channel_both: 'Begge',
            },
            workflow: {
                label: 'Arbeidsflyt',
                none: 'Ingen (manuell statusadministrasjon)',
                steps_count: '[[TOK_1]] trinn',
                preview_label: 'Arbeidsflytsteg',
            },
        },
        errors: {
            fetch_failed: 'Kunne ikkje laste oppgåver.',
            save_failed: 'Kunne ikkje lagre oppgåve.',
            delete_failed: 'Kunne ikkje slette oppgåve.',
            status_change_failed: 'Kunne ikkje endre oppgåvestatus.',
            assign_failed: 'Kunne ikkje tildele oppgåve.',
            comment_failed: 'Kunne ikkje lagre kommentar.',
            checklist_failed: 'Kunne ikkje oppdatere sjekkliste.',
            dependency_failed: 'Kunne ikkje oppdatere avhengnad.',
            workflow_failed: 'Kunne ikkje lagre arbeidsflyt.',
            workflow_activate_failed: 'Kunne ikkje aktivere arbeidsflyt.',
            workflow_delete_failed: 'Kunne ikkje slette arbeidsflyt.',
            template_install_failed: 'Kunne ikkje installere mal.',
            search_failed: 'Kunne ikkje søke oppgåver.',
            convert_failed: 'Kunne ikke starte arbeidsflytkjøringen.',
            convert_quota_exhausted: 'Token bøtte lav. Fyll på før du kjører på nytt.',
        },
        dependency_types: {
            blocks: 'Blokkerer',
            blocked_by: 'Blokkert av',
            related: 'Relatert',
        },
        workflow: {
            current_step: 'Noverande steg',
            transition: 'Overgang',
            history: 'Steghistorikk',
            no_workflow: 'Ingen arbeidsflyt tildelt',
            detail_title: 'Arbeidsflytsdetaljar',
            list_title: 'Arbeidsflytdefinisjonar',
            create_workflow: 'Opprett arbeidsflyt',
            browse_templates: 'Bla i malar',
            template_catalog_title: 'Arbeidsflytmalkatalog',
            name: 'Namn',
            description: 'Skildring',
            task_types: 'Oppgåvetypar',
            steps: 'Steg',
            version: 'Versjon',
            created: 'Oppretta',
            actions: 'Handlingar',
            status_draft: 'Utkast',
            status_active: 'Aktiv',
            status_archived: 'Arkivert',
            activate: 'Aktiver',
            archive: 'Arkiver',
            save: 'Lagre',
            edit: 'Rediger',
            delete: 'Slett',
            clone: 'Klon',
            install: 'Installer',
            installed: 'Installert',
            system: 'System',
            general_settings: 'Generelle innstillingar',
            default_assignment: 'Standardtildeling',
            default_sla: 'Standard SLA',
            workflow_steps: 'Arbeidsflytsteg',
            add_step: 'Legg til steg',
            step_name: 'Stegnamn',
            step_status: 'Statusverdi',
            assignment_strategy: 'Tildelingsstrategi',
            assignment_role: 'Tildelingsrolle',
            sla_hours: 'SLA-timar',
            sla_calendar_type: 'Kalendertype',
            working_days: 'Arbeidsdagar',
            calendar_days: 'Kalenderdagar',
            is_terminal: 'Terminalsteg',
            required_fields: 'Påkravde felt',
            checklist_template: 'Sjekklistemal',
            transitions: 'Overgangar',
            add_transition: 'Legg til overgang',
            from_step: 'Frå',
            to_step: 'Til',
            permission: 'Løyve',
            sla_action: 'SLA-handling',
            notify: 'Varsle',
            escalation_rules: 'Eskaleringsreglar',
            add_rule: 'Legg til regel',
            trigger: 'Utløysar',
            threshold: 'Terskel',
            action: 'Handling',
            target_role: 'Målrolle',
            trigger_sla_threshold: 'SLA-terskel',
            trigger_sla_breach: 'SLA-brot',
            trigger_blocked_duration: 'Blokkert varigheit',
            trigger_manual: 'Manuell',
            action_notify: 'Varsle',
            action_escalate: 'Eskaler nivå',
            action_reassign: 'Tildel på nytt',
            sla_start: 'Start',
            sla_pause: 'Pause',
            sla_resume: 'Gjenoppta',
            sla_stop: 'Stopp',
            strategy_manual: 'Manuell',
            strategy_role_based: 'Rollebasert',
            strategy_round_robin: 'Round Robin',
            strategy_least_loaded: 'Minst belasta',
            strategy_creator: 'Opprettar',
            confirm_delete: 'Er du sikker på at du vil slette denne arbeidsflyten?',
            confirm_archive: 'Er du sikker på at du vil arkivere denne arbeidsflyten?',
            cannot_delete_active: 'Aktive arbeidsflytar kan ikkje slettast. Arkiver først.',
            validation_errors: 'Valideringsfeil i arbeidsflyt',
            step_count: '[[TOK_1]] trinn',
            no_workflows: 'Ingen arbeidsflytar funne.',
            no_templates: 'Ingen malar tilgjengelege.',
            sr_templates_count: '[[TOK_1]] maler tilgjengelig',
            template_installed: 'Mal installert.',
            activate_success: 'Arbeidsflyt aktivert.',
            archive_success: 'Arbeidsflyt arkivert.',
            save_success: 'Arbeidsflyt lagra.',
            delete_success: 'Arbeidsflyt sletta.',
        },
        columns: {
            priority: 'Prioritet',
            title: 'Tittel',
            status: 'Status',
            type: 'Type',
            assignees: 'Tildelt(e)',
            due_date: 'Forfallsdato',
            source: 'Kjelde',
            actions: 'Handlingar',
        },
        groups: {
            overdue: 'Forseinka',
            due_today: 'Forfell i dag',
            due_this_week: 'Forfell denne veka',
            due_later: 'Forfell seinare',
            no_due_date: 'Ingen forfallsdato',
        },
        board: {
            title: 'Oppgåvetavle',
            drag_hint: 'Dra oppgåver mellom kolonnar for å endre status',
            empty_column: 'Ingen oppgåver',
            keyboard_hint: 'Tastatur: piltastar for å navigere, mellomrom for å plukke opp ei oppgåve, pil venstre/høgre for å velje kolonne, Enter for å sleppe, Escape for å avbryte.',
            sr_moving: 'Flyttar {title}. Over {column}. Trykk Enter for å sleppe, Escape for å avbryte.',
            sr_tasks_shown: '{count} oppgåver viste',
            sr_picked_up: '{title} plukka opp',
            sr_returned: '[[TOK_2]] returnerte til [[TOK_3]]',
            sr_dropped: '{title} sleppt i {column}, posisjon {position} av {total}',
            sr_move_cancelled: 'Flytting avbroten',
            sr_over_column: 'Over [[TOK_1]]',
            sr_moved_to: '{title} flytta til {column}',
            invalid_transition: 'Kan ikkje flytte oppgave fra {from} til {to}.',
            terminal_status: 'Denne oppgava har ein avslutta status og kan ikkje flyttast.',
            invalid_drop_target: 'Ugyldig sleppmal',
        },
        team: {
            title: 'Lagarbeidsbelastning',
            assignee: 'Tildelt',
            active: 'Aktiv',
            overdue: 'Forseinka',
            blocked: 'Blokkert',
            completed_7d: 'Fullført (7d)',
            load: 'Belastning',
            load_high: 'Høg',
            load_medium: 'Middels',
            load_normal: 'Normal',
        },
        graph: {
            title: 'Avhengighetsgraf',
            list_view: 'Listevisning',
            graph_view: 'Grafvisning',
            zoom_in: 'Zoom inn',
            zoom_out: 'Zoom ut',
            reset_zoom: 'Tilbakestill',
            blocks_label: 'blocks',
            related_label: 'related',
            no_dependencies: 'Ingen avhengigheter å visualisere.',
        },
        add_dependency_modal: {
            title: 'Legg til avhengigheit',
            search_placeholder: 'Søk i oppgaver etter tittel eller ID...',
            no_results: 'Ingen oppgåver funne.',
            this_blocks: 'Denne oppgaven blokkerer valgt',
            this_blocked_by: 'Denne oppgaven er blokkert av valgt',
            related: 'Relatert',
            max_dependencies: 'Maks 10 avhengigheter per oppgave.',
            circular_error: 'Kan ikke legge til: vil skape en sirkulær avhengighet.',
        },
        conflict_detection: {
            title: 'Konfliktdeteksjon',
            unresolved: 'uløyst',
            no_conflicts: 'Ingen konfliktar oppdaga',
            section: 'Seksjon',
            field: 'Felt',
            dept_a: 'Avdeling A',
            value_a: 'Verdi A',
            dept_b: 'Avdeling B',
            value_b: 'Verdi B',
            severity: 'Alvorlegheit',
            status: 'Status',
            resolved: 'Løyst',
            open: '�&pne',
            resolve: 'Løys',
            load_failed: 'Kunne ikkje load conflicts',
            resolve_success: 'Konflikt løyst',
            resolve_failed: 'Kunne ikkje resolve conflict',
            severity_critical: 'Kritisk',
            severity_warning: 'Advarsel',
            severity_info: 'Info',
        },
        consolidation: {
            title: 'Konsolideringsframdrift',
            add_child: 'Legg til underoppgåve',
            child_task_id: 'Underoppgåve-ID',
            department_id: 'Avdelings-ID',
            link: 'Koble',
            overall_completion: 'Samla fullføring',
            departments_complete: 'Avdelingar fullførte',
            overdue: 'Forfallen',
            ready: 'Klar',
            not_ready: 'Ikkje klar',
            master_status: 'Overordna status',
            department_breakdown: 'Avdelingsfordeling',
            department: 'Avdeling',
            status: 'Status',
            completion: 'Fullføring',
            due_date: 'Forfallsdato',
            overdue_flag: 'Forfallen',
            child_tasks: 'Underoppgåver',
            task: 'Oppgåve',
            load_failed: 'Kunne ikkje load consolidation data',
            child_linked: 'Underoppgåve kopla',
            link_failed: 'Kunne ikkje link child task',
            confirm_unlink: 'Er du sikker på at du vil fjerne tilknytningen til denne underordnede oppgaven?',
            child_unlinked: 'Underordnet oppgave frakoblet',
            unlink_failed: 'Kunne ikke koble fra underordnet oppgave',
            unlink: 'Fjern tilknytningen',
            status_completed: 'Fullført',
            status_in_progress: 'Pågår',
            status_pending: 'Ventar',
            select_child_task: 'Vel underoppgåve',
            select_department: 'Vel avdeling',
        },
        section_assignments: {
            title: 'Seksjonstildelingar',
            assign_section: 'Tildel seksjon',
            section_ref: 'Seksjonsref.',
            section_label: 'Seksjonsetikett',
            department_id: 'Avdelings-ID',
            department: 'Avdeling',
            assignee_id: 'Tildeltes-ID',
            assignee: 'Tildelt',
            mandatory: 'Obligatorisk',
            assign: 'Tildel',
            no_assignments: 'Ingen seksjonstildelingar',
            status: 'Status',
            completion: 'Fullføring',
            mark_complete: 'Fullfør',
            load_failed: 'Kunne ikkje load section assignments',
            assign_success: 'Seksjon tildelt',
            assign_failed: 'Kunne ikkje assign section',
            status_updated: 'Status oppdatert',
            status_update_failed: 'Kunne ikkje oppdatere status',
            section_ref_placeholder: 't.d. 3.2',
            status_completed: 'Fullført',
            status_in_progress: 'Pågår',
            status_pending: 'Ventar',
            select_department: 'Vel avdeling',
            select_assignee: 'Vel tildelt',
        },
        overdue_columns: {
            days_overdue: 'Dagar forsinka',
        },
        regulatory_info: {
            deadline_context: 'Ved oppretting av DPIA-oppgaver bor forfallsdatoar samsvare med PDPL-innleveringsfristar: avdelingsinput = 10 arbeidsdagar. Cybersikkerheits- og telekomfristar gjeld ogsa.',
            overdue_deadline_context: 'Regulatoriske fristar fran pakkedata: PDPL avdelingsinput = 10 arbeidsdagar, tilleggssvar = 15 arbeidsdagar, ny innsending = 10 arbeidsdagar. SLA-brot vert markert visuelt.',
            section_assignment_context: 'DPIA fleiravdelingsarbeidsflyt (PDPL-P1): DPO tildeler dossierseksjonar til avdelingar. Avdelingsinputfrist: 10 arbeidsdagar.',
            template_catalog_context: 'Systemmalar dekkjer rammeverksspesifikke prosessar: PDPL DPIA, datalovattestering, cybersikkerheitsrespons, telekommyndigheitsforespurnader og AI-registrering. Systemmalar kan ikkje redigerast.',
            workflow_instantiation_context: 'Installerte malar kan instantierast til aktive arbeidsflyter. Oppgaver vert oppretta automatisk med utrekna forfallsdatoar.',
        },
    },
    notifications: {
        bell: {
            title: 'Varsler',
            unread_count: 'unread',
        },
        drawer: {
            title: 'Varsler',
            mark_all_read: 'Merk alle som lest',
            no_notifications: 'Ingen varsler',
            filter: {
                all: 'Alle',
                unread: 'Ulest',
                tasks: 'Oppgaver',
                approvals: 'Godkjenninger',
                alerts: 'Varsler',
            },
        },
        preferences: {
            title: 'Varslingsinnstillinger',
            description: 'Konfigurer hvordan du mottar varsler',
            category: {
                label: 'Kategori',
                task_assigned: 'Oppgave tildelt',
                task_sla_approaching: '[[TOK_0]] Nærmer seg',
                task_overdue: 'Oppgave forfalt',
                task_completed: 'Oppgave fullført',
                task_escalated: 'Oppgave eskalert',
                workflow_transition: 'Arbeidsflytovergang',
                approval_requested: 'Godkjenning forespurt',
                comment_added: 'Kommentar lagt til',
                weekly_digest: 'Ukentlig sammendrag',
                sla_breach_report: '[[TOK_0]] Rapport om brudd',
                system_alert: 'Systemvarsel',
            },
            channel: {
                platform: 'Plattform',
                email: 'Email',
            },
            quiet_hours: {
                title: 'Stille timer',
                start: 'Start',
                end: 'End',
                timezone: 'Tidssone',
            },
            digest: {
                title: 'Digest Frequency',
                daily: 'Daglig',
                weekly: 'Ukentlig',
                none: 'Ingen',
            },
            watched: {
                title: 'Så på Entities',
                empty: 'Ingen overvåkede enheter',
            },
            save: 'Lagre innstillinger',
            saving: 'Lagrer...',
            saved_success: 'Preferansene er lagret',
            load_error: 'Kunne ikke laste inn lagrede preferanser. Viser standardinnstillinger � endringer lagres når du klikker på Lagre.',
            enabled: 'Aktivert',
            disabled: 'Deaktivert',
            unwatch: 'Fjern se',
        },
        admin_queue: {
            title: 'Administrasjonskø for varsel',
            description: 'Overvak e-postleveringsstatus og prøv mislukka meldingar på nytt',
            load_error: 'Kunne ikkje lasta e-postkødata',
            retry_error: 'Kunne ikkje prøva e-post på nytt',
            filter_status: 'Filtrer etter status',
            all_statuses: 'Alle',
            refresh: 'Oppdater',
            status_queued: 'I kø',
            status_sent: 'Sendt',
            status_failed: 'Mislukka',
            status_bounced: 'Avvist',
            col_recipient: 'Mottakar',
            col_category: 'Kategori',
            col_template: 'Mal',
            col_status: 'Status',
            col_retries: 'Nye forsøk',
            col_created: 'Oppretta',
            col_sent: 'Sendt den',
            col_actions: 'Handlingar',
            no_items: 'Ingen e-postkøelement funne',
            retry: 'Prøv på nytt',
            retrying: 'Prøver på nytt...',
            prev: 'Førre',
            next: 'Neste',
            access_denied_title: 'Administratortilgang krevst',
            access_denied: 'Denne sida er berre tilgjengeleg for administratorar. Kontakt administratoren din om du treng tilgang.',
            announce_queue_loaded: 'E-postkø lastet, [[TOK_1]] elementer',
            announce_processed: 'Behandlet [[TOK_1]] e-post(er)',
            process_now: 'Behandle nå',
            processing_ellipsis: 'Behandler ⬦',
        },
    },
    ui_assist: {
        toolbar: {
            title: 'UI Assist',
            activate: 'Aktiver',
            deactivate: 'Deaktiver',
            connected: 'Tilkoblet',
            disconnected: 'Koblet fra',
            disconnected_hint: "Frakoblet � kjør 'npm run relay' for å koble til Claude CLI",
            open_panel: '�&pne UI Assist-panelet',
            history: 'Historie',
            settings: 'Innstillinger',
        },
        prompt: {
            placeholder: 'Beskriv endringen du vil gjøre...',
            send: 'Send',
            cancel: 'Avbryt',
            char_count: '[[TOK_2]] / [[TOK_3]]',
        },
        session: {
            streaming: 'Behandler ⬦',
            complete: 'Komplett',
            error: 'Feil',
            abort: 'Avbryt',
            abort_confirm: 'Er du sikker på at du vil abortere?',
            aborted_hint: '��kta vart avbroten � du kan halde fram herifrå.',
            undo: 'Angre',
            redo: 'Gjenta',
            retry: 'Prøv på nytt',
            dismiss: 'Avvis',
        },
        label: {
            component: 'Komponent',
            element: 'Element',
            file: 'Fil',
        },
        response: {
            you: 'You',
            claude: 'Claude',
            empty: 'Ingen meldinger ennå. Velg elementer og send en melding for å komme i gang.',
        },
        panel: {
            tab_conversation: 'Chat',
            tab_tasks: 'Oppgaver',
            tab_sprint: 'Sprint',
            tab_sessions: 'Sesjonar',
            tab_lobby: 'Lobbyen',
            follow_up: 'Følg opp',
            followup_placeholder: 'Still et oppfølgingsspørsmål...',
            interrupt_placeholder: 'Skriv for å avbryte og omdirigere⬦',
            send_interrupt: 'Send & Avbryt',
            will_interrupt: 'Avbryt det gjeldande svaret og send dette i staden',
            expand: 'Utvid til fullskjerm',
            collapse: 'Skjul til sidepanel',
            no_sessions: 'Ingen tidlegare sesjonar. Vel element og send ei melding for å starte.',
            session_active: 'Aktiv',
            session_ended: 'Avslutta',
            session_messages: '{count} meldingar',
            switch_session: 'Byt til denne sesjonen',
            load_session: 'Last inn økthistorikk',
            session_restored: 'Sesjon gjenopprettet fra historien',
            archive_session: 'Arkivøkt',
            archive_confirm: 'Vil du arkivere denne økten? Sesjonsfilen vil bli slettet.',
            new_session: 'Ny økt',
            new_session_desc: 'Bruk Aktiver for å velge et UI-element og starte en ny økt',
            start_new_session: 'Start ny økt',
            no_active_session_chat: 'Start en ny økt eller bruk Aktiver for å velge et UI-element på siden for å begynne.',
            no_active_session_tasks: 'Start en ny økt eller velg en eksisterende økt for å opprette oppgaver.',
            no_active_session_sprint: 'Start en ny økt eller velg en eksisterende økt for å planlegge en sprint.',
            previous_sessions: 'Tidligere økter',
        },
        tasks: {
            none_found: 'Finner ingen oppgaver i svaret. Be Claude foreslå oppgaver.',
            selected: 'selected',
            create_selected: 'Lag oppgaver',
            execute_tasks: 'Utfør oppgåver',
            creating: 'Oppretter ⬦',
            created: 'opprettede oppgaver',
            create_error: 'Kunne ikke opprette oppgaven',
            plan_sprint: 'Planlegg sprint',
            priority_critical_desc: 'Blokkerande � fiks umiddelbart',
            priority_high_desc: 'Viktig � løys i denne sprinten',
            priority_medium_desc: 'Normal � planlegg for kommande sprint',
            priority_low_desc: 'Kjekt å ha � backlog-kandidat',
            add_custom: 'Legg til oppgåve',
            add_title_placeholder: 'Oppgåvetittel⬦',
            add_desc_placeholder: 'Skildring (valfritt)',
            add_save: 'Legg til',
            add_cancel: 'Avbryt',
        },
        sprint: {
            title: 'Sprintplanlegger',
            assigned: 'assigned',
            new_placeholder: 'Sprintnavn (f.eks. Sprint 18.1.0)',
            add: 'Add',
            backlog: 'Etterslep',
            move_to: 'Flytt til...',
            empty: 'Opprett en sprintgruppe og tildel oppgaver til den.',
            create_all: 'Opprett alle oppgaver',
            remove: 'Fjern',
            drop_here: 'Tildel oppgaver fra backlog nedenfor',
            add_task: 'Legg til oppgave fra backlog...',
        },
        feature_disabled: 'UI Assist er ikke aktivert',
        permission_denied: 'Du har ikke tillatelse til å bruke UI Assist',
    },
    license: {
        title: 'Lisens og pakke',
        current_license: 'Gjeldende lisens',
        license_key: 'Lisensnøkkel',
        activate: 'Aktiver lisens',
        deactivate: 'Deaktiver lisens',
        validate_now: 'Bekreft nå',
        status: 'Lisensstatus',
        active: 'Aktiv',
        expired: 'Utløpt',
        suspended: 'Suspendert',
        invalid: 'Ugyldig',
        pending: 'Venter',
        no_license: 'Ingen lisens',
        expires_at: 'Utløper',
        last_validated: 'Sist validert',
        domain: 'Lisensiert domene',
        activation_success: 'Lisens aktivert.',
        activation_failed: 'Lisensaktivering mislyktes.',
        domain_mismatch: 'Lisensdomenet samsvarer ikke med gjeldende domene.',
        deactivation_success: 'Lisens deaktivert.',
        validation_success: 'Lisensen er validert.',
        validation_failed: 'Lisensvalidering mislyktes.',
        enter_key: 'Skriv inn lisensnøkkelen din',
        confirm_deactivate: 'Er du sikker på at du vil deaktivere denne lisensen? Modulbegrensninger vil gjelde basert på standardnivået.',
    },
    package_mgmt: {
        title: 'Pakke',
        module_column: 'Modul',
        current_tier: 'Gjeldende pakke',
        light: 'Lys',
        standard: 'Standard',
        enterprise_unlimited: 'Enterprise Unlimited',
        change_package: 'Endre pakke',
        upgrade: 'Oppgrader',
        downgrade: 'Nedgrader',
        target_tier: 'Målpakke',
        new_license_key: 'Lisensnøkkel for målpakke',
        confirm_change: 'Bekreft pakkeendring',
        change_success: 'Pakken ble endret.',
        change_failed: 'Pakkebytte mislyktes.',
        modules_included: 'Moduler inkludert',
        modules_restricted: 'Ikke tilgjengelig i gjeldende pakke',
        upgrade_to_enable: 'Oppgrader for å aktivere denne modulen.',
        module_availability: 'Modultilgjengelighet',
        comparison: 'Pakkesammenligning',
        power_users: 'Superbrukere',
        unlimited: 'Ubegrenset',
        impact_warning: 'Nedgradering vil deaktivere følgende moduler:',
        invalid_license: 'Den oppgitte lisensnøkkelen er ikke gyldig for denne pakken.',
        tier_mismatch: 'Lisensnøkkelen er for et annet pakkenivå.',
    },
    board_report: {
        title: 'Styrerapport om Samsvar',
        subtitle: 'Samandrag av samsvar på tvers av alle modular',
        date_from: 'Frå dato',
        date_to: 'Til dato',
        language: 'Rapportspråk',
        generate: 'Generer rapport',
        generating: 'Genererer rapport...',
        download_pdf: 'Last ned PDF',
        close: 'Lukk rapport',
        open_board_report: 'Generer styrerapport',
        close_board_report: 'Lukk styrerapport',
        report_period: 'Rapportperiode',
        generated_at: 'Generert den',
        generated_by: 'Generert av',
        organization: 'Organisasjon',
        section_rights_requests: 'Rettskrav',
        section_vendors: 'Leverandørar',
        section_dpias: 'DPIA-ar',
        section_consent: 'Samtykkepolicyer',
        section_data_mapping: 'Datakartlegging',
        section_incidents: 'Hendingar',
        section_classification: 'Dataklassifisering',
        section_governance: 'Styring',
        open: '�&pne',
        closed: 'Lukka',
        sla_compliance: 'SLA-samsvar',
        total: 'Totalt',
        expired_dpa: 'Utløpt DPA',
        high_risk: 'Høg risiko',
        completed: 'Fullført',
        overdue: 'Forseinka',
        policies_active: 'Aktive policyer',
        coverage: 'Dekning',
        systems: 'System',
        completeness: 'Fullstende',
        avg_resolution_days: 'Gjs. løysingstid (dagar)',
        labeled: 'Merka',
        unlabeled_systems: 'Umerka system',
        compliance_score: 'Samsvarspoeng',
        drift_events_open: 'Opne avvik',
        no_data: 'Ingen data tilgjengeleg for den valde perioden.',
        error_date_range: 'Vel både start- og sluttdato.',
        table_category: 'Kategori',
        table_metric: 'Metrikk',
        table_value: 'Verdi',
        showing_chart_view: 'Viser diagramvising',
        showing_table_view: 'Viser datatabellvising',
        error_generate: 'Styrerapport kunne ikkje genererast.',
        playbook_evidence_title: 'Prov for playbook-utføring',
        playbook_evidence_description: 'Utføringsaktivitet per playbook og vedlagde provfiler for rapportperioden.',
        playbook_name: 'Playbook',
        playbook_execution_count: 'Utføringar',
        playbook_steps_total: 'Steg',
        playbook_steps_required: 'Prov kravd',
        playbook_steps_attached: 'Prov vedlagt',
        playbook_coverage_pct: 'Dekning',
        playbook_evidence_files: 'Provfiler',
        playbook_no_evidence: 'Ingen playbook-utføringar i denne perioden.',
        playbook_download_file: 'Last ned fil',
    },
    framework_module_links: {
        title: 'Rammetilknyting',
        modules: 'Tilknytta modular',
        add_module: 'Legg til modul',
        module_code: 'Modulkode',
        required: 'Påkravd',
        notes: 'Notat',
        link: 'Lenkje',
        no_modules: 'Ingen modular tilknytta',
        personas: 'Tilknytta personar',
        add_persona: 'Legg til person',
        persona_id: 'Person-id',
        role_description: 'Rolleskildring',
        no_personas: 'Ingen personar tilknytta',
    },
    framework_channels: {
        title: 'Innleveringskanalar & Fristar',
        channels: 'Innleveringskanalar',
        add_channel: 'Legg til kanal',
        channel_type: 'Type',
        name: 'Namn',
        instructions: 'Instruksjonar',
        active: 'Aktiv',
        no_channels: 'Ingen innleveringskanalar konfigurert',
        portal: 'Portal',
        in_person: 'Personleg',
        postal: 'Post',
        email: 'E-post',
        add: 'Legg til',
        deadlines: 'Regelverksfristar',
        add_deadline: 'Legg til frist',
        label: 'Etikett',
        days: 'Dagar',
        day_type: 'Dagtype',
        calendar_days: 'Kalenderdagar',
        working_days: 'Arbeidsdagar',
        description: 'Skildring',
        no_deadlines: 'Ingen fristar konfigurert',
    },
    regulatory_updates: {
        title: 'Regelverksoppdateringar & Ramme-dashbord',
        coverage_dashboard: 'Ramme-dekning-dashbord',
        no_frameworks: 'Ingen rammeverk funne',
        framework: 'Rammeverk',
        status: 'Status',
        modules: 'Modular',
        templates: 'Malar',
        forms: 'Skjema',
        channels: 'Kanalar',
        deadlines: 'Fristar',
        pending: 'Ventande oppdateringar',
        updates: 'Regelverksoppdateringar',
        create_update: 'Opprett oppdatering',
        framework_id: 'Rammeverk-id',
        update_title: 'Tittel',
        description: 'Skildring',
        effective_date: 'Iverksetjingsdato',
        create: 'Opprett',
        no_updates: 'Ingen regelverksoppdateringar',
        impact: 'Verknad',
        assess: 'Vurder',
    },
    module_tips: {
        show_guide: 'Vis rettleiing',
        hide_guide: 'Skjul rettleiing',
        title: 'Modulveiledning',
        title_prefix: 'Modultips:',
        loading_aria: 'Lastar modultips',
        related_frameworks: 'Relaterte rammeverk',
        quick_start_label: 'Snøggstart',
        related_forms_note: 'Relaterte samsvarsskjema er tilgjengelege nedanfor � sjå etter Mẫu s�-merket for å identifisere offisielle vietnamesiske forskriftsskjema.',
        read_full_guide: 'Les hele veiledningen',
        view_full_requirements: 'Sjå alle krav',
        relevant_for: 'Relevant for',
        key_procedure: 'Nøkkelprosedyre',
        deletion_orchestration: 'Koordinering av dataslettingsførespurnader på tvers av system og leverandørar med verifiseringsarbeidsflyt og revisjonsspor.',
        rights_requests: 'Administrer førespurnader om registrerte sine rettar inkludert tilgang, sletting, retting og portabilitet. Påkravd under PDPL lov 91/2025 og GDPR.',
        consent: 'Administrer retningsliner og arbeidsflyter for samtykkeinnhenting. Påkravd for PDPL, e-handelslov og GDPR-samsvar.',
        consent_properties: 'Konfigurer samtykkeinnsamlingspunkt og CMP-integrasjonseigenskapar for web- og appsamtykke.',
        data_mapping: 'Kartlegg dataflyter i organisasjonen � behandlingsaktivitetar, system og grenseoverskridande overføringar.',
        data_mapping_registry: 'Oppretthold en per-felt beholdning av hvert persondataelement organisasjonen din har. Fest hvert element til en datakategori, overstyr sensitivitet eller oppbevaring når det er nødvendig, og importer fra regulatoriske registerinnsendinger ([[TOK_0]] persondatabeholdning) uten å miste operatørredigeringer.',
        data_mapping_ropa_completeness: 'Hygienerevisjon per felt av hver behandlingsaktivitet mot rammeverkets påkrevde ROPA-felt ([[TOK_1]], [[TOK_0]], dekret 165). Identifiser kritiske / høye / betingede feil før regulatorisk innsending og hopp rett inn i aktivitetsredigeringsprogrammet for å fikse hver enkelt.',
        assessments: 'Opprett og administrer personvernkonsekvensvurderingar (DPIA) og AI-systemrisikovurderingar. Påkravd under PDPL lov 91/2025 artikkel 24.',
        classification: 'Klassifiser og merk dataressursar etter sensitivitet, kategori og forskriftskrav.',
        incidents: 'Registrer og administrer tryggleikshendingar og databrot. Påkravd for brotvarsling under PDPL og cybersikkerheitslova.',
        incident_ops: 'Koordiner hendingshandteringsoperasjonar med playbook-aktiveringar, eskaleringsbanar og sanntids-koordineringsdashboards.',
        monitoring: 'Overvak samsvars-KPI-ar, programhelse og oppgåvefullføringsratar i heile organisasjonen.',
        vendor_risk: 'Vurder og administrer leverandørrisiko gjennom spørjeskjema, risikoporteføljar og samsvarsscoring.',
        governance: 'Administrer leverandørstyring, playbooks og tredjepartskrav for samsvar.',
        program_governance: 'Konfigurer programstyringa sine mognadsvurderingar, dashboardmålingar og rammeverk for samsvarsscoring.',
        discovery: 'Oppdag og inventariser dataressursar i organisasjonen med automatisert skanning og klassifiseringsarbeidsflyter.',
        discovery_cycles: 'Planlegg og køyr gjentakande oppdagingssyklusar som skannar system på nytt, viser delta-endringar og rutar funn gjennom gjennomgang, godkjenning og publisering.',
        connectors: 'Konfigurer integrasjonar og datakonnektorar for automatisert samsvarsdatainnsamling.',
        task_management: 'Administrer samsvarsoppgåver, tildelingar og fristar på tvers av team og modular.',
        audit_trail: 'Sjå og søk i det samla revisjonssporet for alle samsvarsaktivitetar og bevisinnsamling.',
        evidence_packs: 'Sett sammen, verifiser og send inn revisjonsbevispakker for overholdelse av forskrifter. Bevispakker samler revisjonshendelser etter rammeverk, enhetstype og tidsperiode til eksporterbare pakker for intern gjennomgang eller regulatorisk innsending.',
        audit_periods: 'Definer og administrer revisjonsrapporteringsperioder i henhold til regelverket. Revisjonsperioder setter tidsgrenser og oppbevaringspolicyer for bevisinnsamling og samsvarsrapporteringssykluser.',
        qs_evidence_pack: 'Sett sammen din første bevispakke',
        qs_audit_period: 'Opprett en revisjonsrapporteringsperiode',
        compliance_forms: 'Bla gjennom samsvarsskjemakatalogen og opprett skjemainstansar for forskriftsinnleveringar.',
        partner_workspace: 'Administrasjon av partnar- og forhandlararbeidsområde med avgrensa tilgang, samsvarsgjennomgangsarbeidsflyt og samarbeidsverktøy.',
        localization: 'Administrer forskriftsrammeverk, språkpakkar og lokaliseringsinnstillingar.',
        onboarding: 'Følg onboardingframgang, fullfør snøggstartar og følg personabaserte samsvarsbanar.',
        organizations: 'Administrer organisasjonsstruktur, avdelingar og multi-org-konfigurasjonar.',
        privacy_scanner: 'Overvak nettstaden sitt personvernsamsvar med automatisert skanning og problemdeteksjon.',
        access_accountability: 'Konfigurer tilgangsgjennomgangskampanjar og ansvarspolitikkar for datatilgangsstyring.',
        dashboard: 'Se oversikten over samsvarsoversikten med statusoppsummeringer i sanntid, rammeverksdekning og viktige overholdelsesberegninger.',
        platform: 'Administrer plattformsikkerhetsinnstillinger, inkludert [[TOK_0]]-nøkler, nødtilgang og SSO-konfigurasjon.',
        framework_vn_pdpl: 'VN Lov om vern av personopplysningar (PDPL)',
        framework_vn_cybersecurity: 'VN Cybersikkerheitslov',
        framework_vn_ecommerce: 'VN E-handelslov',
        framework_vn_ai_law: 'VN AI-lov',
        framework_vn_telecom: 'VN Telekommunikasjonslov',
        framework_vn_banking_circular_83: 'VN Banking Circular [[TOK_0]] � Internt kontrollsystem',
        framework_gdpr: 'EU GDPR',
        cross_framework: 'På tvers av rammeverk � støttar alle regulatoriske samsvarsaktivitetar',
        qs_dpia_filing: 'Fullfør den fyrste DPIA-innleveringa di',
        qs_dept_compliance: 'Send inn den fyrste avdelingssamsvarseksjonen din',
        qs_ecommerce_consent: 'Konfigurer samtykkeinnhenting for e-handel',
        qs_telecom_data: 'Set opp handtering av telekommunikasjonsabonnentdata',
        qs_data_flow: 'Kartlegg den fyrste dataflyten din',
        qs_incident_response: 'Konfigurer arbeidsflyt for hendingshandtering',
        qs_ai_risk: 'Køyr ei AI-systemrisikovurdering',
        qs_cross_border: 'Vurder ei grenseoverskridande dataoverføring',
        qs_breach_notification: 'Simuler ein brotvarslings-arbeidsflyt',
        qs_audit_trail: 'Gå gjennom eit samsvarsrevisjonsspor',
        procedure_data_deletion_fulfillment: 'Gjennomføring av datasletting',
        procedure_cross_system_deletion: 'Sletting på tvers av system',
        procedure_dsar_intake: 'Mottak av førespurnader frå registrerte',
        procedure_cmp_property_config: 'CMP-eigenskapskonfigurasjon',
        procedure_consent_collection: 'Politikk for innhenting av samtykke',
        procedure_ropa_filing: 'Innlevering av behandlingsaktivitetar',
        procedure_cross_border_assessment: 'Vurdering av grenseoverskridande dataoverføring',
        procedure_data_classification: 'Dataklassifisering',
        procedure_breach_notification: 'Varsling om databrot',
        procedure_incident_timeline: 'Sporing av hendingsforløp',
        procedure_playbook_escalation: 'Eskalering via handlingsplan',
        procedure_compliance_kpi_monitoring: 'Overvaking av samsvars-KPI',
        procedure_vendor_risk_assessment: 'Leverandørrisikovurdering',
        procedure_transfer_mechanism_review: 'Gjennomgang av overføringsmekanisme',
        procedure_program_maturity: 'Vurdering av programmodnad',
        procedure_data_discovery: 'Oppdaging av dataeigedommar',
        procedure_connector_setup: 'Oppsett og konfigurasjon av koplingar',
        procedure_task_assignment: 'Oppgåvetildeling og delegering',
        procedure_audit_evidence: 'Innsamling av revisjonsbevis',
        procedure_form_submission: 'Innsending av samsvarsskjema',
        procedure_partner_onboarding: 'Arbeidsflyt for partnar-onboarding',
        procedure_partner_access: 'Partnartilgang og løyve',
        procedure_framework_pack_install: 'Installasjon av rammeverks-pakke',
        procedure_language_pack_deploy: 'Utrulling av språkpakke',
        procedure_org_onboarding: 'Oppsett av organisasjons-onboarding',
        procedure_multi_org_config: 'Multiorganisasjonskonfigurasjon',
        procedure_privacy_scan: 'Skanning av personvernsamsvar',
        procedure_access_review: 'Kampanje for tilgangsgjennomgang',
        procedure_dpia_filing: 'DPIA-innleveringsprosess',
        security: 'Plattformsikkerhetskonfigurasjon: [[TOK_0]] nøkkeladministrasjon, sesjonspolicyer, MFA-håndhevelse, SSO-integrasjon, IP-godkjenningslister og krisetilgangskontroller.',
        settings: 'Plattformomfattende konfigurasjon: varslingspreferanser, domeneadministrasjon, eksportplaner og modulkonfigurasjon for organisasjonen din.',
        users: 'Brukerkontoadministrasjon: opprett og administrer brukerkontoer, tildel roller, konfigurer avdelingsmedlemskap og spor påloggingsaktivitet.',
        roles: 'Rolle- og tillatelsesadministrasjon: definer egendefinerte roller, konfigurer granulære tillatelser per modul, og håndhev separasjonspolicyer.',
        profile: 'Dine personlige profilinnstillinger: visningsnavn, kontaktdetaljer, språkpreferanser, modulguidepreferanser, tilgjengelighetsalternativer og passordbehandling.',
        consent_properties_bindings: 'Administrer samtykkepolicybindinger på tvers av digitale eiendommer. Spor hvilken policyversjon som er distribuert til hver eiendom, identifiser utdaterte bindinger og koordiner policyutrulling.',
        consent_properties_templates: 'Gylden maladministrasjon: definer standard konfigurasjoner for samtykke, sammenlign egenskaper med maler, og rull ut malendringer på tvers av eiendomsgrupper.',
        consent_properties_compliance: 'Overvåking av samtykkeoverholdelse: oppdage konfigurasjonsinkonsekvenser mellom egenskaper og gylne maler, administrer endringsforespørsler gjennom godkjenningsarbeidsflyter, og generer bevispakker for revisjonsberedskap.',
        consent_properties_operations: 'Driftsadministrasjon for samtykkeegenskaper: konfigurer automatiserte øyeblikksbildeplaner, organiser eiendommer i grupper og gjennomgå revisjonssporet for samtykkeegenskapene.',
        consent_properties_audit: 'Godkjenningseiendomsrevisjon og analyser: gjennomgå konfigurasjonsendringshistorikk, analyser eiendomsoverholdelsestrender og generer samsvarsrapporter for forskriftsgjennomgang.',
        classification_taxonomies: 'Definer og administrer dataklassifiseringstaksonomier med sensitivitets- og viktighetsdimensjoner. Konfigurer klassifiseringsnivåer, håndteringskrav og [[TOK_0]] risikonivåer.',
        classification_labeling: 'Bruk klassifiseringsetiketter på dataressurser. Send inn etiketter for gjennomgang, administrer masseklassifisering og spor merkestatus på tvers av databeholdningen din.',
        classification_lifecycle: 'Spor livssyklusen til klassifiserte dataressurser gjennom stadier: utkast, aktiv bruk, under vurdering, arkivering og venter på sletting. Overvåk oppbevaringsperioder og utløs arbeidsflyter for sletting.',
        classification_gaps: 'Oppdag og administrer klassifiseringshull på tvers av databeholdningen din. Kjør gapdeteksjon for å identifisere umerkede eiendeler og manglende livssyklustilordninger, og spor deretter utbedring.',
        classification_reviews: 'Administrer klassifiseringsgjennomgangsoppgaver med eskaleringstidtakere. Gjennomgå foreslåtte etiketter, håndter unntak og sørg for rettidige klassifiseringsbeslutninger.',
        incidents_breach: 'Administrer varsler om datainnbrudd og myndighetsrapportering. Opprett varslingspakker, spor regulatoriske tidsfrister og dokumenter hele tidslinjen for bruddsvar.',
        incidents_authority: 'Håndtere formelle myndighetsforespørsler fra reguleringsorganer. Spor innkommende forespørsler, sett sammen bevispakker, administrer verifikasjonssjekklister og overhold svarfrister.',
        incidents_disclosure: 'Opprettholde det sentraliserte opplysningsregisteret for all kommunikasjon med tilsynsmyndigheter. Registrer avsløringsdatoer, kanaler, mottakere og innholdssammendrag for overholdelse av revisjonsspor.',
        incidents_reports: 'Generer og administrer hendelsesrapporter for intern gjennomgang og forskriftsinnsending. Lag detaljerte hendelsessammendrag, spor rapportstatus og eksporter dokumentasjon for myndighetsarkivering.',
        incidents_tasks: 'Koordinere hendelsesreaksjonsoppgaver på tvers av team. Lag oppgavesjekklister, tilordne eiere, spor prioriteringer og avhengigheter, eskaler blokkerte elementer og overvåk fullføringsfremdriften.',
        incidents_supplements: 'Administrer tilleggsdokumentasjon forespurt av regulatoriske myndigheter etter første varsel om brudd. Spor forespørsler om tillegg, klargjør svarpakker og overvåk innsendingsfrister.',
        incidents_remediation: 'Spor korrigerende handlinger tildelt avdelinger og brukere for å løse årsaken til og virkningen av hendelser. Overvåk implementeringsfrister, verifiser fullføring og dokumenter utbedringsbevis.',
        incident_ops_playbooks: 'Lag og administrer lekebøker for respons på hendelser. Definer eskaleringsbaner, tildel responsteam og aktiver spillebøker under direktehendelser.',
        incident_ops_sla: 'Spor SLA-er for respons på hendelser og regulatoriske tidsfrister. Overvåk overholdelse av lovpålagte varslingstidslinjer og mål responsytelsesmålinger.',
        incident_ops_evidence: 'Vedlikeholde beviskjeder for hendelser og gjennomgang etter hendelsen. Generer regulator-klare eksportpakker med fullstendig hendelsesdokumentasjon.',
        data_mapping_systems: 'Registrer og administrer systemer som behandler personopplysninger. Dokumenter systemeierskap, datakategorier, behandlingsformål og samsvarsscoring.',
        data_mapping_flows: 'Kartlegge dataflyter mellom systemer, inkludert grenseoverskridende overføringer. Dokumenter databevegelsesbaner, overføringsmekanismer og mottakerjurisdiksjoner.',
        data_mapping_activities: 'Dokumentere behandlingsaktiviteter og generere Records of Processing Activities (RoPA). Koble aktiviteter til juridiske grunnlag, formål og datakategorier.',
        data_mapping_governance: 'Administrer datastyringsoppdrag, attestasjonssykluser og risikovurderinger. Spor eierskap og gjennomgå tidsplaner på tvers av databeholdningen din.',
        data_mapping_reference: 'Administrer referansedata for datakartlegging: datakategorier, behandlingsformål, oppbevaringspolicyer og eksportkonfigurasjoner.',
        data_mapping_categories: 'Administrer datakategorikatalogen: navn, sensitivitetsnivåer, eksempler og tagger. Grunnlag for hver klassifiserings- og kartleggingsaktivitet.',
        data_mapping_purposes: 'Katalogbehandlingsformål med deres juridiske grunnlag. Brukes av ROPA, [[TOK_0]], og lovlighetsrevisjoner.',
        data_mapping_retention: 'Konfigurer oppbevaringspolicyer, avhendingsmetoder og gjennomgå tråkkfrekvens. Er i tråd med dekret 13/2023 og dekret 356/2025.',
        data_mapping_exports: 'Eksporter ROPA, systemer, formål og kategorier til [[TOK_0]], [[TOK_3]], [[TOK_2]], eller [[TOK_1]]. All eksport lander i plattformen File Browser.',
        data_mapping_attestation: 'Planlegg og overvåk dataattesteringssykluser. Spor fullføring av attester på tvers av databeholdningen din.',
        data_mapping_review: 'Klassifiseringsgjennomgangskø: gjennomgangsoppgaver, kvalitetssignaler og godkjenningsstatus.',
        data_mapping_risk: 'Risikovurdering for behandlingsaktiviteter: scoringsrammer, avbøtende planer og effektivitetssporing.',
        data_mapping_evidence: 'Bevis knyttet til behandlingsaktiviteter: sikkerhetssertifikater, DPA-kontrakter, [[TOK_0]] rapporter.',
        data_mapping_inventory: 'Klassifikasjonsbeholdningsoversikt: tagger, sensitivitetsnivåer og organisasjonsomfattende distribusjon.',
        data_mapping_exceptions: 'Unntaksregister for klassifiseringer: begrunnelse, godkjenner, gyldighetsvindu og utbedringsvei.',
        data_mapping_history: 'Klassifiseringsendringshistorikk: hvem endret hva, når og hvorfor.',
        access_accountability_logs: 'Sanntidsstrøm av begivenheter med privilegert tilgang. Koble sammen med policysiden for å definere hvem som kan nå hver datasone; par med undersøkelser for å følge opp avvik.',
        access_accountability_policies: 'Utarbeiding av tilgangssonepolicy: erklær hvilke roller og brukere som kan nå hver datasone, med tidsbegrensede unntak. Driver håndhevingen sjekker den overflaten i loggene.',
        access_accountability_anchoring: 'Forankringssikker forankring av tilgangsloggen til en hasjkjede. Kreves for VN Cybersecurity Law revisjonsspor integritet.',
        access_accountability_investigations: 'Saksarbeidsområde for å undersøke mistenkelige tilgangshendelser. Tidslinje, koblede logger, bevispakker og arbeidsflyt for saksavslutning i én visning.',
        assessment_triggers: 'Regler som automatisk åpner en [[TOK_0]]- eller dokumentarkivering når oppstrømsendringer (ny behandlingsaktivitet, ny leverandør, ny grenseoverskridende flyt) oppfyller utløserbetingelsen.',
        connectors_gap_register: 'Katalog over uimplementerte eller delvise koblinger. Triage elementer, tilordne eiere, spor lukking av gap over veikartet.',
        connectors_system_inventory: 'Beholdning av hvert system tilgjengelig via en kobling. Enkelt kilde til sannhet for datakartet.',
        connectors_traceability: 'End-to-end linje av et dataelement på tvers av systemer koblet gjennom koblinger. Viktig for ROPA-nøyaktighet og oppfyllelse av emneforespørsel.',
        consent_properties_change_requests: 'Pipeline med foreslåtte endringer i en samtykkeegenskap (tillagt formål, nytt språk, oppdatert policy-lenke). Styringsgjennomgang før produksjonsutrulling.',
        consent_properties_comparison: 'Side-ved-side-sammenligning av formen på samtykkeegenskapen på tvers av domener eller distribusjoner. Flaggdrift som vil svekke håndhevbarheten.',
        governance_playbooks: 'Playbook-maler som driver repeterbare styringsarbeidsflyter (leverandørintroduksjon, DPA-gjennomgang, overføringsvurdering).',
        incident_ops_coordination: 'Dashboard for koordinering på tvers av team for en aktiv hendelse. Ett sted å se hvem som er på den, hva de gjør og hva som er blokkert.',
        incident_ops_escalation: 'Eskaleringslogg for aktive hendelser. Alvorlighetsoverganger, interessentvarslinger og lederbeskrivelser er registrert her.',
        incident_ops_post_review: 'Gjennomgang etter hendelsen: rotårsaksanalyse, tidslinje, utbedringshandlinger og lærdom. Mater inn i trenings- og lekebokoppdateringer.',
        incident_ops_regulator_exports: 'Generer innsendingspakker for regulatorer for meldepliktige hendelser. Mẫu s� 08 (brudd) + pakke med støttende bevis.',
        incident_ops_vendor_coordination: 'Koordiner svar med leverandøren hvis system ble brutt. Kontraktsforpliktelser, SLA-er for svar og delt beviskjede.',
        monitoring_authority_readiness: 'Sjekkliste for beredskap og bevispakke for kommende regulatorbesøk. Konsolidert oversikt over utestående hull og fullførte kontroller.',
        monitoring_change_review: 'Periodisk gjennomgang av kontrollendringer på tvers av overvåkingsprogrammet. Oppdager drift før det blir et samsvarsgap.',
        monitoring_framework_link: 'Koble overvåkingskontroller til spesifikke regelverksartikler. Genererer beviskartet regulatorer forventer.',
        monitoring_ric: 'Regulatoriske henvendelser og korrespondansesaker. Spor spørsmål og svar fra regulatoren over tid.',
        forms: 'Forskriftsskjemakatalog, skjemautfyller, skjemaforekomster og lenker for innleveringssaker. Ryggraden for Mẫu s� 02a/02b og relaterte innleveringer.',
        monitoring_tasks: 'Overvåkingsoppgavekø: planlagte kontrollverifikasjoner, attester og bevisoppdateringer.',
        partner_workspace_reports: 'Rapporter delt på tvers av partnernettverket: overholdelseshelse, månedlige sammendrag, beregninger på tvers av organisasjoner.',
        partner_workspace_tickets: 'Støttebilletter samlet inn mellom partnere på delte arbeidsflyter og eskaleringer.',
        program_governance_audit_readiness: 'Revisjonsberedskapsscoring med drill-down i manglende bevis, gapregister og saneringseiere.',
        program_governance_drafting: 'Arbeidsområde for dokumentutkast med versjonsstyring, gjennomgangsruting og godkjenningsarbeidsflyt.',
        program_governance_evidence_gaps: 'Evidence-gap register: hvilke kontroller som mangler nåværende bevis og når oppdateringen skal skje.',
        program_governance_executive_summaries: 'Sammendragsmaler med automatisk utfylte KPIer for styre- og lederbriefinger.',
        program_governance_health: 'Overordnet programhelsedashbord: modenhet, dekning og trendindikatorer.',
        program_governance_issuance: 'Dokumentutstedelsesarbeidsflyt: godkjenning, publisering, interessentvarsling.',
        program_governance_model: 'Driftsmodell for styring: roller, ansvar, utvalg og beslutningsrettigheter.',
        program_governance_remediation: 'Utbedringsplaner knyttet til identifiserte hull. Eier, frist, status og bekreftelsesbevis.',
        program_governance_review_cadence: 'Planlagt gjennomgang for styringsartefakter: retningslinjer, prosedyrer, kontroller, bevis.',
        program_governance_trends: 'Trenddashbord: modenhet over tid, bevisfrihet, lukkingshastighet.',
        task_management_conflicts: 'Oppdag motstridende oppgaveoppdrag (dobbeltbookede eiere, overlappende tidsfrister) og løs via omtildeling.',
        task_management_consolidation: 'Konsolider oppgaver som er automatisk generert av flere moduler i én enkelt arbeidsflyt for tilordnet.',
        localization_dashboard: 'Oversikt over lokaliseringsmoduler: rammekataloghelse, pakkestatus, oversettelsesdekning og ventende forskriftsoppdateringer i ett dashbord.',
        localization_frameworks: 'Katalog for regelverk: [[TOK_1]], dekret 13/2023, dekret 356/2025, lov om nettsikkerhet og [[TOK_0]]. Hvert rammeverk kobler artikler til plattformkontroller.',
        localization_framework_channels: 'Innsendingskanaler for regulatorer knyttet til hvert rammeverk ([[TOK_1]]-portal, [[TOK_0]] endepunkt, autoritets-e-post). Driver ruting av Mẫu s�-filer.',
        localization_framework_detail: 'Enkeltramme detaljvisning: artikler, prosedyrer, personas, koblede skjemaer og implementeringsdybde på tvers av plattformen.',
        localization_framework_module_links: 'Rammeverk �  moduldekningskart. Hvilke forskriftsartikler håndheves av hvilken plattformmodul.',
        localization_language_packs: 'Språkpakkekatalog på tvers av 16 lokaliteter: installasjonsstatus, fullstendig oversettelse og innsendingshistorikk.',
        localization_audit: 'Revisjonsspor for lokaliseringsendringer: rammeverksredigeringer, pakkeoppdateringer, innsendingshendelser.',
        localization_market_packs: 'Markedspakkekatalogbundlingramme + språk + skjemaer per marked (VN, EU-medlemsstater, etc.).',
        localization_module_mappings: 'Modulkartleggingsregister: hvilken rammeartikkel som gjelder for hvilken modul på funksjonsnivå.',
        localization_pack_detail: 'Enkeltpakke detaljvisning: versjon, rammer inkludert, oversettelsesstatus, installasjonshistorikk.',
        localization_pack_submissions: 'Pakkeinnsendingspipeline: partnerinnleveringer, vurderingstilstander, publikasjonsgodkjenninger.',
        localization_regulatory_updates: 'Forskriftsoppdateringsfeed: nye dekreter, endringer og veiledning som påvirker rammekatalogen.',
        localization_sector_overlays: 'Sektoroverleggskatalog: valgfrie bransjespesifikke reguleringspakker (f.eks. bank, helsevesen). Installer i Direkte-modus for organisasjoner innenfor omfanget eller Referansemodus for synlighet på tvers av sektorer.',
        localization_help_content_packs: 'Help-Content Pack manager: installer, versjoner og oversett hjelpeartiklene i appen, modulveiledningene og hurtigstartene som dukker opp i administrasjonsgrensesnittet.',
        localization_translation_preview: 'Live forhåndsvisning av UI-strenger på tvers av lokaliteter. Side-ved-side sammenligning for QA for oversettelse.',
        organizations_groups_create: 'Opprett en ny organisasjonsgruppe (koncern): velg rotorganisasjon, velg medlemmer, definer arvemodus per kategori.',
        organizations_groups_detail: 'Enkeltorganisasjonsgruppedetaljer: medlemmer, arvematrise, delte ressurser og revisjonssammendrag.',
        organizations_groups_settings: 'Innstillinger for organisasjonsgruppe: [[TOK_0]], kalender, varsler, inntak, [[TOK_1]] integrasjon. Bytte for arv/overstyring per kategori.',
        organizations_groups_audit: 'Per-gruppe revisjonslogg: medlemskapsendringer, arving veksler, delt ressurs legg til/fjern.',
        organizations_groups_consolidated_audit: 'Konsolidert revisjonsvisning på tvers av alle medlemsorganisasjoner i en gruppe. Filtrer etter enhet, skuespiller, tidsvindu.',
        organizations_groups_dashboard: 'Dashboard på tvers av medlemmer: overholdelseshelse, åpne elementer, [[TOK_0]] brudd rullet opp for hele gruppen.',
        organizations_groups_reports: 'Rapporter på gruppenivå: sammendrag av ledere, sammenstilling av regulatorer, sammenligning på tvers av medlemmer [[TOK_0]].',
        organizations_groups_users: 'Brukere som er synlige på tvers av gruppen: rolletilordninger på tvers av organisasjoner, delte administratorer, etterligningskjede.',
        organizations_groups_merged_vendors: 'Deduplisert leverandørvisning på tvers av medlemsorganisasjoner � en enkelt leverandør vises én gang selv om den er ombord separat.',
        organizations_groups_shared_templates: 'Skjemamaler publisert på gruppenivå. Medlemmer velger å arve en mal; framelding er per organisasjon.',
        organizations_groups_shared_frameworks: 'Regelverk deles på tvers av gruppen. Sentral oppdatering flyter til hvert medlem med mode=inherit.',
        organizations_groups_shared_vendors: 'Leverandørregister på gruppenivå. Kontrakt, DPA-status og risikopoeng er synlig for hvert medlem.',
        onboarding_help_center: 'Hjelpesenter: bla gjennom alle 309+ artiklene etter modul, kategori og persona. Fulltekstsøk på tvers av EN + VI-innhold.',
        onboarding_progress: 'Onboarding fremdriftsporer: hvilke start-trinn er fullført, hvilke venter, hvem som eier blokkeringene.',
        onboarding_personas: 'Personadrevne ombordreiser for de 10 VN-rollene (P-VN-01 til og med P-VN-10). Hver reise er en kuratert liste over første handlinger.',
        onboarding_quick_starts: 'Hurtigstartscenarier: Kjør en komplett overholdelsesarbeidsflyt ende-til-ende i sandkassen. Ideell for trening.',
        onboarding_sample_data: 'Eksempeldatagenerator: last inn realistiske demo-rader i hvilken som helst modul. Nyttig for salgsdemoer og opplæring.',
        onboarding_tours: 'Interaktive guidede turer. Start en modulspesifikk gjennomgang som forteller hver side mens du navigerer.',
        security_sessions: 'Livevisning av autentiserte økter: enhet, IP, siste aktivitet, MFA-faktor brukt. Avslutt med ett klikk.',
        security_api_keys: 'Tjenestekonto [[TOK_0]]-nøkler: omfang, rotasjon, sist brukt og revisjonsspor per nøkkel.',
        security_break_glass: 'Emergency break-glass-tilgang: tidsbegrenset superadmin-bevilgning med obligatorisk revisjonsspor og gjennomgang etter hendelsen.',
        security_delegations: 'Midlertidige rolledelegeringer: dekning utenfor kontoret, godkjenningskjeder, automatisk utløp.',
        security_ip_allowlist: 'Konfigurasjon av IP-godkjenningsliste: begrense admin-pålogging til bestemte bedriftsnettverk eller VPN-områder.',
        security_mfa: 'Flerfaktorautentiseringspolicy: håndhevelse per rolle, faktortillatelsesliste (TOTP/SMS/WebAuthn), tilbakestill flyt.',
        security_service_accounts: 'Tjenesten står for system-til-system-integrasjon. Omfanget, revidert og rotert separat fra menneskelige brukere.',
        security_session_settings: '��ktpolicy: inaktiv tidsavbrudd, maks. øktsalder, grense for samtidige økter, utløsere for ny autentisering.',
        security_sso: 'Konfigurasjon av enkeltpålogging: SAML / OIDC-leverandører, attributtkartlegging, regler for automatisk klargjøring.',
        rights_requests_create: 'Opprett en ny sak om rettigheter for datasubjekter. Fanger forespørselsidentitet, forespørselstype, kanal og [[TOK_0]] klokkestart.',
        rights_requests_list: 'Alle rettighetsforespørselssaker med [[TOK_0]] nedtelling, mottaker, status og filterbrikker for kanal + forespørselstype.',
        rights_requests_detail: 'Enkeltsaksarbeidsområde: korrespondanse, oppfyllelseshandlinger, bevis, utforming av svar, [[TOK_0]] overganger.',
        rights_requests_cmp_sync: '[[TOK_0]] synkroniseringsinnstillinger for integrering: webhook-endepunkt, regler for oppretting av automatisk sak, policy for forsøk på nytt.',
        rights_requests_extensions: '[[TOK_0]] utvidelsesforespørsler: begrunnelse, godkjennerruting og registrering av revisjonsspor ved tildeling/avslag.',
        rights_requests_fulfillment: 'Forespørselsoppfyllingsarbeidsområde: samle datapakker, ta i bruk redaksjoner, pakke for levering.',
        rights_requests_responses: 'Svarutkast med malinnsetting, flettefelt og side-ved-side EN/VI forhåndsvisning.',
        rights_requests_response_templates: 'Svarmalkatalog: godkjente maler per forespørselstype + jurisdiksjon, med versjonshistorikk.',
        compliance_forms_consolidation_create: 'Opprett en ny konsolideringssak: grupper relaterte skjemainnsendinger under én enkelt innleveringspakke beregnet på én regulator.',
        compliance_forms_consolidation_detail: 'Enkeltkonsolideringssaksarbeidsområde: seksjonsinndata, godkjenninger av anmeldere, eksport av hele dokumentasjonen til regulatoren.',
        compliance_forms_consolidation_cases: 'Alle konsolideringssaker med arkivstatus, anmelderoppdrag og tidsfristsporing.',
        compliance_forms_consolidation_review: 'Gjennomgå arbeidsområdet for konsolideringssaker: godkjenn seksjonsinndata, be om revisjoner, logg av før eksport.',
        compliance_forms_dossier_export: 'Eksporter den konsoliderte dokumentasjonen som en regulator-klar [[TOK_0]]-pakke med følgebrev, vedlegg og signaturer.',
        compliance_forms_section_input: 'Avdelingseier arbeidsområde for å fullføre en enkelt del av en konsolideringssak.',
        compliance_forms_filing_case_links: 'Koblinger mellom skjemainstanser og arkivsaker. Sikrer at hver arkivering er støttet av de riktige skjemadataene.',
        compliance_forms_section_routing: 'Seksjonsrutingsregler: hvilken avdeling eier hvilken seksjon av hver skjemamal.',
        assessments_dashboard: 'Vurderingsoversikt: [[TOK_0]] telling, overføringsvurderinger, gap-sammendrag, kommende gjennomgangsfrister.',
        assessments_dossier_filing_detail: 'Enkelt dossierarkivering: skjematype (Mẫu s� 02a/02b), seksjonsoppgaver, seksjonsstatus, innleveringsdetaljer, [[TOK_0]] tidtakere.',
        assessments_dossier_filing_list: 'Alle dossierinnleveringer med skjematype, status og seksjonsoppdragsfremdrift. Filtrer etter status og rammeverk.',
        assessments_dpia_list: '[[TOK_0]] register: alle pågående, godkjente og arkiverte databeskyttelseskonsekvensvurderinger.',
        assessments_gap_report: 'Gap-rapport: [[TOK_0]] dekning, uklassifisert [[TOK_1]] krav, ubegrenset risiko, manglende registreringer. Primær revisjonsberedskapsoverflate.',
        assessments_transfer_list: 'Overføringsvurderinger for grenseoverskridende datastrømmer. Hver vurdering dokumenterer mekanisme, sikkerhetstiltak og risikovurdering.',
        deletion_orchestration_templates: 'Sjekklistemaler for slettingskjøringer. Hver mal er en skriptsekvens av oppgaver knyttet til spesifikke systemer og oppbevaringsregler.',
        deletion_orchestration_dsr_integration: 'DSR-til-sletting-integrasjon: utløser automatisk en slettingskjøring fra en godkjent sletteforespørsel.',
        deletion_orchestration_tasks: 'Utførelsesoppgaver for aktive slettingskjøringer. Hver oppgave sporer system-, handlings-, eier- og verifikasjonsbevis.',
        deletion_orchestration_dashboard: 'Oversikt over sletting av orkestrering: aktive kjøringer, fullføringsgrad, ventende verifikasjoner, korrekturkjedefriskhet.',
        deletion_orchestration_proof_chain: 'Inngrepssikker kjede for hver slettingshandling. Nødvendig for [[TOK_0]] samsvar ved sletting.',
        organizations_compliance_rollup: 'Samsvarssamsvar på tvers av enheter: [[TOK_0]] etter enhet, dekning på rammenivå, utestående forpliktelser.',
        organizations_departments_admin: 'Administratorarbeidsområde for avdelinger: opprett, tilordne eiere på nytt, administrer teammedlemskap, angi rutingsregler.',
        organizations_departments: 'Avdelinger liste på tvers av enheter. Driver seksjonsruting, godkjenningsflyter og bevisattribusjon.',
        organizations_entity_frameworks: 'Tilordne regulatoriske rammer til hver enhet. Drives som Mẫu s�-skjemaer gjelder og hvilke revisjoner som er obligatoriske.',
        organizations_entity_form: 'Opprett eller rediger en enkelt organisasjonsenhet: juridisk navn, bedriftsregistrering, adresse, representant.',
        organizations_list: 'Alle organisasjonsenheter på tvers av leietakeren. Primær listevisning med statusfiltre og hurtigtilgangshandlinger.',
        organizations_retention_policies_admin: 'Administrasjon av oppbevaringspolicy dekket av organisasjonen: standardregler, per-enhetsoverstyringer.',
        task_management_calendar: 'Kalendervisning av oppgaver og tidsfrister. Fargekodet etter modul og [[TOK_0]] tilstand.',
        task_management_my_tasks: 'Personlig oppgavekø: tildelt meg, forfaller snart, forfaller. Primær daglig arbeidsplass.',
        task_management_overdue: 'Forfalte oppgaver på tvers av organisasjonen. Filtrerer etter eier, modul og forfalte dager.',
        task_management_section_assignments: 'Seksjonsoppdragsoversikt: hvilken avdeling som eier hvilken del av hver aktive skjemainnlevering.',
        task_management_board: 'Kanban tavlevisning av oppgaver. Dra mellom kolonnene (Gjøremål / Pågår / Gjennomgang / Ferdig) for å oppdatere status.',
        task_management_detail: 'Enkeltoppgavearbeidsområde: beskrivelse, kommentarer, vedlegg, underoppgaver, revisjonsspor, statusoverganger.',
        task_management_list: 'Flat liste over alle oppgaver med filtre: eier, modul, status, prioritet, forfallsdatoområde.',
        consent_cmp_sync: '[[TOK_0]] synkroniseringsarbeidsområde: utløs synkroniseringer, se gjennom synkroniseringshistorikk, inspiser feil. Holder tilstanden [[TOK_1]] på linje med plattformen.',
        consent_cmp_bulk_sync: 'Bulk [[TOK_0]] synkronisering: synkroniser alle samtykkeposter på nytt på tvers av alle eiendommer. Brukes til leietakermigreringer og store [[TOK_1]] endringer.',
        consent_cmp_integration: '[[TOK_0]] integrasjonsinnstillinger: endepunkt, autentisering, synkroniseringspolicy og tilkoblingshelse.',
        consent_cmp_purpose_mapping: 'Kartlegg [[TOK_0]] formål til plattformformål. Sikrer at samtykkesignaler flyter riktig mellom de to systemene.',
        consent_cmp_webhook: '[[TOK_0]] webhook-konfigurasjon: ruting av innkommende hendelser, signering av hemmeligheter, policy for forsøk på nytt.',
        partner_workspace_brand_profiles: 'Partnermerkeprofiler: logo, slagord, kontakt, tjenestetilbud. Driver oppføringen for partnermarkedsplassen.',
        partner_workspace_deliverable_templates: 'Leverbar malkatalog: standardiserte tjenestepakker partnere kan tilby ([[TOK_0]] gjennomgang, leverandørrevisjon, opplæring).',
        partner_workspace_deliverables: 'Aktive leveranser på tvers av partnerengasjementer. Sporomfang, forfallsdatoer, akseptkriterier.',
        partner_workspace_service_tiers: 'Tjenestenivådefinisjoner: Bronse / Sølv / Gull med omfang, [[TOK_0]], og prisbånd.',
        partner_workspace_workflow_instances: 'Aktive arbeidsflytforekomster på tvers av partnere: onboarding, gjennomgang, eskalering, offboarding-kjøringer.',
        partner_workspace_workflow_templates: 'Arbeidsflytmalkatalog for partnerengasjementer. Hver mal definerer trinn, eiere, SLAer og utganger.',
        access_accountability_justification_reviews: 'Gjennomgå tilgangsbegrunnelser som er sendt inn av brukere. Godkjenn, utfordre eller eskaler retningslinjene per sone.',
        access_accountability_review_campaigns: 'Planlagte tilgangsvurderingskampanjer: gjentakelse, omfang, anmelderoppdrag, fullføringssporing.',
        access_reviews_list: 'Alle tilgang-anmeldelseskampanjer med filtre: syklus, status, anmelder, målsystem.',
        access_reviews_campaign_detail: 'Enkeltkampanjearbeidsområde: omfang, anmeldere, varekø, sertifiseringsstatus, revisjonsspor.',
        access_reviews_my_reviews: 'Anmeldelser tildelt meg: avgjørelser som venter med kontekst, bekrefte eller tilbakekalle per vare.',
        attestation_schedules_list: 'Attestasjonsplanregister: gjentakelse, omfang, neste forfallsdato, fullføringsgrad per tidsplan.',
        attestation_schedules_create: 'Opprett en ny attestasjonsplan: plukkfrekvens, omfang, attester og beviskrav.',
        attestation_schedules_edit: 'Rediger en eksisterende attestasjonsplan. Endringer gjelder for neste syklus; tidligere sykluser forblir uendret.',
        attestation_schedules_history: 'Historisk fullføringstidslinje for en attestasjonsplan. Bevisartefakter koblet per syklus.',
        governance_board_report: 'Styreklar overholdelsesrapport: sammendrag, resultattrender, utestående risikoer, utbedringsstatus.',
        governance_compliance_score: 'Compliance score beregning på tvers av rammeverk. Drill-down i bidrag per kontroll.',
        governance_drift_monitor: 'Oppdag kontrollavvik: endringer i innstillinger, tillatelser, unntak fra retningslinjer som svekker holdning.',
        governance_audit: 'Styringsspesifikk revisjonslogg: arbeidsflythendelser, godkjenningsbeslutninger, driftsignaler.',
        governance_evidence: 'Beviskatalog for styringskontroller. Støttedokumenter, skjermbilder, attestasjonskvitteringer.',
        partner_workspace_escalation: 'Dashboard for eskalering på tvers av partnere: åpne eskaleringer, alvorlighetsgrad, [[TOK_0]] klokker og eiere av neste handling.',
        partner_workspace_audit: 'Revisjonslogg for partnerarbeidsområde: engasjementendringer, leverbare oppdateringer, eskaleringsoverganger.',
        partner_workspace_partner_detail: 'Enkeltpartnerorganisasjonsprofil: engasjementshistorikk, aktive leveranser, kontakter, resultatpoeng.',
        partner_workspace_partner_list: 'Partnerorganisasjonsregister: aktive, onboarding- og offboard-partnere med servicenivå + ytelsesmerker.',
        platform_license: 'Lisensinnstillinger: nivå, antall seter, fornyelsesstatus, funksjonsbrytere drevet av den installerte lisensen.',
        platform_notifications_admin_queue: 'Administratorvarslingskø: varsler under fly, leveringsfeil, prøvetilstand på tvers av e-post/SMS/in-app-kanaler.',
        platform_notifications_prefs: 'Varslingspreferanser per bruker: kanalvalg, sammendragsplan, dempet emner.',
        settings_overview: 'Oversikt over leietakerinnstillinger: hurtigkoblinger til domener, e-post, eksport, webhooks og andre plattformomfattende konfigurasjoner.',
        settings_domains: 'Tillatte domener for registrering og SSO. Begrenser kontooppretting til bekreftede bedriftsdomener.',
        settings_email: 'Utgående e-postkonfigurasjon: SMTP-leverandør, avsenderidentitet, DKIM/SPF-status, test-e-postverktøy.',
        settings_export_schedules: 'Planlagte eksporter: gjentakende [[TOK_0]]/[[TOK_2]]/[[TOK_1]] generasjon levert til filleseren på en cron-plan.',
        settings_webhooks: 'Utgående webhook-endepunkter: abonner på eksterne systemer på plattformhendelser. Signering, prøv på nytt, revisjon av hver levering.',
        sod_rules_create: 'Opprett en regel for pliktdeling: velg motstridende rollepar, omfang og håndhevingsmodus (blokker/advars).',
        sod_rules_edit: 'Rediger en eksisterende SoD-regel. Endringer trer i kraft umiddelbart; eksisterende brudd vurderes på nytt ved neste tilgang.',
        sod_rules_list: 'Alle SoD-regler på tvers av leietakeren: håndhevingsmodus, rollepar, antall unntak, antall overtredelser.',
        connectors_definitions: 'Koblingstyperegister: definisjon av hver integrasjon (endepunktform, auth, støttede operasjoner).',
        connectors_list: 'Alle koblingsinstanser koblet til leietakeren. Status, siste synkronisering, feillogg, handling etter synkronisering.',
        connectors_credentials: 'Koblingslegitimasjonshvelv: [[TOK_1]]-tokens, [[TOK_0]]-nøkler, passord for tjenestekontoer. Turnusplan + revisjon.',
        connectors_event_bus: 'Koblingsbegivenhetsbuss: innkommende hendelser fra integrasjoner, rutingsregler, avspilling av dødbokstaver.',
        consent_change_awareness: 'Oppdag meningsfulle samtykkeendringer: formål lagt til, retningslinjer oppdatert, omfang utvidet. Driver kampanjer for nytt samtykke.',
        consent_audit: 'Revisjonsspor for samtykke: hver bevilgning, oppdatering, tilbaketrekking på tvers av arbeidsflyter. Primær overflate for regulatorgjennomganger.',
        consent_reconciliation: 'Avstem samtykketilstand på tvers av [[TOK_0]], plattform og nedstrømssystemer. Flagger avvik.',
        consent_withdrawal_propagation: 'Utbredelsespipeline for tilbaketrekking: når en subjekt trekker tilbake samtykke, sørg for at det flyter til alle koblede systemer.',
        consent_policies: 'Samtykkepolicykatalog: versjoner av personvernpolicy, språkvarianter, aktiveringsvinduer.',
        consent_purpose_catalog: 'Formålskatalog brukt av samtykkearbeidsflyter. Hvert formål knytter seg til et rettslig grunnlag og en oppbevaringsregel.',
        consent_snapshots: '��yeblikksbilder av samtykke: innhenting av alle aktive samtykker på et tidspunkt. Nødvendig for revisjoner og juridiske oppbevaringer.',
        consent_workflows: 'Samtykke arbeidsflytkatalog. Hver arbeidsflyt definerer utløsere, innsamlingsflyter og nedstrømshandlinger.',
        discovery_classification_lineage: 'Klassifiseringslinje: spor hvordan et dataelement ble klassifisert på tvers av skanninger og manuell gjennomgang.',
        discovery_classification_rules: 'Klassifiseringsreglerregister: regulært uttrykk, vokabular, ML-mønstre som brukes til å autoklassifisere oppdagede felt.',
        discovery_dedup_rules: 'Dedupliseringsregler for oppdagede poster. Forhindrer at det samme feltet vises flere ganger.',
        discovery_import_templates: 'Importer maler for å bringe eksisterende datakataloger inn i Discovery-modulen via [[TOK_0]] eller eksterne verktøy.',
        discovery_owner_review: 'Eiervurderingskø: foreslåtte klassifiseringer som venter på godkjenning eller avvisning fra dataeier.',
        discovery_staging: 'Oppholdsplass for nyoppdagede felt. Triage før opprykk til Data Mapping-katalogen.',
        discovery_suggestion_analytics: 'Analyse for forslagsmotoren: nøyaktighet, dekning, mest overstyrte klassifikasjoner.',
        discovery_suggestion_queue: 'Se gjennom køen med foreslåtte klassifiseringer før de brukes. Godta, endre eller avslå per vare.',
        compliance_forms_filler: 'Interaktivt skjemautfyller: gå gjennom et forskriftsskjema med validering, autolagring og medforfatterstøtte.',
        compliance_forms_instance_detail: 'Enkeltskjemaforekomst: nåværende tilstand, historikk, koblet arkivsak, eksporter.',
        compliance_forms_outputs: 'Genererte utdata per skjemaforekomst: [[TOK_2]], [[TOK_1]], [[TOK_0]] pakker med følgebrev og signaturer.',
        compliance_forms_submission_packages: 'Innsendingspakkekatalog: regulatorklare pakker med manifest, signaturer og leveringskvittering.',
        incident_ops_regulatory_sla: 'Forskriftsmessig [TOK_2]]-konfigurasjon for hendelsesvarsler (VN Cybersecurity Law 72-timers vindu, [[TOK_1]] 72-timers, [[TOK_0]] 72-timers).',
        incident_ops_response_metrics: 'Hendelsesresponsberegninger: MTTD, MTTR, [[TOK_0]] samsvarsgrad, eskaleringstall.',
        incident_ops_sla_dashboard: '[[TOK_0]] dashbord: aktive hendelser mot deres [[TOK_1]]-klokke, risikoadvarsler, bruddhistorikk.',
        incident_ops_sla_definitions: '[[TOK_0]] definisjoner: alvorlighetsnivåer, per-tier respons og oppløsningsvinduer, rammeverksiteringer.',
        monitoring_governance_raci: 'RACI-matrise for styringskontroller: ansvarlig, ansvarlig, konsultert, informert per kontroll på tvers av programmet.',
        monitoring_periods: 'Overvåkingsperioder: årlige/kvartalsvise/månedlige gjennomgangssykluser tilpasset regulatoriske arkiveringsvinduer.',
        monitoring_programs_list: 'Overvåkingsprogramkatalog: rammetilpassede programmer med omfang, eier, tråkkfrekvens.',
        monitoring_task_templates: 'Oppgavemaler for overvåking av sykluser. Hver mal definerer omfang, tildelt rolle, beviskrav.',
        access_accountability_evidence_detail: 'Enkeltbevispakkedetalj: varetektskjede, signaturer, eksportalternativer for innsending av regulator.',
        access_accountability_evidence_packages: 'Bevispakkekatalog for tilgangsansvar: Signerte, manipulasjonssikre pakker klare for revisjon.',
        access_reviews_role_analytics: 'Rolleanalyse: rollebrukstetthet, rettighetskryp, sertifisering-beslutningstrender.',
        access_accountability_pattern_analysis: 'Mønsteranalyse over tilgangslogger: uvanlige tilgangstider, geografiske uteliggere, privilegieeskaleringssignaler.',
        access_accountability_session_dashboard: '��ktdashbord: autentiserte økter, øktens varmekart etter time/dag, varsler om inaktiv økt.',
        classification_exports: 'Klassifikasjonseksport: eksporter klassifiseringsbeholdningen som [[TOK_0]]/[[TOK_1]] for eksterne revisjonsverktøy.',
        classification_discovery_cycles: 'Klassifikasjonsoppdagelsessykluser: planlagte skanninger som viser dataelementer som nylig er lagt til eller endret.',
        classification_enterprise_data_map: 'Bedriftsdatakart: aggregert klassifiseringsvisning på tvers av systemer, avdelinger og sensitivitetsnivåer.',
        connectors_automation_planning: 'Automatiseringsplanlegging: definer trigger �  kobling �  handlingskjeder for hendelsesdrevne dataoperasjoner.',
        connectors_brd_capture: 'Forretningskrav Dokumentfangst for nye koblingsutbygginger.',
        connectors_poc_scorecards: 'Proof-of-concept scorekort for å evaluere nye koblingsintegrasjoner mot akseptkriterier.',
        discovery_connector_management: 'Administrering av oppdagelseskoblinger: hvilke skannere som er installert, deres helse og hvilke systemer de målretter mot.',
        discovery_scans_list: 'Alle oppdagelsesskanninger med status, dekning og oppdagelser. Drill ned i funn per skanning.',
        governance_approvals: 'Kø for styringsgodkjenninger: avgjørelser som venter på tvers av leverandørintroduksjon, DPA-gjennomganger, overføringsvurderinger.',
        governance_offboarding: 'Leverandør offboarding arbeidsflyt: kontraktsoppsigelse, dataretur/sletting, tilbakekall av tilgang, sluttrevisjon.',
        governance_periodic_review: 'Periodisk leverandørgjennomgang: planlagt revurdering av risiko, DPA-valuta, underbehandlerliste.',
        incident_ops_playbook_activations: 'Aktive playbook-forekomster: hvilken playbook kjører på hvilken hendelse, fremgang, utestående oppgaver.',
        incident_ops_playbook_links: 'Playbook �  hendelseskoblingsregister. Også lenker til regulatorvarslingsmaler per playbook.',
        incident_ops_playbook_templates: 'Playbook-malkatalog: gjenbrukbare hendelsesresponsskript per hendelsestype og alvorlighetsgrad.',
        organizations_groups_settings_inheritance: 'Innstillinger for arvematrise på tvers av gruppemedlemmer. Bytte for arv/overstyring per kategori med revisjonsspor.',
        organizations_intake_config_form: 'Opprett eller rediger en inntakskonfigurasjon: offentlig-form [[TOK_0]] bane, hastighetsgrenser, captcha, varslingsruting.',
        organizations_intake_configs_list: 'Katalog for inntakskonfigurasjon: offentlig-vendte rettigheter-forespørsel-inngangspunkter per marked/merke.',
        privacy_scanner_monitoring_dashboard: 'Overvåkingsdashbord for personvernskanner: eiendomsdekning, skannetråkk, signaler flagget per eiendom.',
        privacy_scanner_monitoring_settings: 'Overvåkingsinnstillinger: skannefrekvens, terskelregler, varslingsruting, oppbevaring av skanneresultater.',
        privacy_scanner_settings: 'Skannerinnstillinger: aktiverte skannekategorier, signaturoppdateringer, [[TOK_0]] skannerendepunktlegitimasjon.',
        privacy_scanner_real_time_scan: 'Sanntidsskanning: utløs en ad-hoc-skanning og se resultater strømme inn. Ideell for rask verifisering.',
        privacy_scanner_scan_result_detail: 'Detaljvisning av et enkelt skanneresultat: informasjonskapsler, beacons, sporere funnet, klassifisering, utbedringshandlinger.',
        privacy_scanner_results_archive: 'Arkiv med historiske skanneresultater. Filtrer etter egenskap, datoperiode, signaltype.',
        task_management_workflow_detail: 'Enkel arbeidsflytforekomst: alle trinn, eiere, SLAer, forgreningslogikk, fullføringsbevis.',
        task_management_workflow_list: 'Alle arbeidsflytforekomster på tvers av moduler: status, eier, frist, opprinnelsesmodul.',
        task_management_workflow_templates: 'Arbeidsflytmalkatalog: gjenbrukbare flertrinns arbeidsflyter som kan instansieres fra hvilken som helst kildemodul.',
        audit_trail_classic: 'Klassisk revisjonssporvisning (legacy). Blir avviklet til fordel for den enhetlige revisjonsmodulen.',
        audit_trail_unified: 'Samlet revisjonsspor på tvers av hver modul. Primær revisjonsflate.',
        iat_settings: 'Konfigurer Immutable Audit Trails-tillegget: aktivering, omfang, standard bevismodus, taksonomioverstyringer, caps og [[TOK_0]] påloggingsrotasjon. Les den kanoniske modulveiledningen først; den dype følgesvennen er "Aktivere og konfigurere".',
        iat_status: 'Bla gjennom hver proof_link med status-, modus-, modul- og datofiltre. Klikk på et merke for å åpne prøveskuffen. Dyp følgesvenn: "Forstå bevisstatus".',
        iat_integrity_center: 'Kjør avdriftsdeteksjonsverifisering går over en datoperiode; eksporter integritetspakken for ethvert revisjonsomfang. Dyp følgesvenn: "Bruke integritetssenteret".',
        iat_usage: 'Spor gjeldende saldo, månedlig forbruk, takstatus og innløs kredittpakker. Dyp følgesvenn: "Credits and Caps".',
        classification_exceptions: 'Klassifiseringsunntakskø: poster flagget som kantsaker, venter på manuell gjennomgang.',
        classification_review_tasks: 'Oppgavekø for klassifiseringsgjennomgang: automatisk foreslåtte klassifiseringer som venter på eierbekreftelse.',
        consent_properties_audit_log: 'Revisjonsspor for endringer i samtykkeegenskaper: hvem oppdaterte hva, når, gamle/nye verdier.',
        consent_properties_analytics: 'Samtykkeegenskapsanalyse: innhentingsfrekvens for samtykke, tilbaketrekkingsfrekvens, trender for formålsblanding.',
        consent_properties_evidence_packs: 'Bevispakker for samtykkeegenskaper: regulatorklare pakker som beviser samsvar med samtykkefangst.',
        consent_properties_inconsistencies: 'Inkonsekvens av samtykkeegenskaper: egenskaper der plattformen og [[TOK_0]] er uenige om tilstanden.',
        consent_properties_golden_templates: 'Gyldne samtykkebannermaler: godkjente, gjennomgåtte, styringsklare bannerformer distribuert på tvers av eiendommer.',
        consent_properties_template_rollouts: 'Rørledning for malutrulling: trinn, pilot, produksjonsbølger for å skyve gyldne maler til eiendommer.',
        consent_properties_property_groups: 'Eiendomsgrupper: klyngrelaterte eiendommer for styring og rapportering.',
        consent_properties_snapshot_schedules: '��yeblikksbildeplaner: automatiser periodiske innhentinger av samtykketilstander for revisjons- og lovlig hold-formål.',
        deletion_orchestration_completeness: 'Fullstendighetssporer: verifiserer hvert system i oppbevaringsomfanget bekreftet sletting.',
        deletion_orchestration_runs_list: 'Alle slettingskjøringer: status, varighet, systemer dekket, fullføringsgrad.',
        deletion_orchestration_vendor_requests: 'Utgående slettingsforespørsler til leverandører: sporing, [[TOK_0]], bekreftelsesartefakter.',
        deletion_orchestration_vendor_verification: 'Arbeidsflyt for leverandørverifisering: Bekreft at leverandørsystemer har fullført sletting i henhold til vår forespørsel.',
        compliance_forms_catalog: 'Samsvarsskjemakatalog: alle forskriftsskjemaer (Mẫu s�, [[TOK_0]] Art 30, ISO 27701) tilgjengelig for innlevering.',
        compliance_forms_template_browser: 'Malnettleser: oppdag godkjente skjemamaler på tvers av rammeverk.',
        governance_cross_border: 'Register for grenseoverskridende overføringer på styringsnivå: mekanismer, sikkerhetstiltak, landrisikovurdering.',
        governance_subprocessors: 'Underbehandlerregister: hvem våre leverandører bruker, DPA-kaskade, varsling om endringer.',
        incidents_detail: 'Enkelthendelsesarbeidsområde: tidslinje, eier, alvorlighetsgrad, utbedring, status for regulatorvarsling.',
        incidents_list: 'Hendelsesregister: alle aktive + historiske hendelser med filtre for alvorlighetsgrad, kanal, rammeverk.',
        partner_workspace_partner_dashboard: 'Partner-dashboard: KPI-er på toppnivå for alle partnerengasjementer, eskaleringstall, helsetrend.',
        partner_workspace_support_tickets: 'Billettkatalog for partnerstøtte. Delt mellom partner- og leietakerteam med [[TOK_0]] sporing.',
        program_governance_acknowledgment_tracking: 'Dokumentbekreftelsessporing: hvem som har lest og bekreftet hver policy eller prosedyre.',
        program_governance_change_log: 'Dokumentendringslogg: hver redigering av et styringsdokument med diff og godkjenningskjede.',
        roles_detail: 'Enkeltrolledetaljer: tillatelser knyttet til denne rollen, brukere tildelt, revisjon av medlemskapsendringer.',
        roles_list: 'Rollekatalog: hver innebygde og tilpassede rolle med antall medlemmer og tillatelsesomfang.',
        consent_properties_cross_property_dashboard: 'Dashboard på tvers av eiendom: samtykkehelse på tvers av alle eiendommer. Samler fangsthastighet, uttakshastighet, driftindikatorer.',
        consent_properties_property_registry: 'Eiendomsregister: hver eiendom leietakeren administrerer med sin samtykkebannerstatus, koblet [[TOK_0]], policyversjon.',
        forseti_projects_overview: 'Forseti-arbeidsområder: et prosjekt grupperer dokumenter, samtaler, arbeidsflytkjøringer og gjennomganger i tabeller i én beholder slik at [[TOK_0]]-rådgiveren holder konteksten på tvers av hele engasjementet.',
        forseti_workflows_list: 'Lagrede [[TOK_0]] forespørselsmaler som produserer oppgaver og utkast til bevis på forespørsel. Bruk innebygde pakkearbeidsflyter eller skriv dine egne; runs belastes din månedlige token-bøtte.',
        forseti_tabular_reviews_list: 'Repeterbar, kolonne-for-kolonne gjennomgang av et dokumentkorpus. Definer spørsmålene én gang, kjør den samme gjennomgangen på tvers av mange vedlegg, og få et side-ved-side-svarrutenett med henvisninger.',
        forseti_document_review_index: 'Triage-innboks for dokumenter med [[TOK_0]]-foreslåtte redigeringer eller versjoner fra Forseti. Dokumenter kommer inn i køen fra chatter, arbeidsflytkjøringer eller CTAen "Send et dokument for gjennomgang" på denne siden.',
        forseti_audit_lineage: 'Spor alle [[TOK_0]]-genererte gjenstander som er knyttet til enhver post: chatter, verktøyanrop, oppgaver, bevisutkast og dokumentversjoner. Nødvendig for bevisforsvarlighet og revisjoner etter handling.',
        forseti_draft_evidence: '[[TOK_0]]-utkastet bevis i påvente av menneskelig vurdering. Hvert utkast må godkjennes av en autorisert anmelder før det blir formelt bevis � Forseti arkiverer aldri automatisk.',
        forseti_usage: 'Tokenforbruk og bøttestatus for denne organisasjonen. Sporer månedlige fakturerbare enheter, gjenværende bøtte og nylig aktivitet etter bruker/funksjon/verktøy.',
        forseti_overview: 'Inngangspunkt til Forseti [[TOK_0]] juridisk rådgiver: velg en persona, bla gjennom nylige chatter og start en ny samtale. Personavalg her angir standardstemmen for nye chatter.',
        forseti_chat_detail: 'Enkel Forseti-samtale: se meldingshistorikken, bytt personas midt i chatten, send nye meldinger og eksporter transkripsjonen som [[TOK_0]] for bevisformål.',
        forseti_cross_framework_conflicts: 'Utvalgt katalog over konflikter mellom reguleringspakkene organisasjonen din har installert. Filtrer etter rammeverk / emne / alvorlighetsgrad / bekreftelsesstatus, klikk på en rad for å se side-ved-side rammeposisjoner og bekrefte / tilordne / løse. Forseti overflater konfliktene; mennesker bestemmer.',
        users_detail: 'Enkeltbrukerprofil: identitet, rolle, MFA, økthistorikk, revisjonsspor.',
        users_list: 'Brukerkatalog: alle aktive, inviterte og deaktiverte brukere med hurtigfiltre og massehandlinger.',
        governance_vendors: 'Administrer livssyklus for leverandørstyring: onboarding pipeline, periodiske gjennomganger, godkjenninger og offboarding. Spor leverandørens overholdelsesstatus og overholdelse av playbook.',
        governance_compliance: 'Overvåk organisatorisk etterlevelse med scoring, avdriftsdeteksjon og styrerapportering. Spor overholdelsestrender og generer lederklare rapporter.',
        governance_transfers: 'Administrer grenseoverskridende dataoverføringer, DPA-gjennomganger og underprosessorstyring. Dokumentere overføringsmekanismer og sikre regulatorisk samsvar for internasjonale dataflyter.',
        vendor_risk_assessment: 'Vurder og score leverandørrisiko på tvers av porteføljen din. Overvåk risikosignaler, spor revurderinger og oppretthold en omfattende oversikt over risikoporteføljen.',
        vendor_risk_contracts: 'Administrer leverandørkontrakter, due diligence-spørreskjemaer og portevalueringer. Spor kontraktsvilkår, fornyelsesdatoer og overholdelseskrav.',
        vendor_risk_onboarding: 'Administrer leverandørens onboarding-livssyklus: inntaksvurdering, gjennomgangsruting, godkjenningsarbeidsflyter og beslutninger om risikoaksept.',
        vendor_risk_dashboard: 'Sentral oversikt over leverandørens risikoposisjon: porteføljefordeling etter nivå, nylige nivåendringer, kontrakter som utløper innen 90 dager, gjennomgang av KPIer og risikoaksepthelse. Begynn her for å lese et øyeblikk før du borer deg inn i scoringer, signaler eller porter.',
        vendor_risk_scoring: 'Konfigurer poengdimensjoner og evaluer leverandører mot vektede risikokriterier. Spor sammensatte poengsummer, tildelte nivåer og poenghistorikk over tid.',
        vendor_risk_signals: 'Spor uønskede hendelser som kan berettige leverandørrevurdering: sertifiseringsutløp, bruddvarsler, finansiell ustabilitet og endringer i samsvar. Signaler driver nedstrøms revurderingsoppgaver.',
        vendor_risk_reviews: 'Gjennomfør periodiske leverandørgjennomganger med øyeblikksbilder av kontraktstatus, funn og anbefalinger. Spor vurderingsresultater (tilfredsstillende, identifiserte bekymringer, utbedring nødvendig, eskalert) på tvers av programmer og perioder.',
        vendor_risk_reassessments: 'Utløs og administrer revurderingsoppgaver når signaler eller periodiske tidsplaner indikerer endret risikostilling. Registrere resultater og oppdaterte risikonivåer; gjennomførte revurderinger flyter tilbake til scoring.',
        vendor_risk_acceptance: 'Godta formelt gjenværende leverandørrisiko med eksplisitte betingelser, utløpsdatoer og begrunnelse. Oppretthold risikoakseptregisteret � den reviderbare oversikten over aktive, utløpte og tilbakekalte akseptbeslutninger.',
        vendor_risk_onboarding_cases: 'Administrer leverandørens onboarding-saks livssyklus: ny onboarding, gjennomganger av materialendring og periodiske gjennomganger. Arbeid gjennom trinnvise faner med fullføringsindikatorer og utløs godkjenningsporter når du er klar.',
        vendor_risk_review_routing: 'Send leverandørvurderingsoppgaver til spesifikke anmeldere etter bruker og rolle. Tildel spørreskjemaer, spor kontrollørens oppdrag og fange opp rutingresultater med fullstendig revisjonsspor.',
        vendor_risk_gates: 'Evaluer innkjøpsgodkjenningsporter før leverandører går live. Konfigurer gatekriterier (sertifiseringer, DPA signert, spørreskjema fullført, risiko innenfor terskel), registrer overstyringsbegrunnelser og koblingsbevis.',
        vendor_risk_questionnaires: 'Bygg due-diligence spørreskjemamaler og tilordne dem til leverandører. Spor fullføring av svar, gjennomgå merknader og funn som inngår i risikoscoring og godkjenningsporter.',
        monitoring_programs: 'Opprette og administrere overvåkingsprogrammer knyttet til regelverk. Tildel oppgaver via RACI-styring og spor programgjennomføring.',
        monitoring_kpi: 'Spor compliance-KPIer, autoritetsberedskapspoeng og endre gjennomgangsstatus. Dashboardvisning av overvåking av programytelse på tvers av alle aktive rammeverk.',
        discovery_scans: 'Kjør dataoppdagingsskanninger på tvers av tilkoblede systemer. Administrer oppdagelsessykluser med deltadeteksjon, konfigurer koblinger og spor skanneresultater.',
        discovery_classification: 'Gjennomgå oppdagelsesforslag, administrer oppsamlingsområdet for nylig oppdagede data, og foreta eiergjennomgang med klassifiseringsanbefalinger.',
        discovery_management: 'Konfigurer dedupliseringsregler, administrer importmaler og spor klassifiseringsavstamning fra oppdagelse til godkjente klassifiseringsetiketter.',
        connectors_integration: 'Konfigurer systemkoblinger, administrer legitimasjon og overvåk hendelsesbussen for sanntidsdatasynkronisering på tvers av integrerte systemer.',
        connectors_automation: 'Planlegg automatiseringsstrategier, fange opp forretningskrav og evaluer proof-of-concept scorekort for systemintegrasjonsprosjekter.',
        connectors_governance: 'Administrer systembeholdningen, foreta sikkerhetsgjennomganger, vedlikeholde sporbarhetsmatriser og spor registre for integrasjonsgap.',
        task_management_tasks: 'Se og administrer overholdelsesoppgaver: oppgaveliste, personlig oppgavekø, forfalte oppgaver, oppgavebord og kalendervisninger for sporing av arbeid på tvers av alle moduler.',
        task_management_workflows: 'Design og administrer overholdelsesarbeidsflyter: lag arbeidsflytmaler, konfigurer seksjonsoppdrag og overvåk utførelse av arbeidsflyt.',
        compliance_forms_templates: 'Bla gjennom og administrer samsvarsskjemamaler. Få tilgang til malkatalogen, lag egendefinerte maler og konfigurer skjemaoppsett for forskriftsmessige innsendinger.',
        compliance_forms_submissions: 'Fyll ut og send inn samsvarsskjemaer. Spor skjemaforekomster, gjennomgå utdata og administrer innsendingspakker for regulatorisk innlevering.',
        compliance_forms_filing: 'Administrer innleveringssakskoblinger, seksjonsruting og konsolidering av flere avdelinger for utarbeidelse og innsending av forskriftsdokumenter.',
        organizations_entities: 'Administrer organisasjonsenheter, tilordne regulatoriske rammer per enhet, og konfigurer avdelingshierarkier for overholdelse av flere enheter.',
        organizations_groups: 'Administrer organisasjonsgrupper for multi-entity-bedrifter. Del leverandører, rammeverk og skjemamaler på tvers av gruppemedlemmer med konsolidert rapportering.',
        organizations_intake: 'Konfigurer inntaksinnstillinger og administrer innstillingsarv på tvers av organisasjonshierarkier.',
        access_accountability_sessions: 'Overvåk brukerøkter, gjennomgå tilgangslogger og analyser tilgangsmønstre. Spor øktaktivitet med forankringsstatus for bevis på ansvarlighet.',
        access_accountability_reviews: 'Kjør kampanjer for tilgangsvurderinger, administrer vurderinger av begrunnelse og spor fremgang for anmeldere. Koordiner periodisk tilgangssertifisering på tvers av organisasjonen.',
        access_accountability_sod: 'Definer regler for separasjon av oppgaver, oppdage brudd og administrer unntak. Håndhev kontroll av interessekonflikt på tvers av roller og tillatelser.',
        access_accountability_evidence: 'Generer bevispakker for tilgangsgjennomganger, utfør undersøkelser og analyser rollebruksmønstre for tilgangsrapportering.',
        program_governance_maturity: 'Vurder og spor etterlevelsesprogrammodenhet på tvers av rammeverk. Definer modenhetsmodeller, kjør vurderinger og overvåk forbedringstrender over tid.',
        program_governance_obligations: 'Kartlegge regulatoriske forpliktelser til organisasjonsenheter med RACI-styring. Definer styringsmodellen og spor utbedringsplaner for identifiserte hull.',
        program_governance_documents: 'Administrer styringsdokumentregisteret: utarbeide, gjennomgå, utstede og spore anerkjennelse av samsvarspolicyer og driftsdokumenter.',
        program_governance_reporting: 'Generer ledersammendrag, rapporter om revisjonsberedskap og analyser av bevishull. Spor rapporteringsperioder og overvåk programhelseberegninger.',
        deletion_orchestration_runs: 'Utfør og overvåk slettingsorkestreringskjøringer. Spor utførelsesoppgaver, verifiser fullstendighet og administrer slettingsdashbordet.',
        deletion_orchestration_vendors: 'Koordiner forespørsler om leverandørsletting, verifiser leverandørens overholdelse av sletteforpliktelsene og oppretthold beviskjededokumentasjon.',
        consent_management: 'Administrer samtykkepolicyer, formålskataloger og samtykkearbeidsflyter. Konfigurer regler for innsamling av samtykke og spor øyeblikksbilder av samtykke over tid.',
        consent_cmp: 'Integrer med Consent Management Platforms (CMPs): konfigurer webhooks, kartlegg [[TOK_0]]-formål til GRC-katalogformål, og synkroniser samtykkeposter.',
        consent_compliance: 'Overvåk overholdelse av samtykke: oppdage konfigurasjonsendringer, avstemme uoverensstemmelser, spor forplantning av tilbaketrekking og gjennomgå revisjonssporet for samtykke.',
        partner_workspace_partners: 'Administrer partnerorganisasjoner, foreta partnerrevisjoner og håndtere eskaleringer. Spor partnerens ombordstigningsstatus og overholdelseskrav.',
        partner_workspace_operations: 'Administrer partnerleveranser, arbeidsflytmaler, tjenestenivåer og merkevareprofiler. Konfigurer operative arbeidsflyter for partnersamarbeid.',
        privacy_scanner_scanning: 'Kjør personvernskanning i sanntid på nettsteder og applikasjoner. Gjennomgå skanneresultater, spor sporingsbevis for forhåndssamtykke og administrer skannearkivet.',
        privacy_scanner_monitoring: 'Konfigurer dashbord og innstillinger for overvåking av personvernskanner. Sett opp automatiserte skanneplaner og administrer skannerkonfigurasjon.',
        consent_import: 'Masseimport av samtykkeposter fra [[TOK_0]] filer. Ideell for å registrere papirbasert samtykke (arbeidsavtaler, samtykkeskjemaer for foreldre/skole) i stor skala. Støtter arbeidsflyttyper for bevilgning, tilbaketrekking, begrensning og innsigelse.',
        cases_import: 'Masseimport av forespørselssaker for registrerte rettigheter fra [[TOK_0]] filer. Støtter flerkanals inntakskilder, inkludert telefon-, post-, e-post og personlige innsendinger for organisasjoner som mottar store mengder DSARer.',
        data_subjects: 'Se enhetlige registrerte profiler som samler alle rettighetsforespørselssaker og samtykkeposter for hver enkelt person. Spor hele personvernlivssyklusen per person � samtykkehistorikk, DSR-saker og interaksjonstidslinje.',
        files_config: 'Angi retningslinjene for filopplasting for hele plattformen � størrelsesgrenser, type tillatelsesliste, oppbevaringsstandarder og regler for lovlig tilbakeholdelse. Overstyringer per eiertype lar deg stramme inn retningslinjer for sensitive moduler (f.eks. rettighetsbevis) mens resten av organisasjonen holdes på standard. Oppbevaringsstandarder støtter dataminimeringsforventningene under [[TOK_0]] lov 91/2025 artikkel 3; juridisk hold suspenderer sletting under åpne undersøkelser eller tvister.',
        files_browser: 'Bla gjennom, søk og administrer hvert vedlegg som lastes opp på tvers av organisasjonen. Filtrer etter eiermodul, opplaster, dato og MIME-type; åpne skuffen for vedleggsdetaljer for å se revisjonshistorikk, koblet enhet og oppbevaringsstatus. En operasjonell visning � ikke rammespesifikk � brukt av administratorer og revisorer for å finne og triage filer.',
        files_dashboard: 'Driftsoversikt over filoverflaten: total lagring, vekst over tid, foreldreløse vedlegg (ingen overordnet enhet) og overholdelse av retningslinjer for oppbevaring etter eiertype. Bruk den til å oppdage policydrift (f.eks. en modul som beholder filer forbi det globale oppbevaringsvinduet) og til å budsjettere lagring. Operasjonell verktøy � ikke knyttet til et spesifikt regelverk.',
    },
    framework_rights: {
        be_informed: 'Rett til å bli informert',
        consent: 'Rett til samtykke',
        refuse_consent: 'Rett til å nekte samtykke',
        withdraw_consent: 'Rett til å trekkje tilbake samtykke',
        access: 'Rett til innsyn',
        rectification: 'Rett til retting',
        data_provision: 'Rett til datautlevering',
        deletion: 'Rett til sletting',
        restriction_of_processing: 'Rett til avgrensing av behandling',
        object_to_processing: 'Rett til å protestere mot behandling',
        complaint: 'Rett til å klage',
        denunciation: 'Rett til melding',
        lawsuit: 'Rett til å reise søksmål',
        claim_damages: 'Rett til skadebot',
        request_protection_measures: 'Rett til å be om vernetiltak',
    },
    framework_content: {
        EU_EPRIVACY_DIRECTIVE: {
            display_name: 'Direktiv 2002/58/EF (e-personverndirektivet)',
            description: 'Overordnet direktiv for nasjonal transponering av ePersonvern. Dekker informasjonskapsler, personvern for elektronisk kommunikasjon, direkte markedsføring. Hvert medlemsland må innføre i nasjonal lovgivning.',
        },
        EU_GDPR: {
            display_name: 'Generell databeskyttelsesforordning (EU) 2016/679',
            description: 'General Data Protection Regulation ([[TOK_0]]) er en EU-forordning om databeskyttelse og personvern. Den gjelder direkte i alle EU/E��S-medlemsland.',
        },
        EU_NIS2_DIRECTIVE: {
            display_name: 'Direktiv (EU) 2022/2555 ([[TOK_0]])',
            description: 'Overordnet direktiv for nasjonale [[TOK_0]] transposisjoner. Dekker cybersikkerhetsrisikostyring, hendelsesrapportering, forsyningskjedesikkerhet for viktige og viktige enheter.',
        },
        VN_AI_LAW_2026: {
            display_name: 'Vietnam [[TOK_0]] lov ([[TOK_1]]) � Gjelder 1. mars 2026',
            description: 'Vietnam [TOK_0]] lov (Luật Trí tu�! nhân tạo [[TOK_2]]) som styrer utvikling, distribusjon og bruk av kunstig intelligens-systemer. Etablerer risikoklassifisering, transparens og merkeplikter, krav til hendelsesrapportering, konsekvensvurderingsforpliktelser og en kontrollert testmekanisme (sandbox) for [[TOK_1]] aktiviteter i Vietnam.',
        },
        VN_AI_DECREE_142_2026: {
            display_name: 'Decree 142/2026/NĐ-CP — [[TOK_0]] Law Implementation',
            description: 'Decree 142/2026/NĐ-CP (Nghị định số 142/2026/NĐ-CP) detailing certain articles and implementing measures of the Vietnam [[TOK_0]] Law (Law 134/2025/QH15). Issued 2026-04-30, effective 2026-05-01. Lead authority: Ministry of Science and Technology. Operationalises [[TOK_0]] risk classification, classification dossier, reclassification review, high-risk conformity assessment, high-risk risk-management system, transparency / explanation / technical marking / visible labeling, serious [[TOK_0]] incident reporting (72h / 5wd / 15d), state-agency [[TOK_0]] impact assessment (Mẫu AI02), and the controlled testing / [[TOK_0]] sandbox lifecycle (Mẫu AI03a-AI09b). Submission via the [[TOK_0]] one-stop e-portal or MoST transitional channel. No statutory fines.',
        },
        VN_CYBERSEC_LAW: {
            display_name: 'Vietnam Cybersecurity Law (24/2018-epoken)',
            description: 'Vietnams lov om cybersikkerhet (lov nr. [[TOK_0]]) som etablerer krav til cybersikkerhet, datalokalisering og hendelsesrapportering. Aktiv inntil erstattet av lov [[TOK_1]] med virkning fra 2026-07-01.',
        },
        VN_CYBERSEC_DECREE_53: {
            display_name: 'Dekret 53 � Implementering av lov om nettsikkerhet',
            description: 'Dekret [[TOK_0]] som implementerer cybersikkerhetsloven, som dekker fastsettelse innenfor omfanget, utløsere for datalokalisering, krav til lokal tilstedeværelse og arbeidsflyter for myndighetssamarbeid.',
        },
        VN_CYBERSEC_LAW_2025: {
            display_name: 'Lov om nettsikkerhet ([[TOK_0]])',
            description: 'Vietnams konsoliderte lov om cybersikkerhet (lov [[TOK_0]]), som erstatter lov [[TOK_1]], med virkning fra 1. juli 2026. Konsoliderer omfanget av dekret [[TOK_2]]Đ-CP (se VN_CYBERSEC_DECREE_53).',
        },
        VN_DATA_LAW: {
            display_name: 'Vietnam datalov',
            description: 'Vietnams datalov (lov [[TOK_0]]) som etablerer omfattende datastyringskrav, inkludert databeholdning, klassifisering, delingsstyring og grenseoverskridende dataoverføringsstyring. Overlapper med VN_PDPL_LAW_2025 (personopplysningsaspekter) og VN_CYBERSEC_LAW_2025 (datalokalisering/klassifisering).',
        },
        VN_DATA_LAW_DECREE_165_2025: {
            display_name: 'Dekret [[TOK_0]]Đ-CP (datalovimplementering)',
            description: 'Dekret [[TOK_0]]Đ-CP som implementerer Vietnams datalov (lov [[TOK_1]]). Tilbyr offisielle skjemaer for konsekvensvurderinger for grenseoverskridende dataoverføring, årlig risikovurderingsrapportering og nasjonal databasetilgang. Definerer 11 offisielle Mẫu s�-former.',
        },
        VN_DATA_EXCHANGES_DRAFT_2026: {
            display_name: 'Utkast til dekret om databørsar 2026',
            description: 'Utkast til dekret om drift av datautvekslingsplattformer (Dự thảo Ngh�9 ��9nh quy ��9nh về hoạt ��"ng của sàn dữ li�!u). Regulerer plattformklassifisering, deltakerberettigelse, kontroller for dataprodukt- og tjenesteoppføringer, sandkassetesting, transaksjonsarbeidsflyt, elektroniske kontrakter, sertifikater for eiendomsrettigheter over data og håndtering av klager/tvister. For tiden i offentlig høring; ennå ikke kunngjort. Siterer lov om data [[TOK_0]], lov om beskyttelse av personopplysninger [[TOK_1]], lov om nettsikkerhet [[TOK_2]], og lov om elektroniske transaksjoner [[TOK_3]].',
        },
        VN_ECOMMERCE_LAW_2025: {
            display_name: 'Lov om elektronisk handel ([[TOK_0]])',
            description: 'Vietnam lov om elektronisk handel (Luật Thương mại �i�!n tử [[TOK_0]]) som etablerer et enhetlig nasjonalt regime for elektronisk handel, som dekker innenlands og grenseoverskridende plattformoperasjoner, plattformstyring og ansvarlighet, forbrukerbeskyttelse, selger og tilknyttede selskaper, fjerning av innhold, håndtering av innhold, klage og nedlasting av innhold, klage og nedlasting. statlig styringssystem for e-handel.',
        },
        VN_PDPL: {
            display_name: 'Vietnam [[TOK_0]] (dekret 13/2023-epoken)',
            description: 'Vietnams personopplysningsdekret (dekret [[TOK_0]]) som etablerer omfattende databeskyttelseskrav. Eldre rammeverk � erstattet av lov [[TOK_1]] og dekret [[TOK_2]] gjeldende 2026-01-01.',
        },
        VN_PDPD_DECREE_13: {
            display_name: 'Dekret 13 � [[TOK_0]] Operasjonell grunnlinje',
            description: 'Dekret [[TOK_1]], det operative instrumentet for [[TOK_0]] oppgaver, inkludert dossierarkivering, styringsartefakter, grenseoverskridende mekanikk og administrative prosedyrer for MoPS. Erstattet av dekret [[TOK_2]] med virkning fra 2026-01-01.',
        },
        VN_PDPL_LAW_2025: {
            display_name: 'Personvernlov ([[TOK_0]])',
            description: 'Vietnams lov om beskyttelse av personopplysninger (lov [[TOK_2]]) som etablerer et omfattende rammeverk for beskyttelse av personopplysninger, gjeldende 1. januar 2026. Dekker samsvarstemaer A�J: lovlige behandlingsbaser, samtykke til sensitive data, rettigheter til registrerte personer (tilgang/retting/sletting/begrensning/innsigelse/portabilitet), og datasubjektets rettigheter. [[TOK_0]] for behandling med høy risiko, styring av grenseoverskridende overføringer, [[TOK_1]] betegnelse, registreringer av behandlingsaktiviteter, kontraktsmessige forpliktelser for behandler. Myndighetsarkiveringsforpliktelser via MoPS (VN_PDPL_ADMIN_PROCEDURES_778_2026). Kryssreferanser: VN_PDPL_DECREE_356_2025 (gjennomføringsdekret), VN_CYBERSEC_LAW_2025 (cybersikkerhet overlapper), VN_DATA_LAW (datastyring).',
        },
        VN_PDPL_DECREE_356_2025: {
            display_name: 'Dekret [[TOK_1]] ([[TOK_0]] Implementering)',
            description: 'Dekret [[TOK_0]] som implementerer personopplysningsloven, og erstatter dekret [[TOK_1]]. Dekker dossierarkivering, styringsartefakter, grenseoverskridende mekanikk og sertifisering av tjenesteleverandører. Vedleggsskjema inventar: Phụ lục I�VIII (konsekvensvurdering, grenseoverskridende overføring, sertifisering). MoPS administrative prosedyrer via VN_PDPL_ADMIN_PROCEDURES_778_2026 (vedtak 778/QĐ-BCA-A05). Arbeidsflyt for sertifisering: søknad �  utstedelse �  endringsforespørsel �  ny utstedelse �  tilbakekall. Kryssreferanser: VN_PDPL_LAW_2025 (overordnet lov), VN_CYBERSEC_LAW_2025 (datalokalisering), VN_DATA_LAW (datastyring overlapper).',
        },
        VN_PDPL_ADMIN_PROCEDURES_778_2026: {
            display_name: '[[TOK_0]] A05 Administrative prosedyrer (vedtak 778/QĐ-BCA-A05)',
            description: 'Avgjørelse 778/QĐ-BCA-A05 (februar 2026) � Administrative prosedyrer for beskyttelse av personopplysninger under A05 ([[TOK_0]]). Definerer prosedyrer for innsending, behandling og resultatutstedelse, inkludert DLCN-HC-skjemaer og lovbestemte skjemaer.',
        },
        VN_PDPL_ENFORCEMENT_DRAFT_2026: {
            display_name: 'Utkast til håndhevingsdekret 2026',
            description: 'Utkast til håndhevings- og sanksjonsdekret for brudd på personopplysningsloven (lov [[TOK_0]]). Definerer straffeområder, skjerpende/formildende faktorer og håndhevelsesprosedyrer. For øyeblikket i utkaststatus og venter på kunngjøring.',
        },
        VN_MOPS_ADMIN_SIMPLIFICATION_NQ22_2026: {
            display_name: 'Government Resolution NQ22/2026 — MoPS Administrative Simplification (Temporary Overlay)',
            description: 'Temporary procedural overlay (effective 2026-04-29, expiring 2027-03-01) introducing three official channels (National Public Service Portal, direct submission to MoPS, postal submission to MoPS) for [[TOK_0]] Decree 356/2025 and Decision 778/2026 dossier submissions. Email is NOT a NQ22 official channel — a separate unofficial email-ZIP submission guidance ([[TOK_0]]_GUIDANCE_EMAIL_ZIP_DOSSIER_SUBMISSION_2026) is shipped with requires_legal_review: true. Procedural overlay only — does NOT alter substantive obligations, fine ranges, or the binding force of underlying frameworks. Review task scheduled 2027-02-01.',
        },
        VN_TELECOM_LAW_2023: {
            display_name: 'Vietnam telekommunikasjonslov 2023',
            description: 'Vietnam Telecommunications Law 2023 (Luật Vi�&n thông), et sektoroverlegg for telekommunikasjons-/ISP-/plattformselskaper med forpliktelser om konfidensialitet, avsløringskontroll og myndighetshåndtering. Kryssreferanser: VN_CYBERSEC_LAW_2025 (informasjonssystemsikkerhet), VN_PDPL_LAW_2025 (brukerdatabehandling), VN_DATA_LAW (datastyring).',
        },
        VN_TELECOM_DECREE_163_2024: {
            display_name: 'Dekret [[TOK_0]]Đ-CP (Telecom Law Implementation)',
            description: 'Dekret [[TOK_0]]Đ-CP som implementerer telekommunikasjonsloven (lov [[TOK_1]]). Gir offisielle skjemaer for varsling av telekomtjenester, lisensiering, registrering og utviklingsplaner for datasenter. Definerer 7 offisielle Mẫu s�-former.',
        },
    },
    framework_requirements: {
        d163_r4: {
            title: 'Innlevering av utviklingsplan for datasenter',
            description: 'Datasenterutviklingsplaner må innleveres til den kompetente myndigheten i henhold til dekret [[TOK_0]]Đ-CP.',
        },
        d163_r3: {
            title: 'Registrering av teletjenester',
            description: 'Registrering av telekommunikasjonstjenester må innleveres til vedkommende myndighet ved bruk av det foreskrevne skjemaet.',
        },
        d163_r2: {
            title: 'Søknad om telekomlisens',
            description: 'Søknad om telelisenser skal sendes på fastsatt skjema i henhold til dekret [[TOK_0]]Đ-CP.',
        },
        d163_r1: {
            title: 'Varsling om teletjenester',
            description: 'Tilbydere av teletjenester skal varsle vedkommende myndighet om tjenesteytelse ved å bruke det foreskrevne skjemaet før tjenesten påbegynnes.',
        },
        vn_dp_draft_f: {
            title: 'Klager, tvister og risikohåndtering',
            description: 'Plattformoperatører må sørge for klageinntak, tvistehåndteringsarbeidsflyt med bevisbevaring, risikoidentifikasjon og tidlige varslingskontroller, og periodisk gjennomgang av risikoer for personvern, cybersikkerhet og tilgangsadministrasjon.',
        },
        vn_dp_draft_e: {
            title: 'Transaksjonsarbeidsflyt og sertifikat for eiendomsrett over data',
            description: 'Transaksjoner krever kontoregistrering, noteringsgodkjenning, elektronisk kontrakt, betalingsbekreftelse, leveringsregistrering og utstedelse av et sertifikat for eiendomsrett til data der det er aktuelt. Transaksjonshistorikk og sporbarhet skal oppbevares i et transaksjonsregister.',
        },
        vn_dp_draft_d: {
            title: 'Sandkasse og testmiljøkontroller',
            description: 'Testmiljøer må være isolert, tilgangsbegrenset, sikkerhetsovervåket og gjennomgått før utdata trekkes ut. Ingen kildedata kan trekkes ut fra testmiljøet, og stenging/opprydding av testøkter skal registreres.',
        },
        vn_dp_draft_c: {
            title: 'Datakontroller for produkt- og tjenesteoppføringer',
            description: 'Oppføringer må støttes av bevis fra lovlig kilde og eierskap/bruksrett, tekniske valideringsregistreringer, kvalitetsavsløringer og oppføringer for gjennomgang og godkjenning på plattformsiden. Forbudte data må filtreres før oppføring.',
        },
        vn_dp_draft_b: {
            title: 'Deltakerberettigelse og onboarding',
            description: 'Plattformoperatører må verifisere juridisk status, juridisk kapasitet og betingede forretningskrav for selgere og kjøpere, registrere transaksjons- og betalingskontoer og opprettholde et deltakerregister.',
        },
        vn_dp_draft_a: {
            title: 'Dataplattformklassifisering og driftsmodell',
            description: 'Plattformoperatører må etablere en klassifisering av plattformtype (nasjonal dataplattform vs andre dataplattformer), definere operatørens berettigelse og ansvar, og dokumentere priser, gebyrer, driftsregler og teknisk styring.',
        },
        d165_r5: {
            title: 'Informasjonstilgang til nasjonal database',
            description: 'Forespørsler om å trekke ut/bruke informasjon fra den nasjonale digitale datadatabasen bruker foreskrevne skjemaer (Mẫu s� 07a/07b).',
        },
        d165_r4: {
            title: '�&rlig risikovurderingsrapportering',
            description: '�&rlige risikovurderingsrapporter må innleveres ved bruk av foreskrevne skjemaer (Mẫu s� 05a/05b, 06).',
        },
        d165_r3: {
            title: 'Oppsigelse av grenseoverskridende overføring',
            description: 'Oppsigelse av grenseoverskridende overføring skal varsles ved bruk av fastsatte skjemaer (Mẫu s� 04a/04b).',
        },
        d165_r2: {
            title: 'Varsling om vurderingsresultat',
            description: 'Myndigheten utsteder kunngjøringer om vurderingsresultater ved å bruke foreskrevet skjema (Mẫu s� 03).',
        },
        d165_r1: {
            title: 'Innlevering av konsekvensanalyse for grenseoverskridende dataoverføring',
            description: 'Organisasjoner må sende inn dokumentasjon for grenseoverskridende dataoverføring/behandling av konsekvensvurderinger ved å bruke foreskrevne skjemaer (Mẫu s� 01a/01b, 02).',
        },
        a964190d_8d1d_4284_bc7d_4023e2866751: {
            title: 'Samtykke for informasjonskapsler og lignende teknologier',
            description: 'Lagring eller tilgang til informasjon på et terminalutstyr er kun tillatt med forhåndssamtykke, med unntak av teknisk nødvendig lagring.',
        },
        '8437d96d_cf01_4f87_89f6_4faaf8eefdf6': {
            title: 'Konfidensialitet av kommunikasjon',
            description: 'Medlemsstatene skal sikre konfidensialiteten til kommunikasjon og relaterte trafikkdata ved hjelp av et offentlig kommunikasjonsnett og offentlig tilgjengelige elektroniske kommunikasjonstjenester.',
        },
        c5420073_50c6_4981_816a_398460e5f546: {
            title: 'Samtykke for direkte markedsføring (opt-in)',
            description: 'Bruk av elektroniske kommunikasjonssystemer for direkte markedsføring krever forhåndssamtykke fra abonnenten.',
        },
        c8bf67d2_874b_4647_92d7_39aaa3230819: {
            title: 'Myk opt-in for eksisterende kunder',
            description: 'Direkte markedsføring til eksisterende kunder for lignende produkter/tjenester er tillatt uten samtykke dersom opt-out er gitt.',
        },
        b546df40_9217_4204_b71c_5af5022a0ff9: {
            title: 'Bruddvarsling for teleleverandører',
            description: 'Tilbydere av offentlig tilgjengelige elektroniske kommunikasjonstjenester skal varsle vedkommende nasjonale myndighet om brudd på personopplysninger.',
        },
        '5bd66ae4_dee3_4611_9104_71742df55484': {
            title: 'Rett til å motsette seg direkte markedsføring',
            description: 'Abonnenter skal gis mulighet til å motsette seg å motta direkte markedsføringsmeldinger når som helst og gratis.',
        },
        a10af31f_ba28_494e_ab50_f8679e86a0b0: {
            title: 'Oppbevaring og sletting av trafikkdata',
            description: 'Trafikkdata knyttet til abonnenter og brukere må slettes eller gjøres anonyme når de ikke lenger er nødvendige for overføring, bortsett fra fakturering eller samtrafikkbetalinger.',
        },
        '8577e60f_66a8_4651_8336_d561db9929ad': {
            title: 'Betingelser for behandling av stedsdata',
            description: 'Andre stedsdata enn trafikkdata kan kun behandles når de er gjort anonyme eller med samtykke fra brukeren, i den utstrekning og varighet det er nødvendig.',
        },
        '7f3abb41_8713_4276_93b5_6902f419a016': {
            title: 'Behandlingens lovlighet � samtykke',
            description: 'Behandling skal bare være lovlig dersom den registrerte har gitt samtykke til behandling av sine personopplysninger for ett eller flere spesifikke formål.',
        },
        '1c2a945a_8eac_428d_8105_e80e95288ea4': {
            title: 'Behandlingens lovlighet � kontrakt',
            description: 'Behandling er nødvendig for å oppfylle en kontrakt som den registrerte er part i.',
        },
        '2b50c0fb_ee96_412e_a092_c3c1f3f817e8': {
            title: 'Behandlingens lovlighet � juridisk forpliktelse',
            description: 'Behandling er nødvendig for å overholde en rettslig forpliktelse som den behandlingsansvarlige er underlagt.',
        },
        '702ea760_9e5c_4c32_babc_0b5094ca9735': {
            title: 'Behandlingens lovlighet � vitale interesser',
            description: 'Behandling er nødvendig for å beskytte de vitale interessene til den registrerte eller en annen fysisk person.',
        },
        '8b55ce88_2d5e_467b_a55c_8c5b0efab67e': {
            title: 'Behandlingens lovlighet � allmenn interesse',
            description: 'Behandling er nødvendig for å utføre en oppgave som utføres i allmennhetens interesse eller ved utøvelse av offentlig myndighet.',
        },
        '8a72dd16_ee3c_4947_b5cd_9484719adad8': {
            title: 'Behandlingens lovlighet � legitime interesser',
            description: 'Behandling er nødvendig for formålet med de legitime interessene som forfølges av den behandlingsansvarlige eller en tredjepart.',
        },
        afefc965_8f83_4d75_a9fc_92d4d4f549d6: {
            title: 'Behandling av spesielle kategorier (sensitive data)',
            description: 'Behandling av spesielle kategorier av personopplysninger (raseopprinnelse, politiske meninger, helse, etc.) er forbudt med mindre spesifikke vilkår i art. 9(2) er oppfylt.',
        },
        '10a2d63f_744d_4222_91f6_86a5a4cdaefd': {
            title: 'Vilkår for samtykke',
            description: 'Kontrolløren må vise at samtykke ble gitt. Samtykke må være fritt gitt, spesifikt, informert og utvetydig. Tilbaketrekking må være like enkelt som å gi samtykke.',
        },
        '27697f99_efef_49e6_b8e7_c2dc550d1791': {
            title: 'Barns samtykke � digitale tjenester',
            description: 'Behandling av personopplysninger om et barn under 16 år (eller lavere alder fastsatt av medlemsland, ikke under 13) krever samtykke fra foreldre for informasjonssamfunnstjenester.',
        },
        '53883480_508e_4f8e_984f_9354c18de285': {
            title: 'Transparent informasjon og kommunikasjon',
            description: 'Behandlingsansvarlig skal gi informasjon knyttet til behandlingen i en kortfattet, transparent, forståelig og lett tilgjengelig form.',
        },
        b5eb22b7_78f2_4c55_b342_827d5f8ac90c: {
            title: 'Informasjon for direkte innsamling',
            description: 'Der det samles inn personopplysninger fra den registrerte, skal behandlingsansvarlig gi spesifisert informasjon på innsamlingstidspunktet.',
        },
        e55f7dbf_cd2a_4713_887e_8c64744e2d95: {
            title: 'Informasjon for indirekte innsamling',
            description: 'Der det ikke er innhentet personopplysninger fra den registrerte, skal behandlingsansvarlig gi spesifisert informasjon innen rimelig tid.',
        },
        '6bc5ec07_0589_4593_882a_13f41c31e1f6': {
            title: 'Rett til innsyn',
            description: 'Den registrerte skal ha rett til å få bekreftelse på behandlingen og tilgang til personopplysningene og tilleggsopplysninger.',
        },
        '0e011e25_dcea_4a1e_ae55_583e683cea44': {
            title: 'Rett til retting',
            description: 'Den registrerte skal ha rett til å få retting av unøyaktige personopplysninger uten ugrunnet opphold.',
        },
        e8ec5a55_f657_4a99_9b92_3e9861067d28: {
            title: 'Rett til sletting (rett til å bli glemt)',
            description: 'Den registrerte skal ha rett til å få slettet personopplysninger uten ugrunnet opphold der spesifiserte grunner gjør seg gjeldende.',
        },
        '5b0c92fd_cd08_47be_bfd2_0540ad73f84f': {
            title: 'Rett til begrensning av behandlingen',
            description: 'Den registrerte skal ha rett til å få begrensning av behandlingen der nærmere angitte vilkår gjelder.',
        },
        '3b829862_39f4_41be_8f2b_d469469a801b': {
            title: 'Meldeplikt � retting/sletting/begrensning',
            description: 'Behandlingsansvarlig skal kommunisere enhver retting, sletting eller begrensning til hver mottaker som data ble utlevert til.',
        },
        '9cf34be6_121b_4fdf_ad7c_c4773696522e': {
            title: 'Rett til dataportabilitet',
            description: 'Den registrerte skal ha rett til å motta sine personopplysninger i et strukturert, vanlig brukt, maskinlesbart format.',
        },
        becae433_90b9_4cc0_bd33_df50976c1561: {
            title: 'Rett til å protestere',
            description: 'Den registrerte skal ha rett til å motsette seg behandling basert på allmenne interesser eller legitime interesser, herunder profilering.',
        },
        '4ef387f1_439c_4579_82a3_01565e6dc05d': {
            title: 'Automatisert individuell beslutningstaking, inkludert profilering',
            description: 'Den registrerte skal ha rett til ikke å bli gjenstand for en avgjørelse basert utelukkende på automatisert behandling som gir rettslige eller tilsvarende betydelige virkninger.',
        },
        '667ae5eb_a39a_4809_a032_923cc804eaed': {
            title: 'Bruddmelding til tilsynsmyndigheten (72t)',
            description: 'Ved brudd på personopplysninger skal den behandlingsansvarlige varsle tilsynsmyndigheten innen 72 timer etter at han ble kjent med det, med mindre det er usannsynlig at det medfører risiko.',
        },
        '40e4c2ad_bc85_436c_814f_265f02c8c3b1': {
            title: 'Bruddvarsling til registrerte (høy risiko)',
            description: 'Når et brudd sannsynligvis vil medføre en høy risiko for rettigheter og friheter, skal den behandlingsansvarlige kommunisere bruddet til den registrerte uten unødig opphold.',
        },
        '9dbb47bd_172f_4335_b7f3_4558476c4192': {
            title: 'Svar på forespørsler fra registrerte (30 dager)',
            description: 'Behandlingsansvarlig skal svare på forespørsler fra registrerte uten unødig forsinkelse og innen én måned etter mottak, som kan forlenges med ytterligere to måneder for komplekse forespørsler.',
        },
        '175d16b7_a0fc_44ff_bb9e_5ccb5d3de5a9': {
            title: 'Konsekvensvurdering av databeskyttelse',
            description: 'Der behandling sannsynligvis vil resultere i en høy risiko for rettigheter og friheter, skal den behandlingsansvarlige utføre en [[TOK_0]] før behandlingen.',
        },
        e54a7b09_33dd_4cda_8e21_d10a51e5e925: {
            title: 'Forutgående konsultasjon med tilsynsmyndighet',
            description: 'Behandlingsansvarlig skal rådføre seg med tilsynsmyndigheten der en [[TOK_0]] indikerer at behandling vil resultere i høy risiko uten avbøtende tiltak.',
        },
        '047b7838_bae5_4861_9c38_c99fedec9c96': {
            title: '[[TOK_0]] obligatorisk behandlingsliste',
            description: '[[TOK_0]] kreves for systematisk evaluering/profilering, storskala behandling av spesielle kategorier, og systematisk overvåking av offentlige arealer.',
        },
        aa08dc83_7c1a_441d_a8e7_960f65c8de87: {
            title: 'Registrering av behandlingsaktiviteter (kontrollør)',
            description: 'Hver behandlingsansvarlig skal føre en oversikt over behandlingsaktiviteter under dens ansvar, inkludert formål, kategorier, mottakere, overføringer og oppbevaring.',
        },
        b7eb6296_5962_449c_b267_d322d7919122: {
            title: 'Registrering av behandlingsaktiviteter (behandler)',
            description: 'Hver databehandler skal føre en oversikt over alle kategorier av behandlingsaktiviteter utført på vegne av en behandlingsansvarlig.',
        },
        '0d57e6d5_bbf5_4ea6_9a89_0f57bed61b5b': {
            title: 'Behandlingssikkerhet',
            description: 'Behandlingsansvarlig og databehandler skal iverksette passende tekniske og organisatoriske tiltak for å sikre sikkerhet tilpasset risikoen.',
        },
        ad85edfc_3c92_4ce4_a414_3ba6186cae98: {
            title: 'Databeskyttelse ved design og som standard',
            description: 'Behandlingsansvarlig skal iverksette hensiktsmessige tiltak for å sikre at kun personopplysninger som er nødvendige for hvert spesifikke formål behandles (dataminimering).',
        },
        '933b438d_53b8_4b6a_b1db_8e7f1b429ede': {
            title: 'Utpeking av personvernombud',
            description: 'Behandlingsansvarlig og databehandler skal utpeke en [[TOK_0]] der behandlingen utføres av offentlig myndighet, innebærer regelmessig og systematisk overvåking, eller storskala behandling av spesielle kategorier.',
        },
        '28810a5d_d818_411a_9e8c_792d1b2c9b2f': {
            title: 'Generelt prinsipp for overføringer',
            description: 'Enhver overføring av personopplysninger til et tredjeland skal bare skje dersom vilkårene i kapittel V er oppfylt.',
        },
        '60add64b_bb0c_44e7_baaf_666af65b2d0f': {
            title: 'Overføringer basert på tilstrekkelighetsbeslutning',
            description: 'En overføring kan finne sted der Kommisjonen har besluttet at tredjelandet sikrer et tilstrekkelig beskyttelsesnivå.',
        },
        cde8c7cd_3727_40ce_a321_e6b72b335179: {
            title: 'Overføringer underlagt passende sikkerhetstiltak',
            description: 'I fravær av en beslutning om tilstrekkelighet, kan overføringer finne sted der hensiktsmessige garantier er gitt, inkludert SCC eller BCR.',
        },
        '0e8edaa1_2156_44d9_95f2_1b284f581658': {
            title: 'Standard kontraktsmessige klausuler',
            description: 'Standard kontraktsbestemmelser vedtatt av Kommisjonen eller av en tilsynsmyndighet gir passende garantier for internasjonale overføringer.',
        },
        '608a8de7_6c75_4f88_bd4c_1cc308780ab9': {
            title: 'Bindende bedriftsregler',
            description: 'Bindende selskapsregler godkjent av en kompetent tilsynsmyndighet gir hensiktsmessige garantier for konserninterne internasjonale overføringer.',
        },
        '420ced80_0d3b_4a28_adad_14ba54df3e40': {
            title: 'Unntak for spesifikke situasjoner',
            description: 'I mangel av tilstrekkelighet eller garantier, kan overføringer finne sted basert på uttrykkelig samtykke, kontraktsnødvendighet, allmenne interesser, rettskrav, vitale interesser eller offentlig register.',
        },
        c86fbc0d_7188_486c_8ea5_96b3fe957c6f: {
            title: 'Lederorgansansvar og opplæring',
            description: 'Ledelsesorganer for viktige og viktige enheter må godkjenne risikostyringstiltak for nettsikkerhet og gjennomgå regelmessig opplæring.',
        },
        ffb95a09_993c_4db0_a4bb_c48000e43b33: {
            title: 'Risikostyringstiltak for cybersikkerhet',
            description: 'Essensielle og viktige enheter skal iverksette passende og forholdsmessige tekniske, operasjonelle og organisatoriske tiltak for å håndtere cybersikkerhetsrisiko.',
        },
        '6a7c8c8f_4b81_4b47_adb7_c6abd12acd4b': {
            title: 'Retningslinjer og prosedyrer for hendelseshåndtering',
            description: 'Enheter skal implementere retningslinjer for hendelseshåndtering, inkludert deteksjon, analyse, inneslutning og responsprosedyrer.',
        },
        de019eab_9992_4361_be7c_3e592f209d76: {
            title: 'Forretningskontinuitet og krisehåndtering',
            description: 'Enheter skal implementere forretningskontinuitetstiltak, inkludert sikkerhetskopiering, katastrofegjenoppretting og krisehåndtering.',
        },
        '6b5f482f_301c_4f69_bd91_f9ae1b21de6c': {
            title: 'Sikkerhet i forsyningskjeden',
            description: 'Enheter skal behandle sikkerhetsrelaterte aspekter ved forhold til direkte leverandører og tjenesteleverandører, inkludert risikovurderinger i forsyningskjeden.',
        },
        c8e7738b_358c_4c79_9fc2_a564f15a6e37: {
            title: 'Sikkerhet i nettverk og informasjonssystemer',
            description: 'Enheter skal implementere sikkerhet ved anskaffelse, utvikling og vedlikehold av nettverk og informasjonssystem, inkludert sårbarhetshåndtering.',
        },
        '72520ed1_51ff_4983_a785_9be1f72cf7dd': {
            title: 'Sårbarhetshåndtering og avsløring',
            description: 'Enheter skal implementere retningslinjer og prosedyrer for koordinert avsløring og håndtering av sårbarheter.',
        },
        f009e65d_d55e_4c98_9532_63c150694698: {
            title: 'Effektivitet av vurdering av cybersikkerhetsrisiko',
            description: 'Enheter skal implementere retningslinjer og prosedyrer for å vurdere effektiviteten til risikostyringstiltak for nettsikkerhet.',
        },
        '00e88824_675d_4b37_960c_757b3176c079': {
            title: 'Politikk for kryptografi og kryptering',
            description: 'Enheter skal implementere retningslinjer og prosedyrer angående bruk av kryptografi og, der det er hensiktsmessig, kryptering.',
        },
        de29d287_81f1_46b1_b327_9cbf06ddad3d: {
            title: 'HR-sikkerhet, tilgangskontroll, kapitalforvaltning',
            description: 'Enheter skal implementere sikkerhet for menneskelige ressurser, retningslinjer for tilgangskontroll og aktivaforvaltning.',
        },
        '750f4459_9ba4_415e_bc47_5b0ec27d35a2': {
            title: 'Multi-faktor autentisering',
            description: 'Enheter skal bruke multifaktorautentisering eller kontinuerlig autentiseringsløsninger, sikret tale/video/tekstkommunikasjon og sikrede nødkommunikasjonssystemer.',
        },
        '359474f9_1820_4e3e_9031_a593b66ccde4': {
            title: 'Tidlig advarsel til CSIRT (24 timer)',
            description: 'Enheter skal sende inn en tidlig advarsel til den kompetente CSIRT innen 24 timer etter at de ble oppmerksomme på en betydelig hendelse.',
        },
        '66acd92c_3091_4148_b935_68b0d24308e7': {
            title: 'Hendelsesvarsling til CSIRT (72 timer)',
            description: 'Enheter skal sende inn en hendelsesmelding til den kompetente CSIRT innen 72 timer etter at de ble oppmerksomme på en betydelig hendelse.',
        },
        '68269688_06b2_43ea_8e3e_a84532086557': {
            title: 'Sluttrapport til CSIRT (1 måned)',
            description: 'Enheter skal sende inn en sluttrapport til den kompetente CSIRT senest én måned etter hendelsesmeldingen.',
        },
        c8512bde_b064_4926_b333_06b9c95cecd7: {
            title: 'Anvendelsesbestemmelse for [[TOK_0]] aktiviteter',
            description: 'Bestem om organisasjonen utfører [[TOK_0]] aktiviteter underlagt Vietnam [[TOK_1]]-loven og dokumenter anvendelsesbeslutningen.',
        },
        '3a87ad63_179a_45ba_8743_98d865df80ab': {
            title: '[[TOK_0]] systemrisikoklassifisering etter risikonivå',
            description: 'Klassifiser hvert [[TOK_0]] system etter risikonivå (minimalt, begrenset, høyt, uakseptabelt) ved å bruke den veiledede klassifiseringsmetoden.',
        },
        '0f4475d3_77a6_4b41_bfe2_d4b299b1bd45': {
            title: '[[TOK_0]] Vedlikehold av systemregisteroppføring',
            description: 'Oppretthold et register over [[TOK_0]] systemer med systemnavn, eier, formål, distribusjonskontekst, risikonivå og leverandørinvolvering.',
        },
        '2a73ce94_906a_4c95_8a45_a5bdf2a8118c': {
            title: '[[TOK_0]] Systemdokumentasjon med artefaktsjekkliste og bevis',
            description: 'Bygg og vedlikehold et systemdossier med nødvendig sjekkliste for artefakter, bevisbibliotek og versjonshistorikk.',
        },
        e92cfb42_d91b_444f_adbc_c03903844eac: {
            title: '�&penhetsforpliktelser for [[TOK_0]] systemoperatører',
            description: 'Implementer åpenhetstiltak for [[TOK_0]]-systemer, inkludert brukervarsling, avsløring av [[TOK_1]] involvering og systemdokumentasjon.',
        },
        '45eb43d7_9b63_4166_aa0d_fa6aeeaa70ba': {
            title: '[[TOK_0]] utdatamerking, vannmerking og metadatasignering',
            description: 'Implementer merking og vannmerking for [[TOK_0]]-generert innhold, inkludert metadatasignering der det er aktuelt.',
        },
        '9566c94d_0dd3_419c_869f_6707d2a972f9': {
            title: 'Offentliggjøringskrav for [[TOK_0]]-generert innhold',
            description: 'Fortell brukere når innhold er [TOK_0]]-generert og gi brukere mekanismer for å identifisere [[TOK_1]] involvering.',
        },
        '21d39ea5_df78_45c6_8710_b203db229e25': {
            title: 'Forklaringsoppgaver og plikter til brukervennlig åpenhet',
            description: 'Gi forklarlige utdata for [[TOK_0]] beslutninger som påvirker enkeltpersoner, og oppretthold dokumentasjon for brukervendt åpenhet.',
        },
        f523fbc2_156d_466d_ad50_6a0c51b3ac9d: {
            title: 'Menneskelige tilsynsforpliktelser for [[TOK_0]]-systemer med høy risiko',
            description: 'Sørg for at menneskelige tilsynsmekanismer er på plass for [[TOK_0]]-systemer med høy risiko, inkludert eskalerings- og overstyringsfunksjoner.',
        },
        bd180a89_4976_4790_9e50_f1c5c97dc576: {
            title: '[[TOK_0]] hendelsesovervåking og deteksjon',
            description: 'Implementer overvåkingsfunksjoner for å oppdage [[TOK_0]] systemhendelser, funksjonsfeil og uønskede utfall.',
        },
        e7c1c60b_856c_4d3d_b6c9_092cde9b56bd: {
            title: 'Alvorlig [TOK_0]] hendelse som rapporteres til myndigheten',
            description: 'Rapporter alvorlige [TOK_0]] hendelser til vedkommende myndighet innen den foreskrevne tidslinjen (72 timer).',
        },
        '97f15adc_558a_49f2_bb06_86597cb9579b': {
            title: '[[TOK_0]] tidslinjeoverholdelse av hendelsesvarsling',
            description: 'Overhold varslingstidslinjene for [[TOK_0]] hendelser, inkludert innledende varsling, oppdateringer og avslutningsrapporter.',
        },
        '96c33d7e_fe52_4730_adac_70c8c477c88e': {
            title: '[[TOK_0]] konsekvensvurdering for høyrisikosystemer',
            description: 'Gjennomfør konsekvensvurderinger for høyrisiko-[TOK_0]]-systemer som dekker risikoer, avbøtende tiltak, menneskelig tilsyn og overvåkingsplaner.',
        },
        '0f3b72c0_1030_44ff_ba53_596f45601cd7': {
            title: 'Kontrollert testing / fastsettelse av kvalifisering for sandkasse',
            description: 'Bestem kvalifisering for kontrollert testing (sandkasse) deltakelse og dokumenter kvalifikasjonsvurderingen.',
        },
        '4a6aed20_f655_4182_a760_aef1f329d5df': {
            title: 'Sandbox-søknadsinnsending og godkjenningssporing',
            description: 'Send inn sandkassesøknader til den kompetente myndigheten og spor godkjenningsstatus gjennom innsendingslivssyklusen.',
        },
        '8376988d_cd32_491e_a5b8_3340d3973358': {
            title: 'Sandkasse overvåking sjekkpunkter og ferdigstillelse/utgang',
            description: 'Gjennomfør periodiske overvåkingssjekkpunkter under sandkassedeltakelse og utarbeide fullførings-/utgangsrapporter.',
        },
        '7cb2b544_0512_4702_a092_9f1c10872376': {
            title: 'Merkefritak/unntaksdokumentasjon med begrunnelse',
            description: 'Dokumenter eventuelle merkingsunntak eller unntak med begrunnelse og støttende bevis.',
        },
        dccd7fbf_872a_4716_87a4_b9c5ce8e2387: {
            title: 'Datalokalisering for vietnamesiske brukere',
            description: 'Data fra vietnamesiske brukere om tjenester som tilbys i Vietnam må lagres innenfor Vietnams territorium.',
        },
        '9eb86a03_e165_4963_8813_2272b638d529': {
            title: 'Rapportering av cybersikkerhetshendelser',
            description: 'Cybersikkerhetshendelser må rapporteres til kompetente myndigheter i tide.',
        },
        '736ac7de_7a6a_4bfd_b2be_c594e290038a': {
            title: 'Klassifisering av informasjonssystem',
            description: 'Informasjonssystemer må klassifiseres etter viktighetsnivå og passende sikkerhetstiltak skal iverksettes.',
        },
        ffb807cf_f121_4b52_8e50_e091c33180c9: {
            title: 'Risikovurdering av cybersikkerhet',
            description: 'Det må gjennomføres regelmessige risikovurderinger av cybersikkerhet for informasjonssystemer.',
        },
        a4de518b_a5f1_481f_9b08_f8d2bc9db7e5: {
            title: 'Bestemmelse innenfor omfanget (beslutningstre)',
            description: 'Organisasjoner må avgjøre om de er innenfor virkeområdet for dekret 53 ved å bruke det foreskrevne beslutningstreet.',
        },
        '01f99e9a_5e30_4d14_aae5_a2ce322a700b': {
            title: 'Datalokaliseringsvurdering og beredskap',
            description: 'Organisasjoner må vurdere krav til datalokalisering og vise beredskap.',
        },
        cf24f011_dc23_4d84_aef5_994dde440571: {
            title: 'Sjekkliste for beredskap for lagring og oppbevaring',
            description: 'En sjekkliste for beredskap for lagring og oppbevaring må fylles ut for samsvar med datalokalisering.',
        },
        b3884cb8_c785_4258_9517_9e393be4f4e1: {
            title: 'Lokal tilstedeværelseskrav vurdering',
            description: 'Organisasjoner må vurdere om lokale tilstedeværelseskrav gjelder og planlegge deretter.',
        },
        c1dc645b_cb1a_42a6_8ca5_9b15cfa84156: {
            title: 'Myndighetsforespørsel om mottak og verifisering',
            description: 'Myndighetsforespørsler må mottas, verifiseres og behandles i henhold til foreskrevne prosedyrer.',
        },
        d4571651_f39d_4c51_8f2d_7248c37f7b14: {
            title: 'Myndigheten ber om svar innen fristen',
            description: 'Svar på myndighetsforespørsler skal gis innen fastsatt frist.',
        },
        '66c1df70_3456_40e9_b645_6c6bd3be702e': {
            title: 'Logg for håndtering av myndighetsforespørsel',
            description: 'Det skal føres en logg over alle myndighetsforespørselshåndteringsaktiviteter.',
        },
        '04bbba2a_9804_4199_a517_054b6f4689fb': {
            title: 'Anvendbarhet og fastsettelse innenfor omfanget (konsolidert)',
            description: 'Organisasjoner må avgjøre om de er innenfor virkeområdet under den konsoliderte cybersikkerhetsloven, som dekker både den gamle loven 24/2018 og dekret 53/2022.',
        },
        '89a21eaf_cf09_4fec_bbb4_a1dadd652f6e': {
            title: 'Informasjonssystemklassifisering etter viktighetsnivå',
            description: 'Informasjonssystemer skal klassifiseres etter viktighetsnivå (generelt, viktig, kritisk) med tilsvarende sikkerhetsforpliktelser.',
        },
        '83ad981e_23ff_4a92_bebd_cd24487e912f': {
            title: 'Styringsstruktur for cybersikkerhet og ansvarlig personell',
            description: 'Organisasjoner må etablere styringsstrukturer for cybersikkerhet og utpeke ansvarlig personell.',
        },
        '98d9a523_fefb_400b_bb7f_ebaf609a6ed4': {
            title: 'Periodisk vurdering av cybersikkerhetsrisiko',
            description: 'Det skal gjennomføres regelmessige risikovurderinger av nettsikkerhet for alle klassifiserte informasjonssystemer.',
        },
        '5236539f_4c1a_4eff_b2eb_fc11eb4eab23': {
            title: 'Sikkerhetstiltak per informasjonssystemklassifisering',
            description: 'Tekniske sikkerhetstiltak må iverksettes hensiktsmessig for hvert informasjonssystemklassifiseringsnivå.',
        },
        b69a8be2_ae0c_408c_b8f1_73b573eca876: {
            title: 'Adgangskontroll og identitetshåndtering',
            description: 'Det skal implementeres tilgangskontroll og identitetsstyringstiltak for informasjonssystemer.',
        },
        ac774c26_feb7_4123_b799_c54f77bd87b5: {
            title: 'Logging, overvåking og revisjonsspor',
            description: 'Informasjonssystemer må opprettholde logging, overvåking og revisjonsspor.',
        },
        a86cb01d_239b_44e2_9e09_e6973bcf9658: {
            title: 'Sårbarhetshåndtering og oppdatering',
            description: 'Sårbarhetshåndtering og oppdateringsprosesser må etableres og vedlikeholdes.',
        },
        '826a789f_0c03_4918_81a1_6aa1cc2c205c': {
            title: 'Datalokalisering for vietnamesiske brukerdata',
            description: 'Data fra vietnamesiske brukere om tjenester som tilbys i Vietnam må lagres innenfor Vietnams territorium.',
        },
        '8bee2b51_ace8_4118_89c8_010b96640016': {
            title: 'Lokal tilstedeværelseskrav for utenlandske tjenesteleverandører',
            description: 'Utenlandske tjenesteleverandører som opererer i Vietnam må opprettholde lokal tilstedeværelse som foreskrevet.',
        },
        '74d89250_b45f_41b6_bfe3_f915071580de': {
            title: 'Lokal lagringsarkitektur og grenseoverskridende flytdokumentasjon',
            description: 'Lokal lagringsarkitektur må dokumenteres og grenseoverskridende datastrømmer må kartlegges og kontrolleres.',
        },
        '04dec6f8_3280_494c_8506_292804b16d4d': {
            title: 'Deteksjon og respons på cybersikkerhetshendelser',
            description: 'Organisasjoner må ha evner til å oppdage og reagere på cybersikkerhetshendelser.',
        },
        faeda71b_5050_497d_b08b_e3f3f5313ad4: {
            title: 'Obligatorisk hendelsesrapportering til kompetent myndighet',
            description: 'Kvalifiserte cybersikkerhetshendelser må rapporteres til [[TOK_1]]/[[TOK_0]] innen foreskrevne tidslinjer.',
        },
        d732b5a2_2b2c_48a0_955d_97a39daf132d: {
            title: 'Overholdelse av tidslinje for hendelsesvarsling',
            description: 'Hendelsesvarsler må overholde foreskrevne tidslinjekrav (innledende rapport innen 24 timer, fullstendig rapport innen 72 timer).',
        },
        '8e2dffb0_3481_44f0_baf2_130ddd8cfe12': {
            title: 'Myndighetsforespørselsbehandling og samarbeid',
            description: 'Myndighetsforespørsler må behandles raskt og samarbeid gis i henhold til foreskrevne prosedyrer.',
        },
        e4c5b870_1d61_48fe_a6c2_1b9f5a458ea3: {
            title: 'Myndighetsbegjæringssaksregister og utleveringslogg',
            description: 'Alle myndighetsforespørsler og avsløringer skal loggføres i et saksregister med fullstendig revisjonsspor.',
        },
        '8eff8b17_65bc_4f94_8ece_c509a9fd9abb': {
            title: 'Leverandørs og tredjeparts sikkerhetsvurdering',
            description: 'Tredjepartsleverandører med tilgang til informasjonssystemer må gjennomgå sikkerhetsvurdering.',
        },
        '69891e1b_97f6_464c_9cce_b1276794fe4a': {
            title: 'Kontroller for leverandørdatatilgang og hendelsesvarsling',
            description: 'Leverandørdatatilgang må dokumenteres og kontraktsmessige forpliktelser om varsling av hendelser skal etableres.',
        },
        d89b6bc0_7a9e_4816_b31e_7c0abc02e90c: {
            title: 'Sikkerhetsbevissthetstrening og øvelser',
            description: 'Regelmessig bevisstgjøringstrening for nettsikkerhet og bordøvelser må gjennomføres.',
        },
        f9c5d3cc_5bb2_4b30_a5fb_ada34e407981: {
            title: 'Periodisk pennetest og sikkerhetsrevisjon',
            description: 'Periodiske penetrasjonstesting og sikkerhetsrevisjoner skal utføres på klassifiserte informasjonssystemer.',
        },
        '88dd9877_d2e2_4e41_a248_ae39b1ff478f': {
            title: 'Opprettholde digital databeholdning',
            description: 'Organisasjoner må opprettholde en omfattende digital databeholdning som katalogiserer alle dataressurser.',
        },
        '18e4bfd1_42cf_4d87_870f_5a34242962ef': {
            title: 'Dataklassifisering etter sensitivitet og viktighet',
            description: 'Data må klassifiseres i henhold til sensitivitets- og viktighetsnivåer som definert av dataloven.',
        },
        b89981ac_7559_46f9_a74c_a143976dde4e: {
            title: 'Definer håndteringsregler etter klassifiseringsnivå',
            description: 'Det må etableres håndteringsregler for hvert dataklassifiseringsnivå.',
        },
        '3bf8019d_b72c_41d7_82cf_fc367efd9526': {
            title: 'Spor datadeling og avsløring med godkjenninger',
            description: 'Alle datadelings- og avsløringsaktiviteter må spores med passende godkjenninger.',
        },
        '8623eca2_4cf9_41bd_bfbd_2300c06ca1f3': {
            title: 'Grenseoverskridende dataoverføringsstyring',
            description: 'Grenseoverskridende dataoverføringer må være i samsvar med styringskrav i henhold til dataloven.',
        },
        '006b8aa6_9379_4eff_b8ab_935f9a087601': {
            title: 'Opprettholde styringspolitikk og ansvar',
            description: 'Organisasjoner må opprettholde retningslinjer for datastyring og tildele styringsansvar.',
        },
        f12fc090_5c3e_4fa8_9813_74bea0359c5c: {
            title: '�&rlig styringsattest',
            description: 'En årlig styringsattest må fylles ut for å bekrefte løpende overholdelse.',
        },
        f6c3060a_5e52_4f97_b1af_c6a5f00bfaee: {
            title: 'Datarisikovurdering',
            description: 'En datarisikovurdering må utføres for å identifisere og redusere risikoer for datastyring.',
        },
        '6f228998_1c61_49cf_a585_3d3e9baff55a': {
            title: 'Plattformoperatørens ansvar og styringsforpliktelser',
            description: 'Etabler ansvarlighetsstrukturer for plattformoperatører, inkludert styringspolitikk, overvåkingsansvar og håndhevelsesforpliktelser.',
        },
        eee1d423_3783_4530_bc64_eef6fd9d02dc: {
            title: 'Plattformregler publisering og åpenhet av informasjon',
            description: 'Publiser plattformregler, handelsbetingelser og operasjonelle avsløringer på en transparent og tilgjengelig måte.',
        },
        '50b57433_7a51_4e92_9c84_c748d6865b70': {
            title: 'E-handel salgsnettsted/app-melding til MOIT',
            description: 'Send melding til MOIT for e-handelssalgsnettsteder og -applikasjoner via Online.gov.vn eller angitte kanaler.',
        },
        '92854abe_6654_4155_8495_f3419a8a8da0': {
            title: 'E-handelstjenesteplattform/markedsplassregistrering hos MOIT',
            description: 'Registrer e-handelstjenesteplattformer og markedsplasser med MOIT, inkludert innsending av dossier og godkjenningssporing.',
        },
        b8bff437_805e_4a4a_a62e_89cb90b89d3f: {
            title: 'Vedlikehold av selgerregister (innenlandsk og utenlandsk)',
            description: 'Oppretthold et register over alle selgere på plattformen, inkludert innenlandske og utenlandske selgere med onboarding, verifisering og livssyklussporing.',
        },
        '75778639_5235_4d13_a728_fa772c27fc0c': {
            title: 'Livestream selgerregister og samsvarskontroller',
            description: 'Oppretthold et register over livestreamselgere med identitetsbekreftelse, aktivitetssporing og samsvarskontroller.',
        },
        '405f2932_742a_4bcb_9784_1a3d81f2e714': {
            title: 'Affiliate- og markedsføringspartnerregister',
            description: 'Opprettholde et register over tilknyttede markedsførere og henvisningspartnere med kontraktsstatus, retningslinjer for innhold og bekreftelse på samsvar.',
        },
        cce5a4eb_a576_459c_95b5_bdd0e8ed30a8: {
            title: 'Produktliste og håndhevelse av forbudte/betingede varer',
            description: 'Implementer produktoppføringskontroller, inkludert forbudte og betingede varescreening, overvåking og håndhevingshandlinger.',
        },
        '9fc01e19_18dd_4d60_b95a_c1f4bcdbb6ae': {
            title: 'Forbrukerklager registreres med inntak, handlinger og revisjonsspor',
            description: 'Oppretthold et klageregister med inntaksregistreringer, undersøkelseshandlinger, løsningsresultater og fullstendig revisjonsspor.',
        },
        '8a21764e_e5f4_4934_9913_c235f4c462ca': {
            title: 'Prosedyre for klagebehandling og tidsfrister for løsning',
            description: 'Etabler klagebehandlingsprosedyrer med definerte tidslinjer for bekreftelse, etterforskning og løsning.',
        },
        '8406373c_ec31_4bf8_810f_72d9d73b3de8': {
            title: 'Moderering av innhold, overvåking og håndhevelse av fjerning',
            description: 'Implementer prosedyrer for moderering, overvåking og fjerning av innhold for ulovlig, forbudt eller krenkende innhold.',
        },
        '6f32c315_323b_4ce6_a4bb_3262a5b56afe': {
            title: 'Fjerning og håndhevingshandlinger registreres med bevisbevaring',
            description: 'Opprettholde et register over fjernings- og håndhevingshandlinger med beslutningsregister, bevisoppbevaring og selgervarslinger.',
        },
        c0bbbfbf_29bd_4813_89f1_956eab9f1a23: {
            title: 'Plattformpolicy og avsløringsregister (versjoner, publiseringsdatoer, aksept)',
            description: 'Oppretthold et register over plattformpolicyer og avsløringer med versjonshistorikk, publiseringsdatoer og akseptbevis.',
        },
        c9fcbe90_622d_43ca_9ec6_db26c0eda490: {
            title: 'Forbrukerinformasjonsplikter - nøyaktig produktinformasjon og anti-bedrag',
            description: 'Sørg for nøyaktig, tydelig produkt- og tjenesteinformasjon og implementer tiltak for å forhindre villedende praksis på plattformen.',
        },
        '8f49603b_454c_4470_ab07_2f845a447595': {
            title: 'Driftsforhold for utenlandsk plattform og registrering/varsling',
            description: 'Overhold driftsvilkårene for utenlandske plattformer som betjener vietnamesiske brukere, inkludert registrerings- eller varslingskrav.',
        },
        e0dc85cc_5d2a_4142_b1a6_cc2fde891f7b: {
            title: 'Lokal representasjon eller autorisasjon for utenlandske plattformer',
            description: 'Utpek en lokal representant eller autorisert enhet i Vietnam for utenlandske plattformer som kreves av loven.',
        },
        '5719f47c_f298_429e_90c3_df6ceed856e1': {
            title: 'Samordning av selger og klagebehandling på tvers av landegrensene',
            description: 'Koordinere grenseoverskridende selgerhåndtering og klageløsning inkludert eskalering og bevishåndtering.',
        },
        c0b3db29_9161_4cef_a889_94e3b85d78fe: {
            title: 'Statlig samhandling og rapporteringsberedskap for e-handelsstyringssystem',
            description: 'Forbered deg på samhandling med det statlige e-handelsstyringssystemet, inkludert datafeltkartlegging og rapporteringsevne.',
        },
        '145a7016_720a_4a06_badd_00145842821e': {
            title: 'Melding om vesentlig endring etter godkjenning',
            description: 'Send inn varsler for vesentlige endringer i plattformdetaljer, retningslinjer eller operasjoner etter første godkjenning.',
        },
        '4bc0ee2a_610d_490d_8122_d6d1afadaa22': {
            title: 'Oppsigelse og deaktiveringsvarsel',
            description: 'Send inn varsler om oppsigelse eller deaktivering ved opphør av e-handel, inkludert offentlig kunngjøring og håndtering av forbrukerbeskyttelse.',
        },
        be95bc85_2b25_4de7_a3e7_154b780289e4: {
            title: 'Trustmark og troverdighetsvurderingsprogram kvalifisering og vedlikehold',
            description: 'Vurder kvalifisering for trustmerke- og troverdighetsvurderingsprogrammer og opprettholde samsvarsbevis for pågående deltakelse.',
        },
        f639afe2_18f2_4c0a_82d9_626308994267: {
            title: 'Samtykke til behandling av personopplysninger',
            description: 'Behandling av personopplysninger krever samtykke fra den registrerte med mindre unntak gjelder.',
        },
        '5dd8e1b9_ac2d_48af_8c62_538937f0a4f7': {
            title: 'Samtykke til behandling av sensitive data',
            description: 'Behandling av sensitive personopplysninger krever uttrykkelig samtykke med separat, tydelig varsling til den registrerte.',
        },
        '5a958c76_6943_4449_a15c_ddb503ce526f': {
            title: 'Rett til innsyn',
            description: 'Registrerte har rett til innsyn i sine personopplysninger som den behandlingsansvarlige har.',
        },
        '1ae0a58b_65a5_4a32_9b2c_0baed7799a32': {
            title: 'Rett til retting',
            description: 'Registrerte har rett til å be om retting av unøyaktige personopplysninger.',
        },
        '25c61e57_273f_48cb_a318_d6315ad744f1': {
            title: 'Rett til sletting',
            description: 'Registrerte har rett til å be om sletting av sine personopplysninger.',
        },
        '0eafe047_ed8b_4a9a_bda9_b4ef2ae353c2': {
            title: 'Rett til å begrense behandlingen',
            description: 'Registrerte har rett til å be om begrensning av behandlingen av sine personopplysninger.',
        },
        '77f9677a_f436_43ec_a947_3bdc44fc192a': {
            title: 'Rett til å protestere',
            description: 'Registrerte har rett til å protestere mot behandlingen av deres personopplysninger.',
        },
        c8b19e70_782c_49c9_8a71_14bef4147d6b: {
            title: 'Rett til å trekke tilbake samtykke',
            description: 'Registrerte har rett til å trekke tilbake tidligere gitt samtykke når som helst.',
        },
        '7f472a1c_b37f_498d_adc7_df8d8eafbae9': {
            title: 'Melding om brudd til myndigheten (72 timer)',
            description: 'Behandlingsansvarlig må varsle departementet for offentlig sikkerhet innen 72 timer etter oppdagelse av et brudd på personopplysninger.',
        },
        '98bed7ab_e814_43f5_8e70_e95c413266a1': {
            title: 'Bruddvarsling til registrerte',
            description: 'Behandlingsansvarlig skal varsle berørte registrerte om et brudd på personopplysninger uten ugrunnet opphold.',
        },
        '404a3576_dd84_4bac_acf4_29719615c45e': {
            title: '[[TOK_0]] for høyrisikobehandling',
            description: 'En konsekvensutredning for databeskyttelse må utføres for behandlingsaktiviteter som sannsynligvis vil resultere i høy risiko.',
        },
        '29d9ed94_9360_457c_9aca_37aefac66969': {
            title: 'Grenseoverskridende overføringsvurdering',
            description: 'En konsekvensutredning må gjennomføres før overføring av personopplysninger utenfor Vietnam.',
        },
        '9620ff08_b83c_4e1f_9350_eba835b145fe': {
            title: 'Registrering av behandlingsaktiviteter',
            description: 'Behandlingsansvarlige må føre en journal over behandlingsaktiviteter (RoPA) som dokumenterer alle behandlingsaktiviteter.',
        },
        '96ee0ff3_3ead_431e_aa57_08ccff4821fc': {
            title: 'Databehandleravtaleregister',
            description: 'Det skal føres journal over databehandleravtaler med behandlere og underbehandlere.',
        },
        '434dc319_1922_49e4_b757_37622135c4b2': {
            title: 'Beskyttelse av grenseoverskridende overføringer',
            description: 'Overføring av personopplysninger utenfor Vietnam krever passende sikkerhetstiltak og dokumenterte vurderinger.',
        },
        '3372c651_d5a8_4cae_ae57_2fc684ad0768': {
            title: 'Bekreftelse innen 2 virkedager',
            description: 'Registrerte forespørsler må bekreftes innen 2 virkedager etter mottak.',
        },
        b15fa62d_3f52_4e42_8442_f4969e08883a: {
            title: 'Ferdigstillelse innen 15 virkedager',
            description: 'Registrerte forespørsler må fullføres innen 15 virkedager, med en mulig forlengelse på 5 virkedager.',
        },
        '5d81233c_f671_4827_b874_827762edfc20': {
            title: 'Innlevering av MoPS konsekvensvurderingsmapp',
            description: 'Organisasjoner som utfører høyrisikobehandling må sende inn en konsekvensutredningssak til departementet for offentlig sikkerhet ved å bruke den foreskrevne administrative prosedyren.',
        },
        '83bf5bf8_edbd_4f0a_9f8e_5f47db01324d': {
            title: 'MoPS arkivering av grenseoverskridende overføringer',
            description: 'Organisasjoner som overfører personopplysninger utenfor Vietnam, må sende inn en konsekvensvurderingsdossier for grenseoverskridende overføring til departementet for offentlig sikkerhet.',
        },
        '9454e465_e618_4b6f_80b3_d79fdd9cc5cb': {
            title: 'Behandler sertifisering av tjenesteleverandør',
            description: 'Organisasjoner som yter personopplysningsbehandling som en tjeneste må innhente et tjenestebehandlingssertifikat fra departementet for offentlig sikkerhet.',
        },
        b88aec34_046a_4e0a_9c77_ddad27ea4bc4: {
            title: 'Behandling av konsekvensutredningsdossier når triggere er oppfylt',
            description: 'En saksbehandlingssak må innleveres når foreskrevne triggere er oppfylt.',
        },
        '9d34a206_b85e_4649_a23b_e2c6f1398402': {
            title: 'Dokumentasjon for grenseoverskridende overføring',
            description: 'En grenseoverskridende overføringskonsekvensdossier må utarbeides og arkiveres for internasjonale dataoverføringer.',
        },
        '210d3ec3_e6f2_424b_ae25_cad76bc13320': {
            title: 'Utpeking av personvernombud',
            description: 'En personvernombud må utpekes slik dekret 13 krever.',
        },
        '776183b2_2797_40e8_8d81_c4f512c566d2': {
            title: 'Styringsartefakter (policyer, roller, prosedyrer)',
            description: 'Styringsartefakter, inkludert retningslinjer, roller og prosedyrer, må opprettholdes.',
        },
        '4f1385f1_6dfc_4368_b4af_1040cd3f77b7': {
            title: 'Fullstendighet i bevispakken og uforanderlig revisjonsspor',
            description: 'Bevispakker må være komplette og et uforanderlig revisjonsspor må opprettholdes.',
        },
        f6826e26_8991_4a0f_9117_481490230bdd: {
            title: 'Støtte for arbeidsflyt for arkivering',
            description: 'Arbeidsflyter for innlevering av sak må støttes for konsekvensutredning og grenseoverskridende sakssaker.',
        },
        '8a28ee33_305a_491f_a93f_90e59f8da91b': {
            title: 'Behandler kontraktsmessige krav',
            description: 'Kontraktskrav til databehandlere skal etableres og overvåkes.',
        },
        '4fd36e83_8286_40e0_b9b2_a4bc5e8377b3': {
            title: '�&rlig etterlevelsesgjennomgang',
            description: 'En årlig overholdelsesgjennomgang må gjennomføres for å verifisere løpende etterlevelse.',
        },
        '8b6b6c13_0d32_4439_819f_4bd8cff02217': {
            title: 'Myndighetsarkivering av innsendingsposter',
            description: 'Registreringer over alle innleveringer fra myndighetene må opprettholdes.',
        },
        e7ce6c23_03dc_42dd_bccd_fa571c3afee3: {
            title: 'Lovlig grunnlag for behandling av personopplysninger',
            description: 'Behandling av personopplysninger må være basert på lovlige grunnlag som definert av [[TOK_0]].',
        },
        c919c66c_6a74_4403_bb97_04b773d270bf: {
            title: 'Samtykkekrav for sensitive data',
            description: 'Behandling av sensitive personopplysninger krever uttrykkelig samtykke med spesifikke krav.',
        },
        '419cc7c3_a257_4293_a054_304dc2fcb8df': {
            title: 'Registrerte rettigheter (tilgang, retting, sletting, begrense, gjenstand, portabilitet)',
            description: 'Registrerte har omfattende rettigheter, inkludert tilgang, retting, sletting, begrensning, innsigelse og portabilitet.',
        },
        '638e6e25_3a74_4864_8bff_8e21ab82860b': {
            title: 'Bruddmelding til myndighet',
            description: 'Behandlingsansvarlige må varsle vedkommende myndighet om brudd på personopplysninger innen den fastsatte tidsrammen.',
        },
        '6e75c111_66b1_4726_8c27_6537846edb30': {
            title: 'Bruddvarsling til registrerte',
            description: 'Behandlingsansvarlige skal varsle berørte registrerte om brudd på personopplysninger.',
        },
        f686123d_3bdd_4a61_a53c_efe5b52d9058: {
            title: 'Konsekvensvurdering av databeskyttelse',
            description: 'En konsekvensutredning for databeskyttelse må gjennomføres for behandlingsaktiviteter med høy risiko.',
        },
        '554ea5b6_092d_4295_a57a_1bd9b2eef291': {
            title: 'Styring av grenseoverskridende overføringer',
            description: 'Grenseoverskridende overføringer av personopplysninger må være i samsvar med styringskrav.',
        },
        cf9a5b29_46fd_4072_b877_13b8a69df82c: {
            title: 'Utpeking av personvernombud',
            description: 'Organisasjoner må utpeke en personvernansvarlig etter behov.',
        },
        f5a4965d_eb0c_47df_9933_f185ae46463b: {
            title: 'Registrering av behandlingsaktiviteter',
            description: 'Organisasjoner må føre oversikt over alle behandlingsaktiviteter.',
        },
        ce8986ff_684d_41ec_8147_b3f2a1c5206c: {
            title: 'Behandler kontraktsmessige forpliktelser',
            description: 'Kontraktsforpliktelser må etableres med databehandlere.',
        },
        '7a3d7554_7b6f_49d7_8864_4a5cd71fd6bd': {
            title: 'Innlevering av konsekvensanalyser',
            description: 'Dokumenter for konsekvensutredning må innleveres til vedkommende myndighet som foreskrevet.',
        },
        '65dba62f_0788_44c1_89e3_09d802e28eb9': {
            title: 'Dokumentasjon for grenseoverskridende overføring',
            description: 'En grenseoverskridende overføringskonsekvensdossier må utarbeides og arkiveres for internasjonale dataoverføringer.',
        },
        '0eccb520_b1fa_4fa3_a3ab_2d30823dd00e': {
            title: '[[TOK_0]] avtale og varsling',
            description: 'Det skal oppnevnes en personvernombud og myndigheten varsles.',
        },
        '43ead19e_982a_4615_bafd_e6a3a4e80b3a': {
            title: 'Retningslinjer og prosedyrer for styring',
            description: 'Retningslinjer og prosedyrer for styring må etableres og vedlikeholdes.',
        },
        '9ebc7a42_e1f1_49c4_ac90_22a691fd2219': {
            title: 'Bevispakke og uforanderlig revisjonsspor',
            description: 'Bevispakker må være komplette og et uforanderlig revisjonsspor må opprettholdes.',
        },
        '5b0ba1c0_7b86_4c80_b9f9_26e4ff9652c2': {
            title: 'Innleveringssaks livssyklus',
            description: 'Livssykluser for innlevering av sak må administreres gjennom foreskrevne stadier.',
        },
        '83f2f346_47bb_4377_a711_3cef26742f39': {
            title: 'Behandler kontraktsmessige krav',
            description: 'Kontraktskrav til databehandlere skal etableres og overvåkes.',
        },
        cb972e06_f773_492e_8ad5_f65d1e999b79: {
            title: 'Tjenestebehandlingsleverandørsertifisering',
            description: 'Organisasjoner som leverer databehandlingstjenester må få sertifisering.',
        },
        '4ba36ab5_39f0_4d79_927e_c39587bed226': {
            title: 'Myndighetsarkivering av innsendingsposter',
            description: 'Registreringer over alle innleveringer fra myndighetene må opprettholdes.',
        },
        f7a62c88_3cda_4031_bc52_1598661a5128: {
            title: '�&rlig etterlevelsesgjennomgang',
            description: 'En årlig overholdelsesgjennomgang må gjennomføres for å verifisere løpende etterlevelse.',
        },
        '3e97f4d4_60ad_46a8_ad2b_615d4ca04aee': {
            title: 'Datasikkerhetstekniske tiltak',
            description: 'Tekniske tiltak for datasikkerhet skal implementeres og vedlikeholdes.',
        },
        '45f4e745_a923_4879_94ce_5a2b41b7e886': {
            title: 'Dekret 356 offisielle krav til Mẫu s�',
            description: 'De 13 offisielle Mẫu s� administrative prosedyreskjemaene (Mẫu s� 01a�10) foreskrevet ved dekret [[TOK_0]]Đ-CP må brukes for de tilsvarende innleveringene til departementet for offentlig sikkerhet. Phụ lục I�VIII-elementene er interne datastrukturkartlegginger, ikke offisielle reguleringsskjemaer.',
        },
        ff452604_7461_4c12_aeab_cb7dd1fb5ba3: {
            title: '[[TOK_0]] innsending av dossier til A05',
            description: 'Organisasjoner må sende inn [TOK_0]] dossierer til A05/[[TOK_1]] for behandlingsaktiviteter som involverer sensitive personopplysninger eller storskala behandling.',
        },
        '003600ae_7a0f_4034_b206_72f59409b8f3': {
            title: 'Innsending av sakspapir for grenseoverskridende overføring',
            description: 'Organisasjoner må sende inn dokumentasjon for grenseoverskridende dataoverføring for A05/[TOK_0]] gjennomgang og godkjenning.',
        },
        '4632b20c_293a_4c7e_968e_4ce178c3b7d8': {
            title: 'Behandler søknad om tjenestesertifikat',
            description: 'Leverandører av databehandlingstjenester må søke om sertifikater fra A05/[[TOK_0]].',
        },
        be96add4_ebdb_4b6c_9426_4dc87b7cd2ce: {
            title: 'Varsel om behandling av personopplysninger',
            description: 'Behandlingsansvarlige må varsle A05/[[TOK_0]] om behandling av personopplysninger ved bruk av foreskrevne skjemaer (Mẫu s� 01a/01b).',
        },
        '39f50471_27cc_46bd_acff_9aa2211d43ab': {
            title: '�&rlig situasjonsrapportering',
            description: 'Behandlingsansvarlige må levere årlige situasjonsrapporter for behandling av personopplysninger (Mẫu s� 09).',
        },
        '3b45c6fa_d66a_448a_9ff1_597caa055e09': {
            title: 'Brukerinformasjon konfidensialitet som standard',
            description: 'Brukerinformasjon må behandles som konfidensiell som standard.',
        },
        '2994510e_b1f8_4cdd_947c_d9542746433b': {
            title: 'Minimum organisatoriske og tekniske beskyttelseskontroller',
            description: 'Minimum organisatoriske og tekniske vernekontroller må implementeres.',
        },
        '8643160f_9a10_4d93_baf5_082c6a7c768a': {
            title: 'Avsløring kun med riktig grunnlag',
            description: 'Utlevering av brukerinformasjon er kun tillatt med et forsvarlig juridisk grunnlag.',
        },
        c1fb7d85_fdc0_402e_ab0c_ff134bd72dfa: {
            title: 'Obligatorisk avsløringslogging og revisjonerbarhet',
            description: 'Alle avsløringer må logges og revideres.',
        },
        efa36bc0_abae_417a_b676_9509af37f89d: {
            title: 'Intern godkjenningsarbeidsflyt for avsløringer',
            description: 'Det må etableres en intern godkjenningsarbeidsflyt for alle avsløringer.',
        },
        d086fdcd_9a23_4500_893c_db8ac62bd787: {
            title: 'Behandling av svar fra myndighetsforespørsel',
            description: 'Myndighetsforespørsler skal håndteres og besvares i henhold til foreskrevne prosedyrer.',
        },
    },
    framework_rights_descriptions: {
        be_informed: 'Den registrerte har rett til å bli informert om behandling av personopplysninger.',
        consent: 'Den registrerte har rett til å samtykke til behandling av sine personopplysninger.',
        refuse_consent: 'Den registrerte har rett til å ikke samtykke til behandling av sine personopplysninger.',
        withdraw_consent: 'Den registrerte har rett til å be om tilbaketrekking av tidligere gitt samtykke.',
        access: 'Den registrerte har rett til å se og få tilgang til sine personopplysninger som den behandlingsansvarlige har.',
        rectification: 'Den registrerte har rett til å korrigere eller be om retting av unøyaktige personopplysninger.',
        data_provision: 'Den registrerte har rett til å be om utlevering av sine personopplysninger (yêu cầu cung cấp dữ li�!u cá nhân).',
        deletion: 'Den registrerte har rett til å be om sletting eller destruksjon av personopplysninger, med forbehold om lovens unntak.',
        restriction_of_processing: 'Den registrerte har rett til å be om begrensning av behandlingen av sine personopplysninger.',
        object_to_processing: 'Den registrerte har rett til å sende en forespørsel som protesterer mot behandlingen av deres personopplysninger.',
        complaint: 'Den registrerte har rett til å sende inn en klage (khiếu nại) angående behandling av personopplysninger.',
        denunciation: 'Den registrerte har rett til å gjøre en oppsigelse (t� cáo) angående brudd på personopplysningsbeskyttelsen.',
        lawsuit: 'Den registrerte har rett til å reise rettslige skritt (kh�xi ki�!n) for brudd på deres databeskyttelsesrettigheter.',
        claim_damages: 'Den registrerte har rett til å kreve erstatning for skade forårsaket av brudd på personopplysningsbeskyttelsen.',
        request_protection_measures: 'Den registrerte har rett til å be kompetente myndigheter eller relevante organisasjoner/enkeltpersoner om å iverksette tiltak for å beskytte sine personopplysninger.',
    },
    framework_procedures: {
        VN_DP_DRAFT_P7: {
            name: 'Risikostyring og overvåking (utkast)',
            steps: {
                '1': 'Identifiser risikokategorier',
                '2': 'Oppretthold tidlig varslingskontroller',
                '3': 'Gjennomgå risikoer for innsamling, lagring, behandling, deling og transaksjoner',
                '4': 'Registrer risikoer for personvern, cybersikkerhet og tilgangsadministrasjon',
                '5': 'Utløs utbedringshandlinger',
                '6': 'Ta vare på anmeldelsesloggen',
            },
        },
        VN_DP_DRAFT_P6: {
            name: 'Klager og tvister (utkast)',
            steps: {
                '1': 'Motta klage/tvistinntak',
                '2': 'Sjekk fullstendigheten av nødvendig informasjon; be om tillegg innen 24 timer hvis ufullstendig',
                '3': 'Innen 3 virkedager etter å ha mottatt en fullstendig forespørsel, varsle partene om håndteringstilnærming og forventet tidslinje',
                '4': 'Be om svar og støttedokumenter',
                '5': 'Vurder tvistefakta og plattformansvar',
                '6': 'Rekordoppløsningsresultat',
                '7': 'Ta vare på bevis og avslutt sak',
            },
        },
        VN_DP_DRAFT_P5: {
            name: 'Levering og sertifikat for eiendomsrett til data (utkast)',
            steps: {
                '1': 'Levere produkt/tjeneste etter kontraktsmetode',
                '2': 'Registrer leveringshendelse og tidspunkt',
                '3': 'Generer sertifikat for eiendomsrett over data',
                '4': 'Registrer transaksjonsfullføring',
                '5': 'Aktiver senere oppslag/verifisering der det er nødvendig',
            },
        },
        VN_DP_DRAFT_P4: {
            name: 'Transaksjonsinitiering og kontrahering (utkast)',
            steps: {
                '1': 'Gjennomgå oppføring og evalueringsresultat',
                '2': 'Start arbeidsflyt for kjøp, forhandlinger eller auksjon',
                '3': 'Generer elektronisk kontrakt',
                '4': 'Sikre begge parters aksept',
                '5': 'Registrer fullføring av betaling',
                '6': 'Godkjenne levering',
            },
        },
        VN_DP_DRAFT_P3: {
            name: 'Tilgang til sandkasse/testmiljø (utkast)',
            steps: {
                '1': 'Send inn sandkasseforespørsel',
                '2': 'Definer omfang, tillatte data, tidsperiode og behandlingstillatelser',
                '3': 'Tilveiebringe isolert teknisk miljø',
                '4': 'Overvåk sikkerhet og tilgang under testing',
                '5': 'Gjennomgå utdata før ekstraksjon',
                '6': 'Godkjenn uttak kun der det er tillatt',
                '7': 'Lukk testøkt og ryd opp i miljøet',
            },
        },
        VN_DP_DRAFT_P2: {
            name: 'Dataprodukt-/tjenesteoppføring (utkast)',
            steps: {
                '1': 'Opprett oppføringsapplikasjon',
                '2': 'Fang kilde og eierskap / bruksrett bevis',
                '3': 'Registrer tekniske egenskaper, format, [[TOK_0]] detaljer og begrensninger',
                '4': 'Avsløringer av rekordkvalitet',
                '5': 'Send inn oppføringsdossier til plattformgjennomgang',
                '6': 'Plattform utfører fullstendighet, lovlighet og tekniske kontroller',
                '7': 'Godkjenne eller avslå oppføringen',
                '8': 'Hvis godkjent, publiser oppføringen med vedlagt evalueringsresultat',
            },
        },
        VN_DP_DRAFT_P1: {
            name: 'Deltaker onboarding (utkast)',
            steps: {
                '1': 'Bestem deltakertype: selger eller kjøper',
                '2': 'Bekreft juridisk status og rettslig kapasitet',
                '3': 'Bekreft tilleggsbetingelser hvis betingede forretningslinjer gjelder',
                '4': 'Registrer transaksjonskonto',
                '5': 'Koble til betalingskonto',
                '6': 'Godkjenne plattformdeltakelse',
                '7': 'Lagre deltakerregistrering og revisjonsspor',
            },
        },
        AI_A1: {
            name: '[[TOK_0]] Systemregistrering/varsling',
            steps: {
                '1': 'Anvendelseskontroll og [[TOK_0]] systemklassifisering',
                '2': 'Bygg registrerings-/varslingsdossier',
                '3': 'Intern godkjenning',
                '4': 'Send inn via kanal',
                '5': 'Endringssløyfe � hvis returnert, oppdater og send inn på nytt',
                '6': 'Lukk og lagre bekreftelse',
            },
        },
        AI_A2: {
            name: '[[TOK_0]] Arbeidsflyt for risikoklassifisering',
            steps: {
                '1': 'Opprett [[TOK_0]] systemregisteroppføring',
                '2': 'Kjør klassifiseringsveiviseren',
                '3': 'Legg ved bevis',
                '4': 'Godkjenne klassifisering',
                '5': 'Koble utdata til systemdossier',
            },
        },
        AI_A3: {
            name: 'Overholdelse av merking og avsløring',
            steps: {
                '1': 'Identifiser merkingsforpliktelser etter system og brukstilfelle',
                '2': 'Implementer merkingsmerknader',
                '3': 'Ta bevis � skjermbilder, UI-kopi, tekniske metadata',
                '4': 'Håndtere unntak og registrere begrunnelse',
                '5': 'Godkjenne og versjon',
            },
        },
        AI_A4: {
            name: 'Rapportering av alvorlige hendelser',
            steps: {
                '1': 'Opprett [[TOK_0]] hendelsespost',
                '2': 'Klassifiser alvorlighetsgrad',
                '3': 'Utfør inneslutningshandlinger og bevisfangst',
                '4': 'Generer maleksport for alvorlig hendelsesrapport',
                '5': 'Send til autoritet via kanal',
                '6': 'Spor myndighetssvar og stenging',
            },
        },
        AI_A5: {
            name: '[[TOK_0]] Konsekvensanalyse',
            steps: {
                '1': 'Opprett vurderingspost',
                '2': 'Fyll inn nødvendige seksjoner',
                '3': 'Legg ved bevis � dataflyter, modelldokumentasjon, kontroller',
                '4': 'Intern godkjenning',
                '5': 'Eksporter rapport og lagre i dossier',
            },
        },
        AI_A6: {
            name: 'Kontrollert testing / Sandbox-deltakelse',
            steps: {
                '1': 'Fullfør kvalifikasjons- og beredskapsjournal',
                '2': 'Forbered søknad og eksport',
                '3': 'Send inn via kanal',
                '4': 'Spor godkjenning',
                '5': 'Utfør overvåkingssjekkpunkter og logger',
                '6': 'Fullfør ferdigstillelsesrapport og avslutningspakke',
            },
        },
        CYBERSEC_C1: {
            name: 'Sikkerhetsvurdering av kritisk informasjonssystem',
            steps: {
                '1': 'Klassifisere informasjonssystemer i henhold til nasjonale cybersikkerhetskrav',
                '2': 'Gjennomføre sikkerhetsvurdering og risikoevaluering for klassifiserte systemer',
                '3': 'Implementer nødvendige sikkerhetstiltak og basiskontroller',
                '4': 'Dokumenter bevis på samsvar og planlegg periodiske gjennomganger',
            },
        },
        CYBERSEC_C2: {
            name: 'Varsling om cybersikkerhetshendelser',
            steps: {
                '1': 'Oppdag, klassifiser og vurder cybersikkerhetshendelsen',
                '2': 'Utfør umiddelbare reaksjonshandlinger og bevisbevaring',
                '3': 'Rapportere til myndighet og delta i nasjonal koordinering av hendelse-respons',
                '4': 'Gjennomfør gjennomgang etter hendelsen og dokumenter erfaringer',
            },
        },
        CYBERSEC_C3: {
            name: 'Verifikasjon av overholdelse av datalokalisering',
            steps: {
                '1': 'Vurder om datalokaliseringsutløsere gjelder basert på tjenestetype og datakategorier',
                '2': 'Kontroller at lokal lagringsarkitektur og grenseoverskridende flytkontroller er på plass',
                '3': 'Vurder krav til lokal tilstedeværelse (filial / representasjonskontor) der det er aktuelt',
                '4': 'Dokumenter samsvarsbevis og vedlikehold for myndighetsgjennomgang',
            },
        },
        CYBERSEC_C4: {
            name: 'Myndighetssamarbeidsforespørselssvar',
            steps: {
                '1': 'Motta og verifisere legitimiteten og omfanget av myndighetsforespørselen',
                '2': 'Samle og klargjør forespurt informasjon eller utfør nødvendige handlinger',
                '3': 'Send svar til myndigheten innen den nødvendige tidslinjen',
                '4': 'Logg avsløringen og lukk saken',
            },
        },
        CYBERSEC_C5: {
            name: 'Verifisering av kvalifisering for cybersikkerhetspersonell',
            steps: {
                '1': 'Vurder leverandørens sikkerhetsstilling ved å bruke rammeverket for vurdering av nettsikkerhet',
                '2': 'Bekreft leverandørdatatilgangsomfanget og registrer i leverandørdatatilgangsloggen',
                '3': 'Gjennomgå varslingsklausulen for leverandørhendelser og kontraktsfestede krav til cybersikkerhet',
                '4': 'Planlegg periodiske leverandørsikkerhetsgjennomganger og overvåk overholdelse',
            },
        },
        DATA_D1: {
            name: 'Datainventar og klassifiseringsoppsett',
            steps: {
                '1': 'Katalisere alle dataressurser med typer og kilder i datalagerregisteret',
                '2': 'Klassifiser hver eiendel etter følsomhetsnivå',
                '3': 'Definer håndteringsregler per klassifiseringsnivå',
                '4': 'Ta bevis � skjermbilder, arkitekturdiagrammer, tilgangskontroller',
                '5': 'Planlegg periodiske gjennomganger',
            },
        },
        DATA_D2: {
            name: 'Datadelingsstyring',
            steps: {
                '1': 'Evaluer nye delingsordninger via risikovurdering for datadeling',
                '2': 'Fullfør arbeidsflyt for intern godkjenning',
                '3': 'Registrer delingshendelse i datadeling/avsløringslogg',
                '4': 'Ta bevis � godkjenningsdokumenter, kontraktsdokumenter',
                '5': 'Periodisk gjennomgang av delingsordninger',
            },
        },
        DATA_D3: {
            name: 'Grenseoverskridende dataoverføringsvurdering',
            steps: {
                '1': 'Identifiser grenseoverskridende overføringer i databeholdning',
                '2': 'Gjennomfør overføringsrisikovurdering',
                '3': 'Bruk sikkerhetstiltak og styringstiltak',
                '4': 'Dokument i grenseoverskridende del av styringsattest',
                '5': 'Eksportvurderingspakke for revisjon',
            },
        },
        DATA_D4: {
            name: '�&rlig styringsattest',
            steps: {
                '1': 'Gjennomgå governance RACI matrise',
                '2': 'Bekreft policystatus (styring, klassifisering, deling, oppbevaring)',
                '3': 'Komplett attestasjonspakke',
                '4': 'Få intern godkjenning',
                '5': 'Eksportere og arkivere attestering',
            },
        },
        DATA_D5: {
            name: 'Håndtering av datahendelser',
            steps: {
                '1': 'Klassifiser hendelsen ved hjelp av beslutningsprotokoll',
                '2': 'Utfør hendelsesrespons per spillebok',
                '3': 'Ta bevis � logger, skjermbilder, kommunikasjon',
                '4': 'Utfør gjennomgang etter hendelsen',
                '5': 'Hvis myndighetsvarsling kreves: opprett innsendingssak og send inn til [[TOK_0]]',
                '6': 'Lukk og arkiver',
            },
        },
        ECOM_P1: {
            name: 'Varsling (salgsnettsted/app)',
            steps: {
                '1': 'Bestem klassifisering: salgsside/app vs markedsplass/tjenesteplattform',
                '2': 'Opprett intern dossieroppføring med firmaidentitet, informasjon om nettsted/app og nødvendige avsløringer',
                '3': 'Generer bevispakke � skjermbilder av avsløringer, policy-URLer, versjonshistorikk',
                '4': 'Send inn via Online.gov.vn � last opp dokumenter, registrer tidsstempel og bekreftelse',
                '5': 'Spor behandling � hvis den returneres for endring, registrer årsaker og send inn på nytt',
                '6': 'Lukk � butikkbekreftelse, koblingsbevis og revisjonsspor',
            },
        },
        ECOM_P2: {
            name: 'Registrering (tjenesteplattformer / markedsplasser)',
            steps: {
                '1': 'Bestem plattformmodell og forpliktelser - markedsplass vs blandet vs sosial handel',
                '2': 'Bygg registreringsdossier � søknadsskjema, tjenesteordning, vilkår og betingelser, plattformregler',
                '3': 'Interne godkjenninger � tildel juridisk/samsvarseier, godkjenn for innsending',
                '4': 'Send inn via Online.gov.vn � last opp dossier, registrer tidsstempel',
                '5': 'Behandlingssløyfe - hvis returnert for endring, oppdater og send inn på nytt',
                '6': 'Godkjenning og operasjonalisering � butikkbekreftelse, vedlikeholde løpende samsvarsregistre',
            },
        },
        ECOM_P3: {
            name: 'Oppdater/endre varsling',
            steps: {
                '1': 'Identifiser endringsutløser � materiell endring i dossierelementer',
                '2': 'Generer endringspakke � endringssammendrag, oppdaterte dokumenter, bevisoppdateringer',
                '3': 'Send inn oppdatering og noter innsendingsstatus',
                '4': 'Spor behandling og lukk',
            },
        },
        ECOM_P4: {
            name: 'Oppsigelse / deaktivering',
            steps: {
                '1': 'Forbered oppsigelsespakke - opphørsdato, årsak, håndteringsplan for forbrukerbeskyttelse, bevis på offentlig varsel',
                '2': 'Send oppsigelse � registrer tidsstempel og bekreftelse',
                '3': 'Lukk � lagre endelig status og bevis',
            },
        },
        ECOM_P5: {
            name: 'Trustmark / Troverdighetsvurderingsprogram',
            steps: {
                '1': 'Kvalifikasjons- og beredskapsvurdering',
                '2': 'Forbered dokumentasjon ved å bruke offisielt skjema',
                '3': 'Send inn og spor',
                '4': 'Oppretthold løpende samsvarsbevis',
            },
        },
        PDPL_P1: {
            name: '[[TOK_0]] Innlevering til [[TOK_1]]',
            steps: {
                '1': 'Fullfør [[TOK_0]] ved å bruke dekret 356 skjemavei (Mẫu s� 02a/02b)',
                '2': 'Samle omslagsdokumenter og støttebevis',
                '3': 'Send inn én original dossier til departementet for offentlig sikkerhet ([[TOK_0]])',
                '4': 'Overvåk etter forespørsler om tillegg fra [[TOK_0]] og svar innen fristen',
                '5': 'Ta vare på dossier og bevis for innsending for revisjonsspor',
            },
        },
        PDPL_P2: {
            name: 'Søknad om grenseoverskridende overføring',
            steps: {
                '1': 'Fullfør dokumentasjon for grenseoverskridende overføring ved hjelp av dekret 356-skjemaer (Mẫu s� 01a/01b, Mẫu s� 09)',
                '2': 'Send inn ett originalt dokument til [[TOK_0]] innen 60 dager etter at behandlingen startet',
                '3': 'Gi beskjed til [[TOK_0]] etter vellykket overføring med kontaktinformasjon til mottakende part',
                '4': 'Svar på forespørsler om tillegg/korrigering/inspeksjon fra [[TOK_0]] innen fristen',
            },
        },
        PDPL_P3: {
            name: 'Søknad om sertifikat for databehandlingstjeneste',
            steps: {
                '1': 'Forbered sertifiseringssøknadsmapper i henhold til dekret 356 krav',
                '2': 'Send inn søknad til [[TOK_0]] med nødvendige støttedokumenter',
                '3': 'Svar på [[TOK_0]] vurderingskommentarer og forespørsler om tillegg',
                '4': 'Opprettholde sertifikat og fornyelsesplan',
            },
        },
        PDPL_P4: {
            name: 'Behandling av forespørsel om datasubjektrettigheter',
            steps: {
                '1': 'Motta og logg forespørsel; bekrefte identiteten til den registrerte innen 2 virkedager',
                '2': 'Vurder forespørselstype og bestem gjeldende frist (10/15/20 dager etter type)',
                '3': 'Utfør oppfyllelseshandlinger på tvers av relevante systemer og avdelinger',
                '4': 'Forbered og send svar til den registrerte med utfall og begrunnelse',
                '5': 'Avslutt sak og oppbevar bevis for revisjon; dokumentere eventuelle avslagsbegrunnelser',
            },
        },
        PDPL_P5: {
            name: 'Bruddvarsel til [[TOK_0]]',
            steps: {
                '1': 'oppdage og vurdere bruddet; fastsette meldeplikt innen 2 virkedager',
                '2': 'Forbered varslingspakke i henhold til [[TOK_0]] krav',
                '3': 'Send melding til [[TOK_0]] innen 2 virkedager etter oppdagelse',
                '4': 'Svar på [[TOK_0]] oppfølgingsforespørsler; sende inn tillegg og koordineringsbevis',
            },
        },
        TELECOM_T1: {
            name: 'Håndtering av myndighetsforespørsel',
            steps: {
                '1': 'Motta og logg myndighetsforespørselen via inntakspost',
                '2': 'Bekreft myndighetsidentitet, juridisk grunnlag og forespørselsomfang',
                '3': 'Gjennomfør intern juridisk gjennomgang og innhent godkjenning fra ledelsen',
                '4': 'Forbered svarpakke med samlet bevis',
                '5': 'Utkast og godkjenne svarbrev',
                '6': 'Opprett innsendingssak og send inn svar via kanal',
                '7': 'Loggavsløring og spormyndighetsbekreftelse',
                '8': 'Lukk saken og oppbevar bevis for revisjonsspor',
            },
        },
        TELECOM_T2: {
            name: 'Disclosure Management',
            steps: {
                '1': 'Motta forespørsel om offentliggjøring (brukersamtykke, juridisk forpliktelse eller myndighetsforespørsel)',
                '2': 'Fullfør arbeidsflyt for godkjenning av avsløring',
                '3': 'Utfør avsløring og registrer i loggregister',
                '4': 'Fang bevis - godkjenningsposter, kommunikasjonsposter',
                '5': 'Periodisk gjennomgang av avsløringslogg',
            },
        },
        TELECOM_T3: {
            name: 'Konfidensialitetspolicy og oppsett av tilgangskontroll',
            steps: {
                '1': 'Utforme og godkjenne retningslinjer for konfidensialitet',
                '2': 'Utforme og godkjenne retningslinjer for tilgangskontroll og logging',
                '3': 'Dokumentbehandlingsaktiviteter i brukerinformasjonsbehandlingsregister',
                '4': 'Fang bevis � policydokumenter, implementeringsbevis',
                '5': 'Planlegg periodiske gjennomganger',
            },
        },
        TELECOM_T4: {
            name: 'Telekom hendelsesvurdering',
            steps: {
                '1': 'Klassifisere og vurdere hendelsen',
                '2': 'Bestem varslingskrav',
                '3': 'Hvis myndighetsvarsel kreves: opprette innsendingssak',
                '4': 'Fange og ta vare på bevis',
                '5': 'Oppløsning og lukking',
            },
        },
        TELECOM_T5: {
            name: 'Håndtering av oppbevaring og sletting',
            steps: {
                '1': 'Definer oppbevaring og slettingsplan per datakategori',
                '2': 'Implementer sletteprosedyrer',
                '3': 'Ta bevis � sletting av poster',
                '4': 'Periodisk gjennomgang av timeplaner',
            },
        },
    },
    framework_fines: {
        VN_CYBERSEC_LAW: {
            'CYBERSEC-FINE-A': 'Hendelseshåndtering og rapporteringsfeil',
            'CYBERSEC-FINE-B': 'Systemsikkerhetsovervåking og grunnlinjekontrollfeil',
            'CYBERSEC-FINE-C': 'Samarbeidssvikt for myndighetsforespørsel',
            'CYBERSEC-FINE-D': 'Datalokalisering og brudd på lokal tilstedeværelse',
            'CYBERSEC-FINE-E': 'Forebygging av skadelig programvare og systembeskyttelsesfeil',
            'CYBERSEC-FINE-F': 'Svarfeil på plattform/tjenesteleverandør',
            'CYBERSEC-FINE-G': 'Leverandør/tredjeparts sikkerhetsfeil',
        },
        VN_ECOMMERCE_LAW_2025: {
            'ECOM-FINE-A': 'Registrering / Varsling / Administrativ beredskap',
            'ECOM-FINE-B': 'Klager og forbrukerbeskyttelse',
            'ECOM-FINE-C': 'Overvåking og fjerningshåndhevelse',
            'ECOM-FINE-D': 'Grenseoverskridende operasjoner',
            'ECOM-FINE-E': 'Plattformregler og åpenhet',
        },
        VN_PDPL: {
            'PDPL-FINE-A': 'Manglende oppførsel [[TOK_0]]',
            'PDPL-FINE-B': 'Uautorisert overføring over landegrensene',
            'PDPL-FINE-C': 'Behandling uten lovlig grunnlag',
            'PDPL-FINE-D': 'Unnlatelse av å svare på DSR',
            'PDPL-FINE-E': 'Unnlatelse av å varsle databrudd',
            'PDPL-FINE-F': 'Ikke-kompatibel behandlingsavtale',
            'PDPL-FINE-G': 'Brudd på sensitiv databehandling',
            'PDPL-FINE-H': 'Barns databehandlingsbrudd',
            'PDPL-FINE-I': 'Automatiserte brudd på beslutningstaking',
            'PDPL-FINE-J': 'Manglende etterlevelse av myndighetspålegg',
        },
        VN_TELECOM_LAW_2023: {
            'TELECOM-FINE-A': 'Håndtering av myndighetsforespørselsfeil',
            'TELECOM-FINE-B': 'Konfidensialitet og uautorisert avsløring',
            'TELECOM-FINE-C': 'Tilgangskontroll og loggingsfeil',
            'TELECOM-FINE-D': 'Oppbevaring og slettingsbrudd',
            'TELECOM-FINE-E': 'Feil ved vurdering av telekomhendelser',
        },
    },
    framework_fines_detail: {
        VN_TELECOM_LAW_2023: {
            'TELECOM-FINE-E': {
                fine_individual: 'Opptil 100 millioner VND',
                fine_org: 'Opptil 200 millioner VND',
                deadlines: 'Umiddelbart ved oppdagelse',
                remediation: [
                    'Obligatorisk klassifisering av hendingar',
                    'Obligatoriske registreringar av alvorlegheitsgrad og avgjerder',
                    'Obligatorisk sikring av bevis for konfidensialitetshendingar',
                    'Obligatorisk avslutning av hendinga i etterkant',
                ],
            },
            'TELECOM-FINE-D': {
                fine_individual: 'Opptil 100 millioner VND',
                fine_org: 'Opptil 200 millioner VND',
                deadlines: 'Løpende forpliktelse',
                remediation: [
                    'Obligatorisk innf�ring av oppbevaringsplan',
                    'Obligatorisk sikring av bevis for sletting',
                    'Obligatoriske avgjerdsregistreringar for unntak fr� oppbevaring',
                ],
            },
            'TELECOM-FINE-C': {
                fine_individual: 'Opptil 100 millioner VND',
                fine_org: 'Opptil 200 millioner VND',
                deadlines: 'Løpende forpliktelse',
                remediation: [
                    'Obligatorisk innf�ring av retningslinjer for tilgangskontroll',
                    'Obligatorisk logging av tilgangshendingar',
                    'Obligatorisk gjennomgang av tilgangsrettar',
                ],
            },
            'TELECOM-FINE-B': {
                fine_individual: 'Opptil 100 millioner VND',
                fine_org: 'Opptil 200 millioner VND',
                deadlines: 'Løpende forpliktelse',
                remediation: [
                    'Obligatorisk innf�ring av konfidensialitetsreglar',
                    'Obligatorisk arbeidsflyt for godkjenning av utlevering',
                    'Obligatorisk vedlikehald av spor for utlevering',
                    'Obligatorisk tilgangskontroll til brukaropplysningar',
                ],
            },
            'TELECOM-FINE-A': {
                fine_individual: 'Opptil 100 millioner VND',
                fine_org: 'Opptil 200 millioner VND',
                deadlines: 'Som angitt i myndighetsanmodningen',
                remediation: [
                    'Obligatorisk mottak og verifisering av myndigheitsanmodning',
                    'Obligatorisk svar innan fastsett frist',
                    'Obligatorisk registrering i utleveringsloggen',
                    'Obligatorisk sikring av bevis',
                ],
            },
        },
        VN_ECOMMERCE_LAW_2025: {
            'ECOM-FINE-E': {
                fine_individual: 'Opptil 80 millioner VND',
                fine_org: 'Opptil 160 millioner VND',
                deadlines: 'Løpende forpliktelse',
                remediation: [
                    'Obligatorisk publisering og versjonsstyring av plattformreglar',
                    'Obligatorisk informasjon ut mot brukarar',
                    'Obligatorisk dokumentasjon av plikter for seljarar, affiliatar og livestream-vertar',
                    'Obligatorisk historikk over kontrollar og godkjenningskjede',
                ],
            },
            'ECOM-FINE-D': {
                fine_individual: 'Opptil 80 millioner VND',
                fine_org: 'Opptil 160 millioner VND',
                deadlines: 'Løpende forpliktelse',
                remediation: [
                    'Obligatorisk vurdering av plikter ved grensekryssande verksemd',
                    'Obligatorisk beredskap hos autorisert representant',
                    'Obligatorisk register over grensekryssande drift',
                    'Obligatorisk dokumentasjon p� etterlevingstiltak',
                ],
            },
            'ECOM-FINE-C': {
                fine_individual: 'Opptil 80 millioner VND',
                fine_org: 'Opptil 160 millioner VND',
                deadlines: 'Løpende forpliktelse',
                remediation: [
                    'Obligatorisk gjennomgang av forbodne eller ulovlege oppf�ringar',
                    'Obligatoriske avgjerdsregistreringar for nedtaking',
                    'Obligatorisk sikring av bevis',
                    'Obligatorisk varsling til seljar og spor for lukking',
                ],
            },
            'ECOM-FINE-B': {
                fine_individual: 'Opptil 80 millioner VND',
                fine_org: 'Opptil 160 millioner VND',
                deadlines: 'Som spesifisert per klagebehandlingsforpliktelser',
                remediation: [
                    'Obligatorisk prosedyre for mottak av klager',
                    'Obligatorisk l�ysingsprotokoll',
                    'Obligatorisk revisjonsspor for klager',
                    'Obligatorisk eskalering ved problem med grensekryssande seljarar',
                ],
            },
            'ECOM-FINE-A': {
                fine_individual: 'Opptil 80 millioner VND',
                fine_org: 'Opptil 160 millioner VND',
                deadlines: 'Før du starter e-handel',
                remediation: [
                    'Obligatorisk klassifisering av plattforma',
                    'Obligatorisk fullf�ring av melding eller registrering',
                    'Obligatorisk dokumentasjon p� innsending via portalen',
                    'Obligatorisk sporing av oppdatering eller opph�yr',
                ],
            },
        },
        VN_CYBERSEC_LAW: {
            'CYBERSEC-FINE-G': {
                fine_individual: 'Opptil 100 millioner VND',
                fine_org: 'Opptil 200 millioner VND',
                deadlines: 'Løpende forpliktelse',
                remediation: [
                    'Obligatorisk tryggleiksvurdering av leverand�r',
                    'Obligatorisk tilgangskontroll til data hos leverand�r',
                    'Obligatorisk klausul om varsling av leverand�rhendingar',
                    'Obligatorisk periodisk tryggleiksgjennomgang av leverand�r',
                ],
            },
            'CYBERSEC-FINE-F': {
                fine_individual: 'Opptil 100 millioner VND',
                fine_org: 'Opptil 200 millioner VND',
                deadlines: 'Som spesifisert i myndighetsforespørsel',
                remediation: [
                    'Obligatorisk blokkering / nedtaking / sletting / f�rebygging etter myndigheitsanmodning',
                    'Obligatorisk utlevering av informasjon',
                    'Obligatorisk teknisk integrasjon eller samarbeid',
                    'Stans i tenesteleveranse / stans i tilkopling i visse tilfelle',
                ],
            },
            'CYBERSEC-FINE-E': {
                fine_individual: 'Opptil 100 millioner VND',
                fine_org: 'Opptil 200 millioner VND',
                deadlines: 'Løpende forpliktelse',
                remediation: [
                    'Obligatorisk innf�ring av tiltak mot skadevare',
                    'Obligatoriske filtreringssystem',
                    'Obligatorisk handling etter rettleiing fr� styresmaktene',
                    'Obligatoriske tekniske tiltak for f�rebygging/oppdaging/blokkering',
                ],
            },
            'CYBERSEC-FINE-D': {
                fine_individual: 'Opptil 100 millioner VND',
                fine_org: 'Opptil 200 millioner VND',
                deadlines: 'Som spesifisert i myndighetsvedtak; løpende forpliktelse der det utløses',
                remediation: [
                    'Obligatorisk lagring av data i Vietnam der det er p�kravd',
                    'Obligatorisk etablering av lokal filial / representasjonskontor',
                    'Obligatorisk oppbevaring av systemloggar for � st�tte gransking',
                    'Obligatorisk etterleving av vedtak om lokalisering fr� styresmaktene',
                ],
            },
            'CYBERSEC-FINE-C': {
                fine_individual: 'Opptil 100 millioner VND',
                fine_org: 'Opptil 200 millioner VND',
                deadlines: 'Som angitt i myndighetsanmodningen',
                remediation: [
                    'Obligatorisk utlevering av etterspurd informasjon',
                    'Obligatorisk etterleving av skriftlege p�legg',
                    'Obligatoriske nedtakings- / blokkerings- / f�rebyggingstiltak n�r det krevst',
                ],
            },
            'CYBERSEC-FINE-B': {
                fine_individual: 'Opptil 100 millioner VND',
                fine_org: 'Opptil 200 millioner VND',
                deadlines: 'Løpende forpliktelse; kontroller må være på plass før systemet tas i bruk',
                remediation: [
                    'Obligatorisk innf�ring av tryggleiksreglar og grunnleggjande kontrollar',
                    'Obligatorisk overvaking og vurdering av etterleving',
                    'Obligatorisk gjennomf�ring av p�kravde vernetiltak',
                    'Obligatorisk sletting / nedtaking / kontrolltiltak etter myndigheitsanmodning',
                ],
            },
            'CYBERSEC-FINE-A': {
                fine_individual: 'Opptil 100 millioner VND',
                fine_org: 'Opptil 200 millioner VND',
                deadlines: 'Umiddelbar respons kreves; rapportering innen fastsatt tidslinje',
                remediation: [
                    'Obligatorisk innf�ring av plan for hendingsrespons',
                    'Obligatorisk etablering av team for hendingsrespons',
                    'Obligatorisk deltaking i nasjonal samordning av hendingsrespons',
                    'Obligatorisk d�gnopen kontakt og oppbevaring av loggar',
                ],
            },
        },
        VN_PDPL: {
            'PDPL-FINE-A': {
                fine_individual: 'Opptil 1,5 milliarder VND',
                fine_org: 'Opptil 3 milliarder VND',
                deadlines: '60 dager fra påbegynt behandling for å sende inn dossier til [[TOK_0]]',
                remediation: [
                    'Obligatorisk fullf�ring og innsending av DPIA-dossier',
                    'Obligatorisk retting eller utfylling av dossier n�r det blir kravd',
                    'Obligatorisk oppbevaring av dossier',
                ],
            },
            'PDPL-FINE-B': {
                fine_individual: 'Opptil 1,5 milliarder VND',
                fine_org: 'Opptil 3 milliarder VND',
                revenue: '3�5 % av Vietnam-inntektene i fjor i alvorlige tilfeller',
                deadlines: '60 dager fra påbegynt behandling for å sende inn dossier til [[TOK_0]]; varsling etter overføring kreves',
                remediation: [
                    'Obligatorisk innsending av overf�ringsdossier',
                    'Obligatorisk retting av dossier n�r det blir kravd',
                    'Etterleving av krav ved kontroll av overf�ring',
                    'Obligatorisk varsling til [[TOK_0]] etter vellukka overf�ring',
                ],
            },
            'PDPL-FINE-C': {
                fine_individual: 'Opptil 1,5 milliarder VND',
                fine_org: 'Opptil 3 milliarder VND',
                deadlines: 'Løpende forpliktelse; samtykke må innhentes før behandling',
                remediation: [
                    'Obligatorisk stans i ulovleg behandling',
                    'Obligatorisk innf�ring av vernetiltak',
                    'Obligatorisk sletting / destruksjon av ulovleg behandla data',
                    'Tilbakef�ring av ulovleg vinst',
                ],
            },
            'PDPL-FINE-D': {
                fine_individual: 'Opptil 1,5 milliarder VND',
                fine_org: 'Opptil 3 milliarder VND',
                deadlines: '2 virkedager prosedyresvar; 10 dager tilgang/retting; 15 dager tilbaketrekning/begrensning/innsigelse; 20 dagers sletting',
                remediation: [
                    'Obligatorisk oppfylling av f�respurnad innan gjeldande frist',
                    'Obligatorisk varsling om manglande h�ve innan 2 virkedagar',
                    'Obligatorisk retting eller korrigering',
                    'Obligatorisk sletting med bevis',
                ],
            },
            'PDPL-FINE-E': {
                fine_individual: 'Opptil 1,5 milliarder VND',
                fine_org: 'Opptil 3 milliarder VND',
                deadlines: '2 virkedager på å varsle [[TOK_0]] etter å ha oppdaget et brudd',
                remediation: [
                    'Obligatorisk varsling til [[TOK_0]]',
                    'Obligatorisk retting / utfylling av varsling',
                    'Obligatorisk samordning med styresmaktene',
                    'Obligatorisk tiltaksplan',
                ],
            },
            'PDPL-FINE-F': {
                fine_individual: 'Opptil 1,5 milliarder VND',
                fine_org: 'Opptil 3 milliarder VND',
                deadlines: 'Løpende forpliktelse',
                remediation: [
                    'Obligatorisk innf�ring av vernetiltak',
                    'Obligatorisk peiking ut av ansvarleg person for sensitive data',
                    'Obligatorisk kommunikasjon med relevant fagstyresmakt',
                    'Obligatorisk tiltaksplan',
                ],
            },
            'PDPL-FINE-G': {
                fine_individual: 'Opptil 1,5 milliarder VND',
                fine_org: 'Opptil 3 milliarder VND',
                deadlines: 'Løpende forpliktelse; kontroller må være på plass før behandling av sensitive data',
                remediation: [
                    'Obligatorisk innf�ring av forsterka vernetiltak',
                    'Obligatorisk peiking ut av ansvarleg person',
                    'Obligatorisk innf�ring av retningslinjer og styringsrammeverk',
                ],
            },
            'PDPL-FINE-H': {
                fine_individual: 'Opptil 1,5 milliarder VND',
                fine_org: 'Opptil 3 milliarder VND',
                deadlines: 'Løpende forpliktelse; samtykke fra foreldrene kreves før behandling',
                remediation: [
                    'Obligatorisk stans i behandling utan gyldig foreldresamtykke',
                    'Obligatorisk sletting av ulovleg behandla data',
                    'Obligatorisk innf�ring av tiltak for aldersverifisering',
                ],
            },
            'PDPL-FINE-I': {
                fine_individual: 'Opptil 1,5 milliarder VND',
                fine_org: 'Opptil 3 milliarder VND',
                deadlines: 'Løpende forpliktelse',
                remediation: [
                    'Obligatorisk openheit om logikken i automatiserte avgjerder',
                    'Obligatorisk ordning for menneskeleg overpr�ving',
                    'Obligatorisk innf�ring av prosess for handtering av motsegn',
                ],
            },
            'PDPL-FINE-J': {
                fine_individual: 'Opptil 1,5 milliarder VND',
                fine_org: 'Opptil 3 milliarder VND',
                revenue: 'Opptil 5 % av tidligere års Vietnam-inntekter for gjentatte brudd',
                deadlines: 'Som angitt i myndighetspålegget',
                remediation: [
                    'Obligatorisk etterleving av p�legg fr� styresmaktene',
                    'Obligatorisk stans i ulovleg behandling',
                    'Tilbakef�ring av ulovleg vinst',
                    'Offentleg retting / orsaking',
                ],
            },
        },
    },
    framework_procedures_detail: {
        VN_DP_DRAFT_P7: {
            trigger: 'Løpende drift av plattformen',
            outputs: [
                'Risikovurderingsprotokoll',
                'Logg over tidlegvarslingar',
                'Tiltaksprotokoll',
                'Gjennomgangsspor',
            ],
            channels: ['Plattformarbeidsflyt'],
            responsible: {
                '1': 'Plattformoperatør / risiko',
                '2': 'Plattformoperatør / Sikkerhet',
                '3': 'Plattformoperatør / risiko',
                '4': 'Plattformoperatør / Sikkerhet',
                '5': 'Plattformoperatør',
                '6': 'Overholdelse',
            },
            step_outputs: {
                '1': ['Risikovurderingsprotokoll'],
                '2': ['Logg over tidlegvarslingar'],
                '3': ['Funn fr� risikogjennomgang'],
                '4': ['Oppf�ringar i risikoregisteret'],
                '5': ['Tiltaksprotokoll'],
                '6': ['Gjennomgangsspor'],
            },
        },
        VN_DP_DRAFT_P6: {
            trigger: 'En deltaker sender inn en klage eller tvisteforespørsel',
            outputs: [
                'Mottaksprotokoll for klage',
                'L�ysingsprotokoll for tvist',
                'Bevispakke',
                'Avslutningsprotokoll for sak',
            ],
            channels: ['Plattformarbeidsflyt'],
            responsible: {
                '1': 'Plattformoperatør',
                '2': 'Plattformoperatør',
                '3': 'Plattformoperatør',
                '4': 'Plattformoperatør',
                '5': 'Plattformoperatør / juridisk',
                '6': 'Plattformoperatør',
                '7': 'Overholdelse',
            },
            step_outputs: {
                '1': ['Mottaksprotokoll for klage'],
                '2': ['Kontroll av fullstende', 'F�respurnad om tillegg (om n�dvendig)'],
                '3': ['Melding om handteringsm�te'],
                '4': ['Bevispakke'],
                '5': ['Vurderingsfunn'],
                '6': ['L�ysingsprotokoll for tvist'],
                '7': ['Avslutningsprotokoll for sak', 'Arkivert bevispakke'],
            },
        },
        VN_DP_DRAFT_P5: {
            trigger: 'Levering er gjennomført etter at kontrakt og betalingsbetingelser er oppfylt',
            outputs: [
                'Leveringsprotokoll',
                'Sertifikat for eigedomsrett til data',
                'Oppf�ring i transaksjonsregisteret',
            ],
            channels: ['Plattformarbeidsflyt'],
            responsible: {
                '1': 'Selger / Plattformoperatør',
                '2': 'Plattformoperatør',
                '3': 'Plattformoperatør',
                '4': 'Plattformoperatør',
                '5': 'Plattformoperatør',
            },
            step_outputs: {
                '1': ['Leveringsprotokoll'],
                '2': ['Loggf�ring av leveringshending'],
                '3': ['Sertifikat for eigedomsrett'],
                '4': ['Oppf�ring i transaksjonsregisteret'],
                '5': ['Tilgangsprotokoll for verifisering'],
            },
        },
        VN_DP_DRAFT_P4: {
            trigger: 'En kjøper initierer en transaksjon for data, produkt eller tjeneste',
            outputs: [
                'Protokoll for oppstart av transaksjon',
                'Elektronisk kontrakt',
                'Betalingsstadfesting',
                'Protokoll for leveringsfullmakt',
            ],
            channels: ['Plattformarbeidsflyt'],
            responsible: {
                '1': 'Kjøper',
                '2': 'Kjøper / Plattformoperatør',
                '3': 'Plattformoperatør',
                '4': 'Kjøper/selger',
                '5': 'Plattformoperatør / Betaling',
                '6': 'Plattformoperatør',
            },
            step_outputs: {
                '1': ['Avgjerd om gjennomgang av oppf�ring'],
                '2': ['Protokoll for oppstart av transaksjon'],
                '3': ['Protokoll for elektronisk kontrakt'],
                '4': ['Protokoll for godkjenning av kontrakt'],
                '5': ['Betalingsstadfesting'],
                '6': ['Protokoll for leveringsfullmakt'],
            },
        },
        VN_DP_DRAFT_P3: {
            trigger: 'En deltaker ønsker å evaluere dataprodukter/tjenester i det isolerte miljøet',
            outputs: [
                'Sandbox-f�respurnad',
                'Protokoll for sandbox-omfang',
                'Protokoll for vurdering av resultat',
                'Protokoll for avslutting av sandbox',
            ],
            channels: ['Plattformarbeidsflyt'],
            responsible: {
                '1': 'Deltaker',
                '2': 'Plattformoperatør/deltaker',
                '3': 'Plattformoperatør / IT',
                '4': 'Plattformoperatør / Sikkerhet',
                '5': 'Plattformoperatør',
                '6': 'Plattformoperatør',
                '7': 'Plattformoperatør / IT',
            },
            step_outputs: {
                '1': ['Sandbox-f�respurnad'],
                '2': ['Protokoll for sandbox-omfang'],
                '3': ['Klargjort milj�'],
                '4': ['Logg for tryggleiksovervaking'],
                '5': ['Protokoll for vurdering av resultat'],
                '6': ['Avgjerd om godkjenning for uttrekk'],
                '7': ['Protokoll for avslutting av sandbox'],
            },
        },
        VN_DP_DRAFT_P2: {
            trigger: 'En selger søker å føre opp data, produkter eller datatjenester for handel',
            outputs: [
                'S�knad om oppf�ring',
                'Protokoll for kontroll av lovleg kjelde',
                'Protokoll for teknisk validering',
                'Opplysingsprotokoll om kvalitet',
                'Godkjenningsprotokoll for oppf�ring',
                'Oppf�ring i oppf�ringsregisteret',
            ],
            channels: ['Plattformarbeidsflyt'],
            responsible: {
                '1': 'Selger',
                '2': 'Selger / Juridisk',
                '3': 'Selger / IT',
                '4': 'Selger',
                '5': 'Selger',
                '6': 'Plattformoperatør',
                '7': 'Plattformoperatør',
                '8': 'Plattformoperatør',
            },
            step_outputs: {
                '1': ['S�knad om oppf�ring'],
                '2': ['Protokoll for kontroll av lovleg kjelde'],
                '3': ['Protokoll for teknisk validering'],
                '4': ['Opplysingsprotokoll om kvalitet'],
                '5': ['Innsendt oppf�ringsdossier'],
                '6': ['Funn fr� gjennomgang'],
                '7': ['Godkjenningsprotokoll for oppf�ring'],
                '8': ['Publisert oppf�ring', 'Oppf�ring i oppf�ringsregisteret'],
            },
        },
        VN_DP_DRAFT_P1: {
            trigger: 'En selger eller kjøper blir med i dataplattformen',
            outputs: [
                'Onboardingprotokoll for seljar / kj�par',
                'Oppf�ring i deltakarregisteret',
                'Bevis for kontooppsett',
                'Godkjenningsprotokoll',
            ],
            channels: ['Plattformarbeidsflyt'],
            responsible: {
                '1': 'Plattformoperatør',
                '2': 'Plattformoperatør / juridisk',
                '3': 'Plattformoperatør / juridisk',
                '4': 'Plattformoperatør',
                '5': 'Plattformoperatør',
                '6': 'Plattformoperatør',
                '7': 'Overholdelse',
            },
            step_outputs: {
                '1': ['Avgjerd om deltakartype'],
                '2': ['Protokoll for verifisering av rettsleg handleevne'],
                '3': ['Protokoll for kontroll av vilk�rsbunden verksemd'],
                '4': ['Protokoll for registrering av transaksjonskonto'],
                '5': ['Protokoll for kopling av betalingskonto'],
                '6': ['Godkjenningsprotokoll for deltaking'],
                '7': ['Oppf�ring i deltakarregisteret', 'Revisjonsspor'],
            },
        },
        PDPL_P1: {
            trigger: 'Oppstart av personopplysningsbehandling som krever konsekvensutredning',
            outputs: ['DPIA-dossier', 'Innsendingsstadfesting', 'Tilleggspakke'],
            channels: ['MPS-portalen', 'Personleg innlevering hos MPS A05'],
            responsible: {
                '1': '[[TOK_0]] / Personvernteam',
                '2': 'Personvernteam',
                '3': 'Juridisk / Samsvar',
                '4': '[[TOK_0]] / Personvernteam',
                '5': 'Overholdelsesteam',
            },
            step_outputs: {
                '1': ['Fullf�rt DPIA-dossier'],
                '2': ['Dossierpakke', 'F�lgjebrev'],
                '3': ['Innsendingsstadfesting', 'Sporingsreferanse'],
                '4': ['Tilleggspakke', 'Oppdatert dossier'],
                '5': ['Arkivert dossier', 'Revisjonsbevispakke'],
            },
        },
        PDPL_P2: {
            trigger: 'Hensikt om å overføre personopplysninger utenfor Vietnam',
            outputs: ['Overf�ringsdossier', 'Innsendingsstadfesting', 'Varsel etter overf�ring'],
            channels: ['MPS-portalen', 'Personleg innlevering hos MPS A05'],
            responsible: {
                '1': '[[TOK_0]] / Personvernteam',
                '2': 'Juridisk / Samsvar',
                '3': 'Juridisk / Samsvar',
                '4': '[[TOK_0]] / Personvernteam',
            },
            step_outputs: {
                '1': ['Fullf�rt overf�ringsdossier'],
                '2': ['Dossierpakke', 'Sporingsreferanse'],
                '3': ['Varsel etter overf�ring'],
                '4': ['Svar p� tilleggskrav', 'Oppdatert dossier'],
            },
        },
        PDPL_P3: {
            trigger: 'Organisasjon som leverer databehandlingstjenester som krever sertifisering',
            outputs: ['Sertifiseringsdossier', 'Sertifikat', 'Fornyingsprotokoll'],
            channels: ['MPS-portalen', 'Personleg innlevering hos MPS A05'],
            responsible: {
                '1': 'Juridisk / Samsvar',
                '2': 'Juridisk / Samsvar',
                '3': '[[TOK_0]] / Personvernteam',
                '4': 'Overholdelsesteam',
            },
            step_outputs: {
                '1': ['S�knadsdossier for sertifisering'],
                '2': ['Innsendingsstadfesting'],
                '3': ['Svar p� tilleggskrav'],
                '4': ['Sertifikatprotokoll', 'Fornyingsoversikt'],
            },
        },
        PDPL_P4: {
            trigger: 'Mottak av en forespørsel om registrerte rettigheter',
            outputs: [
                'Mottaksprotokoll for rettsforespurnad',
                'Identitetskontroll',
                'Svarbrev',
                'Avslutningsrapport for saka',
            ],
            channels: ['Nettportal', 'E-post', 'Personleg oppm�te'],
            responsible: {
                '1': 'Personvernteam / kundeservice',
                '2': '[[TOK_0]] / Personvernteam',
                '3': 'Avdelingsledere / IT',
                '4': '[[TOK_0]] / Personvernteam',
                '5': 'Overholdelsesteam',
            },
            step_outputs: {
                '1': ['Mottaksprotokoll for rettsforespurnad', 'Protokoll for identitetskontroll'],
                '2': ['Vurdering av f�respurnad', 'Tildeling av frist'],
                '3': ['Bevis for oppfylling', 'Stadfestingar fr� avdelingane'],
                '4': ['Svarbrev'],
                '5': ['Avslutningsrapport for saka', 'Revisjonsbevispakke'],
            },
        },
        PDPL_P5: {
            trigger: 'Oppdagelse av brudd eller brudd på personopplysningsbeskyttelsen',
            outputs: [
                'Vurderingsprotokoll for brot',
                'Varslingspakke',
                'Innsendingsstadfesting',
                'Tilleggspakke',
            ],
            channels: ['MPS-portalen', 'Personleg innlevering hos MPS A05'],
            responsible: {
                '1': 'Incident Response Team / [[TOK_0]]',
                '2': '[[TOK_0]] / Personvernteam',
                '3': 'Juridisk / Samsvar',
                '4': '[[TOK_0]] / Incident Response Team',
            },
            step_outputs: {
                '1': ['Vurderingsprotokoll for brot', 'Avgjerdsprotokoll for varsling'],
                '2': ['Varslingspakke for brot'],
                '3': ['Innsendingsstadfesting', 'Sporingsreferanse'],
                '4': ['Tilleggspakke', 'Samordningsbevis'],
            },
        },
    },
    framework_deadline_references: {
        'PDPL Art. 9': '[[TOK_0]] Art. 9',
        'PDPL Art. 17': '[[TOK_0]] Art. 17',
        'PDPL Art. 23': '[[TOK_0]] Art. 23',
        'Decree 13 Art. 24': 'Dekret 13 Art. 24',
        'MoPS Admin Procedures': 'MoPS Admin Prosedyrer',
        'Annual cycle': '�&rlig syklus',
        'Decree 13/2023/NĐ-CP Art. 24': 'Dekret [[TOK_0]]Đ-CP Art. 24',
        'Decree 356/2025/NĐ-CP Art. 25(4)': 'Dekret [[TOK_0]]Đ-CP Art. 25(4)',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 2': 'Dekret [[TOK_0]]Đ-CP Art. 5 Cl. 2',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 2–5': 'Dekret [[TOK_0]]Đ-CP Art. 5 Cl. 2�5',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 3': 'Dekret [[TOK_0]]Đ-CP Art. 5 Cl. 3',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 4': 'Dekret [[TOK_0]]Đ-CP Art. 5 Cl. 4',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 5': 'Dekret [[TOK_0]]Đ-CP Art. 5 Cl. 5',
        'Decree 356/2025/NĐ-CP Art. 8(3)': 'Dekret [[TOK_0]]Đ-CP Art. 8(3)',
        'Draft Decree on Data Platforms 2026': 'Utkast til dekret om dataplattformer 2026',
        'Law 122/2025/QH15 Ch. III; NĐ 98/2020; NĐ 24/2025': 'Lov [[TOK_0]] Kap. III; NĐ 98/2020; NĐ 24/2025',
        'Law 122/2025/QH15 Ch. IV (Consumer Protection)': 'Lov [[TOK_0]] Kap. IV (forbrukerbeskyttelse)',
        'Law 122/2025/QH15 — Online.gov.vn operational procedure': 'Lov [[TOK_0]] � Online.gov.vn operasjonelle prosedyre',
        'Law 134/2025/QH15 Article 12': 'Lov [[TOK_0]] Artikkel 12',
        'Law 134/2025/QH15 Article 21': 'Lov [[TOK_0]] Artikkel 21',
        'Law 134/2025/QH15 Article 27': 'Lov [[TOK_0]] Artikkel 27',
        'Law 134/2025/QH15 Articles 9–10': 'Lov [[TOK_0]] Artikkel 9�10',
        'Law 24/2023/QH15 — article mapping pending': 'Lov [[TOK_0]] � artikkelkartlegging venter',
        'Law 60/2024/QH15 (internal control target)': 'Lov [[TOK_0]] (internkontrollmål)',
        'Law 91/2025/QH15 Art. 21': 'Lov [[TOK_0]] Art. 21',
        'Law 91/2025/QH15 Art. 23': 'Lov [[TOK_0]] Art. 23',
        'Policy-defined': 'Policy-definert',
        Quarterly: 'Kvartalsvis',
        'QĐ 778/QĐ-BCA-A05 administrative procedure': 'QĐ 778/QĐ-BCA-A05 administrativ prosedyre',
        'internal control target (Law 116/2025/QH15 Art. 24(2)(b), 41(5) — exact timeline pending implementing instrument)': 'internkontrollmål (lov [[TOK_0]] Art. 24(2)(b), 41(5) � eksakt tidslinje i påvente av implementeringsinstrument)',
        'internal control target (Law 116/2025/QH15 Art. 41(3) — exact timeline pending implementing instrument)': 'internkontrollmål (lov [[TOK_0]] art. 41(3) � eksakt tidslinje i påvente av implementeringsinstrument)',
        'source verification pending': 'kildebekreftelse venter',
        'Circular 83/2025/TT-NHNN — Ad-hoc Internal Audit Reporting to SBV (Layer 5)': 'Circular 83/2025/TT-NHNN � Ad hoc-rapportering fr� internrevisjon til SBV (lag 5)',
        'Circular 83/2025/TT-NHNN — Annual ICAAP Report (Phụ lục III) (Layer 5)': 'Circular 83/2025/TT-NHNN � �rleg ICAAP-rapport (Phụ lục III) (lag 5)',
        'Circular 83/2025/TT-NHNN — Annual Phụ lục I (Layer 5)': 'Circular 83/2025/TT-NHNN � �rleg Phụ lục I (lag 5)',
        'Circular 83/2025/TT-NHNN — Annual Phụ lục IV (Layer 5)': 'Circular 83/2025/TT-NHNN � �rleg Phụ lục IV (lag 5)',
        'Circular 83/2025/TT-NHNN — Annual Risk Management Report (Phụ lục II) (Layer 5)': 'Circular 83/2025/TT-NHNN � �rleg risikostyringsrapport (Phụ lục II) (lag 5)',
        'Circular 83/2025/TT-NHNN — Asset Management Responsibility (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN � Ansvar for forvaltning av eigedelar (lag 2, tema C)',
        "Circular 83/2025/TT-NHNN — Board / Members' Council Oversight (Layer 2, theme A)": 'Circular 83/2025/TT-NHNN � Tilsyn fr� styret / representantskapet (lag 2, tema A)',
        'Circular 83/2025/TT-NHNN — Board Committees (Layer 2, theme A)': 'Circular 83/2025/TT-NHNN � Styreutval (lag 2, tema A)',
        'Circular 83/2025/TT-NHNN — Board Decisions and Minutes (Layer 2, theme A)': 'Circular 83/2025/TT-NHNN � Styrevedtak og protokollar (lag 2, tema A)',
        'Circular 83/2025/TT-NHNN — Branch Control Procedures (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN � Kontrollprosedyrar for filialar (lag 2, tema C)',
        'Circular 83/2025/TT-NHNN — Compliance Assessment of Internal Rules (Layer 2, theme D)': 'Circular 83/2025/TT-NHNN � Etterlevingsvurdering av interne reglar (lag 2, tema D)',
        'Circular 83/2025/TT-NHNN — Compliance Function (Layer 2, theme D)': 'Circular 83/2025/TT-NHNN � Etterlevingsfunksjon (lag 2, tema D)',
        'Circular 83/2025/TT-NHNN — Compliance Remediation Monitoring (Layer 2, theme D)': 'Circular 83/2025/TT-NHNN � Oppf�lging av etterlevingstiltak (lag 2, tema D)',
        'Circular 83/2025/TT-NHNN — Concentration Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN � Konsentrasjonsrisiko (lag 3, tema E)',
        'Circular 83/2025/TT-NHNN — Conflict of Interest (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN � Interessekonfliktar (lag 2, tema C)',
        'Circular 83/2025/TT-NHNN — Control Culture (Layer 2, theme A/B)': 'Circular 83/2025/TT-NHNN � Kontrollkultur (lag 2, tema A/B)',
        'Circular 83/2025/TT-NHNN — Credit Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN � Kredittrisiko (lag 3, tema E)',
        'Circular 83/2025/TT-NHNN — Delegated Authority (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN � Delegert myndigheit (lag 2, tema C)',
        'Circular 83/2025/TT-NHNN — Early Implementation Notification (Layer 5)': 'Circular 83/2025/TT-NHNN � Varsel om tidleg implementering (lag 5)',
        'Circular 83/2025/TT-NHNN — General Director Responsibility (Layer 2, theme A)': 'Circular 83/2025/TT-NHNN � Ansvar for administrerande direkt�r (lag 2, tema A)',
        'Circular 83/2025/TT-NHNN — ICAAP (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN � ICAAP (lag 3, tema E)',
        'Circular 83/2025/TT-NHNN — Interest-Rate Risk in the Banking Book (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN � Renterisiko i bankboka (lag 3, tema E)',
        'Circular 83/2025/TT-NHNN — Internal Audit Charter (Layer 2, theme H)': 'Circular 83/2025/TT-NHNN � Mandat for internrevisjon (lag 2, tema H)',
        'Circular 83/2025/TT-NHNN — Internal Audit Engagements (Theme H)': 'Circular 83/2025/TT-NHNN � Internrevisjonsoppdrag (tema H)',
        'Circular 83/2025/TT-NHNN — Internal Audit Findings Communication (Layer 2, theme H)': 'Circular 83/2025/TT-NHNN � Formidling av funn fr� internrevisjon (lag 2, tema H)',
        'Circular 83/2025/TT-NHNN — Internal Audit Findings and Corrective Actions (Theme H)': 'Circular 83/2025/TT-NHNN � Funn fr� internrevisjon og korrigerande tiltak (tema H)',
        'Circular 83/2025/TT-NHNN — Internal Audit Follow-Up (Theme H)': 'Circular 83/2025/TT-NHNN � Oppf�lging fr� internrevisjon (tema H)',
        'Circular 83/2025/TT-NHNN — Internal Audit Governance': 'Circular 83/2025/TT-NHNN � Styring av internrevisjon',
        'Circular 83/2025/TT-NHNN — Internal Audit Independence (Layer 2, theme H)': 'Circular 83/2025/TT-NHNN � Uavhengigheit for internrevisjon (lag 2, tema H)',
        'Circular 83/2025/TT-NHNN — Internal Audit Plan (Layer 2/Theme H)': 'Circular 83/2025/TT-NHNN � Plan for internrevisjon (lag 2/tema H)',
        'Circular 83/2025/TT-NHNN — Internal Audit Reporting to SBV (Layer 2, theme H)': 'Circular 83/2025/TT-NHNN � Rapportering fr� internrevisjon til SBV (lag 2, tema H)',
        'Circular 83/2025/TT-NHNN — Internal Control System Governance (Layer 2)': 'Circular 83/2025/TT-NHNN � Styring av internkontrollsystemet (lag 2)',
        'Circular 83/2025/TT-NHNN — Internal Reporting Procedure (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN � Intern rapporteringsprosedyre (lag 2, tema C)',
        'Circular 83/2025/TT-NHNN — Internal Reports Register (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN � Register over interne rapportar (lag 4, tema F)',
        'Circular 83/2025/TT-NHNN — Law-Change Monitoring (Layer 2, theme D)': 'Circular 83/2025/TT-NHNN � Oppf�lging av lovendringar (lag 2, tema D)',
        'Circular 83/2025/TT-NHNN — Legal and Reputational Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN � Juridisk risiko og omd�mmerisiko (lag 3, tema E)',
        'Circular 83/2025/TT-NHNN — Limit Breach Escalation (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN � Eskalering ved brot p� grenser (lag 3, tema E)',
        'Circular 83/2025/TT-NHNN — Liquidity Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN � Likviditetsrisiko (lag 3, tema E)',
        'Circular 83/2025/TT-NHNN — MIS Annual Review (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN � �rleg gjennomgang av MIS (lag 4, tema F)',
        'Circular 83/2025/TT-NHNN — MIS Backup and Continuity (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN � Reservekopi og kontinuitet for MIS (lag 4, tema F)',
        'Circular 83/2025/TT-NHNN — MIS Escalation Mechanisms (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN � Eskaleringsmekanismar i MIS (lag 4, tema F)',
        'Circular 83/2025/TT-NHNN — MIS Reliability and Confidentiality (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN � P�litelegheit og konfidensialitet i MIS (lag 4, tema F)',
        'Circular 83/2025/TT-NHNN — MIS Risk Data Sources (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN � Risikodatakjelder i MIS (lag 4, tema F)',
        'Circular 83/2025/TT-NHNN — Management Information System (Layer 4)': 'Circular 83/2025/TT-NHNN � Leiingsinformasjonssystem (lag 4)',
        'Circular 83/2025/TT-NHNN — Market Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN � Marknadsrisiko (lag 3, tema E)',
        'Circular 83/2025/TT-NHNN — Material Risk Register (Layer 3)': 'Circular 83/2025/TT-NHNN � Register over vesentleg risiko (lag 3)',
        'Circular 83/2025/TT-NHNN — Model Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN � Modellrisiko (lag 3, tema E)',
        'Circular 83/2025/TT-NHNN — New Product Review (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN � Gjennomgang av nye produkt (lag 3, tema E)',
        'Circular 83/2025/TT-NHNN — Operational Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN � Operasjonell risiko (lag 3, tema E)',
        'Circular 83/2025/TT-NHNN — Outsourcing BCP (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN � Beredskaps- og kontinuitetsplan for utkontraktering (lag 2, tema G)',
        'Circular 83/2025/TT-NHNN — Outsourcing Contracts (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN � Kontraktar for utkontraktering (lag 2, tema G)',
        'Circular 83/2025/TT-NHNN — Outsourcing Controls': 'Circular 83/2025/TT-NHNN � Kontrollar for utkontraktering',
        'Circular 83/2025/TT-NHNN — Outsourcing Due Diligence (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN � Due diligence ved utkontraktering (lag 2, tema G)',
        'Circular 83/2025/TT-NHNN — Outsourcing Fallback Provider (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN � Reserveleverand�r ved utkontraktering (lag 2, tema G)',
        'Circular 83/2025/TT-NHNN — Outsourcing Materiality (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN � Vesentlegheitsvurdering av utkontraktering (lag 2, tema G)',
        'Circular 83/2025/TT-NHNN — Outsourcing Monitoring (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN � Oppf�lging av utkontraktering (lag 2, tema G)',
        'Circular 83/2025/TT-NHNN — Phụ lục V/VI Technical References (Layer 5)': 'Circular 83/2025/TT-NHNN � Tekniske referansar i Phụ lục V/VI (lag 5)',
        'Circular 83/2025/TT-NHNN — Policy Register (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN � Register over styrande dokument (lag 2, tema C)',
        'Circular 83/2025/TT-NHNN — Professional Ethics (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN � Profesjonsetikk (lag 2, tema C)',
        'Circular 83/2025/TT-NHNN — Risk Appetite (Layer 3)': 'Circular 83/2025/TT-NHNN � Risikovilje (lag 3)',
        'Circular 83/2025/TT-NHNN — Risk Committee Coordination (Layer 2, theme E)': 'Circular 83/2025/TT-NHNN � Samordning i risikoutvalet (lag 2, tema E)',
        'Circular 83/2025/TT-NHNN — Risk Data Governance (Layer 3, theme E/F) — phased to 2028-01-01': 'Circular 83/2025/TT-NHNN � Styring av risikodata (lag 3, tema E/F) � faseinnf�rt til 2028-01-01',
        'Circular 83/2025/TT-NHNN — Risk Limit Review (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN � Gjennomgang av risikorammer (lag 3, tema E)',
        'Circular 83/2025/TT-NHNN — Risk Limits Framework (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN � Rammeverk for risikorammer (lag 3, tema E)',
        'Circular 83/2025/TT-NHNN — Risk Management Function (Layer 2, theme E)': 'Circular 83/2025/TT-NHNN � Risikostyringsfunksjon (lag 2, tema E)',
        'Circular 83/2025/TT-NHNN — Risk Methodology and Models (Layer 2, theme E)': 'Circular 83/2025/TT-NHNN � Risikometodikk og modellar (lag 2, tema E)',
        'Circular 83/2025/TT-NHNN — Risk Reporting (Layer 2, theme E)': 'Circular 83/2025/TT-NHNN � Risikorapportering (lag 2, tema E)',
        'Circular 83/2025/TT-NHNN — Risk Reporting Cadence (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN � Rapportfrekvens for risiko (lag 4, tema F)',
        'Circular 83/2025/TT-NHNN — SBV Remediation Submission (Layer 5)': 'Circular 83/2025/TT-NHNN � Innsending av tiltak til SBV (lag 5)',
        'Circular 83/2025/TT-NHNN — SBV Submission Channels (Layer 5)': 'Circular 83/2025/TT-NHNN � Innsendingskanalar til SBV (lag 5)',
        'Circular 83/2025/TT-NHNN — Sector Applicability (Layer 1)': 'Circular 83/2025/TT-NHNN � Sektorrelevans (lag 1)',
        'Circular 83/2025/TT-NHNN — Segregation of Duties (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN � Oppg�veskilje (lag 2, tema C)',
        'Circular 83/2025/TT-NHNN — Senior Management Supervision (Layer 2, theme A)': 'Circular 83/2025/TT-NHNN � Oppf�lging fr� �vste leiing (lag 2, tema A)',
        'Circular 83/2025/TT-NHNN — Strategic Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN � Strategisk risiko (lag 3, tema E)',
        'Circular 83/2025/TT-NHNN — Stress Testing (Layer 3, theme E) — phased to 2028-01-01': 'Circular 83/2025/TT-NHNN � Stresstesting (lag 3, tema E) � faseinnf�rt til 2028-01-01',
        'Circular 83/2025/TT-NHNN — Supervisory Board (Layer 2, theme A)': 'Circular 83/2025/TT-NHNN � Kontrollstyre (lag 2, tema A)',
        'Circular 83/2025/TT-NHNN — Supervisory Findings Register (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN � Register over tilsynsfunn (lag 4, tema F)',
        'Circular 83/2025/TT-NHNN — Three Lines Roles and Escalation (Layer 2, theme B)': 'Circular 83/2025/TT-NHNN � Roller og eskalering i tre forsvarslinjer (lag 2, tema B)',
        'Circular 83/2025/TT-NHNN — Three Lines of Defence (Layer 2)': 'Circular 83/2025/TT-NHNN � Tre forsvarslinjer (lag 2)',
        'Circular 83/2025/TT-NHNN — Violation Escalation (Layer 2, theme D)': 'Circular 83/2025/TT-NHNN � Eskalering ved brot (lag 2, tema D)',
    },
    framework_authorities: {
        'Quốc hội (National Assembly)': 'Qu�c h�i (nasjonalforsamlinga)',
        'Ministry of Public Security / A05 Department': 'Qu�c h�"i (nasjonalforsamlingen)',
        'Ministry of Public Security': 'Departementet for offentlig sikkerhet / A05-avdelingen',
        'Ministry of Information and Communications': 'Departementet for offentlig sikkerhet',
        'Government of Vietnam': 'Informasjons- og kommunikasjonsdepartementet',
        'European Data Protection Board (EDPB)': 'Regjeringen i Vietnam',
        'ENISA / National CSIRTs': 'European Data Protection Board (EDPB)',
        'State Bank of Vietnam': 'ENISA / Nasjonale CSIRTer',
    },
    tour_titles: {
        access_accountability: 'Få tilgang til ansvarlighetstur',
        assessments: 'Vurderingstur',
        audit_trail: 'Audit Trail Tour',
        classification: 'Klassifiseringstur',
        compliance_forms: 'Omvisning i samsvarsskjemaer',
        connectors: 'Connectors Tour',
        consent_properties: 'Omvisning i samtykkeegenskaper',
        consent: 'Samtykkestur',
        dashboard: 'Dashboard tur',
        data_mapping: 'Datakartleggingstur',
        data_subjects: 'Omvisning for dataemner',
        deletion_orchestration: 'Sletting Orchestration Tour',
        discovery: 'Oppdagelsestur',
        governance: 'Governance Tour',
        help_center: 'Omvisning i hjelpesenteret',
        incident_ops: 'Incident Operations Tour',
        incidents: 'Hendelsestur',
        localization: 'Lokaliseringstur',
        monitoring: 'Overvåkingstur',
        onboarding: 'Onboarding Tour',
        organizations: 'Organisasjonstur',
        partner_workspace: 'Partner arbeidsomvisning',
        platform_settings: 'Omvisning i plattforminnstillinger',
        privacy_scanner: 'Privacy Scanner Tour',
        program_governance: 'Program Governance Tour',
        rights_requests: 'Rettighetsforespørsler Tour',
        task_management: 'Task Management Tour',
        vendor_risk: 'Leverandørrisikoomvisning',
    },
    tour_descriptions: {
        access_accountability: 'Som internrevisjonsleder (P-VN-10), gjennomgå tilgangsbevis, bruk av revisjonstillatelser og undersøk unormale mønstre for å demonstrere [[TOK_0]] artikkel 5(1)(f) integritet og konfidensialitet.',
        assessments: 'Som Enterprise [[TOK_1]] (P-VN-01), gjennomføre DPIAer etter dekret 356 Mau so 02a, identifisere samsvarshull og vurdere risikoer for grenseoverskridende overføringer under [[TOK_0]].',
        audit_trail: 'Som Internal Audit Lead (P-VN-10), spør etter bevis på tvers av moduler, sett sammen revisjonspakker og eksporter manipulasjonssikre logger for regulatoriske innsendinger.',
        classification: 'Som Data Steward (P-VN-05), definer dataklassifiseringstaksonomier, tildel sensitivitetsetiketter, håndhev oppbevaringspolicyer og løs dekningshull som kreves for [[TOK_0]].',
        compliance_forms: 'Som Enterprise [[TOK_0]] (P-VN-01), bla gjennom, fyll ut og send inn offisielle vietnamesiske reguleringsskjemaer inkludert Phu luc I, Phu luc II og Mau so maler for PDP-komitéinnleveringer.',
        connectors: 'Som IT Systems Lead (P-VN-05), fange opp forretningskrav for integrasjoner, kartlegge koblinger til samsvarsdataflyter og verifiser POC-beredskap før du går live.',
        consent_properties: 'Som Enterprise [TOK_1]] (P-VN-01), konfigurer [[TOK_2]]-distribusjon: digital eiendomsregistrering, gylne maler for konsistente [[TOK_0]] samtykkebannere og bindende matriser som kobler egenskaper til behandlingsaktiviteter.',
        consent: 'Som Enterprise [[TOK_1]] (P-VN-01), administrer samtykkepolitikkens livssyklus: definer innsamlingsformål, håndhev [[TOK_0]] tilbaketrekkingsrettigheter, og integrer med din samtykkeadministrasjonsplattform.',
        dashboard: 'Som Enterprise [[TOK_1]] (P-VN-01), orienter deg rundt kommandosenteret for samsvarsstilling som viser [[TOK_0]] tidsfrister, brudd på SLAer og KPIer for revisjonsberedskap.',
        data_mapping: 'Som Data Steward (P-VN-05), bygg ROPA-inventaret ditt, kartlegg grenseoverskridende datastrømmer og vedlikehold behandlingsaktivitetsregisteret som kreves av [[TOK_0]].',
        data_subjects: 'Som Enterprise DPO eller Education Compliance Lead, administrer enhetlige datasubjektprofiler som kobler sammen samtykkeposter, rettighetsforespørsler og tidslinjeaktivitet på tvers av plattformen.',
        deletion_orchestration: 'Som [[TOK_1]] (P-VN-01), verifiser sletting av data fra ende til ende på tvers av interne systemer og tredjepartsleverandører, med kryptografiske beviskjeder for [[TOK_0]] artikkel 17-rett til sletting.',
        discovery: 'Som Data Steward (P-VN-05), kjør automatiserte skanninger for å oppdage personopplysninger på tvers av tilkoblede systemer, gjennomgå trinnvise funn og mate resultater inn i klassifiseringsmodulen for [[TOK_0]]-merking.',
        governance: 'Som leverandørrisikobehandler (P-VN-08), vedlikehold leverandørregisteret, spor underprosessorkjeder, vurder risikoer for grenseoverskridende overføringer og håndhev styringshåndbøker under [[TOK_0]].',
        help_center: 'For alle personas -- DPOer, revisorer, IT-ledere og compliance managers -- finn svar, fremgangsmåteveiledninger og modulspesifikk dokumentasjon for å støtte dine daglige compliance-arbeidsflyter.',
        incident_ops: 'Som Incident Commander (P-VN-09), aktiver responsspillebøker, spor [[TOK_1]]-overholdelse mot det 72-timers [[TOK_0]] varslingsvinduet, administrer eskaleringer og koordiner leverandørrespons.',
        incidents: 'Som hendelsessjef (P-VN-09), oppdage og rapporter datainnbrudd med 72-timers [TOK_0]] varslingsforpliktelser til PDP-komiteen, triage etter alvorlighetsgrad, og bygg revisjonsgraderte hendelsesdossierer.',
        localization: 'Som Enterprise [[TOK_1]] (P-VN-01), administrer livssyklusen for det regulatoriske rammeverket: installer vietnamesiske markedspakker, aktiver [[TOK_0]] og dekret 13-rammeverk, kartlegg krav til plattformmoduler og administrer oversettelser.',
        monitoring: 'Som Enterprise [[TOK_1]] (P-VN-01), etablere pågående overvåkingsprogrammer, spor regulatoriske endringer, mål KPIer og administrer regulatoriske interaksjonssaker under [[TOK_0]].',
        onboarding: 'Som Compliance Trainer (P-VN-02), lever opplæring via guidede turer, last inn realistiske eksempeldata for praktiske øvelser, og kjør oppsettsveiviseren for hurtigstartscenarier.',
        organizations: 'Som [[TOK_0]] (P-VN-01), konfigurer overholdelsesstrukturer for flere organisasjoner, etablere avdelingshierarkier og rute datasubjektforespørsler på tvers av bedriftsgruppen din.',
        partner_workspace: 'Som Partner Account Manager, ombord partnerorganisasjoner, konfigurere tjenestenivåer, spore overholdelsesleveranser og administrere partnermarkedsplassen.',
        platform_settings: 'Som plattformadministrator, administrer all operasjonell konfigurasjon -- identitet, sikkerhet, integrasjoner og modultilgang som underbygger samsvarsprogrammet ditt.',
        privacy_scanner: 'Som personvernanalytiker (P-VN-06), kjør kontinuerlige overvåkingsskanninger for å oppdage brudd på informasjonskapslers samtykke, uautoriserte sporere og policyhull � og generer bevis for ePrivacy og [TOK_0]]-overholdelse.',
        program_governance: 'Naviger mellom modenhetsmodeller, vurderinger, bevisgap, ledersammendrag og mer. Hver undermodul bidrar til et helhetlig syn på din interne programhelse.',
        rights_requests: 'Som Enterprise [[TOK_1]] (P-VN-01), administrere forespørsler om registrerte rettigheter under [[TOK_0]] med 15-dagers lovpålagte frister, identitetsverifisering og revisjonsgradsløsningsspor.',
        task_management: 'Rut etterlevelsesoppgaver på tvers av personas, spor [[TOK_0]] tidsfrister og automatiser arbeidsflyter som holder teamet ditt ansvarlig.',
        vendor_risk: 'Som Vendor Risk Manager (P-VN-08) kan du score tredjepartsrisiko, håndheve gatevurderinger og utløse revurderinger � forskjellig fra Program Governance, som sporer din interne modenhet.',
    },
    consolidation: {
        title: 'Konsolideringssaker',
        new_case: 'Opprett konsolideringssak',
        case_count: 'case',
        created: 'Konsolideringssak opprettet',
        create: 'Opprett sak',
        creating: 'Oppretter...',
        cancel: 'Avbryt',
        no_cases: 'Ingen konsolideringssaker funnet.',
        all_statuses: 'Alle statuser',
        all_purposes: 'Alle formål',
        filter_status: 'Filtrer etter status',
        filter_purpose: 'Filtrer etter formål',
        col_title: 'Tittel',
        col_purpose: 'Formål',
        col_status: 'Status',
        col_progress: 'Fremgang',
        col_deadline: 'Frist',
        col_department: 'Avdeling',
        col_version: 'Versjon',
        col_evidence: 'Bevis',
        sections_accepted: 'accepted',
        prev: 'Forrige',
        next: 'Neste',
        page: 'Side',
        prev_page: 'Forrige side',
        next_page: 'Neste side',
        field_title: 'Tittel',
        field_purpose: 'Formål',
        field_framework: 'Rammekode',
        field_deadline: 'Frist',
        field_reviewer: 'Reviewer-bruker-ID',
        title_placeholder: 'Skriv inn sakstittel',
        framework_placeholder: 'f.eks. PDPD-2023',
        reviewer_placeholder: 'Skriv inn anmelder-bruker-ID',
        purposes: {
            dpia_filing: '[[TOK_0]] Arkivering',
            cross_border_filing: 'Grenseoverskridende arkivering',
            annual_governance_attestation: '�&rlig styringsattest',
            breach_package: 'Bruddpakke',
            audit_inspection_pack: 'Revisjon Inspeksjonspakke',
        },
        statuses: {
            draft: 'Utkast',
            collecting: 'Samler',
            consolidating: 'Konsoliderer',
            review: 'Gjennomgå',
            corrections: 'Rettelser',
            pending_approval: 'Venter på godkjenning',
            approved: 'Godkjent',
            completed: 'Fullført',
            closed: 'Stengt',
            rejected: 'Avvist',
        },
        section_statuses: {
            pending: 'Venter',
            in_progress: 'Pågår',
            submitted: 'Sendt inn',
            accepted: 'Godtatt',
            needs_correction: 'Trenger korrigering',
            corrected: 'Rettet',
        },
        flag_types: {
            missing_section: 'Manglende seksjon',
            conflicting_entry: 'Motstridende oppføring',
            stale_entry: 'Foreldet inngang',
            missing_evidence: 'Manglende bevis',
            incomplete_data: 'Ufullstendige data',
            duplicate_entry: 'Duplisert oppføring',
        },
        flag_severities: {
            critical: 'Kritisk',
            warning: 'Advarsel',
            info: 'Info',
        },
        sections_title: 'Seksjoner',
        no_sections: 'Ingen seksjoner er tildelt ennå.',
        flags_title: 'Flagg',
        no_flags: 'Ingen flagg oppdaget.',
        open: 'open',
        approval_chain: 'Godkjenningskjede',
        pending: 'Venter',
        audit_trail: 'Revisjonssti',
        no_audit: 'Ingen revisjonshendelser.',
        auto_assign: 'Auto-tilordne seksjoner',
        start_collection: 'Start samlingen',
        review_case: 'Gjennomgå sak',
        generate_export: 'Generer eksport',
        review_title: 'Konsolideringsgjennomgang',
        advance_approval: 'Gå videre til godkjenning',
        back_to_case: 'Tilbake til sak',
        accept: 'Godta',
        return_section: 'Retur',
        return_comment: 'Returner kommentar...',
        resolve: 'Løs',
        dismiss: 'Avvis',
        resolution_notes: 'Merknader om oppløsning...',
        notes: 'Notater',
        section_accepted: 'Seksjon akseptert',
        section_returned: 'Seksjon returnert for retting',
        advanced_to_approval: 'Saken avventer godkjenning',
        section_data: 'Seksjonsdata',
        save_progress: 'Lagre fremdrift',
        submit_section: 'Send inn seksjon',
        submitting: 'Sender inn...',
        resubmit: 'Send inn på nytt',
        progress_saved: 'Fremdriften er lagret',
        section_submitted: 'Seksjon innsendt',
        correction_required: 'Rettelse kreves',
        evidence_title: 'Bevis',
        no_evidence: 'Ingen bevis vedlagt.',
        add_evidence: 'Legg til bevis',
        evidence_added: 'Bevis lagt til',
        evidence_files: 'bevisfiler',
        uploaded_by: 'lastet opp av',
        comments_title: 'Kommentarer',
        no_comments: 'Ingen kommentarer ennå.',
        comment_placeholder: 'Legg til en kommentar...',
        add_comment: 'Legg til kommentar',
        comment_added: 'Kommentar lagt til',
        view_data: 'Se innsendte data',
        export_title: 'Eksport av dossier',
        export_generated: 'Eksportpakke generert',
        regenerate: 'Regenerer',
        regenerating: 'Regenererer...',
        generated_at: 'Generert kl',
        artifacts_title: 'Eksporter artefakter',
        artifact_type: 'Artefakt',
        file_name: 'Filnavn',
        file_size: 'Størrelse',
        generated: 'Generert',
        download: 'Last ned',
        artifacts: {
            master_report: 'Hovedrapport',
            evidence_bundle: 'Bevispakke (ZIP)',
            contributor_lineage: 'Bidragsyter avstamning',
            conflict_resolution: 'Konfliktløsning',
            approval_history: 'Godkjenningshistorikk',
        },
        official_forms: 'Offisielle skjemaer',
        forms_description: 'Følgende offisielle skjemaer kan genereres fra de konsoliderte dataene. Offisielle skjemaer er atskilt fra interne arbeidspapirer.',
        announce_loaded_cases: 'Lastet inn [[TOK_1]] konsolideringssaker',
        announce_case_detail_loaded: 'Saksdetaljene er lastet inn',
        announce_case_transitioned: 'Saken er overført til [[TOK_1]]',
        announce_flag_resolved: 'Flagg løst',
        announce_flag_dismissed: 'Flagg avvist',
        case_detail_loaded: 'Saksdetaljene er lastet inn',
        sections_auto_assigned: 'Seksjoner automatisk tildelt fra avdelingshierarki',
        errors: {
            load_failed: 'Kunne ikke laste inn data. Vennligst prøv igjen.',
            create_failed: 'Kunne ikke opprette sak. Vennligst prøv igjen.',
            required_fields: 'Fyll ut alle obligatoriske felt.',
            not_found: 'Ikke funnet.',
            comment_required: 'Kommentar er nødvendig når du returnerer en seksjon.',
            notes_required: 'Merknader kreves når du løser eller avviser et flagg.',
        },
    },
    rights_requests: {
        import: {
            title: 'Importer saker',
            nav_title: 'Masseimport',
            description: 'Last opp ei CSV-fil for å masseimportere rettskravssaker.',
            select_file: 'Vel CSV-fil',
            file_help: 'CSV med overskrifter som samsvarar med saksfelt.',
            file_too_large: 'Fila er for stor. Maksimal storleik er 2MB.',
            preview: 'Førehandsvising',
            columns_detected: 'Kolonnar oppdaga: {count}',
            column_mapping: 'Kolonnetilordning',
            import_button: 'Importer',
            import_complete: 'Import fullført',
            import_error: 'Import mislukkast',
            result: 'Importresultat',
            total: 'Totalt',
            imported: 'Importert',
            skipped: 'Hoppa over',
            failed: 'Feila',
            errors: 'Feil',
            error_row: 'Rad',
            error_field: 'Felt',
            error_message: 'Melding',
            history: 'Importhistorikk',
            no_history: 'Ingen importhistorikk.',
            history_file: 'Filnamn',
            history_date: 'Dato',
        },
        batch: {
            nav_title: 'Batch prosess',
            page_title: 'DSR batchprosess',
            page_subtitle: 'Last opp en [[TOK_1]] av ventende DSR-er. Forseti utarbeider et bekreftelsessvar per forespørsel og setter en verifiseringsoppgave i kø per rad. [[TOK_0]] anmeldelser + godtar hver før sending.',
            upload_heading: 'Last opp',
            csv_hint: 'Påkrevde kolonner: request_id, requester_email, request_type. Valgfritt: frist (ISO-8601), merknader.',
            rows_heading: '[[TOK_1]] rader analysert',
            submit_label: 'Kjør batch',
            submitting: 'Utkaster ⬦',
            col_request_id: 'Forespørsels-ID',
            col_email: 'Forespørsels e-post',
            col_type: 'Type',
            col_status: 'Status',
            col_actions: 'Handlinger',
            status_queued: 'I kø',
            status_drafted: 'Utkastet',
            status_failed: 'Mislyktes',
            status_accepted: 'Godtatt',
            status_rejected: 'Avvist',
            'status_parsing-error': 'Parse feil',
            accept: 'Godta',
            reject: 'Avvis',
            permission_denied: 'Du har ikke tillatelse til å kjøre Forseti arbeidsflyter.',
        },
    },
    assessment_triggers: {
        title: 'Vurderingsutløsere',
        subtitle: 'Konfigurer automatisert vurderingsoppretting og [[TOK_0]] varsler for personvernarbeidsflyter.',
        auto_create_dpia_label: 'Opprett [[TOK_0]] automatisk når behandlingsaktivitet merket som [[TOK_1]] kreves',
        auto_notify_new_purpose_label: 'Gi automatisk melding til [[TOK_0]] når nytt formål opprettes med sensitive datakategorier',
        auto_notify_cross_border_label: 'Automatisk varsling [[TOK_0]] når grenseoverskridende overføring legges til behandlingsaktivitet',
        default_dpo_label: 'Standard [[TOK_0]]',
        default_dpo_placeholder: 'Velg standard [[TOK_0]]...',
        notification_channels_label: 'Varslingskanaler',
        channel_in_app: 'I appen',
        channel_email: 'Email',
        save_success: 'Innstillinger for vurderingsutløser lagret.',
        save_error: 'Kunne ikke lagre innstillingene for vurderingsutløser.',
        fetch_error: 'Kunne ikke laste inn innstillingene for vurderingsutløser.',
        fetch_users_error: 'Kunne ikke laste inn brukere.',
        announce_loaded: 'Innstillinger for vurderingstrigger er lastet inn',
        dpia_status: '[[TOK_0]] Status',
        dpia_linked: '[[TOK_0]] Linket',
        dpia_required_no_dpia: '[[TOK_0]] Påkrevd � ikke opprettet',
        create_dpia: 'Opprett [[TOK_0]]',
        create_dpia_success: '[[TOK_0]] opprettet og knyttet til aktivitet.',
        create_dpia_error: 'Kunne ikke opprette [[TOK_0]] for aktivitet.',
        view_dpia: 'Se [[TOK_0]]',
    },
    data_subjects: {
        title: 'Registrerte personars profilar',
        nav_title: 'Registrerte personar',
        nav: {
            profiles: 'Profiler',
        },
        create: 'Opprett profil',
        edit: 'Rediger profil',
        delete: 'Slett profil',
        delete_confirm: 'Er du sikker på at du vil slette denne datasubjektprofilen?',
        display_name: 'Vist navn',
        email: 'Email',
        phone: 'Telefon',
        employee_id: 'Ansatt ID',
        student_id: 'Student-ID',
        notes: 'Notater',
        external_refs: 'Eksterne referanser',
        cases_count: 'Saker',
        workflows_count: 'Samtykkeposter',
        last_activity: 'Siste aktivitet',
        timeline: 'Tidslinje',
        link_case: 'Link Case',
        link_workflow: 'Link Workflow',
        no_profiles: 'Ingen registrerte profiler funnet.',
        search_placeholder: 'Søk etter navn, e-post, telefon eller ID...',
        create_success: 'Registreringsprofil opprettet.',
        create_error: 'Kunne ikke opprette den registrerte profilen.',
        update_success: 'Registreringsprofilen er oppdatert.',
        update_error: 'Kunne ikke oppdatere den registrerte profilen.',
        delete_success: 'Registreringsprofilen er slettet.',
        delete_error: 'Kunne ikke slette den registrerte profilen.',
        link_case_success: 'Sak knyttet til profil.',
        link_case_error: 'Kunne ikke koble sak til profil.',
        link_workflow_success: 'Arbeidsflyt knyttet til profil.',
        link_workflow_error: 'Kunne ikke koble arbeidsflyten til profilen.',
        load_error: 'Kunne ikke laste inn registrerte profiler.',
        detail_load_error: 'Kunne ikke laste inn den registrerte profilen.',
        timeline_load_error: 'Kunne ikke laste inn tidslinjen.',
        tab_cases: 'DSR-saker',
        tab_consent: 'Samtykkeposter',
        tab_timeline: 'Tidslinje',
        tab_consent_workflows: 'Samtykke arbeidsflyter',
        tab_web_consent: '[[TOK_0]] Samtykke',
        web_consent_empty: 'Ingen [[TOK_0]] samtykkeposter funnet for dette emnet.',
        web_consent_load_error: 'Kunne ikke laste inn [[TOK_0]] samtykkeposter.',
        col_policy_version: 'Policyversjon',
        col_versions: 'Versjoner',
        col_consent_version: 'Samtykke',
        col_cookie_declaration_version: 'Cookie-erklæring',
        col_purposes: 'Formål',
        purpose_granted: 'Gitt',
        purpose_denied: 'Nektet',
        granted_domains: 'Gitt',
        denied_domains: 'Nektet',
        col_action: 'Handling',
        col_timestamp: 'Tidsstempel',
        col_domain: 'Domene',
        no_cases: 'Ingen koblede saker.',
        no_workflows: 'Ingen tilknyttede samtykkearbeidsflyter.',
        no_timeline: 'Ingen tidslinjehendelser.',
        case_id: 'Saks-ID',
        case_status: 'Status',
        case_type: 'Forespørselstype',
        case_created: 'Opprettet',
        workflow_id: 'Arbeidsflyt-ID',
        workflow_type: 'Type',
        workflow_status: 'Status',
        workflow_created: 'Opprettet',
        timeline_date: 'Dato',
        timeline_event: 'Hendelse',
        timeline_details: 'Detaljer',
        timeline_time: 'Tid',
        timeline_type: 'Type',
        timeline_summary: 'Sammendrag',
        type_case: 'DSR sak',
        type_consent_workflow: 'Arbeidsflyt for samtykke',
        profile_info: 'Profilinformasjon',
        announce_loaded: 'Registreringsprofiler er lastet inn',
        announce_detail_loaded: 'Registreringsprofilen er lastet inn',
        select_case: '� Vel ei sak �',
        select_workflow: '� Vel ein arbeidsflyt �',
        no_cases_hint: 'Kople saker for å sjå dei her.',
        no_workflows_hint: 'Kople samtykkeflytane for å sjå dei her.',
    },
    flows: {
        map: {
            description_prefix: '[[TOK_4]] systemer · [[TOK_5]] flyter · [[TOK_6]] grenseoverskridende · [[TOK_7]] høy/kritisk risiko',
            switch_to_list: 'Bytt til listevisning',
            switch_to_list_aria: 'Bytt til tabellvisning',
            svg_aria: 'Dataflytkart: [[TOK_3]] systemer, [[TOK_4]] flyter, [[TOK_5]] grenseoverskridende',
            selected_system: 'Valgt system',
            drill_hint: '�&pne listefanen for å redigere de koblede flytene, DPIAene og leverandørtilordningene for dette systemet.',
        },
    },
    packages: {
        light: {
            name: 'Lys',
            description: 'Viktige personvern-samsvarsverktøy for små team',
        },
        standard: {
            name: 'Standard',
            description: 'Fullt utstyrt samsvarsplattform for veksande organisasjonar',
        },
        enterprise_unlimited: {
            name: 'Enterprise Unlimited',
            description: 'Samsvar på bedriftsnivå med multi-org-støtte og dedikerte tenester',
        },
    },
    forseti: {
        providerSettings: {
            title: 'Forseti [[TOK_0]] Leverandørinnstillinger',
            subtitle: 'Konfigurer Claude-leverandøren for Forseti [[TOK_0]] juridisk rådgiver.',
            healthHeading: 'Leverandørhelse',
            statusLabel: 'Status',
            statusOk: 'OK',
            statusFailed: 'Utilgjengelig',
            providerLabel: 'Leverandør',
            providerClaudeApi: 'Claude [[TOK_0]]',
            providerCliRelay: 'Claude CLI stafett',
            providerAesirManaged: 'Aesir-administrerte tokens',
            lastCheckedLabel: 'Sist sjekket',
            reasonLabel: 'Grunn',
            refreshButton: 'Oppdater',
            apiKeyHeading: 'Claude [[TOK_0]] nøkkel',
            apiKeyHint: 'Ved å angi en [TOK_0]]-tast aktiveres Claude [[TOK_1]]-modus. La være uaktivert for å bruke det lokale CLI-reléet (utvikler-/selvvertsmodus).',
            apiKeyLabel: '[[TOK_0]]-tasten',
            apiKeyMinLength: 'Minimum 32 tegn. Kryptert i hvile; aldri vist igjen.',
            apiKeyTooShort: '[[TOK_0]]-tasten må være på minst 32 tegn.',
            apiKeySaved: '[[TOK_0]] nøkkel lagret. Forfriskende helse...',
            apiKeyCleared: '[[TOK_0]]-tasten er slettet. Forseti bruker nå det lokale CLI-reléet.',
            setKeyButton: 'Lagre [[TOK_0]]-tasten',
            clearKeyButton: 'Fjern [[TOK_0]]-tasten (bruk CLI-relé)',
        },
        usage: {
            title: 'Bruk',
            subtitle: 'Tokenforbruk og bøttestatus for denne organisasjonen.',
            bucketHeading: 'Månedlig token bøtte',
            remainingLabel: 'Gjenværende',
            consumedLabel: 'Forbrukt',
            totalLabel: 'Totalt',
            unitsLabel: 'fakturerbare enheter',
            lastReconciledLabel: 'Sist avstemt',
            recentHeading: 'Nylig aktivitet',
            historyHeading: 'Siste 12 perioder',
            noActivity: 'Ingen aktivitet ennå denne perioden.',
            featureLabel: 'Funksjon',
            whenLabel: 'Når',
            periodLabel: 'Periode',
            topUpButton: 'Be om en påfyllingspakke',
            topUpHint: 'Kontakt kontoadministratoren din for å be om en påfyllingspakke.',
            buyMore: {
                buyButton: 'Kjøp fleire einingar',
                purchaseTitle: 'Kjøp fleire faktureringseiningar',
                purchaseSubtitle: 'Vel ein pakke. Du blir sendt til sikker Stripe-betaling, og fakturaen kjem på e-post.',
                packageLabel: 'Pakke',
                optionTemplate: '{name} — {units} {units_label} — {price}',
                packageSmall: 'Liten',
                packageMedium: 'Middels',
                packageLarge: 'Stor',
                checkoutButton: 'Hald fram til betaling',
                checkoutPending: 'Opnar betaling…',
                cancelButton: 'Avbryt',
                purchaseError: 'Kunne ikkje starte betalinga. Prøv igjen om litt.',
                redeemTitle: 'Løys inn ein faktura',
                redeemSubtitle: 'Har du allereie betalt? Vel pakken du kjøpte og skriv inn fakturanummeret frå e-posten din for å leggje til einingane.',
                invoiceLabel: 'Fakturanummer',
                invoicePlaceholder: 'JJVExxxX-0001',
                redeemButton: 'Løys inn',
                redeemPending: 'Løyser inn…',
                redeemSuccess: 'Einingar lagde til i bøtta di.',
                redeemAlready: 'Denne fakturaen er allereie løyst inn.',
                errorNotFound: 'Fann ingen faktura med det nummeret. Kontroller fakturanummeret og prøv igjen.',
                errorNotPaid: 'Denne fakturaen er ikkje merkt som betalt enno.',
                errorOrgMismatch: 'Denne fakturaen vart ikkje utferda til organisasjonen din.',
                errorPackageMismatch: 'Denne fakturaen samsvarar ikkje med den valde pakken.',
                errorInvalidInvoice: 'Skriv inn eit gyldig fakturanummer.',
                errorGeneric: 'Innløysinga mislukkast. Prøv igjen om litt.',
            },
            byFeatureHeading: 'Denne måneden etter funksjon',
            byFeatureEmpty: 'Ingen funksjonsaktivitet ennå denne perioden.',
            featureColumn: 'Funksjon',
            featureUnitsColumn: 'Enheter',
            featureRunsColumn: 'Løper',
            byUserHeading: 'Denne måneden etter bruker (administratorvisning)',
            byUserEmpty: 'Ingen aktivitet per bruker ennå denne perioden.',
            userColumn: 'Bruker',
            reconciliationLinkLabel: 'Se rapport for avstemmingsavvik',
            reconciliationLinkHint: 'Kun Aesir-intern administrator.',
            featureLabels: {
                chat: 'Chat',
                workflow: 'Arbeidsflytkjøring',
                tabular: 'Tabellutvinning',
                redline: 'Redline anmeldelse',
                title: 'Samtaletittel',
                unknown: 'Annet',
            },
        },
        reconciliation: {
            title: 'Forseti-kvoteavstemming',
            subtitle: 'Flytt mellom hurtigbufferen for kvoteteller og den autoritative faktureringsboken. Avstemmingen kjører hvert 5. minutt; denne siden viser den siste kjøringen og historien. Kun Aesir-intern administrator.',
            backLink: 'Tilbake til Forseti-bruk',
            stubHeading: 'Avstemmingshistorikk kommer snart',
            stubBody: 'Avstemmingsarbeiderloggene driver via den strukturerte loggkanalen. Et leseendepunkt for backend som avslører de siste 30 avstemmingskjøringene blir scoped (utsatt fra Sprint 47.5.9.6 � se arbeidsfil). Når endepunktet lander, vil denne siden vise kjøringshistorikktabellen + P0-driftbanner.',
            stubBackendOwner: "Backend-utsettelse: vedvarende avstemmingskjøringer i en ny samling + legg til 'GET /llm-relay/quota/reconciliation'-rute.",
            permissionDenied: 'Denne siden er begrenset til Aesir-interne administratorer. Hvis du mener at du bør ha tilgang, kontakt din [[TOK_0]]-representant.',
        },
        projects: {
            title: 'Prosjekter',
            subtitle: 'Arbeidsområder for dokumenter, samtaler, arbeidsflyter og anmeldelser.',
            modeLabel: 'Visning',
            tabMine: 'Mine prosjekter',
            tabShared: 'Delt med meg',
            searchLabel: 'Søk etter prosjekter',
            searchPlaceholder: 'Søk...',
            newButton: 'Nytt prosjekt',
            colName: 'Navn',
            colVisibility: 'Synlighet',
            colDocs: 'Dokumenter',
            colMembers: 'Medlemmer',
            colUpdated: 'Oppdatert',
            visibilityOwn: 'Kun eie',
            visibilityShared: 'Delt',
            emptyMine: 'Ingen prosjekter ennå. Opprett en for å komme i gang.',
            emptyShared: 'Ingen prosjekter har blitt delt med deg.',
            pageHint: 'Viser [[TOK_2]] av [[TOK_3]].',
            createTitle: 'Nytt prosjekt',
            createSubmit: 'Lag prosjekt',
            fieldName: 'Navn',
            fieldDescription: 'Beskrivelse (valgfritt)',
            fieldCmNumber: 'Saks-/saksnummer (valgfritt)',
            fieldVisibility: 'Synlighet',
            errorNameRequired: 'Navn er påkrevd.',
            errorSelectorRequired: 'Velg en bruker eller organisasjonsgruppe du vil legge til.',
            renameButton: 'Gi nytt navn',
            renamePrompt: 'Gi nytt navn til prosjektet',
            deleteButton: 'Slett',
            deleteConfirm: 'Vil du slette dette prosjektet? Den vil bli oppbevart i 30 dager før permanent fjerning.',
            deleteFolderConfirm: 'Vil du slette denne mappen? Dokumenter inne vil forbli i prosjektet, bare uarkivert.',
            removeMemberConfirm: 'Vil du fjerne dette medlemmet?',
            foldersHeading: 'Mapper',
            foldersEmpty: 'Ingen mapper ennå.',
            addFolderButton: 'Ny mappe',
            addFolderTitle: 'Ny mappe',
            documentsHeading: 'Dokumenter',
            documentsEmpty: 'Ingen dokumenter vedlagt ennå.',
            colFilename: 'Filnavn',
            colAdded: 'Lagt til',
            unattachButton: 'Løsne',
            membersHeading: 'Medlemmer',
            membersEmpty: 'Kun eier.',
            addMemberButton: 'Legg til medlem',
            addMemberTitle: 'Legg til medlem',
            addMemberSubmit: 'Legg til medlem',
            colMember: 'Medlem',
            colRole: 'Rolle',
            selectorTypeLabel: 'Legg til etter',
            selectorUser: 'Bruker-ID',
            selectorGroup: 'Organisasjonsgruppe-ID',
            fieldUserId: 'Bruker',
            fieldGroupId: 'Organisasjonsgruppe',
            fieldRole: 'Rolle',
            roleAdmin: 'Admin',
            roleEditor: 'Redaktør',
            roleViewer: 'Seer',
            notFound: 'Finner ikke prosjektet.',
            selectUserPlaceholder: 'Velg en bruker...',
            selectGroupPlaceholder: 'Velg en organisasjonsgruppe...',
            noUsersAvailable: 'Ingen brukere tilgjengelig.',
            noGroupsAvailable: 'Ingen tilgjengelige organisasjonsgrupper.',
            loadFailed: 'Kunne ikke laste inn alternativer.',
            deleteProjectTitle: 'Vil du slette prosjektet?',
            deleteFolderTitle: 'Vil du slette mappen?',
            removeMemberTitle: 'Vil du fjerne medlem?',
            removeMemberConfirmGeneric: 'Vil du fjerne dette medlemmet fra prosjektet?',
            addDocumentButton: 'Legg til dokument',
            addDocumentTitle: 'Legg til dokument i prosjekt',
            fieldDocument: 'Vel dokument',
            selectDocPlaceholder: 'Søk etter et dokument...',
            ownerLabel: 'Systemeigar',
        },
        chat: {
            sidebarLabel: 'Chatter',
            overviewTitle: 'Forseti',
            overviewSubtitle: 'Din [[TOK_0]] juridiske og overholdelsesrådgiver � basert på leietakerdataene dine og de installerte reguleringspakkene dine.',
            personaSelectorLabel: 'Persona',
            personaHeading: 'Velg en persona',
            startChatButton: 'Start en ny chat',
            startingChat: 'Starter chat ⬦',
            recentHeading: 'Nylige chatter',
            recentEmpty: 'Ingen chatter ennå - start en ovenfor.',
            untitledChat: 'Ny chat',
            messageListLabel: 'Samtale',
            detailSubtitle: 'Persona: [[TOK_1]]',
            composeHeading: 'Send en melding',
            composeLabel: 'Melding Forseti',
            composeDisabledPlaceholder: 'Meldingssammensetningen lander i neste sprint (47.5.4b � SSE-streaming + verktøy-anropsløkke).',
            composeDisabledHint: 'Skrivebeskyttet forhåndsvisning sendt i 47.5.4a. Streaming + verktøyanrop lander i 47.5.4b.',
            switchPersonaHeading: 'Persona',
            presetPersona: 'Førehandsvald persona',
            changePersona: 'Byt persona',
            hidePersonaOptions: 'Skjul personaval',
            starterHeading: 'Start med ei av desse handlingane',
            renameButton: 'Gi nytt navn',
            renamePrompt: 'Gi nytt navn til chat',
            deleteButton: 'Slett',
            deleteConfirm: 'Vil du slette denne chatten? Den vil bli oppbevart i 30 dager før permanent fjerning.',
            notFound: 'Chat ikke funnet.',
            emptyChat: 'Ingen meldinger ennå � si hei for å starte en samtale.',
            roleUser: 'Du',
            roleAssistant: 'Forseti',
            roleSystem: 'System',
            thinkingLabel: 'Tenker',
            toolCallPlaceholder: 'Verktøykall:',
            toolResultPlaceholder: 'Verktøyresultat skjult � hele brukergrensesnittet lander i 47.5.4b.',
            docEditPlaceholder: 'Dokumentredigeringer foreslått (V[[TOK_1]]).',
            disclaimer: 'Forseti støtter dommen din � den erstatter ikke autorisert advokat.',
            sendButton: 'Send',
            sending: 'Sender ⬦',
            composePlaceholder: 'Spør Forseti...',
            composingPlaceholder: 'Forseti svarer...',
            streamingPlaceholder: 'Forseti skriver...',
            promptInjectionTitle: 'Forseti droppet noen kontrolltokens.',
            promptInjectionBody: 'Strippede mønstre: [[TOK_1]]. Forseti vil bare se meldingsteksten din.',
            promptInjectionInline: 'Forseti droppet kontrolltokens ([[TOK_1]]) fra meldingen din.',
            rateLimitTitle: 'Du sender meldinger for fort.',
            rateLimitRetryAfter: 'Prøv igjen om [[TOK_1]]s.',
            counselReviewTitle: 'Forseti er usikker her.',
            counselReviewBody: 'Bekreft med autorisert advokat før du handler på dette svaret.',
            legalConclusionRefused: 'Forseti nektet å avgi en juridisk konklusjon uten begrunnelse. Prøv search_regulatory først eller eskaler til råd.',
            toolCallDone: 'Ferdig.',
            toolCallArgsLabel: 'Argumenter',
            toolCallResultLabel: 'Resultat',
            toolResultLogged: 'Verktøyresultat fanget i revisjonslogg.',
            toolResultAria: 'verktøyresultat',
            documentEditAria: 'dokumentredigering',
            createTaskFromMessage: 'Lag oppgave fra dette',
            createTaskHeading: 'Opprett oppgave fra denne meldingen',
            createTaskTitleLabel: 'Tittel',
            createTaskTitleRequired: 'Tittel er påkrevd.',
            createTaskDescriptionLabel: 'Beskrivelse',
            createTaskAssigneeLabel: 'Oppdragstaker',
            createTaskAssigneePlaceholder: 'Velg mottaker...',
            createTaskAssigneeNone: '� ikke tildelt �',
            createTaskDueDateLabel: 'Forfallsdato',
            createTaskWorkflowLabel: 'Koblet arbeidsflyt (valgfritt)',
            createTaskWorkflowPlaceholder: 'Velg en arbeidsflyt...',
            createTaskWorkflowNone: '� ingen �',
            renameModalSubmit: 'Gi nytt navn',
            renameModalSaving: 'Lagrer ⬦',
            deleteConfirmTitle: 'Vil du slette chatten?',
            createTaskSubmit: 'Lag oppgave',
            createTaskSubmitting: 'Oppretter ⬦',
            cancelButton: 'Avbryt',
            autoRouteHintMessage: 'Dette spørsmålet er mer i [[TOK_1]] sitt styrehus.',
            autoRouteSwitchButton: 'Bytt til [[TOK_1]]',
            autoRouteSwitching: 'Bytter ⬦',
            handoffSuggestionMessage: 'Eller åpne en ny chat med [[TOK_1]] som fører dette spørsmålet videre.',
            handoffSuggestionButton: 'Start ny chat med [[TOK_1]]',
            handoffSuggestionWorking: '�&pner ⬦',
            handoffSuggestionDismiss: 'Ikke nå',
            persona_display: {
                'forseti-generalist': 'Forseti',
                'forseti-compliance': 'Compliance-spesialist',
                'forseti-legal': 'Juridisk rådgjevar',
                'forseti-dpo': 'Personvernrådgjevar',
                'forseti-risk': 'Risikoanalytikar',
                'forseti-auditor': 'Revisorblikk',
            },
            exportButton: 'Eksporter PDF',
            exportRunning: 'Eksporterer⬦',
            exportSuccess: 'Eksportert: {filename} (opn filnettlesaren).',
            citation: {
                verifyBadge: '[VERIFY]',
                verifyAria: 'sitatet kunne ikke bekreftes � gjennomgå før du stoler på',
                popoverAria: 'Kilde for [[TOK_1]]',
                openSource: '�&pen kildekode-side',
            },
        },
        auditTrail: {
            forsetiBadge: 'Forseti',
            forsetiBadgeTooltip: '[[TOK_0]]-generert hendelse fra Forseti revisjonsspor.',
        },
        rowAction: {
            ask: 'Spør Forseti',
            tooltipOpen: 'Spør Forseti om dette [[TOK_1]]',
            tooltipLocked: 'Denne [[TOK_1]] er låst � Forseti kan svare på spørsmål, men kan ikke gjøre endringer.',
        },
        advisorRunPanel: {
            title: 'Forseti � om denne posten',
            heading: 'Forseti � [[TOK_1]]',
            summaryLabel: 'Sammendrag',
            suggestedPersona: 'Foreslått persona',
            askForseti: 'Spør Forseti',
            runWorkflow: 'Kjør en arbeidsflyt',
            viewLineage: 'Se revisjonslinje',
            createPdplEvidencePack: 'Opprett PDPL-dokumentasjonspakke',
            prepareBreachDraft: 'Førebu varslingsutkast',
            primaryActions: {
                projectSummary: 'Oppsummer prosjektdokument',
                supplementSummary: 'Oppsummer tilleggsførespurnad',
                authoritySummary: 'Oppsummer styresmaktsførespurnad',
                rightsRequestResponse: 'Utkast til DSR-svar',
                dpiaQuickReview: 'Køyr rask DPIA-gjennomgang',
                taskControlWalkthrough: 'Gå gjennom kontrollbevis',
                vendorRiskNarrative: 'Generer leverandørrisiko-narrativ',
                incidentLetter: 'Utkast til PDPL-brotbrev',
                ropaSufficiency: 'Køyr RoPA-tilstrekkelegheitssjekk',
                vendorDpaReview: 'Køyr leverandør-DPA-gjennomgang',
            },
            builtinWorkflowViews: {
                ropaSufficiency: {
                    title: 'RoPA Sufficiency Check',
                    notice: 'Runs the existing RoPA sufficiency workflow for this processing activity. The run may create draft follow-up tasks; operators still review and execute them.',
                },
                vendorDpaReview: {
                    title: 'Vendor DPA Review',
                    notice: 'Runs the existing Vendor DPA Review workflow for this vendor contract. The run may create draft follow-up tasks; operators still review every finding and task.',
                },
                vendorRiskNarrative: {
                    title: 'Vendor Risk Narrative',
                    notice: 'Runs the existing vendor risk narrative workflow for this vendor. Output remains draft evidence; the human risk owner reviews and approves it before use.',
                },
                incidentLetter: {
                    title: 'PDPL Breach Notification Letter',
                    notice: 'Runs the existing VN PDPL breach-notification letter workflow for this incident or playbook activation. Output remains draft only; formal regulator filing still requires human sign-off.',
                },
                projectSummary: {
                    title: 'Project Document Summary',
                    notice: 'Runs the existing uploaded-document summary workflow for this Forseti project. The workflow is read-only and does not create tasks, evidence, or record updates.',
                },
                supplementSummary: {
                    title: 'Supplement Request Summary',
                    notice: 'Runs the existing uploaded-document summary workflow for this supplement request. The workflow is read-only and does not create tasks, evidence, record updates, or filing decisions.',
                },
                authoritySummary: {
                    title: 'Authority Request Summary',
                    notice: 'Runs the existing uploaded-document summary workflow for this authority request. The workflow is read-only and does not create tasks, evidence, record updates, filing decisions, or authority-response drafts.',
                },
                rightsRequestResponse: {
                    title: 'DSR Response Draft',
                    notice: 'Runs the existing DSR response draft workflow for this rights request. Output remains draft only; sending and case updates still require the existing human-reviewed rights-request flow.',
                },
                dpiaQuickReview: {
                    title: 'DPIA Quick Review',
                    notice: 'Runs the existing DPIA Quick Review workflow for this DPIA. The run may create draft follow-up tasks; operators still review every finding and task.',
                },
                taskControlWalkthrough: {
                    title: 'Control Evidence Walkthrough',
                    notice: 'Runs the existing compliance-control walkthrough for this task. The workflow must retrieve regulatory anchors before citing them, does not issue legal conclusions or mark controls/evidence approved, and only creates draft evidence placeholders when the operator explicitly requests them.',
                },
            },
            breachDraftNotice: 'Forseti lagar berre utkast til det tilknytte Mẫu số 08. Det avgjer ikkje om varsling er påkravd, og sender ikkje inn eller vidareformidlar skjemaet.',
            breachDraftReady: 'Utkast til Mẫu số 08 klart for gjennomgang',
            breachDraftReviewBeforeSelecting: 'Gå gjennom før val',
            workflowHeading: 'Relevante arbeidsflytar',
            workflowLoading: 'Lastar relevante arbeidsflytar…',
            workflowEmpty: 'Fann ingen eigna arbeidsflyt. Opprett ein rettleidd arbeidsflyt for denne posten.',
            workflowError: 'Kunne ikkje laste relevante arbeidsflytar.',
            selectWorkflow: 'Vel {title}',
            workflowSelected: 'Arbeidsflyten er vald og klar til å køyrast for denne posten.',
            workflowRunSelected: 'Køyr vald arbeidsflyt',
            workflowStarting: 'Startar arbeidsflyt…',
            workflowRunError: 'Kunne ikkje starte denne arbeidsflyten.',
            workflowQuotaExhausted: 'Forseti-brukskvoten din er for låg til å starte denne arbeidsflyten.',
            workflowTopUp: 'Sjå gjennom bruken og be om påfyll',
            workflowCreateGuided: 'Opprett ein rettleidd arbeidsflyt for denne posten',
            lineageHeading: 'Revisjonsspor for denne posten',
            lineageLoading: 'Lastar revisjonsspor…',
            lineageEmpty: 'Det er ikkje registrert nokon Forseti-sporhendingar for denne posten.',
            lineageError: 'Kunne ikkje laste revisjonsspor.',
            retry: 'Prøv igjen',
            chatContextLoading: 'Lastar kontekst for posten…',
            chatGuidance: {
                general: 'Forseti kan oppsummere posten, identifisere manglande informasjon og foreslå gjennomgangssteg.',
                privacy: 'Forseti kan gå gjennom personvernopplysningar, kontrollere plikter i installerte regelverk og hjelpe med å lage eit utkast for menneskeleg gjennomgang.',
                compliance: 'Forseti kan identifisere etterlevingsmanglar, forankre krav i installerte kjelder og foreslå ansvarlege neste steg.',
                legal: 'Forseti kan oppsummere posten, finne underbygd kjeldemateriale og hjelpe med å lage eit utkast for juridisk gjennomgang.',
                risk: 'Forseti kan vurdere registrerte risikoar, markere manglande fakta og foreslå forholdsmessige gjennomgangssteg.',
                audit: 'Forseti kan undersøkje manglar i provgrunnlaget, knyte posten til installerte kontrollar og foreslå revisjonsklare oppfølgingar.',
            },
            starterPrompts: {
                identifyGaps: 'Kva informasjon eller kva provgrunnlag manglar i denne posten?',
                reviewFrameworks: 'Kva plikter i dei installerte regelverka våre bør eg gå gjennom for denne posten?',
                prepareDraft: 'Hjelp meg med å lage eit utkast som berre byggjer på denne posten og underbygde installerte kjelder.',
                nextSteps: 'Kva gjennomgangssteg bør eg ta vidare?',
                summarizeRecord: 'Oppsummer posten og marker punkt som krev menneskeleg gjennomgang.',
                assessRisk: 'Vurder dei registrerte risikoane, identifiser manglande fakta og foreslå gjennomgangssteg.',
            },
            disclaimer: 'Forseti støtter dommen din � den erstatter ikke autorisert advokat.',
            recordType: {
                project: 'Prosjekt',
                dpia: '[[TOK_0]]',
                dossier_filing: 'Dossierarkivering',
                transfer_assessment: 'Overføring over landegrensene',
                vendor: 'Leverandør',
                vendor_contract: 'Leverandørkontrakt',
                vendor_acceptance: 'Leverandørens risikoaksept',
                incident: 'Hendelse',
                incident_op: 'Hendelsesoperasjon',
                breach_notification: 'Bruddvarsel',
                authority_request: 'Myndighetsforespørsel',
                supplement_request: 'Tilleggsforespørsel',
                rights_request: 'Rettighetsforespørsel',
                contract: 'Kontrakt',
                task: 'Oppgave',
                data_mapping_activity: 'RoPA-aktivitet',
                compliance_rule: 'Samsvarsregel',
                program: 'Program',
                governance_document: 'Styringsdokument',
                remediation_plan: 'Saneringsplan',
                cross_border_filing: 'Grenseoverskridende arkivering',
            },
        },
        autocomplete: {
            button_label: 'Be Forseti utarbeide et utkast til dette',
            drafting: 'Utkaster ⬦',
            hint_pick_activity: 'Velg en koblet behandlingsaktivitet for å aktivere Forseti-utkast.',
            draft_origin_label: 'Forseti-utkast � gjennomgang per felt',
            tokens_label: '�0� [[TOK_1]] tokens fra din månedlige bøtte',
            accept_selected: 'Godta valgt',
            reject_all: 'Avvis utkast',
            field_checkbox_label: 'Bruk Forseti-utkast for [[TOK_1]]',
            field_labels: {
                description: 'Beskrivelse',
                purpose: 'Formål',
                data_subjects: 'Datasubjekter',
                data_types: 'Datatyper',
                necessity_justification: 'Nødvendighet og proporsjonalitet',
                consultation_notes: 'Høringsnotater',
                dpo_opinion: '[[TOK_0]] mening',
                system_ids: 'Koblede systemer',
                vendor_ids: 'Tilknyttede leverandører',
            },
            error_generic: 'Forseti kunne ikke utarbeide denne [[TOK_0]]. Prøv igjen eller avgrens aktivitetsposten.',
            variant_legend: 'Rammeramme',
            variant_label_gdpr: '[[TOK_0]]',
            variant_label_pdpl: '[[TOK_0]]',
            variant_label_nis2: '[[TOK_0]]',
            variant_label_iso27001: 'ISO 27001',
            variant_label_soc2: 'SOC 2',
            conflict_banner: 'Vær oppmerksom: [[TOK_1]] konflikter på tvers av rammeverk gjelder for denne varianten. Se gjennom før du godtar.',
        },
        tia: {
            button_label: 'Be Forseti om å utarbeide denne TIA',
            drafting: 'Utkaster TIA ⬦',
            hint_pick_destination: 'Angi destinasjonslandet på overføringsposten før Forseti kan draft.',
            draft_origin_label: 'Forseti TIA-utkast � gjennomgang per felt',
            tokens_label: '�0� [[TOK_1]] tokens fra din månedlige bøtte',
            accept_selected: 'Godta valgt',
            reject_all: 'Avvis utkast',
            field_checkbox_label: 'Bruk Forseti-utkast for [[TOK_1]]',
            error_generic: 'Forseti kunne ikke utarbeide denne TIA. Prøv på nytt eller avgrens overføringsposten.',
            usage_details: 'Detaljar om KI-bruk',
            applied_status: 'Utkast godteke. Gå gjennom dei utfylte felta, og vel deretter Oppdater.',
            recommended_updates_title: 'Tilrådde oppdateringar av oppføring',
            mechanism_recommendation: 'Overføringsmekanisme: {value}',
            dpo_signoff_recommendation: 'Krev DPO-godkjenning for denne sensitive overføringa.',
            review_date_warning: 'Set ein gjennomgangsfrist før du oppdaterer denne sensitive overføringa.',
            processing_activity_warning: 'Kople til minst éin behandlingsaktivitet / ROPA-oppføring før du fullfører TIA-en.',
            go_to_field: 'Gå til felt',
            adequacy_label: 'Destinasjonsregime',
            adequacy_status_adequacy_decision: 'Tilstrekkelighetsbeslutning',
            adequacy_status_non_adequacy_with_sccs: 'Ikke tilstrekkelig � SCC-er kreves',
            adequacy_status_derogation: 'Art.49 unntak',
            adequacy_status_transitional: 'Overgangs-/E��S-snarvei',
            adequacy_status_unknown: 'Ukjent � angi destinasjon',
            conflict_banner: 'Vær oppmerksom: [[TOK_1]] konflikt(er) på tvers av rammeverk gjelder for dette overføringsregimet. Se gjennom før du godtar.',
        },
        // Sprint 48.3.6 — shared draft output-guardrail labels (TIA + DPIA + all draft workflows).
        guardrails: {
            missing_facts_title: 'Manglande påkravde opplysningar',
            missing_facts_hint: 'Forseti merkte opplysningar som ikkje finst i posten. Felt som avheng av dei, er ikkje førehandsvalde — oppgi opplysningane eller godta feltet medvite.',
            risk_label: 'Kalibrert risiko',
            risk_low: 'Låg',
            risk_medium: 'Middels',
            risk_high: 'Høg',
            jurisdiction_label: 'Jurisdiksjonsutløysarar',
            jurisdiction_gdpr: 'GDPR',
            jurisdiction_vn_pdpl: 'PDPL (Vietnam)',
            trigger_applicable: 'Gjeld',
            trigger_not_applicable: 'Ikkje utløyst',
            trigger_unknown: 'Ukjend — opplysning manglar',
            recipient_role_label: 'Rolla til mottakaren',
            recipient_role_controller: 'Behandlingsansvarleg',
            recipient_role_processor: 'Databehandlar',
            recipient_role_joint_controller: 'Felles behandlingsansvarleg',
            recipient_role_unknown: 'Ukjend — ikkje oppgjeve',
            opt_in_hint: 'Juridisk konklusjon — vel berre dersom du godtek han med tilgjengelege fakta.',
        },
        mcp: {
            pageTitle: 'MCP-koblingsnøkler',
            pageSubtitle: 'Utsted [[TOK_0]]-nøkler slik at eksterne Claude-klienter kan ringe skrivebeskyttede Forseti-verktøy (forskriftssøk, dokumentlesing, modulsøk). Fase 1 - skrivebeskyttet. Skriveverktøy lander i 48.3.0.',
            issueButton: 'Utsted ny nøkkel',
            issueModalTitle: 'Utsted MCP-nøkkelen [[TOK_0]]',
            labelField: 'Etikett',
            labelHint: 'En kort beskrivelse (f.eks. "[[TOK_0]] kapasitetslaboratorium � regulatorisk forskning").',
            permittedToolsField: 'Tillatte verktøy',
            expiresAtField: 'Utløper (valgfritt)',
            expiresAtHint: 'La stå tomt for aldri utløper.',
            submit: 'Utsted nøkkel',
            cancel: 'Avbryt',
            keyDisplayedOnce: 'Kopier denne nøkkelen nå - du vil IKKE kunne se den igjen. Lagre det i din hemmelige manager (1Password, AWS Secrets Manager, Vault, etc.).',
            keyDisplayedOnceClose: 'Jeg kopierte det - lukk',
            colLabel: 'Etikett',
            colPrefix: 'Prefiks',
            colStatus: 'Status',
            colTools: 'Verktøy',
            colCreatedAt: 'Opprettet',
            colLastUsed: 'Sist brukt',
            colCalls: 'Samtaler',
            colActions: 'Handlinger',
            statusActive: 'Aktiv',
            statusRevoked: 'Opphevet',
            statusExpired: 'Utløpt',
            revokeAction: 'Oppheve',
            rotateAction: 'Roter',
            confirmRevokeTitle: 'Vil du tilbakekalle denne MCP-nøkkelen?',
            confirmRevokeBody: 'Eksterne Claude-klienter som bruker denne nøkkelen vil miste tilgangen umiddelbart. Dette kan ikke angres.',
            confirmRevoke: 'Opphev nøkkel',
            rotatedTitle: 'Nøkkel rotert',
            rotatedBody: 'Den nye klartekstnøkkelen er nedenfor. Den gamle nøkkelen fortsetter å virke i 5 minutter, så alle anrop under flyet avsluttes.',
            emptyState: 'Ingen MCP-nøkler er utstedt ennå.',
            errorIssue: 'Kunne ikke utstede MCP-nøkkelen.',
            errorList: 'Kunne ikke laste inn MCP-nøkler.',
            errorRevoke: 'Kunne ikke trekke tilbake nøkkelen.',
            errorRotate: 'Kunne ikke rotere nøkkelen.',
            neverUsed: '�',
            neverExpires: 'Aldri',
        },
        memory: {
            pageTitle: 'Forseti minne',
            pageSubtitle: 'Bla gjennom og kurater den organisasjonsspesifikke konteksten Forseti har samlet på tvers av samtaler og beslutninger. Kurserte oppføringer låses mot nattlig oppbevaring og forblir tilgjengelige for alle personer.',
            filterCategory: 'Kategori',
            filterAllCategories: 'Alle kategorier',
            totalCount: '[[TOK_1]] oppføringer',
            colAnchor: 'Anker',
            colCategory: 'Kategori',
            colSource: 'Kilde',
            colContent: 'Innhold',
            colCreatedAt: 'Opprettet',
            colActions: 'Handlinger',
            editButton: 'Rediger',
            deleteButton: 'Slett',
            promoteButton: 'Fremme til kuratert',
            emptyState: 'Ingen minner ennå - Forseti vil samle kontekst mens du chatter.',
            categories: {
                framework_interpretation: 'Rammetolkning',
                process_preference: 'Prosesspreferanse',
                escalation_threshold: 'Eskaleringsterskel',
                decision_context: 'Beslutningskontekst',
                glossary_term: 'Ordlistebegrep',
                auto_inferred: 'Automatisk utledet',
            },
            sources: {
                admin_curated: 'Kuratert',
                user_explicit: 'Eksplisitt',
                auto: 'Utledet',
            },
            deleteConfirmTitle: 'Vil du slette dette minnet?',
            deleteConfirmBody: 'Sletting vil fjerne dette ankeret fra hver fremtidig Forseti-chatoppstart. Anker: [[TOK_1]]',
            deleteConfirmLabel: 'Slett',
            deleteCancelLabel: 'Avbryt',
            editModalTitle: 'Rediger minne',
            editAnchorLabel: 'Anker',
            editCategoryLabel: 'Kategori',
            editContentLabel: 'Innhold',
            editContentCount: '[[TOK_2]]/[[TOK_3]] tegn',
            editEmptyError: 'Innholdet kan ikke være tomt.',
            editTooLongError: 'Innholdet må være �0�1000 tegn.',
            editAutoPromoteHint: 'Lagring av dette automatisk utledede minnet vil merke det som brukerbekreftet og fjerne det fra oppbevaringssveipet.',
            editCancelButton: 'Avbryt',
            editSaveButton: 'Lagre',
            editSaving: 'Lagrer ⬦',
        },
        auditLineage: {
            title: 'Revisjonsslekt',
            subtitle: 'Spor hver [[TOK_0]]-genererte artefakt som er knyttet til en post. Chatter, verktøyanrop, oppgaver, bevisutkast og dokumentversjoner.',
            filterForm: 'Filtre',
            recordType: 'Record type',
            recordId: 'Registrer ID',
            dateStart: 'Fra',
            dateEnd: 'Til',
            search: 'Søk',
            loading: 'Laster inn ⬦',
            exportPdf: 'Eksporter [[TOK_0]]',
            exportCsv: 'Eksporter [[TOK_0]]',
            nodesHeading: 'Avstamningsnoder',
            colType: 'Type',
            colLabel: 'Etikett',
            colOccurredAt: 'Oppstod kl',
            colActor: 'Skuespiller',
            colId: 'ID',
            noResults: 'Ingen rådgiveraktivitet for denne posten.',
            draftBadge: '[[TOK_0]]-generert utkast',
            prev: 'Forrige',
            next: 'Neste',
            viewToggleTable: 'Vis som tabell',
            viewToggleGraph: 'Vis som graf',
            graphAriaLabel: 'Linjegraf (visuelt). Bruk tabellvisningen for hjelpemidler.',
            graphLegendDraft: 'Utkast til [[TOK_0]] bevis',
            graphEmpty: 'Ingen noder å tegne.',
            paginationAriaLabel: 'Paginering',
            exportSuccessTemplate: '[[TOK_2]]: [[TOK_3]]',
            exportErrorTemplate: 'Eksport mislyktes: [[TOK_1]]',
            recordTypes: {
                project: 'Prosjekt',
                dpia: '[[TOK_0]]',
                vendor: 'Leverandør',
                incident: 'Hendelse',
                incident_op: 'Hendelsesoperasjon',
                rights_request: 'Rettighetsforespørsel',
                contract: 'Kontrakt',
                task: 'Oppgave',
                data_mapping_activity: 'Datakartleggingsaktivitet',
                compliance_rule: 'Overholdelsesregel',
                program: 'Program',
            },
            nodeTypes: {
                chat: 'Chat',
                tool_call: 'Verktøykall',
                workflow_run: 'Arbeidsflytkjøring',
                task: 'Oppgave',
                evidence: 'Bevis',
                document_version: 'Dokumentversjon',
            },
        },
        integrityCenter: {
            verdicts: {
                ok: 'OK',
                drifted: 'Drevet',
                hash_mismatch: 'Hash-mismatch',
                merkle_mismatch: 'Merkle misforhold',
                source_missing: 'Kilde mangler',
                not_found: 'Ikke funnet',
                chain_unreachable: 'Kjede uoppnåelig',
                service_unreachable: 'Tjenesten er utilgjengelig',
                pending: 'Venter på forankring',
            },
        },
        evidenceDraft: {
            draftBadge: '[[TOK_0]]-generert UTKAST',
            pendingReviewBadge: 'Venter på vurdering',
            approvedBadge: 'Godkjent',
            rejectedBadge: 'Avvist',
            moveToReviewButton: 'Merk klar for anmeldelse',
            approveButton: 'Godkjenne',
            rejectButton: 'Avvis',
            rejectReasonLabel: 'Grunn til avvisning',
            humanSignoffBanner: 'Forseti støtter dommen din � den erstatter ikke autorisert advokat. [[TOK_0]]-generert bevis krever menneskelig godkjenning før det teller som formelt bevis.',
            pageTitle: '[[TOK_0]] bevisutkast',
            pageSubtitle: 'Se gjennom, godkjenn eller avvis [[TOK_0]]-genererte bevis. Utkast må godkjennes av et menneske før de teller som formelt bevis.',
            filterAll: 'Alle handlingsdyktige',
            filterDrafts: 'Kun utkast',
            filterPending: 'Venter på vurdering',
            filterApproved: 'Nylig godkjent',
            filterRejected: 'Nylig avvist',
            colId: 'Bevis-ID',
            colStatus: 'Status',
            colSource: 'Kilde',
            colCreatedAt: 'Opprettet',
            colActions: 'Handlinger',
            empty: 'Ingen [[TOK_0]] bevisutkast i denne statusen.',
            confirmApprove: 'Godkjenne dette [[TOK_0]]-genererte beviset som formelt?',
            confirmReject: 'Avvis dette bevisutkastet. Dette kan ikke angres.',
            reasonRequired: 'Det kreves en avvisningsgrunn.',
            rejectModalTitle: 'Avvis utkast til bevis',
            approveModalTitle: 'Godkjenne utkast til bevis',
            operationFailed: 'Operasjonen mislyktes. Vennligst prøv igjen.',
            moveToReviewSuccess: 'Merket klar for vurdering.',
            approveSuccess: 'Godkjent.',
            rejectSuccess: 'Avvist.',
            sourceLabelWorkflowRunTitle: 'Arbeidsflyt: [[TOK_1]]',
            sourceLabelWorkflowRunId: 'Arbeidsflytkjøring [[TOK_1]]',
            sourceLabelChatTitle: 'Chat: [[TOK_1]]',
            sourceLabelChatId: 'Forseti chat [[TOK_1]]',
            sourceLabelEmpty: '�',
            filtersAriaLabel: 'Filterstatus',
        },
        workflows: {
            pageTitle: 'AI-arbeidsflyter',
            pageSubtitle: 'Lagra AI-promptmalar som produserer oppgåver og utkast til prov.',
            newWorkflow: 'Ny arbeidsflyt',
            newWorkflowHeading: 'Ny AI-arbeidsflyt',
            tabAll: 'Alle',
            tabBuiltin: 'Innebygd pakke',
            tabMine: 'Mine arbeidsflyter',
            tabDetail: 'Detaljar',
            tabLinkedTasks: 'Tilknytte oppgåver',
            builtinBadge: 'Innebygd',
            builtinSubtitle: 'Innebygd arbeidsflyt.',
            userSubtitle: 'Tilpassa arbeidsflyt.',
            emptyHint: 'Ingen arbeidsflyter enno.',
            loadTimeoutError: 'Kunne ikkje laste arbeidsflyter etter 10 sekund. Prøv igjen, eller sjekk nettlesarens nettverksfane for ein hengande førespurnad.',
            loadError: 'Kunne ikkje laste arbeidsflyter.',
            hideError: 'Skjul mislukkast.',
            unhideError: 'Vis mislukkast.',
            retry: 'Prøv igjen',
            producesTasks: 'Produserer oppgåver',
            producesEvidence: 'Produserer utkast til prov',
            hideButton: 'Skjul frå mi liste',
            unhideButton: 'Vis igjen',
            runButton: 'Køyr',
            editButton: 'Rediger',
            shareButton: 'Del',
            backToList: 'Tilbake til lista',
            requireTitleAndPrompt: 'Tittel og prompt er påkravd.',
            fieldTitle: 'Tittel',
            fieldDescription: 'Skildring',
            fieldType: 'Type',
            fieldPersona: 'Persona-affinitet',
            fieldPractice: 'Praksis',
            fieldPrompt: 'Spørre (Markdown)',
            fieldProducesTasks: 'Produserer oppgåver',
            fieldProducesEvidence: 'Produserer utkast til prov',
            fieldProjectId: 'Prosjekt (valfritt)',
            fieldAttachmentIds: 'Vedlegg',
            fieldParentRecord: 'Overordna post (valfritt)',
            fieldPersonaOverride: 'Persona-overstyring (valfritt)',
            typeAssistant: 'Assistent',
            typeTabular: 'Tabellform',
            personaNone: '� ingen �',
            parentNone: '� ingen �',
            parentIdPlaceholder: 'Overordna post-ID',
            selectProjectPlaceholder: 'Vel eit prosjekt⬦',
            selectProjectFirst: 'Vel eit prosjekt for å velje vedlegg.',
            selectAttachmentsPlaceholder: 'Vel dokument⬦',
            noAttachmentsInProject: 'Dette prosjektet har ingen vedlagde dokument.',
            selectParentRecordPlaceholder: 'Vel ein post⬦',
            selectParentRecordFirst: 'Vel først ein posttype.',
            noRecordsForType: 'Ingen postar av denne typen er tilgjengelege.',
            shareUserSelectorLabel: 'Mottakarar (brukarar)',
            shareGroupSelectorLabel: 'Mottakarar (organisasjonsgrupper)',
            selectUsersPlaceholder: 'Vel brukarar⬦',
            selectOrgGroupsPlaceholder: 'Vel organisasjonsgrupper⬦',
            loadingOptions: 'Lastar⬦',
            loadFailed: 'Kunne ikkje laste alternativ.',
            parentRecordTypes: {
                dpia: 'DPIA',
                vendor: 'Leverandør',
                incident: 'Hending',
                rights_request: 'Rettsforespurnad',
                contract: 'Kontrakt',
                data_mapping_activity: 'RoPA-aktivitet',
                compliance_rule: 'Compliance-regel',
                program: 'Program',
            },
            cancelButton: 'Avbryt',
            closeButton: 'Lukk',
            createButton: 'Opprett',
            creating: 'Opprettar⬦',
            saveButton: 'Lagre',
            saving: 'Lagrar⬦',
            shareWorkflowHeading: 'Del arbeidsflyt',
            shareIntro: 'Deler: {title}',
            shareUserIds: 'Brukar-ID-ar (skilde med mellomrom eller komma)',
            shareGroupIds: 'Organisasjonsgruppe-ID-ar (skilde med mellomrom eller komma)',
            shareAllowEdit: 'Tillat mottakarar å redigere',
            shareRequireRecipient: 'Oppgi minst éin brukar-ID eller gruppe-ID.',
            shareSuccess: 'Delt.',
            sharing: 'Deler⬦',
            runWorkflowHeading: 'Køyr: {title}',
            runStarting: 'Startar⬦',
            runStatusLabel: 'Status: [[TOK_1]]',
            runProducedCounts: 'Oppgåver: {tasks} · Utkast til prov: {evidence} · Vedlegg: {attachments}',
            runPanelHeading: 'Arbeidsflytkøyring',
            runPanelHeadingWithTitle: 'Arbeidsflytkøyring: {title}',
            runViewTasks: 'Vis genererte oppgåver',
            runLoadFailed: 'Kunne ikkje laste arbeidsflytkøyringa.',
            runStreamFailed: 'Tilkoplinga til framdrifta i arbeidsflyten mislukkast.',
            runStatusValues: {
                pending: 'Ventar',
                running: 'Køyrer',
                completed: 'Fullført',
                succeeded: 'Lukkast',
                failed: 'Mislukkast',
                cancelled: 'Avbroten',
            },
            runProgressStatus: 'Status: [[TOK_1]]',
            runProgressTaskCreated: 'Oppgåve oppretta.',
            runProgressEvidenceDrafted: 'Utkast til prov oppretta.',
            runProgressAttachmentGenerated: 'Vedlegg generert.',
            guidedWorkflowTitle: 'Rettleidd arbeidsflyt for {recordType}',
            guidedWorkflowDescription: 'Oppretta for postar av typen {recordType}. Gå gjennom og tilpass arbeidsflyten før du lagrar.',
            guidedWorkflowPrompt: 'Gå gjennom den oppgitte posten av typen {recordType}, identifiser manglande fakta og foreslå underbygde neste steg for menneskeleg gjennomgang.',
            costHint: 'Førehands-kvotekontroll vert utløyst ved innsending; køyringar over kvota returnerer 402 med ein oppfyllings-CTA.',
            quotaExhausted: 'Token-bøtte låg. Fyll på før gjenopptaking.',
            promptHeading: 'Spør',
            editWorkflowHeading: 'Rediger arbeidsflyt',
            linkedTasksHint: 'Oppgåver oppretta av denne arbeidsflyten viser i oppgåvelista filtrert etter denne arbeidsflyt-ID-en. Krysshenvisingar kjem i 47.5.8.',
            notFound: 'Arbeidsflyt ikkje funnen.',
            schedules: {
                tabTitle: 'Tidsplanar',
                sectionHeading: 'Planlagde køyringar',
                empty: 'Ingen tidsplanar enno. Opprett ein for å køyre denne arbeidsflyten automatisk.',
                addButton: 'Legg til tidsplan',
                addHeading: 'Planlegg arbeidsflyt',
                editHeading: 'Rediger tidsplan',
                fieldFrequency: 'Frekvens',
                fieldDayOfWeek: 'Vekedag',
                fieldDayOfMonth: 'Dag i månaden',
                fieldTime: 'Tid (UTC)',
                fieldTimezone: 'Tidssone',
                fieldProject: 'Prosjekt (valfritt)',
                fieldAttachments: 'Standardvedlegg',
                fieldPersonaOverride: 'Persona-overstyring (valfritt)',
                frequencyDaily: 'Dagleg',
                frequencyWeekly: 'Vekentleg',
                frequencyMonthly: 'Månadleg',
                weekdaySun: 'Sundag',
                weekdayMon: 'Måndag',
                weekdayTue: 'Tysdag',
                weekdayWed: 'Onsdag',
                weekdayThu: 'Torsdag',
                weekdayFri: 'Fredag',
                weekdaySat: 'Laurdag',
                statusActive: 'Aktiv',
                statusPaused: 'Pausa',
                nextRunLabel: 'Neste køyring',
                lastRunLabel: 'Siste køyring',
                pauseButton: 'Pause',
                resumeButton: 'Hald fram',
                deleteButton: 'Slett',
                triggerButton: 'Køyr no',
                savingButton: 'Lagrar⬦',
                saveButton: 'Lagre',
                triggered: 'Køyring starta � sjekk køyringshistorikken.',
            },
            branching: {
                helpHeading: 'Vilkårleg prompt-syntaks',
                helpBody: 'Bruk {% if attachment.framework_code == "vn-pdpl" %}⬦{% endif %} for å variere prompten etter kontekst. Tillatne variablar: attachment.framework_code, attachment.locale, project.name, project.tier, persona.slug, org.country, org.locale. Nesta {% if %}-blokker er ikkje støtta.',
            },
        },
        crossFrameworkConflicts: {
            pageTitle: 'Konflikter på tvers av rammeverk',
            pageSubtitle: 'Utvalgt katalog over hvor de installerte reguleringspakkene dine samhandler på motstridende måter. Forseti overflater; mennesker bestemmer.',
            noInstalledPacks: 'Ingen forskriftspakker installert for denne organisasjonen � installer minst to pakker for å avdekke konflikter på tvers av rammeverk.',
            noConflicts: 'Ingen konflikter samsvarer med gjeldende filtre.',
            allAcknowledged: 'Enhver synlig konflikt har blitt erkjent. Fint arbeid.',
            columnSeverity: 'Alvorlighetsgrad',
            columnTitle: 'Tittel',
            columnFrameworks: 'Rammer',
            columnTopic: 'Emne',
            columnStatus: 'Status',
            filterFrameworkPlaceholder: 'Alle rammer',
            filterTopicPlaceholder: 'Alle emner',
            filterSeverityPlaceholder: 'Alle alvorlighetsgrader',
            filterStatusPlaceholder: 'Alle statuser',
            filterStatusAcknowledged: 'Erkjent',
            filterStatusUnacknowledged: 'Ukjent',
            severityCritical: 'Kritisk',
            severityHigh: 'Høy',
            severityMedium: 'Middels',
            severityLow: 'Lavt',
            statusAcknowledged: 'Erkjent',
            statusInReview: 'I anmeldelse',
            statusResolved: 'Løst',
            statusWontFix: 'Vil ikke fikse',
            statusUnacknowledged: 'Ukjent',
            drawerSummaryHeading: 'Sammendrag',
            drawerSideAHeading: 'Side A',
            drawerSideBHeading: 'Side B',
            drawerRequirementsLabel: 'Oppgitte krav',
            drawerSuggestedResolutionHeading: 'Foreslått oppløsning',
            drawerLegalCounselBadge: 'Juridisk gjennomgang kreves',
            drawerAckHeading: 'Anerkjennelse',
            drawerAckStatusLabel: 'Status',
            drawerAckAssigneeLabel: 'Tildelt til',
            drawerAckDueDateLabel: 'Forfallsdato',
            drawerAckNotesLabel: 'Notater',
            drawerAckButtonAcknowledge: 'Bekreft',
            drawerAckButtonUpdate: 'Oppdater',
            drawerAckButtonUnacknowledge: 'Avbekreft',
            searchPlaceholder: 'Søk i tittel eller sammendrag...',
            searchButton: 'Søk',
            searchButtonAriaLabel: 'Kjør konfliktsøk',
            exportSuccessTemplate: '[[TOK_2]]: [[TOK_1]]',
            exportSuccessTemplateXlsx: '[[TOK_2]]: [[TOK_1]]',
            exportErrorTemplate: 'Eksport mislyktes: [[TOK_1]]',
            exportAriaLabel: 'Eksportkonflikter',
        },
        tabularReviews: {
            pageTitle: 'Tabulariske gjennomgangar',
            pageSubtitle: 'Samanlikne N dokument over M attributt med grunngitt sitering.',
            newReview: 'Ny gjennomgang',
            newReviewHeading: 'Ny tabularisk gjennomgang',
            emptyHint: 'Ingen tabulariske gjennomgangar enno.',
            docsLabel: '{n} dokument',
            colsLabel: '{n} kolonnar',
            detailSubtitle: '{docs} dokument · {cols} kolonnar',
            addColumn: 'Legg til kolonne',
            addColumnHeading: 'Legg til kolonne',
            columnInfo: 'Vis prompt og format',
            columnInfoAria: 'Vis prompt og format for kolonnen {name}',
            columnInfoPrompt: 'Prompt',
            columnInfoFormat: 'Returformat',
            columnInfoPresets: 'Tillatne verdiar',
            columnInfoCitations: 'Kjeldehenvisingar',
            columnInfoCitationsRequired: 'Påkravd',
            removeColumn: 'Fjern kolonne',
            removeColumnAria: 'Fjern kolonne {name}',
            removeColumnConfirm: 'Fjerne kolonnen "{name}"? Dei uttrekte cellene blir sletta.',
            deleteReview: 'Slett',
            deleteReviewAria: 'Slett gjennomgang {title}',
            deleteReviewConfirm: 'Slette gjennomgangen "{title}"? Dette fjernar permanent kolonnane, cellene og diskusjonane.',
            runAll: 'Køyr alle',
            running: 'Køyrer⬦',
            cancel: 'Avbryt',
            exportXlsx: 'Eksporter Excel',
            exportCsv: 'Eksporter CSV',
            exporting: 'Eksporterer⬦',
            backToList: 'Tilbake til lista',
            notFound: 'Tabularisk gjennomgang ikkje funnen.',
            noDocuments: 'Vedlegg dokument for å starte gjennomgangen.',
            noColumns: 'Legg til kolonnar for å definere kva som skal trekkast ut.',
            tableAriaLabel: 'Uttrekksrutenett',
            threadsCountAria: '{n} diskusjonsinnlegg',
            startDiscussionAria: 'Start diskusjon',
            docColumn: 'Dokument',
            statusPending: 'Ventar',
            statusRunning: 'Køyrer⬦',
            statusFailed: 'Mislukkast: {msg}',
            statusCancelled: 'Avbroten',
            citationsCount: '{n} sitat',
            citationsView: 'Vis kjeldeutdrag',
            citationPage: 'Side {n}',
            titleRequired: 'Tittel er påkravd.',
            fieldTitle: 'Tittel',
            fieldProjectId: 'Prosjekt (valfritt)',
            fieldAttachmentIds: 'Vedlegg',
            fieldColumnName: 'Kolonnenamn',
            fieldColumnNameHelp: 'Ei kort, skildrande etikett for denne kolonnen i uttrekksrutenettet.',
            columnNamePlaceholder: 'f.eks. Startdato for kontrakt',
            fieldExtractionPrompt: 'Uttrekksprompt',
            fieldExtractionPromptHelp: 'Skildre informasjonen du vil trekkje ut. Ver spesifikk for å få betre resultat.',
            columnPromptPlaceholder: 'Kva skal Forseti sjå etter i dokumenta?',
            fieldReturnFormat: 'Returformat',
            fieldReturnFormatHelp: 'Styrer korleis AI-en formaterer svaret sitt (t.d. som ein dato eller eit tal).',
            fieldPresets: 'Tillatne verdiar (éin per linje)',
            fieldPresetsPlaceholder: 'ja\nnei\ndelvis',
            fieldCitationsRequired: 'Sitat påkravd',
            formatShortText: 'Kort tekst',
            formatLongText: 'Lang tekst',
            formatEnum: 'Enum',
            formatNumber: 'Tal',
            formatDate: 'Dato',
            formatList: 'Liste',
            columnRequireFields: 'Namn og prompt er påkravd.',
            addColumnError: 'Klarte ikkje å leggje til kolonne.',
            cancelButton: 'Avbryt',
            createButton: 'Opprett',
            creating: 'Opprettar⬦',
            addButton: 'Legg til',
            adding: 'Legg til⬦',
            runConfirmHeading: 'Køyr uttrekk',
            estimateBody: 'Estimert ~{units} fakturerbare einingar ({confidence} tillit).',
            costHint: 'Førehands-kvotekontroll vert utløyst ved stadfesting; køyringar over kvota returnerer 402 med ein oppfyllings-CTA.',
            quotaExhausted: 'Token-bøtte låg. Fyll på før gjenopptaking.',
            starting: 'Startar⬦',
            confirmRun: 'Stadfest køyring',
            charts: {
                title: 'Kolonnediagram',
                tabsAria: 'Diagram-kolonnar',
                enumAria: 'Fordeling av enum-verdiar',
                numberAria: 'Histogram over talfordeling',
                dateAria: 'Datotidslinje',
                enumEmpty: 'Ingen fullførte celler.',
                numberEmpty: 'Ingen numeriske verdiar.',
                numberExcluded: '{n} celle(r) ekskluderte (tomme / ikkje-numeriske / ikkje fullførte).',
                dateEmpty: 'Ingen datoverdiar.',
                dateExcluded: '{n} celle(r) ekskluderte.',
                unsupportedFormat: 'Ikkje støtta kolonneformat.',
            },
            threads: {
                drawerTitle: 'Diskusjon',
                loading: 'Lastar⬦',
                empty: 'Ingen innlegg enno. Start samtalen.',
                composerLabel: 'Ny kommentar',
                composerPlaceholder: 'Legg til ein kommentar⬦',
                post: 'Send',
                posting: 'Sender⬦',
                edit: 'Rediger',
                editLabel: 'Rediger innlegg',
                delete: 'Slett',
                save: 'Lagre',
                cancel: 'Avbryt',
                close: 'Lukk',
                editedBadge: 'redigert',
                loadError: 'Kunne ikkje laste tråden',
                postError: 'Kunne ikkje sende',
                editError: 'Kunne ikkje redigere',
                deleteError: 'Kunne ikkje slette',
            },
            compare: {
                pageTitle: 'Samanlikne gjennomgangar',
                leftReviewLabel: 'Venstre gjennomgang',
                rightReviewLabel: 'Høgre gjennomgang',
                pickReview: 'Vel ein gjennomgang å samanlikne med',
                noSharedDocuments: 'Desse gjennomgangane deler ingen dokument � samanlikning krev minst eitt felles vedlegg.',
                sharedDocumentsHeading: 'Delte dokument',
                leftOnlyHeading: 'Kolonnar berre i venstre gjennomgang',
                rightOnlyHeading: 'Kolonnar berre i høgre gjennomgang',
                differs: 'Skil seg',
                identical: 'Identisk',
                emptyValue: '�',
                compareButton: 'Samanlikne med⬦',
                documentHeading: 'Dokument',
                errorMissingIds: 'Både venstre og høgre gjennomgangs-ID-ar er påkravde.',
                errorComparisonFailed: 'Samanlikning mislukkast.',
                errorLoadFailed: 'Kunne ikkje laste gjennomgangar.',
                pickerLoading: 'Lastar⬦',
                pickerNoOtherReviews: 'Ingen andre gjennomgangar tilgjengelege for samanlikning.',
                pickerCancel: 'Avbryt',
            },
        },
        documentReview: {
            pageTitle: 'Dokumentgjennomgang',
            pageSubtitle: 'Godta eller avslå [[TOK_0]]-foreslåtte endringer i dette dokumentet.',
            sidePanelLabel: '[[TOK_0]] røde linjer',
            sidePanelHeading: '[[TOK_0]] røde linjer',
            noPendingEdits: 'Ingen ventende redigeringer.',
            pendingCount: '[[TOK_1]] venter',
            acceptAllButton: 'Godta alle',
            rejectAllButton: 'Avvis alle',
            acceptAllTitle: 'Godta alle ventende redigeringer?',
            acceptAllConfirm: 'Dette vil godta [[TOK_1]] ventende endringer og opprette en eller flere nye versjoner. Fortsette?',
            editsHeading: 'Rediger',
            editsEmpty: 'Ingen endringer å vurdere.',
            versionsHeading: 'Versjonshistorikk',
            versionsEmpty: 'Ingen versjoner ennå.',
            editLabel: 'Rediger',
            editLabelWithId: 'Rediger #{id}',
            acceptButton: 'Godta',
            rejectButton: 'Avvis',
            accepting: 'Godtar ⬦',
            rejecting: 'Avviser ⬦',
            diffDeletedAria: 'Slettet',
            diffInsertedAria: 'Innsatt',
            statusPending: 'Venter',
            statusAccepted: 'Godtatt',
            statusRejected: 'Avvist',
            versionLabel: 'Versjon',
            versionAriaLabel: 'Versjon {n}',
            versionAriaLabelCurrent: 'Versjon {n} ({current})',
            versionCurrentTag: 'gjeldende',
            versionSourceLabel: 'Kilde',
            versionCreatedLabel: 'Opprettet',
            versionModelLabel: 'Modell',
            sourceUpload: 'Last opp',
            sourceUserUpload: 'Brukeropplasting',
            sourceAssistantEdit: 'Assistent-redigering',
            sourceUserAccept: 'Bruker godtatt redigering',
            sourceUserReject: 'Bruker avviste redigering',
            sourceGenerated: 'Generert',
        },
        documentReviewIndex: {
            sidebarLabel: 'Dokumentgjennomgang',
            pageTitle: 'Dokumentgjennomgang',
            pageSubtitle: 'Dokument i organisasjonen din som har AI-føreslegne redigeringar som ventar på gjennomgang eller Forseti-baserte versjonar.',
            colDocument: 'Dokument',
            colLinkedRecord: 'Tilknytt post',
            colPendingEdits: 'Ventande redigeringar',
            colLastActivity: 'Siste aktivitet',
            colOpen: 'Opn',
            open: 'Opn',
            empty: 'Ingen dokument under Forseti-gjennomgang enno. Dokument kjem i denne køen når Forseti føreslår ei redigering under ein chat, når ein AI-arbeidsflyt produserer ein redline, eller når du sender eit dokument til gjennomgang via knappen ovanfor.',
            loading: 'Lastar⬦',
            loadError: 'Kunne ikkje laste dokument under gjennomgang.',
            retryButton: 'Prøv igjen',
            noLinkedRecord: '�',
            pendingZero: 'Ingen',
            sendForReviewButton: 'Send eit dokument til gjennomgang',
            sendForReviewTitle: 'Send eit dokument til gjennomgang',
            sendForReviewSubtitle: 'Vel eit eksisterande vedlegg frå denne organisasjonen, eller last opp ei ny fil. Dokumentet vert lagt til gjennomgangskøen og Forseti vil køyre ein redline-gjennomgang på det.',
            sendForReviewTabPick: 'Vel eksisterande',
            sendForReviewTabUpload: 'Last opp nytt',
            sendForReviewPickerLabel: 'Søk i vedlegg',
            sendForReviewPickerPlaceholder: 'Skriv for å søke⬦',
            sendForReviewPickerEmpty: 'Ingen samsvarande vedlegg. Prøv eit anna søk.',
            sendForReviewSubmit: 'Send til gjennomgang',
            sendForReviewCancel: 'Avbryt',
            sendForReviewSubmitting: 'Sender⬦',
            sendForReviewError: 'Kunne ikkje sende dokumentet til gjennomgang. Prøv igjen.',
            sendForReviewSuccess: 'Dokument sendt til gjennomgang.',
            sendForReviewAcceptedExt: 'Akseptert: {ext}.',
            sendForReviewMaxSize: 'Maks storleik {mb} MB.',
        },
        chats: {
            exportError: 'Eksport mislukkast.',
        },
    },
    pdplEvidencePacks: {
        title: 'PDPL-bevispakkar',
        subtitle: 'Kundestyrt innlevering til MoPS A05',
        nav: { emailProviders: 'E-postleverandørar' },
        providers: {
            pageTitle: 'E-postleverandørar',
            pageSubtitle: 'Konfigurer organisasjonen sin utgåande e-postleverandør for PDPL-bevispakkar til MoPS A05.',
            architectureRuleHeading: 'Arkitekturregel (låst)',
            architectureRuleBody: 'AesirX er ikkje avsendar for bevismateriale-e-postar. Kvar sending nyttar ein leverandør som du eig og kontrollerer. AesirX sender aldri på dine vegner.',
            empty: 'Ingen leverandørar er konfigurerte enno.',
            createCta: 'Opprett leverandør',
            statusPendingConsent: 'Ventar på samtykke',
            statusPendingConnectionCheck: 'Ventar på tilkoplingstest',
            statusActive: 'Aktiv',
            statusConnectionCheckFailed: 'Tilkoplingstest feila',
            statusDisabled: 'Avstengd',
            acceptConsentCta: 'Godta samtykke',
            runConnectionCheckCta: 'Køyr tilkoplingstest',
            disableCta: 'Steng av',
            disableConfirm: 'Avstenging av denne leverandøren stansar direktesendingar til ein ny leverandør er konfigurert og samtykket er stadfesta på nytt. Hald fram?',
            columnDisplayName: 'Namn',
            columnFromAddress: 'Avsendaradresse',
            columnStatus: 'Status',
            columnLastCheck: 'Siste test',
            columnActions: 'Handlingar',
            createModalTitle: 'Ny SMTP-leverandør',
            createDisplayNameLabel: 'Visingsnamn',
            createFromAddressLabel: 'Avsendaradresse',
            createReplyToLabel: 'Svaradresse (valfritt)',
            createSmtpHostLabel: 'SMTP-vert',
            createSmtpPortLabel: 'SMTP-port',
            createSmtpUsernameLabel: 'SMTP-brukarnamn',
            createSmtpPasswordLabel: 'SMTP-passord',
            createSmtpEncryptionLabel: 'Kryptering',
            createSmtpEncryptionStarttls: 'STARTTLS',
            createSmtpEncryptionTls: 'TLS (implisitt)',
            createSmtpEncryptionNone: 'Ingen',
            createOauthM365Tab: 'Microsoft 365',
            createOauthGoogleTab: 'Google Workspace',
            createOauthDisabledBadge: 'Kjem snart',
            createOauthDisabledHint: 'OAuth-leverandørar er enno ikkje aktiverte. Bruk SMTP førebels.',
            createSubmitCta: 'Opprett leverandør',
            createCancelCta: 'Avbryt',
            createErrorInvalidFromAddress: 'Avsendaradressa må vere ein gyldig e-postkonto.',
            createErrorDuplicateFromAddress: 'Ein annan leverandør er allereie konfigurert for denne avsendaradressa.',
            createErrorGeneric: 'Kunne ikkje opprette leverandøren. Sjå gjennom skjemaet og prøv igjen.',
            consentModalTitle: 'Stadfest arkitekturregelen',
            consentLocaleToggleEn: 'Engelsk',
            consentLocaleToggleVi: 'Vietnamesisk',
            consentAcknowledgeCta: 'Eg stadfestar — godta samtykke',
            consentCancelCta: 'Avbryt',
            consentErrorMismatch: 'Samtyketeksten vart endra og samsvarar ikkje lenger med den kanoniske fråsegna. Opn dialogen på nytt og send inn igjen.',
            testModalTitle: 'Tilkoplingstest',
            testRunningCta: 'Testar tilkopling…',
            testRunCta: 'Køyr tilkoplingstest',
            testRetryCta: 'Prøv tilkoplingstest på nytt',
            testSuccessHeading: 'Tilkopling vellukka',
            testSuccessBody: 'Autentisert mot {host}:{port} på {latencyMs} ms. Leverandøren er klar for direktesending.',
            testFailureHeading: 'Tilkopling feila',
            testFailureBody: 'Testen kunne ikkje fullførast. Sjå gjennom årsaka under og prøv igjen når det er retta.',
            testFailureReasonLabel: 'Feilårsak',
            testCloseCta: 'Lat att',
            detailDrawerTitle: 'Leverandørdetaljar',
            detailDrawerHistoryHeading: 'Historikk for tilkoplingstestar',
            detailDrawerConsentHeading: 'Samtykkestadfesting',
            detailDrawerNoHistory: 'Ingen tilkoplingstestar registrerte enno.',
            detailDrawerNoConsent: 'Samtykke er ikkje stadfesta enno.',
            outcomeSuccess: 'Vellukka',
            outcomeFailure: 'Mislukkast',
        },
        builder: {
            pageTitle: 'Set saman bevispakke',
            pageSubtitle: 'Last opp dei 6 delfilene, vel pakketype og set saman den deterministiske 8-delars ZIP-en for innlevering.',
            packTypeLabel: 'Pakketype',
            packTypeDpia: 'DPIA (Mẫu số 02a)',
            packTypeOtia: 'OTIA (Mẫu số 02b)',
            part01CoverLetter: 'Del 01 — Følgjebrev (PDF)',
            part02AuthorityForm: 'Del 02 — Myndigheitsskjema (PDF)',
            part03Supporting: 'Del 03 — Støttebevis (≥1)',
            part04Safeguards: 'Del 04 — Tryggleikstiltak',
            part04SafeguardsRequiredOtia: '(påkravd for OTIA)',
            part05PriorCorrespondence: 'Del 05 — Tidlegare korrespondanse (valfri)',
            part06Signature: 'Del 06 — Signatur + stempelbevis (≥1)',
            uploadPickFile: 'Vel fil',
            uploadPickFiles: 'Vel filer',
            uploadRemoveFile: 'Fjern',
            requiredMissing: 'Påkravd del manglar',
            assembleCta: 'Set saman pakke',
            assembling: 'Set saman…',
            assembleSuccessHeading: 'Pakke sett saman',
            assembleSuccessSummary: '{fileCount} filer · {bytes} byte · SHA-256 {shaPrefix}…',
            composeNextCta: 'Skriv e-postutkast',
            warningsHeading: 'Valideringsåtvaringar',
            assembleError: 'Kunne ikkje setje saman pakka. Gå gjennom inndata og prøv igjen.',
            forsetiAssistHeading: 'Forseti AI-assistanse (valfri)',
            forsetiAssistHint: 'Køyr PDPL Evidence Pack Assembly Advisor for å løfte fram manglande delar, utarbeide følgjebrevprosa og flagge tryggleikshol. AesirX er ikkje avsendaren — AI-en gjev berre råd; du godkjenner kvart artefakt.',
            forsetiAssistCta: 'Opne Forseti arbeidsflyt-bibliotek',
            forsetiAiRunIdLabel: 'Tilknytt Forseti AI-køyrings-id (lim inn for å registrera AI-assistanse)',
        },
        draft: {
            pageTitle: 'E-postutkast',
            pageSubtitle: 'Skriv og rediger e-postutkastet. Direkte sending kjem i ein seinare utgåve.',
            composeCta: 'Skriv utkast',
            composing: 'Skriv…',
            noDraftYet: 'Ingen utkast enno. Skriv eitt for å koma i gang.',
            localeToggleLabel: 'Språk',
            localeEn: 'Engelsk',
            localeVi: 'Vietnamesisk',
            subjectLabel: 'Emne',
            bodyLabel: 'Brødtekst',
            saveCta: 'Lagre endringar',
            saving: 'Lagrar…',
            saveError: 'Kunne ikkje lagre utkastet. Prøv igjen.',
            manifestSummaryLabel: 'Manifest-oversikt',
            coverLetterLabel: 'Følgjebrev (PDF)',
            coverLetterDownloadCta: 'Last ned PDF',
            editHistoryHeading: 'Redigeringshistorikk',
            editHistoryEmpty: 'Ingen redigeringar enno.',
            editHistoryEntry: 'v{version} · {fields} · {when} · {who}',
            unofficialChannelHeading: 'NQ22 uoffisiell kanal-melding',
            uploadSentProofCta: 'Last opp manuelt sendebevis',
            versionLabel: 'Versjon',
            statusDraft: 'Utkast',
            statusEdited: 'Redigert',
            statusFinalized: 'Fullført',
        },
        sentProof: {
            modalTitle: 'Last opp manuelt sendebevis',
            architectureLockNote: 'AesirX er ikkje avsendaren. Dette beviset fangar den manuelle sendinga du gjennomførte via ditt eige e-postprogram.',
            fileLabel: 'Bevisfil (.eml, .png, .jpg)',
            envelopeFromLabel: 'Frå',
            envelopeToLabel: 'Til',
            envelopeSubjectLabel: 'Emne (ved sending)',
            envelopeSentAtLabel: 'Sendt',
            envelopeAttachmentShaLabel: 'Vedlegg SHA-256 (ved sending)',
            uploadCta: 'Last opp bevis',
            uploading: 'Lastar opp…',
            uploadSuccess: 'Sendebevis lasta opp.',
            uploadErrorInvalidMime: 'Filtypen er ikkje tillaten. Bruk .eml, .png, .jpg eller .jpeg.',
            uploadErrorGeneric: 'Kunne ikkje laste opp beviset. Prøv igjen.',
            existingProofsHeading: 'Registrerte sendebevis',
            existingProofsEmpty: 'Ingen sendebevis registrerte enno.',
            proofEntry: '{when} · {filename}',
        },
        packDetail: {
            pageTitle: 'Bevispakke',
            notFoundMessage: 'Pakka blei ikkje funnen — ho kan ha blitt fjerna eller lenkja er feil.',
            manifestHeading: 'Manifest',
            dossierLabel: 'Sak',
            packShaLabel: 'Pakke-SHA-256',
            fileCountLabel: 'Filer',
            bytesLabel: 'Storleik',
            composeDraftCta: 'Skriv utkast',
            sendComingSoonCta: 'Direkte sending: kjem snart',
            sendComingSoonHint: 'Direkte sending er under aktiv utvikling. Bruk "Last opp manuelt sendebevis" på utkastsida til ho vert levert.',
            sendCta: 'Send via konfigurert tilbydar',
            sendDisabledNoProviderHint: 'Konfigurer fyrst ein kundekontrollert e-posttilbydar. AesirX sender aldri på dine vegner.',
            timelineHeading: 'Sendehistorikk',
        },
        // Sprint 58.4.2 (Phase 25 / Sprint E2) — direct-send + timeline + authority response + hard-copy follow-up.
        send: {
            // Send dialog
            dialogTitle: 'Send bevispakke',
            providerPickerLabel: 'Konfigurert e-posttilbydar',
            providerPickerHint: 'AesirX sender aldri på dine vegner. Vel ein av dine konfigurerte tilbydarar nedanfor.',
            providerPickerEmpty: 'Ingen aktive tilbydarar er konfigurerte. Konfigurer ein på sida E-posttilbydarar før du sender.',
            providerPickerEmptyCta: 'Opna E-posttilbydarar',
            draftPickerLabel: 'E-postutkast',
            draftPickerOption: '{locale} · v{version}',
            draftPickerEmpty: 'Ingen utkast er skrivne for denne pakka enno. Skriv eitt på utkastsida fyrst.',
            recipientToLabel: 'Til',
            recipientToHint: 'Ei eller fleire e-postadresser, skilde med komma.',
            recipientCcLabel: 'Kopi (komma-separert)',
            recipientCcHint: 'Valfritt. Kommaskild liste over e-postadresser.',
            recipientBccLabel: 'Blindkopi (komma-separert)',
            recipientBccHint: 'Valfritt. Kommaskild liste over e-postadresser.',
            consentReaffirmHeading: 'Stadfest tilbydarsamtykket på nytt',
            submitCta: 'Send no',
            sending: 'Sender…',
            cancelCta: 'Avbryt',
            sendSuccess: 'Sending registrert. Pakka er overført via din konfigurerte tilbydar.',
            sendErrorGeneric: 'Kunne ikkje sende pakka. Sjå feilen nedanfor og prøv igjen.',
            sendErrorAlreadyFinalized: 'Dette utkastet er allereie nytta til ei vellukka sending. Skriv eit nytt utkast før du sender på nytt.',
            sendErrorInvalidRecipients: 'Éi eller fleire mottakaradresser er ikkje gyldige e-postkasser.',
            // Timeline
            timelineEmpty: 'Ingen sendingar registrerte enno. Bruk "Send via konfigurert tilbydar" over for å overføre gjennom din kundekontrollerte SMTP / Microsoft 365 / Google Workspace-tilbydar.',
            timelineProviderLabel: 'Sendt via din konfigurerte tilbydar',
            timelineSentAtLabel: 'Sendt',
            timelineRecipientLabel: 'Mottakar',
            timelineOutcomeSent: 'Sendt',
            timelineOutcomeFailed: 'Mislukkast',
            timelineViewDetailsCta: 'Vis detaljar',
            // Authority-response chips
            authorityChipNone: 'Ventar på svar',
            authorityChipAcknowledgement: 'Mottak stadfesta',
            authorityChipAcceptance: 'Godteke',
            authorityChipRejection: 'Avvist',
            authorityChipSupplementRequest: 'Førespurnad om tillegg',
            authorityChipNoResponse: 'Ingen respons',
            // Hard-copy chips
            hardCopyChipNone: 'Inga fysisk oppfølging',
            hardCopyChipPending: 'Postlagd — ventar på levering',
            hardCopyChipDelivered: 'Levert',
            // Drawer
            drawerTitle: 'Sendepost',
            drawerEnvelopeHeading: 'Konvolutt',
            drawerEnvelopeFromLabel: 'Frå',
            drawerEnvelopeToLabel: 'Til',
            drawerEnvelopeCcLabel: 'Kopi',
            drawerEnvelopeBccLabel: 'Blindkopi',
            drawerEnvelopeSubjectLabel: 'Emne',
            drawerEnvelopeMessageIdLabel: 'Melding-ID',
            drawerOutcomeHeading: 'Utfall',
            drawerSnapshotHeading: 'Augneblinksbilete av bevisvaretektskjeda',
            drawerSnapshotPackShaLabel: 'Pakke-SHA-256 ved sending',
            drawerSnapshotDraftVersionLabel: 'Utkastversjon ved sending',
            drawerSnapshotAttachmentLabel: 'Overført ZIP',
            drawerSnapshotAttachmentDownloadCta: 'Last ned ZIP',
            drawerAuthorityResponseHeading: 'Tilsynssvar',
            drawerHardCopyHeading: 'Fysisk oppfølging',
            drawerSentByLabel: 'Sendt av',
            drawerSendIdLabel: 'Sendepost-ID',
            drawerSmtpResponseLabel: 'SMTP-respons',
            drawerFailureReasonLabel: 'Årsak til feil',
            drawerLatencyLabel: 'Forseinking',
            drawerLatencyValue: '{ms} ms',
            drawerAcceptedLabel: 'Akseptert',
            drawerRejectedLabel: 'Avvist',
            drawerCloseCta: 'Lat att',
            // Authority-response panel
            authorityRecordCta: 'Registrer svar',
            authorityReclassifyCta: 'Omklassifiser',
            authorityClassificationLabel: 'Klassifisering',
            authorityReceivedAtLabel: 'Motteke',
            authorityFreeTextLabel: 'Merknader (valfritt)',
            authorityEvidenceLabel: 'Bevisfil (.eml / .pdf / .png / .jpg — valfritt)',
            authorityReasonLabel: 'Grunn for omklassifisering',
            authorityHistoryHeading: 'Omklassifiseringshistorikk',
            authorityHistoryEmpty: 'Ingen omklassifiseringar registrerte.',
            authorityHistoryEntry: '{when} · {previous} → {next} · {who}{reason}',
            authoritySubmitCta: 'Lagre svar',
            authoritySubmitting: 'Lagrar…',
            authorityErrorInvalidMime: 'Bevisfiltypen er ikkje tillaten. Bruk .eml, .pdf, .png eller .jpg.',
            authorityErrorGeneric: 'Kunne ikkje lagre svaret. Prøv igjen.',
            authorityRecordedAtLabel: 'Registrert',
            authorityRecordedByLabel: 'Registrert av',
            authorityEvidenceFilenameLabel: 'Bevis',
            authorityEvidenceDownloadCta: 'Last ned prov',
            // Hard-copy panel
            hardCopyRecordCta: 'Loggfør fysisk oppfølging',
            hardCopyConfirmCta: 'Stadfest levering',
            hardCopyEditNotesCta: 'Endre leveringsnotat',
            hardCopyPostedAtLabel: 'Postlagd',
            hardCopyCourierLabel: 'Bodfirma',
            hardCopyTrackingLabel: 'Sporingsnummer',
            hardCopyRecipientLabel: 'Mottakar på etikett',
            hardCopyReceiptLabel: 'Kvitteringsbevis (.pdf / .png / .jpg — valfritt)',
            hardCopyReceiptDownloadCta: 'Last ned kvittering',
            hardCopyDeliveredAtLabel: 'Levert',
            hardCopyDeliveryNotesLabel: 'Leveringsnotat (valfritt)',
            hardCopySubmitCta: 'Lagre oppfølging',
            hardCopySubmitting: 'Lagrar…',
            hardCopyErrorInvalidMime: 'Kvitteringsfiltypen er ikkje tillaten. Bruk .pdf, .png eller .jpg.',
            hardCopyErrorGeneric: 'Kunne ikkje lagre oppfølginga. Prøv igjen.',
        },
    },
};
//# sourceMappingURL=nn.js.map